webpackJsonp([35],{

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var URLParser = function URLParser(url) {
  (0, _classCallCheck3.default)(this, URLParser);

  var modifiedURL = url.toLowerCase().replace(/.*:\/\//, 'http://');
  var urlObject = new URL(modifiedURL);
  this.hostname = urlObject.hostname;
  this.pathname = urlObject.pathname;
  this.searchParams = urlObject.searchParams;
};

exports.default = URLParser;

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _set = __webpack_require__(254);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.toIdentityObject = toIdentityObject;
exports.isSubsetOf = isSubsetOf;
exports.uniq = uniq;
exports.diff = diff;
exports.getRandomElement = getRandomElement;
exports.range = range;
exports.flatten = flatten;

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var isArray = Array.isArray;
exports.isArray = isArray;
function toIdentityObject(member, index, inputArray) {
  this[member] = member;
}

function isSubsetOf(subsetArray, ofArray) {
  subsetArray.every(function (val) {
    return ofArray.indexOf(val) >= 0;
  });
}

function uniq(arr) {
  return [].concat((0, _toConsumableArray3.default)(new _set2.default(arr)));
}

function diff(a1, a2) {
  return a1.filter(function (i) {
    return a2.indexOf(i) < 0;
  });
}

function getRandomElement(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function range(rangeLength) {
  return Array.apply(null, Array(rangeLength));
}

function flatten(arrayOfArrays) {
  var _ref;

  var flat = (_ref = []).concat.apply(_ref, (0, _toConsumableArray3.default)(arrayOfArrays));
  return flat.some(isArray) ? flatten(flat) : flat;
}

var array = (0, _assign2.default)((0, _object.create)(), {
  toIdentityObject: toIdentityObject,
  isSubsetOf: isSubsetOf,
  uniq: uniq,
  diff: diff,
  getRandomElement: getRandomElement,
  isArray: isArray,
  range: range,
  flatten: flatten
});

(0, _nm.registerUtils)({ array: array });

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.group = exports.groupEnd = exports.groupCollapsed = exports.log = exports.info = exports.error = exports.warn = undefined;

var _create = __webpack_require__(182);

var _create2 = _interopRequireDefault(_create);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Safe console methods. Import named methods from here,
 * instead of using the global 'console' objects and it's methods.
 */

function noop() {}
var c = console;
var boundConsole = (0, _create2.default)(null);
var UNSAFE_CONSOLE_METHOD_NAMES = ['group', 'groupEnd', 'collapsedGroup', 'NON_EXISTANT_METHOD'];

function makeSafeConsoleMethod(methodName, method) {
  // For some strange reason, console methods aren't "instanceof Function" in Firebug.
  if (typeof method !== 'function') {
    method = noop; // eslint-disable-line no-param-reassign
  }
  var boundMethod = void 0;
  try {
    boundMethod = method.bind(c);
    boundMethod.curry = function () {
      var _method;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_method = method).bind.apply(_method, [c].concat(args));
    };
  } catch (e) {
    boundMethod = noop;
    boundMethod.curry = noop;
  } finally {
    // From some reason function.name didn't work here, so I added this custom property.
    boundMethod.methodName = methodName;
    boundConsole[methodName] = boundMethod;
  }
}

UNSAFE_CONSOLE_METHOD_NAMES.forEach(makeSafeConsoleMethod);

// We can't simply do Object.entries(c).forEach(makeSafeConsoleMethod) or Object.keys(c)
// because webkit is the new IE ಠ_ಠ
for (var methodName in c) {
  var method = c[methodName];
  makeSafeConsoleMethod(methodName, method);
}

var warn = exports.warn = boundConsole.warn;
var error = exports.error = boundConsole.error;
var info = exports.info = boundConsole.info;
var log = exports.log = boundConsole.log;
var groupCollapsed = exports.groupCollapsed = boundConsole.groupCollapsed;
var groupEnd = exports.groupEnd = boundConsole.groupEnd;
var group = exports.group = boundConsole.group;

/***/ }),

/***/ 1116:
/***/ (function(module, exports) {

var I18n = I18n || {};
I18n.translations = {"en":{"date":{"formats":{"default":"%d-%m-%Y","short":"%e %b","long":"%e %B, %Y","capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"day_names":["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],"abbr_day_names":["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],"month_names":[null,"January","February","March","April","May","June","July","August","September","October","November","December"],"abbr_month_names":[null,"Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],"order":["day","month","year"],"time_since":{"about_an_hour_ago":"About an hour ago","about_two_hours_ago":"About two hours ago","seconds_ago":"Seconds ago","x_hours_ago":{"one":"1 hour ago","other":"%{count} hours ago"},"x_minutes_ago":{"one":"1 minute ago","other":"%{count} minutes ago"}}},"time":{"formats":{"default":"%a, %e %b %Y %H:%M:%S %z","short":"%e %b %H:%M","long":"%e %B, %Y %H:%M","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"errors":{"format":"%{attribute} %{message}","messages":{"inclusion":"is not included in the list","exclusion":"is reserved","invalid":"is invalid","confirmation":"doesn't match confirmation","accepted":"must be accepted","empty":"can't be empty","blank":"can't be blank","too_long":{"one":"is too long (maximum is 1 character)","other":"is too long (maximum is %{count} characters)"},"too_short":{"one":"is too short (minimum is 1 character)","other":"is too short (minimum is %{count} characters)"},"wrong_length":{"one":"is the wrong length (should be 1 character)","other":"is the wrong length (should be %{count} characters)"},"not_a_number":"is not a number","not_an_integer":"must be an integer","greater_than":"must be greater than %{count}","greater_than_or_equal_to":"must be greater than or equal to %{count}","equal_to":"must be equal to %{count}","less_than":"must be less than %{count}","less_than_or_equal_to":"must be less than or equal to %{count}","odd":"must be odd","even":"must be even","record_invalid":"Validation failed: %{errors}","taken":"has already been taken","carrierwave_processing_error":"failed to be processed","carrierwave_integrity_error":"is not of an allowed file type","carrierwave_download_error":"could not be downloaded","extension_white_list_error":"You are not allowed to upload %{extension} files, allowed types: %{allowed_types}","extension_black_list_error":"You are not allowed to upload %{extension} files, prohibited types: %{prohibited_types}","rmagick_processing_error":"Failed to manipulate with rmagick, maybe it is not an image? Original Error: %{e}","mime_types_processing_error":"Failed to process file with MIME::Types, maybe not valid content-type? Original Error: %{e}","mini_magick_processing_error":"Failed to manipulate with MiniMagick, maybe it is not an image? Original Error: %{e}"},"template":{"body":"There were problems with the following fields:","header":{"one":"1 error prohibited this %{model} from being saved","other":"%{count} errors prohibited this %{model} from being saved"}},"200_pixels":"Picture must be at least 200x200 pixels","file_too_big":"Uploaded file is too big","flash":"You must install Adobe Flash to use this feature","invalid_filetype":"Invalid file type (we support .gif, .jpg, .jpeg and .png)","invalid_url":"Invalid URL","mobile_error":"This video cannot be played on a mobile device.","motto":{"title":"Please enter 10-25 characters"},"nick":{"duplicate":"Nick already in use","length":"Nick must be between 5-50 characters.","title":"Use only letters, digits, periods and dashes","validation":"Your display name must be between 5-50 characters - letters, digits, periods and dashes only."},"no_file":"No file chosen","not_found":"We couldn't find that page","one_team":"Must assign at least one team","pic_size":"Picture file size must be between %{min} and %{max}","ratio_alert":"Picture ratio must be between 1:2 and 2:1","return_homepage":"Return to the homepage","select_image":"You must select an image to upload","sorry":"SORRY","subject_id":{"require_fanship":"Fanship is a must!"},"text":{"duplicate_comment":"Duplicate comment","duplicate_post":"Duplicate post","max_char":"Maximum %{num_chars} characters","max_words":"Maximum %{num_words} words","min_char":"Minimum %{num_chars} characters"},"twitter_url":{"invalid":"Invalid Twitter URL"},"unknown_upload":"Unknown upload error has occurd, please contact care","unsupported_video":"Sorry, we do not support embedding videos by this site","url_err":"Unknown error (misspelled URL?), please contact a moderator","website":{"blank":"Please enter site URL"}},"affiliates":{"log_in":"Log in"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Connect","language":"Language","languages":{"de":"German","en":"English","es":"Spanish","fr":"French","hi":"Hindi","id":"Indonesian","it":"Italian","pt-BR":"Portuguese","th":"Thai","tr":"Turkish","vn":"Vietnamese"},"message":"Message","next":"Next","prev":"Previous","prompt":{},"right":{},"share":"Share","table":"Table","tweet":"Tweet","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"About Team","add_caption":"Add a Caption","add_content":"Add content to your article from the following supported sources:","add_image":"Add Image","add_item":"Add Media Item","add_media":"Add Media","add_team":"Add a team","additional_media":"Additional Media","are_you_sure":"Are you sure you want to leave this page?","article_preview":"This is a preview of your article","attach_image":"Choose Photo","back":"Back","back_to_edit":"Back to Edit","back_to_editing":"Back to Editing","bold_tooltip":"Bold","caption_optional":"(Optional, Max 22 characters)","char_count":"Character Count: %{num}","check_grammar":"Please look it over for proper spelling and grammar","choose_team":"Choose a team","clear":"Clear","complete_steps":"Before publishing you need to complete these steps:","congrats":"Congrats!","cover_image":"This will be the image displayed when the post is featured on the website, app or social networks","create_article":"Create Article","crop_image":"Crop Image","crop_ratio":"Crop ratio:","crop_too_small":"Image is too small","date":"Date:","delete":"DELETE","delete_article":"Delete this article","discard":"Discard","discard_confirmation":"Are you sure you'd like to discard this post?","draft":"Save","drag":"Drag Image/Video Here","drag_all":"Drag image, video or social content here","drag_crop":"Drag to reposition","drop_here":"Drop here...","drop_image":"Drop image here","edit_crop":"Move/resize rectangle to adjust thumbnail","edit_thumb":"Edit Thumbnail","editor":"Editor:","embed":"Embed","embed_code":"Embed Code","embed_only":"Paste embed code here","embed_video":"Embed Video","enter_desc":"Enter description here...","enter_title":"Enter title here...","enter_url":"Enter URL/code","facebook_cover_image":"Facebook Cover Image","ftbpro_editor":"FTBpro Editor","grammar_spelling":"Take some time to check for proper grammar and spelling","great":"Great!","guide_tips":"Read our guidelines and tips","guide_tips_links":"http://www.90min.com/blog/guidelines-tips/","h2_tooltip":"Title","header_edit":"Edit post","header_new":"New post","hyperlink_tooltip":"Link","image_bank":"Image Bank","image_crop":"Crop","image_format":"Supported image formats: JPG, JPEG, PNG, GIF.","image_search":"Search","image_size":"Dimensions should be larger than 500x280 pixels.","image_size_parameterized":"Dimensions should be larger than %{width}x%{height} pixels.","image_video":"Image/Video","image_weight":"This file exceeds the maximum file size of %{fileSizeMaxSupported}","insert_link":"Paste link here","invalid_code":"The URL/code is invalid or unsupported. Please enter a valid URL/code.","leave":"Leave this Page","leave_warning":"You are trying to leave this page without saving.\\nAll changes will be lost!","list_tooltip":"Unordered List","max":"(Max %{num})","max_reached":"(maximum reached)","media_longer":"(for articles longer than 200 words)","media_longer_than":"(for articles longer than 300 words)","media_post":"Media Post","min":"(Min %{num})","min_words":"(at least %{num} words)","no_draft":"No saved drafts","num_words":{"one":"1 Word","other":"%{count} Words"},"number_list_tooltip":"Ordered List","oops":"Almost there...","optimal_article":"(Optimal 300-800)","optimal_length":"(Optimal %{min}-%{max})","optional":"(Optional, Max 160 characters)","optional_field":"This field is optional","or":"Or","p_tooltip":"Paragraph","paste_embed":"Paste link or embed code here","paste_url":"Paste a URL or embeddable code","playbuzz":"Paste the full URL of the article you created on PlayBuzz.com here","polls":"Add a poll","prev":"Preview","preview":"Save & Preview","publish":"Publish","remove_attachment":"Are you sure you wish to remove this attachment?","reset":"Reset","review":"Preview Before Publishing","save_changes":"Save changes?","save_draft":"SAVE AS DRAFT","search_bank":"Search image bank","search_for":"Search for...","searching":"Searching...","select_photo":"Select photo","seo_desc":"SEO Description","share":"Share this post on Facebook","small_image":"Your photo is too small, it must be a least 300x150","source":"Source:","start_at":"Start at","stay":"Stay on this Page","steps_complete":"Your article is now ready to be published.","styling_tooltip":"Remove Styling","tag":"Tags","tag_at_least":"(Choose at least 1)","tag_sug":"Tag Suggestions","tag_team":"Tags","teaser":"Teaser","teaser_watermark":"Will appear only as a description on links to your article.","this_is_preview":"This is a preview of your article","tip_controversial ":"Be controversial. A good post raises tough questions.","tip_image":"Add a picture. Posts with images attract more readers.","tip_media":"Got a good video? Movies from YouTube or Metacafe get great reactions.","tip_short":"Keep your paragraphs short. Readers tend to skip long paragraphs.","tips":{"media_close_ups":"Use close-up images in articles about players","media_image_bank":"We recommend using our Getty Image bank to find any photo you need. Search by player or team. ","post_enjoy":"Most importantly, enjoy yourself!","post_original":"Be original. Content copied from other sources will not be allowed. ","post_paragraphs":"Use paragraphs to break up your article. ","post_review":" Review your article before publishing. Check for proper grammar and spelling. ","title":"Tips to increase reads:","title_debatable":"Use opinionated language. Overstate your case. People are drawn to debatable topics.","title_known_name":"Start your title with a player or team name. ","title_popular_terms":"Include popular words like players' full names, team names, or hot topics.","title_question":"Ask a question that is answered in your article.","title_short":"Keep it short. 5-8 words is best. "},"title":"Title","too_long":"Too long (optimal 10-75 characters)","too_short":"Too short (optimal 10-75 characters)","toolong":"Too long (optimal %{min}-%{max} characters)","tooshort":"Too short (optimal %{min}-%{max} characters)","try_again":"Try again","upload_failed":"An error occurred while uploading the image. Please try again.","upload_image":"Upload Photo","upload_img":"Upload Image","valid_code":"The embed code you provided is not valid.","video":"Video","video_provider":"We do not currently support this video provider.","video_services":"Paste video from YouTube, Dailymotion or Metacafe here:","video_url":"Video URL (Youtube, Dailymotion, Metacafe, etc.)","word_count":"Word Count: %{num}","writing_sug":" SEO Suggestions","writing_tips":"Tips for better writing","your_post":"Your Post"},"embed":{"button":"Embed","dialogue":{"additional_options":"Additional options","become_a_partner":"BECOME A PARTNER","comments":"Show comments","customise_collapse/expand":"Customise code","disclaimer":"By embedding this code you agree to our %{terms_conditions}","embed_code":"Embed code","embed_instructions":"Add this post to your website by copying and pasting the HTML code below","embed_instructions_partners":"Copy and paste your personalised code below","full_title":"Full title","header":"EMBED POST","info":"Removal of the 90min link is only available for partners","link":"Show link to 90min","logged_in":"Contact %{email} to join one of our partnership programs.","login":"Login","partner_message":"Already a partner? %{login} to receive your customised code.","remove_title":"Remove title","show-author":"Show author","show-date":"Show date","show-reads-counter":"Show number of views","show-title":"Show title","terms_&_conditions":"Terms & Conditions","title":"Title","views":"Show number of views"}},"footer":{"about_12up":"About 12up","about_90min":"About 90min","about_circasports":"About CircaSports","about_dbltap":"About DBLTAP","about_ei":"About Esporte Interativo","about_floor8":"About Floor8","about_ftb90":"About FTB90","about_ftbpro":"About","about_german_site":"About 90min","about_ht_media":"About HT Media Group","about_pluralist":"About Pluralist","about_swurley":"About Swurley","about_theduel":"About The Duel","affiliates":"Affiliates","apps":"Mobile Apps","apps_Android":"GET IT ON","apps_iphone":"AVAILABLE ON THE","blog":"Blog","boomerang":"Boomerang","cartoon":"Cartoon Network","contact_ftbpro":"Contact Us","fan_store":"Fan Store","faq":"FAQ","house_rules":"House Rules","in_the_news":"In The News","jobs":"Careers","licensing":"Licensing","links":"Links","links_social":"Links","more_about_12up":"About 12up","more_about_90min":"More About 90min ","more_about_circasports":"About CircaSports","more_about_dbltap":"More About DBLTAP","more_about_ei":"More About Esporte Interativo","more_about_floor8":"More About Floor8","more_about_ftb90":"About FTB90","more_about_german_site":"About 90min","more_about_ht_media":"About HT Media Group","more_about_pluralist":"More about Pluralist","more_about_swurley":"More about Swurley","more_about_theduel":"About The Duel","partner_sites":"Partner Sites","partners":"Partners","prev_prog":null,"privacy_policy":"Privacy Policy","rights_reserved":"All rights reserved","rights_reserved_year":"2016 FTBpro \u00a9 All rights reserved","rights_reserved_year_12up":"Minute Media 2019 12up \u00a9 All rights reserved","rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 All rights reserved","rights_reserved_year_archway":"2017 MinuteMedia \u00a9 All rights reserved","rights_reserved_year_circasports":"2016 CircaSports \u00a9 All rights reserved","rights_reserved_year_dbltap":"Minute Media 2019 DBLTAP \u00a9 All rights reserved","rights_reserved_year_ei":"Minute Media 2018 Esporte Interativo\u00a9 All rights reserved","rights_reserved_year_floor8":"Minute Media 2019 Floor8\u00a9 All rights reserved","rights_reserved_year_ftb90":"Minute Media 2018 FTB90 \u00a9 All rights reserved","rights_reserved_year_german_site":"Minute Media 2019 90min \u00a9 All rights reserved","rights_reserved_year_ht_media":"Minute Media 2019 HT Media \u00a9 All rights reserved","rights_reserved_year_pluralist":"Minute Media 2018 Pluralist\u00a9 All rights reserved","rights_reserved_year_swurley":"2016 Swurley \u00a9 All rights reserved","rights_reserved_year_theduel":"Minute Media 2018 The Duel \u00a9 All rights reserved","space":"Space","statistics_12up":"12up Stats","statistics_90min":"90min Stats","statistics_circasports":"CircaSports Stats","statistics_ei":"Esporte Interativo Stats","statistics_floor8":"Floor8 Stats","statistics_ftb90":"FTB90 Stats","statistics_ht_media":"HT Media Stats","statistics_swurley":"Swurley Stats","statistics_theduel":"The Duel Stats","stats":{"articles":"Articles","fans":"Fans","members":"Members","writers":"Writers"},"support":"Support","tbs":"TBS","tcm":"TCM","terms":"Terms","terms_conditions":"Terms & Conditions","tnt":"TNT","warner":"Warner","writers":"Writers"},"header":{"profile":"My Profile","settings":"Settings","signout":"Sign Out"},"home":{"no_matches":"No upcoming matches"},"homepage":{"be_the_first":"BE THE FIRST TO KNOW!","by":"By:","chrome_notifications":"Stay up to date with our Chrome Notifications","ei":{"latest_news":"Latest News","trending":"Trending","view_more":"View More"},"fan_perspectives":"Full Coverage","fan_voice":"FANVOICE","featured_topic":null,"fixtures_and_scores":"Fixtures And Scores","fixtures_scores":"Fixtures & Scores","follow_us_on":"Follow us on Snapchat:","latest_videos":"Latest Videos","league_page":"Premier League","match_day":"Match Day %{num}","month":"%M","more":"More","most_read":"Trending","no_matches":"There are no matches on this day","other_categories":"MORE CATEGORIES","our_categories":"CATEGORIES","read_now":"READ NOW","schedule":"SCHEDULE","scores_page_desc":"All the latest fixtures and results","scores_page_title":"Fixtures & results ","social_text":"All Latest News","stay_up_to":"Stay up to date with all the latest news","top_stories":"Top Stories","trending":"Indian Football","trending_floor8":"Trending","video":"Editor's picks","videos":"Videos","view_all":"View All Games","view_more":"View More","watch_more_videos":"Watch More Videos","watch_tv_12up":"WATCH 12UP SPORTS TV","watch_tv_90min":"WATCH 90MIN TV","watch_tv_circasports":"WATCH CIRCA SPORTS TV","watch_tv_dbltap":"WATCH DBLTAP TV","watch_tv_ei":"WATCH Esporte Interativo TV","watch_tv_floor8":"WATCH FLOOR8 TV","watch_tv_german_site":"WATCH 90MIN TV","watch_tv_ht_media":"WATCH HT MEDIA TV","watch_tv_theduel":"VIDEOS"},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":"Watch Now"}},"post_page":{"ad":"Advertisement","bet_now":"Bet Now","by":"By","by_betway":"via","community_content":"Community Content","community_disclaimer":"This post was created by a member of the 90min community and has not been edited or endorsed by our editorial team.","community_disclaimer_12up":"This post was created by a member of the 12up community and has not been edited or endorsed by our editorial team.","community_disclaimer_90min":"This post was created by a member of the 90min community and has not been edited or endorsed by our editorial team.","community_disclaimer_circasports":"This post was created by a member of the CircaSports community and has not been edited or endorsed by our editorial team.","community_disclaimer_dbltap":"This post was created by a member of the DBLTAP community and has not been edited or endorsed by our editorial team.","community_disclaimer_ei":"This post was created by a member of the Esporte Interativo \ncommunity and has not been edited or endorsed by our editorial team.","community_disclaimer_floor8":"This post was created by a member of the Floor8 community and has not been edited or endorsed by our editorial team.","community_disclaimer_ftb90":"This post was created by a member of the FTB90 community and has not been edited or endorsed by our editorial team.","community_disclaimer_german_site":"This post was created by a member of the 90min community and has not been edited or endorsed by our editorial team.","community_disclaimer_ht_media":"This post was created by a member of the HT Media community and has not been edited or endorsed by our editorial team.","community_disclaimer_swurley":"This post was created by a member of the Swurley community and has not been edited or endorsed by our editorial team.","community_disclaimer_theduel":"This post was created by a member of the The Duel community and has not been edited or endorsed by our editorial team.","cookies_consent_1":"%{site} uses cookies to personalize content and ads and to make our site easier to use. We also share some information with third parties for advertising & analytics.\n","cookies_consent_2":"More Info","cookies_consent_approve":"Got it!","notf":{},"now_playing":"NOW PLAYING:","similar_articles":"Related Articles"},"private_messages":{"conversation_date":"Last updated:","expand":"Expand","header":"Inbox","message_sent":"Your message has been sent","messages":"Messages","no_history":"No history","not_available":"Conversation not available ","private_message":"Private message","private_message_to":"Private message to","send":"Send","send_failed":"Sending failed. Sorry, please try again later.","sending":"sending","sent":"Message sent","side_title":"Conversations","title":"Between you and","view_history":"View conversation history","write_message_here":"Write your message here"},"pundit":{"bet_via":"PLACE BET VIA","draw":"Draw","fan_predictions":"Fan Predictions","follow_match":"Follow Match","follow_pundit":"Follow Pundit","log_in":"Log in to save your prediction","not_available":"Stats are currently not available. Please try again later.","place_your_bet":"PLACE YOUR BET","place_your_bet_via":"Place Your Bet Via","prediction":"Prediction:","pundit_prediction":"%{pundit_first_name}'s Prediction:","select_match":"Select A Match For Your Prediction","select_result":"- Select Result -","team_to_win":"%{team} to win","title":"%{team1} vs %{team2}: betting tips by %{pundit_name}","top_predictors":"TOP PREDICTORS","what_result":"Think you know the result?","what_your_prediction":"WHAT'S YOUR PREDICTION?","your_prediction":"YOUR PREDICTION:"},"reactions":{"campaigns_poweredby":"Powered By","v1":{"lol":"LOL","love":"Love It","must":"Must Read","noway":"No Way!","share":"Share","shocked":"Shocked","tweet":"Tweet"},"v2":{"booh":"Boo!","cool":"Cool","haha":"Haha","loveit":"Love It","noway":"No Way"},"your_reaction":"Your Reaction?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"My article received 100 reads","about_you":"About You","account":"Account","all_info_lost":"All your information on FTBpro.com will be permanently lost.","are_you_sure":"Are you sure?","by_email":"Email","connected_as":"Connected as","deactivate":"Deactivate my account","deactivate_placeholder":"Please let us know why:","deactivate_request_sent":"Your request has been successfully submitted. We will be in contact shortly.","disp_name":"Display Name","fb_hometown":"Current City from Facebook","fb_link":" Facebook link","go_social":"Go social - let my friends know of my reading activity","go_social_short":"Share my article reads","google_plus_link":"Google+ link","if_following_me":"Someone starts following me","if_sending_me_message":"Someone sends me a message","let_see":"Let everyone see my:","my_team":"My Team","name":{"rules":"Must be unique. 5 - 50 characters. Use letters, numbers and dashes"},"notifications":"Notifications","optional":"optional","privacy":"Privacy","recent_articles":"Recently shared articles","save":"Save","settings":"Settings","settings_saved":"Settings saved","share":"Auto-Share","site":"Site:","site_title":"Title:","site_url":"URL:","stats":"vBet stats","submit":"Submit","twitter_link":"Twitter link:","weekly_writers_achievements":"My weekly writer summary","when_notify":"Notify me when","your_writing_language":"Which language will you be writing in?"},"sign_up":{"about_you":"Write something about yourself.","and":"and","change":"You can always change your settings later.","disp_name":"Display Name","join_12up":"Join 12up","join_90min":"Join 90min","join_circasports":"Join CircaSports","join_dbltap":"Join DBLTAP","join_ei":"Join Esporte Interativo","join_floor8":"Join Floor8","join_ftb90":"Join FTB90","join_german_site":"Join 90min","join_ht_media":"Join HT Media","join_swurley":"Join Swurley","lets_start":"Let's get you set up...","my_game":"Game","my_league":"League","of_12up":"of 12up.com","of_90min":"of 90min.com","of_circasports":"of Swurley.com","of_dbltap":"of Dbltap.com","of_ei":"of esporteinterativo.com.br","of_floor8":"of Floor8.com","of_ftb90":"of FTB90.com","of_german_site":"of 90min.de","of_ht_media":"of 90min.in","privacy_policy":"Privacy Policy","required_field":"Required field","team":"My Team","terms":"I agree to the ","terms_and_conditions":"Terms and Conditions"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"Articles","comments":"Comments","reads":"Reads"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"LATEST STORIES","latest_videos":"LATEST VIDEOS","read_more":"Read More","recommended":"RECOMMENDED","video":"Video"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"de":{"date":{"abbr_day_names":["So","Mo","Di","Mi","Do","Fr","Sa"],"abbr_month_names":[null,"Jan","Feb","Mrz","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],"day_names":["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],"formats":{"default":"%d-%m-%Y","long":"%e %B %Y","short":"%e %b","capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"Januar","Februar","M\u00e4rz","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],"order":["day","month","year"],"time_since":{"about_an_hour_ago":"Vor einer Stunde","about_two_hours_ago":"Vor zwei Stunden","seconds_ago":"Vor ein paar Sekunden","x_hours_ago":{"one":"Vor einer Stunde","other":"Vor %{count} Stunden"},"x_minutes_ago":{"one":"Vor einer Minute","other":"Vor %{count} Minuten"}}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"muss akzeptiert werden","blank":"muss ausgef\u00fcllt werden","confirmation":"stimmt nicht mit der Best\u00e4tigung \u00fcberein","empty":"muss ausgef\u00fcllt werden","equal_to":"muss genau %{count} sein","even":"muss gerade sein","exclusion":"ist nicht verf\u00fcgbar","greater_than":"muss gr\u00f6\u00dfer als %{count} sein","greater_than_or_equal_to":"muss gr\u00f6\u00dfer oder gleich %{count} sein","inclusion":"ist kein g\u00fcltiger Wert","invalid":"ist nicht g\u00fcltig","less_than":"muss kleiner als %{count} sein","less_than_or_equal_to":"muss kleiner oder gleich %{count} sein","not_a_number":"ist keine Zahl","not_an_integer":"muss ganzzahlig sein","odd":"muss ungerade sein","record_invalid":"G\u00fcltigkeitspr\u00fcfung ist fehlgeschlagen: %{errors}","taken":"ist bereits vergeben","too_long":"ist zu lang (nicht mehr als %{count} Zeichen)","too_short":"ist zu kurz (nicht weniger als %{count} Zeichen)","wrong_length":"hat die falsche L\u00e4nge (muss genau %{count} Zeichen haben)"},"template":{"body":"Bitte \u00fcberpr\u00fcfen Sie die folgenden Felder:","header":{"one":"Konnte %{model} nicht speichern: ein Fehler.","other":"Konnte %{model} nicht speichern: %{count} Fehler."}},"200_pixels":"Das Bild muss zumindest 200x200 pixel gro\u00df sein","file_too_big":"Die Datei ist zu gro\u00df","flash":"Du musst Adobe Flash installieren um dieses Feature benutzen zu k\u00f6nnen","invalid_filetype":"Ung\u00fcltige Datei (wir unterst\u00fctzen .gif, .jpg, .jpeg and .png)","invalid_url":"Ung\u00fcltige URL","mobile_error":"Dieses Video kann nicht auf dem Handy abgespielt werden","motto":{"title":"Gib bitte 10 - 25 Zeichen ein"},"nick":{"duplicate":"Dieser Name ist schon vergeben","length":"Der Benutzername muss zwischen 5 und 50 Zeichen haben.","title":"Benutze nur Buchstaben, Zahlen, Punkte und Striche.","validation":"Dein Benutzername muss zwischen 5-50 Zeichen lang sein - Einzig Buchstaben, Zahlen, Punkte und Striche."},"no_file":"Keine Datei ausgew\u00e4hlt","not_found":"Wir konnten diese Seite nicht finden","one_team":"Du musst zumindest ein Team ausw\u00e4hlen","pic_size":"Bildgr\u00f6\u00dfe muss zwischen %{min} und %{max} sein","ratio_alert":"Das Bildverh\u00e4ltnis muss zwischen 1:2 und 2:1 sein","return_homepage":"Zur\u00fcck zur Homepage","select_image":"Du musst ein Bild hochladen","sorry":"SORRY","subject_id":{"require_fanship":"Fantum ist ein Muss!"},"text":{"duplicate_comment":"Kommentar kopieren","duplicate_post":"Artikel kopieren","max_char":"H\u00f6chstens %{num_chars} Zeichen","max_words":"Maximum %{num_words} W\u00f6rter","min_char":"Mindestens %{num_chars} Zeichen"},"twitter_url":{"invalid":"Ung\u00fcltige Twitter URL"},"unknown_upload":"Ein Unbekannter Fehler ist eingetreten, bitte kontaktieren","unsupported_video":"Wir unterst\u00fctzen diese Art von Video nicht","url_err":"Unbekannter Fehler (URL falsch geschrieben?) Bitte kontaktiere einen Administrator","website":{"blank":"Bitte gib die URL der Seite ein"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%A, %e %B %Y, %H:%M Uhr","long":"%A, %e %B %Y, %H:%M Uhr","short":"%e %b, %H:%M","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"Log in"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Anmelden","language":"Sprache","languages":{"de":"Deutsch","en":"Englisch","es":"Spanisch","fr":"Franz\u00f6sisch","hi":null,"id":"Indonesisch","it":"Italienisch","pt-BR":"Portugiesisch","th":"Thail\u00e4ndisch","tr":"T\u00fcrkisch","vn":"Vietnamesisch"},"message":"Mitteilung","next":"N\u00e4chste","prev":"Zur\u00fcck","prompt":{},"right":{},"share":"Teilen","table":"Tabelle","tweet":"Twittern","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"\u00dcber die Mannschaft","add_caption":"F\u00fcge einen Titel ein","add_content":"Inhalte von folgenden Quellen in den Artikel einf\u00fcgen:","add_image":"F\u00fcge ein Bild hinzu","add_item":"Medien hinzuf\u00fcgen","add_media":"F\u00fcge Medien hinzu","add_team":"Mannschaft hinzuf\u00fcgen","additional_media":"Zus\u00e4tzliche Medien","are_you_sure":"Willst du die Seite wirklich verlassen?","article_preview":"Vorschau des Artikels","attach_image":"W\u00e4hle ein Photo","back":"\nZur\u00fcck","back_to_edit":" Zur\u00fcck zur Bearbeitung","back_to_editing":"Zur\u00fcck zur \u00dcberarbeitung\n","bold_tooltip":"Fett","caption_optional":"(Optional, H\u00f6chstens 22 Zeichen)","char_count":"Zeichenanzahl: %{num}","check_grammar":"Text auf Rechtschreib- und Grammatikfehler \u00fcberpr\u00fcfen","choose_team":"W\u00e4hle eine Mannschaft","clear":"L\u00f6schen","complete_steps":"Vor dem Verfassen musst Du noch folgendes tun:","congrats":"Gratulation!","cover_image":"Nach Ver\u00f6ffentlichung auf der Seite, unserer App oder in den Sozialen Netzwerken angezeigt","create_article":"Verfasse einen Artikel","crop_image":"Bild anpassen","crop_ratio":"Dimension des Bildes","crop_too_small":"Bild ist zu klein","date":"Datum:","delete":"L\u00d6SCHEN","delete_article":"Diesen Artikel l\u00f6schen","discard":"Verwerfen","discard_confirmation":"Willst du diesen Beitrag wirklich verwerfen?","draft":"Speichern","drag":"Bild / Video hierhin ziehen","drag_all":"Bild, Video oder andere Inhalte hier einf\u00fcgen","drag_crop":"Passe das Bild an","drop_here":"Hier einf\u00fcgen","drop_image":"Bild hier einf\u00fcgen","edit_crop":"Beweg das Viereck um das Bild zu bearbeiten","edit_thumb":"Kleinbild bearbeiten","editor":"Editor","embed":"Einf\u00fcgen","embed_code":"Embed Code","embed_only":"Embed Code hier einf\u00fcgen","embed_video":"Video einf\u00fcgen","enter_desc":"Beschreibung hier einf\u00fcgen...","enter_title":"Titel hier einf\u00fcgen","enter_url":"URL/code einf\u00fcgen","facebook_cover_image":"Facebook Titelbild","ftbpro_editor":"FTBpro Editor","grammar_spelling":"Nimm Dir Zeit um Deinen Artikel zu \u00fcberpr\u00fcfen","great":"Super!","guide_tips":"Lesen Sie unsere Richtlinien und Schreibempfehlungen","guide_tips_links":"http://www.90min.com/blog/richtlinien-tipps/","h2_tooltip":"\u00dcberschrift","header_edit":"Beitrag bearbeiten","header_new":"neuer Beitrag","hyperlink_tooltip":"Link","image_bank":"Bilder Galerie","image_crop":"Ausw\u00e4hlen","image_format":"Das Bildformat begrenzt sich auf: JPEG, PNG und gif.","image_search":"Suchen","image_size":"Die Bildgr\u00f6\u00dfe muss 500X280 Pixel \u00fcbertreffen","image_size_parameterized":"Die Bildgr\u00f6\u00dfe muss %{width}x%{height} Pixel \u00fcbertreffen","image_video":"Bild/Video","image_weight":"Diese Datei \u00fcbertrifft die Maximalgr\u00f6\u00dfe von %{fileSizeMaxSupported}","insert_link":"Link f\u00fcr Video einf\u00fcgen","invalid_code":"URL/Code ung\u00fcltig oder nicht unterst\u00fctzt. Bitte einen g\u00fcltigen URL/Code einf\u00fcgen.","leave":"Seite verlassen","leave_warning":"Willst du diese Seite verlassen ohne abzuspeichern? Alle \u00c4nderungen werden gel\u00f6scht","list_tooltip":"Aufz\u00e4hlung","max":"(Max%{num})","max_reached":"(Maximum erreicht)","media_longer":"(f\u00fcr Artikel mit mehr als 200 W\u00f6rtern)","media_longer_than":"(f\u00fcr Artikel mit mehr als 300 W\u00f6rtern)","media_post":"Medien Post","min":"(Min %{num})","min_words":"(mindestens %{num} W\u00f6rter)","no_draft":"Keine gespeicherten Entw\u00fcrfe","num_words":{"one":"1 Wort","other":"%{count} W\u00f6rter"},"number_list_tooltip":"Nummerierte Liste","oops":"Fast fertig...","optimal_article":"(optimal 300-800)","optimal_length":"(optimal %{min}-%{max})","optional":"(Optional, H\u00f6chstens 160 Zeichen)","optional_field":"Das Feld ist optional","or":"Oder","p_tooltip":"Abschnitt","paste_embed":"Link einf\u00fcgen oder code hier einbinden","paste_url":"URL oder Embed-Code einf\u00fcgen","playbuzz":"Den kompletten Link des erstellten PlayBuzz.com Artikels hier einf\u00fcgen","polls":"Umfrage einf\u00fcgen","prev":"Vorschau","preview":"Vorschau","publish":"Verfassen","remove_attachment":"Bist du sicher, dass du den Anhang entfernen willst?","reset":"Zur\u00fccksetzen","review":"Vorschau & Verfassen","save_changes":"\u00c4nderungen speichern?","save_draft":"ALS ENTWURF SPEICHERN","search_bank":"Datenbank nach Bildern durchsuchen","search_for":"Suchen...","searching":"L\u00e4dt...","select_photo":"W\u00e4hle ein Photo","seo_desc":"SEO-Beschreibung","share":"Teile diesen Beitrag auf Facebook","small_image":"Dein Bild ist zu klein, die Aufl\u00f6sung muss mindestens 300x150 sein","source":"Quelle:","start_at":"Starte von","stay":"Auf der Seite bleiben","steps_complete":"Dein Artikel ist jetzt zum Verfassen bereit.","styling_tooltip":"Formatierung l\u00f6schen","tag":"Tags","tag_at_least":"(W\u00e4hle mindestens einen)","tag_sug":"Empfohlene Tags","tag_team":"\"Tag\"","teaser":"Kurzer Auszug","teaser_watermark":"Wird nur als Beschreibung bei Links zu Deinem Artikel erscheinen","this_is_preview":"Dies ist eine Vorschau Deines Artikels","tip_controversial ":"Schreib \u00fcber umstrittene Sachen. Ein guter Artikel regt zu Fragen an.","tip_image":"F\u00fcg ein Bild hinzu! Artikel mit Bildern sind beliebter","tip_media":"Hast du ein gutes Video? Videos von YouTube, oder Metacafe bekommen viel Aufmerksamkeit","tip_short":"Halte deine Paragraphen kurz. Leser \u00fcberspringen oftmals l\u00e4ngere Passagen","tips":{"media_close_ups":"Benutze Nahansicht-Bilder bei Artikeln \u00fcber Spieler","media_image_bank":"Wir schlagen vor unsere Getty Bilder-Datenbank zu benutzen um das gew\u00fcnschte Bild zu finden. Suche nach Spielern oder Klubs","post_enjoy":"Das Wichtigste: Viel Spass!!","post_original":"Sei originell. Inhalt, der von anderen Quellen kopiert wird, ist nicht gestattet.","post_paragraphs":"F\u00fcge Abschnitte ein um den Artikel aufzuteilen und attraktiver zu machen. ","post_review":"\u00dcberpr\u00fcfe Deinen Artikel bevor Du ihn publizierst. \u00dcberpr\u00fcfe ihn bez\u00fcglich Grammatik- und Rechtschreibefehlern","title":"Tipps f\u00fcr bessere Leserzahlen:","title_debatable":"Verwende spezielle Ausdr\u00fccke. \u00dcbertreibe ein wenig. Die Leute f\u00fchlen sich von debattierbaren Themen angezogen.","title_known_name":"Beginne den Titel mit einem Klub- oder Spielernamen","title_popular_terms":"Binde popul\u00e4re W\u00f6rter wie ganze Spielernamen, Klubnamen oder aktuelle Themen ein.","title_question":"Stelle eine Frage, die im Artikel beantwortet wird.","title_short":"Achte auf kurze Titel: 5-8 W\u00f6rter sind optimal. "},"title":"Titel","too_long":"Zu lang (optimal 10-75)","too_short":"Zu kurz (optimal 10-75)","toolong":"Zu lang (optimal %{min}-%{max})","tooshort":"Zu kurz (optimal %{min}-%{max})","try_again":"Versuche es erneut","upload_failed":"Beim hochladen des Bildes gab es einen Fehler. Versuche es erneut","upload_image":"Foto einf\u00fcgen","upload_img":"Bild hochladen","valid_code":"Der angegebene Embed Code stimmt nicht.","video":"Video","video_provider":"We unterst\u00fctzen diesen Video-Provider derzeit nicht.","video_services":"F\u00fcge ein Video von YouTube, Dailymotion oder Metacafe hier ein:","video_url":"Video URL (Youtube, Dailymotion, Metacafe)","word_count":"W\u00f6rteranzahl: %{num}","writing_sug":"SEO Empfehlungen","writing_tips":"Tipps","your_post":"Dein Artikel "},"embed":{"button":"Einf\u00fcgen","dialogue":{"additional_options":"Weitere Optionen","become_a_partner":"PARTNER WERDEN","comments":"Kommentare anzeigen","customise_collapse/expand":"CODE ANPASSEN","disclaimer":"Durch das Einf\u00fcgen des Codes stimmen Sie unseren %{terms_conditions} zu","embed_code":"Code einf\u00fcgen","embed_instructions":"Den HTML-Code kopieren und diesen auf ihrer Webseite einf\u00fcgen","embed_instructions_partners":"Den individuellen Code kopieren und hier einf\u00fcgen","full_title":"Ganzer Titel","header":"POST EINF\u00dcGEN","info":"Das Entfernen des 90min-Links ist Partnern vorbehalten","link":"Link zu 90min anzeigen","logged_in":"Kontaktieren Sie %{email} um unserem Partner-Programm beizutreten.","login":"Einloggen","partner_message":"Bereits ein Partner? %{login} um einen individuellen Code zu bekommen.","remove_title":"Titel entfernen","show-author":"Autor anzeigen","show-date":"Datum anzeigen","show-reads-counter":"Leserzahl anzeigen","show-title":"Titel anzeigen","terms_&_conditions":"Allgemeine Gesch\u00e4ftsbedingungen","title":"Titel","views":"Leserzahl anzeigen"}},"footer":{"about_12up":null,"about_90min":"\u00dcber 90min","about_circasports":"\u00dcber CircaSports","about_dbltap":null,"about_ei":null,"about_floor8":null,"about_ftb90":"\u00dcber FTB90","about_ftbpro":"\u00dcber uns","about_german_site":"\u00dcber 90min","about_ht_media":null,"about_pluralist":null,"about_swurley":"\u00dcber Swurley","about_theduel":null,"affiliates":"Affiliates","apps":"Mobilapplikationen","apps_Android":"Hol es Dir auf","apps_iphone":"Erh\u00e4ltlich beim","blog":"Blog","boomerang":null,"cartoon":null,"contact_ftbpro":"Kontakt","fan_store":"Fan Shop","faq":"Fragen und Antworten","house_rules":"Regeln","in_the_news":"Pressespiegel","jobs":"Jobs","licensing":"Lizenz","links":"Links","links_social":"Links","more_about_12up":null,"more_about_90min":"Mehr Infos zu 90min","more_about_circasports":"Mehr Infos zu CircaSports","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":null,"more_about_ftb90":"Mehr Infos zu FTB90","more_about_german_site":"Mehr Infos zu 90min","more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"Mehr Infos zu Swurley","more_about_theduel":null,"partner_sites":null,"partners":"Partner","prev_prog":null,"privacy_policy":"Datenschutz","rights_reserved":"Alle Rechte vorbehalten","rights_reserved_year":"2016 FTBpro \u00a9 Alle Rechte vorbehalten","rights_reserved_year_12up":null,"rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 Alle Rechte vorbehalten","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports \u00a9 Alle Rechte vorbehalten","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"Minute Media 2018 FTB90 \u00a9 Alle Rechte vorbehalten","rights_reserved_year_german_site":"Minute Media 2019 90min \u00a9 Alle Rechte vorbehalten","rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"2016 Swurley \u00a9 Alle Rechte vorbehalten","rights_reserved_year_theduel":null,"space":null,"statistics_12up":null,"statistics_90min":"90min Statistiken","statistics_circasports":"CircaSports Statistiken","statistics_ei":null,"statistics_floor8":null,"statistics_ftb90":"FTB90 Statistiken","statistics_ht_media":null,"statistics_swurley":"Swurley Statistiken","statistics_theduel":null,"stats":{"articles":"Artikel","fans":"Fans","members":"Mitglieder","writers":"Autoren"},"support":"Support","tbs":null,"tcm":null,"terms":"Bedingungen","terms_conditions":"Bedingungen","tnt":null,"warner":null,"writers":"Autoren"},"header":{"profile":"Mein Profil","settings":"Einstellungen","signout":"Abmelden"},"home":{"no_matches":"Keine weiteren Spiele"},"homepage":{"be_the_first":"ALS ERSTER INFORMIERT SEIN","by":"Von","chrome_notifications":"Bleib mit Chrome Notifications auf dem Laufenden","ei":{"latest_news":null,"trending":null,"view_more":null},"fan_perspectives":"Alle Infos","fan_voice":"FAN ZONE","featured_topic":null,"fixtures_and_scores":null,"fixtures_scores":"Spielplan & Resultate","follow_us_on":"Folge uns auf Snapchat:","latest_videos":"Neueste Videos","league_page":null,"match_day":"Spieltag %{num}","month":"%M","more":"Mehr","most_read":"Trending","no_matches":"Keine Spiele an diesem Tag","other_categories":"MEHR KATEGORIEN","our_categories":"KATEGORIEN","read_now":"JETZT LESEN","schedule":"SPIELPLAN","scores_page_desc":"Alle letzten Spiele und Ergebnisse","scores_page_title":"Spiele & Ergebnisse","social_text":null,"stay_up_to":"Bleib dran mit den aktuellsten News","top_stories":"Aktuelle Meldungen","trending":null,"trending_floor8":null,"video":"Video","videos":"Videos","view_all":"Alle Spiele im \u00dcberblick","view_more":"Weitere Artikel","watch_more_videos":"Mehr Videos","watch_tv_12up":null,"watch_tv_90min":"90MIN TV ANSCHAUEN","watch_tv_circasports":null,"watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":null,"watch_tv_german_site":"90MIN TV ANSCHAUEN","watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"Werbung","bet_now":"Jetzt Wetten","by":"Von","by_betway":"mit","community_content":"HINWEIS","community_disclaimer":"Dieser Post wurde von einem Mitglied unserer 90min Community erstellt und wurde noch nicht von unserer Redaktion bearbeitet oder best\u00e4tigt.","community_disclaimer_12up":null,"community_disclaimer_90min":"Dieser Post wurde von einem Mitglied unserer 90min Community erstellt und wurde noch nicht von unserer Redaktion bearbeitet oder best\u00e4tigt.","community_disclaimer_circasports":"Dieser Post wurde von einem Mitglied unserer CircaSports Community erstellt und wurde noch nicht von unserer Redaktion bearbeitet oder best\u00e4tigt.","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":null,"community_disclaimer_ftb90":"Dieser Post wurde von einem Mitglied unserer FTB90 Community erstellt und wurde noch nicht von unserer Redaktion bearbeitet oder best\u00e4tigt.","community_disclaimer_german_site":"Dieser Post wurde von einem Mitglied unserer 90min Community erstellt und wurde noch nicht von unserer Redaktion bearbeitet oder best\u00e4tigt.","community_disclaimer_ht_media":null,"community_disclaimer_swurley":"Dieser Post wurde von einem Mitglied unserer Swurley Community erstellt und wurde noch nicht von unserer Redaktion bearbeitet oder best\u00e4tigt.","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} benutzt Cookies um Inhalte und Werbungen anzupassen, sowie die Seite nutzerfreundlicher zu gestalten. Einige Informationen werden mit Drittpartein f\u00fcr Werbezwecke und Datenanalyse geteilt.","cookies_consent_2":"Mehr Infos","cookies_consent_approve":"Verstanden","notf":{},"now_playing":"JETZT ABSPIELEN","similar_articles":"\u00c4hnliche Artikel"},"private_messages":{"conversation_date":"Zuletzt gelesen","expand":"Erweitern","header":"Mitteilungen","message_sent":"Deine Mitteilung wurde verschickt","messages":"Mitteilungen","no_history":"Keine Historie","not_available":"Die Unterhaltung ist nicht verf\u00fcgbar","private_message":"Private Mitteilung","private_message_to":"Private Mitteilung","send":"Senden","send_failed":"Nachricht wurde nicht gesendet. Entschuldige, versuche es sp\u00e4ter noch einmal.","sending":"Sendet\u2026","sent":"Nachricht geschickt","side_title":"Unterhaltungen","title":"Zwischen dir und","view_history":"Unterhaltungsverlauf anzeigen","write_message_here":"Schreibe hier Deine Nachricht"},"pundit":{"bet_via":"WETTE SETZEN VIA","draw":"Remis","fan_predictions":"Fanprognosen","follow_match":"Spiel folgen","follow_pundit":"Dem Experten folgen","log_in":"Einloggen, um die Vorhersage zu speichern","not_available":"Statistiken derzeit nicht verf\u00fcgbar. Versuche es sp\u00e4ter erneut.","place_your_bet":"WETTE SETZEN","place_your_bet_via":"Wette setzen via","prediction":"Vorhersage:","pundit_prediction":"%{pundit_first_name}s Prognose:","select_match":"Spiel f\u00fcr die Wette ausw\u00e4hlen","select_result":"- Ergebnis ausw\u00e4hlen -","team_to_win":"%{team} gewinnt","title":"%{team1} vs %{team2}: Wett-Tipps von %{pundit_name}","top_predictors":"TOP-EXPERTEN","what_result":"Du glaubst, du kennst das Ergebnis?","what_your_prediction":"WAS IST DEINE PROGNOSE?","your_prediction":"DEINE VORHERSAGE:"},"reactions":{"campaigns_poweredby":null,"v1":{"lol":"LOL","love":"Spitze","must":"Wichtig","noway":"Niemals!","share":"Teilen","shocked":"Schockiert","tweet":"Tweeten"},"v2":{"booh":null,"cool":null,"haha":"Haha","loveit":null,"noway":null},"your_reaction":"Ihre Reaktion?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"Mein Artikel hat hundert Leser erreicht","about_you":"\u00dcber Dich","account":"Konto","all_info_lost":"Alle Informationen auf FTBpro.com werden unwiderruflich gel\u00f6scht.","are_you_sure":"Bist Du sicher?","by_email":"E-mail","connected_as":"Verbinden als","deactivate":"Mein Konto deaktivieren","deactivate_placeholder":"Bitte lass uns wissen weshalb:","deactivate_request_sent":"Deine Anfrage wurde erfolgreich abgeschlossen. Wir werden Dich in K\u00fcrze kontaktieren.","disp_name":"Name anzeigen","fb_hometown":" Stadt von Facebook nehmen","fb_link":"Facebook link","go_social":"Werde sozial - lass meine Freunde von meinen Aktivit\u00e4ten wissen","go_social_short":"Teile meine Leserzahlen","google_plus_link":"Google+ Link","if_following_me":"Jemand mir folgt","if_sending_me_message":"Jemand mir eine Mitteilung geschickt hat","let_see":"Jeder soll mich sehen","my_team":"Meine Mannschaft","name":{"rules":"Muss zwischen 5 - 50 Zeichen sein."},"notifications":"Nachrichten","optional":"optional","privacy":"Privat","recent_articles":"Zuletzt ver\u00f6ffentlichte Artikel","save":"Speichern","settings":"Einstellungen","settings_saved":"Einstellungen wurden gespeichert","share":"Automatisch teilen","site":"Seite","site_title":"Titel","site_url":"URL","stats":"vBets Statistik","submit":"Senden","twitter_link":"Twitter link","weekly_writers_achievements":"Meine w\u00f6chentliche Zusammenfassung","when_notify":"Benachrichtige mich wenn","your_writing_language":"In welcher Sprache wirst Du schreiben?"},"sign_up":{"about_you":"Schreibe etwas \u00fcber die Liebe zu Deinem Verein (optional)","and":"und","change":"Du kannst diese Einstellungen zu jeder Zeit \u00e4ndern","disp_name":"Name anzeigen","join_12up":null,"join_90min":"90min beitreten","join_circasports":"CircaSports beitreten","join_dbltap":null,"join_ei":null,"join_floor8":null,"join_ftb90":"FTB90 Beitreten","join_german_site":"90min beitreten","join_ht_media":null,"join_swurley":"Swurley beitreten","lets_start":"Legen wir los","my_game":"Spiel","my_league":"Liga","of_12up":null,"of_90min":"90min zu","of_circasports":"von Swurley","of_dbltap":null,"of_ei":null,"of_floor8":null,"of_ftb90":"von FTB90","of_german_site":"de 90min.de","of_ht_media":null,"privacy_policy":"Datenschutz","required_field":"Erforderliches Feld","team":"Meine Mannschaft","terms":"Ich stimme den ","terms_and_conditions":"Bedingungen"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"Artikel","comments":"Kommentare","reads":"Leser"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"NEUSTE MELDUNGEN","latest_videos":"NEUESTE VIDEOS","read_more":"Weiter lesen","recommended":"EMPFEHLENSWERT","video":"Video"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"it":{"date":{"abbr_day_names":["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],"abbr_month_names":[null,"Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],"day_names":["Domenica","Luned\u00ec","Marted\u00ec","Mercoled\u00ec","Gioved\u00ec","Venerd\u00ec","Sabato"],"formats":{"default":"%d-%m-%Y","long":"%d %B %Y","short":"%d %b","capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],"order":["day","month","year"],"time_since":{"about_an_hour_ago":"circa unora fa","about_two_hours_ago":"circa due ore fa","seconds_ago":"qualche secondo fa","x_hours_ago":{"one":"un'ora fa","other":"%{count} ore fa"},"x_minutes_ago":{"one":"1 minuto fa","other":"%{count} minuti fa"}}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"deve essere accettata","blank":"non pu\u00f2 essere lasciato in bianco","confirmation":"non coincide con la conferma","empty":"non pu\u00f2 essere vuoto","equal_to":"deve essere uguale a %{count}","even":"deve essere pari","exclusion":"\u00e8 riservato","greater_than":"deve essere superiore a %{count}","greater_than_or_equal_to":"deve essere superiore o uguale a %{count}","inclusion":"non \u00e8 incluso nella lista","invalid":"non \u00e8 valido","less_than":"deve essere meno di %{count}","less_than_or_equal_to":"deve essere meno o uguale a %{count}","not_a_number":"non \u00e8 un numero","not_an_integer":"non \u00e8 un intero","odd":"deve essere dispari","record_invalid":"Validazione fallita: %{errors}","taken":"\u00e8 gi\u00e0 in uso","too_long":{"one":"\u00e8 troppo lungo (il massimo \u00e8 1 carattere)","other":"\u00e8 troppo lungo (il massimo \u00e8 %{count} caratteri)"},"too_short":{"one":"\u00e8 troppo corto (il minimo \u00e8 1 carattere)","other":"\u00e8 troppo corto (il minimo \u00e8 %{count} caratteri)"},"wrong_length":{"one":"\u00e8 della lunghezza sbagliata (deve essere di 1 carattere)","other":"\u00e8 della lunghezza sbagliata (deve essere di %{count} caratteri)"}},"template":{"body":"Per favore ricontrolla i seguenti campi:","header":{"one":"Non posso salvare questo %{model}: 1 errore","other":"Non posso salvare questo %{model}: %{count} errori."}},"200_pixels":"L'immagine deve essere almeno di 200x200 pixels","file_too_big":"Il file caricato \u00e8 troppo grande","flash":"Devi installare Adobe Flash per utilizzare questa sezione","invalid_filetype":"Tipo file non valido ( supportiamo. gif,. jpg,. jpeg e .png)","invalid_url":"Url non valido","mobile_error":"Questo video non pu\u00f2 essere visualizzato sul cellulare","motto":{"title":"Prego inserisca 10-25 caratteri"},"nick":{"duplicate":"Nick \u00e8 gia in uso","length":"Prego inserisca 5-50 caratteri","title":"Utilizza solo lettere, numeri, punti e trattini","validation":"Il tuo nome deve contenere almeno 5-50 caratteri - solo lettere, cifre, puntini e trattini"},"no_file":"Nessun file scelto","not_found":"Non siamo riusciti a trovare la pagina\n","one_team":"Devi assegnare  almeno una squadra","pic_size":"L'immagine del file deve essere tra %{min} e %{max}","ratio_alert":"Il rapporto dell'immagine deve essere di almeno 1:2 e 2:1","return_homepage":"Torna alla homepage","select_image":"  Devi selezionare un' immagine da caricare","sorry":"CI DISPIACE","subject_id":{"require_fanship":"Comunit\u00e0 di fan \u00e8 obbligatoria!"},"text":{"duplicate_comment":"Commento duplicato","duplicate_post":"Post duplicato","max_char":"Massimo %{num_chars} caratteri","max_words":"Massimo %{num_words} parole","min_char":"Minimo %{num_chars} caratteri"},"twitter_url":{"invalid":"Twitter non valido URL"},"unknown_upload":"Si \u00e8 verificato un errore nel caricamento, contattare il servizio","unsupported_video":"Scusate, non supportiamo questo tipo video per questo sito","url_err":"Errore sconosciuto(errore scrittura URL?), contatta il moderatore","website":{"blank":"Prego inserisca il sito URL"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%a %d %b %Y, %H:%M:%S %z","long":"%d %B %Y %H:%M","short":"%d %b %H:%M","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"Login"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Connettiti","language":"Lingua","languages":{"de":"tedesco","en":"inglese","es":"spagnolo","fr":"francese","hi":null,"id":"Indonesiano","it":"italiano","pt-BR":"Portoghese","th":"Thailandese","tr":"Turco","vn":"Vietnamita"},"message":"Messaggio","next":"Prossimo","prev":"Precedente","prompt":{},"right":{},"share":"Condividi","table":"Classifica","tweet":"Tweet ","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"a proposito della squadra","add_caption":"Aggiungi un Titolo","add_content":"Aggiungi contenuto al tuo articolo dalle seguenti fonti supportate:","add_image":"Aggiungi Immagine","add_item":"Aggiungi una foto/video","add_media":"Aggiungi Media  ","add_team":"aggiungi una squadra","additional_media":"Media aggiuntivo ","are_you_sure":"Sei sicuro di voler lasciare questa pagina?","article_preview":"Questa \u00e8 l'anteprima del tuo articolo","attach_image":" Scegli una foto     ","back":"Indietro","back_to_edit":" Torna a modificare","back_to_editing":"Torna a modificare","bold_tooltip":"Grassetto","caption_optional":"(Facoltativo, Massimo 22 caratteri)","char_count":"Caratteri: %{num}","check_grammar":"Per favore controlla bene per errori di spelling e grammatica","choose_team":"Scegli una squadra","clear":"Cancella","complete_steps":"Prima di pubblicare bisogna completare questi passaggi:","congrats":"Congratulazioni!","cover_image":"Questa sara' l' immagine che verra' mostrata quando l'articolo e' pubblicato sul sito, sull' app o sui social networks","create_article":" Creatore articolo ","crop_image":"Trascina l' immagine","crop_ratio":"Trascina misura","crop_too_small":"L'immagine \u00e8 troppo piccola","date":"Data","delete":"ELIMINA","delete_article":"Cancella questo articolo","discard":"Cancella","discard_confirmation":"Sei sicuro di voler scartare questo post?","draft":"Salva","drag":"Trascina immagine/video qui","drag_all":"Trascina immagine, video o contenuto social qui","drag_crop":" Trascina per riposizionare  ","drop_here":"Trascina qui...","drop_image":"Trascina qui l' immagine","edit_crop":"Sposta/modifica rettangolo per aggiustare thumbnail","edit_thumb":"Modifica Thumbnail","editor":"Editore:","embed":"Incorporare","embed_code":"Inserire il codice","embed_only":"Incolla il codice qui","embed_video":"Incorporare un Video","enter_desc":"Scrivi qui la descrizione","enter_title":"Inserisci qui il titolo...","enter_url":"Inserisci URL/codice","facebook_cover_image":"Facebook Immagine Copertina","ftbpro_editor":"Redattore FTBpro","grammar_spelling":"Prenditi tutto il tempo per controllare i dettagli grammaticali e l'ortografia","great":"Ottimo!","guide_tips":"Leggi le nostre linee guida e suggerimenti","guide_tips_links":"http://www.90min.com/blog/istruzioni-e-consigli/","h2_tooltip":"Titolo","header_edit":"modifica post ","header_new":"nuovo post ","hyperlink_tooltip":"Link","image_bank":"Galleria Immagini","image_crop":"Ritagliare","image_format":"Il formato dell' immagine e' limitato a JPEG, PNG e gif","image_search":"Cercare ","image_size":"Le dimensioni devono essere piu' larghe di 500x280 pixels.","image_size_parameterized":"Le dimensioni devono essere piu' larghe di %{width}x%{height} pixels.","image_video":"Immagine/video","image_weight":"Questo file eccede il limite massimo di %{fileSizeMaxSupported}","insert_link":"Incolla il link qui","invalid_code":"Il codice/URL non e' valido o non e' supportato. Perfavore inserisci un valido codice/URL","leave":"Lascia questa pagina?","leave_warning":"Stai lasciando questa pagina senza salvare. Tutti i cambiamenti saranno persi!","list_tooltip":"Lista","max":"(Massimo %{num})","max_reached":"(raggiunto il massimo)","media_longer":"(per articoli piu' lunghi di 200 parole)","media_longer_than":"(per articoli piu' lunghi di 300 parole)","media_post":"Foto/Video","min":"(Min %{num})","min_words":"(almeno %{num} parole)","no_draft":"Non ci sono bozze salvate","num_words":{"one":"1 parola","other":"%{count} parole"},"number_list_tooltip":"Lista numerica","oops":"Ci siamo quasi...","optimal_article":"(Ottimale 300-800)","optimal_length":"(Ottimale %{min}-%{max})","optional":"(Facoltativo, Massimo 160 caratteri)","optional_field":"Questo campo \u00e8 facoltativo","or":"O","p_tooltip":"Paragrafo","paste_embed":"Incolla il link o inserisci il codice qui","paste_url":"Incolla un link url o incorpora il codice","playbuzz":"Inserisci l'intero URL dell' articolo che hai creato su PlayBuzz.com qui","polls":"Aggiungi un sondaggio","prev":"Anteprima","preview":"Salva e vedi anteprima","publish":"Pubblica","remove_attachment":"Sei sicuro di voler eliminare questo post?","reset":"Cancella","review":"Bozza prima della pubblicazione ","save_changes":"Vuoi salvare le modifiche?","save_draft":"SALVA COME BOZZA","search_bank":"Cerca nella galleria immagini","search_for":"Cerca...","searching":"Cercando...","select_photo":" Seleziona una foto","seo_desc":"Descrizione SEO","share":"Condividi questo post su Facebook","small_image":"La tua foto e' troppo piccola, deve essere almeno 300x150","source":"Fonte:","start_at":"Inizio alle","stay":"Stai sulla pagina","steps_complete":"Il tuo articolo ora e' pronto per essere pubblicato.","styling_tooltip":"Cancella formato","tag":"Tags","tag_at_least":"(Scegli almeno 1 squadra)","tag_sug":"Suggerimenti Tag","tag_team":"Tag ","teaser":"Rompicapo","teaser_watermark":"Apparira' solo come una descrizione sul link del tuo articolo","this_is_preview":"Questa e' l'anteprima del tuo articolo","tip_controversial ":"Renditi discutibile. Un bel post comunque solleva dure domande.","tip_image":"Aggiungi una foto. Post con immagini attraggono pi\u00f9 persone","tip_media":"Trovato un bel video? Video da youtube o Metacafe suscita grandi reazioni","tip_short":"Mantieni i tuoi paragrafi corti. I lettori tendono a saltare i paragrafi lunghi","tips":{"media_close_ups":"    Usa immagini di primo piano negli articoli sui giocatori","media_image_bank":"Raccomandiamo di utilizzare la nostra sezione Getty Image per trovare ogni foto di cui tu abbia bisogno.Ricerca per giocatore o squadra.","post_enjoy":"La cosa piu' importnate, divertiti !","post_original":"Sii originale. Contenuti copiati da altre fonti non saranno permessi.","post_paragraphs":"Utilizza paragrafi per spezzare il tuo articolo","post_review":"Riguarda il tuo articolo prima di pubblicarlo","title":"Suggerimenti per aumentare letture:","title_debatable":"Utilizza un linguaggio  supponente. Esagera anche. Alla gente piacciono i temi discutibili.","title_known_name":"Inizia il tuo titolo con il nome del giocatore o della squadra.","title_popular_terms":"Includi parole popolari come nomi completi dei giocatori,nomi di squadre, o temi caldi.","title_question":"Fai una domanda che trova risposta all' interno del tuo articolo.","title_short":"Essere brevi. 5- 8 parole e' la cosa migliore."},"title":"Titolo","too_long":"Troppo lungo (ottimale 10-75)","too_short":"Troppo corto (ottimanle 10-75)","toolong":"Troppo lungo (ottimale %{min}-%{max})","tooshort":"Troppo corto (ottimanle %{min}-%{max})","try_again":"Prova di nuovo","upload_failed":"Si \u00e8 verificato un errore durante il caricamento dell'immagine. Prova di nuovo.","upload_image":"Carica una Foto","upload_img":"Carica immagine","valid_code":"Il codice che hai inserito non e' valido.","video":"Video","video_provider":"Al momento non supportiamo questo formato video.","video_services":"Incolla un video da Youtube, Dailymotion o Metacafe qui:","video_url":"Video URL (Youtube, Dailymotion, Metacafe)","word_count":"Parole: %{num}","writing_sug":"Suggerimenti SEO","writing_tips":"Consigli per scrivere meglio","your_post":"Il tuo Post "},"embed":{"button":"Incorpora","dialogue":{"additional_options":"Opzioni aggiuntive","become_a_partner":"DIVENTA UN PARTNER","comments":"Mostra commenti","customise_collapse/expand":"Personalizza il codice","disclaimer":"Incorporando questo codice sei d'accordo con i nostri %{terms_conditions}","embed_code":"Incorpora codice","embed_instructions":"Aggiungi questo post al tuo sito copiando e incollando il codice HTML sotto","embed_instructions_partners":"Copia e incolla il tuo codice personalizzato sotto","full_title":"Titolo completo","header":"Post incorporato","info":"La rimozione del link 90min e' disponibile solo per i partners","link":"Mostra il link a 90min","logged_in":"Scrivi a %{email} per unirti ad uno dei nostri programmi di collaborazione.","login":"log in","partner_message":"Sei gia' un partner? Effettua il %{login} con il tuo codice personalizzato.","remove_title":"Rimuovi titolo","show-author":"Mostra autore ","show-date":"Mostra data","show-reads-counter":"Mostra il numero di visite","show-title":"Mostra titolo","terms_&_conditions":"Termini e le nostre Condizioni","title":"Titolo","views":"Mostra il numero di visite"}},"footer":{"about_12up":null,"about_90min":"A proposito di 90min","about_circasports":"A proposito di CircaSports","about_dbltap":null,"about_ei":null,"about_floor8":null,"about_ftb90":"A proposito di FTB90","about_ftbpro":"Chi siamo","about_german_site":null,"about_ht_media":null,"about_pluralist":null,"about_swurley":"A proposito di Swurley","about_theduel":null,"affiliates":"Affiliati","apps":"Applicazioni cellulare","apps_Android":"TROVALA SU","apps_iphone":"DISPONIBILE SU","blog":"Blog","boomerang":null,"cartoon":null,"contact_ftbpro":"Contattaci","fan_store":"Fan Store","faq":"FAQ","house_rules":"Regole di casa","in_the_news":"Sulla stampa","jobs":"Lavori","licensing":"Licenza","links":"Links","links_social":"Links","more_about_12up":null,"more_about_90min":"Piu' info su 90min","more_about_circasports":"Piu' info su CircaSports","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":null,"more_about_ftb90":"Piu' info su FTB90","more_about_german_site":null,"more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"Piu' info su Swurley","more_about_theduel":null,"partner_sites":null,"partners":"Partners","prev_prog":null,"privacy_policy":"Norme della privacy","rights_reserved":"Tutti i diritti riservati","rights_reserved_year":"2016 FTBpro \u00a9 Tutti i diritti riservati","rights_reserved_year_12up":null,"rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 Tutti i diritti riservati","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports \u00a9 Tutti i diritti riservati","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"2016 FTB90 \u00a9 Tutti i diritti riservati","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"2016 Swurley \u00a9 Tutti i diritti riservati","rights_reserved_year_theduel":null,"space":null,"statistics_12up":null,"statistics_90min":"I numeri di 90min","statistics_circasports":"I numeri di CircaSports","statistics_ei":null,"statistics_floor8":null,"statistics_ftb90":"I numeri di FTB90","statistics_ht_media":null,"statistics_swurley":"I numeri di Swurley","statistics_theduel":null,"stats":{"articles":"Articoli","fans":"Fans","members":"Membri","writers":"Scrittori"},"support":"Supporto ","tbs":null,"tcm":null,"terms":"Termini","terms_conditions":"Termini & condizioni","tnt":null,"warner":null,"writers":"Scrittori"},"header":{"profile":"Mio profilo","settings":"Impostazioni","signout":"Esci"},"home":{"no_matches":"Nessuna partita in programma"},"homepage":{"be_the_first":"DIVENTA IL PRIMO A SAPERLO! ","by":"Di: ","chrome_notifications":"Mantieniti aggiornato con le nostre Notifiche Chrome ","ei":{"latest_news":null,"trending":null,"view_more":null},"fan_perspectives":"Reportage approfondito ","fan_voice":"FANVOICE ","featured_topic":null,"fixtures_and_scores":null,"fixtures_scores":"Partite & Risultati","follow_us_on":"Seguici su Snapchat:","latest_videos":"Ultimi video ","league_page":null,"match_day":"Giornata %{num}","month":"%M","more":"Di pi\u00f9 ","most_read":"Trending ","no_matches":"Non ci sono partite oggi ","other_categories":"PI\u00d9 CATEGORIE ","our_categories":"CATEGORIE ","read_now":"LEGGI ORA! ","schedule":"PROGRAMMA ","scores_page_desc":"Tutte le ultime partite e risultati","scores_page_title":"Partite & risultati","social_text":null,"stay_up_to":"Resta aggiornato su tutte le ultime notizie","top_stories":"Le migliori storie ","trending":null,"trending_floor8":null,"video":"Video","videos":"Video","view_all":"Vedi tutte le partite ","view_more":"Vedi di pi\u00f9 ","watch_more_videos":"Guarda pi\u00f9 video ","watch_tv_12up":null,"watch_tv_90min":"GUARDA 90MIN TV ","watch_tv_circasports":"GUARDA CIRCA SPORTS TV ","watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":null,"watch_tv_german_site":null,"watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"Pubblicita'","bet_now":"Scommetti ora","by":"di","by_betway":null,"community_content":"Contenuto Community","community_disclaimer":"Questo articolo e' stato creato da un membro della community di 90min e non e' stato corretto o approvato dal nostro team editoriale.","community_disclaimer_12up":null,"community_disclaimer_90min":"Questo articolo e' stato creato da un membro della community di 90min e non e' stato corretto o approvato dal nostro team editoriale.","community_disclaimer_circasports":"Questo articolo e' stato creato da un membro della community di CircaSports e non e' stato corretto o approvato dal nostro team editoriale.","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":null,"community_disclaimer_ftb90":"Questo articolo e' stato creato da un membro della community di FTB90 e non e' stato corretto o approvato dal nostro team editoriale.","community_disclaimer_german_site":null,"community_disclaimer_ht_media":null,"community_disclaimer_swurley":"Questo articolo e' stato creato da un membro della community di Swurley e non e' stato corretto o approvato dal nostro team editoriale.","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} usa cookies per personalizzare il contenuto e le pubblicit\u00e0, per rendere il nostro sito pi\u00f9 semplice da usare. Condividiamo anche informazioni da terze parti per pubblicit\u00e0 e per questioni analitiche. ","cookies_consent_2":"Pi\u00f9 info","cookies_consent_approve":"Ho capito","notf":{},"now_playing":"ORA IN ONDA:","similar_articles":"Articoli simili"},"private_messages":{"conversation_date":"Ultimi aggiornamenti:","expand":"Espandi","header":"Messaggi privati","message_sent":"Il tuo messaggio \u00e8 stato mandato ","messages":"Messaggi","no_history":"Nessuna storia","not_available":"Conversazione non disponibile","private_message":"Messaggio privato","private_message_to":"Messaggio privato a ","send":"Manda","send_failed":"Invio non riuscito. Per favore prova a riprovare piu' tardi.","sending":"inviando","sent":"Messaggio inviato","side_title":"Conversazioni","title":"Tra te e ","view_history":"Vedi storia conversazione ","write_message_here":"Scrivi qui il tuo messaggio"},"pundit":{"bet_via":"Piazza la scommessa con","draw":"Pareggio","fan_predictions":"Fan pronostico","follow_match":"Segui la partita","follow_pundit":"Segui Pundit","log_in":"Fai login per salvare il tuo pronostico","not_available":"Le statistiche non sono pi\u00f9 disponibile. Prego, riprovare pi\u00f9 tardi. ","place_your_bet":"Piazza la tua scommessa","place_your_bet_via":"Piazza la tua scommessa con","prediction":"Pronostico: ","pundit_prediction":"Pronostico %{pundit_first_name}:","select_match":"Seleziona una partita per il tuo pronostico","select_result":"- Seleziona risultato - ","team_to_win":"%{team} di vittoria","title":"%{team1} - %{team2}: il consiglio per la scommessa di %{pundit_name}","top_predictors":"I MIGLIORI PRONOSTICATORI","what_result":"Pensi di sapere il risultato? ","what_your_prediction":"QUAL \u00c8 IL TUO PRONOSTICO?","your_prediction":"IL TUO PRONOSTICO:"},"reactions":{"campaigns_poweredby":"Sponsorizzato da","v1":{"lol":"Divertito","love":"Mi Piace","must":"Consigliato","noway":"Pazzesco","share":"Condividi","shocked":"Scioccato","tweet":"Tweet"},"v2":{"booh":null,"cool":null,"haha":"Haha","loveit":"Mi Piace","noway":null},"your_reaction":"La tua reazione? "},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"Il mio articolo ha ricevuto 100 visite","about_you":"Chi sei ","account":"Account","all_info_lost":"Tutte le tue informazioni su FTBpro.com saranno permanentemente perdute.","are_you_sure":"Sei sicuro?","by_email":"Email","connected_as":"Connesso come","deactivate":"Disattiva il mio account","deactivate_placeholder":"Per favore facci sapere il motivo:","deactivate_request_sent":"La tua richiesta e' stata inviata con successo. Ti contatteremo a breve.","disp_name":"Mostra nome","fb_hometown":"Citt\u00e0 corrente da Facebook","fb_link":"Facebook link","go_social":"Socializza - fai sapere ai miei amici cosa leggo","go_social_short":"Condividi gli articoli che leggo","google_plus_link":"Link Google+","if_following_me":"Qualcuno ti sta seguendo","if_sending_me_message":"Qualcuno mi ha mandato un messaggio","let_see":"Permetti a tutti di vedere:","my_team":"La mia squadra","name":{"rules":"Deve essere unico. 5-50 caratteri. Usa lettere, numeri e spazi"},"notifications":"Notifiche","optional":"facoltativo","privacy":"Privacy","recent_articles":"Condivisioni di articoli recenti","save":"Salva","settings":"Impostazioni","settings_saved":"Impostazioni salvate","share":"Auto-condivisione","site":"Sito:","site_title":"titolo","site_url":"URL:","stats":"vBet statistiche","submit":"Manda","twitter_link":"Twitter link:","weekly_writers_achievements":"Realizzazioni settimanali degli scrittori","when_notify":"Avvisami quando","your_writing_language":"In quale lingua vuoi scrivere?"},"sign_up":{"about_you":"Scrivi qualcosa riguardo all'amore per la tua squadra (opzionale)","and":"e","change":"Puoi sempre cambiare questa cosa nelle tue impostazioni","disp_name":"Mostra nome","join_12up":null,"join_90min":"Unisciti 90min","join_circasports":"Unisciti CircaSports","join_dbltap":null,"join_ei":null,"join_floor8":null,"join_ftb90":"Unisciti FTB90","join_german_site":null,"join_ht_media":null,"join_swurley":"Unisciti Swurley","lets_start":"Inizia pure!","my_game":null,"my_league":"Lega","of_12up":null,"of_90min":"di 90min.com","of_circasports":"di Swurley.com","of_dbltap":null,"of_ei":null,"of_floor8":null,"of_ftb90":"di FTB90.com","of_german_site":null,"of_ht_media":null,"privacy_policy":"Norme della privacy","required_field":"Campi obbligatori","team":"La mia squadra","terms":"Accetto i ","terms_and_conditions":"Termini e condizioni"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"Articoli","comments":"Commenti","reads":"Letti"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"ULTIME STORIE ","latest_videos":"ULTIMI VIDEO","read_more":"Leggi di pi\u00f9","recommended":"CONSIGLIATI","video":"Video"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"es":{"date":{"abbr_day_names":["dom","lun","mar","mi\u00e9","jue","vie","s\u00e1b"],"abbr_month_names":[null,"ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],"day_names":["domingo","lunes","martes","mi\u00e9rcoles","jueves","viernes","s\u00e1bado"],"formats":{"default":"%d/%m/%Y","long":"%e de %B de %Y","short":"%e de %b","capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],"order":["day","month","year"],"time_since":{"about_an_hour_ago":"Hace una hora","about_two_hours_ago":"Hace unas dos horas","seconds_ago":"hace segundos","x_hours_ago":{"one":"hace 1 hora","other":"hace %{count} horas"},"x_minutes_ago":{"one":"hace 1 minuto","other":"hace %{count} minutos"}}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"debe ser aceptado","blank":"no puede estar en blanco","confirmation":"no coincide con la confirmaci\u00f3n","empty":"no puede estar vac\u00edo","equal_to":"debe ser igual a %{count}","even":"debe ser par","exclusion":"est\u00e1 reservado","greater_than":"debe ser mayor que %{count}","greater_than_or_equal_to":"debe ser mayor que o igual a %{count}","inclusion":"no est\u00e1 incluido en la lista","invalid":"no es v\u00e1lido","less_than":"debe ser menor que %{count}","less_than_or_equal_to":"debe ser menor que o igual a %{count}","not_a_number":"no es un n\u00famero","not_an_integer":"debe ser un entero","odd":"debe ser impar","record_invalid":"La validaci\u00f3n fall\u00f3: %{errors}","taken":"ya est\u00e1 en uso","too_long":"es demasiado largo (%{count} caracteres m\u00e1ximo)","too_short":"es demasiado corto (%{count} caracteres m\u00ednimo)","wrong_length":"no tiene la longitud correcta (%{count} caracteres exactos)"},"template":{"body":"Se encontraron problemas con los siguientes campos:","header":{"one":"No se pudo guardar este/a %{model} porque se encontr\u00f3 1 error","other":"No se pudo guardar este/a %{model} porque se encontraron %{count} errores"}},"200_pixels":"La foto debe tener al menos 200x200 pixels","file_too_big":"El archivo es demasiado pesado","flash":"Debes instalar Adobe Flash para hacer uso de esta opci\u00f3n","invalid_filetype":"Tipo de archivo no v\u00e1lido (utilizar .gif, .jpg, .jpeg o .png)","invalid_url":"URL no v\u00e1lido","mobile_error":"No puedes reproducir este v\u00eddeo en un m\u00f3vil","motto":{"title":"Introduce entre 10 y 25 caract\u00e9res"},"nick":{"duplicate":"Nombre no disponible","length":"El nombre debe tener entre 5 y 50 caracteres","title":"Usa solo letras, d\u00edgitos, puntos y gu\u00edones","validation":"Tu nombre debe tener entre 5-50 caracteres - letras, n\u00fameros y guiones solamente."},"no_file":"No has elegido un archivo","not_found":"No hemos encontrado esta p\u00e1gina","one_team":"Debes asignar al menos un equipo","pic_size":"El tama\u00f1o de la foto debe ser entre %{min} y %{max}","ratio_alert":"La proporci\u00f3n de la foto debe ser entre 1:2 y 2:1","return_homepage":"Vuelve a la p\u00e1gina principal","select_image":"Debes elegir una imagen para subir","sorry":"Disculpas","subject_id":{"require_fanship":"Ser fan es un requerimiento"},"text":{"duplicate_comment":"Duplicar comentario","duplicate_post":"Duplicar articulo","max_char":"Maximo %{num_chars} caracteres","max_words":"M\u00e1ximo %{num_words} palabras","min_char":"M\u00ednimo %{num_chars} caracteres"},"twitter_url":{"invalid":"Twitter URL inv\u00e1lido"},"unknown_upload":"Error de carga desconocido. Por favor cont\u00e1ctanos","unsupported_video":"Lo sentimos, v\u00eddeos de esta fuente no son compatibles","url_err":"Error desconocido (URL mal deletreado?), por favor contacta a un moderador","website":{"blank":"Introduce URL del sitio"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%A, %e de %B de %Y %H:%M:%S %z","long":"%e de %B de %Y %H:%M","short":"%e %b %H:%M","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"Inicias sesi\u00f3n"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Conectar","language":"Idioma","languages":{"de":"Alem\u00e1n","en":"Ingl\u00e9s","es":"Espa\u00f1ol","fr":"Franc\u00e9s","hi":null,"id":"Indonesio","it":"Italiano","pt-BR":"Portugu\u00e9s","th":"Tailand\u00e9s","tr":"Turco","vn":"Vietnamita"},"message":"Mensaje","next":"Siguiente","prev":"Anterior","prompt":{},"right":{},"share":"Compartir","table":"Clasificaci\u00f3n","tweet":"Tweet","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"Sobre el equipo","add_caption":"Agrega un t\u00edtulo a la foto","add_content":"Agrega contenido a tu art\u00edculo de las siguientes fuentes compatibles:","add_image":"Agregar imagen","add_item":"Agregar multimedia","add_media":"Multimedia","add_team":"Agregar equipo","additional_media":"Multimedia adicional","are_you_sure":"\u00bfEst\u00e1s seguro que quieres dejar la p\u00e1gina?","article_preview":"Esta es la vista previa de tu art\u00edculo","attach_image":"Elige una imagen","back":"Atr\u00e1s","back_to_edit":"Volver a editar","back_to_editing":"Volver a editar","bold_tooltip":"Negrita","caption_optional":"(Opcional, m\u00e1ximo 22 caracteres)","char_count":"N\u00famero de caracteres: %{num}","check_grammar":"Por favor revisa errores de ortograf\u00eda y expresi\u00f3n","choose_team":"Elige un equipo","clear":"Borrar","complete_steps":"Antes de publicar debes completar los siguientes pasos:","congrats":"\u00a1Felicidades!","cover_image":"Esta ser\u00e1 la imagen destacada en la web, app y redes sociales","create_article":"Crea tu art\u00edculo","crop_image":"Recortar imagen","crop_ratio":"Proporciones de corte:","crop_too_small":"La imagen es demasiado peque\u00f1a","date":"Fecha","delete":"BORRAR","delete_article":"Eliminar art\u00edculo","discard":"Descartar","discard_confirmation":"\u00bfEst\u00e1s seguro que deseas descartar este art\u00edculo?","draft":"Guardar","drag":"Arrastrar imagen/video aqu\u00ed","drag_all":"Arrastra la imagen, video o contenido social aqu\u00ed","drag_crop":"Arrastra para reposicionar","drop_here":"Soltar aqu\u00ed","drop_image":"Soltar imagen aqu\u00ed","edit_crop":"Mueve el rect\u00e1ngulo para ajustar la imagen","edit_thumb":"Editar miniatura","editor":"Editor","embed":"Insertar","embed_code":"Subir c\u00f3digo","embed_only":"Pegar enlace/c\u00f3digo aqu\u00ed","embed_video":"Insertar v\u00eddeo","enter_desc":"Introduce descripci\u00f3n aqu\u00ed","enter_title":"Introduce el t\u00edtulo aqu\u00ed...","enter_url":"Introduce URL/c\u00f3digo","facebook_cover_image":"Imagen de portada en Facebook","ftbpro_editor":"Editor de FTBpro","grammar_spelling":"T\u00f3mate un tiempo para revisar posibles errores ortogr\u00e1ficos o gramaticales","great":"\u00a1Muy bien!","guide_tips":"Recomendaciones para escribir","guide_tips_links":"http://www.90min.com/blog/consejos-sobre-seo/","h2_tooltip":"Titular ","header_edit":"Editar art\u00edculo","header_new":"Nuevo art\u00edculo","hyperlink_tooltip":"Enlazar","image_bank":"Banco de im\u00e1genes","image_crop":"Recortar","image_format":"El formato de imagen debe ser JPEG, PNG o gif.","image_search":"Buscar","image_size":"Las dimensiones deben ser mayores a 500x280 pixels.","image_size_parameterized":"Las dimensiones deben ser mayores a %{width}x%{height} pixels.","image_video":"Imagen/V\u00eddeo","image_weight":"Este archivo supera el tama\u00f1o m\u00e1ximo de %{fileSizeMaxSupported}","insert_link":"Pegar enlace aqu\u00ed","invalid_code":"El URL/c\u00f3digo es inv\u00e1lido o no compatible. Por favor introduce un URL/c\u00f3digo v\u00e1lido.","leave":"Dejar la p\u00e1gina","leave_warning":"Est\u00e1s saliendo de la p\u00e1gina sin guardar. \u00a1Perder\u00e1s todas las modificaciones!","list_tooltip":"Vi\u00f1etas","max":"(Max. %{num})","max_reached":"(alcanzado el l\u00edmite)","media_longer":"(art\u00edculos con m\u00e1s de 200 palabras)","media_longer_than":"(art\u00edculos con m\u00e1s de 300 palabras)","media_post":"Post multimedia","min":"(Min %{num})","min_words":"(m\u00edn. %{num} palabras)","no_draft":"No hay borradores","num_words":{"one":"1 palabra","other":"%{count} palabras"},"number_list_tooltip":"N\u00fameros","oops":"Casi all\u00ed...","optimal_article":"(Ideal 300-800)","optimal_length":"(Ideal %{min}-%{max})","optional":"(Opcional, m\u00e1ximo 160 caracteres)","optional_field":"(Opcional)","or":"o","p_tooltip":"P\u00e1rrafo","paste_embed":"Copiar link o insertar c\u00f3digo aqu\u00ed","paste_url":"Pegar URL o c\u00f3digo embed","playbuzz":"Pegar aqui el enlace al art\u00edculo que has creado en PlayBuzz.com","polls":"Agrega una encuesta","prev":"Vista previa","preview":"Vista previa","publish":"Publicar","remove_attachment":"\u00bfEst\u00e1s seguro que deseas eliminar?","reset":"Resetear","review":"Vista antes de publicar ","save_changes":"\u00bfGuardar cambios?","save_draft":"GUARDAR COMO BORRADOR","search_bank":"B\u00fasqueda en el Banco de Im\u00e1genes","search_for":"Buscar...","searching":"Buscando","select_photo":"Seleccionar imagen","seo_desc":"Descripci\u00f3n SEO","share":"Compartir este art\u00edculo en Facebook","small_image":"Tu imagen es muy peque\u00f1a, debe tener al menos una resoluci\u00f3n de 300x150","source":"Fuente:","start_at":"Empezar en","stay":"Permanecer en la p\u00e1gina","steps_complete":"Tu art\u00edculo est\u00e1 listo para ser publicado","styling_tooltip":"Borrar formato","tag":"Tags","tag_at_least":"(Elige por lo menos 1)","tag_sug":"Sugerencia de Tags","tag_team":"Etiquetas","teaser":"Entradilla","teaser_watermark":"Solo aparecer\u00e1 como una descripci\u00f3n en los enlaces a tu art\u00edculo.","this_is_preview":"Vista previa de tu art\u00edculo","tip_controversial ":"Genera controversia. Un buen art\u00edculo plantea preguntas interesantes","tip_image":"A\u00f1ade una foto. Los art\u00edculos con im\u00e1genes son m\u00e1s atractivos","tip_media":"V\u00eddeos de YouTube o Metacafe generan grandes reacciones. \u00bfTienes uno bueno?","tip_short":"Escribe p\u00e1rrafos cortos. Los lectores suelen saltear los p\u00e1rrafos largos","tips":{"media_close_ups":"Utiliza primeros planos en art\u00edculos sobre jugadores.","media_image_bank":"Recomendamos utilizar nuestro banco de im\u00e1genes de Getty para encontrar la foto que necesitas. Busca por jugador/equipo.","post_enjoy":"Lo m\u00e1s importante, disfruta de la experiencia!","post_original":"S\u00e9 original. Contenido de otras fuentes no es permitido.","post_paragraphs":"Escribe en p\u00e1rrafos para dividir tu art\u00edculo.","post_review":"Repasa tu art\u00edculo antes de publicarlo. Revisa que hayas utilizado bien la gram\u00e1tica y ortograf\u00eda.","title":"Consejos para aumentar lecturas:","title_debatable":"Deja claro tu punto de vista. Al p\u00fablico le gustan los temas pol\u00e9micos y debatibles. ","title_known_name":"Comienza tu t\u00edtulo con el nombre de un jugador/equipo.","title_popular_terms":"Incluye palabras populares como nombres completos de jugadores, equipos o temas controversiales.","title_question":"Haz una pregunta la cual se responde en tu art\u00edculo.","title_short":"Cuanto m\u00e1s corto, mejor. Entre 5-8 palabras es lo ideal."},"title":"Titular","too_long":"Demasiado largo (Ideal 10-75)","too_short":"Demasiado corto (Ideal 10-75)","toolong":"Demasiado largo (Ideal %{min}-%{max})","tooshort":"Demasiado corto (Ideal %{min}-%{max})","try_again":"Intenta otra vez","upload_failed":"Un error ha ocurrido mientras se sub\u00eda la imagen. Intenta otra vez","upload_image":"Subir foto","upload_img":"Subir imagen","valid_code":"El c\u00f3digo que subiste no es v\u00e1lido.","video":"V\u00eddeo","video_provider":"De momento no trabajamos con este proveedor de v\u00eddeo.","video_services":"Pegar enlace de v\u00eddeo (YouTube, Dailymotion o Metacafe) aqu\u00ed:","video_url":"Video URL (Youtube, Dailymotion, Metacafe)","word_count":"N\u00famero de palabras: %{num}","writing_sug":"Sugerencias SEO","writing_tips":"Claves para escribir mejor","your_post":"Tu texto"},"embed":{"button":"Insertar","dialogue":{"additional_options":"Opciones adicionales","become_a_partner":"CONVI\u00c9RTETE EN PARTNER","comments":"Mostrar comentarios","customise_collapse/expand":"Costumizar c\u00f3digo","disclaimer":"Al insertar este c\u00f3digo est\u00e1s de acuerdo con nuestras %{terms_conditions}","embed_code":"C\u00f3digo","embed_instructions":"A\u00f1ade este post a tu p\u00e1gina web copiando y pegando el c\u00f3digo de abajo","embed_instructions_partners":"Copia y pega tu c\u00f3digo perzonalizado abajo","full_title":"T\u00edtulo completo","header":"INSERTAR POST","info":"La opci\u00f3n de remover el enlace de 90min solo est\u00e1 disponible para partners","link":"Mostrar enlace a 90min","logged_in":"Contacta a %{email} para unirte a nuestro programa de partnerships. ","login":"Inicia sesi\u00f3n","partner_message":"\u00bfYa eres partner?  %{login} para recibir tu c\u00f3digo costumizado.","remove_title":"Remover t\u00edtulo","show-author":"Mostrar autor","show-date":"Mostrar fecha","show-reads-counter":"Mostrar n\u00famero de vistas","show-title":"Mostrar t\u00edtulo","terms_&_conditions":"T\u00e9rminos y Condiciones","title":"T\u00edtulo","views":"Mostrar n\u00famero de vistas"}},"footer":{"about_12up":"Sobre 12up","about_90min":"Sobre 90min","about_circasports":"Sobre CircaSports","about_dbltap":null,"about_ei":null,"about_floor8":"Sobre Floor8","about_ftb90":"Sobre FTB90","about_ftbpro":"Sobre nosotros","about_german_site":null,"about_ht_media":null,"about_pluralist":null,"about_swurley":"Sobre Swurley","about_theduel":null,"affiliates":"Afiliados","apps":"Aplicaciones m\u00f3vil","apps_Android":"Encu\u00e9ntrala en","apps_iphone":"Disponible en la","blog":"Blog","boomerang":null,"cartoon":null,"contact_ftbpro":"Cont\u00e1ctanos","fan_store":"Tienda online","faq":"Preguntas frecuentes","house_rules":"Reglas de la casa","in_the_news":"En la prensa","jobs":"Trabajo","licensing":"Licencias","links":"Enlaces","links_social":"Enlaces","more_about_12up":"M\u00e1s acerca de 12up","more_about_90min":"M\u00e1s acerca de 90min","more_about_circasports":"M\u00e1s acerca de CircaSports","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":"M\u00e1s acerca de Floor8","more_about_ftb90":"M\u00e1s acerca de FTB90","more_about_german_site":null,"more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"M\u00e1s acerca de Swurley","more_about_theduel":null,"partner_sites":null,"partners":"Partners","prev_prog":null,"privacy_policy":"Pol\u00edtica de privacidad","rights_reserved":"Todos los derechos reservados","rights_reserved_year":"2016 FTBpro \u00a9 Todos los derechos reservados","rights_reserved_year_12up":"Minute Media 2019 12up \u00a9 Todos los derechos reservados","rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 Todos los derechos reservados","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports \u00a9 Todos los derechos reservados","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":"Minute Media 2019 Floor8\u00a9 Todos los derechos reservados","rights_reserved_year_ftb90":"2016 FTB90 \u00a9 Todos los derechos reservados","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":"Minute Media 2018 Pluralist\u00a9 Todos los derechos reservados","rights_reserved_year_swurley":"2016 Swurley \u00a9 Todos los derechos reservados","rights_reserved_year_theduel":null,"space":null,"statistics_12up":"Estad\u00edsticas 12up","statistics_90min":"Estad\u00edsticas 90min","statistics_circasports":"Estad\u00edsticas CircaSports","statistics_ei":null,"statistics_floor8":"Estad\u00edsticas Floor8","statistics_ftb90":"Estad\u00edsticas FTB90","statistics_ht_media":null,"statistics_swurley":"Estad\u00edsticas Swurley","statistics_theduel":null,"stats":{"articles":"Art\u00edculos","fans":"Fans","members":"Usuarios","writers":"Escritores"},"support":"Soporte t\u00e9cnico","tbs":null,"tcm":null,"terms":"Condiciones","terms_conditions":"Condiciones de uso","tnt":null,"warner":null,"writers":"Escritores"},"header":{"profile":"Mi perfil","settings":"Configuraci\u00f3n","signout":"Salir"},"home":{"no_matches":"No hay partidos"},"homepage":{"be_the_first":"\u00a1ENT\u00c9RATE PRIMERO QUE NADIE!","by":"Por:","chrome_notifications":"Mantente al tanto con nuestras Notificaciones en Chrome","ei":{"latest_news":null,"trending":"Tendencias","view_more":null},"fan_perspectives":"Cobertura completa","fan_voice":"FAN ZONE","featured_topic":null,"fixtures_and_scores":null,"fixtures_scores":"Calendario Y Resultados","follow_us_on":"S\u00edguenos en Snapchat","latest_videos":"\u00daltimos v\u00eddeos","league_page":null,"match_day":"Jornada %{num}","month":"%M","more":"M\u00e1s","most_read":"Lo + le\u00eddo","no_matches":"No hay partidos este d\u00eda","other_categories":"M\u00c1S CATEGOR\u00cdAS","our_categories":"SECCIONES","read_now":"LEE AHORA","schedule":"CALENDARIO","scores_page_desc":"Todos los \u00faltimos partidos y resultados","scores_page_title":"Calendarios y resultados","social_text":null,"stay_up_to":"Permanece actualizado con las \u00faltimas noticias","top_stories":"Art\u00edculos destacados","trending":null,"trending_floor8":"ENTREVISTAS","video":"V\u00eddeo","videos":"V\u00eddeos","view_all":"Ver todos los partidos","view_more":"Ver m\u00e1s","watch_more_videos":"Ver m\u00e1s v\u00eddeos","watch_tv_12up":"VER 12UP TV","watch_tv_90min":"VER 90MIN TV","watch_tv_circasports":null,"watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":"VER FLOOR8 TV","watch_tv_german_site":null,"watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"Publicidad","bet_now":"Apuesta ahora","by":"Por","by_betway":null,"community_content":"Importante","community_disclaimer":"Este art\u00edculo fue creado por un usuario de la comunidad de 90min y a\u00fan no ha sido editado ni aprobado por el equipo editorial.","community_disclaimer_12up":"Este art\u00edculo fue creado por un usuario de la comunidad de 12up y a\u00fan no ha sido editado ni aprobado por el equipo editorial.","community_disclaimer_90min":"Este art\u00edculo fue creado por un usuario de la comunidad de 90min y a\u00fan no ha sido editado ni aprobado por el equipo editorial.","community_disclaimer_circasports":"Este art\u00edculo fue creado por un usuario de la comunidad de CircaSports y a\u00fan no ha sido editado ni aprobado por el equipo editorial.","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":"Este art\u00edculo fue creado por un usuario de la comunidad de Floor8 y a\u00fan no ha sido editado ni aprobado por el equipo editorial.","community_disclaimer_ftb90":"Este art\u00edculo fue creado por un usuario de la comunidad de FTB90 y a\u00fan no ha sido editado ni aprobado por el equipo editorial.","community_disclaimer_german_site":null,"community_disclaimer_ht_media":null,"community_disclaimer_swurley":"Este art\u00edculo fue creado por un usuario de la comunidad de Swurley y a\u00fan no ha sido editado ni aprobado por el equipo editorial.","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} utiliza 'cookies' para personalizar contenido y ads y hacer nuestra p\u00e1gina m\u00e1s f\u00e1cil de usar. Alg\u00fan tipo de informaci\u00f3n es compartida con terceros para cuestiones de publicidad y an\u00e1lisis de datos.","cookies_consent_2":"M\u00e1s info","cookies_consent_approve":"Entendido","notf":{},"now_playing":"REPRODUCIENDO:","similar_articles":"Art\u00edculos similares"},"private_messages":{"conversation_date":"\u00daltima actualizaci\u00f3n","expand":"Expandir","header":"Mensajes","message_sent":"Tu mensaje ha sido enviado","messages":"Mensajes","no_history":"No hay historial","not_available":"Conversaci\u00f3n no disponible","private_message":"Mensaje privado a","private_message_to":"Mensaje privado a","send":"Enviar","send_failed":"Error al enviar. Intenta otra vez por favor.","sending":"Enviando","sent":"Mensaje enviado","side_title":"Conversaciones","title":"Entre tu y","view_history":"Ver historial de conversaciones","write_message_here":"Escribe tu mensaje aqu\u00ed"},"pundit":{"bet_via":"APUESTA EN","draw":"Empate","fan_predictions":"Pron\u00f3sticos de los fans","follow_match":"Sigue el partido","follow_pundit":"Seguir a experto","log_in":"Iniciar sesi\u00f3n para guardar tu pron\u00f3stico","not_available":"Estad\u00edsticas no disponibles en este momento. Intenta de nuevo m\u00e1s tarde","place_your_bet":"HAZ TU APUESTA","place_your_bet_via":"Haz tu apuesta en","prediction":"Pron\u00f3stico:","pundit_prediction":"El pron\u00f3stico de %{pundit_first_name}:","select_match":"Elige un partido para hacer tu pron\u00f3stico","select_result":"- Elige el resultado -","team_to_win":"%{team} gana","title":"%{team1} vs %{team2}: tips de apuestas de %{pundit_name}","top_predictors":"TOP EXPERTOS","what_result":"\u00bfSabes cu\u00e1l ser\u00e1 el resultado?","what_your_prediction":"\u00bfCu\u00e1l es tu pron\u00f3stico?","your_prediction":"TU PRON\u00d3STICO:"},"reactions":{"campaigns_poweredby":"Ofrecido por","v1":{"lol":"Divertido","love":"Me encanta","must":"Valioso","noway":"Irritante","share":"Compartir","shocked":"Incre\u00edble","tweet":"Tweet"},"v2":{"booh":"\u00a1Buuuh!","cool":"Cool","haha":"Jaja","loveit":"Me encanta","noway":"Indignante"},"your_reaction":"\u00bfTu reacci\u00f3n?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"Mi art\u00edculo recibi\u00f3 100 lecturas","about_you":"Sobre ti","account":"Cuenta","all_info_lost":"Toda tu informaci\u00f3n en FTBpro ser\u00e1 borrada permanentemente. ","are_you_sure":"\u00bfEst\u00e1s seguro?","by_email":"Correo","connected_as":"Conectado como","deactivate":"Desactivar mi cuenta","deactivate_placeholder":"Por favor cu\u00e9ntanos el motivo:","deactivate_request_sent":"Tu solicitud ha sido enviada. Nos pondremos en contacto en breve.","disp_name":"Nombre","fb_hometown":"Ciudad actual en Facebook","fb_link":"Enlace a Facebook","go_social":"Socializa - permite a tus amigos saber qu\u00e9 est\u00e1s leyendo","go_social_short":"Compartir mis art\u00edculos le\u00eddos","google_plus_link":"Enlace Google+","if_following_me":"Alguien ha empezado a seguirme","if_sending_me_message":"Alguien me ha enviado un mensaje","let_see":"Permitir a todos ver mis:","my_team":"Mi Equipo","name":{"rules":"Entre 5 y 50 caracteres. Puedes usar letras, n\u00fameros y guiones"},"notifications":"Notificaciones","optional":"opcional","privacy":"Privacidad","recent_articles":"Art\u00edculos compartidos recientemente","save":"Guardar","settings":"Configuraci\u00f3n","settings_saved":"Configuraci\u00f3n guardada","share":"Auto-compartir","site":"Web","site_title":"T\u00edtulo","site_url":"URL","stats":"Estad\u00edsticas","submit":"Enviar","twitter_link":"Enlace a Twitter","weekly_writers_achievements":"Mi resumen semanal de art\u00edculos","when_notify":"Notif\u00edcame cuando","your_writing_language":"\u00bfEn que idioma vas a escribir?"},"sign_up":{"about_you":"Escribe algo sobre el sentimiento por tu equipo (opcional)","and":"y","change":"Siempre podr\u00e1s cambiar esto en tu pesta\u00f1a de configuraci\u00f3n","disp_name":"Nombre","join_12up":"\u00danete a 12up","join_90min":"\u00danete a 90min","join_circasports":"\u00danete a CircaSports","join_dbltap":null,"join_ei":null,"join_floor8":"\u00danete a Floor8","join_ftb90":"\u00danete a FTB90","join_german_site":null,"join_ht_media":null,"join_swurley":"\u00danete a Swurley","lets_start":"Configura tu perfil...","my_game":null,"my_league":"Liga","of_12up":"de 12up.com","of_90min":"de 90min.com","of_circasports":"de Swurley.com","of_dbltap":null,"of_ei":null,"of_floor8":"de Floor8.com","of_ftb90":"de FTB90.com","of_german_site":null,"of_ht_media":null,"privacy_policy":"Privacidad","required_field":"Campo requerido","team":"Mi Equipo","terms":"Estoy de acuerdo con los ","terms_and_conditions":"T\u00e9rminos y condiciones"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"Art\u00edculos","comments":"Comentarios","reads":"Lecturas"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"\u00daLTIMAS NOTICIAS","latest_videos":"\u00daLTIMOS V\u00cdDEOS","read_more":"Leer m\u00e1s","recommended":"RECOMENDADO","video":"V\u00eddeo"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"fr":{"date":{"abbr_day_names":["dim","lun","mar","mer","jeu","ven","sam"],"abbr_month_names":[null,"jan.","f\u00e9v.","mar.","avr.","mai","juin","juil.","ao\u00fbt","sept.","oct.","nov.","d\u00e9c."],"day_names":["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],"formats":{"default":"%d/%m/%Y","short":"%e %b","long":"%e %B %Y","capitalized_short_day_and_hour":"%A %H: %M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"janvier","f\u00e9vrier","mars","avril","mai","juin","juillet","ao\u00fbt","septembre","octobre","novembre","d\u00e9cembre"],"order":["jour","mois","ann\u00e9e"],"time_since":{"about_an_hour_ago":"Il y a une heure","about_two_hours_ago":"Il y a deux heures","seconds_ago":"Il y a quelques secondes","x_hours_ago":{"one":"Il y a 1 heure","other":"Il y a %{count} heures"},"x_minutes_ago":{"one":"Il y a une minute","other":"Il y a %{count} minutes"}}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"doit \u00eatre accept\u00e9(e)","blank":"doit \u00eatre rempli(e)","confirmation":"ne concorde pas avec la confirmation","empty":"doit \u00eatre rempli(e)","equal_to":"doit \u00eatre \u00e9gal \u00e0 %{count}","even":"doit \u00eatre pair","exclusion":"n'est pas disponible","greater_than":"doit \u00eatre sup\u00e9rieur \u00e0 %{count}","greater_than_or_equal_to":"doit \u00eatre sup\u00e9rieur ou \u00e9gal \u00e0 %{count}","inclusion":"n'est pas inclus(e) dans la liste","invalid":"n'est pas valide","less_than":"doit \u00eatre inf\u00e9rieur \u00e0 %{count}","less_than_or_equal_to":"doit \u00eatre inf\u00e9rieur ou \u00e9gal \u00e0 %{count}","not_a_number":"n'est pas un nombre","not_an_integer":"doit \u00eatre un nombre entier","odd":"doit \u00eatre impair","record_invalid":"La validation a \u00e9chou\u00e9 : %{errors}","taken":"n'est pas disponible","too_long":{"one":"est trop long (pas plus d'un caract\u00e8re)","other":"est trop long (pas plus de %{count} caract\u00e8res)"},"too_short":{"one":"est trop court (au moins un caract\u00e8re)","other":"est trop court (au moins %{count} caract\u00e8res)"},"wrong_length":{"one":"ne fait pas la bonne longueur (doit comporter un seul caract\u00e8re)","other":"ne fait pas la bonne longueur (doit comporter %{count} caract\u00e8res)"}},"template":{"body":"Veuillez v\u00e9rifier les champs suivants : ","header":{"one":"Impossible d'enregistrer ce(tte) %{model} : %{count} erreur","other":"Impossible d'enregistrer ce(tte) %{model} : %{count} erreurs"}},"200_pixels":"La photo doit \u00eatre au moins de 200x200 pixels","file_too_big":"Le fichier transf\u00e9r\u00e9 est trop gros","flash":"Vous devez installer Adobe Flash pour utiliser cette fonction","invalid_filetype":"Type de fichier invalide (prise en charge de .gif, .jpg, .jpeg et .png)","invalid_url":"URL invalide","mobile_error":"Cette vid\u00e9o ne peut pas \u00eatre lanc\u00e9e sur un appareil mobile","motto":{"title":"Veuillez entrer entre 10 et 25 caract\u00e8res "},"nick":{"duplicate":"Pseudo d\u00e9j\u00e0 utilis\u00e9","length":"Le pseudo doit \u00eatre contenir entre 5 et 50 caract\u00e8res ","title":"Utilisez uniquement des lettres, des chiffres, des points et des tirets","validation":"\nVotre surnom doit comprendre entre 5 et 50 caract\u00e8res - Il ne doit \u00eatre compos\u00e9 que de lettres, de chiffres, de points ou de tirets."},"no_file":"Pas de fichier choisi ","not_found":"Nous n'avons pas pu trouver cette page","one_team":"Vous devez choisir au moins une \u00e9quipe","pic_size":"La taille de la photo doit \u00eatre comprise entre %{min} et %{max}","ratio_alert":"Les proportions de la photo doivent \u00eatre compris entre 1:2 et 2:1","return_homepage":"Retour \u00e0 la page d\u2019accueil ","select_image":"Vous devez s\u00e9lectionner une image \u00e0 transf\u00e9rer ","sorry":"Excusez-nous","subject_id":{"require_fanship":"\u00catre supporter est une obligation!"},"text":{"duplicate_comment":"Dupliquer le commentaire","duplicate_post":"Dupliquer la publication","max_char":"Maximum %{num_chars} caract\u00e8res ","max_words":"Maximum %{num_words} mots","min_char":"Minimum %{num_chars} caract\u00e8res"},"twitter_url":{"invalid":"URL Twitter invalide"},"unknown_upload":"Erreur de transfert inconnue, s'il vous plait contactez-nous","unsupported_video":"D\u00e9sol\u00e9, nous ne prenons pas en charge ce type de vid\u00e9os ","url_err":"Erreur inconnue (URL incompl\u00e8te), s'il vous plait contactez le mod\u00e9rateur","website":{"blank":"Veuillez entrer l\u2019adresse du site"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%d %B %Y %H:%M:%S","long":"%A %d %B %Y %H:%M","short":"%d %b %H:%M","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"Connectez vous"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Connecter","language":"Langue","languages":{"de":"Allemand","en":"Anglais","es":"Espagnol ","fr":"Francais","hi":null,"id":"Indon\u00e9sien","it":"Italien","pt-BR":"Portugais","th":"Tha\u00eflandais ","tr":"Turc","vn":"Vietnamien"},"message":"Message","next":"Suivant","prev":"Pr\u00e9c\u00e9dent ","prompt":{},"right":{},"share":"Partager","table":"Classement","tweet":"Tweeter","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"\u00c0 propos de L'\u00e9quipe","add_caption":"Ajouter un sous-titre","add_content":"Vous pouvez ajouter du contenu \u00e0 votre article de ces sources suivantes:","add_image":"Ajouter une image","add_item":"Ajouter un m\u00e9dia","add_media":"Ajouter du Contenu","add_team":"Ajouter une \u00e9quipe ","additional_media":"Contenu Additionnel ","are_you_sure":"\u00cates-vous s\u00fbr de vouloir quitter cette page?","article_preview":"Aper\u00e7u de l'article","attach_image":"Choisissez une Photo","back":"Retour","back_to_edit":"Revenir \u00e0 Modifier","back_to_editing":"Revenir \u00e0 Modification","bold_tooltip":"Gras","caption_optional":"(Optionnel, Maximum de 22 caract\u00e8res) ","char_count":"Caract\u00e8res: %{num}","check_grammar":"Relisez le texte et corrigez les fautes d'orthographes ","choose_team":"Choisir une \u00e9quipe","clear":"Supprimer","complete_steps":"Avant de publier vous avez besoin de compl\u00e9ter ces \u00e9tapes","congrats":"F\u00e9licitations! ","cover_image":"Celle-ci appara\u00eetra sur le site, sur l'application ou sur les r\u00e9seaux sociaux","create_article":"Cr\u00e9er un article","crop_image":"Modifier la taille de l'image","crop_ratio":"Dimensions de l'image:","crop_too_small":"L'image est trop petite","date":"Date:","delete":"Supprimer","delete_article":"Supprimer cet article","discard":"Abandonner ","discard_confirmation":"\u00cates-vous s\u00fbr de vouloir abandonner cette publication? ","draft":"Sauvegarder","drag":"D\u00e9placez image/vid\u00e9o ici","drag_all":"Inclure image, vid\u00e9o ou un autre contenu ici","drag_crop":"Faites glisser pour repositionner","drop_here":"D\u00e9posez ici","drop_image":"Int\u00e9grer l'image ici","edit_crop":"D\u00e9placez / redimensionnez le rectangle pour ajuster la miniature","edit_thumb":"Modifier la miniature","editor":"Editeur","embed":"Int\u00e9grer ","embed_code":"Embed code","embed_only":"Int\u00e9grer le code ici","embed_video":"Int\u00e9grer la vid\u00e9o","enter_desc":"Ajouter une description...","enter_title":"Ajoutez le titre ici...","enter_url":"Ins\u00e9rez URL/code","facebook_cover_image":"Image de couverture Facebook","ftbpro_editor":"Editeur de FTBpro","grammar_spelling":"Prenez le temps de v\u00e9rifier la grammaire et l'orthographe","great":"Parfait!","guide_tips":"Lire nos lignes directrices et conseils d'\u00e9criture","guide_tips_links":"http://www.90min.com/blog/lignes-directrices-et-conseils/","h2_tooltip":"Titre","header_edit":"Modifier la publication","header_new":"Nouvelle publication","hyperlink_tooltip":"Lien","image_bank":"Banque d'images","image_crop":"Couper","image_format":"Le format de l'image se limite \u00e0 JPEG, PNG et gif.","image_search":"Chercher","image_size":"Les dimensions doivent \u00eatre plus grandes que 500X280 pixels.","image_size_parameterized":"Les dimensions doivent \u00eatre plus grandes que %{width}x%{height} pixels.","image_video":"Image/Vid\u00e9o","image_weight":"Ce fichier d\u00e9passe le maximum de %{fileSizeMaxSupported}","insert_link":"Ins\u00e9rez un lien ici","invalid_code":"URL/code n'est pas valide. Ins\u00e9rez un URL/code valide.","leave":"Quitter cette page","leave_warning":"Vous \u00eates entrain d'essayer de quitter cette page sans sauvegarder. Toutes les modifications seront perdues","list_tooltip":"Al\u00e9atoire","max":"(Max%{num})","max_reached":"(maximum est atteint)","media_longer":"(pour les articles plus long que 200 mots)","media_longer_than":"(pour les articles plus long que 300 mots)","media_post":"M\u00e9dias publi\u00e9s","min":"(Min %{num})","min_words":"(au moins %{num} mots)","no_draft":"Aucun brouillon sauvegard\u00e9","num_words":{"one":"1 mot","other":"%{count} mots"},"number_list_tooltip":"Dans l'ordre","oops":"On y est presque...","optimal_article":"(optimum 300-800)","optimal_length":"(optimum %{min}-%{max})","optional":"(Facultatif, Max 160 caract\u00e8res) ","optional_field":"Case non obligatoire","or":"Ou","p_tooltip":"Paragraphe","paste_embed":"Ins\u00e9rez un code ou un lien ici","paste_url":"Ins\u00e9rez URL ou code embed","playbuzz":"Ins\u00e9rer ici le lien complet de l'article cr\u00e9\u00e9 sur PlayBuzz.com","polls":"Ajouter un sondage","prev":"Aper\u00e7u","preview":"Enregistrer & Aper\u00e7u","publish":"Publier","remove_attachment":"Etes-vous s\u00fbr de vouloir supprimer ce fichier?","reset":"Effacer","review":"Aper\u00e7u avant la publication","save_changes":"Sauvegarder les changements?","save_draft":"SAUVEGUARDER BROUILLON","search_bank":"Recherchez dans la banque d'images","search_for":"Cherchez","searching":"Chargement...","select_photo":"S\u00e9lectionner une photo","seo_desc":"Description SEO","share":"Partager cette publication sur Facebook","small_image":"Votre photo est trop petite, elle doit \u00eatre au moins de 300x150","source":"Source:","start_at":"D\u00e9bute \u00e0 ","stay":"Rester sur cette page","steps_complete":"Votre articles est maintenant pr\u00eat \u00e0 \u00eatre publi\u00e9","styling_tooltip":"Supprimer l'effet","tag":"Tags","tag_at_least":"(Choisissez en au moins 1)","tag_sug":" Tags sugg\u00e9r\u00e9s","tag_team":"Tags","teaser":"Extrait","teaser_watermark":"Cella apparaitra seulement comme une description de liens vers votre article.","this_is_preview":"Ceci est un aper\u00e7u de votre article","tip_controversial ":"Soyez controvers\u00e9. Une bonne publication soul\u00e8ve des questions difficiles.","tip_image":"Ajouter une photo. Les publications avec des images attirent plus de lecteurs.","tip_media":"Vous avez une bonne vid\u00e9o? Les vid\u00e9os de YouTube ou Metacafe permettent d'obtenir beaucoup de r\u00e9actions.","tip_short":"Faites de courts paragraphes. Les lecteurs ont tendance \u00e0 ne pas lire quand c'est trop long.","tips":{"media_close_ups":"Utilisez des images en gros plans dans les articles concernant les joueurs","media_image_bank":"Nous vous recommandons d'utiliser notre banque d'images Getty pour trouver une photo dont vous avez besoin. Recherchez par joueur ou \u00e9quipe","post_enjoy":"Surtout, amusez-vous!","post_original":"Soyez original. Le contenu copi\u00e9 \u00e0 partir d'autres sources ne sera pas autoris\u00e9.","post_paragraphs":"Utilisez des paragraphes pour a\u00e9rer votre article.","post_review":"Passez en revue votre article avant de le publier. V\u00e9rifier la grammaire et l'orthographe.","title":"Conseils pour accro\u00eetre votre popularit\u00e9:","title_debatable":"D\u00e9fendez votre opinion. Les gens sont attir\u00e9s par les d\u00e9bats","title_known_name":"Commencez votre titre avec le nom d'un joueur ou d'une \u00e9quipe.","title_popular_terms":"Ins\u00e9rez des mots populaires comme le nom complet des joueurs, des \u00e9quipes ou des sujets d'actualit\u00e9.","title_question":"Posez une question \u00e0 laquelle vous allez r\u00e9pondre dans l'article","title_short":"Faites court. 5 \u00e0 8 mots serait l'id\u00e9al"},"title":"Titre","too_long":"Trop long (optimum 10-75)","too_short":"Trop court (optimum 10-75)","toolong":"Trop long (optimum %{min}-%{max})","tooshort":"Trop court (optimum %{min}-%{max})","try_again":"Essayez encore","upload_failed":"Une erreur est apparue pendant la publication de l'image. Veuillez r\u00e9essayer.","upload_image":"Transf\u00e9rer une photo","upload_img":"T\u00e9l\u00e9chargez image","valid_code":"L'embed code n'est pas valide","video":"Vid\u00e9o","video_provider":"Nous ne supportons pas ce type de vid\u00e9o","video_services":"Coller la vid\u00e9o de YouTube, Dailymotion ou Metacafe ici:","video_url":"URL de la vid\u00e9o (Youtube, Dailymotion, Metacafe, etc.)","word_count":"Mots %{num}","writing_sug":"Suggestions SEO","writing_tips":"Conseils pour \u00e9crire mieux","your_post":"Votre publication"},"embed":{"button":"Int\u00e9grer","dialogue":{"additional_options":"Options suppl\u00e9mentaires","become_a_partner":"DEVENIR PARTENAIRE","comments":"Afficher les commentaires","customise_collapse/expand":"Customisez le code","disclaimer":"En int\u00e9grant ce code, vous acceptez nos %{terms_conditions}","embed_code":"Code d'int\u00e9gration","embed_instructions":"Ajoutez cette publication \u00e0 votre site web en copiant collant le code HTML ci-dessous","embed_instructions_partners":"Copier et coller votre code personnalis\u00e9 ci-dessous","full_title":"Titre complet","header":"INT\u00c9GRER LA PUBLICATION","info":"La suppression du lien de 90min n'est disponible que pour les partenaires","link":"Voir le lien pour 90min","logged_in":"Contactez %{email} pour rejoindre l'un de nos programmes de partenariat.","login":"Connectez-vous","partner_message":"D\u00e9j\u00e0 partenaire? %{login} pour recevoir votre code personnalis\u00e9.","remove_title":"Supprimer le titre","show-author":"Afficher le r\u00e9dacteur","show-date":"Afficher la date","show-reads-counter":"Montrer le nombre de vues","show-title":"Afficher le titre","terms_&_conditions":"Conditions g\u00e9n\u00e9rales","title":"Titre","views":"Montrer le nombre de vues"}},"footer":{"about_12up":null,"about_90min":"\u00c0 propos de 90min","about_circasports":"\u00c0 propos de CircaSports","about_dbltap":null,"about_ei":null,"about_floor8":null,"about_ftb90":"\u00c0 propos de FTB90","about_ftbpro":"\u00c0 propos","about_german_site":null,"about_ht_media":null,"about_pluralist":null,"about_swurley":"\u00c0 propos de Swurley","about_theduel":null,"affiliates":"Affili\u00e9s","apps":"Applications Mobiles","apps_Android":"T\u00e9l\u00e9chargez-le sur","apps_iphone":"Disponible sur","blog":"Blog","boomerang":null,"cartoon":null,"contact_ftbpro":"Contactez-nous","fan_store":"Boutique fan","faq":"FAQ","house_rules":"R\u00e8gles","in_the_news":"Actualit\u00e9","jobs":"Jobs","licensing":"Licence","links":"Liens","links_social":"Liens","more_about_12up":null,"more_about_90min":"En savoir plus sur 90min","more_about_circasports":"En savoir plus sur CircaSports","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":null,"more_about_ftb90":"En savoir plus sur FTB90","more_about_german_site":null,"more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"En savoir plus sur Swurley","more_about_theduel":null,"partner_sites":null,"partners":"Partenaires","prev_prog":null,"privacy_policy":"Confidentialit\u00e9","rights_reserved":"Tous droits r\u00e9serv\u00e9s","rights_reserved_year":"2016 FTBpro \u00a9 Tous droits r\u00e9serv\u00e9s","rights_reserved_year_12up":null,"rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 Tous droits r\u00e9serv\u00e9s","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports \u00a9 Tous droits r\u00e9serv\u00e9","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"2016 FTB90 \u00a9 Tous droits r\u00e9serv\u00e9","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"2016 Swurley \u00a9 Tous droits r\u00e9serv\u00e9","rights_reserved_year_theduel":null,"space":null,"statistics_12up":null,"statistics_90min":"Statistiques 90min","statistics_circasports":"Statistiques CircaSports","statistics_ei":null,"statistics_floor8":null,"statistics_ftb90":"Statistiques FTB90","statistics_ht_media":null,"statistics_swurley":"Statistiques Swurley","statistics_theduel":null,"stats":{"articles":"Articles","fans":"Fans","members":"Membres","writers":"R\u00e9dacteurs"},"support":"Support","tbs":null,"tcm":null,"terms":"Termes","terms_conditions":"Termes & Conditions","tnt":null,"warner":null,"writers":"R\u00e9dacteurs"},"header":{"profile":"Mon profil","settings":"Param\u00e8tres ","signout":"Se d\u00e9connecter "},"home":{"no_matches":"Aucun autre match"},"homepage":{"be_the_first":"SOYEZ LE PREMIER \u00c0 SAVOIR !","by":"De :","chrome_notifications":"Restez \u00e0 jour avec les notifications Chrome","ei":{"latest_news":null,"trending":null,"view_more":null},"fan_perspectives":"Toute l'actualit\u00e9 au complet","fan_voice":"La voix des fans","featured_topic":null,"fixtures_and_scores":"Calendrier et Scores","fixtures_scores":"Calendrier & Resultats","follow_us_on":"Suivez-nous sur Snapchat","latest_videos":"Les derni\u00e8res vid\u00e9os","league_page":"Premier League","match_day":"Journ\u00e9e %{num}","month":"%M","more":"Plus","most_read":"Les + lus","no_matches":"Il n'y a pas de matchs ce jour l\u00e0","other_categories":"PLUS DE CATEGORIES","our_categories":"CAT\u00c9GORIES ","read_now":"Lisez maintenant !","schedule":"CALENDRIER","scores_page_desc":"Tous les derniers matches et r\u00e9sultats","scores_page_title":"Matches & r\u00e9sultats","social_text":null,"stay_up_to":"Restez connect\u00e9 avec toutes les derni\u00e8res news","top_stories":"Le meilleur de l'actu","trending":null,"trending_floor8":null,"video":"Vid\u00e9o","videos":"Vid\u00e9os","view_all":"Tous les matchs","view_more":"Plus d'articles","watch_more_videos":"D\u00e9couvrez plus de vid\u00e9os","watch_tv_12up":null,"watch_tv_90min":"90MIN TV","watch_tv_circasports":null,"watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":null,"watch_tv_german_site":null,"watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"Publicit\u00e9","bet_now":"Pariez maintenant","by":"Par","by_betway":null,"community_content":"ATTENTION","community_disclaimer":"Cet article a \u00e9t\u00e9 cr\u00e9\u00e9 par un membre de la communaut\u00e9 de 90min et n'a pas \u00e9t\u00e9 \u00e9dit\u00e9 ou approuv\u00e9 par un membre de notre \u00e9quipe \u00e9ditoriale","community_disclaimer_12up":null,"community_disclaimer_90min":"Cet article a \u00e9t\u00e9 cr\u00e9\u00e9 par un membre de la communaut\u00e9 de 90min et n'a pas \u00e9t\u00e9 \u00e9dit\u00e9 ou approuv\u00e9 par un membre de notre \u00e9quipe \u00e9ditoriale","community_disclaimer_circasports":"Cet article a \u00e9t\u00e9 cr\u00e9\u00e9 par un membre de la communaut\u00e9 de CircaSports et n'a pas \u00e9t\u00e9 \u00e9dit\u00e9 ou approuv\u00e9 par un membre de notre \u00e9quipe \u00e9ditoriale","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":null,"community_disclaimer_ftb90":"Cet article a \u00e9t\u00e9 cr\u00e9\u00e9 par un membre de la communaut\u00e9 de FTB90 et n'a pas \u00e9t\u00e9 \u00e9dit\u00e9 ou approuv\u00e9 par un membre de notre \u00e9quipe \u00e9ditoriale","community_disclaimer_german_site":null,"community_disclaimer_ht_media":null,"community_disclaimer_swurley":"Cet article a \u00e9t\u00e9 cr\u00e9\u00e9 par un membre de la communaut\u00e9 de Swurley et n'a pas \u00e9t\u00e9 \u00e9dit\u00e9 ou approuv\u00e9 par un membre de notre \u00e9quipe \u00e9ditoriale","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} utilise des cookies pour personnaliser le contenu et les publicit\u00e9s et pour rendre notre site plus facile d'utilisation. Nous partageons \u00e9galement certaines informations avec des tiers pour des questions publicitaires et analytiques.","cookies_consent_2":"Plus d'informations","cookies_consent_approve":"J'ai compris","notf":{},"now_playing":"Lecture en cours: ","similar_articles":"Plus de news"},"private_messages":{"conversation_date":"Derni\u00e8re mise \u00e0 jour:","expand":"D\u00e9velopper","header":"Boite de r\u00e9ception ","message_sent":"V\u00f4tre message a bien \u00e9t\u00e9 envoy\u00e9","messages":"Messages","no_history":"Pas d'historique ","not_available":"La conversation n'est pas disponible","private_message":"Message priv\u00e9","private_message_to":"Message priv\u00e9 \u00e0 ","send":"Envoyer","send_failed":"L'envoi a \u00e9chou\u00e9. D\u00e9sol\u00e9, veuillez r\u00e9essayer plus tard.","sending":"envoi en cours","sent":"Message envoy\u00e9","side_title":"Conversations","title":"Entre toi et","view_history":"Voir l'historique des conversations","write_message_here":"Ecrivez votre message ici"},"pundit":{"bet_via":"PLACER PARI VIA","draw":"Nul","fan_predictions":"Pronostics des fans","follow_match":"Suivre le match","follow_pundit":"Suivre l'expert ","log_in":"Connectez-vous pour sauvegarder le pronostic","not_available":"Statistiques temporairement indisponibles. Re-essayez plus tard.","place_your_bet":"PLACER UN PARI","place_your_bet_via":"Placer un pari via","prediction":"Pronostics:","pundit_prediction":"Le pronostic de %{pundit_first_name}","select_match":"Choisir un match pour votre pronostic","select_result":"- Choisir le r\u00e9sultat - ","team_to_win":"%{team} va gagner","title":"%{team1} vs %{team2}: Conseils de paris de %{pundit_name}","top_predictors":"MEILLEURS EXPERTS","what_result":"Vous pensez conna\u00eetre le r\u00e9sultat?","what_your_prediction":"QUEL EST VOTRE PRONOSTIC?","your_prediction":"VOTRE PRONOSTIC:"},"reactions":{"campaigns_poweredby":"Pr\u00e9sent\u00e9 par","v1":{"lol":"LOL","love":"J'adore","must":"\u00c0 Lire","noway":"M\u00e9fiant","share":"Partager","shocked":"Choqu\u00e9 ","tweet":"Tweet"},"v2":{"booh":null,"cool":null,"haha":"Haha","loveit":null,"noway":null},"your_reaction":"Votre r\u00e9action"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"Mon article a \u00e9t\u00e9 lu plus de 100 fois","about_you":"\u00c0 propos de Vous","account":"Compte","all_info_lost":"Toutes vos informations sur FTBpro.com seront d\u00e9finitivement perdues","are_you_sure":"\u00cates-vous s\u00fbr?","by_email":"E-mail","connected_as":"Connect\u00e9 en tant que","deactivate":"D\u00e9sactiver mon compte","deactivate_placeholder":"S'il vous plait faites-nous savoir pourquoi:","deactivate_request_sent":"Votre demande a \u00e9t\u00e9 soumise avec succ\u00e8s. Nous serons en contact bient\u00f4t.","disp_name":"Nom d'Affichage","fb_hometown":"Ville Actuelle de Facebook","fb_link":"Lien Facebook","go_social":"Faisons partager - informer mes amis de mes activit\u00e9s de lecteur","go_social_short":"Partager mes","google_plus_link":"Lien Google+","if_following_me":"Quelqu'un commence \u00e0 me suivre","if_sending_me_message":"Quelqu'un m'envoie un message","let_see":"Regardez mon:","my_team":"Mon \u00c9quipe","name":{"rules":"Doit \u00eatre unique. 5 \u00e0 50 caract\u00e8res."},"notifications":"Notifications","optional":"optionnel","privacy":"Priv\u00e9e","recent_articles":"Articles r\u00e9cents","save":"Sauvegarder","settings":"Param\u00e8tres  ","settings_saved":"Param\u00e8tres sauvegard\u00e9s ","share":"Partager automatiquement","site":"Site","site_title":"Titre:","site_url":"URL:","stats":"Statistiques vParis","submit":"Envoyer","twitter_link":"Lien Twitter:","weekly_writers_achievements":"Le r\u00e9sum\u00e9 hebdomadaire de mon activit\u00e9 de r\u00e9dacteur","when_notify":"Informer moi quand","your_writing_language":"Quelle langue choisissez-vous?"},"sign_up":{"about_you":"\u00c9crivez quelque chose \u00e0 propos de l'amour pour votre \u00e9quipe","and":"et","change":"Vous pouvez modifier cela dans votre menu param\u00e8tres","disp_name":"Nom affich\u00e9 ","join_12up":null,"join_90min":"Joindre 90min","join_circasports":"Joindre CircaSports","join_dbltap":null,"join_ei":null,"join_floor8":null,"join_ftb90":"Joindre FTB90","join_german_site":null,"join_ht_media":null,"join_swurley":"Joindre Swurley","lets_start":"Commen\u00e7ons...","my_game":null,"my_league":"Ligue","of_12up":null,"of_90min":"de 90min","of_circasports":"de Swurley.com","of_dbltap":null,"of_ei":null,"of_floor8":null,"of_ftb90":"de FTB90.com","of_german_site":null,"of_ht_media":null,"privacy_policy":"Confidentialit\u00e9","required_field":"Case n\u00e9c\u00e9ssaire","team":"Mon \u00e9quipe","terms":"J'accepte les","terms_and_conditions":"Termes et Conditions"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"Articles","comments":"Commentaires","reads":"Lus"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"DERNI\u00c8RES INFOS","latest_videos":"LES DERNI\u00c8RES VID\u00c9OS","read_more":"Lire plus","recommended":"RECOMMAND\u00c9","video":"Vid\u00e9o"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"tr":{"date":{"abbr_day_names":["Paz","Pzt","Sal","\u00c7r\u015f","Pr\u015f","Cum","Cts"],"abbr_month_names":[null,"Oca","\u015eub","Mar","Nis","May","Haz","Tem","A\u011fu","Eyl","Eki","Kas","Ara"],"day_names":["Pazar","Pazartesi","Sal\u0131","\u00c7ar\u015famba","Per\u015fembe","Cuma","Cumartesi"],"formats":{"default":"%d.%m.%Y","long":"%e %B %Y, %A","short":"%e %b","capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %B %Y, %A","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"Ocak","\u015eubat","Mart","Nisan","May\u0131s","Haziran","Temmuz","A\u011fustos","Eyl\u00fcl","Ekim","Kas\u0131m","Aral\u0131k"],"order":["gun","ay","yil"],"time_since":{"about_an_hour_ago":"1 saat kadar \u00f6nce","about_two_hours_ago":"2 saat kadar \u00f6nce","seconds_ago":"Saniye \u00d6nce","x_hours_ago":"%{count} saat \u00f6nce","x_minutes_ago":"%{count} dakika \u00f6nce"}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"kabul edilmeli","blank":"doldurulmal\u0131","confirmation":"teyidiyle uyu\u015fmamakta","empty":"doldurulmal\u0131","equal_to":"tam olarak %{count} olmal\u0131","even":"\u00e7ift olmal\u0131","exclusion":"kullan\u0131lamaz","greater_than":"%{count} say\u0131s\u0131ndan b\u00fcy\u00fck olmal\u0131","greater_than_or_equal_to":"%{count} say\u0131s\u0131na e\u015fit veya b\u00fcy\u00fck olmal\u0131","inclusion":"kabul edilen bir kelime de\u011fil","invalid":"ge\u00e7ersiz","less_than":"%{count} say\u0131s\u0131ndan k\u00fc\u00e7\u00fck olmal\u0131","less_than_or_equal_to":"%{count} say\u0131s\u0131na e\u015fit veya k\u00fc\u00e7\u00fck olmal\u0131","not_a_number":"ge\u00e7erli bir say\u0131 de\u011fil","not_an_integer":"tam say\u0131 olmal\u0131","odd":"tek say\u0131 olmal\u0131","record_invalid":"Do\u011frulama ba\u015far\u0131s\u0131z oldu: %{errors}","taken":"hali haz\u0131rda kullan\u0131lmakta","too_long":"\u00e7ok uzun (en fazla %{count} karakter)","too_short":"\u00e7ok k\u0131sa (en az %{count} karakter)","wrong_length":"yanl\u0131\u015f uzunlukta (tam olarak %{count} karakter olmal\u0131)"},"template":{"body":"L\u00fctfen a\u015fa\u011f\u0131daki hatalar\u0131 d\u00fczeltiniz:","header":{"one":"%{model} giri\u015fi kaydedilemedi: %{count} hata.","other":"%{model} giri\u015fi kadedilemedi: %{count} hata."}},"200_pixels":"Foto\u011fraf en az 200x200 pixel olmal\u0131","file_too_big":"Y\u00fcklenen dosya \u00e7ok b\u00fcy\u00fck","flash":"Bu \u00f6zelli\u011fi kullanabilmeniz i\u00e7in Adobe Flash y\u00fcklemeniz gerekir.","invalid_filetype":"Ge\u00e7ersiz dosya t\u00fcr\u00fc (desteklediklerimiz .gif, .jpg, .jpeg ve .png)","invalid_url":"Ge\u00e7ersiz URL","mobile_error":"Bu video mobil ayg\u0131tlarda izlenemez.","motto":{"title":"L\u00fctfen 10-25 harf girin"},"nick":{"duplicate":"Kullan\u0131c\u0131 ad\u0131 zaten var","length":"Kullan\u0131c\u0131 ad\u0131 5-50 harf aras\u0131nda olmal\u0131.","title":"Sadece harfler, rakamlar ve simgeler kullan","validation":"\u0130sminiz 5-50 harf aras\u0131nda olmal\u0131 - sadece harfler, numaralar ve noktalamalar."},"no_file":"Dosya se\u00e7ilmedi","not_found":"Arad\u0131\u011f\u0131n\u0131z sayfay\u0131 bulamad\u0131k","one_team":"En az 1 tak\u0131m se\u00e7ilmeli","pic_size":"Foto\u011fraf \u00f6l\u00e7\u00fcleri %{min} ile %{max} aras\u0131nda olmal\u0131","ratio_alert":"Foto\u011fraf oran\u0131 1:2 ile 2:1 aras\u0131nda olmal\u0131","return_homepage":"Anasayfaya d\u00f6n","select_image":"Y\u00fckleme i\u00e7in foto\u011fraf se\u00e7in","sorry":"\u00dcZG\u00dcN\u00dcZ","subject_id":{"require_fanship":"Taraftarl\u0131k zorunludur!"},"text":{"duplicate_comment":"Benzer yaz\u0131","duplicate_post":"Benzer payla\u015f\u0131m","max_char":"En fazla %{num_chars} harf","max_words":"En fazla %{num_words} kelime","min_char":"En az %{num_chars} harf"},"twitter_url":{"invalid":"Ge\u00e7ersiz Twitter URL'i"},"unknown_upload":"Bilinmeyen y\u00fckleme hatas\u0131, l\u00fctfen bizimle ileti\u015fime ge\u00e7in","unsupported_video":"\u00dczg\u00fcn\u00fcz, bu sitede video y\u00fcklemesini desteklemiyoruz","url_err":"Bilinmeyen hata (eksik URL?), l\u00fctfen moderat\u00f6r ile ileti\u015fime ge\u00e7in","website":{"blank":"L\u00fctfen site URL'ini girin"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%a %d.%b.%y %H:%M","long":"%e %B %Y, %A, %H:%M","short":"%e %B, %H:%M","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"Giri\u015f"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Ba\u011flan","language":"Dil","languages":{"de":"Almanca ","en":"\u0130nigilizce","es":"\u0130spanyolca","fr":"Frans\u0131zca","hi":null,"id":"Endonezce","it":"\u0130talyanca","pt-BR":"Portekizce","th":"Tayca","tr":"T\u00fcrk\u00e7e ","vn":"Vietnamca"},"message":"Mesaj","next":"Sonraki","prev":"\u00d6nceki","prompt":{},"right":{},"share":"Payla\u015f","table":"Puan Durumu","tweet":"Tweet","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"Tak\u0131m Hakk\u0131nda","add_caption":"Ba\u015fl\u0131k Ekle","add_content":"A\u015fa\u011f\u0131da g\u00f6sterilen kaynaklardan bir yaz\u0131y\u0131 yaz\u0131n\u0131za ekleyin:","add_image":"Resim Ekle","add_item":"Resim Ekle","add_media":"G\u00f6r\u00fcnt\u00fc Ekle","add_team":"Tak\u0131m Ekle","additional_media":"Ek G\u00f6r\u00fcnt\u00fc","are_you_sure":"Bu sayfadan ayr\u0131lmak istedi\u011finize emin misiniz?","article_preview":"Bu yaz\u0131n\u0131z\u0131n \u00f6nizlemesidir","attach_image":"Foto\u011fraf Se\u00e7","back":"Geri","back_to_edit":"D\u00fczenlemeye Geri D\u00f6n","back_to_editing":"D\u00fczenlemeye Geri D\u00f6n","bold_tooltip":"Kal\u0131n","caption_optional":"(Tercihe Ba\u011fl\u0131, En Fazla 22 karakter)","char_count":"Harf Say\u0131s\u0131: %{num}","check_grammar":"Yaz\u0131m ve noktalama hatalar\u0131n\u0131 d\u00fczeltmek i\u00e7in yeniden g\u00f6z at\u0131n","choose_team":"Tak\u0131m Se\u00e7","clear":"D\u00fczenle","complete_steps":"Yay\u0131nlamadan \u00d6nce Bu Ad\u0131mlar\u0131 Tamamlaman\u0131z Gerekir:","congrats":"Tebrikler!","cover_image":"Bu foto\u011fraf internet sitesinde, uygulamada ya da sosyal a\u011flarda g\u00f6z\u00fckecek","create_article":"Yaz\u0131  Olu\u015ftur","crop_image":"Resmi K\u0131rp","crop_ratio":"K\u0131rpma oran\u0131:","crop_too_small":"Resim \u00c7ok K\u00fc\u00e7\u00fck","date":"Tarih:","delete":"S\u0130L","delete_article":"Bu yaz\u0131y\u0131 sil","discard":"Sil","discard_confirmation":"Bu Payla\u015f\u0131m\u0131 Silmek \u0130stedi\u011fine Emin Misin?","draft":"Kaydet","drag":"Resmi/Videoyu Buraya S\u00fcr\u00fckle","drag_all":"Resim, video ya da sosyal medya yaz\u0131s\u0131n\u0131 buraya s\u00fcr\u00fckleyin","drag_crop":"Konumland\u0131rmak \u0130\u00e7in S\u00fcr\u00fckle","drop_here":"Buraya b\u0131rak...","drop_image":"Resmi buraya b\u0131rak","edit_crop":"Resmi Ayarlamak i\u00e7in kayd\u0131r/tekrar boyutla","edit_thumb":"Resmi D\u00fczenle","editor":"Edit\u00f6r:","embed":"Ekle","embed_code":"Kopyalanan Kod","embed_only":"Kopyalanan kodu buraya yap\u0131\u015ft\u0131r\u0131n","embed_video":"Video Ekle","enter_desc":"Tan\u0131m\u0131n\u0131z\u0131 buraya yaz\u0131n...","enter_title":"Ba\u015fl\u0131\u011f\u0131 buraya yaz\u0131n...","enter_url":"URL/Kod Girin","facebook_cover_image":"Facebook Kapak Foto\u011fraf\u0131","ftbpro_editor":"FTBpro Edit\u00f6r\u00fc","grammar_spelling":"Yaz\u0131 ve imla hatalar\u0131 i\u00e7in biraz ara ver.","great":"M\u00fcthis!","guide_tips":"K\u0131lavuzumuzu ve yaz\u0131 ipu\u00e7lar\u0131m\u0131z\u0131 okuyun","guide_tips_links":"http://www.90min.com/blog/seo-kurallari-ipuclari/","h2_tooltip":"Ba\u015fl\u0131k","header_edit":"Payla\u015f\u0131m\u0131 D\u00fczenle","header_new":"Yeni Payla\u015f\u0131m","hyperlink_tooltip":"Link","image_bank":"Resim Klas\u00f6r\u00fc","image_crop":"K\u0131rp","image_format":"Sadece JPEG, PNG and gif dosyalar\u0131n\u0131 kullanabilirsiniz.","image_search":"Ara","image_size":"\u00d6l\u00e7\u00fcler 520x280 pikselden geni\u015f olmal\u0131.","image_size_parameterized":"\u00d6l\u00e7\u00fcler %{width}x%{height} pikselden geni\u015f olmal\u0131.","image_video":"Resim/Video","image_weight":"Bu dosya maksimum \u00f6l\u00e7\u00fcy\u00fc ge\u00e7ti: %{fileSizeMaxSupported}","insert_link":"Video i\u00e7in URL","invalid_code":"URL/Kod ge\u00e7ersiz ya da destekli de\u011fil. L\u00fctfen ge\u00e7erli bir URL/Kod girin.","leave":"Bu Sayfadan \u00c7\u0131k","leave_warning":"Son De\u011fi\u015fiklikleri Kaydetmedin. B\u00fct\u00fcn De\u011fi\u015fiklikler Silinir!","list_tooltip":"S\u0131ras\u0131z Liste","max":"(En Fazla %{num})","max_reached":"(en fazlaya ula\u015f\u0131ld\u0131)","media_longer":"(200 kelimeden fazla yaz\u0131lar i\u00e7in)","media_longer_than":"(300 kelimeden fazla yaz\u0131lar i\u00e7in)","media_post":"Resim Payla\u015f\u0131m\u0131","min":"(Min %{num})","min_words":"(en az %{num} kelime)","no_draft":"Kaydedilmi\u015f taslak yok","num_words":"%{count} Kelime","number_list_tooltip":"S\u0131ral\u0131 Liste","oops":"Nerdeyse...","optimal_article":"(Olmas\u0131 Gereken 300-800)","optimal_length":"(Olmas\u0131 Gereken %{min}-%{max})","optional":"(Tercihe gore, En fazla 160 karakter)","optional_field":"Bu b\u00f6l\u00fcm iste\u011fe g\u00f6redir","or":"Ya Da","p_tooltip":"Paragraf","paste_embed":"URL'i buraya yap\u0131\u015ft\u0131r ya da kodu buraya ekle","paste_url":"URL ya da Embed Kodu yap\u0131\u015ft\u0131r\u0131n","playbuzz":"PlayBuzz.com sitesinde yazd\u0131\u011f\u0131n\u0131z yaz\u0131n\u0131n URL'ini buraya yap\u0131\u015ft\u0131r\u0131n","polls":"Anket Ekle","prev":"\u00d6nizleme","preview":"Kaydet & \u00d6nizleme ","publish":"Yay\u0131nla","remove_attachment":"Ekteki dosyay\u0131 silmek istedi\u011fine emin misin?","reset":"Ba\u015ftan Ba\u015flat","review":"Yay\u0131nlamadan \u00d6nce \u00d6nizleme Yap","save_changes":"De\u011fi\u015fiklikler Kaydedilsin Mi?","save_draft":"TASLAK OLARAK KAYDET","search_bank":"Image Bank i\u00e7erisinden ara","search_for":"Ara...","searching":"Ar\u0131yor...","select_photo":"Fotograf Se\u00e7","seo_desc":"SEO Tan\u0131m\u0131","share":"Bunu Facebook sayfanda payla\u015f","small_image":"Foto\u011fraf \u00e7ok k\u00fc\u00e7\u00fck. En az 300x150 boyutlar\u0131nda olmal\u0131.","source":"Kaynak:","start_at":"Ba\u015flama saati","stay":"Bu sayfada kal","steps_complete":"Yaz\u0131n yay\u0131na girmeye haz\u0131r.","styling_tooltip":"D\u00fczenlemeyi B\u0131rak","tag":"Etiketler","tag_at_least":"(En az 1 tane se\u00e7)","tag_sug":"Etiket \u00d6nerileri","tag_team":"Etiketler","teaser":"A\u00e7\u0131klama","teaser_watermark":"Bu link sadece yaz\u0131n\u0131z\u0131n tan\u0131m b\u00f6l\u00fcm\u00fcnde g\u00f6z\u00fckecek","this_is_preview":"Yaz\u0131n\u0131z\u0131n \u00d6nizlemesi","tip_controversial ":"Tart\u0131\u015fmac\u0131 olmaya gayret et. \u0130yi payla\u015f\u0131m her zaman sorular\u0131 da beraberinde getirir.","tip_image":"Resim ekle. Resimli payla\u015f\u0131mlar daha fazla ilgi \u00e7eker ve daha \u00e7ok okunur.","tip_media":"Bu video g\u00fczel mi? YouTube ya da Metacafe'den alaca\u011f\u0131n g\u00f6r\u00fcnt\u00fcler daha fazla ilgi g\u00f6r\u00fcr.","tip_short":"Paragraflar\u0131n\u0131 k\u0131sa tut. Okuyucular uzun paragraflar\u0131 genelde atlarlar.","tips":{"media_close_ups":"Yaz\u0131lar\u0131nda futbolcular\u0131n yak\u0131n plan resimlerini kullanmaya \u00f6zen g\u00f6ster.","media_image_bank":"Herhangi bir foto\u011fraf istedi\u011finde Getty Image Bank'i kullanman\u0131 tavsiye ediyoruz. Oyuncu ya da tak\u0131mla arama yapabilirsin.","post_enjoy":"En \u00f6nemlisi, keyfini \u00e7\u0131kar!","post_original":"\u00d6zg\u00fcn ol. Kopyalanm\u0131\u015f yaz\u0131lar ya da ba\u015fka kaynaklara izin verilmeyecek!","post_paragraphs":"Yaz\u0131lar\u0131nda paragraf kullanmaya \u00f6zen g\u00f6ster.","post_review":"Yaz\u0131n\u0131 yay\u0131nlamadan \u00f6nce g\u00f6zden ge\u00e7ir. Yaz\u0131m ya da imla hatas\u0131 olup olmad\u0131\u011f\u0131n\u0131 kontrol et.","title":"Yaz\u0131n\u0131n okunma say\u0131s\u0131n\u0131 artt\u0131rmak i\u00e7in bir ka\u00e7 ipucu.","title_debatable":"Ki\u015fisel d\u00fc\u015f\u00fcncelerini kullan. Hatta biraz abart. \u0130nsanlar tart\u0131\u015f\u0131l\u0131r ba\u015fl\u0131klara daha \u00e7ok ilgi g\u00f6sterir.","title_known_name":"Yaz\u0131na bir futbolcu ad\u0131 ya da tak\u0131m ad\u0131 ile ba\u015fla.","title_popular_terms":"Yaz\u0131n\u0131n i\u00e7ine pop\u00fcler kelimeler kullan. Futbolcu ismi, tak\u0131m ismi ya da ilgi \u00e7ekebilecek bir ba\u015fl\u0131k gibi.","title_question":"Yaz\u0131n\u0131n i\u00e7inde cevab\u0131n\u0131 bulabilece\u011fimiz sorular sor.","title_short":"K\u0131sa tut. 5-8 kelime yeterlidir."},"title":"Ba\u015fl\u0131k","too_long":"\u00c7ok Uzun (10-75 harf olmal\u0131)","too_short":"\u00c7ok K\u0131sa (10-75 harf olmal\u0131)","toolong":"\u00c7ok Uzun (%{min}-%{max} harf olmal\u0131)","tooshort":"\u00c7ok K\u0131sa (%{min}-%{max} harf olmal\u0131)","try_again":"Tekrar deneyin","upload_failed":"Resim y\u00fcklerken bir hata olu\u015ftu. L\u00fctfen tekrar deneyin.","upload_image":"Resim Y\u00fckle","upload_img":"Resim Y\u00fckle","valid_code":"Ekledi\u011finiz kod ge\u00e7erli de\u011fil.","video":"Video","video_provider":"Hen\u00fcz bu t\u00fcrde bir videoyu desteklemiyoruz.","video_services":"YouTube, Dailymotion ya da Metacafe sitelerinden videolar\u0131 burada payla\u015f:","video_url":"Video URL (YouTube, Dailymotion, Metacafe, vs.)","word_count":"Kelime: %{num}","writing_sug":"SEO Tavsiyeleri","writing_tips":"Daha iyi yazmak i\u00e7in ipu\u00e7lar\u0131","your_post":"Payla\u015f\u0131m\u0131n"},"embed":{"button":"Yerle\u015ftir","dialogue":{"additional_options":"\u0130lave Se\u00e7enekler","become_a_partner":"\u0130\u015e ORTA\u011eI OLUN","comments":"Yorumlar\u0131 G\u00f6ster","customise_collapse/expand":"Kodu \u00f6zelle\u015ftir","disclaimer":"Bu kodu yerle\u015ftirerek %{terms_conditions}'\u0131 kabul etmi\u015f oluyorsunuz","embed_code":"Kodu yerle\u015ftir","embed_instructions":"Bu payla\u015f\u0131m\u0131 sitenize eklemek i\u00e7in a\u015fa\u011f\u0131daki HTML kodunu kopyalay\u0131p yap\u0131\u015ft\u0131r\u0131n","embed_instructions_partners":"Ki\u015fisel kodunuzu a\u015fa\u011f\u0131ya kopyala\u0131\u011f yap\u0131\u015ft\u0131r\u0131n","full_title":"T\u00fcm ba\u015fl\u0131k","header":"PAYLA\u015eIM YERLE\u015eT\u0130RME","info":"90min linkini kald\u0131rmak sadece i\u015f ortaklar\u0131m\u0131z taraf\u0131ndan ger\u00e7ekle\u015ftirilebilir","link":"Linki 90min olarak g\u00f6ster","logged_in":"%{email} adresi ile ileti\u015fime ge\u00e7erek i\u015f orta\u011f\u0131m\u0131z olun.","login":"login","partner_message":"\u0130\u015f orta\u011f\u0131m\u0131z m\u0131s\u0131n\u0131z? \u00d6zel kodunuzu \u00f6\u011frenmek i\u00e7in %{login} yap\u0131n.","remove_title":"Ba\u015fl\u0131\u011f\u0131 kald\u0131r","show-author":"Yazar\u0131 g\u00f6ster","show-date":"Tarihi g\u00f6ster","show-reads-counter":"G\u00f6r\u00fcnt\u00fclenme say\u0131s\u0131n\u0131 g\u00f6ster","show-title":"Ba\u015fl\u0131\u011f\u0131 g\u00f6ster","terms_&_conditions":"\u015eartlar & Ko\u015fullar","title":"Ba\u015fl\u0131k","views":"G\u00f6r\u00fcnt\u00fclenme say\u0131s\u0131n\u0131 g\u00f6ster\n"}},"footer":{"about_12up":null,"about_90min":"90min Hakk\u0131nda","about_circasports":"FTB90 CircaSports","about_dbltap":null,"about_ei":null,"about_floor8":null,"about_ftb90":"FTB90 Hakk\u0131nda","about_ftbpro":"Hakk\u0131nda","about_german_site":null,"about_ht_media":null,"about_pluralist":null,"about_swurley":"FTB90 Swurley","about_theduel":null,"affiliates":"Affiliate ","apps":"Mobil Uygulamalar","apps_Android":"HEMEN AL","apps_iphone":"UYGUN","blog":"Blog","boomerang":null,"cartoon":null,"contact_ftbpro":"\u0130leti\u015fim","fan_store":"Taraftar Ma\u011fzas\u0131","faq":"SSS","house_rules":"Kurallar","in_the_news":"Bas\u0131nda","jobs":"\u0130\u015fler","licensing":"Lisans","links":"Link","links_social":"Link","more_about_12up":null,"more_about_90min":"90min hakk\u0131nda daha fazlas\u0131","more_about_circasports":"CircaSports hakk\u0131nda daha fazlas\u0131","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":null,"more_about_ftb90":"FTB90 hakk\u0131nda daha fazlas\u0131","more_about_german_site":null,"more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"Swurley hakk\u0131nda daha fazlas\u0131","more_about_theduel":null,"partner_sites":null,"partners":"\u0130\u015f Ortaklar\u0131","prev_prog":null,"privacy_policy":"Gizlilik Politikas\u0131","rights_reserved":"T\u00fcm haklar\u0131 sakl\u0131d\u0131r","rights_reserved_year":"2016 FTBpro \u00a9 T\u00fcm Haklar\u0131 Sakl\u0131d\u0131r","rights_reserved_year_12up":null,"rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 T\u00fcm Haklar\u0131 Sakl\u0131d\u0131r","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports \u00a9 T\u00fcm Haklar\u0131 Sakl\u0131d\u0131r","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"2017 FTB90 \u00a9 T\u00fcm Haklar\u0131 Sakl\u0131d\u0131r","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"2016 Swurley \u00a9 T\u00fcm Haklar\u0131 Sakl\u0131d\u0131r","rights_reserved_year_theduel":null,"space":null,"statistics_12up":null,"statistics_90min":"90min \u0130statistikler","statistics_circasports":"CircaSports \u0130statistikler","statistics_ei":null,"statistics_floor8":null,"statistics_ftb90":"FTB90 \u0130statistikler","statistics_ht_media":null,"statistics_swurley":"Swurley \u0130statistikler","statistics_theduel":null,"stats":{"articles":"Yaz\u0131lar","fans":"Fanlar","members":"\u00dcyeler","writers":"Yazarlar"},"support":"Destek","tbs":null,"tcm":null,"terms":"\u015eartlar","terms_conditions":"\u015eartlar & Ko\u015fullar","tnt":null,"warner":null,"writers":"Yazarlar"},"header":{"profile":"Profilim","settings":"Ayarlar","signout":"\u00c7\u0131k\u0131\u015f"},"home":{"no_matches":"Yak\u0131nda ma\u00e7 yok"},"homepage":{"be_the_first":"\u0130LK B\u0130LEN S\u0130Z OLUN!","by":"Taraf\u0131ndan:","chrome_notifications":"Chrome bildirimleri ile en son haberlere ula\u015f\u0131n","ei":{"latest_news":null,"trending":null,"view_more":null},"fan_perspectives":"Tam Kapsaml\u0131","fan_voice":"TARAFTARIN SES\u0130","featured_topic":null,"fixtures_and_scores":null,"fixtures_scores":"Fi\u0307kst\u00fcr Ve Skorlar","follow_us_on":"Bizi Snapchat'te takip edin:","latest_videos":"En Son Videolar","league_page":null,"match_day":"Ma\u00e7 G\u00fcn\u00fc %{num}","month":"%M","more":"Daha Fazla","most_read":"Galeriler","no_matches":"Bu tarihe ait herhangi bir ma\u00e7 yok","other_categories":"DAHA FAZLA KATEGOR\u0130","our_categories":"KATEGOR\u0130LER","read_now":"\u015e\u0130MD\u0130 OKU","schedule":"PROGRAM","scores_page_desc":"En g\u00fcncel fikst\u00fcr ve sonu\u00e7lar","scores_page_title":"Fikst\u00fcr & sonu\u00e7lar","social_text":null,"stay_up_to":"Bizi takip ederek en son haberlere ula\u015f\u0131n","top_stories":"En \u0130yi Hikayeler","trending":null,"trending_floor8":null,"video":"Video","videos":"Videolar","view_all":"T\u00fcm Ma\u00e7lar\u0131 G\u00f6r\u00fcnt\u00fcle","view_more":"Daha Fazlas\u0131n\u0131 G\u00f6r\u00fcnt\u00fcle","watch_more_videos":"Daha Fazla Video \u0130zle","watch_tv_12up":null,"watch_tv_90min":"90MIN TV'Y\u0130 \u0130ZLE","watch_tv_circasports":"CIRCA SPORTS TV'Y\u0130 \u0130ZLE","watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":null,"watch_tv_german_site":null,"watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"Reklam","bet_now":"\u015eimdi Bahis Yap ","by":"Ekleyen","by_betway":null,"community_content":"Kullan\u0131c\u0131 Yaz\u0131s\u0131","community_disclaimer":"Bu yaz\u0131 90min kullan\u0131c\u0131lar\u0131ndan biri taraf\u0131ndan yaz\u0131lm\u0131\u015ft\u0131r ve edit\u00f6r tak\u0131m\u0131m\u0131z taraf\u0131ndan d\u00fczeltilmemi\u015f ya da bizim taraf\u0131m\u0131zdan yay\u0131nlanmam\u0131\u015ft\u0131r.","community_disclaimer_12up":null,"community_disclaimer_90min":"Bu yaz\u0131 90min kullan\u0131c\u0131lar\u0131ndan biri taraf\u0131ndan yaz\u0131lm\u0131\u015ft\u0131r ve edit\u00f6r tak\u0131m\u0131m\u0131z taraf\u0131ndan d\u00fczeltilmemi\u015f ya da bizim taraf\u0131m\u0131zdan yay\u0131nlanmam\u0131\u015ft\u0131r.","community_disclaimer_circasports":"Bu yaz\u0131 CircaSports kullan\u0131c\u0131lar\u0131ndan biri taraf\u0131ndan yaz\u0131lm\u0131\u015ft\u0131r ve edit\u00f6r tak\u0131m\u0131m\u0131z taraf\u0131ndan d\u00fczeltilmemi\u015f ya da bizim taraf\u0131m\u0131zdan yay\u0131nlanmam\u0131\u015ft\u0131r.","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":null,"community_disclaimer_ftb90":"Bu yaz\u0131 FTB90 kullan\u0131c\u0131lar\u0131ndan biri taraf\u0131ndan yaz\u0131lm\u0131\u015ft\u0131r ve edit\u00f6r tak\u0131m\u0131m\u0131z taraf\u0131ndan d\u00fczeltilmemi\u015f ya da bizim taraf\u0131m\u0131zdan yay\u0131nlanmam\u0131\u015ft\u0131r.","community_disclaimer_german_site":null,"community_disclaimer_ht_media":null,"community_disclaimer_swurley":"Bu yaz\u0131 Swurley kullan\u0131c\u0131lar\u0131ndan biri taraf\u0131ndan yaz\u0131lm\u0131\u015ft\u0131r ve edit\u00f6r tak\u0131m\u0131m\u0131z taraf\u0131ndan d\u00fczeltilmemi\u015f ya da bizim taraf\u0131m\u0131zdan yay\u0131nlanmam\u0131\u015ft\u0131r.","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} yaz\u0131lar\u0131 ve reklamlar\u0131 ki\u015fiselle\u015ftirmek, ve siteyi daha kolay kullan\u0131labilir hale getirmek i\u00e7in cookies kullan\u0131yoruz. Ayr\u0131ca baz\u0131 bilgileri reklam ve analitik veriler i\u00e7in 3. \u015fah\u0131slarla payla\u015f\u0131yoruz.","cookies_consent_2":"Daha Fazla","cookies_consent_approve":"Anlad\u0131m!","notf":{},"now_playing":"\u015eU AN YAYINDA:","similar_articles":"Benzer Yaz\u0131lar"},"private_messages":{"conversation_date":"Son g\u00fcncelleme:","expand":"Geni\u015flet","header":"Gelen Kutusu","message_sent":"Mesaj\u0131n g\u00f6nderildi","messages":"Mesajlar","no_history":"Ge\u00e7mi\u015f yok","not_available":"Sohbet m\u00fcsait de\u011fil","private_message":"\u00d6zel mesaj","private_message_to":"\u00d6zel mesaj","send":"G\u00f6nder","send_failed":"G\u00f6nderilemedi. L\u00fctfen tekrar deneyin.","sending":"g\u00f6nderiliyor","sent":"Mesaj g\u00f6nderildi","side_title":"Konu\u015fmalar","title":"Aran\u0131zda","view_history":"Konu\u015fma ge\u00e7mi\u015fini g\u00f6r\u00fcnt\u00fcle","write_message_here":"Mesaj\u0131n\u0131 buraya yaz"},"pundit":{"bet_via":"BAH\u0130S YAPMAK \u0130\u00c7\u0130N:","draw":"Berabere","fan_predictions":"Taraftar Tahminleri","follow_match":"Ma\u00e7\u0131 Takip Et","follow_pundit":"Uzman\u0131 Takip Et","log_in":"Tahminin kaydetmek i\u00e7in giri\u015f yap","not_available":"\u0130statistikler \u015fu anda y\u00fcklenemiyor. L\u00fctfen daha sonra tekrar deneyin.","place_your_bet":"BAH\u0130S YAP","place_your_bet_via":"Bahislerinizi Yapman\u0131z \u0130\u00e7in","prediction":"Tahmin:","pundit_prediction":"%{pundit_first_name}'\u0131n Tahmini:","select_match":"Tahmin Yapmak \u0130stedi\u011fin Ma\u00e7\u0131 Se\u00e7","select_result":"- Sonu\u00e7 Se\u00e7 -","team_to_win":"%{team} kazan\u0131r","title":"%{team1} - %{team2}: bahis ipu\u00e7lar\u0131n\u0131z\u0131n yazar\u0131 %{pundit_name}","top_predictors":"EN \u0130Y\u0130 TAHM\u0130NC\u0130LER","what_result":"Sonucu bilece\u011fini d\u00fc\u015f\u00fcn\u00fcyor musun?","what_your_prediction":"SEN\u0130N TAHM\u0130N\u0130N NE?","your_prediction":"TAHM\u0130N\u0130N:"},"reactions":{"campaigns_poweredby":"Taraf\u0131ndan","v1":{"lol":"G\u00fczel","love":"Be\u011fendim","must":"M\u00fcthi\u015f","noway":"Idare Eder!","share":"Payla\u015f","shocked":"\u0130nan\u0131lmaz","tweet":"Tweet"},"v2":{"booh":null,"cool":null,"haha":"Haha","loveit":null,"noway":null},"your_reaction":"Senin Tepkin?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"Yaz\u0131m 100 okuyucuya ula\u015ft\u0131","about_you":"Senin Hakk\u0131nda","account":"Hesap","all_info_lost":"FTBpro.com'daki b\u00fct\u00fcn bilgilerin kal\u0131c\u0131 olarak silinecek.","are_you_sure":"Emin Misin?","by_email":"email","connected_as":"olarak ba\u011fland\u0131","deactivate":"Hesab\u0131m\u0131 durdur","deactivate_placeholder":"L\u00fctfen bize nedenini bildir:","deactivate_request_sent":"Talebin onayland\u0131. En k\u0131sa s\u00fcrede seninle ileti\u015fime ge\u00e7ilecek.","disp_name":"G\u00f6r\u00fcnen \u0130sim","fb_hometown":"Facebook'taki \u015eehrin","fb_link":"Facebook link","go_social":"Sosyal medyaya git - arkada\u015flar\u0131m\u0131 hareket d\u00f6k\u00fcm\u00fcmden haberdar et","go_social_short":"Yaz\u0131m\u0131n ka\u00e7 kere okundu\u011funu payla\u015f","google_plus_link":"Google+ link","if_following_me":"Biri beni takip etmeye ba\u015flad\u0131","if_sending_me_message":"Biri bana mesaj att\u0131","let_see":"Herkesin g\u00f6rmesini sa\u011fla:","my_team":"Tak\u0131m\u0131m","name":{"rules":"\u00d6zel olmal\u0131. 5-50 harf. Harf, say\u0131 ve i\u015faret kullan"},"notifications":"Bildirimler","optional":"Tercihe G\u00f6re","privacy":"Gizlilik","recent_articles":"\u015eu an payla\u015f\u0131lan yaz\u0131lar","save":"Kaydet","settings":"Ayarlar","settings_saved":"Ayarlar kaydedildi","share":"Otomatik Payla\u015f","site":"Site:","site_title":"Ba\u015fl\u0131k:","site_url":"URL:","stats":"vBet istatistikleri","submit":"Onayla","twitter_link":"Twitter link:","weekly_writers_achievements":"Haftal\u0131k yazar \u00f6zetim","when_notify":"Ne zaman oldu\u011funu bana bildir","your_writing_language":"Hangi dilde yazacaks\u0131n?"},"sign_up":{"about_you":"Tak\u0131m\u0131n hakk\u0131ndaki d\u00fc\u015f\u00fcncelerini, tak\u0131m\u0131n\u0131 ne denli sevdi\u011fini yaz (iste\u011fe gore)","and":"ve","change":"Bunlar\u0131 istedi\u011fin zaman Ayarlar sekmesinden de\u011fi\u015ftirebilirsin","disp_name":"G\u00f6z\u00fckecek \u0130sim","join_12up":null,"join_90min":"90min'e kat\u0131l","join_circasports":"CircaSports'e kat\u0131l","join_dbltap":null,"join_ei":null,"join_floor8":null,"join_ftb90":"FTB90'e kat\u0131l","join_german_site":null,"join_ht_media":null,"join_swurley":"Swurley'e kat\u0131l","lets_start":"Ba\u015fl\u0131yoruz...","my_game":null,"my_league":"Lig","of_12up":null,"of_90min":"kabul ediyorum","of_circasports":"kabul ediyorum","of_dbltap":null,"of_ei":null,"of_floor8":null,"of_ftb90":"kabul ediyorum","of_german_site":null,"of_ht_media":null,"privacy_policy":"Gizlilik S\u00f6zle\u015fmesi","required_field":"Gerekli alan","team":"Tak\u0131m\u0131m","terms":"90min.com 'un","terms_and_conditions":"\u015eartlar ve Ko\u015fullar'\u0131n\u0131"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"Yaz\u0131lar","comments":"Yorumlar","reads":"Okunanlar"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"SON HABERLER","latest_videos":"SON V\u0130DEOLAR","read_more":"Devam\u0131","recommended":"TAVS\u0130YE ED\u0130LEN","video":"Video"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"pt-BR":{"date":{"abbr_day_names":["Dom","Seg","Ter","Qua","Qui","Sex","S\u00e1b"],"abbr_month_names":[null,"Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],"day_names":["Domingo","Segunda","Ter\u00e7a","Quarta","Quinta","Sexta","S\u00e1bado"],"formats":{"default":"%d/%m/%Y","long":"%d de %B de %Y","short":"%d de %B","capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"Janeiro","Fevereiro","Mar\u00e7o","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],"order":["Dia","M\u00eas","Ano"],"time_since":{"about_an_hour_ago":"H\u00e1 uma hora","about_two_hours_ago":"H\u00e1 duas horas","seconds_ago":"Segundos atr\u00e1s","x_hours_ago":{"one":"1 hora atr\u00e1s","other":"%{count} horas atr\u00e1s"},"x_minutes_ago":{"one":"1 minuto atr\u00e1s","other":"%{count} minutos atr\u00e1s"}}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"deve ser aceito","blank":"n\u00e3o pode ficar em branco","confirmation":"n\u00e3o est\u00e1 de acordo com a confirma\u00e7\u00e3o","empty":"n\u00e3o pode ficar vazio","equal_to":"deve ser igual a %{count}","even":"deve ser par","exclusion":"n\u00e3o est\u00e1 dispon\u00edvel","greater_than":"deve ser maior que %{count}","greater_than_or_equal_to":"deve ser maior ou igual a %{count}","inclusion":"n\u00e3o est\u00e1 inclu\u00eddo na lista","invalid":"n\u00e3o \u00e9 v\u00e1lido","less_than":"deve ser menor que %{count}","less_than_or_equal_to":"deve ser menor ou igual a %{count}","not_a_number":"n\u00e3o \u00e9 um n\u00famero","not_an_integer":"n\u00e3o \u00e9 um n\u00famero inteiro","odd":"deve ser \u00edmpar","record_invalid":"A valida\u00e7\u00e3o falhou: %{errors}","taken":"j\u00e1 est\u00e1 em uso","too_long":"\u00e9 muito longo (m\u00e1ximo: %{count} caracteres)","too_short":"\u00e9 muito curto (m\u00ednimo: %{count} caracteres)","wrong_length":"n\u00e3o possui o tamanho esperado (%{count} caracteres)"},"template":{"body":"Por favor, verifique o(s) seguinte(s) campo(s):","header":{"one":"N\u00e3o foi poss\u00edvel gravar %{model}: 1 erro","other":"N\u00e3o foi poss\u00edvel gravar %{model}: %{count} erros."}},"200_pixels":"A imagem deve ter no m\u00ednimo 200x200 pixels","file_too_big":"O arquivo \u00e9 muito pesado","flash":"Deve instalar o Adobe Flash para usar esta op\u00e7\u00e3o","invalid_filetype":"Tipo de arquivo inv\u00e1lido (utilizar gif, jpg, jpeg e png)","invalid_url":"URL inv\u00e1lida","mobile_error":"Este v\u00eddeo n\u00e3o pode ser reproduzido no celular","motto":{"title":"Por favor insira 10-25 caract\u00e9res"},"nick":{"duplicate":"Usu\u00e1rio j\u00e1 em uso","length":"Apelido deve conter entre 5 e 50 caract\u00e9res.","title":"Use apenas letras, d\u00edgitos, per\u00edodos e tra\u00e7os","validation":"Seu nome deve conter entre 5-50 caract\u00e9res - apenas letras, d\u00edgitos, pontos e tra\u00e7os."},"no_file":"N\u00e3o escolheu um arquivo","not_found":"N\u00e3o encontramos a p\u00e1gina","one_team":"Deve selecionar pelo menos 1 time","pic_size":"O tamanho da figura deve ser entre %{min} and %{max}","ratio_alert":"A propor\u00e7\u00e3o da foto deve ser entre 1:2 and 2:1","return_homepage":"Volte para a p\u00e1gina inicial","select_image":"Voc\u00ea deve selecionar uma imagem para adicionar","sorry":"DESCULPE","subject_id":{"require_fanship":"Ser torcedor \u00e9 uma obriga\u00e7\u00e3o!"},"text":{"duplicate_comment":"Coment\u00e1rio duplicado","duplicate_post":"Postagem duplicada","max_char":"M\u00e1ximo %{num_chars} caract\u00e9res","max_words":"M\u00e1ximo %{num_words} palavras","min_char":"M\u00ednimo %{num_chars} caract\u00e9res"},"twitter_url":{"invalid":"URL de Twitter inv\u00e1lido"},"unknown_upload":"Um error inesperado ocorreu. Por favor, entre em contato","unsupported_video":"Desculpa, n\u00f3s n\u00e3o suportamos v\u00eddeos dessa fonte","url_err":"Erro inesperado (URL mal escrito?). Por favor, entre em contato conosco","website":{"blank":"Favor preencher URL do site"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%A, %d de %B de %Y, %H:%M h","long":"%A, %d de %B de %Y, %H:%M h","short":"%d/%m, %H:%M h","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"Entrar"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Conectar","language":"Idioma","languages":{"de":"Alem\u00e3o","en":"Ingl\u00eas","es":"Espanhol","fr":"Franc\u00eas","hi":null,"id":"Indon\u00e9sio","it":"Italiano","pt-BR":"Portugu\u00eas","th":"Tailand\u00eas","tr":"Turco","vn":"Vietnamita"},"message":"Mensagem","next":"Pr\u00f3ximo","prev":"Anterior","prompt":{},"right":{},"share":"Compartilhar ","table":"Tabelas","tweet":"Tweet","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"Sobre o time","add_caption":"Adicione uma legenda","add_content":"Adicione conte\u00fado \u00e0 seu artigo das seguintes fontes:","add_image":"Adicione uma imagem","add_item":"Adicione um \u00edtem de m\u00eddia","add_media":"Adicionar m\u00eddia","add_team":"Adicione um time","additional_media":"M\u00eddia adicional","are_you_sure":"Tem certeza que quer sair da p\u00e1gina?","article_preview":"Esta \u00e9 uma pr\u00e9-visualiza\u00e7\u00e3o de seu artigo","attach_image":"Escolha uma imagem","back":"Atr\u00e1s","back_to_edit":"Volte para editar","back_to_editing":"Volte para editar","bold_tooltip":"Negrito","caption_optional":"(Opicional, m\u00e1ximo 22 caracteres)","char_count":"Contagem de caract\u00e9res: %{num}","check_grammar":"N\u00e3o esque\u00e7a de revisar a gram\u00e1tica e a ortografia","choose_team":"Escolha um time","clear":"Limpar","complete_steps":"Antes de publicar, precisa completar os seguintes passos:","congrats":"Parab\u00e9ns!","cover_image":"Esta ser\u00e1 a imagem que aparecer\u00e1 quando o post for publicado no site, no App ou nas redes sociais","create_article":"Criar um artigo","crop_image":"Cortar imagem","crop_ratio":"Propor\u00e7\u00e3o de corte:","crop_too_small":"A imagem \u00e9 muito pequena","date":"Data:","delete":"APAGAR","delete_article":"Apagar este artigo","discard":"Descartar","discard_confirmation":"Tem certeza que gostaria de descartar este post?","draft":"Salvar","drag":"Arraste a imagem/v\u00eddeo aqui","drag_all":"Arraste imagem, v\u00eddeo ou conte\u00fado das redes sociais aqui","drag_crop":"Arrastar para reposicionar","drop_here":"Solte aqui...","drop_image":"Solte a imagem aqui","edit_crop":"Mover/redefinir ret\u00e2ngulo para ajustar a miniatura","edit_thumb":"Editar miniatura","editor":"Editor:","embed":"Incluir","embed_code":"C\u00f3digo de incorpora\u00e7\u00e3o","embed_only":"Colar c\u00f3digo de incorpora\u00e7\u00e3o aqui","embed_video":"Incluir v\u00eddeo","enter_desc":"Insira a descri\u00e7\u00e3o aqui...","enter_title":"Insira o t\u00edtulo aqui...","enter_url":"Insira URL/c\u00f3digo","facebook_cover_image":"Imagem de capa do Facebook","ftbpro_editor":"Editor do FTBpro","grammar_spelling":"Tire algum tempo para verificar a gram\u00e1tica e a ortografia","great":"\u00d3timo!","guide_tips":"Leia as nossas dicas e orienta\u00e7\u00f5es","guide_tips_links":"http://www.90min.com/blog/seo-orientacoes-dicas/","h2_tooltip":"T\u00edtulo","header_edit":"Editar postagem","header_new":"Nova postagem","hyperlink_tooltip":"Link","image_bank":"Banco de imagens","image_crop":"Recortar","image_format":"O formato da imagem est\u00e1 limitado para JPEG, PNG e gif.","image_search":"Busca","image_size":"As dimens\u00f5es devem ser maiores que 500x280 pixels.","image_size_parameterized":"As dimens\u00f5es devem ser maiores que %{width}x%{height} pixels.","image_video":"Imagem/V\u00eddeo","image_weight":"Este arquivo excede o tamanho m\u00e1ximo de %{fileSizeMaxSupported}","insert_link":"Colar o link aqui","invalid_code":"O URL/c\u00f3digo \u00e9 inv\u00e1lido ou n\u00e3o \u00e9 aceito. Insira um URL/c\u00f3digo v\u00e1lido.","leave":"Sair da p\u00e1gina","leave_warning":"Voc\u00ea est\u00e1 tentando sair da p\u00e1gina sem salv\u00e1-la. Todas as mudan\u00e7as ser\u00e3o perdidas!","list_tooltip":"Lista desordenada","max":"(M\u00e1x %{num})","max_reached":"(m\u00e1ximo atingido)","media_longer":"(para artigos maiores de 200 palavras)","media_longer_than":"(para artigos maiores de 300 palavras)","media_post":"Postagem de m\u00eddia","min":"( M\u00edn %{num} )","min_words":"(pelo menos %{num} palavras)","no_draft":"Sem rascunhos salvos","num_words":{"one":"1 palavra","other":"%{count} palavras"},"number_list_tooltip":"Lista ordenada","oops":"Quase l\u00e1...","optimal_article":"(Ideal 300-800)","optimal_length":"(Ideal %{min}-%{max})","optional":"(Opcional, m\u00e1x 160 caract\u00e9res)","optional_field":"Este campo \u00e9 opcional","or":"Ou","p_tooltip":"Par\u00e1grafo","paste_embed":"Cole o link ou o c\u00f3digo aqui","paste_url":"Cole URL ou c\u00f3digo inser\u00edvel","playbuzz":"Cole aqui o link do artigo que voc\u00ea criou no PayBuzz.com","polls":"Adicionar uma enquete","prev":"Visualizar","preview":"Salvar e pr\u00e9 visualizar","publish":"Publica\u00e7\u00e3o","remove_attachment":"Tem certeza que deseja remover este acess\u00f3rio?","reset":"Reiniciar","review":"Pr\u00e9 visualizar antes de publicar","save_changes":"Salvar altera\u00e7\u00f5es?","save_draft":"SALVAR COMO RASCUNHO","search_bank":"Procurar no banco de imagens","search_for":"Procure por...","searching":"Procurando...","select_photo":"Selecionar foto","seo_desc":"Descri\u00e7\u00e3o de SEO","share":"Compartilhar esta postagem no Facebook","small_image":"Sua foto \u00e9 muito pequena. Ela deve ser pelo menos 300x150","source":"Fonte:","start_at":"In\u00edcio \u00e0s","stay":"Permanecer nesta p\u00e1gina","steps_complete":"Seu artigo est\u00e1 pronto para ser publicado.","styling_tooltip":"Remover o format","tag":"Etiquetas","tag_at_least":"(Escolha pelo menos 1)","tag_sug":"Sugest\u00f5es de etiquetas","tag_team":"Marca\u00e7\u00f5es","teaser":"Texto de abertura","teaser_watermark":"Ir\u00e1 aparecer apenas como uma descri\u00e7\u00e3o em links para seu artigo","this_is_preview":"Esta \u00e9 uma pr\u00e9 visualiza\u00e7\u00e3o de seu artigo","tip_controversial ":"Seja controverso. Uma boa postagem trata de quest\u00f5es dif\u00edceis.","tip_image":"Adicione uma foto. Postagens com imagens s\u00e3o mais atraentes.","tip_media":"Tem um v\u00eddeo? Filmes do YouTube ou Metacafe s\u00e3o muito visualizados.","tip_short":"Escreva par\u00e1grafos curtos. Leitores tendem a pular longos par\u00e1grafos.","tips":{"media_close_ups":"Use zoom nas imagens de artigos sobre jogadores","media_image_bank":"Recomendamos que use nosso Banco de Imagens para encontrar qualquer foto que desejar. Busque por jogadores ou times.","post_enjoy":"O mais importante, aproveite!","post_original":"Seja original. Conte\u00fado copiado de outros lugares n\u00e3o ser\u00e3o autorizados.","post_paragraphs":"Utilize par\u00e1grafos para melhorar seu artigo.","post_review":"Releia seu artigo antes de public\u00e1-lo. Verifique a ortografia e a gram\u00e1tica.","title":"Dicas para aumentar o n\u00famero de leitores:","title_debatable":"Use linguagem opinativa. Exagere. As pessoas gostam de t\u00f3picos para debater.","title_known_name":"Comece seu t\u00edtulo com o nome de um jogador ou de um time.","title_popular_terms":"Inclua palavras populares, como nomes de jogadores, times e assuntos quentes.","title_question":"Fa\u00e7a uma pergunta que \u00e9 respondida em seu artigo.","title_short":"Deixe curto. De 5 a 8 palavras \u00e9 o ideal."},"title":"T\u00edtulo","too_long":"Muito longo (Ideal 10-75)","too_short":"Muito curto (Ideal 10-75)","toolong":"Muito longo (Ideal %{min}-%{max})","tooshort":"Muito curto (Ideal %{min}-%{max})","try_again":"Tente de novo","upload_failed":"Ocorreu um erro ao subir a imagem. Por favor, tente de novo.","upload_image":"Fazer upload de foto","upload_img":"Suba uma imagem","valid_code":"O c\u00f3digo n\u00e3o \u00e9 v\u00e1lido.","video":"V\u00eddeo","video_provider":"N\u00e3o temos suporte para este tipo de v\u00eddeo.","video_services":"Colar v\u00eddeo do Youtube, Dailymotion ou Metacafe aqui: ","video_url":"V\u00eddeo URL (Youtube, Dailymotion, Metacafe, etc.)","word_count":"Contagem de palavras: %{num}","writing_sug":"SEO Sugest\u00f5es","writing_tips":"Dicas para escrever melhor","your_post":"Sua postagem"},"embed":{"button":"Inserir","dialogue":{"additional_options":"Op\u00e7\u00f5es adicionais","become_a_partner":"SEJA UM PARCEIRO","comments":"Mostrar coment\u00e1rios","customise_collapse/expand":"Configurar c\u00f3digo","disclaimer":"Inserindo o c\u00f3digo, voc\u00ea concorda com nossos %{terms_conditions}","embed_code":"C\u00f3digo inserido","embed_instructions":"Adicione este post ao seu site copiando e colando o HTML abaixo","embed_instructions_partners":"Copie e cole seu c\u00f3digo personalizado","full_title":"T\u00edtulo completo","header":"POST INSERIDO","info":"Remo\u00e7\u00e3o do link 90min s\u00f3 est\u00e1 dispon\u00edvel para parceiros","link":"Mostrar link para 90min","logged_in":"Contate %{email} para fazer parte de uma de nossas parcerias.","login":"Entre","partner_message":"J\u00e1 \u00e9 um parceiro? %{login} para receber seu c\u00f3digo personalizado.","remove_title":"Apagar t\u00edtulo","show-author":"Mostrar autor","show-date":"Mostrar data","show-reads-counter":"Mostrar n\u00famero de visualiza\u00e7\u00f5es","show-title":"Mostrar t\u00edtulo","terms_&_conditions":"Termos & Condi\u00e7\u00f5es","title":"T\u00edtulo","views":"Mostrar n\u00famero de visualiza\u00e7\u00f5es"}},"footer":{"about_12up":null,"about_90min":"Sobre 90min","about_circasports":"Sobre CircaSports","about_dbltap":null,"about_ei":"Sobre Esporte Interativo","about_floor8":null,"about_ftb90":"Sobre FTB90","about_ftbpro":"Sobre","about_german_site":null,"about_ht_media":null,"about_pluralist":null,"about_swurley":"Sobre Swurley","about_theduel":null,"affiliates":"Afiliados","apps":"Aplicativo de celular","apps_Android":"Encontre em:","apps_iphone":"Dispon\u00edvel em:","blog":"Blog","boomerang":"Boomerang","cartoon":"Cartoon Network","contact_ftbpro":"Fale conosco","fan_store":"Loja on-line","faq":"FAQ","house_rules":"Regras Da Casa","in_the_news":"Nas m\u00eddias","jobs":"Trabalhe Conosco","licensing":"Licen\u00e7a","links":"Links","links_social":"Links","more_about_12up":null,"more_about_90min":"Saiba Mais sobre a 90min","more_about_circasports":"Saiba Mais sobre a CircaSports","more_about_dbltap":null,"more_about_ei":"Saiba mais sobre o Esporte Interativo","more_about_floor8":null,"more_about_ftb90":"Saiba Mais sobre a FTB90","more_about_german_site":null,"more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"Saiba Mais sobre a Swurley","more_about_theduel":null,"partner_sites":"Sites Parceiros","partners":"Parceiros","prev_prog":"Programa\u00e7\u00e3o Veiculada","privacy_policy":"Pol\u00edtica de Privacidade","rights_reserved":"Todos os direitos reservados","rights_reserved_year":"2016 FTBpro \u00a9 Todos os direitos reservados","rights_reserved_year_12up":null,"rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 Todos os direitos reservados","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports \u00a9 Todos os direitos reservados","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":"Minute Media 2018 Esporte Interativo\u00a9 Todos os direitos reservados","rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"2016 FTB90 \u00a9 Todos os direitos reservados","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"2016 Swurley \u00a9 Todos os direitos reservados","rights_reserved_year_theduel":null,"space":"Space","statistics_12up":null,"statistics_90min":"Estat\u00edsticas da 90min","statistics_circasports":"Estat\u00edsticas da CircaSports","statistics_ei":"Estat\u00edsticas da Esporte Interativo","statistics_floor8":null,"statistics_ftb90":"Estat\u00edsticas da FTB90","statistics_ht_media":null,"statistics_swurley":"Estat\u00edsticas da Swurley","statistics_theduel":null,"stats":{"articles":"Artigos","fans":"Torcedores","members":"Membros","writers":"Autores"},"support":"Suporte","tbs":"TBS","tcm":"TCM","terms":"Termos ","terms_conditions":"Termos & Condi\u00e7\u00f5es","tnt":"TNT","warner":"Warner","writers":"Autores"},"header":{"profile":"Meu Perfil","settings":"Op\u00e7\u00f5es","signout":"Sair"},"home":{"no_matches":"N\u00e3o tem partidas"},"homepage":{"be_the_first":"SEJA O PRIMEIRO A SABER","by":"Por:","chrome_notifications":"Mantenha-se atualizado com nossas Notifica\u00e7\u00f5es do Chrome","ei":{"latest_news":"\u00daltimas Not\u00edcias ","trending":"Mais Lidas","view_more":"Veja Mais"},"fan_perspectives":"Cobertura Completa","fan_voice":"VOZ DO TORCEDOR","featured_topic":null,"fixtures_and_scores":null,"fixtures_scores":"Calend\u00e1rio e Resultados","follow_us_on":"Siga-nos no Snapchat:","latest_videos":"\u00daltimos v\u00eddeos","league_page":null,"match_day":"Dia de Jogo %{num}","month":"%M","more":"Mais","most_read":"Tend\u00eancias","no_matches":"N\u00e3o h\u00e1 jogos neste dia","other_categories":"MAIS CATEGORIAS","our_categories":"CATEGORIAS","read_now":"LEIA AGORA","schedule":"AGENDA","scores_page_desc":"Todos os calend\u00e1rios e resultados","scores_page_title":"Calend\u00e1rio & resultados","social_text":null,"stay_up_to":"Mantenha-se atualizado com as \u00faltimas not\u00edcias","top_stories":"Os melhores","trending":null,"trending_floor8":null,"video":"v\u00eddeo","videos":"V\u00eddeos","view_all":"Veja todos os jogos","view_more":"Veja mais","watch_more_videos":"Veja Mais V\u00eddeos","watch_tv_12up":null,"watch_tv_90min":"ASSISTA 90MIN TV","watch_tv_circasports":"ASSISTA CIRCA SPORTS TV","watch_tv_dbltap":null,"watch_tv_ei":"ASSISTA Esporte Interativo TV","watch_tv_floor8":null,"watch_tv_german_site":null,"watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":"Programa\u00e7\u00e3o"},"tv_programming":{"disclaimer":"Todos os conte\u00fados, incluindo programas e coordena\u00e7\u00e3o de transmiss\u00f5es, foram produzidos no Brasil no ano 2017 e s\u00e3o de classifica\u00e7\u00e3o livre","watch_now":"ASSISTA AO VIVO"}},"post_page":{"ad":"Propaganda","bet_now":null,"by":"Por","by_betway":null,"community_content":"Conte\u00fado da Comunidade","community_disclaimer":"Este artigo foi criado por algum membro da comunidade do 90min e n\u00e3o foi editado ou promovido pela nossa equipe de edi\u00e7\u00e3o.","community_disclaimer_12up":null,"community_disclaimer_90min":"Este artigo foi criado por algum membro da comunidade do 90min e n\u00e3o foi editado ou promovido pela nossa equipe de edi\u00e7\u00e3o.","community_disclaimer_circasports":"Este artigo foi criado por algum membro da comunidade do CircaSports e n\u00e3o foi editado ou promovido pela nossa equipe de edi\u00e7\u00e3o.","community_disclaimer_dbltap":null,"community_disclaimer_ei":"Este artigo foi criado por algum membro da comunidade do Esporte Interativo e n\u00e3o foi editado ou promovido pela nossa equipe de edi\u00e7\u00e3o.","community_disclaimer_floor8":null,"community_disclaimer_ftb90":"Este artigo foi criado por algum membro da comunidade do FTB90 e n\u00e3o foi editado ou promovido pela nossa equipe de edi\u00e7\u00e3o.","community_disclaimer_german_site":null,"community_disclaimer_ht_media":null,"community_disclaimer_swurley":"Este artigo foi criado por algum membro da comunidade do Swurley e n\u00e3o foi editado ou promovido pela nossa equipe de edi\u00e7\u00e3o.","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} usa cookies para personalizar conte\u00fado e an\u00fancios e para tornar nosso site mais f\u00e1cil de usar. Tamb\u00e9m compartilhamos algumas informa\u00e7\u00f5es com terceiros para publicidade e an\u00e1lise de dados.","cookies_consent_2":"Mais informa\u00e7\u00f5es","cookies_consent_approve":"Entendi","notf":{},"now_playing":"VENDO AGORA:","similar_articles":"Artigos relacionados"},"private_messages":{"conversation_date":"\u00daltima atualiza\u00e7\u00e3o","expand":"Expandir","header":"Mensagens","message_sent":"Sua mensagem foi enviada","messages":"Mensagens","no_history":"N\u00e3o h\u00e1 hist\u00f3ria","not_available":"Conversa\u00e7\u00e3o indispon\u00edvel","private_message":"Mensagem privada","private_message_to":"Mensagem privada para","send":"Enviar","send_failed":"O envio falhou. Desculpe, tente mais tarde.","sending":"enviando","sent":"Mensagem enviada","side_title":"Conversa\u00e7\u00f5es","title":"Entre voc\u00ea e","view_history":"Ver hist\u00f3rico de conversa\u00e7\u00e3o","write_message_here":"Escreva sua mensagem aqui"},"pundit":{"bet_via":"APOSTE COM","draw":"Empate","fan_predictions":"Palpites dos torcedores","follow_match":"Siga o Jogo","follow_pundit":"Siga Pundit","log_in":"Fa\u00e7a Login para salvar seu palpite ","not_available":"Dados n\u00e3o dispon\u00edveis no momento. Por favor, tente mais tarde.","place_your_bet":"APOSTE","place_your_bet_via":"Aposte com","prediction":"Palpite:","pundit_prediction":"Palpites de %{pundit_first_name}:","select_match":"Selecione um jogo para seu palpite","select_result":"- Selecione Resultado - ","team_to_win":"%{team} vence","title":"%{team1} vs %{team2}: dicas de apostas por %{pundit_name}","top_predictors":"MELHORES PALPITEIROS","what_result":"Acha que sabe o resultado?","what_your_prediction":"QUAL O SEU PALPITE?","your_prediction":"SEU PALPITE"},"reactions":{"campaigns_poweredby":"Oferecido Por","v1":{"lol":"Divertido","love":"Curti","must":"Leia!","noway":"N\u00e3o creio!","share":"Compartilhar ","shocked":"Chocado!","tweet":"Twittar"},"v2":{"booh":null,"cool":null,"haha":"Haha","loveit":null,"noway":null},"your_reaction":"Sua rea\u00e7\u00e3o?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"Meu artigo recebeu 100 leituras","about_you":"Sobre voc\u00ea","account":"Conta","all_info_lost":"Toda sua informa\u00e7\u00e3o no FTBpro.com ser\u00e1 perdida.","are_you_sure":"Tem certeza?","by_email":"Email","connected_as":"Conectado como","deactivate":"Desativar minha conta","deactivate_placeholder":"Por favor informe-nos porque: ","deactivate_request_sent":"Sua solicita\u00e7\u00e3o foi enviada com sucesso. Entraremos em contato em breve.","disp_name":"Nome","fb_hometown":"Cidade atual no facebook","fb_link":"Link do facebook","go_social":"Socialize - permita que seus amigos saibam o que est\u00e1 lendo","go_social_short":"Compartilhar os artigos que l\u00ed","google_plus_link":"Google + link","if_following_me":"Algu\u00e9m come\u00e7ou a me seguir","if_sending_me_message":"Algu\u00e9m me enviou uma mensagem","let_see":"Permitir que todos vejam:","my_team":"Meu time","name":{"rules":"Precisa ser \u00fanico. 5 - 50 caract\u00e9res. Use letras, n\u00fameros e tra\u00e7os"},"notifications":"Notifica\u00e7\u00f5es","optional":"opcional","privacy":"Privado","recent_articles":"Artigos recentemente compartilhados","save":"Salvar","settings":"Defini\u00e7\u00f5es","settings_saved":"Defini\u00e7\u00f5es salvas","share":"Compartilhamento autom\u00e1tico","site":"Site:","site_title":"T\u00edtulo:","site_url":"URL:","stats":"vBets estat\u00edsticas","submit":"Mandar","twitter_link":"Link do twitter:","weekly_writers_achievements":"Meu \u00edndice semanal de autores","when_notify":"Notifique me quando","your_writing_language":"Em que idioma voc\u00ea escrever\u00e1?"},"sign_up":{"about_you":"Escreva algo sobre o amor que tem ao seu time (opcional)","and":"e","change":"Sempre poder\u00e1s modificar isto em sua barra de configura\u00e7\u00f5es","disp_name":"Nome","join_12up":null,"join_90min":"Junte-se ao 90min","join_circasports":"Junte-se ao CircaSports","join_dbltap":null,"join_ei":"Junte-se ao Esporte Interativo","join_floor8":null,"join_ftb90":"Junte-se ao FTB90","join_german_site":null,"join_ht_media":null,"join_swurley":"Junte-se ao Swurley","lets_start":"Configure seu perfil","my_game":null,"my_league":"Campeonato","of_12up":null,"of_90min":"de 90min.com","of_circasports":"de Swurley.com","of_dbltap":null,"of_ei":"de esporteinterativo.com.br","of_floor8":null,"of_ftb90":"de FTB90.com","of_german_site":null,"of_ht_media":null,"privacy_policy":"Pol\u00edtica de Privacidade","required_field":"Campo requerido","team":"Meu time","terms":"Concordo com os","terms_and_conditions":"Termos & Condi\u00e7\u00f5es"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"Artigos","comments":"Coment\u00e1rios","reads":"Visualiza\u00e7\u00f5es"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"\u00daLTIMAS HIST\u00d3RIAS","latest_videos":"\u00daLTIMOS V\u00cdDEOS","read_more":"Leia mais","recommended":"RECOMENDADOS","video":"V\u00eddeo"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"vn":{"affiliates":{"log_in":"\u0110\u0103ng Nh\u1eadp "},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Li\u00ean K\u1ebft ","language":"Ng\u00f4n Ng\u1eef ","languages":{"de":"\u0110\u1ee9c","en":"Anh ","es":"T\u00e2y Ban Nha","fr":"Ph\u00e1p","hi":null,"id":"Indonesia","it":"\u00dd ","pt-BR":"B\u1ed3 \u0110\u00e0o Nha ","th":"Thai ","tr":"Th\u1ed5 Nh\u0129 K\u1ef3","vn":" Ti\u1ebfng Vi\u1ec7t"},"message":"Tin Nh\u1eafn","next":"Ti\u1ebfp Theo","prev":"Tr\u01b0\u1edbc","prompt":{},"right":{},"share":"Chia S\u1ebb","table":"B\u1ea3ng X\u1ebfp H\u1ea1ng","tweet":"Tweet","vbet":{"likes":{}},"vbets":{},"wc":{}},"date":{"abbr_day_names":["Ch\u1ee7 Nh\u1eadt","Th\u1ee9 Hai","Th\u1ee9 Ba","Th\u1ee9 T\u01b0","Th\u1ee9 N\u0103m","Th\u1ee9 S\u00e1u","Th\u1ee9 B\u1ea3y"],"abbr_month_names":[null,"Th\u00e1ng 1","Th\u00e1ng 2","Th\u00e1ng 3","Th\u00e1ng 4","Th\u00e1ng 5","Th\u00e1ng 6","Th\u00e1ng 7","Th\u00e1ng 8","Th\u00e1ng 9","Th\u00e1ng 10","Th\u00e1ng 11","Th\u00e1ng 12"],"day_names":["Ch\u1ee7 Nh\u1eadt","Th\u1ee9 Hai","Th\u1ee9 Ba","Th\u1ee9 T\u01b0","Th\u1ee9 N\u0103m","Th\u1ee9 S\u00e1u","Th\u1ee9 B\u1ea3y"],"formats":{"capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","default":"%d-%m-%Y","full_day":"%a, %e %b","long":"%d %B, %Y","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %N\u0103m","short":"%d %b","short_day_and_hour":"%a %Gi\u1edd:%Ph\u00fat","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"Th\u00e1ng 1","Th\u00e1ng 2","Th\u00e1ng 3","Th\u00e1ng 4","Th\u00e1ng 5","Th\u00e1ng 6","Th\u00e1ng 7","Th\u00e1ng 8","Th\u00e1ng 9","Th\u00e1ng 10","Th\u00e1ng 11","Th\u00e1ng 12"],"order":["ng\u00e0y","th\u00e1ng","n\u0103m"],"time_since":{"about_an_hour_ago":"Kho\u1ea3ng m\u1ed9t gi\u1edd tr\u01b0\u1edbc","about_two_hours_ago":"Kho\u1ea3ng hai gi\u1edd tr\u01b0\u1edbc","seconds_ago":"Kho\u1ea3ng v\u00e0i gi\u00e2y tr\u01b0\u1edbc","x_hours_ago":"%{count} gi\u1edd tr\u01b0\u1edbc \u0111\u00e2y ","x_minutes_ago":"%{count} ph\u00fat tr\u01b0\u1edbc \u0111\u00e2y "}},"edit_post":{"about_team":"\u0110\u1ed9i B\u00f3ng","add_caption":"Th\u00eam Ti\u00eau \u0110\u1ec1","add_content":"Th\u00eam n\u1ed9i dung v\u00e0o b\u00e0i vi\u1ebft t\u1eeb c\u00e1c ngu\u1ed3n sau: ","add_image":"Th\u00eam H\u00ecnh \u1ea2nh","add_item":"Th\u00eam t\u1eadp tin Media ","add_media":"Th\u00eam Media","add_team":"Th\u00eam \u0111\u1ed9i b\u00f3ng","additional_media":"Media Kh\u00e1c ","are_you_sure":"B\u1ea1n co ch\u1eafc r\u1eddi kh\u1ecfi trang ?","article_preview":"Xem tr\u01b0\u1edbc b\u00e0i vi\u1ebft ","attach_image":"Ch\u1ecdn H\u00ecnh ","back":"Quay L\u1ea1i ","back_to_edit":"Quay l\u1ea1i ch\u1ec9nh s\u1eeda ","back_to_editing":"Quay l\u1ea1i ch\u1ec9nh s\u1eeda ","bold_tooltip":"In \u0111\u1eadm","caption_optional":"(t\u00f9y ch\u1ecdn : t\u1ed1i \u0111a 22 k\u00ed t\u1ef1)","char_count":"S\u1ed1 L\u01b0\u1ee3ng K\u00ed T\u1ef1 : %{num}","check_grammar":"Vui l\u00f2ng ki\u1ec3m tra l\u1ed7i ch\u00ednh t\u1ea3 v\u00e0 v\u0103n ph\u1ea1m ","choose_team":"Ch\u1ecdn \u0111\u1ed9i b\u00f3ng ","clear":"X\u00f3a ","complete_steps":"B\u1ea1n c\u1ea7n ho\u00e0n th\u00e0nh c\u00e1c m\u1ee5c sau tr\u01b0\u1edbc khi \u0111\u0103ng b\u00e0i ","congrats":"Ch\u00fac m\u1eebng !","cover_image":"S\u1ebd hi\u1ec3n th\u1ecb khi b\u00e0i vi\u1ebft \u0111\u01b0\u1ee3c \u0111\u0103ng t\u1ea3i tr\u00ean trang web, m\u1ea1ng x\u00e3 h\u1ed9i hay \u1ee9ng d\u1ee5ng di \u0111\u1ed9ng","create_article":"T\u1ea1o B\u00e0i Vi\u1ebft ","crop_image":"C\u1eaft H\u00ecnh \u1ea2nh","crop_ratio":"T\u1ef7 l\u1ec7 c\u1eaft :","crop_too_small":"H\u00ecnh \u1ea3nh qu\u00e1 nh\u1ecf","date":"Ng\u00e0y :","delete":"X\u00f3a","delete_article":"X\u00f3a b\u00e0i vi\u1ebft ","discard":"H\u1ee7y B\u1ecf  ","discard_confirmation":"B\u1ea1n c\u00f3 ch\u1eafc mu\u1ed1n h\u1ee7y b\u1ecf b\u00e0i vi\u1ebft ? ","draft":"L\u01b0u ","drag":"K\u00e9o h\u00ecnh \u1ea3nh/video","drag_all":"Th\u1ea3 h\u00ecnh \u1ea3nh, video hay n\u1ed9i dung v\u00e0o \u0111\u00e2y ","drag_crop":"K\u00e9o \u0111\u1ec3 \u0111\u1ecbnh v\u1ecb ","drop_here":"Th\u1ea3 t\u1ea1i \u0111\u00e2y ","drop_image":"Th\u1ea3 h\u00ecnh \u1ea3nh t\u1ea1i \u0111\u00e2y ","edit_crop":"Di chuy\u1ec3n/thay \u0111\u1ed5i h\u00ecnh \u1ea3nh cho kh\u1edbp v\u1edbi thumbnail     ","edit_thumb":"Ch\u00ecnh s\u1eeda Thumbnail","editor":"Bi\u00ean T\u1eadp:","embed":"Ch\u00e8n","embed_code":"Ch\u00e8n M\u00e3","embed_only":"Ch\u00e8n m\u00e3 nh\u00fang t\u1ea1i \u0111\u00e2y","embed_video":"Ch\u00e8n Video","enter_desc":"Nh\u1eadp l\u1eddi gi\u1edbi thi\u1ec7u t\u1ea1i \u0111\u00e2y ...","enter_title":"Nh\u1eadp ti\u00eau \u0111\u1ec1 ","enter_url":"Nh\u1eadp URL/code","facebook_cover_image":"H\u00ecnh \u0110\u1ea1i Di\u1ec7n Facebook","ftbpro_editor":"Bi\u00ean T\u1eadp FTBpro","grammar_spelling":"Ki\u1ec3m tra l\u1ea1i l\u1ed7i ch\u00ednh t\u1ea3","great":"T\u1ed1t ! ","guide_tips":"\u0110\u1ecdc c\u00e1c h\u01b0\u1edbng d\u1eabn ","guide_tips_links":"http://www.90min.com/blog/huong-dan-seo/","h2_tooltip":"Ti\u00eau \u0111\u1ec1 ","header_edit":"Ch\u1ec9nh s\u1eeda b\u00e0i vi\u1ebft ","header_new":"B\u00e0i vi\u1ebft m\u1edbi ","hyperlink_tooltip":"Li\u00ean K\u1ebft","image_bank":"Th\u01b0 Vi\u1ec7n H\u00ecnh \u1ea2nh","image_crop":"C\u1eaft","image_format":"\u0110\u1ecbnh d\u1ea1ng h\u00ecnh \u1ea3nh l\u00e0 JPEG, PNG v\u00e0 GIF ","image_search":"T\u00ecm","image_size":"K\u00edch th\u01b0\u1edbc ph\u1ea3i l\u1edbn h\u01a1n 500x280 pixels ","image_size_parameterized":"K\u00edch th\u01b0\u1edbc ph\u1ea3i l\u1edbn h\u01a1n %{width}x%{height} pixels","image_video":"H\u00ecnh \u1ea3nh/Video","image_weight":"File n\u00e0y v\u01b0\u1ee3t qu\u00e1 k\u00edch th\u01b0\u1edbc t\u1ed1i \u0111a c\u1ee7a %{fileSizeMaxSupported}","insert_link":"D\u00e1n li\u00ean k\u1ebft t\u1ea1i \u0111\u00e2y","invalid_code":"URL/Code kh\u00f4ng h\u1ee3p l\u1ec7. Vui l\u00f2ng nh\u1eadp URL/code h\u1ee3p l\u1ec7","leave":"R\u1eddi kh\u1ecfi trang ","leave_warning":"B\u1ea1n \u0111ang r\u1eddi kh\u1ecfi trang khi kh\u00f4ng l\u01b0u tr\u1eef. T\u1ea5t c\u1ea3 thay \u0111\u1ed5i s\u1ebd b\u1ecb m\u1ea5t ! ","list_tooltip":"Danh S\u00e1ch Kh\u00f4ng Theo Th\u1ee9 T\u1ef1 ","max":"(Max %{num})","max_reached":"(gi\u1edbi h\u1ea1n t\u1ed1i \u0111a)","media_longer":"(cho b\u00e0i vi\u1ebft nhi\u1ec1u h\u01a1n 200 t\u1eeb)","media_longer_than":"(cho b\u00e0i vi\u1ebft nhi\u1ec1u h\u01a1n 300 t\u1eeb)","media_post":"\u0110\u0103ng t\u1ea3i Media ","min":"(Min %{num})","min_words":"(t\u1ed1i thi\u1ec3u %{num} t\u1eeb)","no_draft":"Kh\u00f4ng l\u01b0u b\u1ea3n th\u1ea3o","num_words":"%{count} T\u1eeb","number_list_tooltip":"Danh S\u00e1ch Th\u1ee9 T\u1ef1 ","oops":"G\u1ea7n ho\u00e0n th\u00e0nh","optimal_article":"(T\u1ed1i \u0111a 300-800)","optimal_length":"(T\u1ed1i \u0111a %{min}-%{max})","optional":"(t\u00f9y ch\u1ecdn, t\u1ed1i \u0111a 160 k\u00ed t\u1ef1)","optional_field":"L\u1eddi vi\u1ebft t\u00f9y ch\u1ecdn","or":"Ho\u1eb7c","p_tooltip":"\u0110o\u1ea1n V\u0103n","paste_embed":"D\u00e1n li\u00ean k\u1ebft hay m\u00e3 ch\u00e8n t\u1ea1i \u0111\u00e2y ","paste_url":"D\u00e1n m\u1ed9t li\u00ean k\u1ebft hay m\u00e3 nh\u00fang","playbuzz":"D\u00e1n \u0111\u01b0\u1eddng d\u1eabn b\u00e0i vi\u1ebft b\u1ea1n t\u1ea1o tr\u00ean PlayBuzz.com","polls":"Th\u00eam b\u00ecnh ch\u1ecdn","prev":"Xem tr\u01b0\u1edbc","preview":"L\u01b0u & Xem Tr\u01b0\u1edbc","publish":"\u0110\u0103ng B\u00e0i ","remove_attachment":"B\u1ea1n c\u00f3 ch\u1eafc mu\u1ed1n b\u1ecf \u0111\u00ednh k\u00e8m ? ","reset":"H\u1ee7y B\u1ecf","review":"Xem Tr\u01b0\u1edbc B\u00e0i Vi\u1ebft ","save_changes":"L\u01b0u thay \u0111\u1ed5i?","save_draft":"L\u01afU B\u1ea2N NH\u00c1P","search_bank":"Ch\u1ecdn h\u00ecnh \u1ea3nh t\u1eeb th\u01b0 vi\u1ec7n ","search_for":"T\u00ecm ki\u1ebfm","searching":"\u0110ang T\u00ecm Ki\u1ebfm ","select_photo":"Ch\u1ecdn h\u00ecnh \u1ea3nh ","seo_desc":"M\u00f4 t\u1ea3 SEO ","share":"Chia s\u1ebb b\u00e0i vi\u1ebft l\u00ean Facebook ","small_image":"H\u00ecnh \u1ea3nh qu\u00e1 nh\u1ecf. K\u00edch th\u01b0\u1edbc \u00edt nh\u1ea5t 300x150","source":"Ngu\u1ed3n:","start_at":"B\u1eaft \u0111\u1ea7u ","stay":"\u1ede l\u1ea1i trang ","steps_complete":"B\u00e0i vi\u1ebft s\u1eb5n s\u00e0ng \u0111\u0103ng t\u1ea3i ","styling_tooltip":"B\u1ecf \u0110\u1ecbnh D\u1ea1ng","tag":"Th\u1ebb","tag_at_least":"(ch\u1ecdn \u00edt nh\u1ea5t 1)","tag_sug":"Th\u1ebb G\u1ee3i \u00dd","tag_team":"Th\u1ebb","teaser":"Gi\u1edbi Thi\u1ec7u ","teaser_watermark":"L\u1eddi gi\u1edbi thi\u1ec7u xu\u1ea5t hi\u1ec7n tr\u00ean \u0111\u01b0\u1eddng li\u00ean k\u1ebft t\u1edbi b\u00e0i vi\u1ebft ","this_is_preview":"Xem tr\u01b0\u1edbc b\u00e0i vi\u1ebft ","tip_controversial ":"T\u1ea1o tranh lu\u1eadn. M\u1ed9t b\u00e0i vi\u1ebft t\u1ed1t s\u1ebd \u0111\u01b0a ra nhi\u1ec1u c\u00e2u h\u1ecfi hay.","tip_image":"Th\u00eam h\u00ecnh \u1ea3nh. B\u00e0i vi\u1ebft v\u1edbi nhi\u1ec1u h\u00ecnh \u1ea3nh s\u1ebd thu h\u00fat ng\u01b0\u1eddi \u0111\u1ecdc. ","tip_media":"C\u00f3 m\u1ed9t video hay ? Video t\u1eeb Youtube hay Metacafe t\u1ea1o n\u00ean s\u01b0 t\u01b0\u01a1ng t\u00e1c l\u1edbn ","tip_short":"Gi\u1eef b\u00e0i vi\u1ebft ng\u1eafn g\u1ecdn. Ng\u01b0\u1eddi \u0111\u1ecdc th\u01b0\u1eddng l\u01b0\u1edbt qua c\u00e1c b\u00e0i vi\u1ebft d\u00e0i ","tips":{"media_close_ups":"D\u00f9ng h\u00ecnh \u1ea3nh c\u1ea7u th\u1ee7 trong b\u00e0i vi\u1ebft","media_image_bank":"B\u1ea1n c\u00f3 th\u1ec3 s\u1eed d\u1ee5ng h\u00ecnh \u1ea3nh t\u1eeb th\u01b0 vi\u1ec7n Getty Image \u0111\u1ec3 l\u1ef1a ch\u1ecdn c\u1ea7u th\u1ee7 hay \u0111\u1ed9i b\u00f3ng   ","post_enjoy":"H\u00e3y c\u1ea3m nh\u1eadn b\u00e0i vi\u1ebft ! ","post_original":"N\u1ed9i dung sao ch\u00e9p t\u1eeb c\u00e1c ngu\u1ed3n kh\u00e1c kh\u00f4ng \u0111\u01b0\u1ee3c ch\u1ea5p nh\u1eadn ","post_paragraphs":"S\u1eed d\u1ee5ng c\u00e1c \u0111o\u1ea1n v\u0103n \u0111\u1ec3 chia nh\u1ecf b\u00e0i vi\u1ebft ","post_review":"Xem l\u1ea1i b\u00e0i vi\u1ebft tr\u01b0\u1edbc khi \u0111\u0103ng t\u1ea3i. Ki\u1ec3m tra l\u1ed7i v\u0103n ph\u1ea1m v\u00e0 ch\u00ednh t\u1ea3 ","title":"H\u01b0\u1edbng d\u1eabn \u0111\u1ec3 t\u0103ng l\u01b0\u1ee3ng \u0111\u1ecdc:","title_debatable":"S\u1eed d\u1ee5ng ng\u00f4n ng\u1eef ph\u00f3ng \u0111\u1ea1i ch\u1ee7 \u0111\u1ec1 c\u1ee7a b\u1ea1n \u0111\u1ec3 t\u1ea1o n\u00ean s\u1ef1 tranh lu\u1eadn cho ng\u01b0\u1eddi \u0111\u1ecdc ","title_known_name":"B\u1eaft \u0111\u1ea7u ti\u00eau \u0111\u1ec1 v\u1edbi t\u00ean c\u1ea7u th\u1ee7 hay \u0111\u1ed9i b\u00f3ng","title_popular_terms":"Bao g\u1ed3m c\u00e1c t\u1eeb th\u00f4ng d\u1ee5ng nh\u01b0 t\u00ean c\u1ea7u th\u1ee7, t\u00ean \u0111\u1ed9i b\u00f3ng, hay c\u00e1c ch\u1ee7 \u0111\u1ec1 n\u00f3ng ","title_question":"H\u1ecfi m\u1ed9t c\u00e2u h\u1ecfi \u0111\u01b0\u1ee3c tr\u1ea3 l\u1eddi trong b\u00e0i vi\u1ebft ","title_short":"Vi\u1ebft ng\u1eafn g\u1ecdn t\u1eeb 5-8 t\u1eeb "},"title":"Ti\u00eau \u0110\u1ec1","too_long":"Qu\u00e1 d\u00e0i (t\u1eeb 10-75 k\u00ed t\u1ef1)","too_short":"Qu\u00e1 ng\u1eafn (t\u1eeb 10-75 k\u00ed t\u1ef1)","toolong":"Qu\u00e1 d\u00e0i (t\u1eeb %{min}-%{max} k\u00ed t\u1ef1)","tooshort":"Qu\u00e1 ng\u1eafn (t\u1eeb %{min}-%{max} k\u00ed t\u1ef1)","try_again":"Th\u1eed l\u1ea1i ","upload_failed":"L\u1ed7i x\u1ea3y ra trong qu\u00e1 tr\u00ecnh \u0111\u0103ng t\u1ea3i h\u00ecnh \u1ea3nh. Vui l\u00f2ng th\u1eed l\u1ea1i ","upload_image":"\u0110\u0103ng T\u1ea3i H\u00ecnh \u1ea2nh","upload_img":"\u0110\u0103ng T\u1ea3i H\u00ecnh \u1ea2nh","valid_code":"B\u1ea1n ch\u00e8n \u0111o\u1ea1n m\u00e3 kh\u00f4ng h\u1ee3p l\u1ec7 ","video":"Video","video_provider":"Hi\u1ec7n t\u1ea1i kh\u00f4ng h\u1ed7 tr\u1ee3 d\u1ecbch v\u1ee5 cung c\u1ea5p video n\u00e0y ","video_services":"Ch\u00e8n video t\u1eeb YouTube, Dailymotion hay Metacafe ","video_url":"Li\u00ean k\u1ebft Video (Yotube, Dailymotion, Metacafe ...)","word_count":"S\u1ed1 L\u01b0\u1ee3ng T\u1eeb : %{num}","writing_sug":"G\u1ee3i \u00dd SEO ","writing_tips":"G\u1ee3i \u00fd \u0111\u1ec3 vi\u1ebft t\u1ed1t h\u01a1n ","your_post":"B\u00e0i Vi\u1ebft "},"embed":{"button":"Ch\u00e8n","dialogue":{"additional_options":"C\u00e1c l\u1ef1a ch\u1ecdn kh\u00e1c","become_a_partner":"LI\u00caN H\u1ec6 H\u1ee2P T\u00c1C ","comments":"Hi\u1ec3n th\u1ecb b\u00ecnh lu\u1eadn","customise_collapse/expand":"\u0110i\u1ec1u ch\u1ec9nh m\u00e3 ","disclaimer":"B\u1ea1n \u0111\u1ed3ng \u00fd c\u00e1c %{terms_conditions} khi ch\u00e8n \u0111o\u1ea1n m\u00e3 ","embed_code":"Ch\u00e8n \u0111o\u1ea1n m\u00e3 ","embed_instructions":"Ch\u00e9p v\u00e0 d\u00e1n \u0111o\u1ea1n m\u00e3 HTML b\u00ean d\u01b0\u1edbi khi th\u00eam b\u00e0i vi\u1ebft v\u00e0o trang web c\u1ee7a b\u1ea1n","embed_instructions_partners":"Sao ch\u00e9p v\u00e0 d\u00e1n \u0111o\u1ea1n m\u00e3 c\u1ee7a b\u1ea1n b\u00ean d\u01b0\u1edbi ","full_title":"Ti\u00eau \u0111\u1ec1 \u0111\u1ea7y \u0111\u1ee7 ","header":"CH\u00c8N B\u00c0I VI\u1ebeT","info":"B\u1ecf ch\u1ecdn li\u00ean k\u1ebft 90min ch\u1ec9 d\u00e0nh cho c\u00e1c \u0111\u1ed1i t\u00e1c ","link":"Hi\u1ec3n th\u1ecb li\u00ean k\u1ebft \u0111\u1ebfn 90min","logged_in":"Li\u00ean h\u1ec7 %{email} \u0111\u1ec3 tham gia c\u00e1c ch\u01b0\u01a1ng tr\u00ecnh h\u1ee3p t\u00e1c","login":"\u0110\u0103ng nh\u1eadp","partner_message":"\u0110\u00e3 l\u00e0 th\u00e0nh vi\u00ean ? %{login} \u0111\u1ec3 nh\u1eadn \u0111i\u1ec1u ch\u1ec9nh m\u00e3 ","remove_title":"B\u1ecf ti\u00eau \u0111\u1ec1","show-author":"Hi\u1ec3n th\u1ecb ng\u01b0\u1eddi vi\u1ebft ","show-date":"Hi\u1ec3n th\u1ecb ng\u00e0y","show-reads-counter":"Hi\u1ec3n th\u1ecb s\u1ed1 l\u01b0\u1ee3t xem","show-title":"Hi\u1ec3n th\u1ecb ti\u00eau \u0111\u1ec1 ","terms_&_conditions":"\u0110i\u1ec1u Kho\u1ea3n & \u0110i\u1ec1u Ki\u1ec7n","title":"Ti\u00eau \u0111\u1ec1","views":"Hi\u1ec3n th\u1ecb s\u1ed1 l\u01b0\u1ee3t xem"}},"errors":{"200_pixels":"H\u00ecnh \u1ea3nh ph\u1ea3i t\u1ed1i thi\u1ec3u 200x200 pixel","file_too_big":"T\u1eadp tin \u0111\u0103ng t\u1ea3i qu\u00e1 n\u1eb7ng","flash":"B\u1ea1n ph\u1ea3i c\u00e0i \u0111\u1eb7t \u1ee9ng d\u1ee5ng Adobe Flash \u0111\u1ec3 s\u1eed d\u1ee5ng ch\u1ee9c n\u0103ng ","format":"%{attribute} %{message}","invalid_filetype":"T\u1eadp tin kh\u00f4ng h\u1ee3p l\u1ec7 (h\u1ed7 tr\u1ee3 .gif, .jpg, .jpeg, .png)","invalid_url":"\u0110\u01b0\u1eddng li\u00ean k\u1ebft kh\u00f4ng h\u1ee3p l\u1ec7 ","messages":{"accepted":"ph\u1ea3i \u0111\u01b0\u1ee3c \u0111\u1ed3ng \u00fd","blank":"kh\u00f4ng th\u1ec3 \u0111\u1ec3 tr\u1eafng","confirmation":"kh\u00f4ng kh\u1edbp v\u1edbi x\u00e1c nh\u1eadn","empty":"kh\u00f4ng th\u1ec3 r\u1ed7ng","equal_to":"ph\u1ea3i b\u1eb1ng %{count}","even":"ph\u1ea3i l\u00e0 s\u1ed1 ch\u1eb5n","exclusion":"\u0111\u00e3 \u0111\u01b0\u1ee3c gi\u00e0nh tr\u01b0\u1edbc","greater_than":"ph\u1ea3i l\u1edbn h\u01a1n %{count}","greater_than_or_equal_to":"ph\u1ea3i l\u1edbn h\u01a1n ho\u1eb7c b\u1eb1ng %{count}","inclusion":"kh\u00f4ng c\u00f3 trong danh s\u00e1ch","invalid":"kh\u00f4ng h\u1ee3p l\u1ec7","less_than":"ph\u1ea3i nh\u1ecf h\u01a1n %{count}","less_than_or_equal_to":"ph\u1ea3i nh\u1ecf h\u01a1n ho\u1eb7c b\u1eb1ng %{count}","not_a_number":"kh\u00f4ng ph\u1ea3i l\u00e0 s\u1ed1","not_an_integer":"ph\u1ea3i l\u00e0 m\u1ed9t s\u1ed1 nguy\u00ean","odd":"ph\u1ea3i l\u00e0 s\u1ed1 l\u1ebb","record_invalid":"L\u1ed7i x\u00e1c nh\u1eadn: %{errors}","taken":"\u0111\u00e3 c\u00f3","too_long":"qu\u00e1 d\u00e0i (t\u1ed1i \u0111a %{count} k\u00fd t\u1ef1)","too_short":"qu\u00e1 ng\u1eafn (t\u1ed1i thi\u1ec3u %{count} k\u00fd t\u1ef1)","wrong_length":"\u0111\u1ed9 d\u00e0i kh\u00f4ng \u0111\u00fang (ph\u1ea3i l\u00e0 %{count} k\u00fd t\u1ef1)"},"mobile_error":"Video kh\u00f4ng th\u1ec3 hi\u1ec3n th\u1ecb tr\u00ean thi\u1ebft b\u1ecb di \u0111\u1ed9ng","motto":{"title":"Vui l\u00f2ng nh\u1eadp 10-25 k\u00ed t\u1ef1"},"nick":{"duplicate":"T\u00ean \u0111\u0103ng nh\u1eadp \u0111\u00e3 \u0111\u01b0\u1ee3c s\u1eed d\u1ee5ng","length":"T\u00ean \u0111\u0103ng nh\u1eadp ph\u1ea3i t\u1eeb 5-50 k\u00ed t\u1ef1","title":"S\u1eed d\u1ee5ng k\u00ed t\u1ef1, ch\u1eef s\u1ed1, d\u1ea5u ch\u1ea5m v\u00e0 d\u1ea5u g\u1ea1ch ngang  ","validation":"T\u00ean hi\u1ec3n th\u1ecb ph\u1ea3i t\u1eeb 5-50 k\u00ed t\u1ef1 - ch\u1eef c\u00e1i, ch\u1eef s\u1ed1, d\u1ea5u ch\u1ea5m v\u00e0 d\u1ea5u g\u1ea1ch ngang. "},"no_file":"Kh\u00f4ng c\u00f3 t\u1eadp tin \u0111\u01b0\u1ee3c ch\u1ecdn","not_found":"Ch\u00fang t\u00f4i kh\u00f4ng t\u00ecm th\u1ea5y trang n\u00e0y","one_team":"Ph\u1ea3i g\u1eafn \u00edt nh\u1ea5t m\u1ed9t \u0111\u1ed9i b\u00f3ng  ","pic_size":"K\u00edch th\u01b0\u1edbc h\u00ecnh \u1ea3nh ph\u1ea3i t\u1eeb %{min} and %{max}","ratio_alert":"T\u1ec9 l\u1ec7 h\u00ecnh \u1ea3nh ph\u1ea3i gi\u1eefa 1:2 v\u00e0 2:1","return_homepage":"V\u1ec1 l\u1ea1i trang ch\u1ee7","select_image":"B\u1ea1n ph\u1ea3i ch\u1ecdn m\u1ed9t h\u00ecnh \u1ea3nh \u0111\u1ec3 \u0111\u0103ng t\u1ea3i ","sorry":"XIN L\u1ed6I","subject_id":{"require_fanship":"B\u1ea1n ph\u1ea3i tr\u1edf th\u00e0nh fan ! "},"template":{"body":"C\u00f3 l\u1ed7i v\u1edbi c\u00e1c m\u1ee5c sau:","header":{"one":"1 l\u1ed7i ng\u0103n kh\u00f4ng cho l\u01b0u %{model} n\u00e0y","other":"%{count} l\u1ed7i ng\u0103n kh\u00f4ng cho l\u01b0u %{model} n\u00e0y"}},"text":{"duplicate_comment":"B\u00ecnh lu\u1eadn l\u1eb7p l\u1ea1i ","duplicate_post":"B\u00e0i vi\u1ebft l\u1eb7p l\u1ea1i ","max_char":"K\u00ed t\u1ef1 %{num_chars} t\u1ed1i \u0111a ","max_words":"T\u1eeb %{num_words} t\u1ed1i \u0111a ","min_char":"K\u00ed t\u1ef1 %{num_chars} t\u1ed1i thi\u1ec3u "},"twitter_url":{"invalid":"\u0110\u01b0\u1eddng d\u1eabn Twitter kh\u00f4ng h\u1ee3p l\u1ec7 "},"unknown_upload":"L\u1ed7i \u0111\u0103ng t\u1ea3i x\u1ea3y ra, vui l\u00f2ng li\u00ean h\u1ec7 FTBpro","unsupported_video":"M\u00e3 ch\u00e8n video kh\u00f4ng \u0111\u01b0\u1ee3c h\u1ed7 tr\u1ee3 b\u1edfi trang web ","url_err":"L\u1ed7i kh\u00f4ng x\u00e1c \u0111\u1ecbnh (\u0111\u01b0\u1eddng d\u1eabn sai ?), vui l\u00f2ng li\u00ean h\u1ec7 ng\u01b0\u1eddi qu\u1ea3n l\u00fd ","website":{"blank":"Vui l\u00f2ng nh\u1eadp \u0111\u01b0\u1eddng d\u1eabn trang web "}},"footer":{"about_12up":null,"about_90min":"V\u1ec1 90min","about_circasports":"V\u1ec1 CircaSports","about_dbltap":null,"about_ei":null,"about_floor8":null,"about_ftb90":"V\u1ec1 FTB90","about_ftbpro":"V\u1ec1","about_german_site":null,"about_ht_media":null,"about_pluralist":null,"about_swurley":"V\u1ec1 Swurley","about_theduel":null,"affiliates":"H\u1ed9i Vi\u00ean ","apps":"\u1ee8ng D\u1ee5ng Di \u0110\u1ed9ng","apps_Android":"B\u1eaeT \u0110\u1ea6U S\u1eec D\u1ee4NG ","apps_iphone":"C\u00d3 S\u1eb4N TR\u00caN ","blog":"Blog","boomerang":null,"cartoon":null,"contact_ftbpro":"Li\u00ean H\u1ec7","fan_store":"D\u00e0nh Ri\u00eang Cho Fan ","faq":"H\u1ecfi \u0110\u00e1p","house_rules":"Lu\u1eadt L\u1ec7","in_the_news":"Tin T\u1ee9c","jobs":"C\u00f4ng Vi\u1ec7c","licensing":"B\u1ea3n Quy\u1ec1n","links":"Li\u00ean K\u1ebft","links_social":"Li\u00ean K\u1ebft ","more_about_12up":null,"more_about_90min":"Xem th\u00eam v\u1ec1 90min","more_about_circasports":"Xem th\u00eam v\u1ec1 CircaSports","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":null,"more_about_ftb90":"Xem th\u00eam v\u1ec1 FTB90","more_about_german_site":null,"more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"Xem th\u00eam v\u1ec1 Swurley","more_about_theduel":null,"partner_sites":null,"partners":"\u0110\u1ed1i T\u00e1c","prev_prog":null,"privacy_policy":"Ch\u00ednh S\u00e1ch Ri\u00eang T\u01b0","rights_reserved":"B\u1ea3n quy\u1ec1n \u0111\u0103ng k\u00fd","rights_reserved_year":"2016 FTBpro @ B\u1ea3n quy\u1ec1n \u0111\u0103ng k\u00fd","rights_reserved_year_12up":null,"rights_reserved_year_90min":"Minute Media 2019 90min @ B\u1ea3n quy\u1ec1n \u0111\u0103ng k\u00fd","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports @ B\u1ea3n quy\u1ec1n \u0111\u0103ng k\u00fd","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"Minute Media 2018 FTB90 @ B\u1ea3n quy\u1ec1n \u0111\u0103ng k\u00fd","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"2016 Swurley @ B\u1ea3n quy\u1ec1n \u0111\u0103ng k\u00fd","rights_reserved_year_theduel":null,"space":null,"statistics_12up":null,"statistics_90min":"Th\u1ed1ng K\u00ea 90min","statistics_circasports":"Th\u1ed1ng K\u00ea CircaSports","statistics_ei":null,"statistics_floor8":null,"statistics_ftb90":"Th\u1ed1ng K\u00ea FTB90","statistics_ht_media":null,"statistics_swurley":"Th\u1ed1ng K\u00ea Swurley","statistics_theduel":null,"stats":{"articles":"B\u00e0i Vi\u1ebft ","fans":"Fans","members":"Th\u00e0nh Vi\u00ean","writers":"C\u00e2y Vi\u1ebft "},"support":"H\u1ed7 tr\u1ee3","tbs":null,"tcm":null,"terms":"\u0110i\u1ec1u L\u1ec7 ","terms_conditions":"\u0110i\u1ec1u Ki\u1ec7n & \u0110i\u1ec1u L\u1ec7","tnt":null,"warner":null,"writers":"C\u00e2y Vi\u1ebft "},"header":{"profile":"Th\u00f4ng Tin C\u1ee7a T\u00f4i","settings":"C\u00e0i \u0110\u1eb7t ","signout":"\u0110\u0103ng Xu\u1ea5t"},"helpers":{"label":{"some_event":{}},"select":{},"submit":{}},"home":{"no_matches":"Kh\u00f4ng c\u00f3 tr\u1eadn \u0111\u1ea5u s\u1eafp t\u1edbi "},"homepage":{"be_the_first":"L\u00c0 NG\u01af\u1edcI XEM \u0110\u1ea6U TI\u00caN!","by":"B\u1edfi:","chrome_notifications":"C\u1eadp nh\u1eadt li\u00ean t\u1ee5c v\u1edbi th\u00f4ng b\u00e1o t\u1eeb Chrome","ei":{"latest_news":null,"trending":null,"view_more":null},"fan_perspectives":"M\u1ee5c L\u1ee5c Chi Ti\u1ebft","fan_voice":"TI\u1ebeNG N\u00d3I NG\u01af\u1edcI H\u00c2M M\u1ed8","featured_topic":null,"fixtures_and_scores":"L\u1ecbch Thi \u0110\u1ea5u v\u00e0 T\u1ec9 S\u1ed1","fixtures_scores":"Lich Thi \u0110\u1ea5u & T\u1ec9 S\u1ed1","follow_us_on":"Theo d\u00f5i ch\u00fang t\u00f4i tr\u00ean Snapchat\n","latest_videos":"Video M\u1edbi Nh\u1ea5t","league_page":"Ngo\u1ea1i h\u1ea1ng Anh","match_day":"Ng\u00e0y Thi \u0110\u1ea5u %{num}","month":"%M","more":"Th\u00eam","most_read":"Xem Nhi\u1ec1u Nh\u1ea5t","no_matches":"Kh\u00f4ng C\u00f3 Tr\u1eadn \u0110\u1ea5u N\u00e0o H\u00f4m Nay","other_categories":"M\u1ee4C KH\u00c1C","our_categories":"TH\u1ec2 LO\u1ea0I","read_now":"\u0110\u1eccC NGAY","schedule":"L\u1ecaCH THI \u0110\u1ea4U","scores_page_desc":"To\u00e0n b\u1ed9 l\u1ecbch thi \u0111\u1ea5u m\u1edbi nh\u1ea5t v\u00e0 k\u1ebft qu\u1ea3","scores_page_title":"L\u1ecbch Thi \u0110\u1ea5u & k\u1ebft qu\u1ea3","social_text":"Tin T\u1ee9c M\u1edbi Nh\u1ea5t","stay_up_to":"C\u1eadp nh\u1eadt v\u1edbi nh\u1eefng tin t\u1ee9c m\u1edbi nh\u1ea5t","top_stories":"B\u00e0i H\u00e0ng \u0110\u1ea7u","trending":null,"trending_floor8":null,"video":"Video","videos":"Video","view_all":"Xem T\u1ea5t C\u1ea3 C\u00e1c Tr\u1eadn \u0110\u1ea5u","view_more":"Xem Th\u00eam","watch_more_videos":"Xem Th\u00eam Videos","watch_tv_12up":null,"watch_tv_90min":"THEO D\u00d5I 90MIN TV","watch_tv_circasports":"THEO D\u00d5I CIRCA SPORTS TV","watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":null,"watch_tv_german_site":null,"watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"Qu\u1ea3ng C\u00e1o","bet_now":"C\u01b0\u1ee3c Ngay","by":"B\u1edfi ","by_betway":null,"community_content":"N\u1ed9i Dung C\u1ed9ng \u0110\u1ed3ng","community_disclaimer":"B\u00e0i vi\u1ebft \u0111\u01b0\u1ee3c t\u1ea1o ra b\u1edfi th\u00e0nh vi\u00ean c\u1ee7a c\u1ed9ng \u0111\u1ed3ng 90min v\u00e0 ch\u01b0a \u0111\u01b0\u1ee3c duy\u1ec7t qua b\u1edfi ban bi\u00ean t\u1eadp ","community_disclaimer_12up":null,"community_disclaimer_90min":"B\u00e0i vi\u1ebft \u0111\u01b0\u1ee3c t\u1ea1o ra b\u1edfi th\u00e0nh vi\u00ean c\u1ee7a c\u1ed9ng \u0111\u1ed3ng 90min v\u00e0 ch\u01b0a \u0111\u01b0\u1ee3c duy\u1ec7t qua b\u1edfi ban bi\u00ean t\u1eadp","community_disclaimer_circasports":"B\u00e0i vi\u1ebft \u0111\u01b0\u1ee3c t\u1ea1o ra b\u1edfi th\u00e0nh vi\u00ean c\u1ee7a c\u1ed9ng \u0111\u1ed3ng CircaSports v\u00e0 ch\u01b0a \u0111\u01b0\u1ee3c duy\u1ec7t qua b\u1edfi ban bi\u00ean t\u1eadp","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":null,"community_disclaimer_ftb90":"B\u00e0i vi\u1ebft \u0111\u01b0\u1ee3c t\u1ea1o ra b\u1edfi th\u00e0nh vi\u00ean c\u1ee7a c\u1ed9ng \u0111\u1ed3ng FTB90 v\u00e0 ch\u01b0a \u0111\u01b0\u1ee3c duy\u1ec7t qua b\u1edfi ban bi\u00ean t\u1eadp","community_disclaimer_german_site":null,"community_disclaimer_ht_media":null,"community_disclaimer_swurley":"B\u00e0i vi\u1ebft \u0111\u01b0\u1ee3c t\u1ea1o ra b\u1edfi th\u00e0nh vi\u00ean c\u1ee7a c\u1ed9ng \u0111\u1ed3ng Swurley v\u00e0 ch\u01b0a \u0111\u01b0\u1ee3c duy\u1ec7t qua b\u1edfi ban bi\u00ean t\u1eadp","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} d\u00f9ng cookies \u0111\u1ec3 c\u00e1 nh\u00e2n h\u00f3a n\u1ed9i dung, \u0111i\u1ec1u ch\u1ec9nh qu\u1ea3ng c\u00e1o v\u00e0 cung c\u1ea5p tr\u1ea3i nghi\u1ec7m d\u1ec5 d\u00e0ng h\u01a1n cho b\u1ea1n \u0111\u1ecdc. Ch\u00fang t\u00f4i c\u0169ng chia s\u1ebb th\u00f4ng tin v\u1edbi c\u00e1c b\u00ean th\u1ee9 ba \u0111\u1ec3 qu\u1ea3ng c\u00e1o v\u00e0 ph\u00e2n t\u00edch.","cookies_consent_2":"Th\u00eam th\u00f4ng tin","cookies_consent_approve":"\u0110\u00e3 hi\u1ec3u!","notf":{},"now_playing":"THEO D\u00d5I","similar_articles":"B\u00e0i Vi\u1ebft Li\u00ean Quan"},"private_messages":{"conversation_date":"C\u1eadp nh\u1eadt g\u1ea7n nh\u1ea5t : ","expand":"M\u1edf r\u1ed9ng ","header":"H\u1ed9p th\u01b0 ","message_sent":"Tin nh\u1eafn \u0111\u00e3 \u0111\u01b0\u1ee3c g\u1eedi ","messages":"Tin nh\u1eafn ","no_history":"Kh\u00f4ng c\u00f3 l\u1ecbch s\u1eed ","not_available":"Tr\u00f2 chuy\u1ec7n kh\u00f4ng c\u00f3 s\u1eb5n ","private_message":"Tin nh\u1eafn ri\u00eang","private_message_to":"Tin nh\u1eafn ri\u00eang \u0111\u1ebfn ","send":"G\u1eedi ","send_failed":"G\u1eedi kh\u00f4ng th\u00e0nh c\u00f4ng. Vui l\u00f2ng th\u1eed l\u1ea1i sau","sending":"\u0111ang g\u1eedi ","sent":"Tin nh\u1eafn \u0111\u00e3 g\u1eedi ","side_title":"Tr\u00f2 Chuy\u1ec7n","title":"Gi\u1eefa b\u1ea1n v\u00e0 ","view_history":"Xem l\u1ecbch s\u1eed tr\u00f2 chuy\u1ec7n ","write_message_here":"Vi\u1ebft tin nh\u1eafn t\u1ea1i \u0111\u00e2y"},"pundit":{"bet_via":"\u0110\u1eb6T C\u01af\u1ee2C B\u1edeI ","draw":"H\u00f2a","fan_predictions":"Fan D\u1ef1 \u0110o\u00e1n ","follow_match":"Theo D\u00f5i Tr\u1eadn \u0110\u1ea5u ","follow_pundit":"Theo D\u00f5i Chuy\u00ean Gia ","log_in":"\u0110\u0103ng nh\u1eadp \u0111\u1ec3 l\u01b0u d\u1ef1 \u0111o\u00e1n c\u1ee7a b\u1ea1n","not_available":"Th\u1ed1ng k\u00ea kh\u00f4ng c\u00f3 s\u1eb5n. Vui l\u00f2ng th\u1eed l\u1ea1i ","place_your_bet":"\u0110\u1eb6T C\u01af\u1ee2C C\u1ee6A B\u1ea0N: ","place_your_bet_via":"\u0110\u1eb7t C\u01b0\u1ee3c B\u1edfi ","prediction":"D\u1ef1 \u0111o\u00e1n ","pundit_prediction":"%{pundit_first_name} D\u1ef1 \u0110o\u00e1n:","select_match":"Ch\u1ecdn Tr\u1eadn \u0110\u1ea5u B\u1ea1n D\u1ef1 \u0110o\u00e1n","select_result":"-Ch\u1ecdn K\u1ebft Qu\u1ea3-","team_to_win":"%{team} chi\u1ebfn th\u1eafng","title":"%{team1} vs %{team2}: tip c\u00e1 c\u01b0\u1ee3c b\u1edfi %{pundit_name}","top_predictors":"NH\u00c0 D\u1ef0 \u0110O\u00c1N H\u00c0NG \u0110\u1ea6U","what_result":"B\u1ea1n c\u00f3 ngh\u0129 \u0111\u00e3 bi\u1ebft k\u1ebft qu\u1ea3?","what_your_prediction":"D\u1ef0 \u0110O\u00c1N C\u1ee6A B\u1ea0N ? ","your_prediction":"D\u1ef0 \u0110O\u00c1N C\u1ee6A B\u1ea0N:"},"reactions":{"campaigns_poweredby":null,"v1":{"lol":"LOL","love":"R\u1ea5t Th\u00edch","must":"\u0110\u1ecdc Ngay","noway":"Gh\u00e9t","share":"Chia S\u1ebb ","shocked":"Ng\u1ea1c Nhi\u00ean","tweet":"Tweet"},"v2":{"booh":null,"cool":null,"haha":"Haha","loveit":null,"noway":null},"your_reaction":"B\u1ea1n th\u1ea5y th\u1ebf n\u00e0o?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"B\u00e0i vi\u1ebft nh\u1eadn \u0111\u01b0\u1ee3c 100 l\u01b0\u1ee3t \u0111\u1ecdc ","about_you":"V\u1ec1 B\u1ea1n","account":"T\u00e0i Kho\u1ea3n ","all_info_lost":"T\u1ea5t c\u1ea3 th\u00f4ng tin c\u1ee7a b\u1ea1n tr\u00ean FTBpro.com s\u1ebd t\u1ea1m th\u1eddi m\u1ea5t ","are_you_sure":"B\u1ea1n c\u00f3 ch\u1eafc ? ","by_email":"Email ","connected_as":"Li\u00ean k\u1ebft nh\u01b0 ","deactivate":"Kh\u00f3a t\u00e0i kho\u1ea3n c\u1ee7a t\u00f4i ","deactivate_placeholder":"Vui l\u00f2ng cho bi\u1ebft l\u00fd do :","deactivate_request_sent":"Y\u00eau c\u1ea7u c\u1ee7a b\u1ea1n \u0111\u01b0\u1ee3c x\u00e1c nh\u1eadn th\u00e0nh c\u00f4ng. Ch\u00fang t\u00f4i s\u1ebd s\u1edbm li\u00ean h\u1ec7 v\u1edbi b\u1ea1n ","disp_name":"T\u00ean Hi\u1ec3n Th\u1ecb ","fb_hometown":"N\u01a1i \u1edf t\u1eeb Facebook ","fb_link":"Li\u00ean k\u1ebft Facebook ","go_social":"Giao l\u01b0u m\u1ea1ng x\u00e3 h\u1ed9i - \u0111\u1ec3 m\u1ecdi ng\u01b0\u1eddi bi\u1ebft \u0111\u1ebfn t\u00e0i n\u0103ng c\u1ee7a b\u1ea1n  ","go_social_short":"Chia s\u1ebb b\u00e0i vi\u1ebft c\u1ee7a t\u00f4i ","google_plus_link":"Li\u00ean k\u1ebft Google+","if_following_me":"Ai \u0111ang theo d\u00f5i t\u00f4i ","if_sending_me_message":"Ai g\u1eedi tin nh\u1eafn \u0111\u1ebfn t\u00f4i ","let_see":"\u0110\u1ec3 m\u1ecdi ng\u01b0\u1eddi th\u1ea5y : ","my_team":"\u0110\u1ed9i B\u00f3ng C\u1ee7a T\u00f4i ","name":{"rules":"Ph\u1ea3i t\u1eeb 5 - 50 k\u00ed t\u1ef1. S\u1eed d\u1ee5ng ch\u1eef c\u00e1i, s\u1ed1 v\u00e0 d\u1ea5u g\u1ea1ch ngang "},"notifications":"Th\u00f4ng B\u00e1o","optional":"t\u00f9y ch\u1ecdn","privacy":"Ri\u00eang T\u01b0","recent_articles":"B\u00e0i vi\u1ebft chia s\u1ebb g\u1ea7n \u0111\u00e2y ","save":"L\u01b0u ","settings":"C\u00e0i \u0110\u1eb7t ","settings_saved":"L\u01b0u C\u00e0i \u0110\u1eb7t ","share":"Chia S\u1ebb T\u1ef1 \u0110\u1ed9ng ","site":"Trang:","site_title":"Ti\u00eau \u0110\u1ec1 :","site_url":"\u0110\u01b0\u1eddng d\u1eabn :","stats":"D\u1eef li\u1ec7u vBet","submit":"X\u00e1c Nh\u1eadn","twitter_link":"\u0110\u01b0\u1eddng d\u1eabn Twitter ","weekly_writers_achievements":"T\u1ed5ng k\u1ebft b\u00e0i vi\u1ebft h\u00e0ng tu\u1ea7n ","when_notify":"Th\u00f4ng b\u00e1o cho t\u00f4i khi ","your_writing_language":"B\u1ea1n ch\u1ecdn ng\u00f4n ng\u1eef n\u00e0o \u0111\u1ebf vi\u1ebft b\u00e0i ?"},"sign_up":{"about_you":"Vi\u1ebft v\u1ec1 \u0111\u1ed9i h\u00ecnh y\u00eau th\u00edch (t\u00f9y ch\u1ecdn) ","and":"v\u00e0","change":"B\u1ea1n c\u00f3 th\u1ec3 thay \u0111\u1ed5i trong ph\u1ea7n c\u00e0i \u0111\u1eb7t  ","disp_name":"T\u00ean Hi\u1ec3n Th\u1ecb","join_12up":null,"join_90min":"Tham gia 90min","join_circasports":"Tham gia CircaSports","join_dbltap":null,"join_ei":null,"join_floor8":null,"join_ftb90":"Tham gia FTB90","join_german_site":"Tham gia 90min","join_ht_media":null,"join_swurley":"Tham gia Swurley","lets_start":"B\u1eaft \u0111\u1ea7u \u0111\u0103ng k\u00fd","my_game":"Game","my_league":"Gi\u1ea3i \u0110\u1ea5u ","of_12up":null,"of_90min":"c\u1ee7a 90min.com","of_circasports":"c\u1ee7a Swurley.com","of_dbltap":null,"of_ei":null,"of_floor8":null,"of_ftb90":"c\u1ee7a FTB90.com","of_german_site":null,"of_ht_media":null,"privacy_policy":"Ch\u00ednh S\u00e1ch Ri\u00eang T\u01b0","required_field":"Tr\u01b0\u1eddng b\u1eaft bu\u1ed9c ","team":"\u0110\u1ed9i B\u00f3ng C\u1ee7a T\u00f4i ","terms":"T\u00f4i \u0111\u1ed3ng \u00fd v\u1edbi ","terms_and_conditions":"\u0110i\u1ec1u Kho\u1ea3n & \u0110i\u1ec1u Ki\u1ec7n "},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"B\u00e0i Vi\u1ebft","comments":"B\u00ecnh Lu\u1eadn","reads":"L\u01b0\u1ee3t Xem"},"suicidesquad":{"reactions":{"v2":{}}},"time":{"formats":{"capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","default":"%a, %d %b %Y %H:%M:%S %z","full_day":"%a, %e %b","hour_minute":"%H:%M","long":"%d %B, %Y %H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short":"%d %b %H:%M","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"tv_template":{"latest_stories":"B\u00e0i M\u1edbi Nh\u1ea5t","latest_videos":"Video M\u1edbi Nh\u1ea5t","read_more":"Xem Th\u00eam","recommended":"\u0110\u1ec0 XU\u1ea4T","video":"Video"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"id":{"date":{"abbr_day_names":["Min","Sen","Sel","Rab","Kam","Jum","Sab"],"abbr_month_names":[null,"Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"],"day_names":["Minggu","Senin","Selasa","Rabu","Kamis","Jum'at","Sabtu"],"formats":{"default":"%d %B %Y","long":"%A, %d %B %Y","short":"%d.%m.%Y","capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],"order":["day","month","year"],"time_since":{"about_an_hour_ago":"Sekitar satu jam yang lalu","about_two_hours_ago":"Sekitar dua jam yang lalu","seconds_ago":"Beberapa detik yang lalu","x_hours_ago":"%{count} jam yang lalu","x_minutes_ago":"%{count} menit yang lalu"}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"harus diterima","blank":"tidak bisa kosong","confirmation":"tidak sesuai dengan konfirmasi","empty":"tidak bisa kosong","equal_to":"harus sama dengan %{count}","even":"Harus seimbang","exclusion":"sudah dipesan","greater_than":"harus lebih besar dari %{count}","greater_than_or_equal_to":"harus sama atau lebih besar dari %{count}","inclusion":"tidak termasuk didalam list","invalid":"tidak valid","less_than":"harus lebih kecil dari %{count}","less_than_or_equal_to":"harus sama atau lebih kecil dari %{count}","not_a_number":"bukan angka","odd":"harus ganjil","record_invalid":"Verifikasi gagal: %{errors}","taken":"telah diambil","too_long":"terlalu panjang (maksimum %{count} karakter)","too_short":"terlalu pendek (minimum %{count} karakter)","wrong_length":"jumlah karakter salah (seharusnya %{count} karakter)","not_an_integer":"harus bilangan yang bulat"},"template":{"body":"Ada masalah dengan bagian berikut:","header":{"one":"1 kesalahan mengakibatkan %{model} ini tidak bisa disimpan","other":"%{count} kesalahan mengakibatkan %{model} ini tidak bisa disimpan"}},"200_pixels":"Gambar harus kurang lebih 200x200 pixels","file_too_big":"File yang di upload terlalu besar.","flash":"Anda harus memasang Adobe Flash untuk menggunakan fitur ini","invalid_filetype":"Tipe file tidak valid (kita mendukung .gif, .jpg, .Jpeg and .png)","invalid_url":"URL tidak valid","mobile_error":"Video ini tidak bisa diputar dalam perangkat mobile","motto":{"title":"Silahkan masukan 10-25 karakter"},"nick":{"duplicate":"Nama akun telah digunakan","length":"Nama akun harus antara 5-50 karakter.","title":"Hanya gunakan huruf, angka, titik, dan strip","validation":"Tampilan nama anda harus terdiri dari 5-50 karakter - yang terdiri dari huruf, angka, titik, dan strip. "},"no_file":"Tidak ada file yang dipilih","not_found":"Kami tidak bisa menemukan halaman yang Anda cari","one_team":"Harus menetapkan paling tidak satu tim","pic_size":"Ukuran file gambar harus antara %{min} and %{max}","ratio_alert":"Rasio gambar harus antara 1:2 dan 2:1","return_homepage":"Kembali ke halaman utama","select_image":"Anda harus memilih sebuah gambar untuk diupload","sorry":"MAAF","subject_id":{"require_fanship":"Fanship itu harus!"},"text":{"duplicate_comment":"Duplikat komentar","duplicate_post":"Duplikat post","max_char":"Maksimum %{num_chars} characters","max_words":"Maksimum %{num_words} words","min_char":"Minimum %{num_chars} characters"},"twitter_url":{"invalid":"URL Twitter tidak valid"},"unknown_upload":"Upload eror yang tidak diketahui telah terjadi, silahkan menghubungi layanan pemeliharaan","unsupported_video":"Maaf, kita tidak mendukung video yang terdapat pada situs tersebut","url_err":"Eror tidak diketahui (pengejaan URL yang salah?), silahkan kontak moderator","website":{"blank":"Silahkan masukan URL situs"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%a, %d %b %Y %H.%M.%S %z","long":"%d %B %Y %H.%M","short":"%d %b %H.%M","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"Masuk"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"Connect","language":"Bahasa","languages":{"de":"Jerman","en":"Inggris","es":"Spanyol","fr":"Perancis","hi":null,"id":"Indonesia","it":"Italia","pt-BR":"Portugal","th":"Thailand","tr":"Turki","vn":"Vietnam"},"message":"Pesan","next":"Selanjutnya","prev":"Sebelumnya","prompt":{},"right":{},"share":"Bagikan","table":"Tabel","tweet":"Tweet","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"Tentang Tim","add_caption":"Menambahkan Judul halaman","add_content":"Masukkan konten di artikel anda dari salah satu sumber di bawah ini:","add_image":"Tambah Foto","add_item":"Menambahkan jumlah  Media","add_media":"Menambahkan Media","add_team":"Menambahkan tim","additional_media":"Media Tambahan","are_you_sure":"Apakah anda yakin mau meninggalkan halaman ini?","article_preview":"Ini adalah preview dari artikel Anda","attach_image":"Memilih Foto","back":"Kembali","back_to_edit":"Kembali Menyunting","back_to_editing":"Kembali ke Suntingan","bold_tooltip":"Tebal","caption_optional":"(Opsional, Maks 22 karakter)","char_count":"Menghitung Huruf: %{num}","check_grammar":"Luangkan waktu sejenak untuk memeriksa ejaan dan tata bahasa yang benar","choose_team":"Pilih sebuah tim","clear":"Hapus","complete_steps":"Sebelum mengedarkan anda harus melengkapi beberapa tahap ini","congrats":"Selamat!","cover_image":"Ini akan menjadi gambar utama di dalam situs, aplikasi atau media sosial","create_article":"Membuat Artikel","crop_image":"Potong Foto","crop_ratio":"Potong ratio:","crop_too_small":"Gambar terlalu kecil","date":"Tanggal:","delete":"MENGHAPUS","delete_article":"Hapus artikel ini","discard":"Membuang","discard_confirmation":"Apakah anda yakin mau membuang postingan ini?","draft":"Simpan","drag":"Tarik Foto/Video ke sini","drag_all":"Pindahkan foto, video, dan konten media sosial di sini","drag_crop":"Menarik menjadi posisi awal","drop_here":"Taruh disini...","drop_image":"Taruh foto di sini","edit_crop":"Pindah / mengubah ukuran persegi panjang untuk menyesuaikan thumbnail","edit_thumb":"Mengedit Thumbnail","editor":"Editor:","embed":"Embed","embed_code":"Kode Embed","embed_only":"Taruh kode embed disini","embed_video":"Video Embed","enter_desc":"Memasukan deskripsi disini...","enter_title":"Tulis judul di sini...","enter_url":"Masukkan kode URL","facebook_cover_image":"Foto Cover Facebook","ftbpro_editor":"Editor FTBpro","grammar_spelling":"Luangkan waktu sebentar untuk memeriksa ejaan dan tata bahasa yang benar","great":"Hebat!","guide_tips":"Baca pedoman dan tips menulis dari kami","guide_tips_links":"http://www.90min.com/blog/panduan-tips-seo/","h2_tooltip":"Judul","header_edit":"Edit postingan","header_new":"Artikel Baru","hyperlink_tooltip":"Tautan","image_bank":"Bank Foto","image_crop":"Potong","image_format":"Format foto ini hanya terbatas pada JPEG, PNG dan gif.","image_search":"Mencari","image_size":"Ukurannya harus lebih besar dari 500x280 pixels.","image_size_parameterized":"Ukurannya harus lebih besar dari %{width}x%{height} pixels.","image_video":"Foto/Video","image_weight":"File ini melewati batas maksimal yang diperbolehkan %{fileSizeMaxSupported}","insert_link":"Taruh tautan anda disini","invalid_code":"URL yang anda masukkan tidak valid. Tolong masukkan kode URL yang lengkap","leave":"Tinggalkan Halaman ini","leave_warning":"Anda mencoba meninggalkan halaman ini tanpa menyimpannya. Semua perubahan akan hilang!","list_tooltip":"Daftar yang tidak diurutkan","max":"(Maks %{num})","max_reached":"(Limit maksimal tercapai)","media_longer":"(untuk artikel yang lebih dari 200 kata)","media_longer_than":"(untuk artikel yang lebih dari 300 kata)","media_post":"Media Post","min":"(Min %{num})","min_words":"(Kurang lebih %{num} kata)","no_draft":"Tidak ada konsep yang disimpan","num_words":"%{count} Kata","number_list_tooltip":"Daftar yang diurutkan","oops":"Hampir sampai...","optimal_article":"(Optimal 300-800)","optimal_length":"(Optimal %{min}-%{max})","optional":"(Opsional, Max 160 karakter)","optional_field":"Kolom ini bersifat opsional","or":"Atau","p_tooltip":"Paragraf","paste_embed":"Taruh tautan atau kode embed disini","paste_url":"Tempel link url atau kode embed","playbuzz":"Taruh link PlayBuzz.com di sini","polls":"Menambahkan poling","prev":"Tinjau","preview":"Simpan & Tinjau","publish":"Menerbitkan","remove_attachment":"Anda yakin untuk menghapus ini dari lampiran?","reset":"Ulang","review":"Tinjau sebelum di terbitkan","save_changes":"Menyimpan Perubahan?","save_draft":"SIMPAN SEBAGAI KONSEP","search_bank":"Mencari bank gambar","search_for":"Mencari untuk ...","searching":"Sedang mencari...","select_photo":"Pilih foto","seo_desc":"Deskripsi SEO","share":"Bagikan postingan ini ke Facebook","small_image":"Foto anda terlalu kecil ukurannya, kurang lebih harus 300x150","source":"Sumber:","start_at":"Dimulai pada","stay":"Tetap dihalaman ini","steps_complete":"Artikel anda siap untuk di terbitkan.","styling_tooltip":"Hapus karakter huruf anda","tag":"Menandai","tag_at_least":"(Pilih minimal 1)","tag_sug":"Tag yang disarankan","tag_team":"Menandai","teaser":"Teaser","teaser_watermark":"Hanya akan muncul sebagai keterangan dalam link untuk artikel anda.","this_is_preview":"Ini preview dari artikel anda","tip_controversial ":"Jadilah kontroversial. Postingan bagus meningkatkan pertanyaan sulit.","tip_image":"Tambah foto. Postingan dengan foto lebih menarik banyak pembaca.","tip_media":"Punya video bagus? Film dari YouTube atau Metacafe bisa mendapatkan tanggapan yang bagus.","tip_short":"Jaga paragraf anda agar tetap pendek. Pembaca cenderung mengabaikan paragraf yang panjang.","tips":{"media_close_ups":"Gunakan gambar jarak dekat dalam artikel anda tentang pemain.","media_image_bank":"Kita merekomendasikan menggunakan Getty Image untuk mencari foto yang anda butuhkan. Cari dari tim atau pemain,","post_enjoy":"Hal yang lebih pentingnya lagi, nikmati diri anda!","post_original":"Jadilah Orisinil. Karena konten yang diambil dari sumber lain tidak diperbolehkan.","post_paragraphs":"Gunakan paragraf untuk mengakhiri artikel anda.","post_review":"Ulas artikel anda sebelum diterbitkan. Periksa tata bahasa dan ejaan yang benar.","title":"Tips untuk meningkatkan pembaca:","title_debatable":"Gunakan bahasa yang beropini. Lebihkan kasusnya. Orang lebih tertarik dengan topik yang bisa diperdebatkan.","title_known_name":"Mulai judul anda dengan nama pemain atau tim.","title_popular_terms":"Masukan kata kata populer seperti nama lengkap pemain, nama tim, atau topik hangat.","title_question":"Menanyakan pertanyaan yang sudah dijawab dalam artikel anda.","title_short":"Dianjurkan tetap membuatnya singkat. 5-8 kata."},"title":"Judul","too_long":"Terlalu Panjang (Optimal 10-75)","too_short":"Terlalu Pendek (Optimal 10-75)","toolong":"Terlalu Panjang (Optimal %{min}-%{max})","tooshort":"Terlalu Pendek (Optimal %{min}-%{max})","try_again":"Coba lagi","upload_failed":"Eror terjadi saat mengupload gambar. Silahkan coba kembali.","upload_image":"Mengupload Foto","upload_img":"Mengupload Gambar","valid_code":"Kode embed yang anda sediakan tidak valid.","video":"Video","video_provider":"Saat ini kita tidak mendukung video provider ini.","video_services":"Taruh video dari YouTube, Dailymotion atau Metacafe disini:","video_url":"URL Video (Youtube, Dailymotion, Metacafe, dll.)","word_count":"Total Kata: %{num}","writing_sug":"Saran dari SEO","writing_tips":"Tips menulis untuk lebih baik","your_post":"Postingan Anda"},"embed":{"button":"Embed","dialogue":{"additional_options":"Pilihan tambahan","become_a_partner":"JADI MITRA","comments":"Tampilkan komentar","customise_collapse/expand":"Sesuaikan kode","disclaimer":"Dengan menempelkan kode ini anda setuju dengan %{terms_conditions} kami","embed_code":"kode Embed","embed_instructions":"Tambahkan artikel ini ke situs Anda dengan menyalin dan menempel kode HTML di bawah ini","embed_instructions_partners":"Salin dan tempel kode personalisasi anda dibawah ini","full_title":"Judul lengkap","header":"ARTIKEL EMBED","info":"Penghapusan tautan 90min hanya tersedia untuk para mitra","link":"Tunjukkan tautan ke 90min","logged_in":"Hubungi %{email} untuk bergabung dengan salah satu program kemitraan kami.","login":"Login","partner_message":"Sudah menjadi mitra? %{login} untuk menerima kode kustomisasi kami.","remove_title":"Hapus judul","show-author":"Lihat nama penulis","show-date":"Lihat tanggal","show-reads-counter":"Tunjukkan berapa kali dilihat ","show-title":"Tampilkan Judul","terms_&_conditions":"Syarat & Ketentuan","title":"Judul","views":"Tunjukkan berapa kali dilihat "}},"footer":{"about_12up":null,"about_90min":"Tentang 90min","about_circasports":"Tentang CircaSports","about_dbltap":null,"about_ei":null,"about_floor8":null,"about_ftb90":"Tentang FTB90","about_ftbpro":"Tentang","about_german_site":null,"about_ht_media":null,"about_pluralist":null,"about_swurley":"Tentang Swurley","about_theduel":null,"affiliates":"Afiliasi","apps":"Aplikasi Mobile","apps_Android":"DAPATKAN DI","apps_iphone":"TERSEDIA DI","blog":"Blog","boomerang":null,"cartoon":null,"contact_ftbpro":"Hubungi Kami","fan_store":"Toko Para Suporter","faq":"FAQ","house_rules":"Aturan Rumah","in_the_news":"Dalam Berita","jobs":"Pekerjaan","licensing":"Lisensi","links":"Tautan","links_social":"Tautan","more_about_12up":null,"more_about_90min":"Tentang 90min","more_about_circasports":"Tentang CircaSports","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":null,"more_about_ftb90":"Tentang FTB90","more_about_german_site":null,"more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"Tentang Swurley","more_about_theduel":null,"partner_sites":null,"partners":"Rekanan","prev_prog":null,"privacy_policy":"Kebijakan Privasi","rights_reserved":"Semua hak cipta","rights_reserved_year":"FTBpro 2016  \u00a9 Semua Hak Cipta","rights_reserved_year_12up":null,"rights_reserved_year_90min":"Minute Media 90min 2019  \u00a9 Semua Hak Cipta","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"CircaSports 2016  \u00a9 Semua Hak Cipta","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"Minute Media FTB90 2018  \u00a9 Semua Hak Cipta","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"Swurley 2016  \u00a9 Semua Hak Cipta","rights_reserved_year_theduel":null,"space":null,"statistics_12up":null,"statistics_90min":"Statistik 90min","statistics_circasports":"Statistik CircaSports","statistics_ei":null,"statistics_floor8":null,"statistics_ftb90":"Statistik FTB90","statistics_ht_media":null,"statistics_swurley":"Statistik Swurley","statistics_theduel":null,"stats":{"articles":"Artikel","fans":"Penggemar","members":"Anggota","writers":"Penulis"},"support":"Bantuan","tbs":null,"tcm":null,"terms":"Syarat","terms_conditions":"Syarat & Ketentuan","tnt":null,"warner":null,"writers":"Penulis"},"header":{"profile":"Profil Saya","settings":"Pengaturan","signout":"Keluar"},"home":{"no_matches":"Tidak ada pertandingan"},"homepage":{"be_the_first":"JADILAH YANG PERTAMA TAHU!","by":"Oleh:","chrome_notifications":"Tetap terkini dengan notifikasi Chrome kami\n","ei":{"latest_news":null,"trending":null,"view_more":null},"fan_perspectives":"Selengkapnya","fan_voice":"SUARA FAN","featured_topic":null,"fixtures_and_scores":null,"fixtures_scores":"Jadwal Dan Hasil","follow_us_on":"Follow kami di Snapchat:","latest_videos":"Video Terbaru","league_page":null,"match_day":"Match Day %{num}","month":"%M","more":"Lainnya","most_read":"Trending","no_matches":"Tidak ada pertandingan hari ini","other_categories":"KATEGORI LAINNYA","our_categories":"KATEGORI","read_now":"SELENGKAPNYA","schedule":"JADWAL","scores_page_desc":"Jadwal dan hasil terbaru","scores_page_title":"Jadwal & Hasil","social_text":null,"stay_up_to":"Tetap update dengan semua berita terkini","top_stories":"Berita Penting","trending":null,"trending_floor8":null,"video":"Video","videos":"Video","view_all":"Lihat Semua Pertandingan","view_more":"Lihat Lainnya","watch_more_videos":null,"watch_tv_12up":null,"watch_tv_90min":"SAKSIKAN 90MIN TV","watch_tv_circasports":"SAKSIKAN CIRCA SPORTS TV","watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":null,"watch_tv_german_site":null,"watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"Iklan","bet_now":"Pasang Sekarang","by":"Oleh","by_betway":null,"community_content":"Konten Komunitas","community_disclaimer":"Tulisan ini dibuat oleh anggota dari komunitas 90min dan belum diedit atau dilihat oleh para editor tim","community_disclaimer_12up":null,"community_disclaimer_90min":"Tulisan ini dibuat oleh anggota dari komunitas 90min dan belum diedit atau dilihat oleh para editor tim","community_disclaimer_circasports":"Tulisan ini dibuat oleh anggota dari komunitas CircaSports dan belum diedit atau dilihat oleh para editor tim","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":null,"community_disclaimer_ftb90":"Tulisan ini dibuat oleh anggota dari komunitas FTB90 dan belum diedit atau dilihat oleh para editor tim","community_disclaimer_german_site":null,"community_disclaimer_ht_media":null,"community_disclaimer_swurley":"Tulisan ini dibuat oleh anggota dari komunitas Swurley dan belum diedit atau dilihat oleh para editor tim","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} menggunakan cookies untuk personalisasi konten dan iklan serta untuk membuat situs kami lebih mudah digunakan. Kami juga membagikan beberapa informasi dengan pihak ketiga untuk iklan dan analitik.","cookies_consent_2":"Info lebih lanjut","cookies_consent_approve":"Mengerti!","notf":{},"now_playing":"SEDANG DIPUTAR:","similar_articles":"Artikel Berkaitan"},"private_messages":{"conversation_date":"Update terakhir:","expand":"Memperluas","header":"kotak masuk","message_sent":"Pesan anda telah terkirim","messages":"Pesan","no_history":"Tidak ada sejarah","not_available":"Percakapan tidak tersedia","private_message":"Pesan pribadi","private_message_to":"Pesan pribadi ke","send":"Kirim","send_failed":"Pengiriman gagal. Maaf, coba lagi nanti","sending":"Mengirim","sent":"Pesan terkirim","side_title":"Percakapan","title":"Antara kamu dan","view_history":"Lihat sejarah percakapan","write_message_here":"Tulis pesan anda di sini"},"pundit":{"bet_via":"PASANG BET MELALUI","draw":"Seri","fan_predictions":"Prediksi Suporter","follow_match":"Ikuti Pertandingan","follow_pundit":"Ikuti Pandit","log_in":"Log in untuk menyimpan prediksi anda","not_available":"Saat ini tidak ada statistik yang tersedia. Mohon dicoba kembali nanti.","place_your_bet":"PASANG BET ANDA","place_your_bet_via":"Pasang Bet Anda Melalui","prediction":"Prediksi","pundit_prediction":"Prediksi %{pundit_first_name}:","select_match":"Pilih Pertandingan untuk Prediksi Kamu","select_result":"Pilih Hasil","team_to_win":"%{team} menang","title":"%{team1} vs %{team2}: Tips Betting Oleh %{pundit_name}","top_predictors":"PREDIKTOR TERATAS","what_result":"Kamu bisa menebak hasilnya?","what_your_prediction":"APA PREDIKSI ANDA","your_prediction":"PREDIKSI ANDA"},"reactions":{"campaigns_poweredby":null,"v1":{"lol":"LOL","love":"Suka","must":"Penting","noway":"No Way!","share":"Bagikan","shocked":"Terkejut","tweet":"Tweet"},"v2":{"booh":null,"cool":null,"haha":"Wkwkwk","loveit":"Suka","noway":"No Way"},"your_reaction":"Reaksi Anda?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"Article saya diterima 100 pembaca","about_you":"Tentang Anda","account":"Akun","all_info_lost":"Seluruh informasi anda di FTBpro.com akan hilang secara permanen","are_you_sure":"Anda Yakin?","by_email":"Email","connected_as":"Terhubung sebagai","deactivate":"nonaktifkan akun saya","deactivate_placeholder":"Mohon beritahu kami kenapa:","deactivate_request_sent":"Permintaan anda telah sukses diajukan. Kami akan menghungi secepatnya","disp_name":"NamaTampilan ","fb_hometown":"Kota saat ini dari Facebook","fb_link":"Tautan Facebook","go_social":"Bersosialisasi - biarkan teman saya tau aktivitas membaca saya","go_social_short":"Bagikan artikel bacaan saya","google_plus_link":"Tautan Google+","if_following_me":"Seseorang mulai mengikuti saya","if_sending_me_message":"Seseorang mengirim kan saya pesan","let_see":"Biarkan orang-orang melihat:","my_team":"Tim Saya","name":{"rules":"Harus unik. 5-50 karakter. Gunakan hurf, angka, dan strip."},"notifications":"Notifikasi","optional":"Opsional","privacy":"Pribadi","recent_articles":"Artikel terbaru yang dibagikan","save":"Simpan","settings":"Aturan","settings_saved":"Aturan Menyimpan","share":"Bagikan secara otomatis","site":"Situs:","site_title":"Judul:","site_url":"URL:","stats":"Statistik vBet","submit":"Menyerahkan","twitter_link":"Tautan twitter:","weekly_writers_achievements":"Rangkuman penulis minggu ini","when_notify":"Beritahu saya apabila","your_writing_language":"Dalam bahasa apa Anda akan menulis?"},"sign_up":{"about_you":"Tulis sesuatu tentang kecintaan anda terhadap skuat anda (opsional)","and":"dan","change":"Anda selalu bisa mengganti ini di settingan anda","disp_name":"Tampilan Nama","join_12up":null,"join_90min":"Gabung 90min","join_circasports":"Gabung CircaSports","join_dbltap":null,"join_ei":null,"join_floor8":null,"join_ftb90":"Gabung FTB90","join_german_site":null,"join_ht_media":null,"join_swurley":"Gabung Swurley","lets_start":"Mari kita memulai persiapan anda...","my_game":null,"my_league":"Liga","of_12up":null,"of_90min":"dari 90min.com","of_circasports":"dari Swurley.com","of_dbltap":null,"of_ei":null,"of_floor8":null,"of_ftb90":"dari FTB90.com","of_german_site":null,"of_ht_media":null,"privacy_policy":"Kebijakan Privasi","required_field":"Bagian yang diperlukan","team":"Tim Saya","terms":"Saya setuju dengan","terms_and_conditions":"Syarat dan Ketentuan"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"Artikel","comments":"Berkomentar","reads":"Baca"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"BERITA TERBARU","latest_videos":"VIDEO TERBARU","read_more":"Baca lebih","recommended":"DIREKOMENDASIKAN","video":"Video"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"th":{"date":{"abbr_day_names":["\u0e2d\u0e32","\u0e08","\u0e2d","\u0e1e","\u0e1e\u0e24","\u0e28","\u0e2a"],"abbr_month_names":[null,"\u0e21.\u0e04.","\u0e01.\u0e1e.","\u0e21\u0e35.\u0e04.","\u0e40\u0e21.\u0e22.","\u0e1e.\u0e04.","\u0e21\u0e34.\u0e22.","\u0e01.\u0e04.","\u0e2a.\u0e04.","\u0e01.\u0e22.","\u0e15.\u0e04.","\u0e1e.\u0e22.","\u0e18.\u0e04."],"day_names":["\u0e2d\u0e32\u0e17\u0e34\u0e15\u0e22\u0e4c","\u0e08\u0e31\u0e19\u0e17\u0e23\u0e4c","\u0e2d\u0e31\u0e07\u0e04\u0e32\u0e23","\u0e1e\u0e38\u0e18","\u0e1e\u0e24\u0e2b\u0e31\u0e2a\u0e1a\u0e14\u0e35","\u0e28\u0e38\u0e01\u0e23\u0e4c","\u0e40\u0e2a\u0e32\u0e23\u0e4c"],"formats":{"default":"%d-%m-%Y","long":"%d %B %Y","short":"%d %b","capitalized_short_day_and_hour":"%A %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"\u0e21\u0e01\u0e23\u0e32\u0e04\u0e21","\u0e01\u0e38\u0e21\u0e20\u0e32\u0e1e\u0e31\u0e19\u0e18\u0e4c","\u0e21\u0e35\u0e19\u0e32\u0e04\u0e21","\u0e40\u0e21\u0e29\u0e32\u0e22\u0e19","\u0e1e\u0e24\u0e29\u0e20\u0e32\u0e04\u0e21","\u0e21\u0e34\u0e16\u0e38\u0e19\u0e32\u0e22\u0e19","\u0e01\u0e23\u0e01\u0e0e\u0e32\u0e04\u0e21","\u0e2a\u0e34\u0e07\u0e2b\u0e32\u0e04\u0e21","\u0e01\u0e31\u0e19\u0e22\u0e32\u0e22\u0e19","\u0e15\u0e38\u0e25\u0e32\u0e04\u0e21","\u0e1e\u0e24\u0e28\u0e08\u0e34\u0e01\u0e32\u0e22\u0e19","\u0e18\u0e31\u0e19\u0e27\u0e32\u0e04\u0e21"],"order":["\u0e27\u0e31\u0e19","\u0e40\u0e14\u0e37\u0e2d\u0e19","\u0e1b\u0e35"],"time_since":{"about_an_hour_ago":"\u0e1b\u0e23\u0e30\u0e21\u0e32\u0e13 1 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27","about_two_hours_ago":"\u0e1b\u0e23\u0e30\u0e21\u0e32\u0e13 2 \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27","seconds_ago":"\u0e27\u0e34\u0e19\u0e32\u0e17\u0e35\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27","x_hours_ago":"%{count} \u0e0a\u0e31\u0e48\u0e27\u0e42\u0e21\u0e07\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27","x_minutes_ago":"%{count} \u0e19\u0e32\u0e17\u0e35\u0e17\u0e35\u0e48\u0e41\u0e25\u0e49\u0e27"}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"\u0e15\u0e49\u0e2d\u0e07\u0e16\u0e39\u0e01\u0e22\u0e2d\u0e21\u0e23\u0e31\u0e1a","blank":"\u0e15\u0e49\u0e2d\u0e07\u0e44\u0e21\u0e48\u0e40\u0e27\u0e49\u0e19\u0e27\u0e48\u0e32\u0e07\u0e40\u0e2d\u0e32\u0e44\u0e27\u0e49","confirmation":"\u0e01\u0e32\u0e23\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19\u0e44\u0e21\u0e48\u0e15\u0e23\u0e07\u0e01\u0e31\u0e19","empty":"\u0e15\u0e49\u0e2d\u0e07\u0e44\u0e21\u0e48\u0e40\u0e27\u0e49\u0e19\u0e27\u0e48\u0e32\u0e07\u0e40\u0e2d\u0e32\u0e44\u0e27\u0e49","equal_to":"\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35\u0e04\u0e48\u0e32\u0e40\u0e17\u0e48\u0e32\u0e01\u0e31\u0e1a %{count}","even":"\u0e15\u0e49\u0e2d\u0e07\u0e40\u0e1b\u0e47\u0e19\u0e08\u0e33\u0e19\u0e27\u0e19\u0e04\u0e39\u0e48","exclusion":"\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49\u0e23\u0e31\u0e1a\u0e2d\u0e19\u0e38\u0e0d\u0e32\u0e15\u0e43\u0e2b\u0e49\u0e43\u0e0a\u0e49","greater_than":"\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e32\u0e01\u0e01\u0e27\u0e48\u0e32 %{count}","greater_than_or_equal_to":"\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e32\u0e01\u0e01\u0e27\u0e48\u0e32\u0e2b\u0e23\u0e37\u0e2d\u0e40\u0e17\u0e48\u0e32\u0e01\u0e31\u0e1a %{count}","inclusion":"\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49\u0e2d\u0e22\u0e39\u0e48\u0e43\u0e19\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23","invalid":"\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e43\u0e0a\u0e49\u0e44\u0e14\u0e49","less_than":"\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35\u0e04\u0e48\u0e32\u0e19\u0e49\u0e2d\u0e22\u0e01\u0e27\u0e48\u0e32 %{count}","less_than_or_equal_to":"\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35\u0e04\u0e48\u0e32\u0e19\u0e49\u0e2d\u0e22\u0e01\u0e27\u0e48\u0e32\u0e2b\u0e23\u0e37\u0e2d\u0e40\u0e17\u0e48\u0e32\u0e01\u0e31\u0e1a %{count}","not_a_number":"\u0e44\u0e21\u0e48\u0e43\u0e0a\u0e48\u0e15\u0e31\u0e27\u0e40\u0e25\u0e02","not_an_integer":"\u0e44\u0e21\u0e48\u0e43\u0e0a\u0e48\u0e08\u0e33\u0e19\u0e27\u0e19\u0e40\u0e15\u0e47\u0e21","odd":"\u0e15\u0e49\u0e2d\u0e07\u0e40\u0e1b\u0e47\u0e19\u0e08\u0e33\u0e19\u0e27\u0e19\u0e04\u0e35\u0e48","record_invalid":"\u0e44\u0e21\u0e48\u0e1c\u0e48\u0e32\u0e19\u0e01\u0e32\u0e23\u0e15\u0e23\u0e27\u0e08\u0e2a\u0e2d\u0e1a: %{errors}","taken":"\u0e16\u0e39\u0e01\u0e43\u0e0a\u0e49\u0e44\u0e1b\u0e41\u0e25\u0e49\u0e27","too_long":"\u0e22\u0e32\u0e27\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b (\u0e15\u0e49\u0e2d\u0e07\u0e44\u0e21\u0e48\u0e40\u0e01\u0e34\u0e19 %{count} \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)","too_short":"\u0e2a\u0e31\u0e49\u0e19\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b (\u0e15\u0e49\u0e2d\u0e07\u0e22\u0e32\u0e27\u0e01\u0e27\u0e48\u0e32 %{count} \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)","wrong_length":"\u0e21\u0e35\u0e04\u0e27\u0e32\u0e21\u0e22\u0e32\u0e27\u0e44\u0e21\u0e48\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07 (\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35\u0e04\u0e27\u0e32\u0e21\u0e22\u0e32\u0e27 %{count} \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)"},"template":{"body":"\u0e42\u0e1b\u0e23\u0e14\u0e15\u0e23\u0e27\u0e08\u0e2a\u0e2d\u0e1a\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e43\u0e19\u0e0a\u0e48\u0e2d\u0e07\u0e15\u0e48\u0e2d\u0e44\u0e1b\u0e19\u0e35\u0e49:","header":"\u0e1e\u0e1a\u0e02\u0e49\u0e2d\u0e1c\u0e34\u0e14\u0e1e\u0e25\u0e32\u0e14 %{count} \u0e1b\u0e23\u0e30\u0e01\u0e32\u0e23 \u0e17\u0e33\u0e43\u0e2b\u0e49\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01%{model}\u0e44\u0e14\u0e49"},"200_pixels":"\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35\u0e02\u0e19\u0e32\u0e14\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e15\u0e48\u0e33 200x200 \u0e1e\u0e34\u0e01\u0e40\u0e0b\u0e25","file_too_big":"\u0e44\u0e1f\u0e25\u0e4c\u0e17\u0e35\u0e48\u0e2d\u0e31\u0e1b\u0e42\u0e2b\u0e25\u0e14\u0e19\u0e31\u0e49\u0e19\u0e21\u0e35\u0e02\u0e19\u0e32\u0e14\u0e43\u0e2b\u0e0d\u0e48\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b","flash":"\u0e04\u0e38\u0e13\u0e15\u0e49\u0e2d\u0e07\u0e15\u0e34\u0e14\u0e15\u0e31\u0e49\u0e07 Adobe Flash \u0e16\u0e36\u0e07\u0e08\u0e30\u0e43\u0e0a\u0e49\u0e1f\u0e35\u0e40\u0e08\u0e2d\u0e23\u0e4c\u0e19\u0e35\u0e49\u0e44\u0e14\u0e49","invalid_filetype":"\u0e43\u0e0a\u0e49\u0e44\u0e1f\u0e25\u0e4c\u0e0a\u0e19\u0e34\u0e14\u0e19\u0e35\u0e49\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49 (\u0e44\u0e1f\u0e25\u0e4c\u0e17\u0e35\u0e48\u0e23\u0e2d\u0e07\u0e23\u0e31\u0e1a\u0e04\u0e37\u0e2d .gif, .jpg, .jpeg \u0e41\u0e25\u0e30 .png)","invalid_url":"URL \u0e44\u0e21\u0e48\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07","mobile_error":"\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e19\u0e35\u0e49\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e43\u0e0a\u0e49\u0e44\u0e14\u0e49\u0e1a\u0e19\u0e2d\u0e38\u0e1b\u0e01\u0e23\u0e13\u0e4c\u0e21\u0e37\u0e2d\u0e16\u0e37\u0e2d","motto":{"title":"\u0e01\u0e23\u0e38\u0e13\u0e32\u0e43\u0e0a\u0e49\u0e23\u0e30\u0e2b\u0e27\u0e48\u0e32\u0e07 10-25 \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23"},"nick":{"duplicate":"\u0e19\u0e34\u0e04\u0e43\u0e0a\u0e49\u0e07\u0e32\u0e19\u0e41\u0e25\u0e49\u0e27","length":"\u0e19\u0e34\u0e04\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35 5-50 \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23","title":"\u0e43\u0e0a\u0e49\u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23 \u0e15\u0e31\u0e27\u0e40\u0e25\u0e02 \u0e08\u0e38\u0e14 \u0e41\u0e25\u0e30 \u0e40\u0e04\u0e23\u0e37\u0e48\u0e2d\u0e07\u0e2b\u0e21\u0e32\u0e22\u0e02\u0e35\u0e14\u0e01\u0e25\u0e32\u0e07\u0e40\u0e17\u0e48\u0e32\u0e19\u0e31\u0e49\u0e19","validation":"\u0e0a\u0e37\u0e48\u0e2d\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e08\u0e30\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35\u0e23\u0e30\u0e2b\u0e27\u0e48\u0e32\u0e07 5-50 \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23 - \u0e43\u0e0a\u0e49\u0e40\u0e09\u0e1e\u0e32\u0e30\u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23,\u0e15\u0e31\u0e27\u0e40\u0e25\u0e02, \u0e08\u0e38\u0e14 \u0e2b\u0e23\u0e37\u0e2d\u0e02\u0e35\u0e14 \u0e40\u0e17\u0e48\u0e32\u0e19\u0e31\u0e49\u0e19"},"no_file":"\u0e44\u0e21\u0e48\u0e21\u0e35\u0e44\u0e1f\u0e25\u0e4c\u0e17\u0e35\u0e48\u0e16\u0e39\u0e01\u0e40\u0e25\u0e37\u0e2d\u0e01","not_found":"\u0e44\u0e21\u0e48\u0e1e\u0e1a\u0e2b\u0e19\u0e49\u0e32\u0e17\u0e35\u0e48\u0e01\u0e33\u0e25\u0e31\u0e07\u0e04\u0e49\u0e19\u0e2b\u0e32","one_team":"\u0e15\u0e49\u0e2d\u0e07\u0e23\u0e30\u0e1a\u0e38\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e19\u0e49\u0e2d\u0e22\u0e2b\u0e19\u0e36\u0e48\u0e07\u0e17\u0e35\u0e21","pic_size":"\u0e44\u0e1f\u0e25\u0e4c\u0e02\u0e2d\u0e07\u0e23\u0e39\u0e1b\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35\u0e02\u0e19\u0e32\u0e14\u0e23\u0e30\u0e2b\u0e27\u0e48\u0e32\u0e07 %{min} \u0e16\u0e36\u0e07 %{max}","ratio_alert":"\u0e2d\u0e31\u0e15\u0e23\u0e32\u0e2a\u0e48\u0e27\u0e19\u0e02\u0e2d\u0e07\u0e23\u0e39\u0e1b\u0e15\u0e49\u0e2d\u0e07\u0e2d\u0e22\u0e39\u0e48\u0e23\u0e30\u0e2b\u0e27\u0e48\u0e32\u0e07 1:2 \u0e41\u0e25\u0e30 2:1","return_homepage":"\u0e01\u0e25\u0e31\u0e1a\u0e44\u0e1b\u0e2b\u0e19\u0e49\u0e32\u0e2b\u0e25\u0e31\u0e01","select_image":"\u0e04\u0e38\u0e13\u0e15\u0e49\u0e2d\u0e07\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e2d\u0e31\u0e1b\u0e42\u0e2b\u0e25\u0e14","sorry":"\u0e02\u0e2d\u0e2d\u0e20\u0e31\u0e22","subject_id":{"require_fanship":"\u0e41\u0e1f\u0e19\u0e15\u0e31\u0e27\u0e22\u0e07\u0e2b\u0e49\u0e32\u0e21\u0e1e\u0e25\u0e32\u0e14!"},"text":{"duplicate_comment":"\u0e04\u0e27\u0e32\u0e21\u0e40\u0e2b\u0e47\u0e19\u0e0b\u0e49\u0e33","duplicate_post":"\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e0b\u0e49\u0e33","max_char":"\u0e2a\u0e39\u0e07\u0e2a\u0e38\u0e14 %{num_chars} \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23","max_words":"\u0e2a\u0e39\u0e07\u0e2a\u0e38\u0e14 %{num_words} \u0e04\u0e33","min_char":"\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e15\u0e48\u0e33 %{num_chars} \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23"},"twitter_url":{"invalid":"URL \u0e17\u0e27\u0e34\u0e15\u0e40\u0e15\u0e2d\u0e23\u0e4c\u0e44\u0e21\u0e48\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07"},"unknown_upload":"\u0e40\u0e01\u0e34\u0e14\u0e1b\u0e31\u0e0d\u0e2b\u0e32\u0e43\u0e19\u0e01\u0e32\u0e23\u0e2d\u0e31\u0e1b\u0e42\u0e2b\u0e25\u0e14\u0e17\u0e35\u0e48\u0e44\u0e21\u0e48\u0e17\u0e23\u0e32\u0e1a\u0e2a\u0e32\u0e40\u0e2b\u0e15\u0e38 \u0e01\u0e23\u0e38\u0e13\u0e32\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e41\u0e1c\u0e19\u0e01\u0e1a\u0e23\u0e34\u0e01\u0e32\u0e23\u0e25\u0e39\u0e01\u0e04\u0e49\u0e32","unsupported_video":"\u0e02\u0e2d\u0e2d\u0e20\u0e31\u0e22 \u0e40\u0e23\u0e32\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e23\u0e2d\u0e07\u0e23\u0e31\u0e1a\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d\u0e1d\u0e31\u0e07\u0e08\u0e32\u0e01\u0e40\u0e27\u0e47\u0e1a\u0e19\u0e35\u0e49","url_err":"\u0e40\u0e01\u0e34\u0e14\u0e1b\u0e31\u0e0d\u0e2b\u0e32\u0e42\u0e14\u0e22\u0e44\u0e21\u0e48\u0e17\u0e23\u0e32\u0e1a\u0e2a\u0e32\u0e40\u0e2b\u0e15\u0e38 (\u0e2d\u0e32\u0e08\u0e40\u0e1b\u0e47\u0e19\u0e40\u0e1e\u0e23\u0e32\u0e30\u0e15\u0e31\u0e27\u0e2a\u0e30\u0e01\u0e14\u0e02\u0e2d\u0e07 URL \u0e1c\u0e34\u0e14\u0e1e\u0e25\u0e32\u0e14) \u0e01\u0e23\u0e38\u0e13\u0e32\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e1c\u0e39\u0e49\u0e14\u0e39\u0e41\u0e25","website":{"blank":"\u0e01\u0e23\u0e38\u0e13\u0e32\u0e43\u0e2a\u0e48 URL \u0e02\u0e2d\u0e07\u0e40\u0e27\u0e47\u0e1a\u0e44\u0e0b\u0e15\u0e4c"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%a %d %b %Y %H:%M:%S %z","long":"%d %B %Y %H:%M \u0e19.","short":"%d %b %H:%M \u0e19.","capitalized_short_day_and_hour":"%A %H:%M","date_format":"%d %b %H:%M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H:%M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H:%M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e39\u0e48\u0e23\u0e30\u0e1a\u0e1a"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"\u0e40\u0e0a\u0e37\u0e48\u0e2d\u0e21\u0e15\u0e48\u0e2d","language":"\u0e20\u0e32\u0e29\u0e32","languages":{"de":"\u0e20\u0e32\u0e29\u0e32\u0e40\u0e22\u0e2d\u0e23\u0e21\u0e31\u0e19","en":"\u0e20\u0e32\u0e29\u0e32\u0e2d\u0e31\u0e07\u0e01\u0e24\u0e29","es":"\u0e20\u0e32\u0e29\u0e32\u0e2a\u0e40\u0e1b\u0e19","fr":"\u0e20\u0e32\u0e29\u0e32\u0e1d\u0e23\u0e31\u0e48\u0e07\u0e40\u0e28\u0e2a","hi":null,"id":"\u0e20\u0e32\u0e29\u0e32\u0e2d\u0e34\u0e19\u0e42\u0e14\u0e19\u0e35\u0e40\u0e0b\u0e35\u0e22","it":"\u0e20\u0e32\u0e29\u0e32\u0e2d\u0e34\u0e15\u0e32\u0e25\u0e35","pt-BR":"\u0e20\u0e32\u0e29\u0e32\u0e42\u0e1b\u0e23\u0e15\u0e38\u0e40\u0e01\u0e2a","th":"\u0e20\u0e32\u0e29\u0e32\u0e44\u0e17\u0e22","tr":"\u0e20\u0e32\u0e29\u0e32\u0e15\u0e38\u0e23\u0e01\u0e35","vn":"\u0e20\u0e32\u0e29\u0e32\u0e40\u0e27\u0e35\u0e22\u0e14\u0e19\u0e32\u0e21"},"message":"\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21","next":"\u0e16\u0e31\u0e14\u0e44\u0e1b","prev":"\u0e01\u0e48\u0e2d\u0e19\u0e2b\u0e19\u0e49\u0e32","prompt":{},"right":{},"share":"\u0e41\u0e0a\u0e23\u0e4c","table":"\u0e15\u0e32\u0e23\u0e32\u0e07\u0e04\u0e30\u0e41\u0e19\u0e19","tweet":"\u0e17\u0e27\u0e34\u0e15","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e17\u0e35\u0e21","add_caption":"\u0e40\u0e15\u0e34\u0e21\u0e04\u0e33\u0e1a\u0e23\u0e23\u0e22\u0e32\u0e22\u0e43\u0e15\u0e49\u0e20\u0e32\u0e1e","add_content":"\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e19\u0e37\u0e49\u0e2d\u0e2b\u0e32\u0e08\u0e32\u0e01\u0e41\u0e2b\u0e25\u0e48\u0e07\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e17\u0e35\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e25\u0e07\u0e43\u0e19\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13","add_image":"\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e17\u0e35\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e40\u0e1e\u0e34\u0e48\u0e21","add_item":"\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23\u0e2a\u0e37\u0e48\u0e2d","add_media":"\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e2a\u0e37\u0e48\u0e2d\u0e2d\u0e37\u0e48\u0e19 \u0e46 ","add_team":"\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e17\u0e35\u0e21","additional_media":"\u0e2a\u0e37\u0e48\u0e2d\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21","are_you_sure":"\u0e04\u0e38\u0e13\u0e41\u0e19\u0e48\u0e43\u0e08\u0e2b\u0e23\u0e37\u0e2d\u0e27\u0e48\u0e32\u0e04\u0e38\u0e13\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e17\u0e35\u0e48\u0e08\u0e30\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e2b\u0e19\u0e49\u0e32\u0e19\u0e35\u0e49","article_preview":"\u0e19\u0e35\u0e48\u0e04\u0e37\u0e2d\u0e15\u0e31\u0e27\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13","attach_image":"\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e","back":"\u0e22\u0e49\u0e2d\u0e19\u0e01\u0e25\u0e31\u0e1a","back_to_edit":"\u0e01\u0e25\u0e31\u0e1a\u0e44\u0e1b\u0e22\u0e31\u0e07\u0e41\u0e01\u0e49\u0e44\u0e02","back_to_editing":"\u0e01\u0e25\u0e31\u0e1a\u0e44\u0e1b\u0e41\u0e01\u0e49\u0e44\u0e02\u0e15\u0e48\u0e2d","bold_tooltip":"\u0e15\u0e31\u0e27\u0e2b\u0e19\u0e32","caption_optional":"(\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e44\u0e14\u0e49, \u0e44\u0e21\u0e48\u0e40\u0e01\u0e34\u0e19 22 \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)","char_count":"\u0e19\u0e31\u0e1a\u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23: %{num}","check_grammar":"\u0e01\u0e23\u0e38\u0e13\u0e32\u0e15\u0e23\u0e27\u0e08\u0e17\u0e32\u0e19\u0e01\u0e32\u0e23\u0e43\u0e0a\u0e49\u0e04\u0e33\u0e41\u0e25\u0e30\u0e40\u0e19\u0e37\u0e49\u0e2d\u0e2b\u0e32\u0e43\u0e2b\u0e49\u0e41\u0e19\u0e48\u0e43\u0e08\u0e01\u0e48\u0e2d\u0e19\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21","choose_team":"\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e17\u0e35\u0e21","clear":"\u0e25\u0e1a\u0e17\u0e34\u0e49\u0e07","complete_steps":"\u0e04\u0e38\u0e13\u0e15\u0e49\u0e2d\u0e07\u0e17\u0e33\u0e15\u0e32\u0e21\u0e02\u0e31\u0e49\u0e19\u0e15\u0e2d\u0e19\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14\u0e19\u0e35\u0e49\u0e01\u0e48\u0e2d\u0e19\u0e17\u0e35\u0e48\u0e08\u0e30\u0e42\u0e1e\u0e2a\u0e15\u0e4c","congrats":"\u0e22\u0e34\u0e19\u0e14\u0e35\u0e14\u0e49\u0e27\u0e22!","cover_image":"\u0e23\u0e39\u0e1b\u0e19\u0e35\u0e49\u0e08\u0e30\u0e16\u0e39\u0e01\u0e43\u0e0a\u0e49\u0e40\u0e1b\u0e47\u0e19\u0e14\u0e34\u0e2a\u0e40\u0e1e\u0e25\u0e22\u0e4c\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e25\u0e07\u0e1a\u0e19\u0e40\u0e27\u0e47\u0e1a\u0e44\u0e0b\u0e15\u0e4c, \u0e41\u0e2d\u0e1e\u0e2f \u0e2b\u0e23\u0e37\u0e2d \u0e42\u0e0b\u0e40\u0e0a\u0e35\u0e22\u0e25\u0e40\u0e19\u0e47\u0e15\u0e40\u0e27\u0e34\u0e23\u0e4c\u0e04","create_article":"\u0e2a\u0e23\u0e49\u0e32\u0e07\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21","crop_image":"\u0e15\u0e31\u0e14\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e","crop_ratio":"\u0e15\u0e31\u0e14\u0e2a\u0e31\u0e14\u0e2a\u0e48\u0e27\u0e19:","crop_too_small":"\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e40\u0e25\u0e47\u0e01\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b","date":"\u0e27\u0e31\u0e19\u0e17\u0e35\u0e48:","delete":"\u0e25\u0e1a\u0e2d\u0e2d\u0e01","delete_article":"\u0e25\u0e1a\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e19\u0e35\u0e49","discard":"\u0e22\u0e01\u0e40\u0e25\u0e34\u0e01","discard_confirmation":"\u0e04\u0e38\u0e13\u0e41\u0e19\u0e48\u0e43\u0e08\u0e2b\u0e23\u0e37\u0e2d\u0e17\u0e35\u0e48\u0e08\u0e30\u0e22\u0e01\u0e40\u0e25\u0e34\u0e01\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e19\u0e35\u0e49","draft":"\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01","drag":"\u0e25\u0e32\u0e01\u0e23\u0e39\u0e1b\u0e2b\u0e23\u0e37\u0e2d\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d\u0e21\u0e32\u0e15\u0e23\u0e07\u0e19\u0e35\u0e49","drag_all":"\u0e25\u0e32\u0e01\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e, \u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d \u0e2b\u0e23\u0e37\u0e2d\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e08\u0e32\u0e01 \u0e42\u0e0b\u0e40\u0e0a\u0e35\u0e22\u0e25\u0e40\u0e19\u0e47\u0e15\u0e40\u0e27\u0e34\u0e23\u0e4c\u0e04 \u0e21\u0e32\u0e43\u0e2a\u0e48\u0e17\u0e35\u0e48\u0e19\u0e35\u0e48","drag_crop":"\u0e25\u0e32\u0e01\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e08\u0e31\u0e14\u0e15\u0e33\u0e41\u0e2b\u0e19\u0e48\u0e07\u0e43\u0e2b\u0e21\u0e48","drop_here":"\u0e27\u0e32\u0e07\u0e15\u0e23\u0e07\u0e19\u0e35\u0e49...","drop_image":"\u0e27\u0e32\u0e07\u0e23\u0e39\u0e1b\u0e15\u0e23\u0e07\u0e19\u0e35\u0e49","edit_crop":"\u0e02\u0e22\u0e31\u0e1a\u0e2b\u0e23\u0e37\u0e2d\u0e1b\u0e23\u0e31\u0e1a\u0e02\u0e19\u0e32\u0e14\u0e2a\u0e35\u0e48\u0e40\u0e2b\u0e25\u0e35\u0e48\u0e22\u0e21\u0e1c\u0e37\u0e19\u0e1c\u0e49\u0e32\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e41\u0e01\u0e49\u0e44\u0e02\u0e20\u0e32\u0e1e\u0e15\u0e31\u0e27\u0e2d\u0e22\u0e48\u0e32\u0e07","edit_thumb":"\u0e41\u0e01\u0e49\u0e44\u0e02\u0e20\u0e32\u0e1e\u0e15\u0e31\u0e27\u0e2d\u0e22\u0e48\u0e32\u0e07","editor":"\u0e1c\u0e39\u0e49\u0e40\u0e23\u0e35\u0e22\u0e1a\u0e40\u0e23\u0e35\u0e22\u0e07:","embed":"\u0e1d\u0e31\u0e07\u0e25\u0e34\u0e07\u0e01\u0e4c","embed_code":"\u0e42\u0e04\u0e49\u0e14\u0e1d\u0e31\u0e07","embed_only":"\u0e27\u0e32\u0e07\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e15\u0e23\u0e07\u0e19\u0e35\u0e49","embed_video":"\u0e1d\u0e31\u0e07\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d","enter_desc":"\u0e40\u0e15\u0e34\u0e21\u0e04\u0e33\u0e2d\u0e18\u0e34\u0e1a\u0e32\u0e22\u0e15\u0e23\u0e07\u0e19\u0e35\u0e49...","enter_title":"\u0e40\u0e15\u0e34\u0e21\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d\u0e15\u0e23\u0e07\u0e19\u0e35\u0e49...","enter_url":"\u0e27\u0e32\u0e07 URL \u0e2b\u0e23\u0e37\u0e2d\u0e42\u0e04\u0e49\u0e14\u0e17\u0e35\u0e48\u0e19\u0e35\u0e48","facebook_cover_image":"\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e2b\u0e19\u0e49\u0e32\u0e1b\u0e01\u0e40\u0e1f\u0e0b\u0e1a\u0e38\u0e4a\u0e04","ftbpro_editor":"\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e19\u0e31\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19 FTBpro","grammar_spelling":"\u0e42\u0e1b\u0e23\u0e14\u0e2a\u0e25\u0e30\u0e40\u0e27\u0e25\u0e32\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e15\u0e23\u0e27\u0e08\u0e2a\u0e2d\u0e1a\u0e04\u0e27\u0e32\u0e21\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07\u0e02\u0e2d\u0e07\u0e15\u0e31\u0e27\u0e2a\u0e30\u0e01\u0e14\u0e41\u0e25\u0e30\u0e44\u0e27\u0e22\u0e32\u0e01\u0e23\u0e13\u0e4c","great":"\u0e22\u0e2d\u0e14\u0e40\u0e22\u0e35\u0e48\u0e22\u0e21!","guide_tips":"\u0e2d\u0e48\u0e32\u0e19\u0e41\u0e19\u0e27\u0e17\u0e32\u0e07\u0e41\u0e25\u0e30\u0e40\u0e17\u0e04\u0e19\u0e34\u0e04\u0e08\u0e32\u0e01\u0e40\u0e23\u0e32","guide_tips_links":"http://www.90min.com/blog/guidelines-thai/","h2_tooltip":"\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d","header_edit":"\u0e41\u0e01\u0e49\u0e44\u0e02\u0e42\u0e1e\u0e2a\u0e15\u0e4c","header_new":"\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e43\u0e2b\u0e21\u0e48","hyperlink_tooltip":"\u0e25\u0e34\u0e07\u0e01\u0e4c","image_bank":"\u0e04\u0e25\u0e31\u0e07\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e","image_crop":"\u0e15\u0e31\u0e14","image_format":"\u0e23\u0e31\u0e1a\u0e40\u0e09\u0e1e\u0e32\u0e30\u0e20\u0e32\u0e1e\u0e43\u0e19\u0e23\u0e39\u0e1b\u0e41\u0e1a\u0e1a\u0e44\u0e1f\u0e25\u0e4c JPEG, PNG \u0e41\u0e25\u0e30 gif \u0e40\u0e17\u0e48\u0e32\u0e19\u0e31\u0e49\u0e19","image_search":"\u0e04\u0e49\u0e19\u0e2b\u0e32","image_size":"\u0e04\u0e27\u0e32\u0e21\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14\u0e02\u0e2d\u0e07\u0e20\u0e32\u0e1e\u0e44\u0e21\u0e48\u0e04\u0e27\u0e23\u0e40\u0e01\u0e34\u0e19\u0e01\u0e27\u0e48\u0e32 500x280 \u0e1e\u0e34\u0e01\u0e40\u0e0b\u0e25","image_size_parameterized":"\u0e04\u0e27\u0e32\u0e21\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14\u0e02\u0e2d\u0e07\u0e20\u0e32\u0e1e\u0e44\u0e21\u0e48\u0e04\u0e27\u0e23\u0e40\u0e01\u0e34\u0e19\u0e01\u0e27\u0e48\u0e32 %{width}x%{height} \u0e1e\u0e34\u0e01\u0e40\u0e0b\u0e25","image_video":"\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e41\u0e25\u0e30\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d","image_weight":"\u0e44\u0e1f\u0e25\u0e4c\u0e19\u0e35\u0e49\u0e43\u0e2b\u0e0d\u0e48\u0e40\u0e01\u0e34\u0e19\u0e01\u0e27\u0e48\u0e32\u0e17\u0e35\u0e48\u0e01\u0e33\u0e2b\u0e19\u0e14\u0e44\u0e27\u0e49 \u0e02\u0e19\u0e32\u0e14\u0e02\u0e2d\u0e07\u0e44\u0e1f\u0e25\u0e4c\u0e04\u0e37\u0e2d %{fileSizeMaxSupported}","insert_link":"\u0e27\u0e32\u0e07\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e15\u0e23\u0e07\u0e19\u0e35\u0e49","invalid_code":"\u0e23\u0e30\u0e1a\u0e1a\u0e44\u0e21\u0e48\u0e23\u0e2d\u0e07\u0e23\u0e31\u0e1a URL \u0e2b\u0e23\u0e37\u0e2d\u0e42\u0e04\u0e49\u0e14\u0e19\u0e35\u0e49 \u0e01\u0e23\u0e38\u0e13\u0e32\u0e43\u0e0a\u0e49 URL \u0e2b\u0e23\u0e37\u0e2d\u0e42\u0e04\u0e49\u0e14\u0e17\u0e35\u0e48\u0e23\u0e30\u0e1a\u0e1a\u0e23\u0e2d\u0e07\u0e23\u0e31\u0e1a\u0e40\u0e17\u0e48\u0e32\u0e19\u0e31\u0e49\u0e19","leave":"\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e2b\u0e19\u0e49\u0e32\u0e19\u0e35\u0e49","leave_warning":"\u0e04\u0e38\u0e13\u0e1e\u0e22\u0e32\u0e22\u0e32\u0e21\u0e17\u0e35\u0e48\u0e08\u0e30\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e2b\u0e19\u0e49\u0e32\u0e19\u0e35\u0e49\u0e42\u0e14\u0e22\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01  \u0e01\u0e32\u0e23\u0e40\u0e1b\u0e25\u0e35\u0e48\u0e22\u0e19\u0e41\u0e1b\u0e25\u0e07\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14\u0e08\u0e30\u0e2a\u0e39\u0e0d\u0e2b\u0e32\u0e22\u0e44\u0e1b","list_tooltip":"\u0e25\u0e33\u0e14\u0e31\u0e1a\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23\u0e41\u0e1a\u0e1a\u0e44\u0e21\u0e48\u0e40\u0e23\u0e35\u0e22\u0e07\u0e25\u0e33\u0e14\u0e31\u0e1a\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25","max":"(\u0e44\u0e21\u0e48\u0e40\u0e01\u0e34\u0e19 %{num})","max_reached":"(\u0e40\u0e01\u0e34\u0e19\u0e08\u0e33\u0e19\u0e27\u0e19\u0e17\u0e35\u0e48\u0e01\u0e33\u0e2b\u0e19\u0e14)","media_longer":"(\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e17\u0e35\u0e48\u0e22\u0e32\u0e27\u0e01\u0e27\u0e48\u0e32 200 \u0e04\u0e33)","media_longer_than":"(\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e17\u0e35\u0e48\u0e22\u0e32\u0e27\u0e01\u0e27\u0e48\u0e32 300 \u0e04\u0e33)","media_post":"\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e2a\u0e37\u0e48\u0e2d","min":"(\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e15\u0e48\u0e33 %{num})","min_words":"(\u0e15\u0e49\u0e2d\u0e07\u0e44\u0e21\u0e48\u0e15\u0e48\u0e33\u0e01\u0e27\u0e48\u0e32 %{num} \u0e04\u0e33)","no_draft":"\u0e44\u0e21\u0e48\u0e21\u0e35\u0e41\u0e1a\u0e1a\u0e23\u0e48\u0e32\u0e07\u0e17\u0e35\u0e48\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e44\u0e27\u0e49","num_words":"%{count} \u0e04\u0e33","number_list_tooltip":"\u0e25\u0e33\u0e14\u0e31\u0e1a\u0e23\u0e32\u0e22\u0e01\u0e32\u0e23\u0e41\u0e1a\u0e1a\u0e40\u0e23\u0e35\u0e22\u0e07\u0e25\u0e33\u0e14\u0e31\u0e1a\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25","oops":"\u0e40\u0e01\u0e37\u0e2d\u0e1a\u0e08\u0e30\u0e40\u0e2a\u0e23\u0e47\u0e08\u0e41\u0e25\u0e49\u0e27...","optimal_article":"(\u0e40\u0e2b\u0e21\u0e32\u0e30\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14 300-800)","optimal_length":"(\u0e40\u0e2b\u0e21\u0e32\u0e30\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14 %{min}-%{max})","optional":"(\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e43\u0e2a\u0e48\u0e44\u0e14\u0e49\u0e44\u0e21\u0e48\u0e40\u0e01\u0e34\u0e19 160 \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)","optional_field":"\u0e04\u0e33\u0e2d\u0e18\u0e34\u0e1a\u0e32\u0e22\u0e02\u0e2d\u0e07\u0e1c\u0e39\u0e49\u0e23\u0e31\u0e01\u0e29\u0e32\u0e1b\u0e23\u0e30\u0e15\u0e39\u0e08\u0e30\u0e43\u0e2a\u0e48\u0e2b\u0e23\u0e37\u0e2d\u0e44\u0e21\u0e48\u0e01\u0e47\u0e44\u0e14\u0e49","or":"\u0e2b\u0e23\u0e37\u0e2d","p_tooltip":"\u0e22\u0e48\u0e2d\u0e2b\u0e19\u0e49\u0e32","paste_embed":"\u0e27\u0e32\u0e07\u0e42\u0e04\u0e4a\u0e14\u0e1d\u0e31\u0e07\u0e15\u0e23\u0e07\u0e19\u0e35\u0e49","paste_url":"\u0e27\u0e32\u0e07 URL \u0e2b\u0e23\u0e37\u0e2d\u0e42\u0e04\u0e49\u0e14\u0e1d\u0e31\u0e07","playbuzz":"\u0e27\u0e32\u0e07 URL \u0e02\u0e2d\u0e07\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e17\u0e35\u0e48\u0e40\u0e02\u0e35\u0e22\u0e19\u0e1a\u0e19 PlayBuzz \u0e17\u0e35\u0e48\u0e19\u0e35\u0e48","polls":"\u0e25\u0e07\u0e04\u0e30\u0e41\u0e19\u0e19\u0e40\u0e2a\u0e35\u0e22\u0e07","prev":"\u0e1e\u0e23\u0e35\u0e27\u0e34\u0e27","preview":"\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01 \u0e41\u0e25\u0e30 \u0e1e\u0e23\u0e35\u0e27\u0e34\u0e27","publish":"\u0e42\u0e1e\u0e2a\u0e15\u0e4c","remove_attachment":"\u0e04\u0e38\u0e13\u0e41\u0e19\u0e48\u0e43\u0e08\u0e2b\u0e23\u0e37\u0e2d\u0e44\u0e21\u0e48\u0e27\u0e48\u0e32\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e25\u0e1a\u0e44\u0e1f\u0e25\u0e4c\u0e41\u0e19\u0e1a\u0e19\u0e35\u0e49","reset":"\u0e23\u0e35\u0e40\u0e0b\u0e47\u0e15","review":"\u0e41\u0e2a\u0e14\u0e07\u0e15\u0e31\u0e27\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e01\u0e48\u0e2d\u0e19\u0e42\u0e1e\u0e2a\u0e15\u0e4c","save_changes":"\u0e22\u0e37\u0e19\u0e22\u0e31\u0e19 ?","save_draft":"\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e40\u0e1b\u0e47\u0e19\u0e09\u0e1a\u0e31\u0e1a\u0e23\u0e48\u0e32\u0e07","search_bank":"\u0e1e\u0e34\u0e21\u0e1e\u0e4c\u0e0a\u0e37\u0e48\u0e2d\u0e19\u0e31\u0e01\u0e40\u0e15\u0e30\u0e2b\u0e23\u0e37\u0e2d\u0e17\u0e35\u0e21\u0e17\u0e35\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e04\u0e49\u0e19\u0e2b\u0e32","search_for":"\u0e04\u0e49\u0e19\u0e2b\u0e32","searching":"\u0e01\u0e33\u0e25\u0e31\u0e07\u0e04\u0e49\u0e19\u0e2b\u0e32...","select_photo":"\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e","seo_desc":"\u0e04\u0e33\u0e2d\u0e18\u0e34\u0e1a\u0e32\u0e22 SEO","share":"\u0e41\u0e0a\u0e23\u0e4c\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e19\u0e35\u0e49\u0e1a\u0e19\u0e40\u0e1f\u0e2a\u0e1a\u0e38\u0e4a\u0e04","small_image":"\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e21\u0e35\u0e02\u0e19\u0e32\u0e14\u0e40\u0e25\u0e47\u0e01\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b \u0e04\u0e27\u0e23\u0e43\u0e0a\u0e49\u0e20\u0e32\u0e1e\u0e17\u0e35\u0e48\u0e21\u0e35\u0e02\u0e19\u0e32\u0e14\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e15\u0e48\u0e33 300x150","source":"\u0e41\u0e2b\u0e25\u0e48\u0e07\u0e17\u0e35\u0e48\u0e21\u0e32:","start_at":"\u0e40\u0e23\u0e34\u0e48\u0e21\u0e40\u0e21\u0e37\u0e48\u0e2d","stay":"\u0e2d\u0e22\u0e39\u0e48\u0e17\u0e35\u0e48\u0e2b\u0e19\u0e49\u0e32\u0e19\u0e35\u0e49\u0e15\u0e48\u0e2d","steps_complete":"\u0e02\u0e13\u0e30\u0e19\u0e35\u0e49\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e01\u0e32\u0e23\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e41\u0e25\u0e49\u0e27","styling_tooltip":"\u0e16\u0e2d\u0e14\u0e01\u0e32\u0e23\u0e2d\u0e2d\u0e01\u0e41\u0e1a\u0e1a","tag":"\u0e41\u0e17\u0e47\u0e01","tag_at_least":"(\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e19\u0e49\u0e2d\u0e22 1 \u0e41\u0e17\u0e47\u0e01)","tag_sug":"\u0e41\u0e17\u0e47\u0e01\u0e04\u0e33\u0e41\u0e19\u0e30\u0e19\u0e33","tag_team":"\u0e41\u0e17\u0e47\u0e01","teaser":"\u0e17\u0e35\u0e40\u0e0b\u0e2d\u0e23\u0e4c","teaser_watermark":"\u0e08\u0e30\u0e1b\u0e23\u0e32\u0e01\u0e0f\u0e43\u0e19\u0e23\u0e39\u0e1b\u0e41\u0e1a\u0e1a\u0e02\u0e2d\u0e07\u0e04\u0e33\u0e2d\u0e18\u0e34\u0e1a\u0e32\u0e22\u0e1a\u0e19\u0e25\u0e34\u0e07\u0e04\u0e4c\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e40\u0e17\u0e48\u0e32\u0e19\u0e31\u0e49\u0e19","this_is_preview":"\u0e19\u0e35\u0e48\u0e04\u0e37\u0e2d\u0e15\u0e31\u0e27\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e02\u0e2d\u0e07\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13","tip_controversial ":"\u0e2b\u0e32\u0e01\u0e22\u0e31\u0e07\u0e21\u0e35\u0e02\u0e49\u0e2d\u0e16\u0e01\u0e40\u0e16\u0e35\u0e22\u0e07\u0e2b\u0e23\u0e37\u0e2d\u0e02\u0e49\u0e2d\u0e42\u0e15\u0e49\u0e40\u0e40\u0e22\u0e49\u0e07 \u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e17\u0e35\u0e48\u0e14\u0e35\u0e21\u0e35\u0e1b\u0e23\u0e30\u0e2a\u0e34\u0e17\u0e18\u0e34\u0e20\u0e32\u0e1e\u0e08\u0e30\u0e01\u0e48\u0e2d\u0e43\u0e2b\u0e49\u0e40\u0e01\u0e34\u0e14\u0e1b\u0e23\u0e30\u0e40\u0e14\u0e47\u0e19\u0e04\u0e33\u0e16\u0e32\u0e21\u0e17\u0e35\u0e48\u0e22\u0e32\u0e01\u0e43\u0e19\u0e01\u0e32\u0e23\u0e2b\u0e32\u0e02\u0e49\u0e2d\u0e40\u0e40\u0e01\u0e49\u0e15\u0e48\u0e32\u0e07\u0e17\u0e35\u0e48\u0e08\u0e30\u0e19\u0e33\u0e44\u0e1b\u0e2a\u0e39\u0e48\u0e08\u0e38\u0e14\u0e2b\u0e21\u0e32\u0e22","tip_image":"\u0e40\u0e15\u0e34\u0e21\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e \u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e17\u0e35\u0e48\u0e21\u0e35\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e1b\u0e23\u0e30\u0e01\u0e2d\u0e1a\u0e19\u0e31\u0e49\u0e19\u0e08\u0e30\u0e14\u0e36\u0e07\u0e14\u0e39\u0e14\u0e1c\u0e39\u0e49\u0e2d\u0e48\u0e32\u0e19\u0e44\u0e14\u0e49\u0e21\u0e32\u0e01\u0e22\u0e34\u0e48\u0e07\u0e02\u0e36\u0e49\u0e19","tip_media":"\u0e21\u0e35\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d\u0e40\u0e14\u0e47\u0e14\u0e46\u0e44\u0e2b\u0e21 \u0e04\u0e25\u0e34\u0e1b\u0e08\u0e32\u0e01\u0e22\u0e39\u0e17\u0e39\u0e1b \u0e2b\u0e23\u0e37\u0e2d \u0e40\u0e21\u0e15\u0e32\u0e04\u0e32\u0e40\u0e1f\u0e48 \u0e44\u0e14\u0e49\u0e23\u0e31\u0e1a\u0e1b\u0e0f\u0e34\u0e01\u0e34\u0e23\u0e34\u0e22\u0e32\u0e15\u0e2d\u0e1a\u0e01\u0e25\u0e31\u0e1a\u0e17\u0e35\u0e48\u0e14\u0e35\u0e08\u0e32\u0e01\u0e1c\u0e39\u0e49\u0e0a\u0e21","tip_short":"\u0e04\u0e27\u0e23\u0e04\u0e27\u0e1a\u0e04\u0e38\u0e21\u0e04\u0e27\u0e32\u0e21\u0e22\u0e32\u0e27\u0e02\u0e2d\u0e07\u0e22\u0e48\u0e2d\u0e2b\u0e19\u0e49\u0e32 \u0e1c\u0e39\u0e49\u0e2d\u0e48\u0e32\u0e19\u0e21\u0e31\u0e01\u0e08\u0e30\u0e40\u0e21\u0e34\u0e19\u0e22\u0e48\u0e2d\u0e2b\u0e19\u0e49\u0e32\u0e17\u0e35\u0e48\u0e22\u0e32\u0e27\u0e08\u0e19\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b","tips":{"media_close_ups":"\u0e2b\u0e32\u0e01\u0e40\u0e1b\u0e47\u0e19\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e15\u0e31\u0e27\u0e19\u0e31\u0e01\u0e40\u0e15\u0e30 \u0e41\u0e19\u0e30\u0e19\u0e33\u0e43\u0e2b\u0e49\u0e43\u0e0a\u0e49\u0e20\u0e32\u0e1e\u0e17\u0e35\u0e48\u0e16\u0e48\u0e32\u0e22\u0e43\u0e19\u0e23\u0e30\u0e22\u0e30\u0e43\u0e01\u0e25\u0e49","media_image_bank":"\u0e40\u0e23\u0e32\u0e41\u0e19\u0e30\u0e19\u0e33\u0e43\u0e2b\u0e49\u0e04\u0e38\u0e13\u0e04\u0e49\u0e19\u0e2b\u0e32\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e\u0e17\u0e35\u0e48\u0e04\u0e38\u0e13\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e08\u0e32\u0e01\u0e04\u0e25\u0e31\u0e07 Getty Image \u0e42\u0e14\u0e22\u0e04\u0e49\u0e19\u0e2b\u0e32\u0e1c\u0e48\u0e32\u0e19\u0e0a\u0e37\u0e48\u0e2d\u0e02\u0e2d\u0e07\u0e19\u0e31\u0e01\u0e40\u0e15\u0e30 \u0e2b\u0e23\u0e37\u0e2d \u0e17\u0e35\u0e21","post_enjoy":"\u0e2a\u0e34\u0e48\u0e07\u0e17\u0e35\u0e48\u0e2a\u0e33\u0e04\u0e31\u0e0d\u0e17\u0e35\u0e48\u0e2a\u0e38\u0e14\u0e04\u0e37\u0e2d \u0e08\u0e07\u0e2a\u0e19\u0e38\u0e01\u0e01\u0e31\u0e1a\u0e21\u0e31\u0e19!","post_original":"\u0e08\u0e07\u0e41\u0e2a\u0e14\u0e07\u0e04\u0e27\u0e32\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e15\u0e49\u0e19\u0e09\u0e1a\u0e31\u0e1a \u0e40\u0e23\u0e32\u0e44\u0e21\u0e48\u0e23\u0e31\u0e1a\u0e40\u0e19\u0e37\u0e49\u0e2d\u0e2b\u0e32\u0e17\u0e35\u0e48\u0e04\u0e31\u0e14\u0e25\u0e2d\u0e01\u0e21\u0e32\u0e08\u0e32\u0e01\u0e41\u0e2b\u0e25\u0e48\u0e07\u0e2a\u0e32\u0e23\u0e2d\u0e37\u0e48\u0e19","post_paragraphs":"\u0e43\u0e0a\u0e49\u0e22\u0e48\u0e2d\u0e2b\u0e19\u0e49\u0e32\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e41\u0e1a\u0e48\u0e07\u0e2a\u0e31\u0e14\u0e2a\u0e48\u0e27\u0e19\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13","post_review":"\u0e01\u0e23\u0e38\u0e13\u0e32\u0e15\u0e23\u0e27\u0e08\u0e2a\u0e2d\u0e1a\u0e04\u0e27\u0e32\u0e21\u0e16\u0e39\u0e01\u0e15\u0e49\u0e2d\u0e07\u0e02\u0e2d\u0e07\u0e15\u0e31\u0e27\u0e2a\u0e30\u0e01\u0e14 \u0e41\u0e25\u0e30 \u0e44\u0e27\u0e22\u0e32\u0e01\u0e23\u0e13\u0e4c\u0e43\u0e19\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e01\u0e48\u0e2d\u0e19\u0e42\u0e1e\u0e2a\u0e15\u0e4c","title":"\u0e40\u0e04\u0e25\u0e47\u0e14\u0e25\u0e31\u0e1a\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e08\u0e33\u0e19\u0e27\u0e19\u0e1c\u0e39\u0e49\u0e2d\u0e48\u0e32\u0e19:","title_debatable":"\u0e43\u0e2b\u0e49\u0e40\u0e40\u0e2a\u0e14\u0e07\u0e2d\u0e2d\u0e01\u0e14\u0e49\u0e27\u0e22\u0e01\u0e32\u0e23\u0e43\u0e0a\u0e49\u0e27\u0e34\u0e18\u0e35\u0e40\u0e40\u0e2a\u0e14\u0e07\u0e04\u0e27\u0e32\u0e21\u0e04\u0e34\u0e14\u0e40\u0e2b\u0e47\u0e19 (\u0e0b\u0e36\u0e48\u0e07\u0e19\u0e48\u0e32\u0e08\u0e30\u0e21\u0e35\u0e2a\u0e2d\u0e07\u0e1d\u0e48\u0e32\u0e22\u0e17\u0e35\u0e48\u0e02\u0e31\u0e14\u0e40\u0e40\u0e22\u0e49\u0e07\u0e01\u0e31\u0e19) \u0e40\u0e40\u0e25\u0e49\u0e27\u0e40\u0e2a\u0e19\u0e2d\u0e2d\u0e2d\u0e01\u0e21\u0e32\u0e43\u0e2b\u0e49\u0e40\u0e15\u0e47\u0e21\u0e17\u0e35\u0e48 \u0e40\u0e1e\u0e23\u0e32\u0e30\u0e27\u0e48\u0e32\u0e42\u0e14\u0e22\u0e2a\u0e48\u0e27\u0e19\u0e43\u0e2b\u0e0d\u0e48 (\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e21\u0e35\u0e04\u0e19\u0e04\u0e34\u0e14\u0e40\u0e2b\u0e47\u0e19\u0e44\u0e21\u0e48\u0e15\u0e23\u0e07\u0e01\u0e31\u0e19) \u0e1b\u0e23\u0e30\u0e40\u0e14\u0e47\u0e19\u0e19\u0e31\u0e49\u0e19\u0e46 \u0e21\u0e31\u0e01\u0e08\u0e30\u0e40\u0e1b\u0e47\u0e19\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d\u0e17\u0e35\u0e48\u0e04\u0e19\u0e19\u0e33\u0e21\u0e32\u0e16\u0e01\u0e40\u0e16\u0e35\u0e22\u0e07\u0e42\u0e15\u0e49\u0e41\u0e22\u0e49\u0e07\u0e01\u0e31\u0e19","title_known_name":"\u0e40\u0e23\u0e34\u0e48\u0e21\u0e15\u0e49\u0e19\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e14\u0e49\u0e27\u0e22\u0e0a\u0e37\u0e48\u0e2d\u0e19\u0e31\u0e01\u0e40\u0e15\u0e30 \u0e2b\u0e23\u0e37\u0e2d\u0e0a\u0e37\u0e48\u0e2d\u0e17\u0e35\u0e21","title_popular_terms":"\u0e43\u0e0a\u0e49\u0e04\u0e33\u0e17\u0e35\u0e48\u0e40\u0e1b\u0e47\u0e19\u0e17\u0e35\u0e48\u0e19\u0e34\u0e22\u0e21 \u0e40\u0e0a\u0e48\u0e19 \u0e0a\u0e37\u0e48\u0e2d\u0e40\u0e15\u0e47\u0e21\u0e02\u0e2d\u0e07\u0e19\u0e31\u0e01\u0e40\u0e15\u0e30 \u0e0a\u0e37\u0e48\u0e2d\u0e17\u0e35\u0e21 \u0e2b\u0e23\u0e37\u0e2d\u0e1b\u0e23\u0e30\u0e40\u0e14\u0e47\u0e19\u0e23\u0e49\u0e2d\u0e19","title_question":"\u0e16\u0e32\u0e21\u0e04\u0e33\u0e16\u0e32\u0e21\u0e17\u0e35\u0e48\u0e04\u0e38\u0e13\u0e08\u0e30\u0e15\u0e2d\u0e1a\u0e43\u0e19\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13","title_short":"\u0e40\u0e02\u0e35\u0e22\u0e19\u0e43\u0e2b\u0e49\u0e2a\u0e31\u0e49\u0e19 \u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d\u0e17\u0e35\u0e48\u0e14\u0e35\u0e04\u0e27\u0e23\u0e21\u0e35\u0e08\u0e33\u0e19\u0e27\u0e19\u0e04\u0e33\u0e23\u0e30\u0e2b\u0e27\u0e48\u0e32\u0e07 5-8 \u0e04\u0e33"},"title":"\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d","too_long":"\u0e22\u0e32\u0e27\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b (\u0e04\u0e27\u0e23\u0e43\u0e0a\u0e49 10-75 \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)","too_short":"\u0e2a\u0e31\u0e49\u0e19\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b (\u0e04\u0e27\u0e23\u0e43\u0e0a\u0e49 10-75 \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)","toolong":"\u0e22\u0e32\u0e27\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b (\u0e04\u0e27\u0e23\u0e43\u0e0a\u0e49 %{min}-%{max} \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)","tooshort":"\u0e2a\u0e31\u0e49\u0e19\u0e40\u0e01\u0e34\u0e19\u0e44\u0e1b (\u0e04\u0e27\u0e23\u0e43\u0e0a\u0e49 %{min}-%{max} \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23)","try_again":"\u0e25\u0e2d\u0e07\u0e2d\u0e35\u0e01\u0e04\u0e23\u0e31\u0e49\u0e07","upload_failed":"\u0e40\u0e01\u0e34\u0e14\u0e1b\u0e31\u0e0d\u0e2b\u0e32\u0e02\u0e36\u0e49\u0e19\u0e23\u0e30\u0e2b\u0e27\u0e48\u0e32\u0e07\u0e2d\u0e31\u0e1b\u0e42\u0e2b\u0e25\u0e14\u0e23\u0e39\u0e1b\u0e20\u0e32\u0e1e \u0e01\u0e23\u0e38\u0e13\u0e32\u0e25\u0e2d\u0e07\u0e2d\u0e35\u0e01\u0e04\u0e23\u0e31\u0e49\u0e07","upload_image":"\u0e2d\u0e31\u0e1b\u0e42\u0e2b\u0e25\u0e14\u0e16\u0e32\u0e1e\u0e16\u0e48\u0e32\u0e22","upload_img":"\u0e2d\u0e31\u0e1b\u0e42\u0e2b\u0e25\u0e14\u0e20\u0e32\u0e1e","valid_code":"\u0e42\u0e04\u0e49\u0e14\u0e1d\u0e31\u0e07\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e19\u0e31\u0e49\u0e19\u0e43\u0e0a\u0e49\u0e01\u0e32\u0e23\u0e44\u0e21\u0e48\u0e44\u0e14\u0e49","video":"\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d","video_provider":"\u0e40\u0e23\u0e32\u0e22\u0e31\u0e07\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e23\u0e2d\u0e07\u0e23\u0e31\u0e1a\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d\u0e08\u0e32\u0e01\u0e1c\u0e39\u0e49\u0e43\u0e2b\u0e49\u0e1a\u0e23\u0e34\u0e01\u0e32\u0e23\u0e19\u0e35\u0e49","video_services":"\u0e27\u0e32\u0e07\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e08\u0e32\u0e01\u0e22\u0e39\u0e17\u0e39\u0e1b,\u0e40\u0e14\u0e25\u0e35\u0e48\u0e42\u0e21\u0e0a\u0e31\u0e48\u0e19 \u0e2b\u0e23\u0e37\u0e2d\u0e40\u0e21\u0e15\u0e32\u0e04\u0e32\u0e40\u0e1f\u0e48 \u0e17\u0e35\u0e48\u0e19\u0e35\u0e48","video_url":"\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d URL (\u0e22\u0e39\u0e17\u0e39\u0e1b \u0e40\u0e14\u0e25\u0e35\u0e48\u0e42\u0e21\u0e0a\u0e31\u0e48\u0e19 \u0e40\u0e21\u0e15\u0e32\u0e04\u0e32\u0e40\u0e1f\u0e48 \u0e2f\u0e25\u0e2f)","word_count":"\u0e19\u0e31\u0e1a\u0e08\u0e33\u0e19\u0e27\u0e19\u0e04\u0e33: %{num}","writing_sug":"SEO \u0e17\u0e35\u0e48\u0e41\u0e19\u0e30\u0e19\u0e33","writing_tips":"\u0e40\u0e04\u0e25\u0e47\u0e14\u0e25\u0e31\u0e1a\u0e2a\u0e33\u0e2b\u0e23\u0e31\u0e1a\u0e01\u0e32\u0e23\u0e40\u0e02\u0e35\u0e22\u0e19\u0e17\u0e35\u0e48\u0e14\u0e35","your_post":"\u0e40\u0e19\u0e37\u0e49\u0e2d\u0e2b\u0e32\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13"},"embed":{"button":"\u0e1d\u0e31\u0e07\u0e25\u0e34\u0e07\u0e01\u0e4c","dialogue":{"additional_options":"\u0e15\u0e31\u0e27\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21","become_a_partner":"\u0e23\u0e48\u0e27\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e1e\u0e32\u0e23\u0e4c\u0e17\u0e40\u0e19\u0e2d\u0e23\u0e4c","comments":"\u0e14\u0e39\u0e04\u0e27\u0e32\u0e21\u0e40\u0e2b\u0e47\u0e19\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14","customise_collapse/expand":"\u0e1b\u0e23\u0e31\u0e1a\u0e41\u0e15\u0e48\u0e07\u0e42\u0e04\u0e49\u0e14","disclaimer":"\u0e04\u0e38\u0e13\u0e44\u0e14\u0e49\u0e22\u0e2d\u0e21\u0e23\u0e31\u0e1a %{terms_conditions} \u0e43\u0e19\u0e01\u0e32\u0e23\u0e43\u0e0a\u0e49\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e1d\u0e31\u0e07\u0e40\u0e23\u0e35\u0e22\u0e1a\u0e23\u0e49\u0e2d\u0e22\u0e41\u0e25\u0e49\u0e27","embed_code":"\u0e27\u0e32\u0e07\u0e42\u0e04\u0e49\u0e14","embed_instructions":"\u0e41\u0e2a\u0e14\u0e07\u0e42\u0e1e\u0e2a\u0e15\u0e4c\u0e19\u0e35\u0e49\u0e02\u0e36\u0e49\u0e19\u0e1a\u0e19\u0e40\u0e27\u0e47\u0e1a\u0e44\u0e0b\u0e15\u0e4c\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e14\u0e49\u0e27\u0e22\u0e01\u0e32\u0e23 \u0e01\u0e47\u0e2d\u0e1b\u0e1b\u0e35\u0e49 \u0e41\u0e25\u0e30 \u0e27\u0e32\u0e07\u0e42\u0e04\u0e49\u0e14\u0e02\u0e49\u0e32\u0e07\u0e25\u0e48\u0e32\u0e07\u0e19\u0e35\u0e49","embed_instructions_partners":"\u0e01\u0e47\u0e2d\u0e1b\u0e1b\u0e35\u0e49 \u0e41\u0e25\u0e30 \u0e27\u0e32\u0e07 \u0e25\u0e34\u0e07\u0e01\u0e4c\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e02\u0e49\u0e32\u0e07\u0e25\u0e48\u0e32\u0e07\u0e19\u0e35\u0e49","full_title":"\u0e43\u0e0a\u0e49\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d\u0e41\u0e1a\u0e1a\u0e40\u0e15\u0e47\u0e21","header":"\u0e42\u0e1e\u0e2a\u0e15\u0e4c","info":"\u0e40\u0e2d\u0e32\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e02\u0e2d\u0e07 90min \u0e2d\u0e2d\u0e01 \u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e43\u0e2b\u0e49\u0e40\u0e2b\u0e47\u0e19\u0e40\u0e09\u0e1e\u0e32\u0e30\u0e1e\u0e32\u0e23\u0e4c\u0e17\u0e40\u0e19\u0e2d\u0e23\u0e4c","link":"\u0e41\u0e2a\u0e14\u0e07\u0e25\u0e34\u0e07\u0e01\u0e4c\u0e44\u0e1b\u0e17\u0e35\u0e48 90min","logged_in":"\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d %{email} \u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e40\u0e02\u0e49\u0e32\u0e23\u0e48\u0e27\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e1e\u0e32\u0e23\u0e4c\u0e17\u0e40\u0e19\u0e2d\u0e23\u0e4c\u0e01\u0e31\u0e1a\u0e40\u0e23\u0e32","login":"\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e39\u0e48\u0e23\u0e30\u0e1a\u0e1a","partner_message":"\u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e08\u0e30\u0e40\u0e1b\u0e47\u0e19\u0e1e\u0e32\u0e23\u0e4c\u0e17\u0e40\u0e19\u0e2d\u0e23\u0e4c\u0e2b\u0e23\u0e37\u0e2d\u0e22\u0e31\u0e07 ? %{login} \u0e41\u0e25\u0e49\u0e27\u0e23\u0e31\u0e1a\u0e42\u0e04\u0e49\u0e14\u0e2a\u0e48\u0e27\u0e19\u0e15\u0e31\u0e27\u0e44\u0e14\u0e49\u0e40\u0e25\u0e22","remove_title":"\u0e40\u0e2d\u0e32\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d\u0e2d\u0e2d\u0e01","show-author":"\u0e41\u0e2a\u0e14\u0e07\u0e0a\u0e37\u0e48\u0e2d\u0e1c\u0e39\u0e49\u0e40\u0e02\u0e35\u0e22\u0e19","show-date":"\u0e41\u0e2a\u0e14\u0e07\u0e27\u0e31\u0e19\u0e17\u0e35\u0e48","show-reads-counter":"\u0e41\u0e2a\u0e14\u0e07\u0e08\u0e33\u0e19\u0e27\u0e19\u0e1c\u0e39\u0e49\u0e40\u0e02\u0e49\u0e32\u0e0a\u0e21","show-title":"\u0e41\u0e2a\u0e14\u0e07\u0e0a\u0e37\u0e48\u0e2d\u0e40\u0e23\u0e37\u0e48\u0e2d\u0e07","terms_&_conditions":"\u0e02\u0e49\u0e2d\u0e15\u0e01\u0e25\u0e07\u0e41\u0e25\u0e30\u0e40\u0e07\u0e37\u0e48\u0e2d\u0e19\u0e44\u0e02","title":"\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d","views":"\u0e41\u0e2a\u0e14\u0e07\u0e08\u0e33\u0e19\u0e27\u0e19\u0e1c\u0e39\u0e49\u0e40\u0e02\u0e49\u0e32\u0e0a\u0e21"}},"footer":{"about_12up":"\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a 12up","about_90min":"\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a 90min","about_circasports":"\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a CircaSports","about_dbltap":null,"about_ei":null,"about_floor8":null,"about_ftb90":"\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a FTB90","about_ftbpro":"\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a","about_german_site":null,"about_ht_media":null,"about_pluralist":null,"about_swurley":"\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a Swurley","about_theduel":null,"affiliates":"\u0e1e\u0e31\u0e19\u0e18\u0e21\u0e34\u0e15\u0e23","apps":"\u0e41\u0e2d\u0e1e\u0e1a\u0e19\u0e21\u0e37\u0e2d\u0e16\u0e37\u0e2d","apps_Android":"\u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e14\u0e32\u0e27\u0e19\u0e4c\u0e42\u0e2b\u0e25\u0e14\u0e41\u0e25\u0e49\u0e27\u0e1a\u0e19","apps_iphone":"\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e42\u0e2b\u0e25\u0e14\u0e44\u0e14\u0e49\u0e1c\u0e48\u0e32\u0e19","blog":"\u0e1a\u0e25\u0e47\u0e2d\u0e01","boomerang":null,"cartoon":null,"contact_ftbpro":"\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e40\u0e23\u0e32","fan_store":"\u0e04\u0e25\u0e31\u0e07\u0e2a\u0e34\u0e19\u0e04\u0e49\u0e32\u0e08\u0e32\u0e01\u0e41\u0e1f\u0e19\u0e46","faq":"\u0e04\u0e33\u0e16\u0e32\u0e21\u0e17\u0e35\u0e48\u0e1e\u0e1a\u0e1a\u0e48\u0e2d\u0e22","house_rules":"\u0e01\u0e0e\u0e23\u0e30\u0e40\u0e1a\u0e35\u0e22\u0e1a","in_the_news":"\u0e43\u0e19\u0e27\u0e07\u0e02\u0e48\u0e32\u0e27\u0e2a\u0e32\u0e23","jobs":"\u0e2b\u0e32\u0e07\u0e32\u0e19","licensing":"\u0e01\u0e32\u0e23\u0e2d\u0e2d\u0e01\u0e43\u0e1a\u0e2d\u0e19\u0e38\u0e0d\u0e32\u0e15","links":"\u0e25\u0e34\u0e07\u0e01\u0e4c","links_social":"\u0e25\u0e34\u0e07\u0e01\u0e4c","more_about_12up":null,"more_about_90min":"\u0e2d\u0e48\u0e32\u0e19\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a 90min","more_about_circasports":"\u0e2d\u0e48\u0e32\u0e19\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a CircaSports","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":null,"more_about_ftb90":"\u0e2d\u0e48\u0e32\u0e19\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a FTB90","more_about_german_site":null,"more_about_ht_media":null,"more_about_pluralist":null,"more_about_swurley":"\u0e2d\u0e48\u0e32\u0e19\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a Swurley","more_about_theduel":null,"partner_sites":null,"partners":"\u0e1e\u0e32\u0e23\u0e4c\u0e17\u0e40\u0e19\u0e2d\u0e23\u0e4c","prev_prog":null,"privacy_policy":"\u0e19\u0e42\u0e22\u0e1a\u0e32\u0e22\u0e04\u0e27\u0e32\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e2a\u0e48\u0e27\u0e19\u0e15\u0e31\u0e27","rights_reserved":"\u0e2a\u0e07\u0e27\u0e19\u0e25\u0e34\u0e02\u0e2a\u0e34\u0e17\u0e18\u0e34\u0e4c","rights_reserved_year":"2016 FTBpro \u00a9 \u0e2a\u0e07\u0e27\u0e19\u0e25\u0e34\u0e02\u0e2a\u0e34\u0e17\u0e18\u0e34\u0e4c","rights_reserved_year_12up":null,"rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 \u0e2a\u0e07\u0e27\u0e19\u0e25\u0e34\u0e02\u0e2a\u0e34\u0e17\u0e18\u0e34\u0e4c","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports \u00a9 \u0e2a\u0e07\u0e27\u0e19\u0e25\u0e34\u0e02\u0e2a\u0e34\u0e17\u0e18\u0e34\u0e4c","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"Minute Media 2018 FTB90 \u00a9 \u0e2a\u0e07\u0e27\u0e19\u0e25\u0e34\u0e02\u0e2a\u0e34\u0e17\u0e18\u0e34\u0e4c","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":null,"rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"2016 Swurley \u00a9 \u0e2a\u0e07\u0e27\u0e19\u0e25\u0e34\u0e02\u0e2a\u0e34\u0e17\u0e18\u0e34\u0e4c","rights_reserved_year_theduel":null,"space":null,"statistics_12up":null,"statistics_90min":"\u0e2a\u0e16\u0e34\u0e15\u0e34\u0e02\u0e2d\u0e07 90min","statistics_circasports":"\u0e2a\u0e16\u0e34\u0e15\u0e34\u0e02\u0e2d\u0e07 CircaSports","statistics_ei":null,"statistics_floor8":null,"statistics_ftb90":"\u0e2a\u0e16\u0e34\u0e15\u0e34\u0e02\u0e2d\u0e07 FTB90","statistics_ht_media":null,"statistics_swurley":"\u0e2a\u0e16\u0e34\u0e15\u0e34\u0e02\u0e2d\u0e07 Swurley","statistics_theduel":null,"stats":{"articles":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21","fans":"\u0e41\u0e1f\u0e19\u0e46","members":"\u0e2a\u0e21\u0e32\u0e0a\u0e34\u0e01","writers":"\u0e19\u0e31\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19"},"support":"\u0e2a\u0e19\u0e31\u0e1a\u0e2a\u0e19\u0e38\u0e19","tbs":null,"tcm":null,"terms":"\u0e02\u0e49\u0e2d\u0e01\u0e33\u0e2b\u0e19\u0e14","terms_conditions":"\u0e02\u0e49\u0e2d\u0e01\u0e33\u0e2b\u0e19\u0e14\u0e41\u0e25\u0e30\u0e40\u0e07\u0e37\u0e48\u0e2d\u0e19\u0e44\u0e02","tnt":null,"warner":null,"writers":"\u0e19\u0e31\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19"},"header":{"profile":"\u0e42\u0e1b\u0e23\u0e44\u0e1f\u0e25\u0e4c\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19","settings":"\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32","signout":"\u0e2d\u0e2d\u0e01\u0e08\u0e32\u0e01\u0e23\u0e30\u0e1a\u0e1a"},"home":{"no_matches":"\u0e44\u0e21\u0e48\u0e21\u0e35\u0e41\u0e21\u0e15\u0e0a\u0e4c\u0e01\u0e32\u0e23\u0e41\u0e02\u0e48\u0e07\u0e02\u0e31\u0e19"},"homepage":{"be_the_first":"\u0e2d\u0e48\u0e32\u0e19\u0e02\u0e48\u0e32\u0e27\u0e43\u0e2b\u0e21\u0e48\u0e25\u0e48\u0e32\u0e2a\u0e38\u0e14\u0e44\u0e14\u0e49\u0e01\u0e48\u0e2d\u0e19\u0e43\u0e04\u0e23","by":"\u0e42\u0e14\u0e22 :","chrome_notifications":"\u0e17\u0e31\u0e19\u0e17\u0e38\u0e01\u0e01\u0e32\u0e23\u0e40\u0e04\u0e25\u0e37\u0e48\u0e2d\u0e19\u0e44\u0e2b\u0e27\u0e1c\u0e48\u0e32\u0e19\u0e23\u0e30\u0e1a\u0e1a\u0e41\u0e08\u0e49\u0e07\u0e40\u0e15\u0e37\u0e2d\u0e19\u0e02\u0e2d\u0e07 Google Chrome","ei":{"latest_news":null,"trending":null,"view_more":null},"fan_perspectives":"\u0e02\u0e48\u0e32\u0e27\u0e40\u0e14\u0e47\u0e14\u0e1b\u0e23\u0e30\u0e40\u0e14\u0e47\u0e19\u0e23\u0e49\u0e2d\u0e19","fan_voice":"\u0e40\u0e2a\u0e35\u0e22\u0e07\u0e08\u0e32\u0e01\u0e41\u0e1f\u0e19 \u0e46 ","featured_topic":null,"fixtures_and_scores":null,"fixtures_scores":"\u0e15\u0e32\u0e23\u0e32\u0e07 & \u0e1c\u0e25\u0e01\u0e32\u0e23\u0e41\u0e02\u0e48\u0e07","follow_us_on":"\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e1c\u0e48\u0e32\u0e19\u0e17\u0e32\u0e07 Snapchat :","latest_videos":"\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e43\u0e2b\u0e21\u0e48\u0e25\u0e48\u0e32\u0e2a\u0e38\u0e14","league_page":null,"match_day":"\u0e27\u0e31\u0e19\u0e41\u0e02\u0e48\u0e07 %{num}","month":"%M","more":"\u0e01\u0e35\u0e2c\u0e32\u0e2d\u0e37\u0e48\u0e19 \u0e46 ","most_read":"\u0e02\u0e48\u0e32\u0e27\u0e2e\u0e34\u0e15\u0e15\u0e34\u0e14\u0e25\u0e21\u0e1a\u0e19","no_matches":"\u0e44\u0e21\u0e48\u0e21\u0e35\u0e40\u0e01\u0e21\u0e01\u0e32\u0e23\u0e41\u0e02\u0e48\u0e07\u0e02\u0e31\u0e19\u0e43\u0e19\u0e27\u0e31\u0e19\u0e19\u0e35\u0e49","other_categories":"\u0e2b\u0e21\u0e27\u0e14\u0e2b\u0e21\u0e39\u0e48\u0e2d\u0e37\u0e48\u0e19 \u0e46 ","our_categories":"\u0e2b\u0e21\u0e27\u0e14\u0e2b\u0e21\u0e39\u0e48","read_now":"\u0e2d\u0e48\u0e32\u0e19\u0e40\u0e1e\u0e34\u0e48\u0e21","schedule":"\u0e15\u0e32\u0e23\u0e32\u0e07\u0e01\u0e32\u0e23\u0e41\u0e02\u0e48\u0e07\u0e02\u0e31\u0e19","scores_page_desc":"\u0e27\u0e31\u0e19\u0e41\u0e02\u0e48\u0e07\u0e41\u0e25\u0e30\u0e1c\u0e25\u0e01\u0e32\u0e23\u0e41\u0e02\u0e48\u0e07\u0e19\u0e31\u0e14\u0e25\u0e48\u0e32\u0e2a\u0e38\u0e14\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14","scores_page_title":"\u0e27\u0e31\u0e19\u0e41\u0e02\u0e48\u0e07 & \u0e1c\u0e25\u0e01\u0e32\u0e23\u0e41\u0e02\u0e48\u0e07","social_text":null,"stay_up_to":"\u0e1e\u0e23\u0e49\u0e2d\u0e21\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e40\u0e08\u0e4b\u0e07 \u0e46 \u0e21\u0e32\u0e01\u0e21\u0e32\u0e22","top_stories":"\u0e40\u0e23\u0e37\u0e48\u0e2d\u0e07\u0e40\u0e14\u0e48\u0e19","trending":null,"trending_floor8":null,"video":"\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d","videos":null,"view_all":"\u0e14\u0e39\u0e15\u0e32\u0e23\u0e32\u0e07\u0e41\u0e02\u0e48\u0e07\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14","view_more":"\u0e2d\u0e48\u0e32\u0e19\u0e02\u0e48\u0e32\u0e27\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14","watch_more_videos":"\u0e0a\u0e21\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21","watch_tv_12up":null,"watch_tv_90min":"\u0e23\u0e31\u0e1a\u0e0a\u0e21 90MIN \u0e17\u0e35\u0e27\u0e35","watch_tv_circasports":"\u0e23\u0e31\u0e1a\u0e0a\u0e21 CIRCA SPORTS \u0e17\u0e35\u0e27\u0e35","watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":null,"watch_tv_german_site":null,"watch_tv_ht_media":null,"watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"\u0e42\u0e06\u0e29\u0e13\u0e32","bet_now":"\u0e25\u0e38\u0e22\u0e01\u0e31\u0e19\u0e40\u0e25\u0e22","by":"\u0e42\u0e14\u0e22","by_betway":null,"community_content":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e08\u0e32\u0e01\u0e41\u0e1f\u0e19\u0e46","community_disclaimer":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e19\u0e35\u0e49\u0e16\u0e39\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19\u0e02\u0e36\u0e49\u0e19\u0e42\u0e14\u0e22\u0e41\u0e1f\u0e19\u0e46 \u0e02\u0e2d\u0e07 90min \u0e17\u0e35\u0e48\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e41\u0e25\u0e30\u0e2a\u0e19\u0e31\u0e1a\u0e2a\u0e19\u0e38\u0e19\u0e01\u0e31\u0e19\u0e21\u0e32 \u0e42\u0e14\u0e22\u0e22\u0e31\u0e07\u0e21\u0e34\u0e44\u0e14\u0e49\u0e16\u0e39\u0e01\u0e41\u0e01\u0e49\u0e44\u0e02\u0e43\u0e14\u0e46 \u0e08\u0e32\u0e01\u0e17\u0e35\u0e21\u0e07\u0e32\u0e19\u0e02\u0e2d\u0e07\u0e40\u0e23\u0e32","community_disclaimer_12up":null,"community_disclaimer_90min":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e19\u0e35\u0e49\u0e16\u0e39\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19\u0e02\u0e36\u0e49\u0e19\u0e42\u0e14\u0e22\u0e41\u0e1f\u0e19\u0e46 \u0e02\u0e2d\u0e07 90min \u0e17\u0e35\u0e48\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e41\u0e25\u0e30\u0e2a\u0e19\u0e31\u0e1a\u0e2a\u0e19\u0e38\u0e19\u0e01\u0e31\u0e19\u0e21\u0e32 \u0e42\u0e14\u0e22\u0e22\u0e31\u0e07\u0e21\u0e34\u0e44\u0e14\u0e49\u0e16\u0e39\u0e01\u0e41\u0e01\u0e49\u0e44\u0e02\u0e43\u0e14\u0e46 \u0e08\u0e32\u0e01\u0e17\u0e35\u0e21\u0e07\u0e32\u0e19\u0e02\u0e2d\u0e07\u0e40\u0e23\u0e32","community_disclaimer_circasports":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e19\u0e35\u0e49\u0e16\u0e39\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19\u0e02\u0e36\u0e49\u0e19\u0e42\u0e14\u0e22\u0e41\u0e1f\u0e19\u0e46 \u0e02\u0e2d\u0e07 CircaSports \u0e17\u0e35\u0e48\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e41\u0e25\u0e30\u0e2a\u0e19\u0e31\u0e1a\u0e2a\u0e19\u0e38\u0e19\u0e01\u0e31\u0e19\u0e21\u0e32 \u0e42\u0e14\u0e22\u0e22\u0e31\u0e07\u0e21\u0e34\u0e44\u0e14\u0e49\u0e16\u0e39\u0e01\u0e41\u0e01\u0e49\u0e44\u0e02\u0e43\u0e14\u0e46 \u0e08\u0e32\u0e01\u0e17\u0e35\u0e21\u0e07\u0e32\u0e19\u0e02\u0e2d\u0e07\u0e40\u0e23\u0e32","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":null,"community_disclaimer_ftb90":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e19\u0e35\u0e49\u0e16\u0e39\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19\u0e02\u0e36\u0e49\u0e19\u0e42\u0e14\u0e22\u0e41\u0e1f\u0e19\u0e46 \u0e02\u0e2d\u0e07 FTB90 \u0e17\u0e35\u0e48\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e41\u0e25\u0e30\u0e2a\u0e19\u0e31\u0e1a\u0e2a\u0e19\u0e38\u0e19\u0e01\u0e31\u0e19\u0e21\u0e32 \u0e42\u0e14\u0e22\u0e22\u0e31\u0e07\u0e21\u0e34\u0e44\u0e14\u0e49\u0e16\u0e39\u0e01\u0e41\u0e01\u0e49\u0e44\u0e02\u0e43\u0e14\u0e46 \u0e08\u0e32\u0e01\u0e17\u0e35\u0e21\u0e07\u0e32\u0e19\u0e02\u0e2d\u0e07\u0e40\u0e23\u0e32","community_disclaimer_german_site":null,"community_disclaimer_ht_media":null,"community_disclaimer_swurley":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e19\u0e35\u0e49\u0e16\u0e39\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19\u0e02\u0e36\u0e49\u0e19\u0e42\u0e14\u0e22\u0e41\u0e1f\u0e19\u0e46 \u0e02\u0e2d\u0e07 Swurley \u0e17\u0e35\u0e48\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e41\u0e25\u0e30\u0e2a\u0e19\u0e31\u0e1a\u0e2a\u0e19\u0e38\u0e19\u0e01\u0e31\u0e19\u0e21\u0e32 \u0e42\u0e14\u0e22\u0e22\u0e31\u0e07\u0e21\u0e34\u0e44\u0e14\u0e49\u0e16\u0e39\u0e01\u0e41\u0e01\u0e49\u0e44\u0e02\u0e43\u0e14\u0e46 \u0e08\u0e32\u0e01\u0e17\u0e35\u0e21\u0e07\u0e32\u0e19\u0e02\u0e2d\u0e07\u0e40\u0e23\u0e32","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} \u0e43\u0e0a\u0e49\u0e07\u0e32\u0e19\u0e04\u0e38\u0e49\u0e01\u0e01\u0e35\u0e49\u0e2a\u0e4c\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e19\u0e33\u0e40\u0e2a\u0e19\u0e2d\u0e40\u0e19\u0e37\u0e49\u0e2d\u0e2b\u0e32\u0e01\u0e31\u0e1a\u0e42\u0e06\u0e29\u0e13\u0e32\u0e43\u0e2b\u0e49\u0e40\u0e2b\u0e21\u0e32\u0e30\u0e2a\u0e21\u0e41\u0e25\u0e30\u0e07\u0e48\u0e32\u0e22\u0e15\u0e48\u0e2d\u0e01\u0e32\u0e23\u0e43\u0e0a\u0e49\u0e07\u0e32\u0e19\u0e21\u0e32\u0e01\u0e02\u0e36\u0e49\u0e19 \u0e40\u0e23\u0e32\u0e22\u0e31\u0e07\u0e41\u0e1a\u0e48\u0e07\u0e1b\u0e31\u0e19\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e23\u0e48\u0e27\u0e21\u0e01\u0e31\u0e1a\u0e1a\u0e23\u0e34\u0e29\u0e31\u0e17\u0e20\u0e32\u0e22\u0e19\u0e2d\u0e01\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e01\u0e32\u0e23\u0e42\u0e06\u0e29\u0e13\u0e32\u0e41\u0e25\u0e30\u0e01\u0e32\u0e23\u0e27\u0e34\u0e40\u0e04\u0e23\u0e32\u0e30\u0e2b\u0e4c\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25","cookies_consent_2":"\u0e02\u0e2d\u0e23\u0e32\u0e22\u0e25\u0e30\u0e40\u0e2d\u0e35\u0e22\u0e14\u200b\u0e40\u0e1e\u0e34\u0e48\u0e21\u0e40\u0e15\u0e34\u0e21","cookies_consent_approve":"\u0e40\u0e02\u0e49\u0e32\u0e43\u0e08\u0e41\u0e25\u0e49\u0e27!","notf":{},"now_playing":"\u0e04\u0e38\u0e13\u0e01\u0e33\u0e25\u0e31\u0e07\u0e0a\u0e21","similar_articles":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e17\u0e35\u0e48\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e02\u0e49\u0e2d\u0e07"},"private_messages":{"conversation_date":"\u0e2d\u0e31\u0e1b\u0e40\u0e14\u0e17\u0e04\u0e23\u0e31\u0e49\u0e07\u0e2a\u0e38\u0e14\u0e17\u0e49\u0e32\u0e22\u0e40\u0e21\u0e37\u0e48\u0e2d","expand":"\u0e02\u0e22\u0e32\u0e22","header":"\u0e2d\u0e34\u0e19\u0e1a\u0e4a\u0e2d\u0e01","message_sent":"\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e44\u0e14\u0e49\u0e16\u0e39\u0e01\u0e2a\u0e48\u0e07\u0e41\u0e25\u0e49\u0e27","messages":"\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21","no_history":"\u0e44\u0e21\u0e48\u0e21\u0e35\u0e1b\u0e23\u0e30\u0e27\u0e31\u0e15\u0e34","not_available":"\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e2d\u0e48\u0e32\u0e19\u0e01\u0e32\u0e23\u0e2a\u0e19\u0e17\u0e19\u0e32\u0e19\u0e35\u0e49\u0e44\u0e14\u0e49","private_message":"\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e2a\u0e48\u0e27\u0e19\u0e15\u0e31\u0e27","private_message_to":"\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e2a\u0e48\u0e27\u0e19\u0e15\u0e31\u0e27\u0e16\u0e36\u0e07","send":"\u0e2a\u0e48\u0e07","send_failed":"\u0e02\u0e2d\u0e2d\u0e20\u0e31\u0e22 \u0e01\u0e32\u0e23\u0e2a\u0e48\u0e07\u0e25\u0e49\u0e21\u0e40\u0e2b\u0e25\u0e27 \u0e42\u0e1b\u0e23\u0e14\u0e25\u0e2d\u0e07\u0e2d\u0e35\u0e01\u0e04\u0e23\u0e31\u0e49\u0e07\u0e43\u0e19\u0e20\u0e32\u0e22\u0e2b\u0e25\u0e31\u0e07","sending":"\u0e01\u0e33\u0e25\u0e31\u0e07\u0e2a\u0e48\u0e07","sent":"\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e16\u0e39\u0e01\u0e2a\u0e48\u0e07\u0e41\u0e25\u0e49\u0e27","side_title":"\u0e01\u0e32\u0e23\u0e2a\u0e19\u0e17\u0e19\u0e32","title":"\u0e01\u0e32\u0e23\u0e2a\u0e19\u0e17\u0e19\u0e32\u0e23\u0e30\u0e2b\u0e27\u0e48\u0e32\u0e07\u0e04\u0e38\u0e13\u0e01\u0e31\u0e1a","view_history":"\u0e14\u0e39\u0e1b\u0e23\u0e30\u0e27\u0e31\u0e15\u0e34\u0e01\u0e32\u0e23\u0e2a\u0e19\u0e17\u0e19\u0e32","write_message_here":"\u0e40\u0e02\u0e35\u0e22\u0e19\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e17\u0e35\u0e48\u0e19\u0e35\u0e48"},"pundit":{"bet_via":"\u0e27\u0e32\u0e07\u0e40\u0e14\u0e34\u0e21\u0e1e\u0e31\u0e19\u0e1c\u0e48\u0e32\u0e19","draw":"\u0e40\u0e2a\u0e21\u0e2d","fan_predictions":"\u0e01\u0e32\u0e23\u0e17\u0e32\u0e22\u0e1c\u0e25","follow_match":"\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e40\u0e01\u0e21","follow_pundit":"\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e01\u0e39\u0e23\u0e39","log_in":"\u0e25\u0e47\u0e2d\u0e04\u0e2d\u0e34\u0e19\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e01\u0e32\u0e23\u0e17\u0e32\u0e22\u0e1c\u0e25","not_available":"\u0e44\u0e21\u0e48\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e40\u0e1b\u0e34\u0e14\u0e14\u0e39\u0e2a\u0e16\u0e34\u0e15\u0e34\u0e44\u0e14\u0e49\u0e15\u0e2d\u0e19\u0e19\u0e35\u0e49 \u0e01\u0e23\u0e38\u0e13\u0e32\u0e25\u0e2d\u0e07\u0e43\u0e2b\u0e21\u0e48\u0e2d\u0e35\u0e01\u0e04\u0e23\u0e31\u0e49\u0e07","place_your_bet":"\u0e27\u0e32\u0e07\u0e40\u0e14\u0e34\u0e21\u0e1e\u0e31\u0e19","place_your_bet_via":"\u0e23\u0e48\u0e27\u0e21\u0e2a\u0e19\u0e38\u0e01\u0e1c\u0e48\u0e32\u0e19","prediction":"\u0e17\u0e32\u0e22\u0e27\u0e48\u0e32","pundit_prediction":"%{pundit_first_name} \u0e1f\u0e31\u0e19\u0e18\u0e07:","select_match":"\u0e40\u0e25\u0e37\u0e2d\u0e01\u0e04\u0e39\u0e48\u0e17\u0e35\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e01\u0e32\u0e23\u0e17\u0e32\u0e22\u0e1c\u0e25","select_result":"- \u0e17\u0e32\u0e22\u0e1c\u0e25 -","team_to_win":"%{team} \u0e08\u0e30\u0e0a\u0e19\u0e30","title":"%{team1} vs %{team2}: \u0e17\u0e23\u0e23\u0e28\u0e19\u0e30\u0e08\u0e32\u0e01 %{pundit_name}","top_predictors":"\u0e2d\u0e31\u0e19\u0e14\u0e31\u0e1a\u0e40\u0e0b\u0e35\u0e22\u0e19","what_result":"\u0e04\u0e38\u0e13\u0e04\u0e34\u0e14\u0e27\u0e48\u0e32\u0e1c\u0e25\u0e01\u0e32\u0e23\u0e41\u0e02\u0e48\u0e07\u0e08\u0e30\u0e40\u0e1b\u0e47\u0e19\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e44\u0e23?","what_your_prediction":"\u0e04\u0e38\u0e13\u0e04\u0e34\u0e14\u0e27\u0e48\u0e32\u0e1c\u0e25\u0e08\u0e30\u0e2d\u0e2d\u0e01\u0e21\u0e32\u0e40\u0e1b\u0e47\u0e19\u0e40\u0e0a\u0e48\u0e19\u0e44\u0e23?","your_prediction":"\u0e04\u0e38\u0e13\u0e17\u0e32\u0e22\u0e27\u0e48\u0e32"},"reactions":{"campaigns_poweredby":null,"v1":{"lol":"\u0e2e\u0e48\u0e32\u0e46\u0e46","love":"\u0e0a\u0e2d\u0e1a\u0e27\u0e48\u0e30","must":"\u0e15\u0e49\u0e2d\u0e07\u0e2d\u0e48\u0e32\u0e19","noway":"\u0e44\u0e21\u0e48\u0e08\u0e23\u0e34\u0e07\u0e2d\u0e48\u0e30!","share":"\u0e41\u0e0a\u0e23\u0e4c","shocked":"\u0e2d\u0e36\u0e49\u0e07\u0e01\u0e34\u0e21\u0e01\u0e35\u0e48","tweet":"\u0e17\u0e27\u0e34\u0e15"},"v2":{"booh":null,"cool":null,"haha":555,"loveit":null,"noway":null},"your_reaction":"\u0e04\u0e34\u0e14\u0e22\u0e31\u0e07\u0e44\u0e07\u0e01\u0e31\u0e19\u0e1a\u0e49\u0e32\u0e07 ?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19\u0e16\u0e39\u0e01\u0e2d\u0e48\u0e32\u0e19\u0e41\u0e25\u0e49\u0e27 100 \u0e04\u0e23\u0e31\u0e49\u0e07","about_you":"\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e04\u0e38\u0e13","account":"\u0e1a\u0e31\u0e0d\u0e0a\u0e35","all_info_lost":"\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e43\u0e19 FTBpro.com \u0e08\u0e30\u0e2b\u0e32\u0e22\u0e44\u0e1b\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e16\u0e32\u0e27\u0e23","are_you_sure":"\u0e04\u0e38\u0e13\u0e41\u0e19\u0e48\u0e43\u0e08\u0e2b\u0e23\u0e37\u0e2d","by_email":"\u0e2d\u0e35\u0e40\u0e21\u0e25","connected_as":"\u0e40\u0e0a\u0e37\u0e48\u0e2d\u0e21\u0e15\u0e48\u0e2d\u0e43\u0e19\u0e10\u0e32\u0e19\u0e30","deactivate":"\u0e1b\u0e34\u0e14\u0e01\u0e32\u0e23\u0e43\u0e0a\u0e49\u0e07\u0e32\u0e19\u0e1a\u0e31\u0e0d\u0e0a\u0e35\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19","deactivate_placeholder":"\u0e44\u0e14\u0e49\u0e42\u0e1b\u0e23\u0e14\u0e2d\u0e18\u0e34\u0e1a\u0e32\u0e22\u0e16\u0e36\u0e07\u0e2a\u0e32\u0e40\u0e2b\u0e15\u0e38\u0e43\u0e2b\u0e49\u0e40\u0e23\u0e32\u0e17\u0e23\u0e32\u0e1a:","deactivate_request_sent":"\u0e04\u0e33\u0e02\u0e2d\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13\u0e19\u0e31\u0e49\u0e19\u0e44\u0e14\u0e49\u0e16\u0e39\u0e01\u0e2a\u0e48\u0e07\u0e40\u0e23\u0e35\u0e22\u0e1a\u0e23\u0e49\u0e2d\u0e22\u0e41\u0e25\u0e49\u0e27 \u0e40\u0e23\u0e32\u0e08\u0e30\u0e15\u0e34\u0e14\u0e15\u0e48\u0e2d\u0e04\u0e38\u0e13\u0e43\u0e19\u0e2d\u0e35\u0e01\u0e44\u0e21\u0e48\u0e0a\u0e49\u0e32","disp_name":"\u0e41\u0e2a\u0e14\u0e07\u0e0a\u0e37\u0e48\u0e2d","fb_hometown":"\u0e40\u0e21\u0e37\u0e2d\u0e07\u0e1b\u0e31\u0e08\u0e08\u0e38\u0e1a\u0e31\u0e19\u0e08\u0e32\u0e01 Facebook","fb_link":"\u0e25\u0e34\u0e07\u0e01\u0e4c Facebook","go_social":"\u0e40\u0e02\u0e49\u0e32\u0e2a\u0e31\u0e07\u0e04\u0e21 - \u0e43\u0e2b\u0e49\u0e40\u0e1e\u0e37\u0e48\u0e2d\u0e19\u0e46 \u0e44\u0e14\u0e49\u0e23\u0e31\u0e1a\u0e23\u0e39\u0e49\u0e16\u0e36\u0e07\u0e01\u0e34\u0e08\u0e01\u0e23\u0e23\u0e21\u0e01\u0e32\u0e23\u0e2d\u0e48\u0e32\u0e19\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19","go_social_short":"\u0e41\u0e0a\u0e23\u0e4c\u0e01\u0e32\u0e23\u0e2d\u0e48\u0e32\u0e19\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19","google_plus_link":"\u0e25\u0e34\u0e07\u0e01\u0e4c Google+","if_following_me":"\u0e21\u0e35\u0e04\u0e19\u0e40\u0e23\u0e34\u0e48\u0e21\u0e15\u0e34\u0e14\u0e15\u0e32\u0e21\u0e09\u0e31\u0e19","if_sending_me_message":"\u0e21\u0e35\u0e04\u0e19\u0e2a\u0e48\u0e07\u0e02\u0e49\u0e2d\u0e04\u0e27\u0e32\u0e21\u0e16\u0e36\u0e07\u0e09\u0e31\u0e19","let_see":"\u0e41\u0e2a\u0e14\u0e07\u0e43\u0e2b\u0e49\u0e17\u0e38\u0e01\u0e04\u0e19\u0e40\u0e2b\u0e47\u0e19:","my_team":"\u0e17\u0e35\u0e21\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19","name":{"rules":"\u0e0a\u0e37\u0e48\u0e2d\u0e15\u0e49\u0e2d\u0e07\u0e44\u0e21\u0e48\u0e0b\u0e49\u0e33\u0e01\u0e31\u0e1a\u0e1c\u0e39\u0e49\u0e2d\u0e37\u0e48\u0e19 \u0e08\u0e33\u0e19\u0e27\u0e19 5 - 50 \u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23 \u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e43\u0e0a\u0e49\u0e15\u0e31\u0e27\u0e2d\u0e31\u0e01\u0e29\u0e23\u0e15\u0e31\u0e27\u0e40\u0e25\u0e02\u0e41\u0e25\u0e30\u0e02\u0e35\u0e14\u0e01\u0e25\u0e32\u0e07\u0e44\u0e14\u0e49"},"notifications":"\u0e01\u0e32\u0e23\u0e41\u0e08\u0e49\u0e07\u0e40\u0e15\u0e37\u0e2d\u0e19","optional":"\u0e44\u0e21\u0e48\u0e15\u0e49\u0e2d\u0e07\u0e21\u0e35\u0e01\u0e47\u0e44\u0e14\u0e49","privacy":"\u0e04\u0e27\u0e32\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e2a\u0e48\u0e27\u0e19\u0e15\u0e31\u0e27","recent_articles":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e17\u0e35\u0e48\u0e16\u0e39\u0e01\u0e41\u0e0a\u0e23\u0e4c\u0e40\u0e21\u0e37\u0e48\u0e2d\u0e44\u0e21\u0e48\u0e19\u0e32\u0e19\u0e21\u0e32\u0e19\u0e35\u0e49","save":"\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01","settings":"\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32","settings_saved":"\u0e1a\u0e31\u0e19\u0e17\u0e36\u0e01\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32","share":"\u0e41\u0e0a\u0e23\u0e4c\u0e2d\u0e31\u0e15\u0e42\u0e19\u0e21\u0e31\u0e15\u0e34","site":"\u0e40\u0e27\u0e47\u0e1a\u0e44\u0e0b\u0e15\u0e4c :","site_title":"\u0e2b\u0e31\u0e27\u0e02\u0e49\u0e2d:","site_url":"URL:","stats":"\u0e2a\u0e16\u0e34\u0e15\u0e34 vBets","submit":"\u0e2a\u0e48\u0e07","twitter_link":"\u0e25\u0e34\u0e07\u0e01\u0e4c Twitter:","weekly_writers_achievements":"\u0e2a\u0e23\u0e38\u0e1b\u0e1c\u0e25\u0e19\u0e31\u0e01\u0e40\u0e02\u0e35\u0e22\u0e19\u0e23\u0e32\u0e22\u0e2a\u0e31\u0e1b\u0e14\u0e32\u0e2b\u0e4c\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19","when_notify":"\u0e41\u0e08\u0e49\u0e07\u0e43\u0e2b\u0e49\u0e09\u0e31\u0e19\u0e17\u0e23\u0e32\u0e1a\u0e40\u0e21\u0e37\u0e48\u0e2d","your_writing_language":"\u0e04\u0e38\u0e13\u0e08\u0e30\u0e40\u0e02\u0e35\u0e22\u0e19\u0e14\u0e49\u0e27\u0e22\u0e20\u0e32\u0e29\u0e32\u0e2d\u0e30\u0e44\u0e23"},"sign_up":{"about_you":"\u0e40\u0e02\u0e35\u0e22\u0e19\u0e1a\u0e32\u0e07\u0e2d\u0e22\u0e48\u0e32\u0e07\u0e40\u0e01\u0e35\u0e48\u0e22\u0e27\u0e01\u0e31\u0e1a\u0e04\u0e27\u0e32\u0e21\u0e23\u0e39\u0e49\u0e2a\u0e36\u0e01\u0e17\u0e35\u0e48\u0e21\u0e35\u0e15\u0e48\u0e2d\u0e17\u0e35\u0e21\u0e42\u0e1b\u0e23\u0e14\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13 (\u0e44\u0e21\u0e48\u0e08\u0e33\u0e40\u0e1b\u0e47\u0e19)","and":"\u0e41\u0e25\u0e30","change":"\u0e04\u0e38\u0e13\u0e2a\u0e32\u0e21\u0e32\u0e23\u0e16\u0e40\u0e41\u0e01\u0e49\u0e44\u0e02\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e17\u0e31\u0e49\u0e07\u0e2b\u0e21\u0e14\u0e44\u0e14\u0e49\u0e1a\u0e19\u0e41\u0e16\u0e1a\u0e01\u0e32\u0e23\u0e15\u0e31\u0e49\u0e07\u0e04\u0e48\u0e32\u0e02\u0e2d\u0e07\u0e04\u0e38\u0e13","disp_name":"\u0e0a\u0e37\u0e48\u0e2d\u0e17\u0e35\u0e48\u0e41\u0e2a\u0e14\u0e07","join_12up":null,"join_90min":"\u0e23\u0e48\u0e27\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27 90min","join_circasports":"\u0e23\u0e48\u0e27\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27 CircaSports","join_dbltap":null,"join_ei":null,"join_floor8":null,"join_ftb90":"\u0e23\u0e48\u0e27\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27 FTB90","join_german_site":null,"join_ht_media":null,"join_swurley":"\u0e23\u0e48\u0e27\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e04\u0e23\u0e2d\u0e1a\u0e04\u0e23\u0e31\u0e27 Swurley","lets_start":"\u0e40\u0e23\u0e34\u0e48\u0e21\u0e01\u0e31\u0e19\u0e40\u0e25\u0e22 !","my_game":null,"my_league":"\u0e25\u0e35\u0e01","of_12up":null,"of_90min":"\u0e02\u0e2d\u0e07 90min.com","of_circasports":"\u0e02\u0e2d\u0e07 Swurley.com","of_dbltap":null,"of_ei":null,"of_floor8":null,"of_ftb90":"\u0e02\u0e2d\u0e07 FTB90.com","of_german_site":null,"of_ht_media":null,"privacy_policy":"\u0e19\u0e42\u0e22\u0e1a\u0e32\u0e22\u0e04\u0e27\u0e32\u0e21\u0e40\u0e1b\u0e47\u0e19\u0e2a\u0e48\u0e27\u0e19\u0e15\u0e31\u0e27","required_field":"\u0e02\u0e49\u0e2d\u0e21\u0e39\u0e25\u0e17\u0e35\u0e48\u0e08\u0e33\u0e40\u0e1b\u0e47\u0e19\u0e15\u0e49\u0e2d\u0e07\u0e23\u0e30\u0e1a\u0e38","team":"\u0e17\u0e35\u0e21\u0e02\u0e2d\u0e07\u0e09\u0e31\u0e19","terms":"\u0e09\u0e31\u0e19\u0e15\u0e01\u0e25\u0e07\u0e15\u0e48\u0e2d","terms_and_conditions":"\u0e02\u0e49\u0e2d\u0e01\u0e33\u0e2b\u0e19\u0e14\u0e41\u0e25\u0e30\u0e40\u0e07\u0e37\u0e48\u0e2d\u0e19\u0e44\u0e02"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21","comments":"\u0e04\u0e27\u0e32\u0e21\u0e04\u0e34\u0e14\u0e40\u0e2b\u0e47\u0e19","reads":"\u0e21\u0e35\u0e1c\u0e39\u0e49\u0e2d\u0e48\u0e32\u0e19"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"\u0e40\u0e23\u0e37\u0e48\u0e2d\u0e07\u0e23\u0e32\u0e27\u0e25\u0e48\u0e32\u0e2a\u0e38\u0e14","latest_videos":"\u0e27\u0e34\u0e14\u0e35\u0e42\u0e2d\u0e43\u0e2b\u0e21\u0e48\u0e25\u0e48\u0e32\u0e2a\u0e38\u0e14","read_more":"\u0e2d\u0e48\u0e32\u0e19\u0e15\u0e48\u0e2d","recommended":"\u0e1a\u0e17\u0e04\u0e27\u0e32\u0e21\u0e41\u0e19\u0e30\u0e19\u0e33","video":"\u0e27\u0e35\u0e14\u0e35\u0e42\u0e2d"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}},"hi":{"date":{"abbr_day_names":["\u0930\u0935\u093f","\u0938\u094b\u092e","\u092e\u0902\u0917\u0932","\u092c\u0941\u0927","\u0917\u0941\u0930\u0941","\u0936\u0941\u0915\u094d\u0930","\u0936\u0928\u093f"],"abbr_month_names":[null,"\u091c\u0948\u0928","\u092b\u0930","\u092e\u093e\u0930\u094d\u091a","\u0905\u092a\u094d\u0930\u0948","\u092e\u0908","\u091c\u0942\u0928","\u091c\u0941\u0932\u093e\u0908","\u0905\u0917","\u0938\u093f\u0924\u0902","\u0905\u0915\u094d\u091f\u0942","\u0928\u0935\u0902","\u0926\u093f\u0938"],"day_names":["\u0930\u0935\u093f\u0935\u093e\u0930","\u0938\u094b\u092e\u0935\u093e\u0930","\u092e\u0902\u0917\u0932\u0935\u093e\u0930","\u092c\u0941\u0927\u0935\u093e\u0930","\u0917\u0941\u0930\u0941\u0935\u093e\u0930","\u0936\u0941\u0915\u094d\u0930\u0935\u093e\u0930","\u0936\u0928\u093f\u0935\u093e\u0930"],"formats":{"default":"%d-%m-%Y","long":"%B %d, %Y","short":"%b %d","capitalized_short_day_and_hour":"%A %H: %M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","month_name_full":"%B","numbered_day_short_month_and_year":"%e %b %Y","short_day_and_hour":"%a %H. %M","short_day_and_month":"%e %b","short_month_and_year":"%b %Y"},"month_names":[null,"\u091c\u0928\u0935\u0930\u0940","\u092b\u0930\u0935\u0930\u0940","\u092e\u093e\u0930\u094d\u091a","\u0905\u092a\u094d\u0930\u0948\u0932","\u092e\u0908","\u091c\u0942\u0928","\u091c\u0941\u0932\u093e\u0908","\u0905\u0917\u0938\u094d\u0924","\u0938\u093f\u0924\u0902\u092c\u0930","\u0905\u0915\u094d\u091f\u0942\u092c\u0930","\u0928\u0935\u0902\u092c\u0930","\u0926\u093f\u0938\u0902\u092c\u0930"],"order":["day","month","year"],"time_since":{"about_an_hour_ago":"\u0932\u0917\u092d\u0917 \u090f\u0915 \u0918\u0902\u091f\u093e \u092a\u0939\u0932\u0947","about_two_hours_ago":"\u0932\u0917\u092d\u0917 \u0926\u094b \u0918\u0902\u091f\u093e \u092a\u0939\u0932\u0947","seconds_ago":"\u0915\u0941\u091b \u0938\u0947\u0915\u0902\u0921 \u092a\u0939\u0932\u0947","x_hours_ago":{"one":"1 \u0918\u0902\u091f\u093e \u092a\u0939\u0932\u0947","other":"%{count} \u0918\u0902\u091f\u0947 \u092a\u0939\u0932\u0947"},"x_minutes_ago":{"one":"1 \u092e\u093f\u0928\u091f  \u092a\u0939\u0932\u0947","other":"%{count} \u092e\u093f\u0928\u091f \u092a\u0939\u0932\u0947"}}},"errors":{"format":"%{attribute} %{message}","messages":{"accepted":"\u0938\u094d\u0935\u0940\u0915\u093e\u0930 \u0915\u093f\u092f\u093e \u091c\u093e\u0928\u093e \u091c\u0930\u0942\u0930\u0940","blank":"\u0916\u093e\u0932\u0940 \u0928\u0939\u0940\u0902 \u0930\u0939 \u0938\u0915\u0924\u093e \u0939\u0948","confirmation":"\u092a\u0941\u0937\u094d\u091f\u093f\u0915\u0930\u0923 \u092e\u0947\u0932 \u0928\u0939\u0940\u0902 \u0916\u093e\u0924\u093e","empty":"\u0930\u093f\u0915\u094d\u0924 \u0928\u0939\u0940\u0902 \u0930\u0939 \u0938\u0915\u0924\u093e \u0939\u0948","equal_to":"%{count} \u0915\u0947 \u0932\u093f\u090f \u092c\u0930\u093e\u092c\u0930 \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","even":"\u0938\u092e \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","exclusion":"\u0906\u0930\u0915\u094d\u0937\u093f\u0924 \u0939\u0948","greater_than":"%{count} \u0938\u0947 \u0905\u0927\u093f\u0915 \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","greater_than_or_equal_to":"%{count} \u0938\u0947 \u092c\u0921\u093c\u093e \u092f\u093e \u092c\u0930\u093e\u092c\u0930 \u0939\u094b\u0928\u093e \u0906\u0935\u0936\u094d\u092f\u0915 \u0939\u0948","inclusion":"\u0938\u0942\u091a\u0940 \u092e\u0947\u0902 \u0936\u093e\u092e\u093f\u0932 \u0928\u0939\u0940\u0902 \u0939\u0948","invalid":"\u0905\u0935\u0948\u0927 \u0939\u0948","less_than":"%{count} \u0938\u0947 \u0915\u092e \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","less_than_or_equal_to":"%{count} \u0938\u0947 \u0915\u092e \u092f\u093e \u092c\u0930\u093e\u092c\u0930 \u0939\u094b\u0928\u093e \u0906\u0935\u0936\u094d\u092f\u0915 \u0939\u0948","not_a_number":"\u0915\u094b\u0908 \u0938\u0902\u0916\u094d\u092f\u093e \u0928\u0939\u0940\u0902 \u0939\u0948","not_an_integer":"\u090f\u0915 \u092a\u0942\u0930\u094d\u0923\u093e\u0902\u0915 \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","odd":"\u0935\u093f\u0938\u092e \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","record_invalid":"\u0938\u0924\u094d\u092f\u093e\u092a\u0928 \u0935\u093f\u092b\u0932: %{errors}","taken":"\u092a\u0939\u0932\u0947 \u0939\u0940 \u0932\u0947 \u0932\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u0948","too_long":"\u0905\u0924\u094d\u092f\u0927\u093f\u0915 \u0932\u0902\u092c\u093e \u0939\u0948 (\u0905\u0927\u093f\u0915\u0924\u092e %{count} \u0935\u0930\u094d\u0923 \u0939\u0948\u0902)","too_short":"\u0905\u0924\u094d\u092f\u0927\u093f\u0915 \u091b\u094b\u091f\u093e \u0939\u0948 (\u0928\u094d\u092f\u0942\u0928\u0924\u092e %{count} \u0935\u0930\u094d\u0923 \u0939\u0948\u0902)","wrong_length":"\u0917\u0932\u0924 \u0932\u0902\u092c\u093e\u0908 \u0939\u0948 (%{count} \u0935\u0930\u094d\u0923 \u092f\u0941\u0915\u094d\u0924 \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f)"},"template":{"body":"\u0928\u093f\u092e\u094d\u0928\u0932\u093f\u0916\u093f\u0924 \u0915\u094d\u0937\u0947\u0924\u094d\u0930\u094b\u0902 \u0915\u0947 \u0938\u093e\u0925 \u0938\u092e\u0938\u094d\u092f\u093e \u0925\u0940:","header":{"one":"\u0907\u0938 %{model} \u0915\u094b \u0938\u0939\u0947\u091c\u0947 \u091c\u093e\u0928\u093e \u090f\u0915 \u0924\u094d\u0930\u0941\u091f\u093f \u0915\u0947 \u0915\u093e\u0930\u0923 \u0928\u0939\u0940\u0902 \u0939\u0941\u0906","other":"\u0907\u0938 %{model} \u0915\u094b \u0938\u0939\u0947\u091c\u0947 \u091c\u093e\u0928\u093e %{count} \u0924\u094d\u0930\u0941\u091f\u093f \u0915\u0947 \u0915\u093e\u0930\u0923 \u0928\u0939\u0940\u0902 \u0939\u0941\u0906"}},"200_pixels":"\u091a\u093f\u0924\u094d\u0930 \u0928\u094d\u092f\u0942\u0928\u0924\u092e 200x200 \u092a\u093f\u0915\u094d\u0938\u0932 \u0915\u093e \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","file_too_big":"\u0905\u092a\u0932\u094b\u0921 \u0915\u0940 \u0917\u0908 \u092b\u093e\u0907\u0932 \u0905\u0924\u094d\u092f\u0927\u093f\u0915 \u092c\u0921\u093c\u0940 \u0939\u0948","flash":"\u0907\u0938 \u0938\u0941\u0935\u093f\u0927\u093e \u0915\u093e \u0909\u092a\u092f\u094b\u0917 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u090f\u0921\u094b\u092c \u092b\u094d\u0932\u0948\u0936 \u0907\u0928\u094d\u0938\u091f\u093e\u0932 \u0915\u0930\u0947\u0902","invalid_filetype":"\u0905\u0935\u0948\u0927 \u092b\u093e\u0907\u0932 (\u0938\u092a\u094b\u0930\u094d\u091f \u092b\u093e\u0907\u0932 .gif, .jpg, .jpeg and .png)","invalid_url":"\u0905\u0935\u0948\u0927 URL","mobile_error":"\u0935\u093f\u0921\u093f\u092f\u094b \u092e\u094b\u092c\u093e\u0907\u0932 \u092b\u094b\u0928 \u092a\u0930 \u0928\u0939\u0940\u0902 \u091a\u0932\u0947\u0917\u093e\u0964","motto":{"title":"\u0915\u0943\u092a\u092f\u093e 10-25 \u0905\u0915\u094d\u0937\u0930 \u092a\u094d\u0930\u0935\u093f\u0937\u094d\u091f \u0915\u0930\u0947\u0902"},"nick":{"duplicate":"\u0928\u093f\u0915 \u092a\u0939\u0932\u0947 \u0938\u0947 \u0907\u0938\u094d\u0924\u0947\u092e\u093e\u0932 \u092e\u0947 \u0939\u0948","length":"\u0928\u093f\u0915 5-50 \u0905\u0915\u094d\u0937\u0930\u094b\u0902 \u0915\u0947 \u092c\u0940\u091a \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","title":"\u0915\u0947\u092c\u0932 \u0932\u0947\u091f\u0930\u094d\u0938\u0947, \u0921\u0940\u091c\u091f, \u092a\u0940\u0930\u093f\u092f\u0921 \u0914\u0930 \u0921\u0948\u0936 \u0915\u093e \u092a\u094d\u0930\u092f\u094b\u0917 \u0915\u0930\u0947\u0902","validation":"\u0906\u092a\u0915\u093e \u0921\u093f\u0938\u092a\u094d\u0932\u0947 \u0928\u093e\u092e 5-50 \u0905\u0915\u094d\u0937\u0930\u094b\u0902 \u0915\u0947 \u092c\u0940\u091a \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f \u0964 \u0915\u0947\u092c\u0932 \u0932\u0947\u091f\u0930\u094d\u0938\u0947, \u0921\u0940\u091c\u091f, \u092a\u0940\u0930\u093f\u092f\u0921 \u0914\u0930 \u0921\u0948\u0936 \u0915\u093e \u092a\u094d\u0930\u092f\u094b\u0917 \u0915\u0930\u0947\u0902"},"no_file":"\u0915\u094b\u0908 \u092b\u093e\u0907\u0932 \u091a\u092f\u0928 \u0928\u0939\u0940 \u0915\u0940 \u0917\u0908","not_found":"\u092f\u0939 \u092a\u0947\u091c \u0909\u092a\u0932\u092c\u094d\u0926 \u0928\u0939\u0940\u0902 \u0939\u0948","one_team":"\u0915\u0943\u092a\u092f\u093e \u090f\u0915 \u091f\u0940\u092e \u0928\u093f\u092f\u0941\u0930\u094d\u0924 \u0915\u0930\u0947\u0902","pic_size":"\u091a\u093f\u0924\u094d\u0930 \u0915\u093e \u0938\u093e\u0907\u091c %{min} \u0914\u0930 %{max} \u0915\u0947  \u092e\u0927\u094d\u092f \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","ratio_alert":"\u091a\u093f\u0924\u094d\u0930 \u0915\u093e \u0905\u0928\u0941\u092a\u093e\u0924 1:2 \u0914\u0930 2:1 \u0915\u0947  \u092e\u0927\u094d\u092f \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","return_homepage":"\u0939\u094b\u092e\u092a\u0947\u091c \u092a\u0930 \u0935\u093e\u092a\u0938 \u091c\u093e\u090f","select_image":"\u0905\u092a\u0932\u094b\u0921 \u0915\u0947 \u0932\u093f\u090f \u091a\u093f\u0924\u094d\u0930 \u091a\u092f\u0928\u093f\u0924 \u0915\u0930\u0947\u0902","sorry":"\u0939\u092e\u0947\u0902 \u0916\u0947\u0926 \u0939\u0948","subject_id":{"require_fanship":"\u092b\u0948\u0928 \u092c\u0928\u0928\u093e \u0906\u0935\u0936\u094d\u092f\u0915 \u0939\u0948"},"text":{"duplicate_comment":"\u0921\u0941\u092a\u094d\u0932\u0940\u0915\u0947\u091f \u0915\u092e\u0947\u0947\u0902\u091f","duplicate_post":"\u0921\u0941\u092a\u094d\u0932\u0940\u0915\u0947\u091f \u092a\u094b\u0938\u094d\u091f","max_char":"\u0905\u0927\u093f\u0915\u0924\u092e %{num_chars} \u0905\u0915\u094d\u0937\u0930","max_words":"\u0905\u0927\u093f\u0915\u0924\u092e %{num_words} \u0936\u092c\u094d\u0926","min_char":"\u0928\u094d\u092f\u0942\u092e\u0924\u092e %{num_chars} \u0905\u0915\u094d\u0937\u0930"},"twitter_url":{"invalid":"\u0905\u0935\u0948\u0927 \u091f\u094d\u0935\u0940\u091f\u0930 URL"},"unknown_upload":"\u0905\u092a\u0932\u094b\u0921 \u092e\u0947\u0902 \u0905\u091c\u094d\u091e\u093e\u0924 \u0924\u094d\u0930\u0941\u091f\u0940 \u0926\u0930\u094d\u091c \u0915\u093f \u0917\u092f\u0940,  \u0915\u0943\u092a\u092f\u093e \u0938\u0902\u092a\u0930\u094d\u0915 \u0915\u0930\u0947\u0902","unsupported_video":" \u092e\u093e\u092b \u0915\u0930\u0947\u0902, \u0907\u0938 \u0935\u0947\u092c\u0938\u093e\u0907\u091f \u092a\u0930 \u0935\u093f\u091c\u093f\u092f\u094b \u090f\u092e\u094d\u092c\u0947\u0921\u093f\u0902\u0917 \u0909\u092a\u0932\u092c\u094d\u0927 \u0928\u0939\u0940 \u0939\u0948\u0964","url_err":"\u0905\u091c\u094d\u091e\u093e\u0924 \u0924\u094d\u0930\u0941\u091f\u0940, (misspelled URL) \u0915\u0943\u092a\u092f\u093e \u092e\u093e\u0921\u0930\u0947\u091f\u0930 \u0915\u094b \u0938\u0902\u092a\u0930\u094d\u0915 \u0915\u0930\u0947\u0902","website":{"blank":"\u0915\u0943\u092a\u092f\u093e \u0938\u093e\u0907\u091f \u0915\u093e URL \u092a\u094d\u0930\u0935\u093f\u0937\u094d\u091f \u0915\u0930\u0947\u0902"}},"number":{"currency":{"format":{}},"format":{},"human":{"decimal_units":{"units":{}},"format":{},"storage_units":{"units":{}}},"percentage":{"format":{}},"precision":{"format":{}}},"time":{"formats":{"default":"%a, %d %b %Y %H:%M:%S %z","long":"%B %d, %Y %H:%M","short":"%d %b %H:%M","capitalized_short_day_and_hour":"%A %H: %M","date_format":"%s %b %H: %M","day_full_name":"%A","day_num":"%I","full_day":"%a, %e %b","hour_minute":"%H: %M","month_name_full":"%B","numbered_day_short_month_and_year":"%e %B %Y","short_day_and_hour":"%a %H: %M","short_day_and_month":"%e %b","short_month_and_day":"%b %e"},"time_since":{}},"affiliates":{"log_in":"\u0932\u0949\u0917 \u0907\u0928"},"channels":{"name":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}},"short_nick":{}},"common":{"connect":"\u0915\u0928\u0947\u0915\u094d\u091f","language":"\u092d\u093e\u0937\u093e","languages":{"de":"\u091c\u0930\u092e\u0928","en":"\u0907\u0902\u0917\u094d\u0932\u093f\u0936","es":"\u0938\u094d\u092a\u0948\u0928\u093f\u0936","fr":"\u092b\u0948\u0902\u091a","hi":"\u0939\u093f\u0902\u0926\u0940","id":"\u0907\u0902\u0921\u094b\u0928\u0947\u0936\u093f\u092f\u0928","it":"\u0907\u091f\u0948\u0932\u093f\u092f\u0928","pt-BR":"\u092a\u0941\u0930\u094d\u0924\u0917\u093e\u0932\u0940","th":"\u0925\u093e\u0908","tr":"\u0924\u0941\u0930\u094d\u0915\u0940","vn":"\u0935\u093f\u092f\u0924\u0928\u093e\u092e\u0940"},"message":"\u0938\u0902\u0926\u0947\u0936","next":"\u0905\u0917\u0932\u093e","prev":"\u092a\u093f\u091b\u0932\u093e","prompt":{},"right":{},"share":"\u0936\u0947\u092f\u0930","table":"\u091f\u0947\u092c\u0932","tweet":"\u091f\u094d\u0935\u0940\u091f","vbet":{"likes":{}},"vbets":{},"wc":{}},"edit_post":{"about_team":"\u091f\u0940\u092e \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","add_caption":"\u0915\u0948\u092a\u094d\u0936\u0928","add_content":"\u0909\u092a\u092f\u0941\u0915\u094d\u0924 \u0938\u094d\u0930\u094b\u0924 \u0938\u0947 \u0905\u092a\u0928\u0947 \u0932\u0947\u0916 \u092e\u0947\u0902 \u0938\u093e\u092e\u0917\u094d\u0930\u0940 \u091c\u094b\u0921\u093c\u0947 ","add_image":"\u091a\u093f\u0924\u094d\u0930 \u091c\u094b\u0921\u093c\u0947","add_item":"\u092e\u0940\u0921\u093f\u092f\u093e \u0938\u093e\u092e\u0917\u094d\u0930\u0940 \u091c\u094b\u0921\u093c\u0947","add_media":"\u092e\u093f\u0921\u093f\u092f\u093e \u091c\u094b\u0921\u093c\u0947","add_team":"\u091f\u0940\u092e \u091c\u094b\u0921\u093c\u0947","additional_media":"\u0905\u0924\u093f\u0930\u093f\u0915\u094d\u0924 \u092e\u0940\u0921\u093f\u092f\u093e","are_you_sure":"\u0915\u094d\u092f\u093e \u0905\u093e\u092a \u092f\u0939 \u092a\u0947\u091c \u091b\u094b\u0921\u093c\u0928\u093e \u091a\u093e\u0939\u0924\u0947 \u0939\u0948?","article_preview":"\u092f\u0939 \u0906\u092a\u0915\u0947 \u0906\u0930\u094d\u091f\u0940\u0915\u0932 \u0915\u093e \u092a\u094d\u0930\u0940\u0935\u094d\u092f\u0942 \u0939\u0948","attach_image":"\u091a\u093f\u0924\u094d\u0930 \u091a\u092f\u0928\u093f\u0924 \u0915\u0930\u0947\u0902","back":"\u092a\u0940\u091b\u0947 \u091c\u093e\u090f\u0902","back_to_edit":"\u090f\u0921\u093c\u093f\u091f \u092a\u0930 \u0935\u093e\u092a\u0938 \u091c\u093e\u090f\u0902","back_to_editing":"\u090f\u0921\u093f\u091f\u093f\u0902\u0917 \u092a\u0930 \u0935\u093e\u092a\u0938 \u091c\u093e\u090f\u0902","bold_tooltip":"\u092c\u094b\u0932\u094d\u0921","caption_optional":"(\u0935\u0948\u0915\u0932\u094d\u092a\u093f\u0915 \u0905\u0927\u093f 22 \u0905\u0915\u094d\u0937\u0930)","char_count":"\u0905\u0915\u094d\u0937\u0930 \u0917\u093f\u0928\u0924\u0940: %{num}","check_grammar":"\u0909\u091a\u093f\u0924 \u0935\u094d\u092f\u093e\u0915\u0930\u0923 \u0914\u0930 \u0935\u0930\u094d\u0924\u0928\u0940 \u0915\u0947 \u0932\u093f\u090f \u0926\u0947\u0916\u0947","choose_team":"\u091f\u0940\u092e \u091a\u092f\u0928\u093f\u0924 \u0915\u0930\u0947\u0902","clear":"\u0939\u091f\u093e\u090f\u0902","complete_steps":"\u092a\u092c\u094d\u0932\u093f\u0936 \u0939\u094b\u0928\u0947 \u0938\u0947 \u092a\u0939\u0932\u0947 \u0906\u092a\u0915\u094b \u092f\u0947 \u091a\u0930\u0923 \u092a\u0942\u0930\u0947 \u0915\u0930\u0928\u0947 \u0939\u0948\u0902:","congrats":"\u092c\u0927\u093e\u0908!","cover_image":"\u0935\u0947\u092c\u0938\u093e\u0907\u091f, \u090f\u092a\u094d\u092a \u092f\u093e \u0938\u094b\u0936\u0932 \u0928\u0947\u091f\u0935\u0930\u094d\u0915 \u092a\u0930 \u092a\u094b\u0938\u094d\u091f \u0936\u0947\u092f\u0930 \u0915\u0930\u0928\u0947 \u092a\u0930 \u092f\u0939 \u0924\u0938\u0935\u0940\u0930 \u092a\u094d\u0930\u0926\u0930\u094d\u0936\u093f\u0924 \u0915\u0940 \u091c\u093e\u090f\u0917\u0940","create_article":"\u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u0932\u093f\u0916\u0947\u0902","crop_image":"\u0915\u094d\u0930\u0949\u092a \u0907\u092e\u0947\u091c","crop_ratio":"\u0915\u094d\u0930\u0949\u092a \u0930\u0947\u0936\u093f\u092f\u094b:","crop_too_small":"\u091a\u093f\u0924\u094d\u0930 \u092c\u0939\u0941\u0924 \u091b\u094b\u091f\u093e \u0939\u0948","date":"\u0924\u093e\u0930\u093f\u0916:","delete":"\u0939\u091f\u093e\u090f\u0902","delete_article":"\u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u0939\u091f\u093e\u090f\u0902","discard":"\u0938\u092e\u093e\u092a\u094d\u0924 \u0915\u0930\u0947\u0902","discard_confirmation":"\u0915\u094d\u092f\u093e \u0906\u092a \u0907\u0938 \u092a\u094b\u0938\u094d\u091f \u0915\u094b \u0938\u092e\u093e\u092a\u094d\u0924 \u0915\u0930\u0928\u093e \u091a\u093e\u0939\u0924\u0947 \u0939\u0948\u0902?","draft":"\u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0915\u0930\u0947\u0902","drag":"\u091a\u093f\u0924\u094d\u0930/\u0935\u0940\u0921\u093f\u092f\u094b \u092f\u0939\u093e\u0901 \u0921\u094d\u0930\u0948\u0917 \u0915\u0930\u0947\u0902","drag_all":"\u091a\u093f\u0924\u094d\u0930, \u0935\u0940\u0921\u093f\u092f\u094b \u092f\u093e \u0938\u094b\u0936\u0932 \u0915\u0902\u091f\u0947\u0902\u091f \u092f\u0939\u093e\u0901 \u0921\u094d\u0930\u0948\u0917 \u0915\u0930\u0947\u0902","drag_crop":"\u0921\u094d\u0930\u0948\u0917 \u0915\u0930 \u092a\u094b\u091c\u0940\u0936\u0928 \u092c\u0926\u0932\u0947","drop_here":"\u092f\u0939\u093e\u0901 \u0921\u094d\u0930\u0948\u0917 \u0915\u0930\u0947\u0902","drop_image":"\u091a\u093f\u0924\u094d\u0930 \u092f\u0939\u093e\u0901 \u0921\u094d\u0930\u0948\u0917 \u0915\u0930\u0947\u0902","edit_crop":"\u0925\u092e\u094d\u0928\u0947\u0932 \u092e\u0947 \u091c\u092e\u093e\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0906\u092f\u0924\u093e\u0915\u093e\u0930 \u0915\u094b \u092e\u0942\u0935 \u0915\u0930\u0947\u0902 \u092f\u093e \u0906\u0915\u093e\u0930 \u092c\u0926\u0932\u0947\u0902","edit_thumb":"\u090f\u0921\u093f\u091f \u0925\u092e\u094d\u0928\u0947\u0932","editor":"\u090f\u0921\u093f\u091f\u0930:","embed":"\u090f\u092e\u094d\u092c\u0947\u0921","embed_code":"\u090f\u092e\u094d\u092c\u0947\u0921 \u0915\u094b\u0921","embed_only":"\u090f\u092e\u094d\u092c\u0947\u0921 \u0915\u094b\u0921 \u092f\u0939\u093e\u0901 \u092a\u0947\u0938\u0947\u091f \u0915\u0930\u0947\u0902","embed_video":"\u090f\u092e\u094d\u092c\u0947\u0921 \u0935\u0940\u0921\u093f\u092f\u094b","enter_desc":"\u092f\u0939\u093e\u0901 \u0935\u093f\u0935\u0930\u0923 \u092a\u094d\u0930\u0935\u093f\u0937\u094d\u091f \u0915\u0930\u0947\u0902","enter_title":"\u092f\u0939\u093e\u0901 \u0936\u0940\u0930\u094d\u0937\u0915 \u092a\u094d\u0930\u0935\u093f\u0937\u094d\u091f \u0915\u0930\u0947\u0902","enter_url":"URL/Code \u0926\u0930\u094d\u091c \u0915\u0930\u0947\u0902","facebook_cover_image":"\u092b\u0947\u0938\u092c\u0941\u0915 \u0915\u0935\u0930 \u092a\u0947\u091c","ftbpro_editor":"FTBpro \u090f\u0921\u0940\u091f\u0930","grammar_spelling":"\u0938\u0939\u0940 \u0935\u094d\u092f\u093e\u0915\u0930\u0923 \u0914\u0930 \u0935\u0930\u094d\u0924\u0928\u0940 \u0915\u0940 \u091c\u093e\u0901\u091a \u0915\u0930\u0947\u0902","great":"\u0917\u094d\u0930\u0947\u091f!","guide_tips":"\u0939\u092e\u093e\u0930\u0947 \u0928\u093f\u0930\u094d\u0926\u0947\u0936 \u0914\u0930 \u0938\u0941\u0915\u094d\u0937\u093e\u0935 \u092a\u0922\u093c\u0947","guide_tips_links":"http://www.90min.com/blog/guidelines-tips/","h2_tooltip":"\u0936\u0940\u0930\u094d\u0937\u0915","header_edit":"\u090f\u0921\u093f\u091f \u092a\u094b\u0938\u094d\u091f","header_new":"\u0928\u092f\u093e \u092a\u094b\u0938\u094d\u091f","hyperlink_tooltip":"\u0932\u093f\u0902\u0915","image_bank":"\u0907\u092e\u0947\u091c \u092c\u0948\u0902\u0915","image_crop":"\u0915\u094d\u0930\u0949\u092a","image_format":"\u0909\u092a\u092f\u0941\u0915\u094d\u0924 \u0907\u092e\u0947\u091c \u092b\u0949\u0930\u094d\u092e\u0948\u091f: JPG, JPEG, PNG, GIF.","image_search":"\u0916\u094b\u091c\u0947\u0902","image_size":"\u0906\u0915\u093e\u0930 500x280 \u092a\u093f\u0915\u094d\u0938\u0932\u094d\u0938 \u0938\u0947 \u092c\u0921\u093c\u093e \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","image_size_parameterized":"\u0906\u0915\u093e\u0930 %{width}x%{height} \u092a\u093f\u0915\u094d\u0938\u0932\u094d\u0938 \u0938\u0947 \u092c\u0921\u093c\u093e \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u090f","image_video":"\u091a\u093f\u0924\u094d\u0930/\u0935\u0940\u0921\u093f\u092f\u094b","image_weight":"\u092b\u093e\u0907\u0932 \u0905\u0927\u093f\u0915\u0924\u092e \u0906\u0915\u093e\u0930  %{fileSizeMaxSupported} \u0938\u0947 \u0905\u0927\u093f\u0915 \u0939\u0948","insert_link":"\u0932\u093f\u0902\u0915 \u092a\u0947\u0938\u094d\u091f \u0915\u0930\u0947\u0902","invalid_code":"URL/Code \u0905\u092e\u093e\u0928\u094d\u092f \u092f\u093e \u0905\u0935\u0948\u0927 \u0939\u0948\u0964 \u0915\u0943\u092a\u092f\u093e \u0935\u0948\u0927 URL/Code \u0926\u0930\u094d\u091c \u0915\u0930\u0947\u0902","leave":"\u092f\u0939 \u092a\u0947\u091c \u091b\u094b\u0921\u093c\u0947","leave_warning":"\u0906\u092a \u092c\u093f\u0928\u093e \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0915\u0930\u0947 \u092f\u0939 \u092a\u0947\u091c \u091b\u094b\u0921\u093c \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0938\u092d\u0940 \u092c\u0926\u0932\u093e\u0935 \u0938\u092e\u093e\u092a\u094d\u0924 \u0939\u094b \u091c\u093e\u090f\u0902\u0917\u0947!","list_tooltip":"\u0905\u0935\u094d\u092f\u0935\u0938\u094d\u0925\u093f\u0924 \u0932\u093f\u0938\u094d\u091f","max":"(Max%{num})","max_reached":"(\u0905\u0927\u093f\u0915\u0924\u092e \u092a\u0939\u0941\u0902\u091a)","media_longer":"(200 \u0938\u0947 \u0905\u0927\u093f\u0915 \u0936\u092c\u094d\u0926\u094b\u0902 \u0935\u093e\u0932\u0947 \u0906\u0930\u094d\u091f\u093f\u0915\u0932\u094d\u0938 \u0915\u0947 \u0932\u093f\u090f)","media_longer_than":"(300 \u0938\u0947 \u0905\u0927\u093f\u0915 \u0936\u092c\u094d\u0926\u094b\u0902 \u0935\u093e\u0932\u0947 \u0906\u0930\u094d\u091f\u093f\u0915\u0932\u094d\u0938 \u0915\u0947 \u0932\u093f\u090f)","media_post":"\u092e\u0940\u0921\u093f\u092f\u093e \u092a\u094b\u0938\u094d\u091f","min":"(MIn %{num})","min_words":"(\u0928\u094d\u092f\u0942\u0928\u0924\u092e %{num} \u0936\u092c\u094d\u0926)","no_draft":"\u0915\u094b\u0908 \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0921\u094d\u0930\u093e\u092b\u094d\u091f \u0928\u0939\u0940\u0902","num_words":{"one":"1 \u0936\u092c\u094d\u0926","other":"%{count} \u0936\u092c\u094d\u0926"},"number_list_tooltip":"\u0935\u094d\u092f\u0935\u0938\u094d\u0925\u093f\u0924 \u0932\u093f\u0938\u094d\u091f","oops":"\u0932\u0917\u092d\u0917 \u0935\u0939\u093e\u0901...","optimal_article":"(\u0911\u092a\u094d\u091f\u093f\u092e\u0932 300-800)","optimal_length":"(\u0911\u092a\u094d\u091f\u093f\u092e\u0932 %{min}-%{max}","optional":"(\u0910\u091a\u094d\u091b\u093f\u0915, Max 160)","optional_field":"\u092f\u0939 \u0915\u094d\u0937\u0947\u0924\u094d\u0930 \u0910\u091a\u094d\u091b\u093f\u0915 \u0939\u0948","or":"\u092f\u093e","p_tooltip":"\u092a\u0948\u0930\u093e\u0917\u094d\u0930\u093e\u092b","paste_embed":"\u0932\u093f\u0902\u0915 \u092f\u093e \u090f\u092e\u094d\u092c\u0947\u0921\u0947\u0921 \u0915\u094b\u0921 \u092f\u0939\u093e\u0901 \u092a\u0947\u0938\u094d\u091f \u0915\u0930\u0947\u0902","paste_url":"URL \u092f\u093e \u090f\u092e\u094d\u092c\u0947\u0921\u0947\u092c\u0932 \u0915\u094b\u0921 \u092f\u0939\u093e\u0901 \u092a\u0947\u0938\u094d\u091f \u0915\u0930\u0947\u0902","playbuzz":"\u0905\u092a\u0928\u0947 PlayBuzz.com \u092a\u0930 \u092c\u0928\u093e\u092f\u0947 \u0917\u090f \u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u0915\u093e \u0932\u093f\u0902\u0915 \u092a\u0947\u0938\u094d\u091f \u0915\u0930\u0947\u0902","polls":"\u092a\u094b\u0932 \u091c\u094b\u0921\u093c\u0947","prev":"\u092a\u094d\u0930\u0940\u0935\u094d\u092f\u0942","preview":"\u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0915\u0930\u0947\u0902 \u0914\u0930 \u092a\u094d\u0930\u0940\u0935\u094d\u092f\u0942 \u0926\u0947\u0916\u0947\u0902","publish":"\u092a\u092c\u094d\u0932\u093f\u0936","remove_attachment":"\u0915\u094d\u092f\u093e \u0906\u092a \u0907\u0938 \u0905\u091f\u0948\u091a\u092e\u0947\u0902\u091f \u0915\u094b \u0939\u091f\u093e\u0928\u093e \u091a\u093e\u0939\u0924\u0947 \u0939\u0948\u0902\u0902?","reset":"\u0930\u0940\u0938\u0947\u091f","review":"\u092a\u092c\u094d\u0932\u093f\u0936 \u0915\u0930\u0928\u0947 \u0938\u0947 \u092a\u0939\u0932\u0947 \u092a\u094d\u0930\u0940\u0935\u094d\u092f\u0942 \u0926\u0947\u0916\u0947\u0902","save_changes":"\u092c\u0926\u0932\u093e\u0935 \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0915\u0930\u0947\u0902?","save_draft":"\u0921\u094d\u0930\u0949\u092b\u094d\u091f \u0915\u0947 \u0930\u0942\u092a \u092e\u0947 \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0915\u0930\u0947\u0902","search_bank":"\u0907\u092e\u0947\u091c \u092c\u0948\u0902\u0915 \u0916\u094b\u091c\u0947","search_for":"\u0915\u094b \u0916\u094b\u091c\u0947\u0902....","searching":"\u0916\u094b\u091c \u0930\u0939\u093e \u0939\u0948\u0948.....","select_photo":"\u0924\u0938\u0935\u0940\u0930 \u091a\u0941\u0928\u0947\u0902","seo_desc":"SEO \u0935\u093f\u0935\u0930\u0923","share":"\u0907\u0938 \u092a\u094b\u0938\u094d\u091f \u0915\u094b \u092b\u0947\u0938\u092c\u0941\u0915 \u092a\u0930 \u0936\u0947\u092f\u0930 \u0915\u0930\u0947\u0902","small_image":"\u0906\u092a\u0915\u0940 \u0924\u0938\u0935\u0940\u0930 \u0905\u0924\u094d\u092f\u093e\u0927\u093f\u0915 \u091b\u094b\u091f\u0940 \u0939\u0948, \u092f\u0939 \u0928\u094d\u092f\u0942\u0928\u0924\u092e 300x150 \u0915\u0940 \u0939\u094b\u0928\u0940 \u091a\u093e\u0939\u093f\u090f","source":"\u0938\u094d\u0930\u094b\u0924:","start_at":"\u092a\u094d\u0930\u093e\u0930\u0902\u092d \u0915\u0930\u0947\u0902","stay":"\u0907\u0938 \u092a\u0947\u091c \u092a\u0930 \u092c\u0928\u0947 \u0930\u0939\u0947\u0902","steps_complete":"\u0906\u092a\u0915\u093e \u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u092a\u092c\u094d\u0932\u093f\u0936 \u0915\u0947 \u0932\u093f\u090f \u0924\u0948\u092f\u093e\u0930 \u0939\u0948","styling_tooltip":"\u0938\u094d\u091f\u093e\u0907\u0932\u093f\u0902\u0917 \u0939\u091f\u093e\u090f\u0902","tag":"\u091f\u0948\u0917\u094d\u0938","tag_at_least":"(\u0915\u0943\u092a\u092f\u093e 1 \u091a\u0941\u0928\u0947\u0902)","tag_sug":"\u091f\u0948\u0917 \u0915\u0947 \u0938\u0941\u0915\u094d\u0937\u093e\u0935","tag_team":"\u091f\u0948\u0917\u094d\u0938","teaser":"\u091f\u0940\u091c\u0930","teaser_watermark":"\u0906\u092a\u0915\u0947 \u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u0915\u0947 \u0932\u093f\u0902\u0915 \u092a\u0930 \u0935\u093f\u0935\u0930\u0923 \u0915\u0947 \u0930\u0942\u092a \u092e\u0947 \u092a\u094d\u0930\u0926\u0930\u094d\u0936\u093f\u0924 \u0939\u094b\u0917\u093e","this_is_preview":"\u092f\u0939 \u0906\u092a\u0915\u0947 \u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u0915\u093e \u092a\u094d\u0930\u0940\u0935\u094d\u092f\u0942 \u0939\u0948","tip_controversial ":"\u0935\u093f\u0935\u093e\u0926\u093e\u0938\u094d\u092a\u0926 \u0930\u0939\u0947\u0902\u0964 \u090f\u0915 \u0905\u091a\u094d\u091b\u093e \u092a\u094b\u0938\u094d\u091f \u0915\u0920\u094b\u0930 \u0938\u0935\u093e\u0932 \u0916\u0921\u093c\u0947 \u0915\u0930\u0924\u093e \u0939\u0948\u0964","tip_image":"\u091a\u093f\u0924\u094d\u0930 \u091c\u094b\u0921\u093c\u0947\u0964 \u0924\u0938\u0935\u0940\u0930 \u092f\u0941\u0915\u094d\u0924 \u092a\u094b\u0938\u094d\u091f \u0905\u0927\u093f\u0915 \u092a\u093e\u0920\u0915 \u0906\u0915\u0930\u094d\u0937\u093f\u0924 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964","tip_media":"\u0936\u093e\u0928\u0926\u093e\u0930 \u0935\u0940\u0921\u093f\u092f\u094b?  \u092f\u0942\u091f\u094d\u092f\u0942\u092c \u092f\u093e \u092e\u0947\u091f\u093e\u0915\u0948\u092b\u0947 \u092a\u0930 \u092e\u0942\u0935\u0940\u091c \u0909\u092e\u094d\u0926\u093e \u092a\u094d\u0930\u0924\u093f\u0915\u094d\u0930\u093f\u092f\u093e\u090f\u0902 \u092a\u094d\u0930\u093e\u092a\u094d\u0924 \u0915\u0930\u0924\u0940 \u0939\u0948\u0902\u0964 ","tip_short":"\u0905\u092a\u0928\u0947 \u092a\u0948\u0930\u093e\u0917\u094d\u0930\u093e\u092b \u091b\u094b\u091f\u093e \u0930\u0916\u0947\u0902\u0964 \u092a\u093e\u0920\u0915 \u0938\u093e\u092e\u093e\u0928\u094d\u092f\u0924: \u0932\u0902\u092c\u0947 \u092a\u0948\u0930\u093e\u0917\u094d\u0930\u093e\u092b \u091b\u094b\u0921\u093c \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964","tips":{"media_close_ups":"\u0905\u092a\u0928\u0947 \u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u092e\u0947\u0902 \u0916\u093f\u0932\u093e\u0921\u093c\u093f\u092f\u094b\u0902 \u0915\u094b \u0926\u0930\u094d\u0936\u094b\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0915\u094d\u0932\u094b\u091c-\u0905\u092a \u0907\u092e\u0947\u091c \u0915\u093e \u092a\u094d\u0930\u092f\u094b\u0917 \u0915\u0930\u0947\u0902","media_image_bank":"\u0924\u0938\u0935\u0940\u0930 \u0916\u094b\u091c\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0917\u0948\u091f\u0940 \u0907\u092e\u0947\u091c \u092c\u0948\u0902\u0915 \u0915\u093e \u092a\u094d\u0930\u092f\u094b\u0917 \u0915\u0930\u0947\u0902\u0964  \u0916\u093f\u0932\u093e\u0921\u093c\u0940 \u092f\u093e \u091f\u0940\u092e \u0915\u0947 \u0928\u093e\u092e \u0938\u0947 \u0922\u0942\u0901\u0922\u093c\u0947\u0964","post_enjoy":"\u0938\u092c\u0938\u0947 \u092e\u0939\u0924\u094d\u0935\u092a\u0942\u0930\u094d\u0923 \u092e\u094b\u0915\u0947 \u0915\u093e \u0932\u0941\u0924\u094d\u092b \u0909\u0920\u093e\u090f\u0902","post_original":" \u092e\u094c\u0932\u093f\u0915\u0924\u093e \u092c\u0928\u093e\u090f\u0902 \u0930\u0939\u0947\u0902\u0964 \u0935\u093f\u092d\u093f\u0928\u094d\u0928 \u0938\u094d\u0930\u094b\u0924\u094b \u0938\u0947 \u0915\u0949\u092a\u0940 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0915\u0902\u091f\u0947\u0902\u091f \u0938\u094d\u0935\u0940\u0915\u093e\u0930 \u0928\u0939\u0940\u0902 \u0915\u093f\u092f\u093e \u091c\u093e\u090f\u0917\u093e\u0964","post_paragraphs":"\u092a\u0948\u0930\u093e\u0917\u094d\u0930\u093e\u092b \u0926\u094d\u0935\u093e\u0930\u093e \u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u0915\u094b \u092d\u093e\u0917\u094b \u092e\u0947\u0902 \u092c\u093e\u091f\u0947\u0902","post_review":"\u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u092a\u092c\u094d\u0932\u093f\u0936 \u0915\u0930\u0928\u0947 \u0938\u0947 \u092a\u0939\u0932\u0947 \u0930\u093f\u0935\u094d\u092f\u0942 \u0915\u0930\u0947\u0902\u0964 \u0935\u094d\u092f\u093e\u0915\u0930\u0923 \u0914\u0930 \u0935\u0930\u094d\u0924\u0928\u0940 \u091c\u093e\u0901\u091a \u0932\u0947\u0902\u0964","title":"\u092a\u093e\u0920\u0915 \u092c\u0922\u093c\u093e\u0928\u0947 \u0915\u0947 \u0938\u0941\u091d\u093e\u0935:","title_debatable":"\u0938\u0930\u0932 \u0914\u0930 \u0938\u094d\u0935\u091a\u094d\u091b\u0902\u0926 \u092d\u093e\u0937\u093e \u0915\u093e \u092a\u094d\u0930\u092f\u094b\u0917 \u0915\u0930\u0947\u0902\u0964 \u0905\u092a\u0928\u0940 \u092c\u093e\u0924 \u0915\u094b \u0905\u0924\u093f\u0930\u0902\u091c\u093f\u0924 \u0915\u0930\u0947\u0902\u0964 \u0932\u094b\u0917 \u0935\u093f\u0935\u093e\u0926\u093e\u0938\u094d\u092a\u0926 \u092e\u0941\u0926\u094d\u0926\u094b \u092a\u0930 \u091c\u0932\u094d\u0926 \u0906\u0915\u0930\u094d\u0937\u093f\u0924 \u0939\u094b\u0924\u0947 \u0939\u0948\u0902\u0964","title_known_name":"\u0905\u092a\u0928\u093e \u0936\u0940\u0930\u094d\u0937\u0915 \u0916\u093f\u0932\u093e\u0921\u093c\u0940 \u092f\u093e \u091f\u0940\u092e \u0915\u0947 \u0928\u093e\u092e \u0938\u0947 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902\u0964","title_popular_terms":"\u0932\u094b\u0915\u092a\u094d\u0930\u093f\u092f \u0936\u092c\u094d\u0926 \u091c\u0948\u0938\u0947 \u0916\u093f\u0932\u093e\u0921\u093c\u0940\u092f\u094b \u0915\u093e \u092a\u0942\u0930\u093e \u0928\u093e\u092e,  \u091f\u0940\u092e \u0915\u093e \u0928\u093e\u092e \u092f\u093e \u0924\u093e\u091c\u093e \u092e\u0941\u0926\u094d\u0926\u094b \u0915\u093e \u0907\u0938\u094d\u0924\u0947\u092e\u093e\u0932 \u0915\u0930\u0947\u0902\u0964","title_question":"\u0910\u0938\u093e \u0938\u0935\u093e\u0932 \u0915\u0930\u0947\u0902 \u091c\u093f\u0938\u0915\u0947 \u0909\u0924\u094d\u0924\u0930 \u0915\u093e \u0909\u0932\u094d\u0932\u0947\u0916 \u0906\u092a\u0915\u0947 \u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u092e\u0947 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u094b\u0964","title_short":"5-8 \u0936\u092c\u094d\u0926\u094b\u0902 \u0915\u093e \u0930\u0916\u0947\u0964"},"title":"\u0936\u0940\u0930\u094d\u0937\u0915","too_long":"\u0905\u0924\u094d\u092f\u093e\u0927\u093f\u0915 \u0932\u0902\u092c\u093e  (optimal 10-75 characters)","too_short":"\u0905\u0924\u094d\u092f\u093e\u0927\u093f\u0915 \u091b\u094b\u091f\u093e (optimal 10-75 characters)","toolong":"\u0905\u0924\u094d\u092f\u093e\u0927\u093f\u0915 \u0932\u0902\u092c\u093e (optimal %{min}-%{max} characters)","tooshort":"\u0905\u0924\u094d\u092f\u093e\u0927\u093f\u0915 \u091b\u094b\u091f\u093e (optimal %{min}-%{max} characters)","try_again":"\u092a\u0941\u0928: \u092a\u094d\u0930\u092f\u093e\u0938 \u0915\u0930\u0947\u0902","upload_failed":"\u091a\u093f\u0924\u094d\u0930 \u0905\u092a\u0932\u094b\u0921 \u0915\u0947 \u0926\u094c\u0930\u093e\u0928 \u0924\u094d\u0930\u0941\u091f\u093f \u0926\u0930\u094d\u091c \u0915\u0940 \u0917\u0908\u0964 \u0915\u0943\u092a\u092f\u093e \u092a\u0941\u0928: \u092a\u094d\u0930\u092f\u093e\u0938 \u0915\u0930\u0947\u0902\u0964","upload_image":"\u092b\u094b\u091f\u094b \u0905\u092a\u0932\u094b\u0921 \u0915\u0930\u0947\u0902","upload_img":"\u0907\u092e\u0947\u091c \u0905\u092a\u0932\u094b\u0921 \u0915\u0930\u0947\u0902","valid_code":"\u0906\u092a\u0915\u0947 \u0926\u094d\u0935\u093e\u0915\u093e \u0909\u092a\u0932\u092c\u094d\u0927 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u090f\u092e\u094d\u092c\u0947\u0921 \u0915\u094b\u0921 \u0905\u0935\u0948\u0927 \u0939\u0948\u0964","video":"\u0935\u0940\u0921\u093f\u092f\u093e","video_provider":"\u0907\u0938 \u0935\u0940\u0921\u093f\u092f\u094b \u092a\u094d\u0930\u094b\u0935\u093e\u0907\u0921\u0930 \u092a\u0930 \u0938\u0941\u0935\u093f\u0927\u093e \u0909\u092a\u0932\u092c\u094d\u0927 \u0928\u0939\u0940\u0902\u0964","video_services":"\u092f\u0942\u091f\u094d\u092f\u0942\u092c, \u0921\u0947\u0932\u0940\u092e\u094b\u0936\u0928 \u092f\u093e \u092e\u0947\u091f\u093e\u0915\u0948\u0947\u092b\u0947 \u0938\u0947 \u0935\u0940\u0921\u093f\u092f\u093e \u092f\u0939\u093e\u0901 \u092a\u0947\u0938\u094d\u091f \u0915\u0930\u0947\u0902:","video_url":"\u0935\u0940\u0921\u093f\u092f\u094b URL (\u092f\u0942\u091f\u094d\u092f\u0942\u092c, \u0921\u0947\u0932\u0940\u092e\u094b\u0936\u0928 \u092f\u093e \u092e\u0947\u091f\u093e\u0915\u0948\u0947\u092b\u0947 \u0906\u0926\u093f)","word_count":"%{num} \u0936\u092c\u094d\u0926","writing_sug":"SEO \u0938\u0941\u0915\u094d\u0937\u093e\u0935","writing_tips":"\u0905\u091a\u094d\u091b\u093e \u0932\u093f\u0916\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0938\u0941\u0915\u094d\u0937\u093e\u0935","your_post":"\u0906\u092a\u0915\u093e \u092a\u094b\u0938\u094d\u091f"},"embed":{"button":"\u090f\u092e\u094d\u092c\u0947\u0921","dialogue":{"additional_options":"\u0905\u0928\u094d\u092f \u0935\u093f\u0915\u0932\u094d\u092a","become_a_partner":"\u092a\u093e\u0930\u094d\u091f\u0928\u0930  \u092c\u0928\u0947\u0902","comments":"\u0915\u092e\u0947\u0902\u0928\u094d\u091f\u094d\u0938 \u0926\u093f\u0916\u093e\u090f\u0902","customise_collapse/expand":"\u0915\u0938\u094d\u091f\u092e\u093e\u0907\u091c \u0915\u094b\u0921","disclaimer":"\u0915\u094b\u0921 \u090f\u092e\u094d\u092c\u0947\u0921 \u0915\u0930\u0928\u0947 \u092a\u0930 \u0905\u092a\u0915\u094b \u0939\u092e\u093e\u0930\u0940 %{terms_conditions} \u0938\u094d\u0935\u0940\u0915\u093e\u0930 \u092e\u093e\u0928\u0940 \u091c\u093e\u090f\u0917\u0940","embed_code":"\u090f\u092e\u094d\u092c\u0947\u0921 \u0915\u094b\u0921","embed_instructions":"\u092a\u094b\u0938\u094d\u091f \u0915\u094b \u0905\u092a\u0928\u0940 \u0935\u0947\u092c\u0938\u093e\u0907\u091f \u092a\u0930 \u091c\u094b\u0921\u093c\u0928 \u0915\u0947 \u0932\u093f\u090f \u0928\u0940\u091a\u0947 \u0926\u093f\u092f\u0947 HTML \u0915\u094b\u0921 \u0915\u094b \u0915\u0949\u092a\u0940 \u0914\u0930 \u092a\u0947\u0938\u094d\u091f \u0915\u0930\u0947\u0902 ","embed_instructions_partners":"\u0905\u092a\u0928\u093e \u092a\u0930\u094d\u0938\u0928\u0932 \u0915\u094b\u0921 \u0928\u0940\u091a\u0947 \u0915\u0949\u092a\u0940 \u0914\u0930 \u092a\u0947\u0938\u094d\u091f \u0915\u0930\u0947\u0902","full_title":"\u092a\u0942\u0930\u093e \u091f\u093e\u0907\u091f\u0932","header":"\u090f\u092e\u094d\u092c\u0947\u0921 \u092a\u094b\u0938\u094d\u091f","info":"90min \u0915\u093e \u0932\u093f\u0902\u0915 \u0915\u0947\u0935\u0932 \u092a\u093e\u0930\u094d\u091f\u0928\u0930 \u0939\u091f\u093e \u0938\u0915\u0924\u0947 \u0939\u0948","link":"90min \u0915\u093e \u0932\u093f\u0902\u0915 \u0926\u093f\u0916\u093e\u090f\u0902","logged_in":"\u0939\u092e\u093e\u0930\u0947 \u092a\u093e\u0930\u094d\u091f\u0928\u0930\u0936\u093f\u092a \u092a\u094d\u0930\u094b\u0917\u094d\u0930\u093e\u092e \u0938\u0947 \u091c\u0941\u0921\u093c\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f %{email}  \u0938\u0902\u092a\u0930\u094d\u0915 \u0915\u0930\u0947\u0902","login":"\u0932\u0949\u0917 \u0907\u0928","partner_message":"\u092a\u0939\u0932\u0947 \u0938\u0947 \u092a\u093e\u0930\u094d\u091f\u0928\u0930 \u0939\u0948\u0902? %{login} \u0905\u092a\u0928\u093e \u0915\u0938\u094d\u091f\u092e\u093e\u0907\u091c\u094d\u0921 \u0915\u094b\u0921 \u092a\u094d\u0930\u093e\u092a\u094d\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f","remove_title":"\u091f\u093e\u0907\u091f\u0932 \u0939\u091f\u093e\u090f\u0902","show-author":"\u0932\u0947\u0916\u0915 \u0926\u093f\u0916\u093e\u090f\u0902","show-date":"\u092a\u093e\u0930\u094d\u091f\u0928\u0930 \u092c\u0928\u0947\u0902","show-reads-counter":"\u0915\u0938\u094d\u091f\u092e\u093e\u0907\u091c \u0915\u094b\u0921","show-title":"\u0936\u0940\u0930\u094d\u0937\u0915 \u0926\u093f\u0916\u093e\u090f\u0902","terms_&_conditions":"\u0928\u093f\u092f\u092e \u0914\u0930 \u0936\u0930\u094d\u0924\u0947","title":"\u0936\u0940\u0930\u094d\u0937\u0915","views":"\u0935\u094d\u092f\u0942\u091c \u0938\u0902\u0916\u094d\u092f\u093e \u0926\u093f\u0916\u093e\u090f"}},"footer":{"about_12up":"12up \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","about_90min":" 90\u092e\u093f\u0928.\u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","about_circasports":"CircaSports \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","about_dbltap":null,"about_ei":null,"about_floor8":null,"about_ftb90":"FTB90 \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","about_ftbpro":"\u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","about_german_site":null,"about_ht_media":"HT \u092e\u0940\u0921\u093f\u092f\u093e \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","about_pluralist":null,"about_swurley":"Swurley \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","about_theduel":null,"affiliates":"\u090f\u092b\u093f\u0932\u093f\u090f\u091f\u094d\u0938","apps":"\u092e\u094b\u092c\u093e\u0907\u0932 \u090f\u092a\u094d\u0938","apps_Android":"\u092a\u094d\u0930\u092a\u094d\u0924 \u0915\u0930\u0947\u0902","apps_iphone":"\u0909\u092a\u0932\u092c\u094d\u0927 \u0939\u0948","blog":"\u092c\u094d\u0932\u093e\u0917","boomerang":null,"cartoon":null,"contact_ftbpro":"\u0938\u0902\u092a\u0930\u094d\u0915 \u0915\u0930\u0947\u0902","fan_store":"\u092a\u094d\u0930\u0936\u0902\u0938\u0915 \u0938\u094d\u091f\u094b\u0930","faq":"FAQ","house_rules":" \u0939\u093e\u0909\u0938 \u0915\u0947 \u0928\u093f\u092f\u092e","in_the_news":"\u0936\u0941\u0930\u094d\u0916\u093f\u092f\u094b\u0902 \u092e\u0947\u0902","jobs":"\u0915\u0948\u0930\u093f\u092f\u0930","licensing":"\u0932\u093e\u0908\u0938\u0947\u0902\u0938\u093f\u0902\u0917","links":"\u0932\u093f\u0902\u0915\u094d\u0938","links_social":"\u0932\u093f\u0902\u0915\u094d\u0938","more_about_12up":"12up \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902 \u0905\u0927\u093f\u0915 \u091c\u093e\u0928\u0947","more_about_90min":"90min \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902 \u0905\u0927\u093f\u0915","more_about_circasports":"CircaSports \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902 \u0905\u0927\u093f\u0915","more_about_dbltap":null,"more_about_ei":null,"more_about_floor8":null,"more_about_ftb90":"FTB90 \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902 \u0905\u0927\u093f\u0915","more_about_german_site":null,"more_about_ht_media":"HT \u092e\u0940\u0921\u093f\u092f\u093e \u0917\u094d\u0930\u0941\u092a \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902 \u0905\u0927\u093f\u0915","more_about_pluralist":null,"more_about_swurley":"Swurley \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902 \u0905\u0927\u093f\u0915","more_about_theduel":null,"partner_sites":null,"partners":"\u092a\u093e\u0930\u094d\u091f\u0928\u0930\u094d\u0938","prev_prog":null,"privacy_policy":"\u092a\u094d\u0930\u0907\u0935\u0947\u0938\u0940 \u092a\u0949\u0932\u093f\u0938\u0940","rights_reserved":"All  Right reserved","rights_reserved_year":"2016 FTBpro \u00a9 All Right Reserved ","rights_reserved_year_12up":"Minute Media 2019 12up \u00a9 All Right Reserved","rights_reserved_year_90min":"Minute Media 2019 90min \u00a9 All Right reserved","rights_reserved_year_archway":null,"rights_reserved_year_circasports":"2016 CircaSports \u00a9 All Right reserved ","rights_reserved_year_dbltap":null,"rights_reserved_year_ei":null,"rights_reserved_year_floor8":null,"rights_reserved_year_ftb90":"2016 FTB90 \u00a9 All Right reserved ","rights_reserved_year_german_site":null,"rights_reserved_year_ht_media":"Minute Media 2019 HT Media \u00a9 All Right reserved","rights_reserved_year_pluralist":null,"rights_reserved_year_swurley":"2016 Swurley \u00a9 All Right reserved ","rights_reserved_year_theduel":null,"space":null,"statistics_12up":"12up Stats","statistics_90min":"90min Stats","statistics_circasports":"CircaSports Stats","statistics_ei":null,"statistics_floor8":null,"statistics_ftb90":"FTB90 Stats","statistics_ht_media":"HT Media Stats","statistics_swurley":"Swurley Stats","statistics_theduel":null,"stats":{"articles":"\u0906\u0930\u094d\u091f\u093f\u0915\u0932\u094d\u0938","fans":"\u092a\u094d\u0930\u0936\u0902\u0938\u0915","members":"\u0938\u0926\u0938\u094d\u092f","writers":"\u0930\u093e\u0907\u091f\u0930\u094d\u0938"},"support":"\u0938\u092a\u094b\u0930\u094d\u091f","tbs":null,"tcm":null,"terms":"\u0928\u093f\u092f\u092e","terms_conditions":"\u0928\u093f\u092f\u092e \u0914\u0930 \u0936\u0930\u094d\u0924\u0947\u0902","tnt":null,"warner":null,"writers":"\u0930\u093e\u0907\u091f\u0930\u094d\u0938"},"header":{"profile":"\u092e\u0947\u0930\u093e \u092a\u094d\u0930\u094b\u092b\u093e\u0907\u0932","settings":"\u0938\u0947\u091f\u093f\u0902\u0917","signout":"\u0938\u093e\u0907\u0928 \u0906\u0909\u091f"},"home":{"no_matches":"\u0915\u094b\u0908 \u0906\u0917\u093e\u092e\u0940 \u092e\u0941\u0915\u093e\u092c\u0932\u093e \u0928\u0939\u0940\u0902"},"homepage":{"be_the_first":"\u092b\u0941\u091f\u092c\u0949\u0932 \u0915\u0940 \u0905\u0928\u094b\u0916\u0940 \u0926\u0941\u0928\u093f\u092f\u093e \u0938\u0947 \u0939\u094b\u0902 \u0930\u0942\u092c\u0930\u0942","by":"By:","chrome_notifications":"\u0915\u094d\u0930\u094b\u092e \u0928\u094b\u091f\u0940\u092b\u093f\u0915\u0947\u0936\u0928 \u0938\u0947 \u0930\u0939\u0947\u0902 \u0905\u092a\u0921\u0947\u091f","ei":{"latest_news":null,"trending":null,"view_more":null},"fan_perspectives":"\u0935\u093f\u0938\u094d\u0924\u093e\u0930 \u0938\u0947 \u092a\u095d\u0947\u0902","fan_voice":"\u092b\u0948\u0928 \u0915\u0940 \u0906\u0935\u093e\u091c","featured_topic":"\u092a\u094d\u0930\u092e\u0941\u0916 \u0935\u093f\u0937\u092f","fixtures_and_scores":"\u092e\u0941\u0915\u093e\u092c\u0932\u093e \u0914\u0930 \u0938\u094d\u0915\u094b\u0930 ","fixtures_scores":"\u092e\u0941\u0915\u093e\u092c\u0932\u093e \u0914\u0930 \u0938\u094d\u0915\u094b\u0930 ","follow_us_on":"\u0939\u092e\u0947\u0902 \u0938\u094d\u0928\u0948\u092a\u091a\u0948\u091f \u092a\u0930 \u092b\u0949\u0932\u094b \u0915\u0930\u0947\u0902:","latest_videos":"\u0932\u0947\u091f\u0947\u0938\u094d\u091f \u0935\u093f\u0921\u093f\u092f\u094b\u091c","league_page":"\u092a\u094d\u0930\u0940\u092e\u093f\u092f\u0930 \u0932\u0940\u0917","match_day":"\u092e\u0941\u0915\u093e\u092c\u0932\u093e \u0926\u093f\u0928 %{num}","month":"%M","more":"\u0905\u0927\u093f\u0915","most_read":"\u091f\u094d\u0930\u0947\u0902\u0921\u093f\u0917","no_matches":"\u0907\u0938 \u0926\u093f\u0928 \u0915\u094b\u0908 \u092e\u0941\u0915\u093e\u092c\u0932\u093e \u0928\u0939\u0940\u0902 \u0939\u0948","other_categories":"\u0905\u0928\u094d\u092f \u0915\u0948\u091f\u0947\u0917\u0930\u0940\u094d\u0938","our_categories":"\u0915\u0948\u091f\u0947\u0917\u0930\u0940\u094d\u0938","read_now":"\u0905\u092d\u0940 \u092a\u0922\u093c\u0947","schedule":"\u0936\u093f\u0921\u094d\u092f\u0942\u0932","scores_page_desc":"\u0932\u0947\u091f\u0947\u0938\u094d\u091f \u092b\u093f\u0915\u094d\u091a\u0930\u094d\u0938 \u0914\u0930 \u0930\u093f\u091c\u0932\u094d\u091f\u094d\u0938","scores_page_title":"\u092b\u093f\u0915\u094d\u091a\u0930\u094d\u0938 \u0914\u0930 \u0930\u093f\u091c\u0932\u094d\u091f\u094d\u0938","social_text":"\u0938\u092d\u0940 \u0932\u0947\u091f\u0947\u0938\u094d\u091f \u0928\u094d\u092f\u0942\u091c","stay_up_to":"\u0938\u092d\u0940 \u0932\u0947\u091f\u0947\u0938\u094d\u091f \u0928\u094d\u092f\u0942\u091c \u0938\u0947 \u0930\u0939\u0947\u0902 \u0905\u092a\u0921\u0947\u091f","top_stories":"\u091f\u0949\u092a \u0938\u094d\u091f\u094b\u0930\u0940","trending":"\u0907\u0902\u0921\u093f\u092f\u0928 \u092b\u0941\u091f\u092c\u0949\u0932","trending_floor8":null,"video":"\u0935\u0940\u0921\u093f\u092f\u094b","videos":"\u0935\u0940\u0921\u093f\u092f\u094b","view_all":"\u0938\u092d\u0940 \u0916\u0947\u0932 \u0926\u0947\u0916\u0947\u0902","view_more":"\u0914\u0930 \u0926\u0947\u0916\u0947\u0902","watch_more_videos":"\u0905\u0928\u094d\u092f \u0935\u0940\u0921\u093f\u092f\u094b \u0926\u0947\u0916\u0947\u0902","watch_tv_12up":"WATCH 12UP SPORTS TV","watch_tv_90min":"WATCH 90MIN TV","watch_tv_circasports":"WATCH CIRCA SPORTS TV","watch_tv_dbltap":null,"watch_tv_ei":null,"watch_tv_floor8":null,"watch_tv_german_site":null,"watch_tv_ht_media":"HT \u092e\u0940\u0921\u093f\u092f\u093e \u091f\u0940\u0935\u0940 \u0926\u0947\u0916\u0947\u0902","watch_tv_theduel":null},"mobile":{"category":{"NA and EU LCS Spring Finals Are Set | Rift Raff Ep":{},"channels":{"name":{}},"common":{},"embed":{"dialogue":{}},"errors":{},"footer":{},"homepage":{},"mobile_hamburger_menu":{},"partner_page":{},"post_page":{},"static_pages":{},"tv_template":{},"website":{"header":{"menu":{}}}}},"pages":{"tv-programing":{"title":null},"tv_programming":{"disclaimer":null,"watch_now":null}},"post_page":{"ad":"\u090f\u0921\u0935\u0930\u094d\u091f\u093e\u0907\u091c\u092e\u0947\u0902\u091f","bet_now":"\u0936\u0930\u094d\u0924 \u0932\u0917\u093e\u090f\u0902","by":"By","by_betway":"via","community_content":"\u0915\u092e\u094d\u092f\u0942\u0928\u093f\u091f\u0940 \u0915\u0902\u091f\u0947\u0902\u091f","community_disclaimer":"\u092f\u0939 \u092a\u094b\u0938\u094d\u091f 90min \u0915\u092e\u094d\u092f\u0942\u0928\u093f\u091f\u0940 \u0915\u0947 \u0938\u0926\u0938\u094d\u092f \u0926\u094d\u0935\u093e\u0930\u093e \u092c\u0928\u093e\u092f\u093e \u0917\u092f\u093e \u0939\u0948, \u0914\u0930 \u0939\u092e\u093e\u0930\u0940 \u090f\u0921\u0940\u091f\u094b\u0930\u093f\u092f\u0932 \u091f\u0940\u092e \u0926\u094d\u0935\u093e\u0930\u093e \u090f\u0921\u093f\u091f \u092f\u093e \u090f\u0928\u094d\u0921\u094b\u0930\u094d\u0938 \u0928\u0939\u0940\u0902 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u0948\u0964 ","community_disclaimer_12up":"\u092f\u0939 \u092a\u094b\u0938\u094d\u091f 12up \u0915\u092e\u094d\u092f\u0942\u0928\u093f\u091f\u0940 \u0915\u0947 \u0938\u0926\u0938\u094d\u092f \u0926\u094d\u0935\u093e\u0930\u093e \u092c\u0928\u093e\u092f\u093e \u0917\u092f\u093e \u0939\u0948, \u0914\u0930 \u0939\u092e\u093e\u0930\u0940 \u090f\u0921\u0940\u091f\u094b\u0930\u093f\u092f\u0932 \u091f\u0940\u092e \u0926\u094d\u0935\u093e\u0930\u093e \u090f\u0921\u093f\u091f \u092f\u093e \u090f\u0928\u094d\u0921\u094b\u0930\u094d\u0938 \u0928\u0939\u0940\u0902 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u0948\u0964 ","community_disclaimer_90min":"\u092f\u0939 \u092a\u094b\u0938\u094d\u091f 90min \u0915\u092e\u094d\u092f\u0942\u0928\u093f\u091f\u0940 \u0915\u0947 \u0938\u0926\u0938\u094d\u092f \u0926\u094d\u0935\u093e\u0930\u093e \u092c\u0928\u093e\u092f\u093e \u0917\u092f\u093e \u0939\u0948, \u0914\u0930 \u0939\u092e\u093e\u0930\u0940 \u090f\u0921\u0940\u091f\u094b\u0930\u093f\u092f\u0932 \u091f\u0940\u092e \u0926\u094d\u0935\u093e\u0930\u093e \u090f\u0921\u093f\u091f \u092f\u093e \u090f\u0928\u094d\u0921\u094b\u0930\u094d\u0938 \u0928\u0939\u0940\u0902 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u0948\u0964 ","community_disclaimer_circasports":"\u092f\u0939 \u092a\u094b\u0938\u094d\u091f CircaSports \u0915\u092e\u094d\u092f\u0942\u0928\u093f\u091f\u0940 \u0915\u0947 \u0938\u0926\u0938\u094d\u092f \u0926\u094d\u0935\u093e\u0930\u093e \u0932\u093f\u0916\u093e \u0917\u092f\u093e \u0939\u0948 \u0924\u0925\u093e \u0939\u092e\u093e\u0930\u0940 \u090f\u0921\u093f\u091f\u094b\u0930\u093f\u092f \u091f\u0940\u092e \u0926\u094d\u0935\u093e\u0930\u093e \u090f\u0921\u093f\u091f \u092f\u093e \u0905\u0928\u0941\u092e\u094b\u0926\u093f\u0924 \u0928\u0939\u0940\u0902 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u0948\u0964 ","community_disclaimer_dbltap":null,"community_disclaimer_ei":null,"community_disclaimer_floor8":null,"community_disclaimer_ftb90":"\u092f\u0939 \u092a\u094b\u0938\u094d\u091f FTB90 \u0915\u092e\u094d\u092f\u0942\u0928\u093f\u091f\u0940 \u0915\u0947 \u0938\u0926\u0938\u094d\u092f \u0926\u094d\u0935\u093e\u0930\u093e \u0932\u093f\u0916\u093e \u0917\u092f\u093e \u0939\u0948 \u0924\u0925\u093e \u0939\u092e\u093e\u0930\u0940 \u090f\u0921\u093f\u091f\u094b\u0930\u093f\u092f\u0932 \u091f\u0940\u092e \u0926\u094d\u0935\u093e\u0930\u093e \u090f\u0921\u093f\u091f \u092f\u093e \u0905\u0928\u0941\u092e\u094b\u0926\u093f\u0924 \u0928\u0939\u0940\u0902 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u0948\u0964","community_disclaimer_german_site":null,"community_disclaimer_ht_media":"\u092f\u0939 \u092a\u094b\u0938\u094d\u091f HT Media \u0915\u092e\u094d\u092f\u0942\u0928\u093f\u091f\u0940 \u0915\u0947 \u0938\u0926\u0938\u094d\u092f \u0926\u094d\u0935\u093e\u0930\u093e \u0932\u093f\u0916\u093e \u0917\u092f\u093e \u0939\u0948 \u0924\u0925\u093e \u0939\u092e\u093e\u0930\u0940 \u090f\u0921\u093f\u091f\u094b\u0930\u093f\u092f\u0932 \u091f\u0940\u092e \u0926\u094d\u0935\u093e\u0930\u093e \u090f\u0921\u093f\u091f \u092f\u093e \u0905\u0928\u0941\u092e\u094b\u0926\u093f\u0924 \u0928\u0939\u0940\u0902 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u0948\u0964","community_disclaimer_swurley":"\u092f\u0939 \u092a\u094b\u0938\u094d\u091f Swurley \u0915\u092e\u094d\u092f\u0942\u0928\u093f\u091f\u0940 \u0915\u0947 \u0938\u0926\u0938\u094d\u092f \u0926\u094d\u0935\u093e\u0930\u093e \u0932\u093f\u0916\u093e \u0917\u092f\u093e \u0939\u0948 \u0924\u0925\u093e \u0939\u092e\u093e\u0930\u0940 \u090f\u0921\u093f\u091f\u094b\u0930\u093f\u092f\u0932 \u091f\u0940\u092e \u0926\u094d\u0935\u093e\u0930\u093e \u090f\u0921\u093f\u091f \u092f\u093e \u0905\u0928\u0941\u092e\u094b\u0926\u093f\u0924 \u0928\u0939\u0940\u0902 \u0915\u093f\u092f\u093e \u0917\u092f\u093e \u0939\u0948\u0964","community_disclaimer_theduel":null,"cookies_consent_1":"%{site} \u092e\u093f\u0928 \u0939\u093f\u0902\u0926\u0940 \u0915\u0902\u091f\u0947\u0902\u091f \u0914\u0930 \u0910\u0921\u094d\u0938 \u0915\u094b \u092a\u0930\u094d\u0938\u0928\u0932\u093e\u0907\u091c \u0915\u0930\u0928\u0947 \u0914\u0930 \u0939\u092e\u093e\u0930\u0940 \u0938\u093e\u0907\u091f \u0915\u094b \u0907\u0938\u094d\u0924\u0947\u092e\u093e\u0932 \u0915\u0930\u0928\u0947 \u092e\u0947\u0902 \u0906\u0938\u093e\u0928 \u092c\u0928\u093e\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0939\u092e \u0915\u0941\u0915\u0940\u091c \u0915\u093e \u092a\u094d\u0930\u092f\u094b\u0917 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964 \u0939\u092e \u0935\u093f\u091c\u094d\u091e\u093e\u092a\u0928 \u0914\u0930 \u090f\u0928\u093e\u0932\u093f\u091f\u093f\u0915\u094d\u0938 \u0915\u0947 \u0932\u093f\u090f \u0925\u0930\u094d\u0921 \u092a\u093e\u0930\u094d\u091f\u0940\u091c \u0915\u0947 \u0938\u093e\u0925 \u0925\u094b\u0921\u093c\u0940 \u091c\u093e\u0928\u0915\u093e\u0930\u0940 \u0938\u093e\u091d\u093e \u092d\u0940 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964","cookies_consent_2":"\u0914\u0930 \u091c\u093e\u0928\u0915\u093e\u0930\u0940","cookies_consent_approve":"\u0920\u0940\u0915 \u0939\u0948!","notf":{},"now_playing":"\u091a\u0932 \u0930\u0939\u093e \u0939\u0948:","similar_articles":"\u0938\u0902\u092c\u0902\u0927\u093f\u0924 \u0906\u0930\u094d\u091f\u093f\u0915\u0932"},"private_messages":{"conversation_date":"\u0905\u0902\u0924\u093f\u092e \u0905\u092a\u0921\u0947\u091f:","expand":"\u092c\u0922\u093c\u093e\u092f\u0947\u0902","header":"\u0907\u0928\u092c\u0949\u0915\u094d\u0938","message_sent":"\u0906\u092a\u0915\u093e \u0938\u0902\u0926\u0947\u0936 \u092d\u0947\u091c\u093e \u0917\u092f\u093e","messages":"\u0938\u0902\u0926\u0947\u0936","no_history":"\u0915\u094b\u0908 \u0939\u093f\u0938\u094d\u091f\u094d\u0930\u0940 \u0928\u0939\u0940\u0902","not_available":"\u0935\u093e\u0930\u094d\u0924\u093e\u0932\u093e\u092a \u0909\u092a\u0932\u092c\u094d\u0927 \u0928\u0939\u0940\u0902","private_message":"\u0935\u094d\u092f\u0915\u094d\u0924\u093f\u0917\u0924 \u0938\u0902\u0926\u0947\u0936","private_message_to":"\u0935\u094d\u092f\u0915\u094d\u0924\u093f\u0917\u0924 \u0938\u0902\u0926\u0947\u0936 ","send":"\u092d\u0947\u091c\u0947\u0902","send_failed":"\u0938\u0902\u0926\u0947\u0936 \u0938\u0902\u092a\u094d\u0930\u0947\u0937\u0923 \u0905\u0938\u092b\u0932\u0964 \u0915\u0943\u092a\u092f\u093e \u092a\u0941\u0928: \u092a\u094d\u0930\u092f\u093e\u0938 \u0915\u0930\u0947\u0902\u0964","sending":"\u0938\u0902\u0926\u0947\u0936 \u0938\u0902\u092a\u094d\u0930\u0947\u0937\u0923 \u091c\u093e\u0930\u0940","sent":"\u0938\u0902\u0926\u0947\u0936 \u092d\u0947\u091c\u093e \u0917\u092f\u093e","side_title":"\u0935\u093e\u0930\u094d\u0924\u093e\u0932\u093e\u092a","title":"\u0906\u092a\u0915\u0947 \u0914\u0930 ","view_history":"\u0935\u093e\u0930\u094d\u0924\u093e\u0932\u093e\u092a \u0939\u093f\u0938\u094d\u091f\u094d\u0930\u0940 \u0926\u0947\u0916\u0947\u0902","write_message_here":"\u0905\u092a\u0928\u093e \u0938\u0902\u0926\u0947\u0936  \u092f\u0939\u093e\u0902 \u0932\u093f\u0916\u0947\u0902"},"pundit":{"bet_via":"\u0915\u0947 \u0926\u094d\u0935\u093e\u0930\u093e \u0936\u0930\u094d\u0924 \u0932\u0917\u093e\u090f\u0902","draw":"\u0921\u094d\u0930\u0949","fan_predictions":"\u092a\u094d\u0930\u0936\u0902\u0938\u0915\u094b\u0902 \u0915\u093e \u092a\u0942\u0930\u094d\u0935\u093e\u0928\u0941\u092e\u093e\u0928","follow_match":"\u092b\u0949\u0932\u094b \u092e\u0948\u091a","follow_pundit":"\u092b\u0949\u0932\u094b \u092a\u0902\u0921\u093f\u0924","log_in":"\u0905\u092a\u0928\u0947 \u092a\u0942\u0930\u094d\u0935\u093e\u0928\u0941\u092e\u093e\u0928 \u0915\u094b \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093f\u090f \u0932\u093e\u0917-\u0907\u0928 \u0915\u0930\u0947\u0902","not_available":"\u0906\u0902\u0915\u0921\u093c\u0947 \u0905\u092d\u0940 \u0909\u092a\u0932\u092c\u094d\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948\u0964 \u0915\u0943\u092a\u092f\u093e \u0925\u094b\u0921\u093c\u0940 \u0926\u0947\u0930 \u092c\u093e\u0926 \u092a\u094d\u0930\u092f\u093e\u0938 \u0915\u0930\u0947\u0902","place_your_bet":"\u0936\u0930\u094d\u0924 \u0932\u0917\u093e\u092f\u0947\u0902","place_your_bet_via":"\u0915\u0947 \u0926\u094d\u0935\u093e\u0930\u093e \u0936\u0930\u094d\u0924 \u0932\u0917\u093e\u092f\u0947\u0902","prediction":"\u092a\u0942\u0930\u094d\u0935\u093e\u0928\u0941\u092e\u093e\u0928:","pundit_prediction":"%{pundit_first_name} \u0915\u093e \u092a\u0942\u0930\u094d\u0935\u093e\u0928\u0941\u092e\u093e\u0928:","select_match":"\u092a\u0942\u0930\u094d\u0935\u093e\u0928\u0941\u092e\u093e\u0928 \u0915\u0947 \u0932\u093f\u090f \u092e\u0948\u091a \u091a\u0941\u0928\u0947\u0902","select_result":"-\u092a\u0930\u093f\u0923\u093e\u092e \u0916\u094b\u091c\u0947-","team_to_win":"%{team} \u091c\u0940\u0924\u0928\u0947 \u0915\u094b","title":"%{team1} vs %{team2}: %{pundit_name} \u0915\u0947 \u0936\u0930\u094d\u0924 \u0915\u0947 \u091f\u093f\u092a\u094d\u0938","top_predictors":"\u091f\u0949\u092a \u092a\u094d\u0930\u093f\u0921\u093f\u0915\u094d\u091f\u0930\u094d\u0938","what_result":"\u0915\u094d\u092f\u093e \u0906\u092a \u092a\u0930\u093f\u0923\u093e\u092e \u091c\u093e\u0928\u0924\u0947 \u0939\u0948\u0902?","what_your_prediction":"\u0906\u092a\u0915\u093e \u092a\u0942\u0930\u094d\u0935\u093e\u0928\u0941\u092e\u093e\u0928 \u0915\u094d\u092f\u093e \u0939\u0948?","your_prediction":"\u0906\u092a\u0915\u093e \u092a\u0942\u0930\u094d\u0935\u093e\u0928\u0941\u092e\u093e\u0928:"},"reactions":{"campaigns_poweredby":"\u092a\u093e\u0935\u0930\u094d\u0921 \u092c\u093e\u092f","v1":{"lol":"\u0939\u093e\u0939\u093e","love":"\u0935\u093e\u0939","must":"\u095b\u0930\u0942\u0930 \u092a\u095d\u0947\u0902","noway":"\u0928\u0939\u0940\u0902 \u0928\u0939\u0940\u0902","share":"Share","shocked":"\u092c\u093f\u0932\u094d\u0915\u0941\u0932 \u0928\u0939\u0940\u0902","tweet":"Tweet"},"v2":{"booh":"\u092c\u0942!","cool":"\u0915\u0942\u0932","haha":"\u0939\u093e\u0939\u093e","loveit":"\u0935\u093e\u0939","noway":"\u0928\u0939\u0940\u0902 \u0928\u0939\u0940\u0902"},"your_reaction":"\u0906\u092a \u0915\u093e \u0930\u093f\u090f\u0915\u094d\u0936\u0928?"},"reactions_suicide_squad":{"reactions":{"v1":{},"v2":{}}},"settings":{"100_reads":"\u092e\u0947\u0930\u093e \u0906\u0930\u094d\u091f\u093f\u0915\u0932 100 \u092c\u093e\u0930 \u092a\u0922\u093c\u093e \u0917\u092f\u093e","about_you":"\u0905\u092a\u0928\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902","account":"\u0905\u0915\u093e\u0909\u0902\u091f","all_info_lost":"FTBpro.com \u092a\u0930 \u0909\u092a\u0932\u092c\u094d\u0927 \u0938\u092d\u0940 \u091c\u093e\u0928\u0915\u093e\u0930\u0940 \u0939\u092e\u0947\u0936\u093e \u0915\u0947 \u0932\u093f\u090f \u0939\u091f\u093e \u0926\u0940 \u091c\u093e\u090f\u0917\u0940\u0964 ","are_you_sure":"\u0915\u094d\u092f\u093e \u0906\u092a\u0915\u094b \u092f\u0915\u0940\u0928 \u0939\u0948?","by_email":"\u0908\u092e\u0947\u0932","connected_as":"\u0938\u0947 \u0915\u0928\u0947\u0915\u094d\u091f \u0939\u0948","deactivate":"\u0905\u0915\u093e\u0909\u0928\u094d\u091f \u092c\u0902\u0926 \u0915\u0930\u0947","deactivate_placeholder":"\u0915\u0943\u092a\u092f\u093e \u0915\u093e\u0930\u0923 \u092c\u0924\u093e\u090f:","deactivate_request_sent":"\u0906\u092a\u0915\u093e \u0928\u093f\u0935\u0947\u0926\u0928 \u0938\u092b\u0932\u0924\u093e \u092a\u0942\u0930\u094d\u0935\u0915 \u092d\u0947\u091c\u093e \u0917\u092f\u093e\u0964 \u0939\u092e \u0906\u092a\u0938\u0947 \u091c\u0932\u094d\u0926 \u0938\u0902\u092a\u0930\u094d\u0915 \u0915\u0930\u0947\u0917\u0947\u0964","disp_name":"\u0921\u093f\u0938\u094d\u092a\u094d\u0932\u0947 \u0928\u093e\u092e","fb_hometown":"\u092b\u0947\u0938\u092c\u0941\u0915 \u092a\u0930 \u0935\u0930\u094d\u0924\u092e\u093e\u0928 \u0936\u0939\u0930 ","fb_link":"\u092b\u0947\u0938\u092c\u0941\u0915 \u0932\u093f\u0902\u0915","go_social":"\u0938\u094b\u0936\u0932 \u092e\u0940\u0921\u093f\u092f\u093e \u092a\u0930 \u0906\u090f\u0902 \u0914\u0931  \u092e\u093f\u0924\u094d\u0930\u094b\u0902 \u0915\u094b \u092c\u0924\u093e\u090f\u0902 \u0905\u092a\u0928\u0940 \u0930\u0940\u0921\u093f\u0902\u0917 \u090f\u0915\u094d\u091f\u093f\u0935\u091f\u0940 \u0915\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947\u0902\u0964","go_social_short":"\u092e\u0947\u0930\u0947 \u092a\u0922\u093c\u0947 \u0939\u0941\u090f \u0906\u0930\u094d\u091f\u093f\u0915\u0932 \u0936\u0947\u092f\u0930 \u0915\u0930\u0947","google_plus_link":"\u0917\u0942\u0917\u0932 + \u0932\u093f\u0902\u0915","if_following_me":"\u0915\u093f\u0938\u0940 \u0928\u0947 \u092e\u0941\u091d\u0947 \u092b\u0949\u0932\u094b \u0915\u093f\u092f\u093e","if_sending_me_message":"\u0915\u093f\u0938\u0940 \u0928\u0947 \u092e\u0941\u091d\u0947 \u0938\u0902\u0926\u0947\u0936 \u092d\u0947\u091c\u093e","let_see":"\u0938\u092d\u0940 \u0915\u094b \u0926\u093f\u0916\u093e\u090f\u0902","my_team":"\u092e\u0947\u0930\u0940 \u091f\u0940\u092e","name":{"rules":"\u0928\u093e\u092e \u0935\u093f\u0936\u093f\u0937\u094d\u091f \u0939\u094b\u0928\u093e \u091a\u093e\u0939\u093f\u0947\u090f\u0964 5-50 \u0905\u0915\u094d\u0937\u0930\u0964 \u0936\u092c\u094d\u0926\u094b\u0902 \u0914\u0930 \u0905\u0902\u0915\u094b \u0915\u093e \u092a\u094d\u0930\u092f\u094b\u0917 \u0915\u0930\u0947\u0902\u0964"},"notifications":"\u0928\u094b\u091f\u093f\u092b\u093f\u0915\u0947\u0936\u0928\u094d\u0938","optional":"\u0935\u0948\u0915\u0932\u094d\u092a\u093f\u0915","privacy":"\u092a\u094d\u0930\u093e\u0907\u0935\u0947\u0938\u0940","recent_articles":"\u0939\u093e\u0932 \u0939\u0940 \u092e\u0947\u0902 \u0936\u0947\u092f\u0930 \u0915\u093f\u092f\u0947 \u0917\u092f\u0947 \u0906\u0930\u094d\u091f\u093f\u0915\u0932\u094d\u0938","save":"\u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0915\u0930\u0947\u0902","settings":"\u0938\u0947\u091f\u093f\u0902\u0917","settings_saved":"\u0938\u0947\u091f\u093f\u0902\u0917 \u0938\u0941\u0930\u0915\u094d\u0937\u093f\u0924 \u0915\u0940 \u0917\u0908","share":"\u0911\u091f\u094b-\u0936\u0947\u092f\u0930","site":"\u0938\u093e\u0907\u091f:","site_title":"\u0936\u0940\u0930\u094d\u0937\u0915","site_url":"URL:","stats":"vBets stats","submit":"\u092d\u0947\u091c\u0947\u0902","twitter_link":"\u091f\u094d\u0935\u0940\u091f\u0930 \u0932\u093f\u0902\u0915:","weekly_writers_achievements":"\u092e\u0947\u0930\u0940 \u0938\u093e\u092a\u094d\u0924\u093e\u0939\u093f\u0915 \u0930\u093e\u0907\u091f\u0930 \u0938\u092e\u0930\u0940","when_notify":"\u0938\u0942\u091a\u0928\u093e \u0926\u0947\u0902  \u091c\u092c","your_writing_language":"\u0906\u092a \u0915\u093f\u0938 \u092d\u093e\u0937\u093e \u092e\u0947\u0902 \u0932\u093f\u0916\u0928\u093e \u091a\u093e\u0939\u0947\u0902\u0917\u0947?"},"sign_up":{"about_you":"\u0905\u092a\u0928\u0947 \u092c\u093e\u0930\u0947 \u092e\u0947 \u0932\u093f\u0916\u0947\u0902","and":"\u0914\u0930","change":"\u0906\u092a \u092c\u093e\u0926 \u092e\u0947\u0902 \u0938\u0947\u091f\u093f\u0902\u0917 \u092c\u0926\u0932 \u0938\u0915\u0924\u0947 \u0939\u0948\u0964","disp_name":"\u0921\u093f\u0938\u094d\u092a\u094d\u0932\u0947 \u0928\u093e\u092e","join_12up":"\u091c\u094d\u0935\u093e\u0907\u0928 12up ","join_90min":"\u091c\u094d\u0935\u093e\u0907\u0928 90min","join_circasports":"\u091c\u094d\u0935\u093e\u0907\u0928 CircaSports","join_dbltap":null,"join_ei":null,"join_floor8":null,"join_ftb90":"\u091c\u094d\u0935\u093e\u0907\u0928 FTB90","join_german_site":null,"join_ht_media":"HT Media \u0938\u0947 \u091c\u0941\u0921\u093c\u0947\u0902","join_swurley":"\u091c\u094d\u0935\u093e\u0907\u0928 Swurley","lets_start":"\u0938\u0947\u091f\u0905\u092a \u092a\u0930 \u091c\u093e\u090f","my_game":null,"my_league":"\u0932\u0940\u0917","of_12up":"12up.com \u0915\u093e","of_90min":"90min.com \u0915\u093e ","of_circasports":"Swurley.com \u0915\u093e","of_dbltap":null,"of_ei":null,"of_floor8":null,"of_ftb90":"FTB90.com \u0915\u093e","of_german_site":null,"of_ht_media":"90min.in \u0915\u093e","privacy_policy":"\u092a\u094d\u0930\u093e\u0907\u0935\u0947\u0938\u0940 \u092a\u0949\u0932\u093f\u0938\u0940","required_field":"\u0906\u0935\u0936\u094d\u092f\u0915 \u0939\u0948","team":"\u092e\u0947\u0930\u0940 \u091f\u0940\u092e","terms":"\u0938\u0947 \u092e\u0948\u0902 \u0938\u0939\u092e\u0924 \u0939\u0942\u0901","terms_and_conditions":"\u0928\u0940\u092f\u092e \u0914\u0930 \u0936\u0930\u094d\u0924\u0947\u0902"},"stadium":{"tables":{"groups":{}}},"stat_types":{"articles":"\u0906\u0930\u094d\u091f\u093f\u0915\u0932\u094d\u0938","comments":"\u0915\u092e\u0947\u0902\u091f\u094d\u0938","reads":"\u0930\u0940\u0921\u094d\u0938"},"suicidesquad":{"reactions":{"v2":{}}},"tv_template":{"latest_stories":"\u0924\u093e\u091c\u093e \u0916\u092c\u0930\u0947\u0902","latest_videos":"\u0932\u0947\u091f\u0947\u0938\u094d\u091f \u0935\u0940\u0921\u093f\u092f\u094b\u091c","read_more":"\u0914\u0930 \u092a\u0922\u093c\u0947","recommended":"\u0906\u092a\u0915\u0947 \u0932\u093f\u090f \u0916\u093e\u0938","video":"\u0935\u0940\u0921\u093f\u092f\u093e"},"validation":{"errors":{"cover_media":{},"field_min_words":{},"games":{},"goal_field":{},"goalkeeper_min_words":{},"introduction":{},"leagues":{},"lineup":{},"media":{},"predictions_text":{},"rank_min_words":{},"rank_min_words_40":{},"rank_title":{},"subjects":{},"teaser":{},"text":{},"title":{}}},"website":{"footer":{"links":{}},"header":{"menu":{}},"static_pages":{}}}};

/*** EXPORTS FROM exports-loader ***/
exports["translations"] = (I18n.translations);

/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "download_appstore_en.svg?5b36d14b750acf21adf6eec89e4a3c1b";

/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "download_appstore_pr.svg?9699b3b0dfbdf1350e836783b48dc249";

/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "download_googleplay_en.svg?ecc7662afe32e0dabef55b1b2de31a41";

/***/ }),

/***/ 1121:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "download_googleplay_pr.svg?2f874abb74ebdf3239fe5be3dacf13c9";

/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "ei_transfers_icon.svg?9937fe299a20352c40244f96e08d032b";

/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mainNavigationChevron_icon.svg?6173d8d1c141425871c45b245dfc6740";

/***/ }),

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "schedule_icon.svg?9724666fa08585caff42010872e18608";

/***/ }),

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sports-news_icon.svg?9bf847b060c0b20d3c3397c321f91c5f";

/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "sports_icon.svg?f90f3db2fef89eb85471d7fa122b38a3";

/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "table_icon.svg?62f906eab3a25f93da24e505a18f3d81";

/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "transfers_icon.svg?ddd7c206674e1f0a5535968dc88c44b3";

/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "worldnews_icon.svg?43e52ccb2e6dbab25b95ae5904699e47";

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classnameGenerator = exports.bem = exports.getLayoutType = exports.getElementById = exports.removeDocumentEvent = exports.addDocumentEvent = exports.addWindowEvent = exports.createElement = exports.nodesByTagName = exports.liveNodesByClassName = exports.node = exports.raf = undefined;

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.elementMatchesSelector = elementMatchesSelector;
exports.selectorMatchesElement = selectorMatchesElement;
exports.makeImage = makeImage;
exports.insertBefore = insertBefore;
exports.insertAfter = insertAfter;
exports.nodeByTagName = nodeByTagName;
exports.nodes = nodes;
exports.getSingleElementByClass = getSingleElementByClass;
exports.changeClassName = changeClassName;
exports.makeImagePromise = makeImagePromise;
exports.addElementAfter = addElementAfter;
exports.removeElement = removeElement;
exports.classList = classList;
exports.toggleBemClass = toggleBemClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.selectText = selectText;
exports.forceRedraw = forceRedraw;
exports.updateClassName = updateClassName;
exports.isVisible = isVisible;
exports.referringDomain = referringDomain;
exports.scrollPercent = scrollPercent;
exports.parentElementUntil = parentElementUntil;

var _bemCn = __webpack_require__(832);

var _bemCn2 = _interopRequireDefault(_bemCn);

var _ua = __webpack_require__(9);

var _bemSelector = __webpack_require__(833);

var _bemSelector2 = _interopRequireDefault(_bemSelector);

var _console = __webpack_require__(11);

var _nm = __webpack_require__(26);

var _classnameGenerator = __webpack_require__(835);

var _classnameGenerator2 = _interopRequireDefault(_classnameGenerator);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_bemCn2.default.setup({
  mod: '--'
}); /* eslint semi:0 */
/**
 * DOM abstractions to allow cross-brwoser and easy mocking.
 */
function elementMatchesSelector(el) {
  var selector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return selector && el.nodeType === Node.ELEMENT_NODE && (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector) || false;
}

function selectorMatchesElement(selector, el) {
  return elementMatchesSelector(el, selector);
}

function makeImage(attrs) {
  return (0, _assign2.default)(new Image(), attrs);
}

var raf = exports.raf = (window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function fakeRaf(callback) {
  return callback();
}).bind(window);

var node = exports.node = document.querySelector.bind(document);
function insertBefore(newElement, targetElement) {
  var parentNode = targetElement.parentNode;

  parentNode.insertBefore(newElement, targetElement);
}

function insertAfter(newElement, targetElement) {
  var parentNode = targetElement.parentNode;

  if (parentNode.lastchild === targetElement) {
    parentNode.appendChild(newElement);
  } else {
    parentNode.insertBefore(newElement, targetElement.nextSibling);
  }
}

function nodeByTagName(tagName) {
  return document.getElementsByTagName(tagName)[0] || null;
}

function nodes() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var compoundSelector = args.join(', ');
  if (!compoundSelector) {
    (0, _console.warn)('No selectors passed to dom.nodes. Selectors:', args);
    return [];
  }
  return document.querySelectorAll.call(document, compoundSelector);
}

var liveNodesByClassName = exports.liveNodesByClassName = document.getElementsByClassName.bind(document);

var nodesByTagName = exports.nodesByTagName = document.getElementsByTagName.bind(document);
var createElement = exports.createElement = document.createElement.bind(document);
var addWindowEvent = exports.addWindowEvent = window.addEventListener.bind(window);
var addDocumentEvent = exports.addDocumentEvent = document.addEventListener.bind(document);
var removeDocumentEvent = exports.removeDocumentEvent = document.removeEventListener.bind(document);
var getElementById = exports.getElementById = document.getElementById.bind(document);
var getLayoutType = exports.getLayoutType = document.body.className;
function getSingleElementByClass(className) {
  return dom.liveNodesByClassName(className)[0] || null;
}

function changeClassName(selector, originalClass, newClass) {
  Array.prototype.slice.call(dom.liveNodesByClassName(selector)).forEach(function replaceClassName(element) {
    element.className = element.className.replace(originalClass, newClass);
  });
}

function makeImagePromise(src, resolve, reject) {
  return new _promise2.default(makeImage.part({ src: src, onerror: reject, onload: resolve })).then(resolve).catch(reject);
}

function addElementAfter(newNode, referenceNode) {
  var skipOverSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (referenceNode && referenceNode.nextSibling) {
    var parentNode = referenceNode.parentNode,
        insertAfterNode = referenceNode.nextSibling;

    var shouldSkipEl = selectorMatchesElement.part(skipOverSelector);
    while (shouldSkipEl(insertAfterNode) || shouldSkipEl(insertAfterNode.nextSibling)) {
      insertAfterNode = insertAfterNode.nextSibling;
    }
    parentNode.insertBefore(newNode, insertAfterNode);
    return newNode;
  }
  return null;
}

function removeElement(node) {
  if (node.parentNode) {
    node.parentNode.removeChild(node);
  }
}

function classList(node) {
  function classListPolyfillFn(classListFn) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      args.forEach(function (singleClass) {
        node.classList[classListFn](singleClass);
      });
    };
  }
  var classListPolyfill = (0, _ua.getIsIe)() ? {
    add: classListPolyfillFn('add'),
    remove: classListPolyfillFn('remove'),
    toggle: function toggleOriginalClassListFn() {
      var _node$classList;

      (_node$classList = node.classList).toggle.apply(_node$classList, arguments);
    },
    contains: function containsOriginalClassListFn() {
      var _node$classList2;

      (_node$classList2 = node.classList).contains.apply(_node$classList2, arguments);
    }
  } : node.classList;
  return classListPolyfill;
}
exports.bem = _bemCn2.default;
exports.classnameGenerator = _classnameGenerator2.default;
function toggleBemClass(bemFromSelector, bemToSelector) {
  (0, _from2.default)(dom.nodes('.' + bemFromSelector)).forEach(function (node) {
    node.className = bemToSelector;
  });
}

function addClass(el, newClass) {
  el.className += ' ' + newClass;
}

function removeClass(el, classToRemove) {
  var elClass = ' ' + el.className + ' ';
  while (elClass.includes(classToRemove)) {
    elClass = elClass.replace(classToRemove, '');
  }
  el.className = elClass.trim();
}

function selectText(element) {
  var range = void 0;
  if (document.body.createTextRange instanceof Function) {
    range = document.body.createTextRange();
    range.moveToElementText(element);
    range.select();
  } else if (window.getSelection instanceof Function) {
    var selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

function forceRedraw(el) {
  if (!(el instanceof Element)) {
    (0, _console.warn)('Called forceRedraw with non Element:', el);
    return el;
  }
  var display = el.style.display;

  el.style.display = 'none';
  // reading this property forces webkit to reflow. Possible alternatives: http://stackoverflow.com/q/3485365
  el.offsetHeight;
  el.style.display = display;
  return el;
}

function updateClassName(selector, baseClass, modifiers) {
  var element = dom.node(selector);
  if (element instanceof Element) {
    var newClassName = (0, _bemSelector2.default)({
      name: baseClass,
      modifiers: modifiers
    });
    element.className = newClassName;
  }
}

function isVisible(el) {
  if (!(el instanceof Element)) {
    (0, _console.warn)('Called isVisible with non Element:', el);
    return false;
  }
  return window.getComputedStyle(el).display !== 'none';
}

function referringDomain() {
  var referrer = document.referrer.split('/')[2];
  return referrer && referrer.match(document.domain) || referrer === undefined ? '' : referrer;
}

function scrollPercent() {
  var h = document.documentElement;
  var b = document.body;
  var scrolled = h.scrollTop || b.scrollTop / ((h.scrollHeight || b.scrollHeight) - h.clientHeight) * 100;
  return window.parseInt(scrolled, 10);
}

function parentElementUntil(predicate) {
  return function checkElement(target) {
    if (!target || target === document.body) {
      return null;
    }
    return predicate(target) ? target : checkElement(target.parentNode);
  };
}
var dom = (0, _assign2.default)((0, _object.create)(), {
  raf: raf,
  node: node,
  insertAfter: insertAfter,
  nodeByTagName: nodeByTagName,
  nodes: nodes,
  liveNodesByClassName: liveNodesByClassName,
  nodesByTagName: nodesByTagName,
  createElement: createElement,
  addWindowEvent: addWindowEvent,
  addDocumentEvent: addDocumentEvent,
  removeDocumentEvent: removeDocumentEvent,
  getElementById: getElementById,
  getLayoutType: getLayoutType,
  getSingleElementByClass: getSingleElementByClass,
  changeClassName: changeClassName,
  makeImage: makeImage,
  makeImagePromise: makeImagePromise,
  elementMatchesSelector: elementMatchesSelector,
  selectorMatchesElement: selectorMatchesElement,
  addElementAfter: addElementAfter,
  removeElement: removeElement,
  classList: classList,
  bem: _bemCn2.default,
  classnameGenerator: _classnameGenerator2.default,
  toggleBemClass: toggleBemClass,
  addClass: addClass,
  removeClass: removeClass,
  selectText: selectText,
  forceRedraw: forceRedraw,
  updateClassName: updateClassName,
  isVisible: isVisible,
  referringDomain: referringDomain,
  scrollPercent: scrollPercent,
  parentElementUntil: parentElementUntil
});

(0, _nm.registerUtils)({ dom: dom });

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends4 = __webpack_require__(10);

var _extends5 = _interopRequireDefault(_extends4);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.getApiEndpoints = getApiEndpoints;

var _console = __webpack_require__(11);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
/**
 * A way to get API endpoints from PDO.
 */
var apiPdo = null;
var apiEndpoints = null;
var endpointNames = null;

function getApiEndpoints() {
  var endpointName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  apiPdo = apiPdo || _pageDataObject2.default.get('config.api', {});
  var apiKeys = (0, _keys2.default)(apiPdo);
  endpointNames = endpointNames || apiKeys.reduce(function (accumulator, key) {
    return (0, _extends5.default)({}, accumulator, (0, _defineProperty3.default)({}, key.toUpperCase(), key.toUpperCase()));
  }, {});

  apiEndpoints = apiEndpoints || apiKeys.reduce(function (accumulator, key) {
    return (0, _extends5.default)({}, accumulator, (0, _defineProperty3.default)({}, key.toUpperCase(), apiPdo[key]));
  }, {});
  if (endpointName && endpointName in apiEndpoints) {
    var url = apiEndpoints[endpointName];
    return url && {
      url: url,
      endpointName: endpointName
    };
  }
  (0, _console.warn)('No \'' + endpointName + '\' in apiEndpoints! Check PDO and possibly clear Redis', {
    endpointName: endpointName,
    endpointNames: endpointNames,
    apiEndpoints: apiEndpoints,
    apiPdo: apiPdo
  });
  return {
    endpointNames: endpointNames,
    apiEndpoints: apiEndpoints
  };
}

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reduceObjectEntries = exports.isObject = exports.objectMap = exports.keys = exports.create = undefined;

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _of = __webpack_require__(821);

var _of2 = _interopRequireDefault(_of);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

var _regenerator = __webpack_require__(128);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _getIterator2 = __webpack_require__(55);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _create = __webpack_require__(182);

var _create2 = _interopRequireDefault(_create);

var _isFrozen = __webpack_require__(825);

var _isFrozen2 = _interopRequireDefault(_isFrozen);

var _typeof2 = __webpack_require__(255);

var _typeof3 = _interopRequireDefault(_typeof2);

var _freeze = __webpack_require__(435);

var _freeze2 = _interopRequireDefault(_freeze);

exports.deepFreeze = deepFreeze;
exports.makeEmptyObj = makeEmptyObj;
exports.mapObject = mapObject;
exports.snakeToCamel = snakeToCamel;
exports.snakeKeysToCamel = snakeKeysToCamel;
exports.noFalsyValue = noFalsyValue;
exports.objectTouple = objectTouple;
exports.reduceObjectEntriesInto = reduceObjectEntriesInto;
exports.classFactory = classFactory;
exports.serialize = serialize;
exports.map = map;
exports.iterate = iterate;
exports.namespacedConsts = namespacedConsts;
exports.removeFalsyValues = removeFalsyValues;

var _nm = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(objectTouple);

var freeze = _freeze2.default,
    isObject = Object.isObject;
function deepFreeze(o) {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze
  //TODO - make sure to enable deepFreeze when last supported Chrome version will be 43
  /* eslint-disable*/
  freeze(o); // First freeze the object.
  for (var propKey in o) {
    var prop = o[propKey];
    if (!Object.prototype.hasOwnProperty.call(o, propKey) || (typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop)) !== 'object' || (0, _isFrozen2.default)(prop)) {
      // If the object is on the prototype, not an object, or is already frozen,
      // skip it. Note that this might leave an unfrozen reference somewhere in the
      // object if there is an already frozen object containing an unfrozen object.
      continue;
    }
    deepFreeze(prop); // Recursively call deepFreeze.
  }
  return o;
  /* eslint-enable*/
}

function makeEmptyObj() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Object.define((0, _create2.default)(null), props);
}

function mapObject(obj, mapFunction) {
  var newObject = {};
  (0, _keys2.default)(obj).forEach(function mapObjectKey(key) {
    (0, _assign2.default)(newObject, mapFunction(key, obj[key]));
  });
  return newObject;
}

function snakeToCamel(s) {
  return s.replace(/(\_\w)/g, function (m) {
    return m[1].toUpperCase();
  });
}

function snakeKeysToCamel(obj) {
  return mapObject(obj, function (key, value) {
    var camelKey = snakeToCamel(key);
    var tempObj = {};
    tempObj[camelKey] = value;
    return tempObj;
  });
}

function noFalsyValue(key, val) {
  return val ? (0, _defineProperty3.default)({}, key, val) : {};
}

function objectTouple(obj) {
  var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

  return _regenerator2.default.wrap(function objectTouple$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iteratorNormalCompletion = true;
          _didIteratorError = false;
          _iteratorError = undefined;
          _context.prev = 3;
          _iterator = (0, _getIterator3.default)((0, _keys2.default)(obj));

        case 5:
          if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
            _context.next = 12;
            break;
          }

          key = _step.value;
          _context.next = 9;
          return [key, obj[key]];

        case 9:
          _iteratorNormalCompletion = true;
          _context.next = 5;
          break;

        case 12:
          _context.next = 18;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](3);
          _didIteratorError = true;
          _iteratorError = _context.t0;

        case 18:
          _context.prev = 18;
          _context.prev = 19;

          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }

        case 21:
          _context.prev = 21;

          if (!_didIteratorError) {
            _context.next = 24;
            break;
          }

          throw _iteratorError;

        case 24:
          return _context.finish(21);

        case 25:
          return _context.finish(18);

        case 26:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[3, 14, 18, 26], [19,, 21, 25]]);
}

function reduceObjectEntriesInto(accumulator, reducerFn, objectToReduce) {
  return (0, _entries2.default)(objectToReduce).reduce(reducerFn, accumulator);
}

exports.create = makeEmptyObj;
function classFactory(Class) {
  return freeze({
    create: function instantiate() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return new (Function.prototype.bind.apply(Class, [null].concat(args)))();
    }
  });
}

var keys = exports.keys = function keys() {
  return _of2.default.apply(Array, arguments).reduce(function (allKeys, obj) {
    return allKeys.concat((0, _keys2.default)(obj));
  }, []);
};
function serialize(obj, delimiter) {
  return (0, _keys2.default)(obj).reduce(function (keyValuePairs, key) {
    var val = obj[key];
    if (val) {
      keyValuePairs.push(key + '=\'' + val + '\'');
    }
    return keyValuePairs;
  }, []).join(delimiter);
}

function map(obj, block) {
  var result = [];
  for (var key in obj) {
    var value = obj[key];
    result.push(block(key, value));
  }
  return result;
}

function iterate(obj, callback, context) {
  if (context) {
    callback = callback.bind(context); // eslint-disable-line no-param-reassign
  }
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (0, _getIterator3.default)(objectTouple(obj)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _ref2 = _step2.value;

      var _ref3 = (0, _slicedToArray3.default)(_ref2, 2);

      var key = _ref3[0];
      var value = _ref3[1];

      callback(value, key);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return obj;
}

exports.objectMap = mapObject;
function namespacedConsts(nestedNames) {
  var seperator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';
  var currentNamespace = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  var namespacedNames = object.create();
  for (var key in nestedNames) {
    var currentName = '' + currentNamespace + seperator + key;
    var value = nestedNames[key];
    if ((typeof value === 'undefined' ? 'undefined' : (0, _typeof3.default)(value)) === 'object') {
      namespacedNames[key] = namespacedConsts(value, seperator, currentName);
    } else if (value) {
      namespacedNames[key] = currentName.slice(1);
    }
  }
  return deepFreeze(namespacedNames);
}

function removeFalsyValues(obj) {
  return mapObject(obj, noFalsyValue);
}

exports.isObject = isObject;
var reduceObjectEntries = exports.reduceObjectEntries = reduceObjectEntriesInto.bind(null, {});

var object = (0, _assign2.default)(makeEmptyObj(), {
  snakeKeysToCamel: snakeKeysToCamel,
  makeEmptyObj: makeEmptyObj,
  create: makeEmptyObj,
  classFactory: classFactory,
  deepFreeze: deepFreeze,
  keys: keys,
  serialize: serialize,
  map: map,
  iterate: iterate,
  objectMap: mapObject,
  noFalsyValue: noFalsyValue,
  removeFalsyValues: removeFalsyValues,
  namespacedConsts: namespacedConsts,
  isObject: isObject,
  objectTouple: objectTouple,
  reduceObjectEntriesInto: reduceObjectEntriesInto,
  reduceObjectEntries: reduceObjectEntries
});

(0, _nm.registerUtils)({ object: object });

/***/ }),

/***/ 1301:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 20 20' style='enable-background:new 0 0 20 20;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23EEEEEE;%7D .st1%7Bfill:none;%7D %3C/style%3E %3Cpath id='Shape_1_' class='st0' d='M11,9.5h-0.5V7.3H11c0.3,0,0.5,0.2,0.5,0.5s0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5 c0-0.9-0.7-1.6-1.5-1.6h-0.5V5.7c0-0.3-0.2-0.5-0.5-0.5S9.5,5.4,9.5,5.7v0.5H9c-0.8,0-1.5,0.7-1.5,1.6v1.1c0,0.9,0.7,1.6,1.5,1.6 h0.5v2.2H9c-0.3,0-0.5-0.2-0.5-0.5S8.3,11.7,8,11.7s-0.5,0.2-0.5,0.5c0,0.9,0.7,1.6,1.5,1.6h0.5v0.5c0,0.3,0.2,0.5,0.5,0.5 s0.5-0.2,0.5-0.5v-0.5H11c0.8,0,1.5-0.7,1.5-1.6v-1.1C12.4,10.2,11.8,9.5,11,9.5z M9.5,9.5H9C8.7,9.5,8.5,9.3,8.5,9V7.8 c0-0.3,0.2-0.5,0.5-0.5h0.5V9.5z M11.5,12.2c0,0.3-0.2,0.5-0.5,0.5h-0.5v-2.2H11c0.3,0,0.5,0.2,0.5,0.5V12.2z'/%3E %3Cpath class='st1' d='M12.7,16C12.7,16,12.7,16,12.7,16C12.7,16,12.7,16,12.7,16z'/%3E %3Cpath class='st1' d='M7.3,4C7.3,4,7.3,4,7.3,4C7.3,4,7.3,4,7.3,4z'/%3E %3Cpath class='st1' d='M13.3,15.7C13.3,15.7,13.3,15.7,13.3,15.7C13.3,15.7,13.3,15.7,13.3,15.7z'/%3E %3Cpath class='st1' d='M6.7,4.3C6.7,4.3,6.7,4.3,6.7,4.3C6.7,4.3,6.7,4.3,6.7,4.3z'/%3E %3Cpath class='st0' d='M12.1,1H12C12,1,12.1,1,12.1,1L12.1,1z'/%3E %3Cpath class='st0' d='M10,0C4.5,0,0,4.5,0,10s4.5,10,10,10s10-4.5,10-10S15.5,0,10,0z M17.3,4.5c0.5,0.6,0.9,1.3,1.2,2l-2.3,1.2 c-0.1-0.4-0.3-0.7-0.5-1.1c-0.2-0.3-0.4-0.7-0.7-1L17.3,4.5z M15.8,10c0,3.2-2.6,5.8-5.8,5.8S4.2,13.2,4.2,10S6.8,4.2,10,4.2 S15.8,6.8,15.8,10z M12.1,1c1.9,0.4,3.5,1.4,4.8,2.9l-2.3,1.2c-0.7-0.7-1.6-1.2-2.5-1.5V1z M8.6,0.9c0.6-0.1,1-0.1,1.4-0.1 s0.8,0,1.2,0.1v2.6c0,0,0,0-0.1,0c-0.4-0.1-0.7-0.1-1.1-0.1s-0.8,0-1.1,0.1c0,0,0,0-0.1,0H8.7c0,0,0,0-0.1,0V0.9z M8,1v2.7 c-0.1,0-0.2,0.1-0.2,0.1C7.6,3.8,7.5,3.9,7.3,4c0,0,0,0,0,0C7.1,4.1,6.9,4.2,6.7,4.3c0,0,0,0,0,0C6.2,4.6,5.8,4.9,5.5,5.2L3.2,4 C4.5,2.4,6.2,1.4,8,1z M2.7,4.5L5,5.7C4.8,5.9,4.7,6.1,4.5,6.3C4.4,6.4,4.4,6.5,4.3,6.6C4.1,6.9,3.9,7.3,3.8,7.7L1.5,6.5 C1.8,5.8,2.2,5.2,2.7,4.5z M0.8,10c0-0.9,0.1-1.8,0.4-2.7l2.3,1.2C3.4,9,3.3,9.5,3.3,10s0.1,1,0.2,1.5l-2.3,1.2 C0.9,11.8,0.8,10.9,0.8,10z M2.7,15.5c-0.5-0.6-0.9-1.3-1.2-2l2.3-1.2c0.1,0.4,0.3,0.7,0.5,1.1c0.2,0.3,0.4,0.7,0.7,0.9c0,0,0,0,0,0 L2.7,15.5z M8,19c-1.8-0.4-3.5-1.4-4.8-2.9l2.3-1.2c0.7,0.7,1.6,1.2,2.5,1.5V19z M11.4,19.1c-0.6,0.1-1,0.1-1.4,0.1s-0.8,0-1.2-0.1 v-2.6c0,0,0,0,0.1,0c0.4,0.1,0.7,0.1,1.1,0.1s0.8,0,1.1-0.1c0,0,0,0,0.1,0h0.1c0,0,0,0,0.1,0V19.1z M12,19v-2.7 c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0,0,0,0c0.2-0.1,0.4-0.2,0.6-0.3c0,0,0,0,0,0c0.4-0.3,0.8-0.5,1.2-0.9l2.3,1.3 C15.5,17.6,13.8,18.6,12,19z M17.3,15.5l-2.2-1.2c0.2-0.3,0.5-0.6,0.7-1c0.2-0.3,0.4-0.7,0.5-1.1l2.2,1.2 C18.2,14.2,17.8,14.9,17.3,15.5z M16.5,11.4c0.1-0.5,0.2-1,0.2-1.5s-0.1-1-0.2-1.5l2.3-1.2c0.3,0.9,0.4,1.8,0.4,2.7 c0,1-0.1,2-0.4,2.8L16.5,11.4z'/%3E %3Cpath class='st0' d='M5,14.3C5,14.3,5,14.3,5,14.3L5,14.3C5,14.3,5,14.3,5,14.3z'/%3E %3Cpath class='st0' d='M12.2,16.2c0.1-0.1,0.3-0.1,0.4-0.2C12.5,16.1,12.4,16.2,12.2,16.2z'/%3E %3C/svg%3E"

/***/ }),

/***/ 1302:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 23.0.3, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 148 256' style='enable-background:new 0 0 148 256;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23133F75;%7D .st1%7Bfill:%23BA2222;%7D %3C/style%3E %3Cg id='bg'%3E %3C/g%3E %3Cg id='graphics'%3E %3Cg%3E %3Cpath class='st0' d='M142.6,97.5c-1.3,0.2-5.2,0.2-5.7-6c-0.3-4.1,1.5-5.7,1.5-5.7s-3.1-0.1-3.8,2.4c-0.6,2.2-1.2,7.1,1.7,10.3 c-3.2,0.3-7,0.4-10,1.1c-3.1,0.7-4.6-1.9-5-2.5c-6.3,1.9-8.7,3.7-13.4,4c-4.9,0.3-7.8-0.4-7.8-0.4s-12.6,1.4-21.4,0.6 c-1.4,4.6-2.6,9.6-3,11.4c-1.7,10.1-0.5,13.4,0.2,20.6c0.4,3.7,1.6,5.3,1.2,6.1c-0.6,1.3-3.5,1.5-3.5,1.5l3.8,9.7l0.8,2.7 c0,0,7.6,11.2,16.4,20c8.8,8.8,8,13,7.6,18c-0.1,1.3,0.3,4.8,0.9,8.7c0.1,0.5,0.2,1.2,0.3,2.1c0.4,4.4,4.2,23.8,5,27.5 c0.8,3.8,5.2,7.4,6.8,8.6c3.1,2.3,12.3,6.2,12.5,8.7c0.1,1.2,1.6,6.8-13.9,3.1c-2.1-0.5-10.4-2.1-14.5-3.2 c-6.2-1.7-4.3-6-2.8-10.1c1.3-4.4,1.9-8.8-0.6-11.9c-11.5-14.3-8.1-22-9-26.6c-0.8-3.7-5.2-8.3-5.2-8.3c-8.1,0.9-14.1,0.6-16-2.5 c0-0.1-0.1-0.1-0.1-0.2c1.2-6.7,3.4-11.4,6.5-16.2c-4.7,1.9-9,6.3-9.9,11.6c-0.2,1.3-0.3,4-0.3,5.2c0,3.8-0.8,7.6-2.9,8 c-6.4,1-8,0.5-15.2-0.8c-4.2-0.9-6.9-1.8-10.5-1.6c3.6,2.3,6.2,3.8,7.8,5.3c-0.4,0.4-0.9,0.9-1.4,1.3c-3.7,3.1-4.9,7.8-7.2,10.2 c-0.8,5.1-1.7,11.6-6.8,17.1c-6.7,7.1-7.4,9-9.9,13.1c-0.4,1.3,0.2,6-0.6,7.8c-0.6,1.3,0.6,5.3,0.9,7.8H148V95.2 C146.9,96.6,144.7,97.2,142.6,97.5z'/%3E %3Cpath class='st1' d='M0,0v248.8c0.8-2,2.3-4.3,2.7-5.4c0,0,4.5-7.2,7.3-15.9c2.7-8.4,0.8-13.4,9.8-24.3c0.1-0.2,0.3-0.3,0.5-0.4 c1.2-4.7,4.6-9.5,4.6-9.5s-1.7-1.7,0-3.4c1.7-1.7,5.9-11.3,5.9-13.4c0-2.1,0.4-11.3,2.3-20.1c1.7-8,4-7.4,4.7-9.7 c2.2,1.1,5.3,2,8.6,0.2c7.5-4.1,12.7-6.3,19.7-5.2c0,0-1.7-1.6-5.7-1.7c-6-0.1-6.7,1-13.5,2.5c-6.6,1.4-8.8-1.8-12-2.5 c-4-0.8,0.1-6.2,0.4-7c1.8-5.4,3.5-13.5,2.8-19.5c2.8,6.5,7.6,7.8,11.7,10.6c3.2,2.2,8.4,5.2,11.1,4c2.3-1.1,6.5-11.5,7.8-14.9 c-0.7-0.3-9.1-4.5-9.3-4.7l-2.6,3.6c0,0,0.6-3.7-0.5-7.6c-0.7-2.3-3.5-4.8-3.5-4.8c1.6-8.3-3.6-12.6-8.7-13.6c1.3-4.4,6-3.1,8-2.4 c1.6,0.6,3.3,1.8,4.9,3.1c0.3,2,0.8,4.3,1.6,6.1c1.8,3.8,5.1,4.5,5.1,4.5s-1.6-1.6-2.7-6.7c0.5-2,1.2-4,1.7-5.4 c0.2-0.6,0.5-1,0.7-1.3c-1.7-1.3-6.9-5.1-9.8-8.4c-2.8-3.1-2.1-10.1,0-14.3c2.1-4.2,4.2-5.9,14.3-4.9c10.1,1,11.3,6.6,11.3,6.6 c1.9,0.6,2.2,4.9,2,8c-0.1,1.7-1.6,1.7-1.6,1.7c-7-0.4-6.4-4.1-8.3,4.5c4.1-2.1,7.5,1.2,10.4,4.1c1,1,1.4,2.2,1.4,3.5 c-0.2,3.7-0.9,6.7-2.9,9.2c3.2-2.9,4.7-5.7,5.5-8.7c2.7,0.5,5.8,1.2,9.5,2.1c3.8,1,6.9-0.7,11.3-1.1c3.3-0.3,8.1,0.1,14.3,0.5 c0-0.1,0-0.1,0-0.2c0.4-2.1,5.2-1.1,6.2-2.1c1-1.1,1.2-1,4.5-2.6c3.4-1.6,5.3-2.6,8.2-2.5c2.9,0.1,4.2,1.1,4.2,1.1s0.8-0.6,3,1.3 c0.5,0.4,0.9,1,1.2,1.7V0H0z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1303:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='premier_league' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 32 32' style='enable-background:new 0 0 32 32;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%2311498E;%7D .st1%7Bfill:%23FEFEFE;%7D .st2%7Bfill:%231DC1FF;%7D .st3%7Bfill:%23C70909;%7D .st4%7Bfill:%23CC791D;%7D .st5%7Bfill:%23F6C660;%7D .st6%7Bfill:%238F0225;%7D %3C/style%3E %3Cg%3E %3Ccircle id='Ellipse_1_copy_15_2_' class='st0' cx='16' cy='16' r='16'/%3E %3Ccircle id='Ellipse_7_copy_2_2_' class='st1' cx='16' cy='16' r='14.7'/%3E %3Cpath class='st0' d='M16,9.7l2.1,3.8l4.2,0.8l-3,3.2l0.5,4.3L16,20l-3.9,1.8l0.5-4.3l-3-3.2l4.2-0.8L16,9.7'/%3E %3Cpath id='Shape_51_copy_5' class='st0' d='M16,8.4l-2.1-1.8L9.6,6.2l3-1.5l-0.5-2.1L16,3.5l3.9-0.9l-0.5,2.1l3,1.5l-4.2,0.4L16,8.4 '/%3E %3Cpath id='Shape_51_copy_6' class='st0' d='M23.2,13.5l0.9-2.6l-1.3-4.1l2.5,2.1L27,7.6l0.7,4l2.3,3.3L28,15.2l-0.3,3.3l-2-3.8 L23.2,13.5'/%3E %3Cpath id='Shape_51_copy_7' class='st0' d='M11.3,22.4l0.4,2.8l2.9,3.1l-3.2-0.8l-1,1.9l-2.3-3.2l-3.5-1.9L6.4,23l-1.2-3.1l3.4,2.5 L11.3,22.4'/%3E %3Cpath id='Shape_51_copy_9' class='st0' d='M20.6,22.2l2.8,0.1l3.5-2.3l-1.3,3l1.7,1.3l-3.6,1.7l-2.5,3.1l-0.9-1.9l-3.3,0.7l3-3 L20.6,22.2'/%3E %3Cpath id='Shape_51_copy_8' class='st0' d='M8.8,14.2l-2.4,1.3l-1.8,3.9l-0.4-3.3l-2.1-0.2l2.2-3.4l0.5-4l1.8,1.2l2.5-2.3l-1.1,4.1 L8.8,14.2'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1304:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 200 200' style='enable-background:new 0 0 200 200;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23CD9238;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%230B8C38;%7D %3C/style%3E %3Cg%3E %3Ccircle class='st0' cx='100' cy='100' r='100'/%3E %3Cpath d='M100,201.5C44,201.5-1.5,156-1.5,100C-1.5,44,44-1.5,100-1.5C156-1.5,201.5,44,201.5,100C201.5,156,156,201.5,100,201.5z M100,1.5C45.7,1.5,1.5,45.7,1.5,100c0,54.3,44.2,98.5,98.5,98.5c54.3,0,98.5-44.2,98.5-98.5C198.5,45.7,154.3,1.5,100,1.5z'/%3E %3C/g%3E %3Cg%3E %3Crect x='97.5' y='1.5' class='st1' width='5' height='196.5'/%3E %3C/g%3E %3Cg%3E %3Crect x='1.8' y='97.2' class='st1' width='196.5' height='5'/%3E %3C/g%3E %3Cg%3E %3Crect x='1.8' y='97.2' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -41.2426 99.9262)' class='st1' width='196.5' height='5'/%3E %3C/g%3E %3Cg%3E %3Crect x='97.5' y='1.5' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -41.2426 99.9262)' class='st1' width='5' height='196.5'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st1' d='M101,183.5c-45.9,0-83.2-37.3-83.2-83.2S55.1,17.2,101,17.2s83.2,37.3,83.2,83.2S146.9,183.5,101,183.5z M101,22.2c-43.1,0-78.2,35.1-78.2,78.2s35.1,78.2,78.2,78.2s78.2-35.1,78.2-78.2S144.1,22.2,101,22.2z'/%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath class='st2' d='M118.9,49.9c-1.1-1.8-0.4-2.2-3.6-5.8c-3.3-3.6-9.8-4.7-9.8-4.7s-3.4,0.4-4.4,0s-5.8-3.6-5.8-3.6l-5.1-2.2 l-4.7-3.3l-4,3.6l-6.6,0.4l-3.3-4v7.3c0,0-1.8,1.8-2.5,0.7c-0.7-1.1-1.8-8-1.8-8l-5.1,5.1c0,0-2.5,2.5-3.6,3.3s-0.4-2.2-1.1,0.7 c-0.7,2.9-1.1,5.8,0,7.3c1.1,1.5,2.2,8.7,2.2,8.7s-2.9,3.3-4.7,4.7s-3.3,4-2.2,5.8c1.1,1.8,2.9,3.6,2.9,3.6s-4.4,1.8-3.3,3.6 s-0.4,2.9,1.5,3.6s8,6.9,9.5,7.6s5.5,10.8,7.3,12c1.8,1.2,12.7,5.9,12.7,5.9l5.1,36.4l1.1,10.9l0.6,9.2l0.2,2.5l3.3,5.8 c0,0,0.7,5.5,2.5,6.2s2.9,2.5,4.7,2.2s1.8-0.4,1.8-0.4l3-24c0,0-1.7-1.8,0-2.9c1.7-1.1,3.9-4.7,3.9-4.7l7.6-6.2l-4.4-4.3l0.4-3.8 l8.7,3.8l6.2-10c0,0,2.9-5.1,2.2-8s0.1-5.8,0.1-5.8s2.4-5.4,3.9-6.3s5.8-2.4,5.8-2.4s2.2,0.4,3.6-1.8s2.2-9.1,2.2-9.1 s-0.4-8,0-9.1c0.4-1.1,7.3-9.1,7.3-9.1s0-4,0-5.5c0-1.5,2.5-4,0-6.2s-0.7-1.8-4-3.6c-3.3-1.8-4-2.5-6.2-3.3s-4.7,0.7-5.8,0.7 s-1.5,0.7-3.3,0.7s-3.3-0.4-3.3-0.4s-1.5-2.2-2.5-1.8s-1.1,0.4-1.1,0.4s-1.5,1.8-2.5,4.4c-1.1,2.5,0.4,2.5-1.1,2.5s0.7,2.5-1.5,0 c-2.2-2.5-2.5-0.7-2.2-2.5c0.4-1.8,2.2-5.1,2.2-5.1h-2.9V49.9z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1305:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Cpath class='st6' d='M21.1,7.2c-1-2-3-4.1-5.1-4.9C12.7,0.7,8.2,1.2,5.3,3.4c-3.6,2.7-5.1,7.1-3.9,11.4c0.8,3.4,4,6.6,7.4,7.4 c4.2,1.1,8.6-0.2,11.3-3.8C22.5,15.5,22.9,10.7,21.1,7.2z M19.3,18.3c-2.5,2.8-5.9,4.1-9.6,3.4c-2.2-0.6-4.5-1.6-5.9-3.6 c-2.3-2.8-2.8-7.5-1-10.6C4.6,3.8,8.4,1.8,12.4,2c2.4,0.2,4.6,1.2,6.4,2.9c0.8,0.9,1.4,1.9,1.9,2.9C22.3,11.1,21.7,15.6,19.3,18.3z' /%3E %3Cpath class='st6' d='M18.9,5.7h-0.2c-0.1-0.1-0.3-0.1-0.3-0.2c0-0.1,0.1-0.1,0.2-0.1c-0.2-0.1-0.1-0.3-0.2-0.5 c-0.3-0.1-0.1,0.3-0.2,0.3c-0.3,0-0.5,0.1-0.8-0.1l0.1-0.1c0,0-0.1-0.1-0.2-0.1c0,0.4-0.4,0.1-0.7,0.2c-0.2-0.1-0.1-0.2-0.1-0.4 c-0.1,0-0.1,0-0.2,0c0,0.5-0.6,0.3-0.9,0.3c-0.3-0.2-1,0.2-1-0.5c-0.2-0.1-0.4,0.1-0.5,0.2c-0.7-0.4-0.8,0.7-1.4,0.3 c0-0.2,0-0.4,0.2-0.6c0.3-0.3-0.1-0.7-0.1-1c-0.3-0.7-1.2-1-1.9-0.6C9.8,3.1,9.7,4,9.8,4.7c0,0.1-0.1,0-0.2,0C9,5.1,8.6,5.8,8.2,6.3 c0,1.4-0.3,2.8-0.7,4.1c0.1,0,0.2,0,0.2,0.1c-0.3,0.4,0.1,0.8,0.1,1.2c-0.5,1.4-0.9,2.8-1.2,4.2c-0.1,0.3-0.5,0.3-0.8,0.5 c-0.4,0.5-0.9,1-1.1,1.6c0.2,0.5,0.2,1.2,0.7,1.4c0.3,0.5,0.8,0.1,1.1,0.1c0.2-0.4-0.1-0.7-0.1-1.1c0.4-0.2,0.9,0,1.3-0.1 c0.3-0.7,0.5-1.3,0.9-2c0.2-1,0.6-2,1.1-3c0.1-0.1,0-0.2,0.1-0.3c0.7,0.2,1,0.9,1.4,1.4c0.2,0.5,0.8,0.8,1.1,1.3 c0.3,1,0.5,2,0.8,2.9c0.1,0.5-0.2,1,0.3,1.4c0.6,0.4,1.2,1,2,0.6V20c-0.2-0.6-0.9-1.1-0.8-1.9c0.2-1-0.4-1.8-0.3-2.8 c-0.4-0.4-0.5-0.9-0.9-1.3c-0.1-0.3-0.5-0.5-0.5-0.8c0.1-0.1,0.1-0.2,0.2-0.2c0-0.5-0.4-0.8-0.7-1.1c-0.2-0.4-0.7-0.7-0.9-1.1 l-0.3,0.1c0-0.3-0.1-0.5-0.1-0.8c0-0.2,0.2-0.3,0.4-0.2c0.1-0.4,0.1-0.8,0.1-1.2c0.1-0.2,0.3-0.1,0.5-0.2c0.3,0.1,0.6-0.1,0.9-0.2 l0,0c0.1,0,0.1-0.1,0.2-0.1c0.6,0.2,0.7-0.6,1.1-0.8l0.8,0.2c0.1,0,0.2-0.1,0.2-0.2c0.1-0.2-0.2-0.4,0-0.6c0.3,0.6,0.4,1.3,0.9,1.9 c0.1,0,0.2-0.1,0.3-0.2c-0.3-0.6-0.7-1.2-0.7-1.9c0.2,0,0.3,0.2,0.4,0.2c0.1-0.1,0.2-0.3,0.3-0.2C17,5.5,18.2,6,18.9,5.7 C18.9,5.7,18.9,5.7,18.9,5.7z M12.5,6.7c-0.2,0-0.3-0.1-0.4-0.2l0.7-0.5c0.4,0,0.7,0.1,1,0.1C13.5,6.5,12.7,6.1,12.5,6.7z'/%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3C/svg%3E"

/***/ }),

/***/ 1306:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 20 20' style='enable-background:new 0 0 20 20;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23EEEEEE;%7D %3C/style%3E %3Ctitle%3Edfs_icon%3C/title%3E %3Cdesc%3ECreated with Sketch.%3C/desc%3E %3Cg id='nav_x5F_bar_x2F_expand_x2F_table-copy-2' transform='translate(0.000000, 52.000000)'%3E %3Cg id='dfs' transform='translate(123.000000, 7.000000)'%3E %3Cg id='dfs_icon' transform='translate(31.000000, 0.000000)'%3E %3Cpath id='Shape' class='st0' d='M-139.5-54h-4v-3.2c0-0.5-0.2-0.8-0.5-0.8s-0.5,0.4-0.5,0.8v3.2h-4v-3.2c0-0.5-0.2-0.8-0.5-0.8 s-0.5,0.4-0.5,0.8v3.2h-3v13.1c0,0.6,0.5,1,1.1,1h14.8c0.6,0,1.1-0.5,1.1-1V-54h-3v-3.2c0-0.5-0.2-0.8-0.5-0.8s-0.5,0.4-0.5,0.8 V-54z M-140.5-57v-0.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v0.5h1c1.1,0,2,0.9,2,2v14c0,1.1-0.9,2-2,2h-15c-1.1,0-2-0.9-2-2 v-14c0-1.1,0.9-2,2-2h1v-0.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v0.5h2v-0.5c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5v0.5 H-140.5z'/%3E %3Cpath id='star' class='st0' d='M-139.5-48.4c0-0.1-0.1-0.2-0.3-0.2h-3l-0.9-3.2c-0.1-0.2-0.4-0.2-0.5,0l-0.9,3.2h-3 c-0.1,0-0.2,0.1-0.3,0.2c0,0.1,0,0.3,0.1,0.3l2.5,1.6l-1,3.2c0,0.1,0,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0l2.5-2.1l2.5,2.1 c0,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.1,0c0.1-0.1,0.1-0.2,0.1-0.3l-1-3.2l2.5-1.6C-139.5-48.2-139.5-48.3-139.5-48.4z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1307:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Crect x='0' y='0' class='st8' width='24' height='24'/%3E %3Cpath class='st34' d='M5.2,14.1c0.2,0.1,0.4,0.3,0.6,0.4l1.7,1.6c0.4,0.3,1.3,1.2,1.6,1.7C9.3,18,9.4,18,9.6,18.3 c-0.1,0-0.9,0.2-1.3,0.4c-1,0.3-1.8,0.9-2.7,0.6c-0.1,0-0.7-0.6-1-0.8c-0.2-0.1-0.3-0.2-0.5-0.3c-0.5-0.4-0.7-0.1,0-1.7 c0.2-0.4,0.3-0.8,0.5-1.2C4.8,14.9,5,14.4,5.2,14.1L5.2,14.1z M17.3,4.6c0.3,0.1,1.2,0.6,1.4,0.9c0.2,0.2,0.1,0.2,0.1,0.6l-0.3,2.7 c-0.5,0-0.3,0-0.6-0.2c-0.5-0.3-2.2-1.6-2.7-2l-1-0.8c0.1-0.1,0,0,0.1-0.1l1.5-0.3C16.6,5,16.7,4.9,17.3,4.6L17.3,4.6z M3.5,5.2 C3.8,5,4,5.1,4.6,4.7c0.2-0.1,0.5-0.1,0.8-0.1c0.2,0,0.8,0.5,1,0.6C6.5,5.3,7.2,5.8,7.3,6l0.3,0.5c0.4,0,0.4,0,0.9,0.4l5.2,3.5 c1.1,0.8,2.4,1.6,3.6,2.4l3.2,2.1c-0.1,0.2-0.2,0.9-0.3,1.2c-0.3,1.3-0.6,1.8-1.2,3c-0.8,0-1.5,0-2.3,0c-0.3,0-0.2,0.1-0.3-0.1 c-0.5-0.5-1.3-1.5-1.8-1.9c-0.2-0.2-0.3-0.3-0.5-0.5c-1.3-1.4-0.7-1-0.9-1.3l-2.6-2.5c-0.6-0.6-1.2-1.2-1.8-1.9 c-0.2-0.2-0.2-0.3-0.4-0.5l0,0c0,0,0,0-0.1-0.1L7.5,9.4C7.4,9.3,7.4,9.3,7.3,9.2L6.6,8.4C6.5,8.3,6.4,8.1,6.2,8L5.6,7.3 C5.5,7.2,5.4,7.1,5.3,7C5,6.7,4.7,6.4,4.4,6.1C4.2,5.8,3.5,5.3,3.5,5.2L3.5,5.2z M6.6,1.3L1.2,1.4c-0.3,1.1,0,0.5,0,1.7l0,2 C1.2,5.7,1,6,1,6.7C1,7,1,7.6,1.1,7.8C1.3,8.2,1.3,8.5,1.4,9c0.1,0.5,0.2,0.4,0,0.8l-0.1,0.9l0.5,0.5l0,0.8c-0.3,0.3,0,0.1-0.5,0.5 l0.1,2.4l0.6,0.4l-0.1,2c-0.6,0.4-0.5,1-0.5,1.5l0.1,2l-0.1,1c1.4,0.3,1.1,0.2,2.6,0.2c1.4,0,1.2,0,2.5-0.2l0,0.2c0.2,0,0.4,0,0.6,0 c0.6-0.1,0.3-0.1,0.5-0.2c0.1-0.1,1.7,0.3,1.9,0.4c0.1-0.2,0.1-0.1,0.3-0.2c0.1,0.2,0.6,0.7,0.7,0.9l0.6-0.5l1,0.4l0.3-0.2 c0.1,0.1,0.2,0.3,0.4,0.3c0.3,0,0.3-0.4,1-0.5l3.7-0.1c0,0,0.1-0.1,0.1-0.1l0.2-0.2c0.2,0.1,0.3,0.3,0.7,0.3c1-0.1,0.5,0.2,1.8,0.2 c0.2,0,0.2-0.1,0.4-0.1l0.4-0.1c-0.1-0.2-0.2-0.2-0.3-0.4l2.4,0.5c0-2.8,0-6.1,0-9l-0.6,0c0-0.2,0.3-0.1,0.3-0.5c0-0.5,0-2.1,0-2.4 c0-0.2-0.5-0.7-0.6-0.8c0.1-0.4,0.2-0.4,0.4-0.7c0-0.2-0.1-0.3-0.2-0.5L23,8.3c0-0.4,0.1-2,0-2.5l-0.3-2.7l0.2-0.7l0-0.7 c-0.6-0.3-0.5-0.4-0.9-0.4c-0.4,0-0.9,0-1.2-0.1c-0.5-0.1-0.3-0.2-0.8,0.3l-0.2-0.5c-0.7-0.1-3-0.3-3.5-0.3c-0.7,0-0.6,0.1-0.8,0.8 l-1,0.1l-0.1-0.4l-0.9,0l0.1-0.1c0.2-0.2,0.1-0.1,0.3-0.4l-3.6,0C9.9,1.1,9.7,1.2,9.4,1.3C9,1.5,9.2,1.3,9,1.5 C8.8,1.6,8.8,1.6,8.5,1.6c-0.4,0-0.7,0-1.1,0c-0.2,0-0.3,0-0.5,0C6.7,1.5,6.8,1.4,6.6,1.3L6.6,1.3z'/%3E %3C/svg%3E"

/***/ }),

/***/ 1308:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dr_pepper.embedded.svg?bdd97f344860a173a5f5007f031a7cd6";

/***/ }),

/***/ 1309:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Cg%3E %3Cpath class='st26' d='M10,7C10,7.2,10,7.2,9.9,7.1L9.8,6.6c0-0.1,0-0.1,0-0.3l0.3-0.8c0.1-0.2,0.1-0.2,0.1-0.1l0.1,0.5 c0,0.1,0,0.2,0,0.4L10,7L10,7z'/%3E %3Cpath class='st26' d='M15.3,14C15.4,14.1,15.4,14.1,15.3,14l-0.4-0.3c-0.1-0.1-0.1-0.1-0.2-0.2L14.3,13c-0.1-0.1-0.1-0.1,0-0.1 l0.4,0.4c0.1,0.1,0.1,0.1,0.2,0.2L15.3,14L15.3,14z'/%3E %3Cpath class='st26' d='M14.2,13.1C14.3,13.2,14.2,13.2,14.2,13.1l-0.4-0.3c-0.1-0.1-0.1-0.1-0.2-0.2L13.3,12c-0.1-0.1-0.1-0.2,0-0.1 l0.3,0.4c0.1,0.1,0.1,0.1,0.2,0.3L14.2,13.1L14.2,13.1z'/%3E %3Cpath class='st26' d='M13.2,12.1C13.2,12.2,13.2,12.2,13.2,12.1l-0.4-0.3c-0.1-0.1-0.1-0.1-0.1-0.2l-0.2-0.6c0-0.2,0-0.2,0-0.1 l0.3,0.4c0.1,0.1,0.1,0.1,0.1,0.3L13.2,12.1L13.2,12.1z'/%3E %3Cpath class='st26' d='M12.3,11.2C12.4,11.3,12.4,11.3,12.3,11.2L12,10.8c-0.1-0.1-0.1-0.1-0.1-0.3l-0.1-0.6c0-0.2,0-0.2,0-0.1 l0.3,0.4c0.1,0.1,0.1,0.1,0.1,0.3L12.3,11.2L12.3,11.2z'/%3E %3Cpath class='st26' d='M11.6,10.2C11.6,10.4,11.6,10.4,11.6,10.2l-0.3-0.4c-0.1-0.1-0.1-0.1-0.1-0.3l0-0.7c0-0.2,0-0.2,0.1-0.1 l0.2,0.4c0,0.1,0.1,0.2,0.1,0.3L11.6,10.2L11.6,10.2z'/%3E %3Cpath class='st26' d='M11,9.2C11,9.4,11,9.4,11,9.2l-0.3-0.4c0-0.1-0.1-0.1,0-0.3l0.1-0.7c0-0.2,0-0.2,0.1-0.1L11,8.2 c0,0.1,0,0.2,0,0.3L11,9.2L11,9.2z'/%3E %3Cpath class='st26' d='M10.5,8.1C10.4,8.3,10.4,8.3,10.5,8.1l-0.3-0.4c0-0.1-0.1-0.1,0-0.3l0.2-0.7c0-0.2,0.1-0.2,0.1-0.1l0.1,0.5 c0,0.1,0,0.2,0,0.3L10.5,8.1L10.5,8.1z'/%3E %3Cpath class='st26' d='M6.5,11.9c-0.1,0.2-0.2,0.2-0.3,0.1l-0.5-0.3c-0.1-0.1-0.1-0.1,0-0.3l0.6-1c0.2-0.2,0.2-0.3,0.3-0.2l0.4,0.4 c0.1,0.1,0.1,0.2-0.1,0.4L6.5,11.9L6.5,11.9z'/%3E %3Cpath class='st26' d='M7.8,12.7c-0.1,0.2-0.1,0.2-0.2,0.1L7,12.5c-0.1-0.1-0.1-0.1,0-0.3l0.5-0.9c0.1-0.2,0.2-0.3,0.3-0.2l0.5,0.4 c0.1,0.1,0.1,0.1,0,0.4L7.8,12.7L7.8,12.7z'/%3E %3Cpath class='st26' d='M18.8,16.8C19,16.9,19,16.9,18.8,16.8L18,16.7c-0.2,0-0.2,0-0.3-0.2l-0.5-0.4C17,16,17,16,17.2,16l0.7,0.2 c0.1,0,0.2,0.1,0.4,0.2L18.8,16.8L18.8,16.8z'/%3E %3Cpath class='st26' d='M17,16.3C17.2,16.4,17.1,16.4,17,16.3l-0.8-0.1c-0.2,0-0.2-0.1-0.3-0.2l-0.4-0.5c-0.1-0.1-0.1-0.1,0-0.1 l0.7,0.2c0.1,0,0.2,0.1,0.3,0.2L17,16.3L17,16.3z'/%3E %3Cpath class='st26' d='M15.3,15.8C15.4,15.9,15.4,15.9,15.3,15.8l-0.8-0.2c-0.1,0-0.2-0.1-0.3-0.2L14,14.9c-0.1-0.1-0.1-0.2,0.1-0.1 l0.6,0.3c0.1,0.1,0.2,0.1,0.3,0.2L15.3,15.8L15.3,15.8z'/%3E %3Cpath class='st26' d='M13.7,15.3c0.1,0.1,0,0.1-0.1,0.1l-0.7-0.2c-0.1-0.1-0.2-0.1-0.2-0.2l-0.1-0.6c0-0.2,0-0.2,0.1-0.1l0.6,0.3 c0.1,0.1,0.2,0.1,0.2,0.2L13.7,15.3L13.7,15.3z'/%3E %3Cpath class='st26' d='M12.1,14.7c0,0.2,0,0.1-0.1,0.1l-0.6-0.3c-0.1-0.1-0.2-0.1-0.2-0.2l0-0.7c0-0.2,0-0.2,0.1-0.1l0.6,0.3 c0.1,0.1,0.1,0.1,0.2,0.3L12.1,14.7L12.1,14.7z'/%3E %3Cpath class='st26' d='M10.6,14c0,0.2,0,0.2-0.2,0.1l-0.6-0.3c-0.1-0.1-0.2-0.1-0.1-0.3l0.2-0.7c0-0.2,0.1-0.2,0.2-0.2l0.5,0.3 c0.1,0.1,0.1,0.1,0.1,0.3L10.6,14L10.6,14z'/%3E %3Cpath class='st26' d='M9.2,13.4c-0.1,0.2-0.1,0.2-0.2,0.1l-0.6-0.3c-0.1-0.1-0.2-0.1-0.1-0.3l0.3-0.8c0.1-0.2,0.1-0.2,0.2-0.2 l0.5,0.3c0.1,0.1,0.1,0.1,0.1,0.3L9.2,13.4L9.2,13.4z'/%3E %3Cpath class='st26' d='M4.4,15.3c-0.2,0.2-0.2,0.2-0.4,0.2l-0.8-0.2c-0.2,0-0.2,0,0-0.3l0.8-1c0.2-0.3,0.3-0.3,0.4-0.3l0.7,0.2 c0.1,0,0.1,0.1,0,0.4L4.4,15.3L4.4,15.3z'/%3E %3Cpath class='st26' d='M6.3,15.7c-0.1,0.2-0.1,0.2-0.3,0.2l-0.8-0.2c-0.2,0-0.2,0-0.1-0.3l0.6-0.9c0.1-0.2,0.2-0.3,0.4-0.2l0.7,0.2 c0.1,0,0.1,0.1,0,0.3L6.3,15.7L6.3,15.7z'/%3E %3Cpath class='st26' d='M21.2,18.1C21.4,18.2,21.3,18.2,21.2,18.1l-1,0c-0.2,0-0.2,0-0.4-0.1l-0.6-0.4c-0.2-0.1-0.1-0.1,0-0.1 l0.9,0.1c0.2,0,0.3,0.1,0.4,0.1L21.2,18.1L21.2,18.1z'/%3E %3Cpath class='st26' d='M18.9,17.8C19.1,17.9,19.1,17.9,18.9,17.8l-1,0c-0.2,0-0.2,0-0.4-0.1l-0.5-0.4c-0.1-0.1-0.1-0.1,0.1-0.1 l0.8,0.2c0.2,0,0.2,0.1,0.4,0.2L18.9,17.8L18.9,17.8z'/%3E %3Cpath class='st26' d='M16.7,17.5c0.1,0.1,0.1,0.1-0.1,0.1l-0.9-0.1c-0.2,0-0.2,0-0.3-0.2L15,16.8c-0.1-0.1-0.1-0.2,0.1-0.1l0.8,0.2 c0.2,0,0.2,0.1,0.3,0.2L16.7,17.5L16.7,17.5z'/%3E %3Cpath class='st26' d='M14.6,17.2c0.1,0.1,0,0.1-0.2,0.1l-0.9-0.1c-0.2,0-0.2,0-0.3-0.2l-0.2-0.6c0-0.1,0-0.2,0.2-0.1l0.8,0.2 c0.2,0,0.2,0.1,0.3,0.2L14.6,17.2L14.6,17.2z'/%3E %3Cpath class='st26' d='M12.4,16.9c0,0.2,0,0.1-0.2,0.1l-0.9-0.1c-0.2,0-0.2,0-0.2-0.2l0-0.7c0-0.2,0-0.2,0.2-0.2l0.8,0.2 c0.2,0,0.2,0.1,0.2,0.2L12.4,16.9L12.4,16.9z'/%3E %3Cpath class='st26' d='M10.4,16.5c0,0.2,0,0.2-0.2,0.1l-0.9-0.2c-0.2,0-0.2,0-0.2-0.2l0.2-0.7c0-0.2,0.1-0.2,0.3-0.2l0.8,0.2 c0.2,0,0.2,0.1,0.2,0.3L10.4,16.5L10.4,16.5z'/%3E %3Cpath class='st26' d='M8.3,16.1c-0.1,0.2-0.1,0.2-0.3,0.2l-0.9-0.2c-0.2,0-0.2,0-0.1-0.2L7.4,15c0.1-0.2,0.2-0.3,0.3-0.2L8.5,15 c0.2,0,0.2,0.1,0.1,0.3L8.3,16.1L8.3,16.1z'/%3E %3Cpath class='st26' d='M1.9,18.8C1.7,19.1,1.6,19,1.4,19l-1.2,0c-0.2,0-0.3,0-0.1-0.3l0.9-1.1c0.2-0.3,0.3-0.3,0.6-0.3l1,0.1 c0.2,0,0.2,0.1,0,0.3L1.9,18.8L1.9,18.8z'/%3E %3Cpath class='st26' d='M4.6,18.8c-0.1,0.2-0.2,0.2-0.4,0.2l-1.2,0c-0.2,0-0.3,0-0.1-0.2l0.7-1c0.2-0.2,0.3-0.3,0.5-0.3l1,0.1 c0.2,0,0.2,0.1,0.1,0.3L4.6,18.8L4.6,18.8z'/%3E %3Cpath class='st26' d='M23.9,19.2C24.1,19.3,24,19.3,23.9,19.2l-1.3,0.1c-0.2,0-0.3,0-0.5-0.1l-0.7-0.3c-0.2-0.1-0.2-0.1,0.1-0.1 l1.1,0.1c0.2,0,0.3,0,0.5,0.1L23.9,19.2L23.9,19.2z'/%3E %3Cpath class='st26' d='M21.1,19.2c0.2,0.1,0.1,0.1-0.1,0.1l-1.2,0c-0.2,0-0.3,0-0.4-0.1l-0.5-0.4c-0.1-0.1-0.1-0.1,0.1-0.1l1.1,0.1 c0.2,0,0.3,0,0.5,0.1L21.1,19.2L21.1,19.2z'/%3E %3Cpath class='st26' d='M18.4,19.1c0.1,0.1,0.1,0.1-0.2,0.1l-1.2,0c-0.2,0-0.3,0-0.4-0.1l-0.4-0.5c-0.1-0.1-0.1-0.2,0.2-0.1l1.1,0.1 c0.2,0,0.3,0,0.4,0.2L18.4,19.1L18.4,19.1z'/%3E %3Cpath class='st26' d='M15.6,19.1c0.1,0.1,0,0.1-0.2,0.1l-1.2,0c-0.2,0-0.3,0-0.4-0.1l-0.2-0.6c0-0.1,0-0.2,0.2-0.2l1,0.1 c0.2,0,0.3,0.1,0.4,0.2L15.6,19.1L15.6,19.1z'/%3E %3Cpath class='st26' d='M12.8,19c0,0.2,0,0.1-0.3,0.1l-1.2,0c-0.2,0-0.3,0-0.3-0.2l0-0.7c0-0.2,0.1-0.2,0.3-0.2l1,0.1 c0.2,0,0.3,0.1,0.3,0.2L12.8,19L12.8,19z'/%3E %3Cpath class='st26' d='M10.1,19c0,0.2-0.1,0.2-0.3,0.2l-1.2,0c-0.2,0-0.3,0-0.3-0.2l0.2-0.8c0.1-0.2,0.1-0.2,0.3-0.2l1,0.1 c0.2,0,0.2,0.1,0.2,0.2L10.1,19L10.1,19z'/%3E %3Cpath class='st26' d='M7.3,18.9c-0.1,0.2-0.1,0.2-0.4,0.2l-1.2,0c-0.2,0-0.3,0-0.2-0.2L6.1,18c0.1-0.2,0.2-0.3,0.4-0.3l1,0.1 c0.2,0,0.2,0.1,0.2,0.3L7.3,18.9L7.3,18.9z'/%3E %3Cpath class='st26' d='M8.3,8.8C8.2,9,8.2,9,8.1,8.9L7.8,8.5C7.8,8.4,7.8,8.4,7.9,8.1l0.5-0.9C8.5,7,8.6,7,8.6,7.1l0.2,0.5 c0,0.1,0,0.2-0.1,0.4L8.3,8.8L8.3,8.8z'/%3E %3Cpath class='st26' d='M9.1,9.8C9,10,9,10,8.9,9.9L8.6,9.5c-0.1-0.1-0.1-0.1,0-0.3L9,8.3c0.1-0.2,0.1-0.2,0.2-0.2l0.2,0.4 c0.1,0.1,0,0.2,0,0.4L9.1,9.8L9.1,9.8z'/%3E %3Cpath class='st26' d='M16.8,15.4C16.9,15.5,16.9,15.5,16.8,15.4l-0.6-0.2c-0.1-0.1-0.1-0.1-0.3-0.2l-0.5-0.5 c-0.1-0.1-0.1-0.1,0-0.1l0.5,0.3c0.1,0.1,0.2,0.1,0.3,0.2L16.8,15.4L16.8,15.4z'/%3E %3Cpath class='st26' d='M15.4,14.7C15.5,14.8,15.5,14.8,15.4,14.7l-0.6-0.2c-0.1-0.1-0.1-0.1-0.2-0.2l-0.3-0.5 c-0.1-0.1-0.1-0.2,0-0.1l0.5,0.3c0.1,0.1,0.1,0.1,0.2,0.2L15.4,14.7L15.4,14.7z'/%3E %3Cpath class='st26' d='M14.1,14C14.2,14.1,14.2,14.1,14.1,14l-0.6-0.2c-0.1-0.1-0.1-0.1-0.2-0.2L13.1,13c-0.1-0.1,0-0.2,0-0.1 l0.4,0.3c0.1,0.1,0.1,0.1,0.2,0.3L14.1,14L14.1,14z'/%3E %3Cpath class='st26' d='M12.9,13.3C13,13.4,13,13.4,12.9,13.3L12.4,13c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.6c0-0.2,0-0.2,0.1-0.1 l0.4,0.4c0.1,0.1,0.1,0.1,0.2,0.3L12.9,13.3L12.9,13.3z'/%3E %3Cpath class='st26' d='M11.8,12.5C11.8,12.6,11.8,12.6,11.8,12.5l-0.5-0.3c-0.1-0.1-0.1-0.1-0.1-0.3l0-0.7c0-0.2,0-0.2,0.1-0.1 l0.4,0.4c0.1,0.1,0.1,0.1,0.1,0.3L11.8,12.5L11.8,12.5z'/%3E %3Cpath class='st26' d='M10.8,11.6c0,0.2,0,0.2-0.1,0.1l-0.4-0.4c-0.1-0.1-0.1-0.1-0.1-0.3l0.1-0.7c0-0.2,0.1-0.2,0.1-0.1l0.3,0.4 c0.1,0.1,0.1,0.1,0.1,0.3L10.8,11.6L10.8,11.6z'/%3E %3Cpath class='st26' d='M9.9,10.7c0,0.2-0.1,0.2-0.1,0.1l-0.4-0.4c-0.1-0.1-0.1-0.1,0-0.3l0.3-0.8c0.1-0.2,0.1-0.2,0.2-0.1l0.3,0.4 c0.1,0.1,0.1,0.2,0,0.3L9.9,10.7L9.9,10.7z'/%3E %3C/g%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3C/svg%3E"

/***/ }),

/***/ 1310:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Cg%3E %3Cpath class='st6' d='M12,1.9c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S6.5,1.9,12,1.9 M12,0.9c-6.1,0-11,4.9-11,11 s4.9,11,11,11s11-4.9,11-11S18.1,0.9,12,0.9L12,0.9z'/%3E %3Cpath class='st6' d='M12,20.9c4.9,0,8.9-3.9,9-8.8L9.1,20.4C10,20.8,11,20.9,12,20.9z'/%3E %3Cpath class='st6' d='M12,2.9C12,2.9,12,2.9,12,2.9L3.5,14.9c0.3,0.9,0.8,1.8,1.4,2.5L17.4,4.7C15.9,3.6,14,2.9,12,2.9z'/%3E %3Cpath class='st19' d='M18.3,5.5L5.7,18.3c0.7,0.7,1.4,1.2,2.2,1.6l13-9.4C20.6,8.6,19.7,6.9,18.3,5.5z'/%3E %3C/g%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3C/svg%3E"

/***/ }),

/***/ 1311:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 150 150' style='enable-background:new 0 0 150 150;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:url(%23SVGID_1_);%7D .st1%7Bfill:url(%23SVGID_2_);%7D .st2%7Bfill:url(%23SVGID_3_);%7D .st3%7Bfill:url(%23SVGID_4_);%7D %3C/style%3E %3Cg id='Ebene_2'%3E %3Cg id='V'%3E %3ClinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='394.3662' y1='1044.9481' x2='394.3662' y2='1011.845' gradientTransform='matrix(1.8916 0 0 1.8916 -616.4683 -1870.546)'%3E %3Cstop offset='0' style='stop-color:%23DFE1EC'/%3E %3Cstop offset='0.6' style='stop-color:%23F6F6F9'/%3E %3Cstop offset='1' style='stop-color:%23FFFFFF'/%3E %3C/linearGradient%3E %3Cpath class='st0' d='M136.1,43.6h-13.3c-7.9,0-13.8,5.9-13.8,13.8v49h15.1V59.6c0-1.6,1.1-3.6,3.6-3.6h3.6c2.5,0,3.6,1.5,3.6,3.6 v12.9h-8V85h8v21.4H150V57.4C150,49.5,144.1,43.6,136.1,43.6L136.1,43.6z'/%3E %3ClinearGradient id='SVGID_2_' gradientUnits='userSpaceOnUse' x1='370.7072' y1='1044.9481' x2='370.7072' y2='1011.8357' gradientTransform='matrix(1.8916 0 0 1.8916 -616.4683 -1870.546)'%3E %3Cstop offset='0' style='stop-color:%23DFE1EC'/%3E %3Cstop offset='0.6' style='stop-color:%23F6F6F9'/%3E %3Cstop offset='1' style='stop-color:%23FFFFFF'/%3E %3C/linearGradient%3E %3Cpath class='st1' d='M65.5,57.5v48.9h15.3V81.3h17V68.7H80.7v-9c0-1.6,1.1-3.6,3.6-3.6H104V43.6H79.4 C71.4,43.6,65.5,49.5,65.5,57.5z'/%3E %3ClinearGradient id='SVGID_3_' gradientUnits='userSpaceOnUse' x1='353.1494' y1='1044.9388' x2='353.1494' y2='1011.8357' gradientTransform='matrix(1.8916 0 0 1.8916 -616.4683 -1870.546)'%3E %3Cstop offset='0' style='stop-color:%23DFE1EC'/%3E %3Cstop offset='0.6' style='stop-color:%23F6F6F9'/%3E %3Cstop offset='1' style='stop-color:%23FFFFFF'/%3E %3C/linearGradient%3E %3Cpath class='st2' d='M43.9,43.6h15.2v62.7H43.9V43.6z'/%3E %3ClinearGradient id='SVGID_4_' gradientUnits='userSpaceOnUse' x1='336.0903' y1='1044.9481' x2='336.0903' y2='1011.8357' gradientTransform='matrix(1.8916 0 0 1.8916 -616.4683 -1870.546)'%3E %3Cstop offset='0' style='stop-color:%23DFE1EC'/%3E %3Cstop offset='0.6' style='stop-color:%23F6F6F9'/%3E %3Cstop offset='1' style='stop-color:%23FFFFFF'/%3E %3C/linearGradient%3E %3Cpath class='st3' d='M0,57.5v48.9h15.3V81.3h17V68.7h-17v-9c0-1.6,1.1-3.6,3.6-3.6h19.7V43.6H13.9C5.9,43.6,0,49.5,0,57.5z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1312:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Cg%3E %3Cpath class='st24' d='M0,8.4C0,8.3,0.1,8.1,0.1,8c0.2-0.4,0.5-0.7,0.8-1c0.6-0.4,1.2-0.8,1.9-1c0.5-0.2,1.1-0.4,1.7-0.6 C4.7,5.3,4.8,5.3,5,5.3c0.8-0.1,1.6-0.1,2.5-0.1c0.6,0,1.2,0,1.8,0c0.4,0,0.8,0,1.2,0.2c0.8,0.3,1.2,0.9,1.4,1.8 c0.1,0.6,0,1.3-0.1,1.9c-0.2,0.9-0.6,1.8-1,2.6c-0.4,0.9-0.9,1.8-1.4,2.6c-0.8,1.4-1.6,2.7-2.6,3.9c-0.5,0.7-1.1,1.3-1.7,1.9 c-0.3,0.3-0.6,0.5-1,0.7c-0.1,0-0.2,0.1-0.3,0.2c-0.2,0.1-0.5,0.2-0.8,0.2c-0.1,0-0.3-0.1-0.4-0.2c-0.1,0-0.1-0.1-0.1-0.2 c0-0.3,0-0.5,0.1-0.8c0.1-0.6,0.2-1.3,0.3-1.9c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.4,0.4-0.6,0.8-0.7c0.3,0,0.6-0.1,0.9-0.1 c0.8-0.1,1.4-0.6,1.6-1.4c0-0.1,0-0.2,0.1-0.3c0-0.1,0-0.1-0.1-0.1c-0.5,0.1-0.9,0.2-1.4,0.3c-0.5,0.2-1,0.4-1.5,0.6 c-0.6,0.3-1.2,0.3-1.8,0c-0.3-0.1-0.3-0.3-0.4-0.6c0-0.4,0.1-0.6,0.4-0.9c0.3-0.3,0.6-0.4,1-0.5c0.5-0.2,1.1-0.3,1.6-0.4 c0.5-0.1,0.9-0.1,1.4-0.2c0.3,0,0.7-0.1,1-0.1c0.2,0,0.3,0,0.5-0.1c0.2-0.1,0.5-0.2,0.7-0.3c0.3-0.2,0.5-0.5,0.7-0.8 c0.4-0.6,0.6-1.3,0.7-2.1c0-0.4,0.1-0.7,0-1.1c0-0.2-0.1-0.3-0.2-0.4C8.9,8,8.6,7.9,8.3,7.9C7.5,7.7,6.7,7.7,5.9,7.7 c-0.5,0-1,0.1-1.5,0.1C3.8,7.9,3.3,8,2.8,8.2C2.6,8.3,2.5,8.3,2.4,8.5c-0.2,0.2-0.1,0.3,0,0.5C2.5,9,2.6,9,2.7,9.1 c0.1,0,0.1,0.1,0,0.2C2.7,9.4,2.6,9.4,2.5,9.5c-0.3,0.1-0.6,0.2-1,0.2c-0.3,0-0.7-0.1-1-0.1c-0.1,0-0.2-0.1-0.3-0.2 C0.1,9.2,0.1,9,0,8.8C0,8.7,0,8.5,0,8.4z'/%3E %3Cpath class='st24' d='M21,21.5c-0.2-0.2-0.4-0.3-0.6-0.4c-0.9-0.6-1.7-1.2-2.4-2c-1.4-1.4-2.5-3.1-3.4-4.9c-1-1.9-1.6-3.9-2.1-6 c-0.1-0.6-0.1-1.2,0-1.8c0-0.1,0.1-0.2,0.1-0.3c0.2-0.4,0.5-0.6,0.9-0.6c0.6-0.1,1.1-0.1,1.7-0.1c0.8,0,1.6,0,2.4,0 c0.7,0,1.5,0.1,2.2,0.1c0.9,0.1,1.7,0.4,2.4,0.8c0.4,0.2,0.8,0.5,1.1,0.8c0.3,0.3,0.5,0.6,0.6,1c0.1,0.5-0.1,0.9-0.6,1.1 c-0.3,0.1-0.5,0.1-0.8,0.1c-0.5,0-1,0-1.5-0.2c-0.1,0-0.2-0.1-0.3-0.1C21,9,21.2,9,21.3,8.9c0.1,0,0.1,0,0.2-0.1 c0-0.1-0.1-0.1-0.1-0.1c-0.3-0.1-0.6-0.2-0.9-0.3c-1.2-0.2-2.4-0.3-3.6-0.2c-0.4,0-0.8,0.1-1.2,0.1c-0.1,0-0.1,0-0.2,0.1 C15.2,8.5,15,8.7,15,9c0,0.3,0.1,0.6,0.2,0.9c0.4,1.1,0.8,2.2,1.2,3.3c0.4,0.9,0.9,1.8,1.6,2.5c0.5,0.5,0.9,1,1.3,1.5 c0.1,0.1,0.2,0.2,0.4,0.1c0.2-0.1,0.4-0.2,0.5-0.3c0.2-0.1,0.3-0.1,0.5,0c0.3,0.2,0.6,0.5,0.7,0.8c0.5,1,0.5,2,0.1,3 C21.4,21,21.2,21.2,21,21.5C21.1,21.5,21,21.5,21,21.5z'/%3E %3Cpath class='st25' d='M11.1,18.6c0-1.1,0-2.1,0.1-3.2c0-0.5,0-1,0-1.5c0-0.5,0-0.9,0-1.4c0-0.1,0-0.1,0.1-0.1 c0.2-0.1,0.5-0.2,0.8-0.3c0.3,0,0.5,0.1,0.6,0.4c0,0.1,0,0.2,0.1,0.3c0,0.6,0,1.3,0,1.9c0,0.6,0,1.1,0,1.7c0,0.8-0.1,1.7-0.1,2.5 c0,0.5,0,1-0.1,1.5c0,0.1,0,0.2-0.2,0.2c-0.2,0.1-0.3,0.2-0.5,0.2c-0.4,0.1-0.7-0.1-0.7-0.5c0-0.4-0.1-0.7-0.1-1.1 C11.1,19.1,11.1,18.9,11.1,18.6z'/%3E %3Cpath class='st25' d='M11.1,3.5c0-0.3,0.1-0.5,0.3-0.7c0.1-0.1,0.2-0.2,0.3-0.2c0,0,0,0,0.1,0c0.3,0,0.6,0,0.8,0.2 c0.3,0.1,0.4,0.4,0.5,0.7c0,0.3-0.1,0.7-0.3,0.9c-0.4,0.5-1.2,0.3-1.5-0.1C11.2,4.1,11.1,3.8,11.1,3.5z'/%3E %3C/g%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3C/svg%3E"

/***/ }),

/***/ 1313:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 142'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Efortnite%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M512,36.16a7.87,7.87,0,0,1-1.07.15l-22.45.29c-.87,0-1,.14-1,1,0,6.19,0,12.39-.07,18.58,0,.6.22.81.81.8l18.65-.24c.79,0,.91.09.91,1,0,6,0,11.91,0,17.86,0,2.14.07,4.28.16,6.41,0,.72-.25.94-.94.93-6-.09-12-.15-18-.24-.61,0-.9.16-.88.82.09,4.37.16,8.74.24,13.11,0,1.46.07,2.92.1,4.38,0,.92.22,1.15,1.16,1.21l12.78.69c2.82.16,5.64.31,8.47.43.53,0,.72.21.7.74-.07,2.65-.16,5.29-.18,7.94q-.08,12.46-.11,24.93c0,1.19,0,1.19-1.18,1.11q-10.2-.74-20.41-1.47c-7-.51-14-1.05-21-1.54-3.3-.22-6.62-.35-9.93-.5-.84,0-1-.18-1-1,.1-3.59.19-7.19.33-10.78.2-5.1.37-10.2.68-15.29.67-11,.07-22,.11-33,0-10.05-.17-20.11-.28-30.17q-.19-17.2-.42-34.4c0-.71-.08-1.41-.13-2.11s.18-.9.86-1c6.76-.67,13.52-1.37,20.28-2.06q5.49-.55,11-1.08c4.05-.39,8.1-.79,12.15-1.12,2.82-.23,5.64-.36,8.47-.51.89,0,1,.11,1,1q0,14.21,0,28.43c0,1.08.18,2.16.28,3.24Z'/%3E%3Cpath class='cls-1' d='M23.7,0a1.65,1.65,0,0,0,.52.16Q38.11.27,52,.34c1.9,0,3.8-.12,5.7-.2.56,0,.8.22.78.79-.09,3.76-.21,7.53-.25,11.29-.07,6.2-.09,12.39-.13,18.59a2.42,2.42,0,0,1-.05.86.89.89,0,0,1-.62.48c-2.39,0-4.77-.21-7.15-.2-5,0-10,.09-15.06.15-.88,0-1.75.1-2.63.13-.46,0-.68.21-.68.67,0,.17,0,.34,0,.51V52.87c0,1.4,0,1.4,1.44,1.38,3.53,0,7.06-.06,10.6-.14,2.69-.07,5.38-.22,8.16-.34,0,.21,0,.47,0,.72.11,7.37,0,14.73-.41,22.08-.11,2.1,0,4.22.1,6.33,0,1-.06,1.1-1.07,1.1-5.53,0-11.05,0-16.58,0H32.79c0,4.47,0,8.91,0,13.34q.15,17.13.37,34.25c0,.83.06,1.66.13,2.48.08,1-.08,1.27-1.06,1.48L19.8,138.22,2.3,141.93c-.83.18-1,0-1.09-.84,0-.44,0-.87,0-1.31q-.06-24.27-.14-48.55C1,79.77.85,68.3.73,56.83Q.6,43.75.43,30.67.31,20.24.14,9.83C.1,7,0,4.06,0,1.18c0-1,.05-1,1-1L5.56,0Z'/%3E%3Cpath class='cls-1' d='M323.29,66.34c-.4-7.29-.71-14.58-1.22-21.86-.45-6.51-1.09-13-1.68-19.52-.42-4.74-.89-9.48-1.34-14.22-.12-1.25-.26-2.5-.34-3.75a.72.72,0,0,1,.39-.54,2.79,2.79,0,0,1,.87,0l24.64.14a11.88,11.88,0,0,0,1.68-.13c.48,0,.69.12.65.61,0,.12,0,.24,0,.36V117.11c0,2.33.06,4.66.13,7,0,.67-.12,1-.89,1.06Q335,126.32,324,127.55a1,1,0,0,1-1.28-.83c-2.41-6.79-4.56-13.69-7.36-20.31-4.64-11-8.48-22.22-12.65-33.35-.26-.68-.5-1.36-.82-2L302,76.4c0,.19.05.38.06.58.2,5.65.34,11.31.6,17,.31,6.6.72,13.19,1.09,19.79.16,3,.34,5.92.49,8.88.05,1-.1,1.17-1.11,1.14-5.33-.14-10.67-.34-16-.45-3.37-.07-6.73,0-10.09,0-2.34,0-2,.21-2-2,.07-12.61.25-25.22.23-37.83,0-23-.15-46-.23-69,0-.3,0-.59,0-.88,0-.91.17-1.05,1.09-1.21,3.79-.65,7.57-1.34,11.36-2,4.78-.82,9.56-1.59,14.33-2.41.62-.1.82.22,1,.7q4.45,12.63,8.9,25.27,5.58,15.9,11.13,31.8c.09.25.2.48.3.72Z'/%3E%3Cpath class='cls-1' d='M224.84,82V40.05c0-1.2-.05-1.25-1.22-1.24L211,38.92c-.73,0-1.46.09-2.19.12-.49,0-.79-.1-.65-.73a7.68,7.68,0,0,0,.13-1.73q0-11.37-.11-22.75c0-1.65-.09-3.3-.17-4.95,0-.62.13-.83.83-.78,4.37.34,8.75.62,13.13.92s9,.62,13.49,1c5.71.45,11.42.89,17.12,1.4,6.57.6,13.14,1.27,19.71,1.9.59.06.78.23.74.9-.12,2.35-.16,4.7-.17,7.06,0,7.21-.05,14.43-.07,21.65,0,.12,0,.24,0,.36,0,1,0,1-1,1-2.56,0-5.12-.06-7.67-.1-2.32,0-4.63-.07-6.95-.13-.65,0-.86.28-.85.88,0,1.87,0,3.74,0,5.61,0,10,0,19.93,0,29.89.07,9.35.26,18.71.4,28.06q.12,7.73.23,15.45c0,.85-.14,1-.85,1-5.61,0-11.21-.14-16.82-.12-4.46,0-8.92.16-13.38.25-.86,0-.95,0-.94-1,.05-7.41.13-14.82.16-22.23,0-6.64,0-13.27,0-19.9Z'/%3E%3Cpath class='cls-1' d='M388.22,16.82c1.08-.07,2-.17,3-.2l12.71-.42c1.76-.06,3.51-.13,5.26-.17,2.56-.06,5.12-.09,7.68-.17,4-.12,8.08-.27,12.12-.39l7-.18,16.22-.46c1.67-.05,1.71-.07,1.66,1.58-.13,5.05-.35,10.1-.45,15.15-.09,4-.06,8-.06,12a5.19,5.19,0,0,0,.18,1c-4.22,0-8.43,0-12.65,0-1.46,0-2.92,0-4.39-.08-.54,0-.75.25-.73.76,0,.19,0,.39,0,.58,0,14.46,0,28.92.14,43.37.12,13.83.37,27.65.57,41.47,0,.32,0,.63,0,.95,0,.77-.19,1-1,.89-7.95-.51-15.89-.05-23.83,0-1.52,0-3,.1-4.54.15-.78,0-.89-.13-.75-.9a7.22,7.22,0,0,0,.12-1.23q-.09-39.28-.2-78.58c0-1.52-.13-3-.2-4.66h-.82l-14,.19c-.76,0-1.52,0-2.27,0s-.85-.22-.72-.91a5.48,5.48,0,0,0,.14-1.15q-.06-13-.15-26C388.37,18.57,388.28,17.75,388.22,16.82Z'/%3E%3Cpath class='cls-1' d='M386.2,71c0,4.47,0,8.94,0,13.41.05,9.84.09,19.68.17,29.52,0,4.86.15,9.72.23,14.58,0,1-.07,1.1-1.12,1.1H355.2c-1.14,0-1.18,0-1.18-1.2q.06-30,.12-60,0-12-.15-23.91c-.1-9.64-.26-19.29-.4-28.93,0-.75-.09-1.5-.16-2.25s.16-.84.82-.83q13.71,0,27.42,0c.95,0,1.9-.06,2.85-.11,1.27-.08,1.28-.08,1.28,1.16,0,2.85-.06,5.69,0,8.53q.17,24.46.37,48.91Z'/%3E%3Cpath class='cls-1' d='M210.83,126.5c-1.05-2.87-2.08-5.75-3.18-8.6q-7.22-18.53-13.18-37.48a1.37,1.37,0,0,1,.58-1.76,32.11,32.11,0,0,0,11.41-16.51,46.15,46.15,0,0,0,1.35-11A42.23,42.23,0,0,0,204.48,32a47.94,47.94,0,0,0-9.73-13.91,27.26,27.26,0,0,0-9-6.39,36.78,36.78,0,0,0-13-2.49C169,9.05,165.14,9,161.32,9c-8.12-.13-16.23-.35-24.34.25-1.1.08-1.23.19-1.24,1.31,0,2.57-.09,5.15-.13,7.72-.15,8.11-.34,16.22-.41,24.34s0,16.42,0,24.63h-.12q-.17,16-.32,32c0,4.37,0,8.74-.05,13.12,0,4-.06,8-.12,12,0,.62.26.83.84.79.19,0,.39,0,.58,0,3.88-.06,7.75-.14,11.63-.17,6,0,11.94,0,17.91-.06.64,0,.87-.23.82-.87-.08-1.16-.15-2.33-.16-3.49-.11-6-.19-12-.28-17.93l-.18-13.11c0-.55,0-1.08.77-1.15,1.16-.09,1.46,0,1.69.88q5.26,19.73,10.52,39.45c.2.75.52,1,1.26.93,2.29-.15,4.58-.22,6.86-.37,4-.25,8-.55,12-.81,3.74-.24,7.49-.45,11.23-.65C211.12,127.66,211.22,127.57,210.83,126.5Zm-35.44-68a13.2,13.2,0,0,1-2.57,5.81,9.85,9.85,0,0,1-6.39,3.31c-.63.11-.85-.16-.85-.94,0-2.79,0-5.59,0-8.38h-.23q-.15-10.81-.28-21.63c0-1.43,0-1.47,1.39-1.4A8.11,8.11,0,0,1,173.65,40a21.41,21.41,0,0,1,2,7.34A35.18,35.18,0,0,1,175.39,58.51Z'/%3E%3Cpath class='cls-1' d='M131.05,66a163,163,0,0,0-1.88-25,52.91,52.91,0,0,0-5-15.85c-3.77-7.4-9.51-12.58-17.51-15A44.91,44.91,0,0,0,85.79,9.1a28.54,28.54,0,0,0-15.63,8.09,36.07,36.07,0,0,0-7.71,11.92c-2.9,6.91-4.14,14.2-4.94,21.57a137.54,137.54,0,0,0-.75,17.81,129.32,129.32,0,0,0,1.77,25.06,54.14,54.14,0,0,0,6.38,18.64c4.19,7.23,10.21,12.17,18.44,14.19a45.74,45.74,0,0,0,22-.18,26,26,0,0,0,15.25-9.87,40,40,0,0,0,5.78-11.14,96.28,96.28,0,0,0,4.52-26.55C131.1,74.42,131.05,70.18,131.05,66Zm-32.64,26A39.34,39.34,0,0,1,97,102.43a5.93,5.93,0,0,1-.41,1,2.71,2.71,0,0,1-4.69.38,7.38,7.38,0,0,1-1.32-3.74c-.4-3.55-.81-7.1-1-10.66C88.84,76.7,89,64,89.13,51.24a91.82,91.82,0,0,1,1-14,18.46,18.46,0,0,1,.58-2.55,4.87,4.87,0,0,1,.8-1.53,2.75,2.75,0,0,1,4.67.21,9.29,9.29,0,0,1,1.37,4.11,107,107,0,0,1,1,13.51c0,6.09.18,12.19.29,18.79C98.71,76.86,98.65,84.4,98.41,91.92Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"

/***/ }),

/***/ 1314:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='premier_league' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 32 32' style='enable-background:new 0 0 32 32;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%2311498E;%7D .st1%7Bfill:%23FEFEFE;%7D .st2%7Bfill:%231DC1FF;%7D .st3%7Bfill:%23C70909;%7D .st4%7Bfill:%23CC791D;%7D .st5%7Bfill:%23F6C660;%7D .st6%7Bfill:%238F0225;%7D .st7%7Bfill:%23CC9138;%7D .st8%7Bfill:%23FFFFFF;%7D .st9%7Bfill:%230B8B38;%7D .st10%7Bfill:%230667AC;%7D .st11%7Bfill:url(%23SVGID_1_);%7D .st12%7Bfill:url(%23SVGID_2_);%7D .st13%7Bfill:none;%7D .st14%7Bfill:%2302457C;%7D .st15%7Bfill:url(%23SVGID_3_);%7D .st16%7Bfill:%23261C6E;%7D .st17%7Bfill:%23941482;%7D .st18%7Bfill:%23F49302;%7D .st19%7Bfill:%23006739;%7D .st20%7Bfill:%230167B4;%7D .st21%7Bfill:%23C5C5C5;%7D .st22%7Bfill:%23D80201;%7D %3C/style%3E %3Cg%3E %3Ccircle class='st8' cx='16' cy='16' r='13.7'/%3E %3Cpolygon class='st10' points='16,11.4 11.2,14.9 13,20.6 19,20.6 20.8,14.9 '/%3E %3Cg%3E %3ClinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='0.7224' y1='16' x2='31.2776' y2='16'%3E %3Cstop offset='0' style='stop-color:%23FFBE00'/%3E %3Cstop offset='0.4548' style='stop-color:%23FF8300'/%3E %3Cstop offset='1' style='stop-color:%23FFB100'/%3E %3C/linearGradient%3E %3Cpath class='st11' d='M16,31.3C7.6,31.3,0.7,24.4,0.7,16S7.6,0.7,16,0.7S31.3,7.6,31.3,16S24.4,31.3,16,31.3z M16,2.4 C8.5,2.4,2.4,8.5,2.4,16S8.5,29.6,16,29.6S29.6,23.5,29.6,16S23.5,2.4,16,2.4z'/%3E %3C/g%3E %3Cg%3E %3ClinearGradient id='SVGID_2_' gradientUnits='userSpaceOnUse' x1='0' y1='16' x2='32' y2='16'%3E %3Cstop offset='0' style='stop-color:%230065B9'/%3E %3Cstop offset='4.310726e-02' style='stop-color:%23005DB3'/%3E %3Cstop offset='0.185' style='stop-color:%230048A2'/%3E %3Cstop offset='0.3237' style='stop-color:%23003B98'/%3E %3Cstop offset='0.4548' style='stop-color:%23003795'/%3E %3Cstop offset='0.6245' style='stop-color:%23003B98'/%3E %3Cstop offset='0.7866' style='stop-color:%230046A1'/%3E %3Cstop offset='0.9451' style='stop-color:%230059AF'/%3E %3Cstop offset='1' style='stop-color:%230062B6'/%3E %3C/linearGradient%3E %3Cpath class='st12' d='M16,32C7.2,32,0,24.8,0,16S7.2,0,16,0s16,7.2,16,16S24.8,32,16,32z M16,0.8C7.6,0.8,0.8,7.6,0.8,16 S7.6,31.2,16,31.2S31.2,24.4,31.2,16S24.4,0.8,16,0.8z'/%3E %3C/g%3E %3Cpath class='st13' d='M23.2,13.7L25,8l2,0c-1.7-2.3-4-4.1-6.8-5l0.6,1.9L16,8.5l-4.8-3.5L11.8,3C9,3.9,6.7,5.7,5,8l2,0l1.8,5.7 L4,17.2L2.4,16c0,0,0,0,0,0c0,3,1,5.7,2.6,8l0.6-1.9l6,0l1.8,5.7L11.8,29c1.3,0.4,2.7,0.7,4.2,0.7c1.5,0,2.9-0.2,4.2-0.7l-1.6-1.2 l1.9-5.7l6,0L27,24c1.6-2.2,2.6-5,2.6-8L28,17.2L23.2,13.7z'/%3E %3Cpath class='st14' d='M16,8.5l4.8-3.5L20.2,3c-1.3-0.4-2.7-0.7-4.2-0.7c-1.5,0-2.9,0.2-4.2,0.7l-0.6,1.9L16,8.5z'/%3E %3Cpath class='st14' d='M8.8,13.7L7,8L5,8c-1.6,2.3-2.6,5-2.6,8L4,17.2L8.8,13.7z'/%3E %3Cpath class='st14' d='M11.6,22.1l-6,0L5,24c1.7,2.3,4,4.1,6.8,5l1.6-1.2L11.6,22.1z'/%3E %3Cpath class='st14' d='M20.4,22.1l-1.9,5.7l1.6,1.2c2.8-0.9,5.1-2.7,6.8-5l-0.6-1.9L20.4,22.1z'/%3E %3Cpath class='st14' d='M27,8l-2,0l-1.9,5.7l4.8,3.5l1.6-1.2c0,0,0,0,0,0C29.6,13,28.7,10.3,27,8z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1315:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 184'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Eleague of legends%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M435.15,154.4c2.91,2.2,5.78,4.46,8.75,6.56a44.13,44.13,0,0,0,35.58,7.57,21.14,21.14,0,0,0,16-12.88c2.12-4.89,1.44-9.3-2.48-12.81a47,47,0,0,0-9.43-6.82c-7.6-4-15.49-7.4-23.17-11.24a66,66,0,0,1-9.74-5.82c-15.33-11.28-14.53-31,1.9-40.63a43.75,43.75,0,0,1,15-5.3c10.65-1.65,21.34-.78,31.89,1.62,2.75.62,3.82,2,3.71,4.9-.21,5.55-.06,11.12-.06,17.29-1.14-.75-1.77-1.09-2.31-1.54-11.15-9.24-23.77-10.54-37.15-6.49a14.91,14.91,0,0,0-6.78,5c-3.08,3.93-2.77,8.06.92,11.42a51.62,51.62,0,0,0,10.85,7.65c7.53,3.87,15.39,7.09,23,10.77a62.23,62.23,0,0,1,9.85,5.63,24.9,24.9,0,0,1,5.07,35.85c-8.79,11.37-20.94,16.43-34.87,17.22-9.85.56-19.57-1-29.11-3.57a4.31,4.31,0,0,1-3.6-3.73c-1.38-6.75-3-13.46-4.5-20.19Z'/%3E%3Cpath class='cls-1' d='M199.49,88.8v15.81c-2.24-.65-3.93-1.12-5.59-1.63-8.29-2.56-16.7-3.94-25.41-2.86-19,2.37-29.31,20-22.15,37.89,5.89,14.7,20.25,22.46,37.59,20.29,2.64-.33,5.27-.78,8.4-1.24,0-4.17-.42-8.32.1-12.35.84-6.62-.86-12-6-16.31a6.92,6.92,0,0,1-1-1.31c-.05-.07,0-.21,0-.58H208v4c0,10.72-.08,21.45.09,32.17,0,3.13-.86,4.57-4.11,5.06-14.17,2.12-28.28,3.68-42.53.33-20.36-4.79-32.73-18.86-33.45-38.48-.65-17.95,11.4-34.11,30.24-40C171.85,85.38,185.71,86.13,199.49,88.8Z'/%3E%3Cpath class='cls-1' d='M295.91,110.05v56.5H274.47a22.29,22.29,0,0,1,3.35-3c4.06-2.24,4.88-5.62,4.82-10-.24-17.2-.21-34.41,0-51.61,0-4-.63-7.25-4.09-9.56a15.57,15.57,0,0,1-2-2.24c3.53,0,6.37.33,9.09-.06,7.31-1.06,12.52,1.77,17.46,7.14,10.42,11.34,21.45,22.12,32.22,33.14a6.46,6.46,0,0,1,.79,1.47l1.06-.43v-3.76c0-11.4.06-22.8-.05-34.19,0-2.46.65-3.34,3.2-3.25,5.3.19,10.6.06,16.49.06-.71.85-.91,1.27-1.24,1.44-5.11,2.66-5.74,7-5.67,12.35.26,20,.08,40,.06,60v3.51l-.82.28Z'/%3E%3Cpath class='cls-1' d='M0,183.61c3-3.62,5.83-6.77,8.3-10.18a9.45,9.45,0,0,0,1.8-5.14q.24-40.53.11-81.08c0-2.33-1.33-4.81-2.52-6.95s-2.91-3.82-4.78-6.2H27v93.63H65.59l.45.81c-4.35,5-8.68,10-13.1,15a3.28,3.28,0,0,1-2.18.52q-24.6,0-49.2,0A10.45,10.45,0,0,1,0,183.61Z'/%3E%3Cpath class='cls-1' d='M123.86,105.41c-3.18-4-7.24-4.1-11.51-4-6.56.16-13.13,0-20,0v16.82h19c0,4,.13,7.5-.12,11,0,.59-1.67,1.51-2.59,1.54-5.34.14-10.69.07-16.31.07v24.16c1.52,0,2.93,0,4.35,0,8.92,0,17.85.11,26.77,0a7.62,7.62,0,0,1,6.42,2.77c2.23,2.56,4.67,4.94,7.5,7.89H69.19a83.32,83.32,0,0,0,6-6.38,8.55,8.55,0,0,0,1.93-4.67q.25-26.8.09-53.61a11,11,0,0,0-1.82-5.13,69.84,69.84,0,0,0-4.63-6.21h53.15Z'/%3E%3Cpath class='cls-1' d='M308.11,6.42V20.13c-5.31-1.17-10.23-2.68-15.26-3.25a47,47,0,0,0-13.61.22c-14.62,2.71-22.4,16-18.16,30.3C265,60.69,277.78,69,292.39,67.83c10-.82,10-.82,10-10.77,0-8.66,0-8.66-6.4-17h19.76v3.83c0,9.49.05,19-.09,28.48,0,1.09-1,3-1.74,3.12-13.36,2.27-26.78,3.89-40.17.44C253.07,70.58,241.57,52.07,247,32.66,251.32,17.4,262.31,9.24,277.23,6,287.49,3.82,297.83,4.34,308.11,6.42Z'/%3E%3Cpath class='cls-1' d='M214.35,89.71h53.09v15.9c-.3.06-.47.13-.5.09-3.29-4.77-8.18-4.41-13.11-4.27-5.89.16-11.79,0-18,0v16.86c5.32,0,10.53.14,15.73,0,2.64-.1,3.6.7,3.4,3.38-.22,2.88,0,5.78,0,9.07H235.9v24.35h34.64l.69.88c-2.17,3.13-4.28,6.3-6.55,9.35-.35.47-1.4.58-2.14.58q-24.26,0-48.51,0a4.76,4.76,0,0,1-1.08-.41,71.94,71.94,0,0,0,5.68-6,9.26,9.26,0,0,0,2.1-5q.26-26.79.07-53.58a10.26,10.26,0,0,0-1.74-4.83C217.82,94,216.2,92.18,214.35,89.71Z'/%3E%3Cpath class='cls-1' d='M335.39,7.79v3.64c0,13.84,0,27.69,0,41.53,0,7.44,2.79,11,10,13a21.61,21.61,0,0,0,13.49-.37c5.62-2,8-5.35,8-11.37.05-14.18,0-28.36,0-42.54v-4h16.47c0,.24,0,.68-.16.8-4.62,3.22-4.92,7.85-4.84,13q.33,21.26,0,42.53c-.05,3.82.9,6.76,3.95,9,1.06.77,2.26,1.35,3.4,2l-1,1.24H366.36c-.18-1.31-.36-2.57-.61-4.31-7.39,5.89-15.66,6.71-24.26,5.47-10.24-1.47-17-8.55-17.44-18.89-.52-12.37-.49-24.77-.62-37.16-.08-7.7,0-7.7-5.05-13.6Z'/%3E%3Cpath class='cls-1' d='M123.07,7.54h48.79V24.43a20.74,20.74,0,0,1-2.86-2.7c-2.5-3.63-6-4.62-10.19-4.52-5.55.13-11.11,0-16.9,0v16h17v11H142.12v21.5h33.95c-1.33,3.66-2.37,6.77-3.65,9.77-.23.55-1.45,1-2.22,1q-22.42.08-44.84,0a3.59,3.59,0,0,1-1-.34c.14-.37.16-.79.37-.92,5-3.26,5.16-8.15,5.05-13.51q-.41-20.76,0-41.53c.06-4.15-.87-7.4-4.18-9.93A25.34,25.34,0,0,1,123.07,7.54Z'/%3E%3Cpath class='cls-1' d='M391.57,76.19c.06-.32,0-.48.1-.53,5.49-3.89,5.48-9.53,5.37-15.5-.24-13.29-.21-26.58,0-39.87.06-4.09-.64-7.45-4.05-10a21.8,21.8,0,0,1-2.43-2.57h48.59V24.18a11.41,11.41,0,0,1-2-1.68c-3.15-4.55-7.53-5.6-12.8-5.21-5,.38-10,.08-15.18.08V33.19h17.1V44.35c-4.77,0-9.43.08-14.07,0-2.13-.06-3,.53-2.93,2.8.13,6.11,0,12.23,0,18.76h35.91c-3.13,3.79-5.59,6.89-8.21,9.85a3.59,3.59,0,0,1-2.44.76q-21.09.08-42.17,0C392.16,76.52,392,76.36,391.57,76.19Z'/%3E%3Cpath class='cls-1' d='M69.92,0c6.91,0,12.92-.08,18.92.1.66,0,1.8,1.47,1.84,2.3.19,4.23.09,8.48.09,12.73V62.06c0,1.11,0,2.21,0,3.79h32.77l.24.88c-4.29,4-7.19,9.33-15,8.81-11.67-.78-23.43-.19-35.14-.2-1.08,0-2.15-.09-3.69-.16a8.53,8.53,0,0,1,1.31-1.85c4.24-3,5-7.14,4.89-12q-.37-24.79-.11-49.6c0-3.9-.79-7-3.95-9.32A22.07,22.07,0,0,1,69.92,0Z'/%3E%3Cpath class='cls-1' d='M464,44.53h-5.14c-.09.33-.19.66-.28,1,.89.3,1.81.52,2.66.9a27.58,27.58,0,0,1,2.46,1.43,24.74,24.74,0,0,1-2.58,1.39,8.91,8.91,0,0,1-2.11.25c-.15,1.92-.29,3.75-.44,5.73H454.7V41.52C458.69,39.6,463.26,40.71,464,44.53Z'/%3E%3Cpath class='cls-1' d='M398.45,89.51c-11.37-.1-22.75,0-34.13,0-.94,0-1.88.12-3,.19,5.89,8,5.91,8,5.91,18.29q0,19.08-.1,38.18c0,7-.38,13.86-6.21,19.61,11.91,0,23.05.06,34.2,0a35.65,35.65,0,0,0,8.95-.86c15.5-4.18,24.53-15,28.71-29.88C439.4,111.44,422.79,89.72,398.45,89.51Zm21.21,42.85c-.83,9.43-5.93,16.1-14.73,19.87-7.56,3.24-15.5,3.54-23.72,3.63v-55.5c8.61-.32,16.93-.44,24.81,3.09,6.62,3,11.23,7.86,12.67,15A49.41,49.41,0,0,1,419.66,132.36Z'/%3E%3Cpath class='cls-1' d='M250.92,73.79c-3.14-2.55-4.89-5.92-6.38-9.61-7.21-17.91-14.63-35.74-21.85-53.65-1-2.47-2.32-3.42-5-3.32-5,.2-10,0-15.06.08-1,0-2,.14-3.85.28a26.26,26.26,0,0,0,2.91,2.64c3.23,2,2.87,4.4,1.51,7.61-7.84,18.49-15.45,37.09-23.13,55.66-.33.79-.54,1.64-1,3,3.54,0,6.54-.12,9.53,0,2,.1,3-.65,3.66-2.53,2.56-6.78,5.39-13.47,7.92-20.27.85-2.29,2.13-3,4.48-2.93,5.68.13,11.38.15,17.06,0,2.45-.08,3.58.89,4.43,3.06,2.66,6.75,5.45,13.45,8.32,20.11.42,1,1.5,2.36,2.32,2.4,5.28.21,10.58.11,16.57.11A28,28,0,0,0,250.92,73.79Zm-45.18-33.3c2.43-6,4.72-11.61,7.37-18.12,2.46,6.45,4.61,12.06,6.92,18.12Z'/%3E%3Cpath class='cls-1' d='M445.72,40.56c-5.13,0-8.3,2.6-8.46,7-.16,4.8,2.8,8.17,7.24,8.25,4.84.09,8-2.81,8.07-7.41S449.72,40.58,445.72,40.56Zm-.9,11.35c-2.44,0-3.65-1.5-3.72-3.79-.07-2.49,1.31-4.36,3.76-4,1.53.24,2.82,2,4.21,3.1C448.31,50.32,447.28,51.88,444.82,51.91Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"

/***/ }),

/***/ 1316:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Cpath class='st29' d='M21,13c0,2.1-0.7,4-1.9,5.5h1.2c1-1.6,1.7-3.5,1.7-5.5c0-5.5-4.5-10-10-10v1C17,4,21,8,21,13z'/%3E %3Cpath class='st30' d='M20,13c0-4.4-3.6-8-8-8v13.5h5.8C19.2,17.1,20,15.1,20,13z'/%3E %3Cpath class='st29' d='M5,18.6c-1.2-1.5-2-3.5-2-5.6c0-2.1,0.8-4.1,2-5.6V5.9c-1.7,1.7-2.8,4-3,6.6c0,0.2,0,0.4,0,0.5 c0,0.3,0,0.6,0,0.9c0.2,2.4,1.3,4.6,3,6.3V18.6z'/%3E %3Cpath class='st29' d='M21.5,19.5H11v-18C11,1.2,10.8,1,10.5,1H5C4.8,1,4.6,1.1,4.6,1.3c-0.1,0.2-0.1,0.4,0,0.5L6,3.7v16.7l-1.9,1.9 c-0.1,0.2-0.1,0.4,0,0.5C4.1,22.9,4.3,23,4.5,23H19c0.2,0,0.3-0.1,0.4-0.2l2.5-2.5C22,20.2,22,20,22,19.8 C21.9,19.6,21.7,19.5,21.5,19.5z'/%3E %3Cpath class='st30' d='M5,9.1c-0.6,1.1-1,2.5-1,3.9s0.4,2.7,1,3.9V9.1z'/%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3C/svg%3E"

/***/ }),

/***/ 1317:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Cg%3E %3Cpolygon class='st20' points='1.9,2.7 1.9,22 21.9,22 21.9,2.3 11.9,5.4 '/%3E %3Cpath class='st21' d='M0.9,1v6.3V23h22v-6.2V1l-11,3.1L0.9,1z M3,20.2V8.8l8.9-2.5l0,0l0.6-0.2l8.3-2.4v11.5L3,20.2z M8.3,20.9 l12.5-3.5v3.5H8.3z M3,6.7V3.8l5.1,1.5L3,6.7z'/%3E %3Cpath class='st1' d='M4.2,10.4l2.5-0.7l0.6,5.4L8,9.4l2.5-0.7v7.4L9,16.5v-6l-0.8,6.2l-1.8,0.5l-0.8-5.8v6l-1.4,0.4V10.4z'/%3E %3Cpath class='st1' d='M11.5,8.4l3.3-0.9l1,0.7v5.5l-1,1.2l-3.3,0.9V8.4z M13.8,13.8l0.2-0.3V9.3l-0.2-0.2l-0.6,0.2V14L13.8,13.8z'/%3E %3Cpath class='st1' d='M16.7,7l1.7-0.5v5.9l1.5-0.4v1.5l-3.2,0.9V7z'/%3E %3Cpolygon class='st22' points='1.9,2.7 1.9,22 21.9,22 21.9,2.3 11.9,5.4 '/%3E %3Cpath class='st23' d='M0.9,1v6.3V23h22v-6.2V1l-11,3.1L0.9,1z M3,20.2V8.8l8.9-2.5l0,0l0.6-0.2l8.3-2.4v11.5L3,20.2z M8.3,20.9 l12.5-3.5v3.5H8.3z M3,6.7V3.8l5.1,1.5L3,6.7z'/%3E %3Cpath class='st1' d='M4.2,10.4l2.5-0.7l0.6,5.4L8,9.4l2.5-0.7v7.4L9,16.5v-6l-0.8,6.2l-1.8,0.5l-0.8-5.8v6l-1.4,0.4V10.4z'/%3E %3Cpath class='st1' d='M11.5,8.4l3.3-0.9l1,0.7v5.5l-1,1.2l-3.3,0.9V8.4z M13.8,13.8l0.2-0.3V9.3l-0.2-0.2l-0.6,0.2V14L13.8,13.8z'/%3E %3Cpath class='st1' d='M16.7,7l1.7-0.5v5.9l1.5-0.4v1.5l-3.2,0.9V7z'/%3E %3C/g%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3C/svg%3E"

/***/ }),

/***/ 1318:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Crect x='0' y='0' class='st8' width='24' height='24'/%3E %3Cg%3E %3Cpath class='st35' d='M12,22.8c-0.3,0-0.6,0-0.9-0.1c-0.3,0-0.6-0.1-1-0.1c0-2.4,0-4.8,0-7.2c4.1,0,8.2,0,12.2,0 c-0.1,0.2-0.1,0.4-0.2,0.5c-1.4,3.3-3.8,5.4-7.3,6.4c-0.9,0.3-1.8,0.4-2.7,0.4c0,0-0.1,0-0.1,0C12,22.8,12,22.8,12,22.8z'/%3E %3Cpath class='st35' d='M1,11.4c0-0.2,0-0.4,0-0.5c0.1-1.6,0.6-3.1,1.4-4.5c0.6-1.1,1.4-2,2.4-2.9c0,0,0,0,0.1-0.1c0,3.3,0,6.6,0,9.9 c-1.3,0-2.5,0-3.8,0c0-0.2,0-0.5-0.1-0.7c0-0.1,0-0.2,0-0.3C1,12,1,11.7,1,11.4z'/%3E %3Cpath class='st35' d='M22.9,13.3c-4.3,0-8.5,0-12.8,0c0-4.1,0-8.2,0-12.4c3.5-0.5,6.6,0.3,9.2,2.7C22.5,6.4,23.3,10.2,22.9,13.3z' /%3E %3Cpath class='st35' d='M1.7,15.5c1.1,0,2.2,0,3.2,0c0,1.6,0,3.1,0,4.7C3.4,18.9,2.3,17.4,1.7,15.5z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1319:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='layer1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 198.3 104.6' style='enable-background:new 0 0 198.3 104.6;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D .st1%7Bfill:%23FA012D;%7D .st2%7Bfill:%23092668;%7D %3C/style%3E %3Cg%3E %3Cpath id='path2475' class='st0' d='M29,1c-6.6,0-11.8,5.3-11.8,11.8v77.9c0,6.6,5.3,11.8,11.8,11.8h137.6L195.1,91L187,1.1L29,1z' /%3E %3Cpath id='rect2470' class='st1' d='M185.5,1c6.6,0,11.8,5.3,11.8,11.8v77.9c0,6.6-5.3,11.8-11.8,11.8h-21.6l0.3-8.7 c12.1,0.6,20.1-0.9,24.6-5.8c0-2.1,1.6-5.6-1.6-11.6c-1.8-3.3-3.9-7.2-11-12.1c-0.4-5.4-3.3-8-5.4-10.6c-2.3-2.9-4-5.4-6.4-6.6 L136.2,1.1L185.5,1z'/%3E %3Cpath id='path2473' class='st2' d='M13.8,1C7.3,1,2,6.3,2,12.8v77.9c0,6.6,5.3,11.8,11.8,11.8h69.7c-0.8-2.7-2.9-8.4-4.8-8.4 c-1.5-0.1-7.4,0.6-8.4-0.5c4.4-32.5,10.1-30.1,15.8-34.3c1-0.8-0.7-1.7,0-2.7c0.9-1.2-0.9-2.4-0.3-3.6c1-1.8-6.9,0.3-6.3-1.5 c1.2-3.5,2.7-5.8,3.5-8.8c0.7-2.5-0.1-1.3-0.1-2.5c0-1.7-12.7,0.9-12.3-0.7c0.7-2.9,11.1-5.9,10.9-8.8C81,17.8,91.9,11,99.6,11.2 c13.6-0.2,17.4,1.3,22.4,10.2c3.2,6.5,7.1,17.2,0.2,20.2c0.4,3.2,1.2,5.9,2.9,7c2.4-0.1,3.4,0.1,5.4,0.1c14.4,0,21.1,1.1,24.6,3.5 l0.9-6L121.5,1.1L13.8,1z'/%3E %3Cpath id='path2529' class='st0' d='M33.5,78.3c0,4.3-3.5,7.8-7.8,7.8c-4.3,0-7.8-3.5-7.8-7.8c0,0,0,0,0,0c0-4.3,3.5-7.8,7.8-7.8 C30,70.5,33.5,74,33.5,78.3C33.5,78.3,33.5,78.3,33.5,78.3z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1320:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 53.6 43.9' style='enable-background:new 0 0 53.6 43.9;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23231F20;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%230057A1;%7D .st3%7Bfill:%2393A0A4;%7D .st4%7Bfill:%231E8255;%7D %3C/style%3E %3Cpath class='st0' d='M6,0C2.6,0-0.1,2.8-0.1,6.1v31.7c0,3.4,2.8,6.1,6.1,6.1h41.5c3.4,0,6.1-2.8,6.1-6.1V6.1c0-3.4-2.8-6.1-6.1-6.1 H6'/%3E %3Cpath class='st1' d='M6,41.9c-2.2,0-4-1.8-4-4V6.1c0-2.2,1.8-4,4-4h41.5c2.2,0,4,1.8,4,4v31.7c0,2.2-1.8,4-4,4H6'/%3E %3Cpath class='st2' d='M48.8,7.8c0-1.2-1-2.2-2.2-2.2l-26.2,0l0.1,0.4c0.3,0,0.6,0.1,0.9,0.2c0.4,0.2,0.9,0.7,1.2,1.3 c0.2,0.4,0.2,0.9,0.2,1.4c0.2,0.1,0.4,0.3,0.6,0.7c0.2,0.5,0.4,0.9,0.6,1.4c0.2,0.5,0.5,1.1,0.6,1.5c0,0.1,0.1,0.2,0.2,0.3 c0.8-1.5,1.9-2.8,3.2-3.8c0.4-0.3,1-0.1,1-0.1s-0.1-0.5,0.3-0.8c1.3-0.8,2.7-1.3,4.2-1.6C34.1,6.5,34.6,7,34.6,7s0.3-0.5,0.9-0.6 c1.3,0,2.6,0.2,3.9,0.7c0.9,0.3,1.6,0.7,2.4,1.2c0.5,0.5,0.4,1,0.4,1s0.7-0.2,1.1,0.1c1.3,1.1,2.3,2.5,2.9,4.1 c0.2,0.7-0.2,1.1-0.2,1.1s0.6,0.2,0.8,0.8c0.5,1.9,0.5,3.9,0,5.9c-0.2,0.7-0.7,0.8-0.7,0.8s0.3,0.4,0.1,1c-0.7,1.6-1.6,2.9-2.7,4 c-0.5,0.4-1.1,0.3-1.1,0.3s0,0.6-0.4,1c-0.6,0.4-1.2,0.7-1.8,1l6.3,0c1.2,0,2.2-1,2.2-2.2L48.8,7.8z'/%3E %3Cpath class='st0' d='M46.9,15.4c-0.2-0.5-0.8-0.8-0.8-0.8s0.3-0.4,0.2-1.1c-0.7-1.5-1.7-2.9-2.9-4.1c-0.4-0.3-1.1-0.1-1.1-0.1 s0.1-0.5-0.4-1c-0.7-0.5-1.5-0.9-2.4-1.2c-1.3-0.5-2.6-0.7-3.9-0.7c-0.6,0-0.9,0.6-0.9,0.6s-0.4-0.5-1.2-0.4 c-1.5,0.3-2.9,0.8-4.2,1.6C28.7,8.5,28.8,9,28.8,9s-0.5-0.2-1,0.1c-1.3,1-2.4,2.3-3.2,3.8c0.3,0.5,0.8,1.5,1.5,2.5 c0.6-0.4,1.2-0.9,1.9-1c0.9,0.5,2.4,1.2,2.9,1.6c-0.4,2.3-0.1,4.3,0,5.1c-0.1,0.1-0.2,0.2-0.4,0.3c0.3,0.3,0.5,0.5,0.8,0.8 c0.1-0.1,0.2-0.1,0.3-0.2c1.7,0.9,4,1.3,4.7,1.4c0,0,0.8,1.9,0.7,3.1c-0.9,1.7-3,2.4-3,2.4c-0.8-0.1-1.6-0.3-2.4-0.6 c-0.5,0.4-1.1,0.7-1.9,0.8c0,0-0.2,0-0.5,0c0,0,0.1,0,0.1,0.1c0.6,0.3,1.2,0.6,1.8,0.8c0.9,0.3,1.7,0.5,2.6,0.6 c0.7,0.1,0.9-0.5,0.9-0.5s0.3,0.5,1,0.5c2.3-0.1,4.6-0.9,6.4-2.2c0.5-0.4,0.4-1,0.4-1s0.6,0.1,1.1-0.3c1.1-1.1,2.1-2.5,2.7-4 c0.2-0.5-0.1-1-0.1-1s0.5-0.2,0.7-0.8C47.4,19.3,47.4,17.3,46.9,15.4z'/%3E %3Cpath class='st2' d='M28.2,11.1l0.3-1.1c-1.6,0.9-2.7,3-3.2,4.1c0,0,0,0.1,0.1,0.1C26.9,11.8,28.2,11.1,28.2,11.1z'/%3E %3Cpath class='st3' d='M30.9,21c-0.1-0.7-0.3-2.8,0-5.1c0,0-0.5,0-0.9,0.3c-0.4,2.1,0,4.5,0,4.5c0,0,0,0,0,0c0.2,0.2,0.4,0.4,0.6,0.6 C30.7,21.2,30.8,21.1,30.9,21z'/%3E %3Cpath class='st3' d='M36.3,23.3l-0.5,0.7c0,0-2-0.3-3.6-1c0.8,0.9,1.8,2.3,0.4,4.3c-0.2,0.3-0.5,0.6-0.9,0.8 c0.8,0.3,1.6,0.5,2.4,0.6c0,0,2.1-0.7,3-2.4C37,25.2,36.3,23.3,36.3,23.3z'/%3E %3Cpath class='st1' d='M43.6,18l-3.4-0.2c-1-2.2-2.3-3.6-2.8-4l0.8-2.6c0.6-0.3,2.1-0.6,3.9-0.6c1.2,1.1,2.2,2.4,2.8,3.9 C44.8,14.4,44.5,16.9,43.6,18'/%3E %3Cpath class='st1' d='M28.7,13.4c0,0,0.4-1.8,1-3.8C31,8.7,32.5,8.2,34.2,8c1.5,0.9,2.5,2.1,2.9,2.8l-0.8,2.6c-2.2,0.3-4,1.2-4.6,1.6 C31.6,15,30,14,28.7,13.4'/%3E %3Cpath class='st1' d='M38.1,26c0,0-0.3-1.7-0.8-3.1c1.4-1.3,2.8-4,2.8-4l3.4,0.2c0.9,1.2,1.1,3.2,1.1,3.2c-0.5,1.5-1.5,2.9-2.9,4 C41.9,26.3,40,26.8,38.1,26'/%3E %3Cpath class='st3' d='M36.2,13.5l0.8-2.6c0,0-0.4-0.2-0.7,0c-0.1,0.4-0.6,2-0.6,2c-2.2,0.1-4.3,1.4-4.3,1.4c-1.1-0.7-2.1-1.1-2.1-1.1 l-0.7,0.3c1.3,0.6,3,1.7,3,1.7C32.3,14.7,34,13.8,36.2,13.5'/%3E %3Cpath class='st3' d='M41.9,26.3c1.3-1.1,2.3-2.5,2.9-4c0,0-0.2-2.1-1.1-3.2c0,0-0.2,0.6-0.4,0.8c0,0-1.5-0.1-2.5-0.1 c-0.4,0.9-1.7,2.8-2.5,3.5c0,0,0.4,1.1,0.6,2.5L38.1,26C40,26.8,41.9,26.3,41.9,26.3'/%3E %3Cpath class='st3' d='M40.2,17.7l3.4,0.2c0.9-1.1,1.2-3.6,1.2-3.6c-0.6-1.5-1.5-2.9-2.8-3.9L41.9,11c1.6,1.6,2.1,3.2,2.1,3.2 c-0.3,1.8-0.8,2.9-0.8,2.9c-1.1,0-2.6-0.1-2.6-0.1L40.2,17.7'/%3E %3Cpath class='st2' d='M32.1,20.5c0,0-0.2-1.9,0.1-4.3c0,0,1.8-1.2,4.2-1.2C36.4,15,32.8,15.8,32.1,20.5'/%3E %3Cpath class='st2' d='M36.3,8.5l-0.8-0.7c0,0,2.9-0.2,5.8,1.9C41.3,9.7,38.1,8.2,36.3,8.5'/%3E %3Cpath class='st4' d='M33.6,21.4c0,0,1.6,0.7,2.8,0.8c0,0,1.6-1.5,2.5-3.8C38.9,18.4,37.3,22.1,33.6,21.4'/%3E %3Cpath class='st4' d='M45.5,20.7l-0.3-1.3c0,0,0.7-1.6,0.3-4.1C45.5,15.2,46.5,17.9,45.5,20.7'/%3E %3Cpath class='st4' d='M39.8,27.6c-0.9,0.7-2.4,1.1-3.6,1.2c-0.4,0.4-1,0.7-1,0.7c3.4,0.1,5.8-1.7,5.8-1.7S40.5,27.7,39.8,27.6'/%3E %3Cpolyline class='st0' points='49.2,8.4 50.4,8.4 50.4,7.9 50.6,7.9 50.6,9.1 50.4,9.1 50.4,8.7 49.2,8.7 49.2,8.4 '/%3E %3Cpolyline class='st0' points='49.2,9.5 50.6,9.5 50.6,9.9 49.6,10.2 50.6,10.5 50.6,10.9 49.2,10.9 49.2,10.6 50.3,10.6 49.2,10.3 49.2,10 50.3,9.8 49.2,9.8 49.2,9.5 '/%3E %3Cpath class='st2' d='M8.5,5.7l-1.4,0C5.9,5.7,5,6.6,5,7.8l0,2.7C5.7,7.9,7.8,6.2,8.5,5.7'/%3E %3Cpath class='st4' d='M24.9,28.5c-0.9-0.2-1.7-0.6-2.4-1c0,0.1,0,0.1,0,0.1C22.5,27.9,22,28,21.5,28c-0.3,0-0.7-0.1-0.8-0.4 c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0.1-1.1,0.2-1.4c-1.4-1.5-2.3-3.2-2.7-3.6c-0.9-0.9-1.9-2.2-7.6-4c-1-0.3-1.8-0.6-2.5-1 c0,0.1,0,0.1,0,0.1c0,0.3-0.6,0.4-1.1,0.4c-0.3,0-0.7-0.1-0.8-0.4c-0.1-0.1-0.1-0.2-0.1-0.3c0,0,0.1-0.6,0.1-1 C5.5,15.8,5.1,15.4,5,15l0,12.2c0,1.2,1,2.2,2.2,2.2l17.7,0C24.9,29.2,24.9,28.8,24.9,28.5'/%3E %3Cpath class='st3' d='M31.3,23.3L31.3,23.3c-0.8-0.9-2.6-2.9-2.9-3.1L28.3,20c0,0-0.5-0.6-0.5-0.6c0,0-0.3-0.5-0.3-0.4 c0,0-0.5-0.7-0.5-0.7c0,0-0.2-0.2-0.1-0.2l-0.1-0.1c-1.1-1.7-2.8-4.4-3-5c-0.2-0.4-0.4-0.9-0.6-1.5c-0.2-0.5-0.4-1-0.6-1.4 c-0.1-0.4-0.4-0.6-0.6-0.7c0-0.4,0-0.9-0.2-1.4c-0.3-0.6-0.6-0.9-1-1.1c-0.6-0.2-1.2,0-1.4,0.1c-0.3,0.1-1.1,0.3-3.2,0.6 c-3.3,0.4-4.5,0.2-5-1.8l-2.6,0C6.4,6.8,5.4,9.1,5,10.6L5,15c0.3,0.4,0.6,0.8,1.1,1.2l-0.1,1c0,0-0.1,0.4,0.9,0.6 c0.7,0.1,1-0.2,1.1-0.5c0.2,0.1,0.4,0.2,0.7,0.3c3.3,1.3,5.8,1.8,8,3.4c1.2,0.9,2.9,3.5,4.2,5c0,0,0,0.1,0,0.1l-0.1,1.3 c0,0-0.1,0.4,0.9,0.6c0.4,0.1,1,0,1.2-0.5c0.9,0.5,1.7,0.9,2.2,1.1l0,0.8h3.5c1.5,0,2.9-1,3.5-1.7C33.3,25.6,32,24.1,31.3,23.3'/%3E %3Cpath class='st0' d='M18,21.3c-0.7-0.6-2.7-2.1-5.3-2.7c0,0,3.7,0.3,4.1,0.6C17.7,19.8,18,21.3,18,21.3'/%3E %3Cpath class='st0' d='M27.5,26.3l-0.1,1.1c0,0,0.5-0.3,1.1,0.1c0,0,0.2-1.3,0.5-1.2c0,0-0.4-0.4-0.9-0.3C27.9,26,27.6,26.1,27.5,26.3 '/%3E %3Cpath class='st0' d='M23.7,23.8l-0.1,1.1c0,0,0.5-0.3,1.1,0.1c0,0,0.2-1.3,0.5-1.2c0,0-0.4-0.4-0.9-0.3C24,23.4,23.7,23.5,23.7,23.8 '/%3E %3Cpath class='st0' d='M8.3,14.3l-0.1,1.1c0,0,0.5-0.3,1.1,0.1c0,0,0.2-1.3,0.5-1.2c0,0-0.4-0.4-0.9-0.3C8.6,14,8.3,14.1,8.3,14.3'/%3E %3Cpath class='st0' d='M30.6,23.7c-0.8-0.9-2.8-3-2.8-3c-0.1-0.2-0.4-0.5-0.6-0.8c-0.1-0.2-0.2-0.3-0.3-0.5l-0.5-0.7 c-0.1-0.1-0.1-0.2-0.2-0.2c-1.3-2-2.9-4.6-3.2-5.3c-0.3-0.8-0.8-1.9-1.2-2.9c-0.2-0.6-0.7-0.3-0.6-0.6c0-0.5,0.1-1-0.1-1.4 c-0.4-0.9-0.8-0.8-1.4-0.5c-0.6,0.3-2.1,0.5-3.4,0.6c-1.3,0.2-4,0.4-4.8-0.5c-0.5-0.5-0.8-1.5-0.9-2.1L9,5.7 c-2.6,2.7-2.3,4.4-2.3,4.4s3.3-0.1,5.8,2.5c0,0-4.8-2.8-7.5-0.9v1.9c0.4-0.6,1.2-1.4,4-0.3c3.3,1.3,10.4,4.9,12.7,6.5 c2,1.5,5.4,3.5,6.3,4.1c0.8,0.6,3.7,2.2,3,3.7c0.1-0.1,0.1-0.2,0.2-0.3C32.3,25.6,31.4,24.6,30.6,23.7'/%3E %3Cpath class='st0' d='M6.4,16L6.3,17c0,0,0.5-0.3,1.1,0.1c0,0,0.2-1.3,0.5-1.2c0,0-0.4-0.3-0.9-0.3C6.8,15.7,6.5,15.7,6.4,16'/%3E %3Cpath class='st0' d='M21.1,26.2L21,27.2c0,0,0.5-0.3,1.1,0.1c0,0,0.2-1.3,0.5-1.2c0,0-0.4-0.4-0.9-0.3 C21.4,25.9,21.2,25.9,21.1,26.2'/%3E %3Cpath class='st0' d='M26.3,29.4c0.1-0.4,0.2-1,0.4-1c0,0-0.4-0.3-0.9-0.3c-0.2,0-0.5,0.1-0.5,0.3l-0.1,1H26.3'/%3E %3Cpath class='st2' d='M13.6,13.3c0,0,5.3,3,7.2,4.3c1.9,1.3,5.3,3.8,6.1,4c0.8,0.2-3.2-3.1-4.5-4.2c-1.9-1.6-4.3-2.9-6.1-3.8 C14.6,12.6,11.1,11.7,13.6,13.3'/%3E %3Cpolyline class='st0' points='4.9,31.1 12.1,31.1 13.8,35.2 13.8,35.2 15.4,31.1 22.6,31.1 22.6,38.7 18.2,38.7 18.2,32.7 18.2,32.7 15.7,38.7 11.6,38.7 9.1,32.7 9.1,32.7 9.1,38.7 4.9,38.7 4.9,31.1 '/%3E %3Cpolyline class='st0' points='24.9,31.1 29.8,31.1 29.8,36.5 35.8,36.4 35.8,38.7 24.9,38.7 24.9,31.1 '/%3E %3Cpath class='st0' d='M44.2,33.7c-0.8-0.1-1.9-0.2-1.9-0.4c0,0,0,0,0-0.1c0.3-0.3,1.4-0.3,1.9-0.3c1.3,0,2.6,0.1,3.7,0.4l0.2,0l0-2.3 l-0.1,0c-1.4-0.2-2.9-0.3-4.2-0.3c-3.2,0-5.3,0.4-6.2,1.4c-0.4,0.4-0.5,0.8-0.5,1.3c0,2,2.8,2.3,4.8,2.6c0.8,0.1,1.9,0.2,1.9,0.5 l0,0.1c-0.2,0.2-0.8,0.3-2,0.3c-1.5,0-3.1-0.2-4.3-0.5l-0.2-0.1v2.3l0.1,0c1.8,0.3,3.4,0.4,5.3,0.4c1.6,0,4.6-0.2,5.8-1.4 c0.4-0.4,0.6-0.8,0.6-1.3C49,34.3,46.2,34,44.2,33.7'/%3E %3C/svg%3E"

/***/ }),

/***/ 1321:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "mma_icon.embedded.svg?ffa03e73df594283545673ae9f14e66d";

/***/ }),

/***/ 1322:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 120.8 272.2' style='enable-background:new 0 0 120.8 272.2;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23FFFFFF;%7D .st1%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D53F52;%7D .st2%7Bfill:%23046DB2;%7D %3C/style%3E %3Cpath class='st0' d='M112.8,8.3c-5.1-5.1-12.2-8.3-20-8.3H29.2c-7.8,0-14.9,3.2-20,8.3C4.2,13.4,1,20.4,1,28.2V244 c0,7.8,3.2,14.9,8.2,19.9c5.1,5.1,12.2,8.3,20,8.3h63.6c7.8,0,14.9-3.2,20-8.2c5.1-5,8.3-12.2,8.3-20V28.2 C121.1,20.4,117.9,13.4,112.8,8.3z'/%3E %3Cpath class='st1' d='M77.1,49.9l0.1,0.9c1.9,1.1,2.9,2.1,4.9,3.3c5.2,3.3,11.5,9.1,10.7,29.2c1.5,4.4,2.1,12.9,3.5,15.7 c2.7,5.4,4.5,8.9,5.3,13.9c0,0,0.8,7.9,1.8,8.5c5.3,1.2,3.8,1.8,4.6,2.7c0.8,1.1,3.9,1,3.9,3.9c1.1,1.4,1.9,2.9,2.5,4.5V28.2 c0-11.9-9.6-21.6-21.5-21.6H72.3c3.3,1.2,5.2,2.6,6.3,4.8c2.6,0.2,5.7,6.1,0.9,15c2.1,1.5,0.5,3.7-1.1,6.2c-0.5,0.8-1,2.2-2.4,2.1 c-1.9,4-4.2,7.8-5.9,8c-0.5,0.6-0.8,2.3-0.1,3.1C72.5,47,75.5,48.5,77.1,49.9z'/%3E %3Cpath class='st1' d='M96.3,265.3l-0.2,0c9.4-5.7,3.6-16.6,1.8-23l0.4-1.1c0.5-0.9-0.5-2.9-0.5-2.9c-1.2-1-1.4-6.3-2.1-8.8 c-1-4,1.8-11,1.8-13.3c0-2.4-1.8-5.6-5-9.7c-0.8-0.9-3.2-21.1-5.3-26.3c-2.9-7.1-3.8-5.9-7.3-14.4c-2.7-5.9-0.6-14.6-6.6-34.9 l1.4-1.3c0,0-4.8-17.6-6.4-22.5c-1.5-4.8-4.4-5.1-4.4-5.1l0.2-2.5c0.2-0.7,5.9-15.4,6.4-15.9c0-0.3,8.2-5.9,8.3-5 c0.7,3.6,3.8,21.9,5.2,24.8c1.4,2.9,6.1,11.9,8.2,17.5c-8.4,2.1-14.6,9.6-14.6,18.6c0,10.6,8.6,19.3,19.2,19.3 c8.1,0,15.1-5,17.9-12.1l0,97.5C114.4,254.8,106.6,263.7,96.3,265.3z'/%3E %3Cg%3E %3Cpath class='st2' d='M53.1,227.4c0-2.2-0.4-3.5-2.3-3.5h-0.3h-2.1v7.3h2.1C52.9,231.1,53.1,229.4,53.1,227.4z'/%3E %3Cpath class='st2' d='M90.2,239.9c-3.5-3.1-1.1-4.4-1.3-5.7c-2.3-9.4-9.8-15.1-5.9-18.2c-1-3.2-2.9-7-2.8-7 c-3.1-1.8-6.1-3.9-8.9-6.1c-7.5-5.8-13.2-12-14.4-13.2c-2-2.2-5.5-4.5-6.2-6.3c0,0-0.1-0.1-0.1-0.1c-3.1-3.1-16.5-22.1-19.6-29.2 l-2.2-0.3l-3.4-0.5c-2.5-10.3-11-19-11.2-29.4c-0.1-4,1.8-12.4,2.5-14.1c0.7-1.7,3.9-4.5,3.9-4.5v-2.8c-12.2,0.4-8.6-0.9-10.8-5.6 c-1.4-3.3-0.4-4,0.1-6.3c1.6-6.7,7.1-17.1,9.3-21.8c0.7-2.4,3-8.1,3-8.1c2.5-5.1,4.6-8.7,6.5-11.3c5-6.7,8.9-6.1,16.7-6.9L46,42 c1.8-0.1,3.3-0.2,4.6-0.3c5.7-0.7,4.7-2.8,6-11.4c-1.6,0.7-2-3.3-2-3.3c-0.8-5.9,1.6-4.8,2.8-4.9c0.3-9.7,1.2-12.8,8.2-15.5h-15 H29.2c-0.2,0-0.3,0-0.5,0C17,6.9,7.6,16.4,7.6,28.2V244c0,11.7,9.4,21.3,21.1,21.5c0.2,0,0.3,0,0.5,0h21.4h20.7h21.6 C85.6,261.6,89.9,254.2,90.2,239.9z M38.3,250.7H31l-2.3-8.3l-2.9-10.5l-0.1-1.1h-0.1v20h-6.4v-32.3h7.3l2.3,8l2.9,9.7l0.2,1.3h0.1 v-19h6.4V250.7z M51.6,250.7h-1.1h-9.7v-32.3h9.7h0.8c5.4,0,8,2.1,8,7.6c0,3.4-0.5,6.4-4.1,7.6v0c3.6,0.7,4.9,3.4,4.9,7.4 C60.2,246.5,58.2,250.7,51.6,250.7z M74.5,250.7l-0.7-7.1h-2.5h-2.7l-0.8,7.1h-7.4l5.9-32.3h5h4.9l6.1,32.3H74.5z'/%3E %3Cpath class='st2' d='M50.9,236.4h-0.3h-2.1v8.8h2.1h0.1c2.5,0,2.8-1.2,2.8-4.4C53.4,238.6,53.2,236.4,50.9,236.4z'/%3E %3Cpolygon class='st2' points='71.3,223.3 71.3,223.3 71.2,223.3 71.2,224 69.3,238.5 71.3,238.5 73,238.5 71.3,224 '/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1323:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 22' style='enable-background:new 0 0 24 22;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23007AC2;%7D .st1%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23FFFFFF;%7D .st2%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23ED174C;%7D %3C/style%3E %3Cpolygon class='st0' points='21.2,4.7 16.5,22 1.4,22 6.1,4.7 21.2,4.7 21.2,4.7 '/%3E %3Cpath class='st1' d='M18.6,14.6c2.6-1,4.1-2.3,4.3-3.7c0.3-2.7-3.9-4.9-9.4-5.1C8,5.6,3.3,7.7,3,10.3c0.8-2.2,4.9-3.9,9.5-3.7 c5.1,0.1,8.9,2.3,8.6,4.8c-0.1,0.9-1.3,2.1-2.4,2.7L18.6,14.6L18.6,14.6L18.6,14.6z'/%3E %3Cpath class='st2' d='M12.6,6.1c5.1,0.1,8.9,2.3,8.6,4.8c-0.2,1.9-2.8,3.5-6.3,4.1c4.4-0.4,7.8-2.2,8.1-4.5c0.3-2.7-3.9-4.9-9.4-5.1 C8.1,5.2,3.2,7.3,2.8,10C3.6,7.7,7.9,5.9,12.6,6.1L12.6,6.1L12.6,6.1z'/%3E %3Cpath class='st1' d='M2.2,19.2L6.1,4.7l6.2,0l0.4,0c0,0,0.2,0.2,0.3,0.2c1.3,0.5,2.5,1.6,3.4,2.9c0,0,0.1,0,0.1,0l0.3,0.6 c0,0,0,0.1,0.1,0.1c0.9,1.6,1.4,3.4,1.3,5.3c0,0,0,0.2,0,0.2c0,0.1-0.2,1.3-0.2,1.3s0-0.5,0-0.3c-0.3,1.6-1,3-2.1,4.3l-3.2,0 L2.2,19.2L2.2,19.2L2.2,19.2z'/%3E %3Cpath class='st2' d='M12.5,19.2c0.6-0.6,1.1-1.3,1.6-2.1c1.3-2.2,1.8-4.5,1.5-6.9l-0.1-0.7l0.4,0.6c0,0,0.1,0.1,0.1,0.1 c0.1,0.2,0.3,0.4,0.4,0.6l0,0l0,0c0,0.5,0.1,1.1,0.2,1.6c0.1,0.8,0.3,1.6,0.2,2.4c0,0-0.1,0.8-0.2,1.4c-0.2,0.7-0.4,1.8-1.1,2.8 L12.5,19.2L12.5,19.2L12.5,19.2z'/%3E %3Cpath class='st2' d='M2.2,19.2l1.4-5.4c0.3,0,1.1,0,1.3,0c0.1,0,0.2,0,0.3,0c2.8-0.1,4.2-0.6,4.9-0.9c1.8-0.9,2.4-2.4,2.5-3 c0.2-0.7,0.3-1.5,0.2-2.1l-0.1-0.4l0.4,0.2c0.6,0.3,1,0.7,1.5,1c0.1,0.1,0.1,0.2,0.1,0.3c0,0,0,0,0,0c0,0,0,0,0,0l0,0l0,0 c0.2,0.8,0.2,2.4,0.2,2.4l0-0.2c0,1.7-0.5,3.6-1.4,5.2c-0.6,1.1-1.3,2-2.1,2.8L2.2,19.2L2.2,19.2L2.2,19.2z'/%3E %3Cpath class='st2' d='M5.7,6.2c0.4-0.1,0.6-0.1,0.9-0.1C8.3,6,9.9,6.2,11.5,6.9l0.1,0l0,0.1c0.2,0.7,0.2,1.4,0,2 c-0.3,1.3-1.1,2.2-2.2,2.7c-1.3,0.6-2.8,0.7-4.2,0.8c-0.3,0-0.9,0-1.2,0.1L5.7,6.2L5.7,6.2L5.7,6.2z'/%3E %3Cpath class='st2' d='M16.9,10.5c0-0.4,0-1.3-0.2-2.2L17.1,9c0.6,1.2,1,2.9,1,3.7c0,0.6,0,1.3,0,1.3C17.9,12.8,17.4,11.3,16.9,10.5 L16.9,10.5L16.9,10.5L16.9,10.5L16.9,10.5z'/%3E %3Cpath class='st2' d='M15.2,8.3c-0.4-1.2-1.3-2.7-2.5-3.6l1,0.5c1.2,0.7,2,1.5,2.7,2.5l0,0l0,0c0.1,0.4,0.1,0.9,0.1,1.5l0,0.5 l-0.3-0.4C15.8,8.9,15.5,8.6,15.2,8.3L15.2,8.3L15.2,8.3L15.2,8.3L15.2,8.3z'/%3E %3Cpath class='st2' d='M5.8,5.7c1.6-0.2,3.4-0.2,5,0.3l0.6,0.2L11,5.6c-0.3-0.4-0.6-0.7-1-0.9l-4,0L5.8,5.7L5.8,5.7L5.8,5.7z'/%3E %3Cpath class='st2' d='M12.3,4.7c0.1,0.1,0.2,0.1,0.2,0.2l0,0c0.6,0.5,1.2,1.3,1.6,2.2l0.3,0.6l-0.6-0.4C13.4,7,13,6.8,12.5,6.6 l-0.1,0l0-0.1c-0.3-0.6-0.9-1.3-1.8-1.8L12.3,4.7L12.3,4.7L12.3,4.7z'/%3E %3Cpath class='st2' d='M15.8,19.2c0.3-0.5,0.6-1.2,0.6-1.2c0.5-1.2,0.8-2.8,0.8-4.1v0c0-0.1,0-0.2,0-0.4c0-0.3-0.1-0.6-0.1-0.8 c0-0.3-0.1-0.7-0.1-1.2c0.4,0.6,0.5,1.1,0.5,1.1c0.3,1.1,0.6,2.2,0.2,3.3l0,0c-0.2,0.7-0.7,1.7-1,2.1C16.5,18.4,16.1,18.9,15.8,19.2 L15.8,19.2L15.8,19.2L15.8,19.2z'/%3E %3Cpath class='st1' d='M4.7,9.8c-2.2,0.8-3.7,2.1-3.9,3.5c-0.3,2.7,3.9,4.9,9.4,5.1c5.5,0.1,10.3-2.1,10.7-4.7 c-0.8,2.2-5.1,4.1-9.7,3.9c-5.1-0.1-8.9-2.3-8.6-4.8c0.1-1,0.8-1.9,2-2.6L4.7,9.8L4.7,9.8L4.7,9.8z'/%3E %3Cpath class='st0' d='M4.8,9.2c-2.2,0.8-3.8,2.2-4,3.7c-0.3,2.7,3.9,4.9,9.4,5.1c5.5,0.1,10.3-2.1,10.7-4.7c-0.8,2.2-5.1,4.1-9.7,3.9 c-5.1-0.1-8.9-2.3-8.6-4.8c0.1-1,0.9-1.9,2.1-2.6L4.8,9.2L4.8,9.2L4.8,9.2z'/%3E %3Cpath class='st1' d='M2.6,20H2.5l0.1-0.3h0.8c0.2,0,0.4,0.1,0.3,0.4c-0.1,0.2-0.2,0.4-0.4,0.4l0,0c0.2,0,0.3,0.2,0.2,0.4 c-0.1,0.3-0.4,0.5-0.6,0.5H2.1l0.1-0.3h0.1L2.6,20L2.6,20L2.6,20L2.6,20z M3,20.4c0.1,0,0.2-0.1,0.3-0.2C3.3,20,3.3,20,3.1,20H3 l-0.1,0.4H3L3,20.4L3,20.4L3,20.4z M2.8,21.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.2,0-0.2-0.2-0.2H2.8l-0.1,0.5H2.8L2.8,21.2z'/%3E %3Cpath class='st1' d='M4.5,20.9H4.1l-0.1,0.2h0.2L4,21.4H3.4l0.1-0.3h0.1l0.9-1.4h0.5l0,1.4H5L5,21.4H4.3l0.1-0.3h0.2L4.5,20.9 L4.5,20.9L4.5,20.9L4.5,20.9z M4.6,20.1L4.6,20.1l-0.3,0.6h0.3L4.6,20.1L4.6,20.1z'/%3E %3Cpath class='st1' d='M6.4,19.7h0.3l-0.2,0.5H6.2c0-0.1,0-0.3-0.1-0.3C6,20,5.9,20,5.9,20.1c0,0.1,0,0.1,0.3,0.3 c0.2,0.1,0.3,0.2,0.2,0.5c-0.1,0.4-0.4,0.5-0.7,0.5c-0.1,0-0.3,0-0.3-0.2h0l0,0.1H5.1l0.2-0.6h0.3c0,0.1,0,0.2,0,0.2 c0,0.1,0.1,0.1,0.2,0.1C5.9,21.2,6,21.1,6,21c0-0.1,0-0.2-0.3-0.3c-0.2-0.1-0.3-0.2-0.3-0.4c0.1-0.4,0.3-0.5,0.6-0.5 c0.1,0,0.3,0,0.3,0.2h0L6.4,19.7L6.4,19.7z'/%3E %3Cpolygon class='st1' points='7.7,20 7.6,20 7.7,19.7 8.3,19.7 8.2,20 8.1,20 7.5,20.5 7.8,21.1 7.9,21.1 7.8,21.4 7.2,21.4 7.2,21.1 7.4,21.1 7.1,20.6 7.1,20.6 7,21.1 7.1,21.1 7,21.4 6.4,21.4 6.4,21.1 6.6,21.1 6.9,20 6.8,20 6.9,19.7 7.5,19.7 7.4,20 7.3,20 7.1,20.5 7.7,20 '/%3E %3Cpolygon class='st1' points='8.9,20.3 9.1,20.3 9,20.9 8.7,20.9 8.8,20.7 8.6,20.7 8.5,21.1 9,21.1 9,20.9 9.4,20.9 9.2,21.4 7.9,21.4 8,21.1 8.1,21.1 8.4,20 8.3,20 8.4,19.7 9.7,19.7 9.5,20.3 9.2,20.3 9.3,20 8.8,20 8.7,20.4 8.8,20.4 8.9,20.3 '/%3E %3Cpolygon class='st1' points='10.8,20 10.6,20 10.3,21.1 10.4,21.1 10.3,21.4 9.6,21.4 9.7,21.1 9.9,21.1 10.2,20 10,20 9.9,20.3 9.6,20.3 9.8,19.7 11.2,19.7 11,20.3 10.7,20.3 10.8,20 '/%3E %3Cpath class='st1' d='M11.3,20h-0.1l0.1-0.3H12c0.2,0,0.4,0.1,0.3,0.4c-0.1,0.2-0.2,0.4-0.4,0.4l0,0c0.2,0,0.3,0.2,0.2,0.4 c-0.1,0.3-0.4,0.5-0.6,0.5h-0.8l0.1-0.3H11L11.3,20L11.3,20L11.3,20L11.3,20z M11.7,20.4c0.1,0,0.2-0.1,0.3-0.2 c0.1-0.2,0-0.2-0.2-0.2h-0.1l-0.1,0.4H11.7L11.7,20.4L11.7,20.4L11.7,20.4z M11.5,21.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.2,0-0.2-0.2-0.2 h-0.2l-0.1,0.5H11.5L11.5,21.2z'/%3E %3Cpath class='st1' d='M13.2,20.9h-0.5l-0.1,0.2h0.2l-0.1,0.3h-0.6l0.1-0.3h0.1l0.9-1.4h0.5l0,1.4h0.1l-0.1,0.3H13l0.1-0.3h0.2 L13.2,20.9L13.2,20.9L13.2,20.9L13.2,20.9z M13.2,20.1L13.2,20.1l-0.3,0.6h0.3L13.2,20.1L13.2,20.1z'/%3E %3Cpolygon class='st1' points='14.8,20.8 15.1,20.8 14.9,21.4 13.7,21.4 13.8,21.1 13.9,21.1 14.3,20 14.1,20 14.2,19.7 15,19.7 14.9,20 14.7,20 14.3,21.1 14.7,21.1 14.8,20.8 '/%3E %3Cpolygon class='st1' points='16.1,20.8 16.4,20.8 16.2,21.4 15,21.4 15.1,21.1 15.2,21.1 15.6,20 15.4,20 15.5,19.7 16.3,19.7 16.2,20 16,20 15.7,21.1 16,21.1 16.1,20.8 '/%3E %3Cpath class='st0' d='M17.8,21.3h-0.3V22h-0.1v-0.7H17v-0.1L17.8,21.3L17.8,21.3L17.8,21.3L17.8,21.3L17.8,21.3z M18.4,21.9 c0.1-0.1,0.1-0.2,0.2-0.3l0.2-0.3h0.2V22h-0.1v-0.3c0-0.1,0-0.2,0-0.4h0c-0.1,0.1-0.1,0.2-0.2,0.4L18.5,22h-0.1l-0.2-0.3 c-0.1-0.1-0.1-0.2-0.2-0.4h0c0,0.1,0,0.2,0,0.4V22h-0.1v-0.8h0.2l0.2,0.3C18.3,21.7,18.3,21.8,18.4,21.9L18.4,21.9L18.4,21.9 L18.4,21.9z'/%3E %3Cpath class='st0' d='M21.6,3.8c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3c0,0.2-0.1,0.3-0.3,0.3C21.7,4.1,21.6,4,21.6,3.8 L21.6,3.8L21.6,3.8L21.6,3.8z M21.9,4.2c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4 C21.5,4,21.7,4.2,21.9,4.2L21.9,4.2L21.9,4.2L21.9,4.2z M21.8,3.9L21.8,3.9L22,4h0.1L22,3.8c0.1,0,0.1,0,0.1-0.1 c0-0.1-0.1-0.1-0.2-0.1h-0.2V4h0.1V3.9L21.8,3.9L21.8,3.9L21.8,3.9z M21.8,3.8V3.7h0.1c0,0,0.1,0,0.1,0.1C22,3.8,22,3.8,21.8,3.8 L21.8,3.8L21.8,3.8L21.8,3.8z'/%3E %3Cpath class='st0' d='M15.4,2.6l0.9-1.3l0,1.3H15.4L15.4,2.6L15.4,2.6L15.4,2.6z M19,2.6l0.9-1.3l0,1.3H19L19,2.6L19,2.6L19,2.6z M21.3,4.2L21,0h-2.3l-0.3,1c0,0,0.4,0,0.4,0l-1.1,1.8L17.5,0h-2.3l-0.3,1l0.4,0l-1.5,2.3l-1.3,0c-0.1,0-0.6-0.1-0.6-0.8 C11.8,1.9,12.4,1,13,1l0.3,0c0,0.2-0.1,0.5-0.1,0.5h1.1L14.7,0l-1.8,0c-0.8,0-1.9,0.8-2.1,1.6L11.2,0L9.7,0L9.4,1l0.4,0L9.4,2.4 L8.4,0H6.9L6.7,1h0.4L6.2,4.2h1.1c0,0,0.4-1.6,0.6-2c0.2,0.4,0.8,2,0.8,2l1.3,0l0.6-2.1c-0.1,0.3-0.1,0.6,0,0.9 c0.1,0.7,0.8,1.1,1.5,1.1l2.3,0l0.4-0.6h1.6l0,0.6h1.4l0.4-0.6h1.7L20,4.2L21.3,4.2L21.3,4.2L21.3,4.2z'/%3E %3C/svg%3E"

/***/ }),

/***/ 1324:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 22' style='enable-background:new 0 0 24 22;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%2331487A;%7D .st1%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E95140;%7D .st2%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23FFFFFF;%7D %3C/style%3E %3Cpath class='st0' d='M0,2.8C1.6,3.9,24,6,24,6C6.3,14.7,1.9,18.8,1.9,18.8c0.5-2.1,0.6-4.1,0.7-5.8c1.1,0.5,3.1,0.8,6.2,0.5l0,0 l1.2-1.5l-7.5-1.4l0,0C1.9,5.6,0,2.8,0,2.8L0,2.8L0,2.8L0,2.8L0,2.8z'/%3E %3Cpath class='st1' d='M1.2,3.2C1.9,4.4,3,6.9,3.3,10.9l-0.9-0.2l0,0C1.9,5.6,0,2.8,0,2.8l0,0l0,0l0,0C0.2,3,0.6,3.1,1.2,3.2L1.2,3.2 L1.2,3.2L1.2,3.2z M3.4,13.3c0,1.4-0.1,2.9-0.3,4.5c-0.9,0.6-1.2,0.9-1.2,0.9c0.5-2.1,0.6-4.1,0.7-5.8C2.8,13.1,3.1,13.2,3.4,13.3 L3.4,13.3z'/%3E %3Cpath class='st1' d='M3.3,7.3c0,0,5.4-6.1,12.5-1.8c0,0,2.5,1.6,0.5,3.8c0,0-5.4,6.8-12.9,2.9c0,0-1.3-1.2-1.3-1.8 c0-0.6-0.1-1.4,0.5-2C3.1,8,3.3,7.3,3.3,7.3L3.3,7.3L3.3,7.3L3.3,7.3z'/%3E %3Cpath class='st0' d='M3.8,12.5c0,0-3.1-1.3-2.4-2.9c0,0,1.4-4.5,8.1-6c0,0,5.4-0.7,7.9,3.3c0,0-0.9,5.9-9.1,7.1c0,0-5.4,0.6-7.2-1.9 c0,0,2.2,2.2,8.3,1.2c0,0,5.3-1,7.3-5.4c0,0,0.3-0.8-0.7-1.6c0,0-4.9-5.1-11.9,0.6c0,0,3.7-1.7,6.3-2l0,0l0.8,0.6l0,0 c0,0,3.4,0.2,5.1,1.5c0,0-3.3-1.4-5.1-0.7l0,0l-1,0.8l0,0c0,0-4.3-0.4-6.4,0.9c-0.7,0.3-1.8,1.1-1.7,2.2c0,0.1,0,0.1,0,0.2 C2.3,10.9,2.7,11.6,3.8,12.5L3.8,12.5L3.8,12.5L3.8,12.5z'/%3E %3Cpath class='st2' d='M5,7.1c0,0,1.8-1.2,4.9-1.6l0,0l0.8,0.4l-0.6,0.6l0,0C10.1,6.4,6.6,6.5,5,7.1L5,7.1L5,7.1L5,7.1z'/%3E %3Cpath class='st0' d='M15.7,6.8c0,0,1,0.5,0.5,1.1c0,0-0.3,0.5-0.9,1c0,0,0.9-0.6,1.3-1.3c0,0,0-0.2,0.2,0c0,0,0.1-0.8-0.3-1 c0,0,0.4,0.8-0.1,0.6C16.4,7.1,16,6.9,15.7,6.8L15.7,6.8L15.7,6.8L15.7,6.8z'/%3E %3Cpath class='st2' d='M13.2,10.7L13.2,10.7L13.2,10.7L13.2,10.7L13.2,10.7L13.2,10.7c0.1-0.1,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.1 c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.1-0.1,0.1c-0.1,0-0.1,0-0.2,0l0,0v-0.1l0,0c0,0,0.1,0,0.1,0c0,0,0.1-0.1,0.1-0.1 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1C13.3,10.7,13.2,10.7,13.2,10.7L13.2,10.7L13.2,10.7L13.2,10.7L13.2,10.7 L13.2,10.7z M13.2,11C13.2,11,13.2,11,13.2,11L13.2,11l0.1,0.1h0.1l0-0.1l0,0C13.3,11,13.3,11,13.2,11C13.2,11,13.2,11,13.2,11 c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0-0.1,0v0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 C13.3,10.9,13.3,10.9,13.2,11C13.2,10.9,13.2,10.9,13.2,11L13.2,11L13.2,11L13.2,11z M13.2,10.7c0,0-0.1,0-0.1,0 c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c0,0.1,0,0.1,0,0.1c0,0,0.1,0.1,0.1,0.1c0,0,0.1,0,0.1,0v0.1c-0.1,0-0.1,0-0.2,0 c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0.1-0.1,0.1-0.1C13.1,10.6,13.1,10.6,13.2,10.7L13.2,10.7 L13.2,10.7L13.2,10.7L13.2,10.7z M13.2,10.8C13.2,10.8,13.2,10.8,13.2,10.8L13.2,10.8H13v0.4l0,0h0.1V11h0l0,0c0,0,0,0,0,0 c0,0,0,0,0,0v-0.1c0,0,0,0,0,0l0,0h-0.1l0,0L13.2,10.8L13.2,10.8L13.2,10.8C13.2,10.8,13.2,10.8,13.2,10.8L13.2,10.8L13.2,10.8 L13.2,10.8L13.2,10.8z M11.9,10.8v-0.5H12l0,0c0-0.3,0-0.7,0.1-1.2c-0.1,0.2-0.1,0.4-0.2,0.6V8.4h0.8l0,0l0,2.9h-0.8L11.9,10.8 L11.9,10.8L11.9,10.8L11.9,10.8z M11.9,8.4v1.2c-0.1,0.3-0.1,0.5-0.2,0.6l0,0h0.2v0.5h-0.2l-0.1,0.5h-0.8l0.8-2.9H11.9L11.9,8.4 L11.9,8.4L11.9,8.4z M9.9,10.8v-0.5H10l0,0c0-0.3,0-0.7,0.1-1.2C10,9.3,10,9.5,9.9,9.6V8.4h0.8l0,0l0,2.9H10L9.9,10.8L9.9,10.8 L9.9,10.8L9.9,10.8z M9.9,8.4v1.2c-0.1,0.3-0.1,0.5-0.2,0.6l0,0h0.2v0.5H9.7l-0.1,0.5H8.9v-0.4l0.7-2.5H9.9L9.9,8.4L9.9,8.4L9.9,8.4 z M8.9,9.7L8.9,9.7L8.9,9.7L9,9.4l0,0c0-0.3,0-0.5,0-0.6c0-0.1,0-0.1-0.1-0.2V9.7L8.9,9.7L8.9,9.7z M8.9,8.6v1H8.2l0.1-0.5l0,0 c0-0.1,0-0.2,0-0.3c0,0,0-0.1-0.1-0.1c-0.1,0-0.1,0-0.1,0.1C8,9,8,9,8,9.2l0,0l-0.2,1.3l0,0c0,0.1,0,0.2,0,0.3c0,0,0,0.1,0.1,0.1 c0.1,0,0.1,0,0.1-0.1c0,0,0-0.1,0.1-0.3l0,0l0-0.4h0.7l0,0.1l0,0c0,0.3-0.1,0.5-0.2,0.6c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.2,0.1-0.3,0.1-0.6,0.1c-0.2,0-0.4,0-0.5-0.1c-0.1-0.1-0.2-0.2-0.2-0.3c0,0,0,0,0-0.1v-0.3c0-0.1,0-0.2,0-0.2l0,0l0.1-0.8l0,0 c0-0.2,0.1-0.4,0.1-0.5c0-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.3-0.1,0.4-0.1c0.2,0,0.4,0,0.5,0.1 C8.8,8.5,8.9,8.6,8.9,8.6L8.9,8.6L8.9,8.6L8.9,8.6z M8.9,10.9l-0.1,0.4h0.1V10.9L8.9,10.9L8.9,10.9L8.9,10.9z M7.1,8.5L7.1,8.5 L7.1,8.5L7.1,8.5L7.1,8.5L7.1,8.5L7.1,8.5z M7.1,8.4L7.1,8.4l-0.4,2.9H6L5.8,10l-0.2,1.3H5l0.4-2.9H6l0.2,1.3l0.2-1.3H7.1L7.1,8.4 L7.1,8.4L7.1,8.4z M7.1,10.5c0,0.1,0,0.2,0,0.3V10.5L7.1,10.5z'/%3E %3C/svg%3E"

/***/ }),

/***/ 1325:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='nfl' xmlns:cc='http://creativecommons.org/ns%23' xmlns:dc='http://purl.org/dc/elements/1.1/' xmlns:rdf='http://www.w3.org/1999/02/22-rdf-syntax-ns%23' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 172.3 240.7' style='enable-background:new 0 0 172.3 240.7;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D .st1%7Bfill:%23013369;%7D .st2%7Bfill:%23D50A0A;%7D %3C/style%3E %3Cpath class='st0' d='M166.3,28.9c-7.2,5.4-21.5,12.6-39.5,8.1C95.1,29.2,86.2,2,86.2,2s-9,27.2-40.7,35c-18.2,4.5-32.3-2.8-39.8-8H0 v146.6c0,3.9,0.9,11.1,6.9,18.5c7.4,9,20,14.7,37.4,17.3c14.1,2,24.2,6.4,31.4,13.3c5.4,5.1,10.5,14,10.5,14s5.2-9,10.4-14 c7.2-7,17.5-11.3,31.4-13.3c17.4-2.5,29.9-8.4,37.4-17.4c6-7.3,6.9-14.6,6.9-18.3V29.1h-5.7'/%3E %3Cpath class='st1' d='M166.9,34.6c0,0-17.3,13.4-41.6,7.4C97,34.9,85.9,13.7,85.9,13.7S74.9,34.9,46.4,42c-23.9,6-41.3-7.5-41.3-7.5 v140.9c0,4.8,2,25.1,40.1,30.5c15,2.2,26.2,7,34.1,14.7c2.9,2.8,5.1,5.6,6.8,8.2c1.7-2.6,3.9-5.4,6.8-8.2c8-7.7,19.2-12.6,34.1-14.7 c38-5.5,39.8-25.8,40.1-30.5V34.5'/%3E %3Cpath class='st0' d='M86.2,214.8c0,0,11-13.6,39.5-18c32.9-5.1,31.7-20.4,31.7-21.2v-73.9H14.7v73.9c0,0.8-1,16.2,31.7,21.2 c28.6,4.4,39.5,18,39.5,18'/%3E %3Cg%3E %3Cpath class='st2' d='M52.7,155.8l0-35l-4.4-2.5v-9.1h20.1v9.1l-4.2,2.5v71.5l-10.7-3.2l-15.5-45.8l0,30.2l4.9,3.8v9.3l-21.5-5.5 v-7.9l4.9-1.9v-50.6l-5.1-2.5v-9.1h16.3L52.7,155.8'/%3E %3Cpath class='st2' d='M89.8,187.8l4.3,5.1v9.1l-21.3-8v-7.7l4.7-1.9v-63.7l-4.7-2.4v-9.2h37.1v18.5h-8.1l-2.5-7.6h-9.4v21.4h7.1 l2.8-4.1h5.7v19.1h-5.7l-2.7-3.9h-7.2v35.3'/%3E %3Cpath class='st2' d='M113.4,191.1V182l5.3-4.3v-56.8l-4.5-2.4v-9.2h21.3v9.2l-4.2,2.4v53.6l9.2-2.5l1.8-14h8.8v23.4l-37.7,10.1'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M18.4,86.7l-6.5-4.8h7.9l2.6-7.5l2.6,7.5h7.9l-6.5,4.9l2.4,7.6l-6.4-4.5L16,94.3L18.4,86.7'/%3E %3Cpath class='st0' d='M46.4,86.7l-6.5-4.8h7.9l2.6-7.5l2.6,7.5h7.9l-6.5,4.9l2.4,7.6l-6.4-4.5L44,94.3L46.4,86.7'/%3E %3Cpath class='st0' d='M18.4,61.5l-6.5-4.8h7.9l2.6-7.5l2.6,7.5h7.9l-6.5,4.9l2.4,7.6l-6.4-4.5L16,69.2L18.4,61.5'/%3E %3Cpath class='st0' d='M46.4,61.5l-6.5-4.8h7.9l2.6-7.5l2.6,7.5h7.9l-6.5,4.9l2.4,7.6l-6.4-4.5L44,69.2L46.4,61.5'/%3E %3Cpath class='st0' d='M156.2,94.1l-6.4-4.5l-6.4,4.5l2.4-7.6l-6.5-4.9h7.9l2.6-7.5l2.6,7.5h7.9l-6.5,4.9L156.2,94.1'/%3E %3Cpath class='st0' d='M128,94.1l-6.4-4.5l-6.4,4.5l2.4-7.6l-6.5-4.9h7.9l2.6-7.5l2.6,7.5h7.9l-6.5,4.9L128,94.1'/%3E %3Cpath class='st0' d='M156.2,69l-6.4-4.5l-6.4,4.5l2.4-7.6l-6.5-4.9h7.9l2.6-7.5l2.6,7.5h7.9l-6.5,4.9L156.2,69'/%3E %3Cpath class='st0' d='M128,69l-6.4-4.5l-6.4,4.5l2.4-7.6l-6.5-4.9h7.9l2.6-7.5l2.6,7.5h7.9l-6.5,4.9L128,69'/%3E %3Cpath class='st0' d='M92.1,55.8c-2.9-2.4-6.1-3.9-9.5-4.6c0.8-0.8,1.7-1.5,2.4-2.1c4.3,1,7.2,2.9,9.1,4.6 C93.5,54.4,92.8,55.1,92.1,55.8L92.1,55.8z M88,60.8c-2.7-2.3-6.1-4-9.8-4.8c0.6-0.7,1.3-1.5,1.9-2.3c2.9,0.5,6.6,2,9.8,4.7 C89.2,59.3,88.6,60.1,88,60.8L88,60.8z M84.2,66.1c-3-2.5-6.4-4-9.8-4.6c0,0,1-1.7,1.6-2.6c4.1,0.8,7.5,2.8,9.8,4.7 C85.3,64.5,84.8,65.3,84.2,66.1L84.2,66.1L84.2,66.1z M103.8,41.1c0,0-3.4,1.7-8,6.3c1.1,0.6,2.2,1.4,2.9,2 c-0.7,0.6-1.4,1.3-2.1,1.9c-3.1-2.5-6.2-3.8-8.6-4.4c0.8-0.6,1.7-1.2,2.5-1.7c1.3,0.3,2.6,0.9,2.6,0.9c5.3-4,9.8-5.7,9.8-5.7 s-0.5-0.3-1.9-0.2c-20.7,0.3-39.8,15.7-36.2,42.2c0.4,2.8,1.5,7.9,2.9,10.2c0.5-4.4,2.1-14.2,7-24.6C73,67.2,71.5,67,71.5,67 c0.5-1.1,1.2-2.4,1.2-2.4c3.6,0.7,6.9,2.2,9.6,4.4c-0.7,1.1-1.1,1.8-1.4,2.3c-1-0.8-2-1.4-3.1-2c-5.5,9.7-8.1,18.8-9.1,23.5 c0.1,0.3,0.7,0.4,1.1,0.4c22.7-2.9,33.2-14.5,36.5-27.1c2.1-8.2,1.4-16.8-1.4-23.9C104.8,41.8,104.4,41,103.8,41.1'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1326:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nhl_icon.embedded.svg?aa74b50e38faf3fe13abfbbc2f2d657d";

/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fa9c1e;%7D.cls-2%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Eoverwatch%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath id='path3961' class='cls-1' d='M253.19,0A255.46,255.46,0,0,0,95.64,56.41L144,112.55c40.81-32.21,95.79-45.33,146.79-35.19A182.87,182.87,0,0,1,368,112.55l48.35-56.14A255.49,255.49,0,0,0,253.19,0Z'/%3E%3Cpath id='path4052' class='cls-2' d='M79.9,70.21C29,118.07-.92,187.64,0,257.81c0,72.84,33.26,144.4,88.45,191.72,51,44.62,120.39,67.34,188.13,61.59C350,505.66,419.66,466.46,462.73,406.9c41.91-56.59,58.34-131.22,44.42-200.43-10.23-53-38-102.08-77.51-138.58L381.29,124c39,36.71,60.23,90.92,56.22,144.39a180.67,180.67,0,0,1-22.46,75.9l-98.53-95.17L266.8,142l-.07,162.27,99.58,96.35c-44.38,34.48-105.26,45.91-159.21,30.63a180.72,180.72,0,0,1-60.86-30.2L246.5,304.27c-.17-52.76.61-109.71,0-162.45L196.71,249.15l-99.38,96c-30.32-52.92-31-121.34-1.86-174.85A184.74,184.74,0,0,1,130.67,124L82.32,67.89Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"

/***/ }),

/***/ 1328:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Crect x='0' y='0' class='st8' width='24' height='24'/%3E %3Cpath class='st31' d='M18.9,15.9l-4.4-4.2l-2-4.5V14l4.4,4.2c-1.3,1-3,1.6-4.9,1.6s-3.5-0.6-4.9-1.6l4.4-4.2V7.2l-2,4.5l-4.4,4.2 c-0.7-1.1-1-2.5-1-3.9c0-2.2,0.9-4.3,2.4-5.7L4.6,3.9C2.4,5.9,1,8.8,1,12c0,6,4.9,10.9,11,10.9h0h0c6.1,0,11-4.9,11-10.9 c0-3.2-1.4-6.1-3.6-8.1l-1.9,2.4c1.5,1.4,2.4,3.5,2.4,5.7C19.9,13.4,19.6,14.7,18.9,15.9L18.9,15.9z'/%3E %3Cpath class='st32' d='M12,1.1L12,1.1L12,1.1c2.6,0,4.9,0.9,6.8,2.3l-1.9,2.4c-1.3-1-3-1.6-4.8-1.6S8.5,4.7,7.2,5.8L5.2,3.4 C7.1,1.9,9.4,1.1,12,1.1L12,1.1z'/%3E %3C/svg%3E"

/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 296'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23f47b00;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Epubg%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M33.29,1.05c-3.61,1.09-6.3,2.58-8.3,5C22.13,9.51,22,10,22.24,20.26c.12,5.88.12,16.29,0,23.32-.11,12.57-.11,12.57-2.46,11.83-4.7-1.6-15.92-.86-17.81,1.2-1.6,1.71-1.6,1.71.23,1.08,1.37-.4,1.83-.23,1.49.63A1.59,1.59,0,0,1,2,59.41c-.74-.12-1.2,1.83-1.2,5.31A83.22,83.22,0,0,1,.14,74.1c-.4,3,0,4.28,2.23,6.62,2.58,2.75,3.44,3,11.11,3,7.16,0,8.42.34,8.88,1.83C23,88,22.24,209.6,21.61,211.32c-.34,1-2.75,1.37-7.39,1.37s-8,.63-10.13,1.83C.88,216.46.77,216.63.65,225c-.23,17,.23,17.6,13.69,17.6h9L23,263c-.41,28.81.4,30.07,21.13,31.21,30.75,1.6,120.76,2.23,135.54,1a143,143,0,0,1,14.71-.4c6.93.11,8.65,0,9.91-1.2,1.09-.86,1.49-.86,1.49,0a1.19,1.19,0,0,0,1.09,1.2c.63,0,1.08-1,1.08-2.23s-.4-1.83-1.08-1.49c-.52.35-1.09.12-1.09-.51,0-1.94,2.58-.63,3.72,1.94,1.09,2.35,1.38,2.35,25.08,2.35,13.23,0,31.38.34,40.37.63,24.22,1,62.19-.4,62.19-2.35a1.33,1.33,0,0,1,1.2-1.48c.63,0,1,.74.52,1.6-.4,1.37.74,1.6,7.67,1.6,4.47.11,29.15.23,54.92.34s46.32-.11,46-.63.34-.74,1.26-.74c1.08,0,1.37.51,1,1.26-1.26,2,26.68.34,31.38-2,7.79-3.83,8.25-5.43,8.3-28.58.12-11.43.4-21.43.86-22.41.4-1.25,1.26-1.48,3-1,3.09,1.09,14.72.52,16.89-.63,1.38-.85,1.26-1-.34-1.08-1.2,0-1.83-.52-1.49-1.37.23-.63,1-1.2,1.49-1.09,1.37.34,2.46-16.74,1.26-18.86-2.58-4.57-3-4.8-12.71-5.31l-9.74-.52-.23-64.3L488,83.81h9.5c8.77,0,9.51-.23,12.09-3,2.23-2.34,2.69-3.6,2.23-6.63a70.55,70.55,0,0,1-.63-9.26c0-3.6-.4-5.54-1.2-5.31a1.68,1.68,0,0,1-1.72-1.2c-.34-.86.11-1.09,1.49-.63,1.72.63,1.72.51.34-1-1.72-1.82-12.25-2.68-17.06-1.37s-5.21.12-5.9-19.09c-1.2-29.66-3.44-33.89-18-33.49-4.29.12-8.3-.11-9-.4C459,1.45,440.83.2,431.67.2c-3.55.11-9.73.11-13.86.11s-25.19.23-47,.34-43.58.35-48.62.52-11.22.4-13.85.34c-41.46-.63-75.82-.86-77.65-.4-1.38.34-2.35,1-2.12,1.37s-.23.86-.86,1-1.09-.34-1.09-1.08c0-1-5.15-1.26-21.87-1.26-17,0-21.76.34-21.7,1.26.22.74-.41,1.37-1.38,1.37s-1.37-.4-1.09-1C181.83.82,174.9.54,126.23.54c-27,0-57.78-.23-68.37-.4-14-.34-20.73-.06-24.57.91ZM250.38,29.92c146.19.22,194.58-.12,194.58-1s.34-.85.86,0,3.2,1.49,6.07,1.6l5.32.35.12,5.31c.22,8.52,1.6,94.65,1.48,96.48-.34,9.08,0,77.61.52,101.5s.4,30.69-.63,31.32c-.74.4-4.81.63-8.88.51-7.9-.34-36.76-.34-147.39-.22-57.38.11-64.82.34-64.31,1.71.4,1.09-.11,1.6-1.49,1.6s-1.94-.51-1.49-1.6c.52-1.37-6.18-1.49-53.71-1.49-29.77.12-63,.4-73.81.75s-19.41.4-19.41-.12c0-1.25-3.72-.85-5.16.52-1,1-1.6,1.08-2.11.23s-5.56-1.26-14-1.38c-7.27-.11-13.68-.4-14.08-.74s-1-4.34-1-9.14c0-7.15-.23-8.4-1.6-7.89-1.09.4-1.6-.11-1.6-1.49s.51-1.94,1.6-1.48c1.37.51,1.6-4.17,1.72-38.07.4-127.5.4-126-1.09-126.53-.86-.35-1.09-.75-.34-1.2,1.6-1,1.83-13.83.34-18.58-.74-2.11-1-4.46-.4-5.2.4-.74.86-6.74,1.09-13.09.11-6.51.23-12.34.23-13.2s.74-1.2,2-.51c1,.4,89.44.91,196.53,1Z'/%3E%3Cpath class='cls-1' d='M390.84,56.78,368.11,57l-4.18,4.05c-3.55,3.43-4.3,4.81-4.81,9.83-1.2,10.12-1.2,24.29-.23,46.93.52,12.06.86,23.77.63,26.12s-.4,21.94-.4,43.72L359,227.09l2.58,4.18a16.64,16.64,0,0,0,6,5.54c4.29,1.83,47.18,2.23,52.85.51,5.21-1.6,9.39-6.91,10-12.8,1.09-10.34.63-89.1-.51-92.07l-1.21-2.86H414c-9.9,0-15.06.4-15.91,1.26s-1.26,5-1.26,11.49v10.23l3.2,1.83,3.21,1.94.11,11.94c0,6.63,0,17.26-.11,23.89-.12,7.15.34,12.69,1.09,13.83.86,1.38,1,2.75.11,4.81-1.09,2.85-1.2,2.85-9.16,2.45-9.11-.4-10.77-1.08-9.11-3.2,1.21-1.48,1.72-76,.75-111l-.52-17.14,7.68-.4c11.45-.52,11.33-.63,11.33,7,0,3.71.52,7.14,1.26,7.88,1,1,1,1.26,0,1.26-2.34,0-1.37,3,1.21,3.55,3.83.74,18.89.11,20-1,.4-.51,1.09-8.74,1.38-18.34l.4-17.49-3-3c-2.58-2.57-4.81-3.43-12-4.58-.69-.22-11.51-.22-23.88,0ZM85.63,58.84c-1,1-1.26,7-1,21.83.34,23.89.23,22.06,1.49,20.06.86-1.26,1.08-1,1.08,1.26,0,1.48-.51,3-1.26,3.2-1,.34-1.26,4.91-1.26,15.88-.11,13.32-.34,15.78-1.94,17.38s-2,3.83-2,13.66c0,6.51.34,11.49.75,11.2,1-1,4.58,2.34,4.58,4.29,0,.74-.35,1.37-.75,1.37s-1,14.63-1.2,32.52.23,32.52.63,32.52,1.49,1.2,2.12,2.69c1.2,2.57,1.6,2.68,11.85,2.68,15.81,0,15,1.94,14.66-36.86-.23-17-.4-31.32-.63-31.89-1.2-4.58-.63-4.8,14.55-4.8,16.43,0,22.61-1.2,26.28-5l2.46-2.69.35-46.24c.22-31.15-.12-47-.86-48.41-2.7-4.91-5.56-5.31-38.14-5.65-22.56-.17-31,0-31.84,1Zm42.15,25.54c.11,1.09.11,12.46.23,25.38s.34,22.57.51,21.55c.86-3.21,2.46-1.95,2.46,2,0,3.08-.34,3.71-1.71,3.2-1.21-.4-1.49-.12-1.09,1.25.51,1.6-.12,1.83-6.53,1.49-4.07-.23-7.67-1.09-8.53-1.83-1.72-1.71-1.84-4.8-.23-4.8.74,0,1-7.49.51-24.4-.23-13.44-.23-24.75.12-25s3.72-.63,7.5-.63c5.73.06,6.76.35,6.76,1.83ZM177,58.49c-1.83,2.12-1.2,25.78.75,25.38.63-.12,1.26.51,1.26,1.37s-.63,1.49-1.26,1.26c-1-.12-1.49,1.6-1.72,5.43-.23,4.45,0,5.54,1.09,4.91s1.09-.51.23.74c-1.72,2.23-2.87,123-1.26,130.14,1,3.83,2.12,5.89,4.81,7.78l3.55,2.74,28-.4c31.21-.4,33.44-1,36.82-7.49,2.35-4.57,3.32-40.52,2.75-103.1-.23-25.49-.4-50.87-.4-56.18,0-6.18-.4-10.12-1.21-10.69a1.18,1.18,0,0,0-1.71.51c-.52,1.83-2.35,1.6-2.35-.34,0-1.26-1.72-1.6-9.11-1.6-14.66,0-13.57-3.54-13.45,45.61.11,22.69.4,47.66.74,55.32.52,10.12.34,14.18-.51,14.18-1.95,0-1.38,4.05.74,5.2,1.26.85,1.49,1.37.52,1.94-.75.63-1.38,5.89-1.61,15.43-.34,12.35-.63,14.92-2.23,16.52-1.83,1.83-2,1.83-3.32,0-1.61-2-6.07-2.35-9.28-.63s-6.53-1.49-5.67-5.32c.75-3.2,1.26-91.67.75-123.73l-.4-21.95L199,59.06c-3.09-1.71-5.32-2.34-6.64-1.71-2,.86-9.16.86-12.25-.12a4.29,4.29,0,0,0-3,1.26Zm95.17-.11c-1.2,1.6-1.6,40.29-.4,45.49.52,2,.52,7,.23,11.2s-.34,8,.23,8.75c1.38,1.71,0,5.66-1.95,5.66-.85,0-1.26.51-1,1.08s-.11,1.83-1,2.75c-1.95,1.94-2.47,16.86-.63,18a3.36,3.36,0,0,1,1.09,2.68,2.46,2.46,0,0,0,1.2,2.35c1,.34,1.26,9.89,1.26,35-.12,20.06.34,35.14,1,36,.52.62.52,1.48.12,1.71s-.75,2.57-.52,4.91l.4,4.35,28.52-.34c42.49-.35,40,2.68,40.14-49.78,0-35.27-.12-36.87-2.12-39-6.41-6.92-7.16-8.23-5.44-9.14,4.3-2.35,5.33-7.26,5.56-23.27.11-8.51.34-24,.51-34.4.34-17.89.23-19.09-1.95-21.09-3.32-3.32-8.3-4-37.27-4.06-20.22,0-27.15.23-28,1.26Zm40,24.35c.63,1.08.63,9.14,0,40.4-.11,7.78-.63,8.23-8.64,6.92l-4.58-.63-.63-9.26c-.35-5.14-.63-10-.75-10.86s.34-7.49.75-14.69l.74-13h6.18C308.61,81.52,311.71,82,312.16,82.73Zm-.45,74.92c.4.63.85,8.86.85,18.23s.12,21.44.12,26.87-.12,10.23-.52,10.74c-.86,1.37-12,.86-13.8-.74-1.2-1-1.37-2.23-.74-5.15.51-2.11,1-14.17,1-26.86,0-19.83.23-23.14,1.72-24.17,2-1.49,10.25-.75,11.4,1.08Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"

/***/ }),

/***/ 1330:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3Cpath class='st6' d='M13.7,21.7c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.1,0-0.3,0c0.3-0.2,0.6-0.2,0.9-0.1c0.4,0.1,0.7,0.2,1.1,0.3 c-0.7,0.1-1.4,0.2-2.1,0.4c0.2,0.1,0.4,0.1,0.6,0.2c0,0,0,0,0,0.1c-0.1,0-0.1,0-0.2,0c-0.5,0-1,0-1.5,0.1c-0.2,0-0.4,0-0.5-0.3 c-0.1-0.3-0.5-0.4-0.8-0.3c-0.4,0.2-0.7,0.1-1.1,0c-0.3-0.1-0.6-0.1-0.9-0.1c0-0.1,0-0.1,0.1-0.3c-0.2,0-0.3,0.1-0.4,0.1 C7.8,21.8,7.2,22,6.6,22c-0.5,0-0.9-0.1-1.3-0.4c-0.3-0.2-0.6-0.3-1-0.5c0,0,0.1-0.1,0.1-0.2c-0.2,0-0.3-0.1-0.5-0.1 c-0.7-0.1-1.2-0.4-1.6-0.9c-0.2-0.3-0.4-0.7-0.1-1c0,0,0-0.1,0-0.2c-0.1-0.1-0.2-0.2-0.2-0.3c-0.1-0.2-0.2-0.4,0.1-0.6 c-0.1-0.1-0.2-0.1-0.3-0.2c-0.4-0.2-0.6-0.5-0.6-1c0-0.3-0.1-0.6-0.1-0.9c0-0.1,0-0.2,0-0.3c0.4,0.1,0.4,0,0.5-0.3 c0-0.1,0.1-0.1,0.2-0.1c0.2,0,0.3-0.2,0.3-0.4c0-0.3-0.1-0.5-0.1-0.8c-0.1-0.6-0.2-1.2-0.1-1.7c0-0.1,0.1-0.3,0.2-0.4 c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.3,0.1-0.6,0.1-0.9c0.5,0.2,0.8,0.2,1.2-0.3C3.9,10.2,4,9.9,4.2,9.6 c0.1-0.3,0.1-0.6-0.2-0.8c0.3-0.7,0.3-1.6,1.1-2.1C5,6.9,5,7,4.9,7.2C4.8,7.7,5.1,8,5.6,7.8C6,7.7,6.3,7.5,6.5,7.1 c0.1-0.2,0.2-0.5,0.4-0.7C7.2,6,7.5,5.6,8.1,5.3c-0.3,0.5-0.2,0.8,0,1.2c0.1,0.3,0.1,0.5,0,0.8C8,7.5,8,7.6,8,7.7 c0.2-0.3,0.4-0.6,0.7-1c0,0.3-0.1,0.6-0.1,0.9c0,0.2,0,0.4,0,0.6c0,0.2,0.2,0.3,0.4,0.3c0-0.1,0-0.3,0-0.4C9,8,9,7.8,9.1,7.7 c0.2-0.2,0.2-0.3,0.2-0.6c0-0.3-0.1-0.6-0.1-0.9c-0.1-0.3,0-0.6,0.2-0.9C9.6,5.2,9.6,5,9.7,4.9c-0.4,0-0.6,0.2-0.8,0.5 c-0.1-1,0.5-1.6,1.1-2.2c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3c0.1,0,0.3,0,0.3-0.1c0.2-0.1,0.3-0.3,0.4-0.5c0.2-0.4,0.4-0.7,0.8-0.9 C11.5,2,11.6,2,11.7,1.9c-0.1,0.1-0.2,0.3-0.3,0.5c0.1,0,0.2,0,0.2,0c-0.1,0.1-0.1,0.2-0.2,0.2c0.5-0.3,0.9-0.7,1.2-1.3 c0.1,0.4,0.1,0.9-0.2,1.2c-0.3,0.3-0.6,0.6-0.8,0.9c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1,0,0.2,0,0.4c0.1-0.1,0.3-0.1,0.3-0.2 c0.1-0.2,0.2-0.5,0.4-0.7c0.2,0.3,0.2,0.3,0.5,0.1c0.2-0.2,0.4-0.5,0.7-0.7c-0.1,0.2-0.1,0.3-0.2,0.5c0,0.1,0,0.2,0,0.3 c0,0.1,0,0.1,0,0.2c-0.3,0.7-0.7,1.3-1.3,1.6C11.1,6.1,11,6.5,11,7c0.3,0,0.4-0.2,0.5-0.4c0,0.3-0.1,0.6-0.3,0.9 C11.1,7.5,11,7.6,11,7.7c0,0.1,0,0.2,0,0.2c0,0,0.2,0.1,0.2,0c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.3-0.2,0.5-0.2 c-0.4,0.4-0.4,0.8-0.7,1.2C11.3,9,11,9.2,10.7,9.5c0.1,0,0.2-0.1,0.2-0.1c0.4-0.2,0.7-0.5,1.1-0.7c0.4-0.3,0.5-0.8,0.5-1.3 c0-0.2,0-0.5,0.1-0.7c0.1-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.2-0.1,0.2-0.2c0.2-0.3,0.4-0.6,0.7-0.7c0.7-0.3,1.2-0.9,1.4-1.6 c0,0,0-0.1,0-0.1c0,0,0,0,0.1,0c0,0.3-0.1,0.6-0.1,0.9c0,0.1,0,0.1,0.1,0.2c0,0.2,0,0.4-0.1,0.6c-0.1,0.1-0.2,0.3-0.3,0.4 c-0.2,0.1-0.3,0.2-0.5,0.3c-0.3,0.2-0.5,0.4-0.5,0.7c-0.1,0.3,0.1,0.4,0.4,0.4c0,0,0.1,0,0.2,0c-0.1,0.1-0.2,0.2-0.3,0.3 c0.3,0.1,0.7-0.1,0.9-0.4c0.2-0.3,0.3-0.5,0.4-0.8c0.2-0.4,0.5-0.6,0.9-0.7c-0.3,0.2-0.5,0.4-0.5,0.8c0.1-0.1,0.2-0.1,0.2-0.2 c0,0,0,0,0.1,0c-0.1,0.4-0.3,0.8-0.4,1.2c0,0,0,0,0.1,0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.4,1.2-0.9,1.4-1.7c0.2-0.5,0.4-1,0.8-1.4 c0.4-0.4,0.9-0.6,1.4-0.8c-0.2,0.2-0.5,0.4-0.7,0.6c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.3,0,0.3,0.3,0.3c-0.1,0.1-0.2,0.3-0.3,0.4 C19.1,5.3,19,5.3,19,5.4c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0.2,0.1,0.3,0.2c-0.1,0.3-0.2,0.6-0.5,0.8c-0.3,0.3-0.7,0.5-1,0.8 c-0.1,0.1-0.3,0.2-0.4,0.4c1.2-0.4,2.1-1.1,2.9-2c0,0.1,0,0.2-0.1,0.3c-0.5,1.4-1.5,2.4-2.8,3c-0.1,0-0.1,0-0.2,0 c-0.3,0.1-0.7,0.2-0.9,0.4c-0.4,0.3-0.8,0.6-1.2,0.9c-0.1,0.1-0.2,0.2-0.2,0.2c-0.1,0.1-0.1,0.3-0.1,0.4c0,0.1,0.2,0.1,0.3,0.1 c0.8-0.1,1.5-0.4,2.1-1c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.4-0.3,0.7-0.2c-0.3,0.2-0.5,0.5-0.5,0.9c0,0.3,0.1,0.3,0.4,0.2 c-0.1,0.2-0.2,0.4-0.3,0.5c-0.3,0.4-0.7,0.7-1,1.1c-0.1,0-0.2,0.1-0.2,0c-0.6-0.2-1.1,0.1-1.5,0.4c0,0,0,0,0,0.1 c-0.1,0.3-0.3,0.5-0.5,0.8c-0.1,0.2,0,0.3,0.2,0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c-0.2,0.2-0.4,0.3-0.6,0.5 c-0.1,0.1-0.3,0.3-0.2,0.5c0.1,0.2,0.3,0.2,0.5,0.2c0.6,0,1.2-0.3,1.7-0.5c0.7-0.3,1.3-0.7,1.8-1.3c0.2-0.3,0.6-0.5,1.1-0.5 c-0.3,0.2-0.6,0.4-0.6,0.7c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.2-0.1,0.3,0.2,0.4c-0.2,0.3-0.3,0.5-0.5,0.8 c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c-0.3,0.2-0.6,0.3-0.9,0.4c-0.4,0.1-0.7,0.3-0.9,0.7c-0.1,0.2-0.1,0.4,0.2,0.5 c-0.2,0.2-0.4,0.4-0.6,0.6c0.5,0,0.9,0,1.2-0.4c0.2-0.2,0.3-0.2,0.5-0.3c0.2,0,0.4-0.1,0.7-0.1c-0.1,0.1-0.2,0.2-0.2,0.3 c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0.2,0.1,0.3,0.1c0.6,0,1.1-0.2,1.6-0.5c0.4-0.3,0.7-0.7,1.1-1c0.6-0.7,1.4-1.1,2.3-1.2 c-0.2,0.1-0.4,0.2-0.6,0.3c-0.3,0.2-0.6,0.5-1,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1-0.1,0.3-0.1,0.4c0.1,0,0.3,0,0.4,0 c0.1,0,0.2,0,0.3,0c-0.6,0.4-1.2,0.8-1.8,1.2c-0.6,0.4-1.3,0.6-2,0.8c0,0,0,0.1,0,0.1c0.5-0.1,1-0.2,1.5-0.4c0.5-0.2,1-0.4,1.5-0.6 c-0.2,0.2-0.4,0.4-0.7,0.6c-0.7,0.5-1.4,1-2.3,1.1c-0.5,0.1-1,0-1.5,0c-0.5,0-1.1,0.3-1.5,0.6c0.4,0.3,0.8,0,1.3,0 c-0.2,0.1-0.3,0.2-0.6,0.4c0.5,0,0.9,0,1.3-0.1c0,0,0,0,0,0c-0.2,0.1-0.5,0.2-0.7,0.2c-0.4,0.1-0.7,0.2-1,0.4 c-0.4,0.4-1,0.4-1.5,0.3C13.7,21.1,13.4,21,13,21c-0.2,0-0.5,0-0.7,0.1c-0.1,0-0.1,0.2-0.2,0.3c0.1,0.1,0.2,0.1,0.3,0.2 c0.1,0.1,0.2,0.1,0.3,0.2c0.3,0.2,0.6,0.2,0.9,0.2C13.6,21.9,13.6,21.8,13.7,21.7z M12.7,16.6c0.4-1.1,0.4-2.3,0-3.4 c-0.8-2.1-2.7-2.9-4.4-2.7c-0.1,0-0.2,0.1-0.2,0.2c-0.1,1-0.3,2-0.5,3c-0.1,1-0.3,1.9-0.4,2.9C9,16.6,10.9,16.6,12.7,16.6z M6.6,20.6c1.6,0.6,5.1-1.3,5.6-3c-0.7,0-1.4,0-2.1,0c-0.9,0-1.9,0-2.8,0c-0.1,0-0.2,0-0.2,0.1C6.9,18.8,6.7,19.7,6.6,20.6z M5.5,11.7c-1.5,1-2.6,3.2-2.4,4.9c0.6,0,1.1,0,1.7,0C5,15,5.2,13.4,5.5,11.7z M4.5,17.7c-0.5,0-0.9,0-1.4,0 c0.2,0.7,0.5,1.3,1.1,1.8C4.4,18.9,4.5,18.3,4.5,17.7z'/%3E %3C/svg%3E"

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 24 24' style='enable-background:new 0 0 24 24;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st1%7Bfill:%23FFFFFF;%7D .st2%7Bfill:%23A1A1A1;%7D .st3%7Bdisplay:none;fill:none;stroke:%23000000;stroke-miterlimit:10;%7D .st4%7Bstroke:%23000000;stroke-width:0.1;stroke-miterlimit:10;%7D .st5%7Bstroke:%23000000;stroke-width:0.1;stroke-linecap:round;stroke-miterlimit:10;%7D .st6%7Bfill:%23EEEEEE;%7D .st7%7Bfill:%23FF9900;%7D .st8%7Bfill:none;%7D .st9%7Bfill:none;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st10%7Bfill:%23FF0000;%7D .st11%7Bfill:none;stroke:%23FF0000;stroke-miterlimit:10;%7D .st12%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linejoin:round;stroke-miterlimit:10;%7D .st13%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linejoin:round;stroke-miterlimit:10;%7D .st14%7Bfill:none;stroke:%23FF0000;stroke-linecap:round;stroke-miterlimit:10;%7D .st15%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-miterlimit:10;%7D .st16%7Bfill:none;stroke:%23000000;stroke-width:1.5;stroke-linecap:round;stroke-miterlimit:10;%7D .st17%7Bfill:none;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st18%7Bfill:%23FFFFFF;stroke:%23000000;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st19%7Bfill:%23009BDB;%7D .st20%7Bfill:%238AC440;%7D .st21%7Bfill:%23164722;%7D .st22%7Bfill:%238BC541;%7D .st23%7Bfill:%23164822;%7D .st24%7Bfill:%23FE7D05;%7D .st25%7Bfill:%23FE7D06;%7D .st26%7Bfill:%23F26D34;%7D .st27%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;%7D .st28%7Bfill:none;stroke:%23000000;stroke-width:0.75;stroke-miterlimit:10;%7D .st29%7Bfill:%23D2A938;%7D .st30%7Bfill:%232400E5;%7D .st31%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23EEEEEE;%7D .st32%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23E6792B;%7D .st33%7Bfill:url(%23SVGID_1_);%7D .st34%7Bfill-rule:evenodd;clip-rule:evenodd;fill:%23D43B3B;%7D .st35%7Bfill:%23E40300;%7D %3C/style%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3Crect y='0' class='st8' width='24' height='24'/%3E %3ClinearGradient id='SVGID_1_' gradientUnits='userSpaceOnUse' x1='12' y1='21.7526' x2='12' y2='2.0125'%3E %3Cstop offset='8.034112e-02' style='stop-color:%23FFEA3F'/%3E %3Cstop offset='0.1336' style='stop-color:%23FDC83C'/%3E %3Cstop offset='0.2193' style='stop-color:%23FA9737'/%3E %3Cstop offset='0.3044' style='stop-color:%23F86F34'/%3E %3Cstop offset='0.3874' style='stop-color:%23F64F31'/%3E %3Cstop offset='0.4677' style='stop-color:%23F5392F'/%3E %3Cstop offset='0.5441' style='stop-color:%23F42C2D'/%3E %3Cstop offset='0.6123' style='stop-color:%23F4272D'/%3E %3Cstop offset='0.874' style='stop-color:%2390272D'/%3E %3C/linearGradient%3E %3Cpath class='st33' d='M12,7.8c0.3-0.6,0.7-1.2,1-1.7c0.6-1,1.1-1.9,1.7-2.9c0.1-0.1,0.1-0.2,0.1-0.3C14.9,2.2,15.3,2,15.7,2 c2.1,0,4.2,0,6.3,0c0.6,0,0.9,0.2,1,0.9c0,0.5,0.1,1-0.1,1.4c0,0.2-0.1,0.3-0.3,0.4c-0.5,0.3-0.8,0.8-1.2,1.2 c-0.6,0.7-1,1.5-1.4,2.3c-2.4,4.3-4.8,8.6-7.2,12.9c-0.2,0.3-0.4,0.5-0.7,0.6c-0.3,0-0.7,0-0.8-0.3c-0.2-0.4-0.5-0.8-0.7-1.2 c-2.6-4.7-5.3-9.4-8-14.1C2.3,5.6,1.9,5.2,1.4,4.9C1.2,4.7,1,4.4,1,4.1c0-0.5-0.1-1,0.1-1.5c0.1-0.3,0.2-0.4,0.5-0.5 C1.7,2,1.9,2,2.1,2c2,0,4,0,6.1,0c0.4,0,0.7,0.1,0.9,0.4c0,0,0,0.1,0.1,0.1C9.2,3,9.5,3.4,9.7,3.8c0.7,1.3,1.4,2.5,2.2,3.8 C11.9,7.6,12,7.7,12,7.8z M10.9,15.2c0-0.1,0.1-0.1,0.1-0.2c0.6-1.1,1.2-2.2,1.9-3.4c1.6-2.8,3.1-5.6,4.7-8.4 c0.1-0.1,0.1-0.2,0.1-0.3c-0.7,0-1.3,0-1.9,0c0,0.1-0.1,0.3-0.1,0.4c-0.9,1.5-1.7,3.1-2.6,4.6c-0.3,0.6-0.6,1.1-1,1.7 c0-0.1-0.1-0.1-0.1-0.2c-1.1-2-2.3-4-3.4-6C8.4,3.2,8.3,3.1,8.3,2.9c-1.3,0-2.7,0-4.1,0c0,0.1,0.1,0.3,0.1,0.4 C6,6.4,7.7,9.4,9.4,12.5C9.9,13.4,10.4,14.3,10.9,15.2z M22.1,2.9c-1.4,0-2.8,0-4.2,0c0,0.1,0,0.2-0.1,0.3c-2.2,4-4.5,8-6.7,12.1 c-0.1,0.1-0.1,0.2,0,0.3c0.5,0.8,0.9,1.6,1.4,2.5c0.2,0.3,0.3,0.6,0.5,0.9c0-0.1,0.1-0.1,0.1-0.1c2-3.6,4.1-7.3,6.1-10.9 c0.5-0.8,0.9-1.7,1.5-2.5c0.4-0.5,0.8-1,1.3-1.4c0,0,0-0.1,0.1-0.1C22.1,3.7,22.1,3.3,22.1,2.9z M12,20.9c0-0.1,0.1-0.1,0.1-0.1 c0.2-0.4,0.5-0.9,0.7-1.3c0.1-0.1,0-0.2,0-0.2c-0.5-0.9-1-1.8-1.5-2.7C8.9,12.2,6.5,7.9,4.1,3.6C4,3.4,3.9,3.2,3.8,2.9 c-0.6,0-1.2,0-1.9,0c0,0.3,0,0.6,0,0.9c0,0.2,0,0.3,0.2,0.4c0.6,0.5,1.1,1,1.4,1.7C4.1,7,4.8,8,5.4,9.1c1,1.7,2,3.4,3,5.1 c1.2,2.1,2.4,4.3,3.6,6.5C11.9,20.7,11.9,20.8,12,20.9z'/%3E %3C/svg%3E"

/***/ }),

/***/ 1332:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 200 200' style='enable-background:new 0 0 200 200;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D .st1%7Bclip-path:url(%23SVGID_2_);%7D .st2%7Bclip-path:url(%23SVGID_4_);fill:%23076694;%7D .st3%7Bclip-path:url(%23SVGID_6_);%7D .st4%7Bclip-path:url(%23SVGID_8_);fill:%23076694;%7D .st5%7Bclip-path:url(%23SVGID_10_);%7D .st6%7Bclip-path:url(%23SVGID_12_);fill:%23E90E8B;%7D .st7%7Bclip-path:url(%23SVGID_14_);%7D .st8%7Bclip-path:url(%23SVGID_16_);fill:%23076694;%7D .st9%7Bclip-path:url(%23SVGID_18_);%7D .st10%7Bclip-path:url(%23SVGID_20_);fill:%23076694;%7D .st11%7Bclip-path:url(%23SVGID_22_);%7D .st12%7Bclip-path:url(%23SVGID_24_);fill:%23E90E8B;%7D .st13%7Bclip-path:url(%23SVGID_26_);%7D .st14%7Bclip-path:url(%23SVGID_28_);fill:%23E90E8B;%7D %3C/style%3E %3Ccircle class='st0' cx='100.5' cy='99.4' r='96.3'/%3E %3Cg%3E %3Cg%3E %3Cdefs%3E %3Crect id='SVGID_1_' x='87.8' y='144.2' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -81.0916 116.0164)' width='23.3' height='23.3'/%3E %3C/defs%3E %3CclipPath id='SVGID_2_'%3E %3Cuse xlink:href='%23SVGID_1_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Cg class='st1'%3E %3Cdefs%3E %3Crect id='SVGID_3_' x='1' y='1' width='198' height='198'/%3E %3C/defs%3E %3CclipPath id='SVGID_4_'%3E %3Cuse xlink:href='%23SVGID_3_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Crect x='52.1' y='108.4' class='st2' width='94.9' height='94.9'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cdefs%3E %3Crect id='SVGID_5_' x='32.5' y='90.7' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -59.4809 61.1966)' width='23.3' height='23.3'/%3E %3C/defs%3E %3CclipPath id='SVGID_6_'%3E %3Cuse xlink:href='%23SVGID_5_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Cg class='st3'%3E %3Cdefs%3E %3Crect id='SVGID_7_' x='1' y='1' width='198' height='198'/%3E %3C/defs%3E %3CclipPath id='SVGID_8_'%3E %3Cuse xlink:href='%23SVGID_7_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Crect x='-3.3' y='55' class='st4' width='94.9' height='94.9'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cdefs%3E %3Cpolygon id='SVGID_9_' points='36.1,61.9 25.8,72.3 25.8,83.5 32.3,83.5 45,70.8 75.3,101.1 45,131.5 33.8,120.4 25.8,120.4 25.8,129.9 37.4,141.6 52.5,141.6 84.2,110 90.7,116.5 59.9,147.3 59.9,164.1 72.8,177 81.1,177 81.1,167.6 69.1,155.7 99.5,125.3 129.9,155.7 117.9,167.6 117.9,177 126.2,177 139.1,164.1 139.1,147.3 53.8,61.9 '/%3E %3C/defs%3E %3CclipPath id='SVGID_10_'%3E %3Cuse xlink:href='%23SVGID_9_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Cg class='st5'%3E %3Cdefs%3E %3Crect id='SVGID_11_' x='1' y='1' width='198' height='198'/%3E %3C/defs%3E %3CclipPath id='SVGID_12_'%3E %3Cuse xlink:href='%23SVGID_11_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Crect x='-5.2' y='31' class='st6' width='175.2' height='176.9'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cdefs%3E %3Crect id='SVGID_13_' x='87.8' y='35.4' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -4.1123 84.1344)' width='23.3' height='23.3'/%3E %3C/defs%3E %3CclipPath id='SVGID_14_'%3E %3Cuse xlink:href='%23SVGID_13_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Cg class='st7'%3E %3Cdefs%3E %3Crect id='SVGID_15_' x='1' y='1' width='198' height='198'/%3E %3C/defs%3E %3CclipPath id='SVGID_16_'%3E %3Cuse xlink:href='%23SVGID_15_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Crect x='52.1' y='-0.4' class='st8' width='94.9' height='94.9'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cdefs%3E %3Crect id='SVGID_17_' x='143.2' y='88.9' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -25.724 138.9515)' width='23.3' height='23.3'/%3E %3C/defs%3E %3CclipPath id='SVGID_18_'%3E %3Cuse xlink:href='%23SVGID_17_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Cg class='st9'%3E %3Cdefs%3E %3Crect id='SVGID_19_' x='1' y='1' width='198' height='198'/%3E %3C/defs%3E %3CclipPath id='SVGID_20_'%3E %3Cuse xlink:href='%23SVGID_19_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Crect x='107.4' y='53.1' class='st10' width='94.9' height='94.9'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cdefs%3E %3Cpolygon id='SVGID_21_' points='117.9,25.9 117.9,35.4 129.9,47.3 99.5,77.6 69.1,47.3 81.1,35.4 81.1,25.9 72.8,25.9 59.9,38.9 59.9,55.7 145.2,141 162.9,141 173.2,130.6 173.2,119.5 166.7,119.5 154,132.1 123.7,101.8 154,71.4 165.2,82.6 173.2,82.6 173.2,73 161.6,61.3 146.5,61.3 114.8,92.9 108.3,86.5 139.1,55.7 139.1,38.9 126.2,25.9 '/%3E %3C/defs%3E %3CclipPath id='SVGID_22_'%3E %3Cuse xlink:href='%23SVGID_21_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Cg class='st11'%3E %3Cdefs%3E %3Crect id='SVGID_23_' x='1' y='1' width='198' height='198'/%3E %3C/defs%3E %3CclipPath id='SVGID_24_'%3E %3Cuse xlink:href='%23SVGID_23_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Crect x='28.9' y='-5' class='st12' width='175.2' height='176.9'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cdefs%3E %3Cpath id='SVGID_25_' d='M100,199c-54.6,0-99-44.4-99-99S45.4,1,100,1s99,44.4,99,99S154.6,199,100,199 M100,6.1 C48.2,6.1,6.1,48.2,6.1,100s42.1,93.9,93.9,93.9c51.8,0,93.9-42.1,93.9-93.9S151.8,6.1,100,6.1'/%3E %3C/defs%3E %3CclipPath id='SVGID_26_'%3E %3Cuse xlink:href='%23SVGID_25_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Cg class='st13'%3E %3Cdefs%3E %3Crect id='SVGID_27_' x='1' y='1' width='198' height='198'/%3E %3C/defs%3E %3CclipPath id='SVGID_28_'%3E %3Cuse xlink:href='%23SVGID_27_' style='overflow:visible;'/%3E %3C/clipPath%3E %3Crect x='-29.9' y='-29.9' class='st14' width='259.9' height='259.9'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 948.4 416.3' style='enable-background:new 0 0 948.4 416.3;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D .st1%7Bfill:%233DD96F;%7D .st2%7Bfill:%2336C565;%7D .st3%7Bfill:%231F375B;%7D .st4%7Bfill:%23162C4D;%7D %3C/style%3E %3Cg%3E %3Cg%3E %3Cpath class='st0' d='M6.7,47.5V27.1H0.4v-9.5h6.5l0.7-11h11.3v11h8.9v9.5h-8.9v19.6c0,4.2,1,5.3,4.5,5.3h4.8v9.8h-9 C10.4,62,6.7,57.7,6.7,47.5z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M35.6,0h12.2v21.2c3-3.1,6.5-4.6,11.1-4.6c8.9,0,13.5,5.4,13.5,16V62H60.2V33.7c0-4.2-1.5-6.2-4.8-6.2 c-3.2,0-5.8,2-7.6,5.9V62H35.6V0z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M81.9,44.2v-8.7c0-12.3,6.6-18.9,19.1-18.9c12.6,0,19.2,6.7,19.2,19v8.1H94v0.8c0,5.8,2.2,8.6,7.5,8.6 c4.1,0,6.5-1.7,6.8-4.8h11.6c-0.5,9.6-6.8,14.6-18.5,14.6C88.5,63,81.9,56.6,81.9,44.2z M108.7,34.9c0-5.9-2.1-8.4-7.3-8.4 s-7.3,2.5-7.3,8.4H108.7z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cg%3E %3Cpath class='st0' d='M104.8,110.8h81.1c58.7,0,84.7,26.9,84.7,85.9v46.2c0,59.3-26,85.9-84.7,85.9h-81.1L104.8,110.8L104.8,110.8 z M179.2,287.8c32.4,0,43.3-11.9,43.3-45.9v-44.2c0-34-10.9-45.9-43.3-45.9h-26.3v136H179.2z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M309.4,255.7V110.8h48.1v143.3c0,27.3,9.3,37.2,34.3,37.2s34.3-9.9,34.3-37.2V110.8h46.5v144.9 c0,53.9-24.4,77-81.4,77C333.7,332.7,309.4,309.6,309.4,255.7z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M519.4,110.8h149.4v41.4H567.5v45.2h85.3v41h-85.3v49.1H672v41.4H519.4V110.8z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M710.9,110.8H759v176h92v42H710.9V110.8z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpolygon class='st1' points='902.3,357.7 902.3,17 948.3,63 948.3,357.7 925.3,381 '/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpolygon class='st2' points='948.3,63 902.3,84 902.3,49.7 '/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpolygon class='st1' points='139.3,63 948.3,63 902.3,17 139.3,17 '/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpolygon class='st3' points='46.4,88.7 46.4,416.3 0.4,370.3 0.4,88.7 '/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpolygon class='st4' points='0.4,370.3 46.4,349.3 46.4,383.5 '/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpolygon class='st3' points='0.4,370.3 891.7,370.3 914.7,393.3 891.7,416.3 46.4,416.3 '/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1334:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 19.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='menu_1_' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='17px' height='17px' viewBox='-951 532 17 17' style='enable-background:new -951 532 17 17;' xml:space='preserve'%3E %3Cg id='menu' fill='%23fff'%3E %3Cpath d='M-936.5,536.003h-12c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h12c0.276,0,0.5-0.224,0.5-0.5 S-936.224,536.003-936.5,536.003z'/%3E %3Cpath d='M-948.5,541.003h7c0.276,0,0.5-0.224,0.5-0.5s-0.224-0.5-0.5-0.5h-7c-0.276,0-0.5,0.224-0.5,0.5 S-948.776,541.003-948.5,541.003z'/%3E %3Cpath d='M-937.5,544.003h-11c-0.276,0-0.5,0.224-0.5,0.5s0.224,0.5,0.5,0.5h11c0.276,0,0.5-0.224,0.5-0.5 S-937.224,544.003-937.5,544.003z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 316.21'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23d9d9d9;%7D.cls-2%7Bfill:%23fff;%7D.cls-3%7Bfill:%23fd0;%7D.cls-4%7Bfill:%23009ee2;%7D.cls-5%7Bfill:%23e20613;%7D.cls-6%7Bfill:%23009540;%7D.cls-7%7Bfill:%233c3c3b;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3Etrending-games%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M511.67,243.27l-20.9-145A98.3,98.3,0,0,0,312,41.89H200A98.3,98.3,0,0,0,21.23,98.31l-20.9,145s-6.19,48.32,34.84,65.58a72.19,72.19,0,0,0,31.07,7.36c14.19,0,30.9-4.88,44.79-22.61l65.8-86.34s6.95-15.47,29.42-15.47h99.5c22.46,0,29.42,15.47,29.42,15.47L401,293.6c13.89,17.73,30.6,22.61,44.79,22.61a72.19,72.19,0,0,0,31.07-7.36C517.86,291.59,511.67,243.27,511.67,243.27Z'/%3E%3Cpath class='cls-2' d='M200.8,102.33a81.26,81.26,0,1,1-81.25-81.26A81.25,81.25,0,0,1,200.8,102.33Z'/%3E%3Cpath class='cls-2' d='M473.71,102.33a81.26,81.26,0,1,1-81.26-81.26A81.26,81.26,0,0,1,473.71,102.33Z'/%3E%3Cpath class='cls-3' d='M412.55,59.44a20.1,20.1,0,1,1-20.1-20.11A20.09,20.09,0,0,1,412.55,59.44Z'/%3E%3Cpath class='cls-4' d='M369.66,102.33a20.1,20.1,0,1,1-20.1-20.1A20.1,20.1,0,0,1,369.66,102.33Z'/%3E%3Cpath class='cls-5' d='M455.44,102.33a20.1,20.1,0,1,1-20.09-20.1A20.09,20.09,0,0,1,455.44,102.33Z'/%3E%3Cpath class='cls-6' d='M412.55,145.22a20.1,20.1,0,1,1-20.1-20.1A20.09,20.09,0,0,1,412.55,145.22Z'/%3E%3Cpath class='cls-7' d='M148.17,84.31H137.56V73.7A17.16,17.16,0,0,0,120.4,56.54h-1.72A17.15,17.15,0,0,0,101.53,73.7V84.31H90.91a17.16,17.16,0,0,0-17.16,17.16v1.72a17.16,17.16,0,0,0,17.16,17.15h10.62V131a17.16,17.16,0,0,0,17.15,17.16h1.72A17.17,17.17,0,0,0,137.56,131V120.34h10.61a17.15,17.15,0,0,0,17.16-17.15v-1.72A17.16,17.16,0,0,0,148.17,84.31Z'/%3E%3Crect class='cls-7' x='219.37' y='94.86' width='26.61' height='22.32' rx='1.72'/%3E%3Crect class='cls-7' x='267.01' y='94.86' width='26.61' height='22.32' rx='1.72'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"

/***/ }),

/***/ 1336:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "women-football.embedded.svg?e5da721e2a23ab43080e19c419047f67";

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23fff;%7D.cls-2%7Bfill:%23ffb518;%7D.cls-3%7Bfill:%23ffcc18;%7D.cls-4%7Bfill:%23ffa818;%7D.cls-5%7Bfill:%23008846;%7D.cls-6%7Bfill:%2300bf41;%7D.cls-7%7Bfill:%23ffe418;%7D.cls-8%7Bfill:%23ffd118;%7D.cls-9%7Bfill:%23ffe818;%7D.cls-10%7Bfill:%23ff9218;%7D.cls-11%7Bfill:%23ffff18;%7D%3C/style%3E%3C/defs%3E%3Ctitle%3EAsset 2%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='BACKGROUND_1' data-name='BACKGROUND 1'%3E%3Cpath class='cls-1' d='M256,504.5A248.51,248.51,0,0,1,80.28,80.28,248.51,248.51,0,0,1,431.72,431.72,246.9,246.9,0,0,1,256,504.5Z'/%3E%3Cpath class='cls-2' d='M256,15a241.07,241.07,0,0,1,93.8,463.07A241.07,241.07,0,0,1,162.2,33.93,239.51,239.51,0,0,1,256,15m0-15C114.62,0,0,114.62,0,256S114.62,512,256,512,512,397.38,512,256,397.38,0,256,0Z'/%3E%3Ccircle class='cls-3' cx='254.49' cy='136.08' r='72.08' transform='translate(-21.69 219.81) rotate(-45)'/%3E%3Cpath class='cls-4' d='M326.43,131.63c-.05-.78-.11-1.55-.18-2.33l-.12-1.18c-.08-.76-.18-1.52-.29-2.27l-.15-1.06c-.16-1-.34-2-.55-3.05l-.06-.32c-.21-1-.45-2-.7-3-.09-.37-.2-.74-.29-1.11-.19-.68-.38-1.36-.58-2-.13-.41-.25-.82-.38-1.23-.21-.64-.43-1.28-.65-1.91-.14-.39-.27-.79-.42-1.18-.28-.76-.58-1.51-.89-2.26-.18-.44-.37-.89-.56-1.33-.32-.72-.63-1.43-1-2.13-.21-.44-.43-.88-.65-1.31s-.5-1-.76-1.5-.5-.93-.76-1.39-.51-.89-.77-1.33-.55-1-.84-1.42-.5-.79-.76-1.18c-.61-1-1.25-1.89-1.91-2.82-.2-.28-.4-.58-.61-.86-.39-.53-.79-1-1.19-1.55l-.67-.87c-.42-.52-.85-1-1.28-1.54l-.63-.72c-.47-.54-.94-1.08-1.43-1.6l-.18-.2a72.66,72.66,0,0,0-5.59-5.37l-.37-.33-1.88-1.55a3.92,3.92,0,0,1-.32-.25,73,73,0,0,0-9-6l-.06,0c-.79-.45-1.59-.88-2.4-1.3l-.07,0a71.53,71.53,0,0,0-10.31-4.34h0l-6.41,2.91.94,8.63L275,78l3.1,2,4.58-.76-.43,4.83-3.09,6.83-6.49,3.42s3.18,6.33,6.54,5.63,6.12-4.17,6.12-4.17l.16-4.16,4.56,2.13,2.8-1.41,1.73,3.35,2.89,1,4.58-.75,1.84,1.88,4.45,2.56,1.73,3.35-6,.65-7.39-3.8L281.1,102l-7.65,5.73-9.67,8.83,5,9-2.48,9.79s10.22,10.41,20.24,8.1,10.74-.82,10.74-.82l3.15-1.69.74,3.55.09,9.25,3.27,6.73L302.17,167l4.46,11.42-3,8.25,1,1.2a72.64,72.64,0,0,0,9.12-10.74v0c.66-1,1.29-1.91,1.9-2.89l.06-.09c.59-.95,1.16-1.91,1.71-2.89,0-.06.07-.12.1-.19.53-.94,1-1.91,1.52-2.88,0-.1.1-.19.14-.29.46-.93.9-1.89,1.32-2.85.06-.13.13-.27.19-.41.4-.92.77-1.86,1.13-2.8l.21-.54c.34-.9.65-1.82.95-2.74.07-.22.16-.44.23-.67.28-.88.53-1.77.77-2.66.08-.28.16-.55.23-.83.23-.85.42-1.72.61-2.58.08-.32.16-.64.23-1,.17-.84.31-1.69.46-2.54.06-.35.14-.71.19-1.07.13-.83.23-1.68.33-2.52,0-.38.1-.76.14-1.14.09-.88.15-1.78.21-2.67,0-.35.06-.69.08-1,.06-1.25.1-2.5.1-3.76s0-2.26-.09-3.39Z'/%3E%3Cpath class='cls-4' d='M249.1,64.22a71.73,71.73,0,0,0-33.45,11.15l0,0a72.5,72.5,0,0,0-13.35,11l0,0a72.08,72.08,0,0,0-14.73,23l7.75,2.62,3.41,1.55,2.62-3.23-2.71-9.93,3.47-5.05,5.65-8.4,24.06-5.06,4.73-4.9,4.63-3.45L247.6,71l1.5-6.73Z'/%3E%3Cpath class='cls-4' d='M219.32,198l6.46-5.48,4.89-14,7.46-4.66s2.61-4.25,2.74-11.48c0,0,4.5-4,3.42-9.17L232.08,149l-4-5.14-2.17-4.48-12.17-3-3.31-3L204,133l-2.43-1.75,2.12-1.68-2.76.58-2.43,2.16-2.08,1.87-4.46.32-4.84-1.45-1.82-8.68,2.48-4.84-1.74-4.37-.6.12h0c-.65,2.16-1.2,4.37-1.65,6.61l-.06.29c-.2,1-.38,2.06-.54,3.1,0,.3-.07.6-.11.9-.12.86-.24,1.72-.33,2.59h0a3.21,3.21,0,0,1,.86,1.29l2.77,4.36,5.61,5.11-2.78,8.33L188,153.7A18.93,18.93,0,0,0,200.25,168l1,4.73a3.54,3.54,0,0,0,3.19,2.42L204,186.59a9.06,9.06,0,0,0,.12,1h0q1.62,1.59,3.35,3.07l.25.22a72.64,72.64,0,0,0,7.45,5.58l0,0c1.32.86,2.66,1.67,4,2.44h0Z'/%3E%3Cellipse class='cls-2' cx='258.31' cy='416.78' rx='61.45' ry='26.56'/%3E%3Cpath class='cls-5' d='M315.41,410.82l-.06-.24a11.6,11.6,0,0,0-.59-2.83l-3.38-16.07-13.42,2c-10.27-4.29-24.24-6.93-39.65-6.93-15.94,0-30.34,2.83-40.7,7.38l-12.74-.69-3.66,16.29.13.1a12.18,12.18,0,0,0-.13,1.6c0,13.63,25.57,24.67,57.1,24.67s57.1-11,57.1-24.67c0-.21,0-.42,0-.63Z'/%3E%3Cellipse class='cls-6' cx='258.31' cy='394.37' rx='53.44' ry='23.09'/%3E%3Cpath class='cls-7' d='M307.38,386.22,301.75,373l-11.4,2.91a104.47,104.47,0,0,0-32-4.65,106.11,106.11,0,0,0-30.46,4.15l-12.42-4.15L209,386.56a10.26,10.26,0,0,0-2.08,6c0,11.75,23,21.27,51.38,21.27s51.38-9.52,51.38-21.27A10.48,10.48,0,0,0,307.38,386.22Z'/%3E%3Cpath class='cls-5' d='M303.7,370.12h0l0,0c-.16-.31-.33-.63-.52-.94l-1.71-3.07-.72.11c-7.22-7-23.49-11.93-42.42-11.93-18.11,0-33.78,4.49-41.43,11l-1.41-.14-2.22,4.37c-.18.32-.35.65-.5,1l-.06.13v0a9.38,9.38,0,0,0-.79,3.69c0,11.08,20.78,20.06,46.41,20.06s46.41-9,46.41-20.06A9.35,9.35,0,0,0,303.7,370.12Z'/%3E%3Cellipse class='cls-6' cx='258.31' cy='368.53' rx='43.44' ry='19.06'/%3E%3Cpath class='cls-2' d='M323.39,150.69c-4.1,13.37-14.57,25.18-27.57,30.47-9.93,4-24.73,3.35-31.86-20.26-2.45.16-.79,8.78-3.24,8.61-.76.07-1.66.15-2.49.28-2.26,8.09-9.69,15-16.05,20a40.47,40.47,0,0,1-24.1,8.9c-8.33.26-16.91-1.41-22.51-8a47.85,47.85,0,0,1-7.74-11.82l-1.27,1.33s34.63,78.67,41.37,107.16c6.54,27.69.56,61.86-8.84,76.67a9.51,9.51,0,0,0-.75,1.12l-.08.12h0a7.31,7.31,0,0,0-1,3.52c0,9,18.36,16.3,41,16.3s41-7.29,41-16.3a7.32,7.32,0,0,0-1-3.6h0l-.19-.3-.11-.2c-1.95-3.26-12.81-22.56-12-46.83.86-26.67,16.34-81.43,16.34-81.43s21.79-62.31,21.79-62.12,3.06-17.15,3.06-17.15Z'/%3E%3Cpath class='cls-8' d='M194.19,190.71c5.4,6.34,13.57,8.12,21.6,8-7.58-.11-15.13-2-20.22-8a47.85,47.85,0,0,1-7.74-11.82l-.93,1A50.15,50.15,0,0,0,194.19,190.71Z'/%3E%3Cpath class='cls-8' d='M286,183c-8.24-.26-17-5.52-22.06-22.12-.5,0-.82.43-1,1C268.26,178.61,277.57,183.31,286,183Z'/%3E%3Cpath class='cls-8' d='M297.51,181.16c12.4-5,22.49-16,26.95-28.63l-1.07-1.84c-4.1,13.37-14.57,25.18-27.57,30.47a25.12,25.12,0,0,1-8.23,1.86A24.23,24.23,0,0,0,297.51,181.16Z'/%3E%3Cpath class='cls-8' d='M219.77,198.7a40.45,40.45,0,0,0,24.1-8.9c6.36-5,13.79-11.92,16.06-20,.82-.13,1.73-.21,2.48-.28,1.82.13,1.38-4.6,2-7.1-.16-.5-.33-1-.48-1.51-2.45.16-.79,8.78-3.24,8.61-.76.07-1.66.15-2.49.28-2.26,8.09-9.69,15-16.05,20a40.47,40.47,0,0,1-24.1,8.9h-.76C218.14,198.73,219,198.73,219.77,198.7Z'/%3E%3Cpath class='cls-9' d='M257.16,169.36s-2.5,18-26.21,24.67c-27.57,7.75-49.35-31.36-48.54-59.74a2.1,2.1,0,0,0-1.63,1s-5.33,36.27,15.15,60.7,50.35,9.89,61.25-20.83l3.51-3.43Z'/%3E%3Cpath class='cls-10' d='M257.05,168.68s-2.56,17.65-26.29,24.19c-27.6,7.61-49.25-30.75-48.35-58.58a2.14,2.14,0,0,0-1.64.94s-5.44,35.57,15,59.52,50.31,9.7,61.32-20.42l3.52-3.36Z'/%3E%3Cpath class='cls-9' d='M263.9,161.52s4.42,26.89,23,29.86,36.36-20.5,40.25-47.2l-.5-6.1s-7.2,35.48-31.13,43.37C271.36,189.42,263.9,161.52,263.9,161.52Z'/%3E%3Cpath class='cls-10' d='M264,160.9S268.45,187.09,287,190s36.3-20,40.13-46l-.52-5.94s-7.11,34.55-31,42.23C271.49,188.07,264,160.9,264,160.9Z'/%3E%3Cpath class='cls-10' d='M324.57,138.08s-.41,45.74-26,76.19c-3.45,23,10.62,14.93,10.62,14.93l7.47-26.14,7.88-21.54,5.05-30'/%3E%3Cpath class='cls-10' d='M245.14,156.29a58.56,58.56,0,0,0,9.35,21.14s16.2,59,0,115.85-37.19,75.9-37.19,75.9,20.42-12.4,33.76-37.92S277.15,249,277.15,249l-9-58.63-9.5-24.93-4.17-9.13Z'/%3E%3Cpath class='cls-10' d='M268.22,317.79s-10.55,35.14-48.13,56.95c26-8.57,48.13-28.47,48.13-28.47l8.93-17.2L284.81,307V294.18l-5.73-2.31'/%3E%3Cpath class='cls-9' d='M217.3,369.18s37.81-37.67,49.35-90.49c11.86-54.26-9.6-104.36-9.6-104.36s-7.78-9.29-11.91-18a3.08,3.08,0,0,1,1.18-3.92l3.13-2a3.54,3.54,0,0,1,4.2.35l5.64,4.95-.14-1.66a1.64,1.64,0,0,1,1.25-1.74h0a1.63,1.63,0,0,1,1.94,1.07,35.42,35.42,0,0,1,1.37,16.73s10.88,47.67,23.87,54l.09-9.14s-5-4.89-5.26-9.57,2.41-13,11.76-12.57,10.21,11.2,10.21,11.2l1.19,8.65a2.68,2.68,0,0,1-1.15,2.59l-1.83,1.22-.66,6.95s10.38-9.44,18.33-43.35c7.1-30.24,4.71-37.62,4.31-42h2s0-5.66-.41-9.71l2.92,4.91a19.63,19.63,0,0,1,2.8,9.92c0,.4,0,.79,0,1.16a68.61,68.61,0,0,1-.66,11.09c-.74,5-4.32,39.16-16.61,70.3s-16.87,43.76-21.48,71.91c-4.54,27.69-3.4,53.75-71,78.81l-2-1.73s38.74-22.48,51.43-45.31c9.54-17.16,9.11-30.91,9.11-30.91s-21.88,40.37-62.78,73Z'/%3E%3Cpath class='cls-11' d='M252.91,150.77l5.64,4.95-.06-.7-4.84-4.25a3.51,3.51,0,0,0-2.7-.85A3.43,3.43,0,0,1,252.91,150.77Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"

/***/ }),

/***/ 1338:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 23.0.6, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 16 16' style='enable-background:new 0 0 16 16;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%2301AEEA;%7D .st1%7Bfill:%23FBFDFE;%7D %3C/style%3E %3Cpath class='st0' d='M13.3,0.4C15.1,1,16.2,2.1,16,4.1c-0.3,2.7-0.7,5.4-1.7,8c-0.6,1.6-1.8,2.7-3.4,3.2c-2.6,0.9-5.3,0.9-7.9,0.3 c-2.2-0.5-3.2-2-2.9-4.2C0.4,9.3,0.9,7.1,1.4,5c0.6-2.3,2-4,4.5-4.6C5.9,0.4,10.5-0.5,13.3,0.4z'/%3E %3Cpath class='st1' d='M4.5,12.1c0.6-3,1.1-5.6,1.7-8.5c2.2,1.4,4.2,2.7,6.6,4.2C10,9.2,7.4,10.6,4.5,12.1z'/%3E %3C/svg%3E"

/***/ }),

/***/ 1350:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./betting_icon.embedded.svg": 1301,
	"./boxing_icon.embedded.svg": 1302,
	"./champions_league.embedded.svg": 1303,
	"./conmebol_icon.embedded.svg": 1304,
	"./csgo_icon.embedded.svg": 1305,
	"./dfs_icon.embedded.svg": 1306,
	"./dota2_icon.embedded.svg": 1307,
	"./dr_pepper.embedded.svg": 1308,
	"./dreamhack_icon.embedded.svg": 1309,
	"./esl_icon.embedded.svg": 1310,
	"./fifa.embedded.svg": 1311,
	"./fnatic_icon.embedded.svg": 1312,
	"./fortnite.embedded.svg": 1313,
	"./i_league_icon.embedded.svg": 1314,
	"./league-of-legends.embedded.svg": 1315,
	"./logo-12up.embedded.svg": 542,
	"./logo-90min.embedded.svg": 543,
	"./logo-dbltap.embedded.svg": 544,
	"./logo-ei.embedded.svg": 545,
	"./logo-floor8.embedded.svg": 546,
	"./logo-ftb90.embedded.svg": 547,
	"./logo-german_site.embedded.svg": 548,
	"./logo-ht_media.embedded.svg": 549,
	"./logo-pluralist.embedded.svg": 550,
	"./logo-theduel-mobile.embedded.svg": 551,
	"./logo-theduel.embedded.svg": 552,
	"./lol_icon.embedded.svg": 1316,
	"./mdl_icon.embedded.svg": 1317,
	"./melee_icon.embedded.svg": 1318,
	"./mlb_icon.embedded.svg": 1319,
	"./mls_icon.embedded.svg": 1320,
	"./mma_icon.embedded.svg": 1321,
	"./nba_icon.embedded.svg": 1322,
	"./ncaa-basketball_icon.embedded.svg": 1323,
	"./ncaa-football_icon.embedded.svg": 1324,
	"./nfl_icon.embedded.svg": 1325,
	"./nhl_icon.embedded.svg": 1326,
	"./overwatch.embedded.svg": 1327,
	"./overwatch_icon.embedded.svg": 1328,
	"./powered-by-ei.embedded.svg": 553,
	"./powered-by-german_site.embedded.svg": 554,
	"./powered-by-ht_media.embedded.svg": 555,
	"./pubg.embedded.svg": 1329,
	"./smash4_icon.embedded.svg": 1330,
	"./streetfighter_icon.embedded.svg": 1331,
	"./suzuki_cup.embedded.svg": 1332,
	"./theduel-nav.embedded.svg": 1333,
	"./theduel_menu_icon.embedded.svg": 1334,
	"./trending-games.embedded.svg": 1335,
	"./women-football.embedded.svg": 1336,
	"./world-cup.embedded.svg": 1337,
	"./yousport_icon.embedded.svg": 1338
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1350;

/***/ }),

/***/ 1351:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./ei_transfers_icon.svg": 1122,
	"./mainNavigationChevron_icon.svg": 1123,
	"./schedule_icon.svg": 1124,
	"./sports-news_icon.svg": 1125,
	"./sports_icon.svg": 1126,
	"./table_icon.svg": 1127,
	"./transfers_icon.svg": 1128,
	"./worldnews_icon.svg": 1129
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1351;

/***/ }),

/***/ 1352:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./download_appstore_en.svg": 1118,
	"./download_appstore_pr.svg": 1119
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1352;

/***/ }),

/***/ 1353:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./download_googleplay_en.svg": 1120,
	"./download_googleplay_pr.svg": 1121
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1353;

/***/ }),

/***/ 1354:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./logo-12up.embedded.svg": 542,
	"./logo-90min.embedded.svg": 543,
	"./logo-dbltap.embedded.svg": 544,
	"./logo-ei.embedded.svg": 545,
	"./logo-floor8.embedded.svg": 546,
	"./logo-ftb90.embedded.svg": 547,
	"./logo-german_site.embedded.svg": 548,
	"./logo-ht_media.embedded.svg": 549,
	"./logo-pluralist.embedded.svg": 550,
	"./logo-theduel-mobile.embedded.svg": 551,
	"./logo-theduel.embedded.svg": 552
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1354;

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./powered-by-ei.embedded.svg": 553,
	"./powered-by-german_site.embedded.svg": 554,
	"./powered-by-ht_media.embedded.svg": 555
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1355;

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackUserIdentifier = trackUserIdentifier;

var _pageDataObject = __webpack_require__(5);

function getCookie(name) {
  var re = new RegExp(name + '=([^;]+)');
  var value = re.exec(document.cookie);
  return value !== null ? unescape(value[1]) : null;
}

function trackUserIdentifier() {
  var identifierFromStorege = localStorage.getItem('mmUserIdentifier') || Math.floor(Math.random() * 100);
  localStorage.setItem('mmUserIdentifier', identifierFromStorege);
  return identifierFromStorege;
}

/***/ }),

/***/ 1391:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nm-icons_a5c3af4ab1afe6fc8cb75d6b74c7c039.svg?991bb81dcfdd8bfd143fbed9b801c1bd";

/***/ }),

/***/ 1393:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nm-icons_a5c3af4ab1afe6fc8cb75d6b74c7c039.eot?658c5886bd51ce4c2fd76a3e105dc2c8";

/***/ }),

/***/ 1394:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "nm-icons_a5c3af4ab1afe6fc8cb75d6b74c7c039.ttf?543ea35954e33026b1dedfc74141a460";

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.socialButtonsAction = exports.TYPES = undefined;
exports.openEmbed = openEmbed;
exports.closeEmbed = closeEmbed;

var _object = __webpack_require__(13);

var _AppDispatcher = __webpack_require__(56);

var CLASS_CONSTATNTS = (0, _object.namespacedConsts)({
  SOCIAL_BUTTONS: {
    ACTIONS: {
      EMBED_OPEN: true,
      EMBED_CLOSE: true
    }
  }
});

var TYPES = exports.TYPES = CLASS_CONSTATNTS.SOCIAL_BUTTONS.ACTIONS;

function openEmbed(caller, position, title, e) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.EMBED_OPEN,
    dispatchToRedux: true
  });
}

function closeEmbed(caller, e) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.EMBED_CLOSE
  });
}

var socialButtonsAction = exports.socialButtonsAction = { openEmbed: openEmbed, closeEmbed: closeEmbed };

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCountryCodeUnitedStates = undefined;

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _pageDataObject = __webpack_require__(5);

var _dom = __webpack_require__(12);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _ua = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adsConfig = (0, _pageDataObject.get)('config.ads', __webpack_require__(27));
var APS_PUBLISHER_ID = '3777';
var US_COUNTRY_CODE = 'US';

var isCountryCodeUnitedStates = exports.isCountryCodeUnitedStates = function isCountryCodeUnitedStates(countryCode) {
  return countryCode === US_COUNTRY_CODE;
};

var getDimensionsArray = function getDimensionsArray(dimensions) {
  var res = dimensions[(0, _keys2.default)(dimensions)[0]];
  if ((0, _ua.getIsDesktop)() && dimensions.desktop) {
    res = dimensions.desktop;
  } else if ((0, _ua.getIsMobile)() && dimensions.mobile) {
    res = dimensions.mobile;
  } else if ((0, _ua.getIsTablet)() && dimensions.landscapeTablet) {
    res = dimensions.landscapeTablet;
  } else if ((0, _ua.getIsTabletInPortrait)() && dimensions.portraitTablet) {
    res = dimensions.portraitTablet;
  }
  return res.map(function (x) {
    return [x.width, x.height];
  });
};

var initAmazonHeaderBidder = function initAmazonHeaderBidder() {
  var adElements = (0, _dom.nodes)(_preRenderedSelectorsConfig.SELECTORS.AD);

  var _getFromPdo = (0, _pageDataObject.get)('page', null),
      ads_conf = _getFromPdo.ads_conf;

  var adIds = [].concat((0, _toConsumableArray3.default)(adElements)).map(function (element) {
    return element.dataset.slotId;
  }).filter(function (id) {
    return adsConfig.slot[id];
  });
  var slotConfigs = adIds.map(function (id) {
    return { id: id, config: adsConfig.slot[id] };
  });
  var slots = slotConfigs.map(function (entry) {
    return {
      slotID: entry.config.doubleClick.slotDivId,
      slotName: ads_conf.ad_unit_path_prefix + '/' + entry.id,
      sizes: getDimensionsArray(entry.config.doubleClick.dimensions)
    };
  });

  !function (a9, a, p, s, t, A, g) {
    if (a[a9]) {
      return;
    }

    function q(c, r) {
      a[a9]._Q.push([c, r]);
    }

    a[a9] = {
      init: function init() {
        q('i', arguments);
      },
      fetchBids: function fetchBids() {
        q('f', arguments);
      },
      setDisplayBids: function setDisplayBids() {},
      targetingKeys: function targetingKeys() {
        return [];
      },
      _Q: []
    };
    A = p.createElement(s);
    A.async = !0;
    A.src = t;
    g = p.getElementsByTagName(s)[0];
    g.parentNode.insertBefore(A, g);
  }('apstag', window, document, 'script', '//c.amazon-adsystem.com/aax2/apstag.js');

  // initialize apstag and have apstag set bids on the googletag slots when they are returned to the page
  apstag.init({
    pubID: APS_PUBLISHER_ID,
    adServer: 'googletag',
    videoAdServer: 'DFP',
    bidTimeout: 2e3
  });

  // request the bids for the googletag slots
  apstag.fetchBids({
    slots: slots
  }, function (bids) {
    // set apstag bids, then trigger the first request to DFP
    googletag.cmd.push(function () {
      apstag.setDisplayBids();
      googletag.pubads().refresh();
    });
  });
};

exports.default = initAmazonHeaderBidder;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identity = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _defineEnumerableProperties2 = __webpack_require__(829);

var _defineEnumerableProperties3 = _interopRequireDefault(_defineEnumerableProperties2);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.deserializeQueryString = deserializeQueryString;
exports.noop = noop;
exports.makeSafeFn = makeSafeFn;
exports.areAllFunctions = areAllFunctions;
exports.once = once;
exports.allTrue = allTrue;
exports.memoizeFirstCall = memoizeFirstCall;
exports.throwIfMissingArgument = throwIfMissingArgument;
exports.isFunction = isFunction;

var _console = __webpack_require__(11);

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// FIXME START: deduplicate this by resolving the circular dependency and replace with "import { queryString, } from 'utils/window';"
function dashDelimitedToCamelCase(string) {
  return string.replace(/-([a-z])/g, function (group) {
    return group[1].toUpperCase();
  });
}
function decode(s) {
  var plus = /\+/g; //Regex for replacing addition symbol with a space
  return decodeURIComponent(s.replace(plus, ' '));
}
function deserializeQueryString() {
  var inputQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.search;
  var queryStringObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var search = /([^&=]+)=?([^&]*)/g;
  var query = inputQuery.substring(1);
  var matches = search.exec(query);
  while (matches) {
    var _matches = matches,
        _matches2 = (0, _slicedToArray3.default)(_matches, 3),
        fullKey = _matches2[0],
        onlyKey = _matches2[1],
        rawValue = _matches2[2];

    var isOnlyKey = fullKey === onlyKey;
    var value = isOnlyKey ? true : decode(rawValue);
    var key = dashDelimitedToCamelCase(onlyKey);
    queryStringObj[key] = value;
    matches = search.exec(query);
  }
  return queryStringObj;
}
var queryString = deserializeQueryString();
// FIXME END

var debugUnsafeFn = queryString.debugUnsafeFn;
function noop() {}

function makeSafeFn() {
  var unsafeFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
  var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { isMute: false };

  var unsafeFnName = unsafeFn.name;
  function safeFnWrapper() {
    // eslint-disable-line consistent-return
    var args = arguments;
    if ([unsafeFnName, true].includes(debugUnsafeFn)) {
      return unsafeFn.apply(this, args);
    }
    try {
      return unsafeFn.apply(this, args);
    } catch (ex) {
      if (!opt.isMute) {
        (0, _console.warn)('makeSafeFn: failed to invoke \'' + (unsafeFnName || unsafeFn) + '\'', {
          unsafeFn: unsafeFn,
          args: args,
          exception: ex
        }, '\n' + ex.stack);
      }
    }
  }
  safeFnWrapper.invoke = function callWithNullBinding() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return safeFnWrapper.call.apply(safeFnWrapper, [null].concat(args));
  };
  return safeFnWrapper;
}

function areAllFunctions() {
  for (var _len2 = arguments.length, possiblyFunctions = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    possiblyFunctions[_key2] = arguments[_key2];
  }

  return !possiblyFunctions.some(makeSafeFn(function (possiblyFn) {
    return !(possiblyFn instanceof Function);
  }));
}

function once(fn) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  var result; // has to be var to avoid DMZ!
  var originalFn = fn;
  var onceRunner = function onceRunner() {
    if (fn && fn instanceof Function) {
      result = fn.apply(undefined, args);
      fn = null; // eslint-disable-line no-param-reassign
    }
    return result;
  };
  onceRunner.reset = function enableRunningOnceAgain() {
    fn = originalFn; // eslint-disable-line no-param-reassign
    return onceRunner;
  };
  return onceRunner;
}

function allTrue() {
  for (var _len4 = arguments.length, predicates = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    predicates[_key4] = arguments[_key4];
  }

  return predicates.reduce(function (prev, current) {
    return prev && current;
  });
}

function memoizeFirstCall(getterName, fn) {
  for (var _len5 = arguments.length, args = Array(_len5 > 2 ? _len5 - 2 : 0), _key5 = 2; _key5 < _len5; _key5++) {
    args[_key5 - 2] = arguments[_key5];
  }

  var _ref, _mutatorMap;

  var memoizedObj = null;
  return _ref = {}, _mutatorMap = {}, _mutatorMap[getterName] = _mutatorMap[getterName] || {}, _mutatorMap[getterName].get = function () {
    memoizedObj = memoizedObj || fn.apply(null, args);
    return memoizedObj;
  }, (0, _defineEnumerableProperties3.default)(_ref, _mutatorMap), _ref;
}
var identity = exports.identity = function identity(it) {
  return it;
};

function throwIfMissingArgument() {
  var missingArgumentMessage = 'Missing argument!';
  (0, _console.error)(missingArgumentMessage, this);
  throw new Error(missingArgumentMessage);
}

var fn = (0, _assign2.default)((0, _object.create)(), {
  noop: noop,
  once: once,
  allTrue: allTrue,
  makeSafeFn: makeSafeFn,
  areAllFunctions: areAllFunctions,
  memoizeFirstCall: memoizeFirstCall,
  identity: identity,
  throwIfMissingArgument: throwIfMissingArgument
});

function isFunction(functionToCheck) {
  return typeof functionToCheck === 'function';
}

(0, _nm.registerUtils)({ fn: fn });

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_HOST = undefined;

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.fetchCounters = fetchCounters;
exports.fetchCountersIndependent = fetchCountersIndependent;
exports.getActionProviderHosts = getActionProviderHosts;

var _fetch = __webpack_require__(58);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTION_COUNTER_PDO_BASE_KEY = 'config.action_counter';
var NO_HOST = exports.NO_HOST = null;

var actionProviderHosts = null;

var fetchPromise = null;

function getFetchUrlByKeys(keys) {
  var hosts = getActionProviderHosts();
  var baseUrl = hosts.READER_ACTION_PROVIDER;

  var serializedKeys = keys.map(function (k) {
    return 'key=' + k + '&';
  }).join('');
  return '//' + baseUrl + '/get?' + serializedKeys;
}

function fetchCounters(keys) {
  var url = getFetchUrlByKeys(keys);
  return fetchPromise = fetchPromise || (0, _fetch.getJsonOrError)(url);
}

//Fetch without dependency for other promises to be resolved (see: 'fetchCounters' above)
function fetchCountersIndependent(key) {
  var url = getFetchUrlByKeys([key]);
  return (0, _fetch.getJsonOrError)(url);
}

function getActionProviderHosts() {
  if (actionProviderHosts) {
    return actionProviderHosts;
  }

  var _map = ['host', 'slave'].map(function (i) {
    return (0, _pageDataObject.get)(ACTION_COUNTER_PDO_BASE_KEY + '.' + i);
  }, NO_HOST),
      _map2 = (0, _slicedToArray3.default)(_map, 2),
      WRITER_ACTION_PROVIDER = _map2[0],
      READER_ACTION_PROVIDER = _map2[1];

  actionProviderHosts = { READER_ACTION_PROVIDER: READER_ACTION_PROVIDER, WRITER_ACTION_PROVIDER: WRITER_ACTION_PROVIDER };
  return actionProviderHosts;
}

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOUNT_POINTS = exports.SCROLL_EVENTS_SELECTORS = exports.SELECTORS = undefined;

var _taggedTemplateLiteral2 = __webpack_require__(831);

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['.title'], ['.title']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['.body-start'], ['.body-start']),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(['.share-buttons-bottom'], ['.share-buttons-bottom']),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(['.top-posts'], ['.top-posts']),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(['.taboola'], ['.taboola']),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(['.page-end'], ['.page-end']);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
/**
 * The idea is that this file should be generated at deploy time and
 * statically delivered to the client. We're not there yet, so it is
 * hard-coded :(
 */
var SELECTORS = exports.SELECTORS = {
  NAVBAR_SOCIAL_COMPONENT: '.header-post-actions',
  SHARE_COMPONENT: '.share-component',
  SHARE_COVER_COMPONENT: '.share-component--post-cover',
  BOTTOM_SOCIAL_ICONS: '.bottom-social',
  SEARCH_COMPONENT: '.search-comp',
  MONTI_BODY: '.Jwplayer-container',
  USER_MENU_DROPDOWN: '.user-menu.has-dropdown',
  POST_METADATA_STATS: '.post-metadata__stats',
  COMMUNITY_DISCLAIMER: '.community-disclaimer',
  SITE_HEADER: '#site-header',
  NAVIGATION: '.mobile-nav-main-wrapper',
  SLIDE: '.slide',
  SLIDE_CONTAINER: '.slideshow__slide',
  POST_BODY_SELECTOR: '.post-body',
  POST_BODY_WRAP_SELECTOR: '.post-body-wrap',
  POST_CONTENT_SELECTOR: '.post-content',
  SOCIAL_BAR__COVER: '.social-bar--cover',
  SOCIAL_BAR__HEADER: '.social-bar--header',
  SOCIAL_BAR__DETAILS: '.social-bar--details',
  SOCIAL_BAR__BOTTOM: '.social-bar--bottom',
  SLIDESHOW_POST_METADATA: '.post-metadata',
  PLAYBYZZ_CONTAINER: '.pb_feed',
  SCRIBBLELIVE_CONTAINER: '.scrbbl-embed[data-src]',
  POST_COVER: '.post-cover',
  MAIN_SIDENAV: '.main-sidenav',
  MAIN_SIDENAV_TOGGLE: '.main-sidenav-toggle',
  MAIN_SIDENAV_CHECKBOX: '#main-sidenav-checkbox',
  EDITION_DROPDOWN: '.edition-component__dropdown',
  EDITION_COMPONENT: '.edition-component',
  PAGE_WRAP: '.page-wrap',
  HEADER_AD_UNIT: '.ad[data-slot-id="Top"]',
  MODAL: '#root-dialog',
  MODAL__MOUNT_POINT: '.modal__mount-point',
  MODAL__CLOSE_BUTTON: '.modal__close',
  POST_AFTER: '.post-after',
  TOP_POSTS_AFTER_POST: '.top-posts-after-post',
  SECTION_TITLE_TOP_POSTS_AFTER_POST: '.section-title--top-posts-after-post',
  TOP_POSTS_SIDE_BAR: '.top-posts-side-bar',
  SECTION_TITLE_TOP_POSTS_SIDE_BAR: '.section-title--top-posts-side-bar',
  TOP_POSTS_AFTER_POST_ITEM_IMAGE_CONTAINER: '.top-posts-after-post__item__image-container',
  TOP_POSTS_SIDE_BAR_ITEM_IMAGE_CONTAINER: '.top-posts-side-bar__item__image-container',
  NEWSCORP_EMBED_CONTAINER: '.newscorp-container',
  AD: '.ad',
  TABOOLA_WIDGET_CONTAINER: '.nm-taboola-widget',
  POST_ARTICLE_TITLE: '.post-article__post-title',
  SCHEDULE: '.schedule-component',
  SCHEDULE_IN_FIXTURES_PAGE: '.schedule-component--scores',
  LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE: '.league-selection-scores',
  TV_SCHEDULE_CHANNEL_SELECTION: '.tv-schedule__channel-selection',
  TV_SCHEDULE_CHANNEL: '.tv-schedule__channel-schedule',
  FANVOICE_CONTAINER: '.fanvoice',
  YAHOO_FANTASY: '.fantasy-mount-point',
  FACEBOOK_BOT: '.facebook-bot-mount-point',
  FRESH8_MOUNT_POINT: '.fresh8-mount',
  FRESH8_FLOATING: '.fresh8-floating-container',
  SCORES_TABLE: '.scores-table',
  WRITERS_ARTICLE_BUTTON: '.writers__write-article-button',
  RECOMMENDED_VIDEOS_CONTAINER: '.recommended-videos',
  USER_STATS: '.user-stats-mount-point',
  ADMIN_PANEL: '.admin-panel-mount-point',
  MESSAGE_USER: '.message-user-mount-point',
  RECOMMENDED_POSTS_INJECTED: '.recommendedPostsPlaceHolder'
};

var SCROLL_EVENTS_BASE_SELECTOR = '.scroll-anchor';
function prefixScrollAnchorSelector(strings) {
  return '' + SCROLL_EVENTS_BASE_SELECTOR + strings[0];
}
var SCROLL_EVENTS_SELECTORS = exports.SCROLL_EVENTS_SELECTORS = {
  TITLE: prefixScrollAnchorSelector(_templateObject),
  BODY_START: prefixScrollAnchorSelector(_templateObject2),
  SHARE_BUTTONS_BOTTOM: prefixScrollAnchorSelector(_templateObject3),
  TOP_POSTS: prefixScrollAnchorSelector(_templateObject4),
  TABOOLA: prefixScrollAnchorSelector(_templateObject5),
  PAGE_END: prefixScrollAnchorSelector(_templateObject6)
  // mobile only
};

var MOUNT_POINTS = exports.MOUNT_POINTS = {
  SHARE_COMPONENT: SELECTORS.SHARE_COMPONENT,
  NAVBAR_SOCIAL_COMPONENT: SELECTORS.NAVBAR_SOCIAL_COMPONENT,
  SHARE_COVER_COMPONENT: SELECTORS.SHARE_COVER_COMPONENT,
  BOTTOM_SOCIAL_ICONS: SELECTORS.BOTTOM_SOCIAL_ICONS,
  SEARCH_COMPONENT: SELECTORS.SEARCH_COMPONENT,
  MONTI_BODY: SELECTORS.MONTI_BODY,
  USER_MENU_DROPDOWN: SELECTORS.USER_MENU_DROPDOWN,
  POST_METADATA_STATS: SELECTORS.POST_METADATA_STATS,
  COMMUNITY_DISCLAIMER: SELECTORS.COMMUNITY_DISCLAIMER,
  SLIDE: SELECTORS.SLIDE,
  SLIDE_CONTAINER: SELECTORS.SLIDE_CONTAINER,
  MODAL__MOUNT_POINT: SELECTORS.MODAL__MOUNT_POINT,
  SCHEDULE_COMPONENT: SELECTORS.SCHEDULE,
  SCHEDULE_COMPONENT_IN_FIXTURES_PAGE: SELECTORS.SCHEDULE_IN_FIXTURES_PAGE,
  SOCIAL_BAR_COMPONENT__COVER: SELECTORS.SOCIAL_BAR__COVER,
  SOCIAL_BAR_COMPONENT__HEADER: SELECTORS.SOCIAL_BAR__HEADER,
  SOCIAL_BAR_COMPONENT__DETAILS: SELECTORS.SOCIAL_BAR__DETAILS,
  SOCIAL_BAR_COMPONENT__BOTTOM: SELECTORS.SOCIAL_BAR__BOTTOM,
  LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE: SELECTORS.LEAGUE_SELECTION_COMPONENT_IN_FIXTURES_PAGE,
  TV_SCHEDULE_CHANNEL_SELECTION: SELECTORS.TV_SCHEDULE_CHANNEL_SELECTION,
  TV_SCHEDULE_CHANNEL: SELECTORS.TV_SCHEDULE_CHANNEL,
  FANVOICE_CONTAINER: SELECTORS.FANVOICE_CONTAINER,
  FRESH8_MOUNT_POINT: SELECTORS.FRESH8_MOUNT_POINT,
  YAHOO_FANTASY_MOUNT_POINT: SELECTORS.YAHOO_FANTASY,
  FACEBOOK_BOT_MOUNT_POINT: SELECTORS.FACEBOOK_BOT,
  FRESH8_FLOATING_MOUNT_POINT: SELECTORS.FRESH8_FLOATING,
  SCORES_TABLE: SELECTORS.SCORES_TABLE,
  USER_STATS: SELECTORS.USER_STATS,
  ADMIN_PANEL: SELECTORS.ADMIN_PANEL,
  MESSAGE_USER: SELECTORS.MESSAGE_USER,
  RECOMMENDED_VIDEOS_CONTAINER: SELECTORS.RECOMMENDED_VIDEOS_CONTAINER,
  RECOMMENDED_POSTS: SELECTORS.RECOMMENDED_POSTS_INJECTED
};

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeLocalStorageProvider = undefined;

var _store = __webpack_require__(1298);

var _store2 = _interopRequireDefault(_store);

var _nm = __webpack_require__(26);

var _console = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var get = _store2.default.get.bind(_store2.default); /**
                                                      * Allows safe access to localStorage, which is necessary on devices which
                                                      * throw errors in webviews, where localStorage is programmatically disabled.
                                                      */

var set = _store2.default.set.bind(_store2.default);

function getGMTStringDate(date) {
  return new Date(new Date().toGMTString());
}
_store2.default.get = function getItem(key, defaultValue) {
  if (defaultValue !== undefined) {
    return get(key) || defaultValue;
  }
  return get(key);
};

_store2.default.getWithExpiration = function (key) {
  var value = get(key);
  if (value === null) {
    return value;
  }
  var creationDate = value.creationDate,
      data = value.data,
      expiration = value.expiration;

  return {
    data: data,
    isExpired: getGMTStringDate() - new Date(creationDate) > expiration
  };
};

_store2.default.setWithExpiration = function setItem(key, value, expiration) {
  set(key, { creationDate: getGMTStringDate(), data: value, expiration: expiration });
};

exports.safeLocalStorageProvider = _store2.default;


(0, _nm.registerInNamespace)({ safeLocalStorageProvider: _store2.default });

exports.default = _store2.default;

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

exports.connectWithStore = connectWithStore;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(37);

var _appStore = __webpack_require__(23);

var _appStore2 = _interopRequireDefault(_appStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function connectWithStore(WrappedComponent) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var ConnectedWrappedComponent = _reactRedux.connect.apply(undefined, args)(WrappedComponent);
  return function (props) {
    return _react2.default.createElement(ConnectedWrappedComponent, (0, _extends3.default)({}, props, { store: _appStore2.default }));
  };
}

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.i18n = exports.l = exports.t = exports.locale = exports.DEFAULT_LOCALE = exports.AVAILABLE_LOCALES = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.getShortLocale = getShortLocale;
exports.localizedPath = localizedPath;
exports.translateTrusted = translateTrusted;

var _i18nJs = __webpack_require__(1135);

var _i18nJs2 = _interopRequireDefault(_i18nJs);

var _string = __webpack_require__(46);

var _mithril = __webpack_require__(54);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _nm = __webpack_require__(26);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var translations = __webpack_require__(1116); /* eslint semi:0 */


var FEATURE_FLAGS = {
  forceLocale: _window.queryString.forceLocale
};

var AVAILABLE_LOCALES = exports.AVAILABLE_LOCALES = {
  EN: 'en',
  TR: 'tr',
  TH: 'th',
  ES: 'es',
  VN: 'vn',
  IT: 'it',
  ID: 'id',
  FR: 'fr',
  DE: 'de',
  BR: 'pt-BR'
};

var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = AVAILABLE_LOCALES.EN;
var NO_QS_LOCALE = null;

function getLocaleFromQs() {
  var qsLocale = FEATURE_FLAGS.forceLocale;
  if (!qsLocale || !(0, _string.isString)(qsLocale)) {
    return NO_QS_LOCALE;
  }
  var qsLocaleUpperCase = qsLocale.toUpperCase();
  var qsLocaleValue = AVAILABLE_LOCALES[qsLocaleUpperCase];
  if (!qsLocaleValue) {
    (0, _console.warn)('overriding nonexistent locale', qsLocaleUpperCase);
    return NO_QS_LOCALE;
  }
  (0, _console.info)('overriding locale', qsLocaleValue);
  return qsLocaleValue;
}

var locale = exports.locale = getLocaleFromQs() || (0, _pageDataObject.get)('page.locale', DEFAULT_LOCALE);

function getShortLocale() {
  var localeToShorten = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : locale;

  return localeToShorten.slice(-2).toLowerCase();
}

function localizedPath(path) {
  return locale === (0, _pageDataObject.get)('context.defaultLocale') ? path : '/' + locale + path;
}

var t = exports.t = _i18nJs2.default.t.bind(_i18nJs2.default);
var l = exports.l = _i18nJs2.default.l.bind(_i18nJs2.default);

function translateTrusted() {
  return (0, _mithril.trustHtmlString)(t.apply(undefined, arguments));
}

(0, _assign2.default)(_i18nJs2.default, translations, { locale: locale, localizedPath: localizedPath, translateTrusted: translateTrusted });

(0, _nm.registerInNamespace)({ i18n: _i18nJs2.default });
exports.i18n = _i18nJs2.default;

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.get = get;
exports.set = set;
exports.expire = expire;

var _cookie = __webpack_require__(836);

var _cookie2 = _interopRequireDefault(_cookie);

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var allCookies = _cookie2.default.parse(document.cookie); /* eslint semi:0 */

var epoch = new Date('Thu, 01 Jan 1970 00:00:01 GMT');

function get(name) {
  return allCookies[name];
}

function set(name, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  document.cookie = _cookie2.default.serialize(name, value, options);
  allCookies = _cookie2.default.parse(document.cookie);
}

function expire(name) {
  document.cookie = _cookie2.default.serialize(name, '', { expires: epoch });
  allCookies = _cookie2.default.parse(document.cookie);
}

var cookies = (0, _assign2.default)((0, _object.create)(), {
  get: get,
  set: set,
  expire: expire
});

(0, _nm.registerUtils)({ cookies: cookies });

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.external = undefined;

var _getIterator2 = __webpack_require__(55);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.load = load;
exports.loadAll = loadAll;

var _fn = __webpack_require__(15);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _object = __webpack_require__(13);

var _dom = __webpack_require__(12);

var _externalScripts = __webpack_require__(51);

var _nm = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noThirdParty = _window.queryString.noThirdParty; /* eslint semi:0 */
/**
 * Script loader, powered by configuration payloads. All attributes can
 * be literals, functions or promises.
 */

var firstScriptNode = null;
var firstScriptParentNode = null;

function performQueuedCallbacks(callbackQueue) {
  while (callbackQueue.length) {
    callbackQueue.shift().call();
  }
  return callbackQueue;
}

function debugMessage() {
  if (_window.queryString.debugExternals) {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _console.info.apply(undefined, ['[scriptLoader]'].concat(args));
  }
}

var DONT_LOAD_SCRIPT_VALUE = false;

function insertScriptBeforeFirstScript(scriptTag) {
  if (!firstScriptNode) {
    firstScriptNode = (0, _dom.nodeByTagName)('script');
    firstScriptParentNode = firstScriptNode.parentNode;
  }
  firstScriptParentNode.insertBefore(scriptTag, firstScriptNode);
}

function loadExternalScript(config) {
  var callbackQueue = [];
  var isLoaded = false;
  var isLoading = false;

  return function scriptLoader(callback) {
    // eslint-disable-line complexity
    if (callback instanceof Function) {
      callbackQueue.push(callback);
    }
    debugMessage(config, { callback: callback, callbackQueue: callbackQueue, isLoading: isLoading, isLoaded: isLoaded });
    if (isLoaded) {
      return performQueuedCallbacks(callbackQueue);
    }
    if (!isLoading) {
      isLoading = true;
      var scriptConf = (0, _assign2.default)((0, _object.create)(), _externalScripts.SCRIPT_LOADER_CONF_DEFAULTS, config);
      var scriptOnLoad = function scriptOnLoadHandler() {
        scriptConf.onload();
        isLoaded = true;
        performQueuedCallbacks(callbackQueue);
      };
      var beforeLoad = scriptConf.beforeLoad;

      delete scriptConf.beforeLoad;
      if (beforeLoad() === DONT_LOAD_SCRIPT_VALUE) {
        debugMessage('skipping ' + config.name + ' because', config.beforeLoad, 'returned', DONT_LOAD_SCRIPT_VALUE, config, { callback: callback, callbackQueue: callbackQueue, isLoading: isLoading, isLoaded: isLoaded });
        scriptOnLoad();
        return callbackQueue;
      }
      var scriptTag = (0, _dom.createElement)('script');
      var configurableAttrs = (0, _keys2.default)(scriptConf).filter(function (attr) {
        return attr !== 'onload' && scriptConf[attr] !== undefined;
      });
      var promisesToWaitFor = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(configurableAttrs), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var attr = _step.value;

          var scriptAttributeValue = scriptConf[attr];
          if (scriptAttributeValue instanceof Function) {
            var scriptAttributeFunctionValue = scriptAttributeValue();
            if (scriptAttributeFunctionValue instanceof _promise2.default) {
              promisesToWaitFor.push(scriptAttributeFunctionValue);
              scriptAttributeFunctionValue.then(scriptTag.setAttribute.bind(scriptTag, attr)).catch(_console.warn);
            }
            scriptTag.setAttribute(attr, scriptAttributeFunctionValue);
          } else {
            scriptTag.setAttribute(attr, scriptAttributeValue);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      scriptTag.onload = scriptOnLoad;
      scriptTag.onerror = scriptTag.onerror || function onScriptError(e) {
        (0, _console.warn)('Error loading script \'' + config.name + '\' from \'' + config.src + '\'!', e, this);
      };
      if (promisesToWaitFor.length) {
        _promise2.default.all(promisesToWaitFor).then(function (_) {
          return insertScriptBeforeFirstScript(scriptTag);
        }).catch(_console.warn);
      } else {
        insertScriptBeforeFirstScript(scriptTag);
      }
      return callbackQueue;
    }
    return callbackQueue;
  };
}

var loadedScripts = (0, _object.create)();

function load(options) {
  if (noThirdParty) {
    return _fn.noop;
  }
  var config = options.config,
      loadNow = options.loadNow;

  var name = config && config.name || options.name; // eslint-disable-line no-shadow
  var possiblyLoadedScript = loadedScripts[name];
  if (!possiblyLoadedScript) {
    config = config || _externalScripts.externalScriptsConfig[name] || {};
    var _config = config,
        src = _config.src;

    if (!src) {
      var missingConfOrSrcErrorMessage = 'Missing src \'' + src + '\' in config for loading external script \'' + name + '\'!';
      (0, _console.warn)(missingConfOrSrcErrorMessage, { name: name, config: config });
      throw new Error(missingConfOrSrcErrorMessage);
    }
    possiblyLoadedScript = loadedScripts[name] = loadExternalScript(config);
    if (loadNow) {
      possiblyLoadedScript();
    }
  }
  return possiblyLoadedScript;
}

function loadAll() {
  for (var _len2 = arguments.length, scriptConfs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    scriptConfs[_key2] = arguments[_key2];
  }

  // TODO: investigate why when converted to an arrow function,
  // it broke here when called via
  // script.external.loadAll.apply(null, [...scriptConfigs])
  return scriptConfs.map(load);
}

/* eslint-disable complexity */
var external = exports.external = {
  load: load,
  loadAll: loadAll
};

var script = (0, _assign2.default)((0, _object.create)(), {
  external: external
});

(0, _nm.registerUtils)({ script: script });
(0, _nm.registerInNamespace)({ loadedScripts: loadedScripts });

/***/ }),

/***/ 196:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.mobileHeaderOrientationHandler = mobileHeaderOrientationHandler;
exports.repositionMobileHeader = repositionMobileHeader;
exports.default = mountHeaderComponents;

var _component = __webpack_require__(70);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _userToolbarComponent = __webpack_require__(423);

var _userToolbarComponent2 = _interopRequireDefault(_userToolbarComponent);

var _hamburger = __webpack_require__(405);

var _googleSearchComponent = __webpack_require__(421);

var _googleSearchComponent2 = _interopRequireDefault(_googleSearchComponent);

var _searchInjector = __webpack_require__(413);

var _editionDropdown = __webpack_require__(402);

var _editionDropdown2 = _interopRequireDefault(_editionDropdown);

var _window = __webpack_require__(8);

var _dom = __webpack_require__(12);

var _ua = __webpack_require__(9);

var _pageDataObject = __webpack_require__(5);

var _adStore = __webpack_require__(69);

var _adActions = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var px = function px(num) {
  return num + 'px';
};

var pageWrap = null;
var headerNode = null;
var navigationNode = null;
var DESKTOP_HEADER_HEIGHT = 106;
function getHeaderNode() {
  headerNode = headerNode || (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.SITE_HEADER);
  return headerNode;
}
function getNavigationNode() {
  navigationNode = navigationNode || (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.NAVIGATION);
  return navigationNode;
}
var headerAdNode = null;

function initDialogProvider(predicate) {
  if (predicate) {
    __webpack_require__(316);
  }
  return predicate;
}

function mobileHeaderOrientationHandler(vm) {
  (0, _window.addOnOrientationChangeEvent)(function () {
    repositionMobileHeader(vm);
  }, function () {
    repositionMobileHeader(vm);
  });
}

function repositionMobileHeader(vm) {
  // eslint-disable-line complexity
  if ((0, _ua.getIsTablet)() && _ua.viewport.orientation === 'landscape') {
    removeHeaderMargins();
    return this;
  }
  if ((0, _ua.getIsMobileOrTablet)() || (0, _ua.getIsIos)()) {
    addHeaderMargins(vm);
  }
  return this;
}

function removeHeaderMargins() {
  headerAdNode = headerAdNode || (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.HEADER_AD_UNIT);
  getHeaderNode().style.marginTop = 0;
  getNavigationNode().style.marginTop = 0;
  headerAdNode.style.marginTop = px(DESKTOP_HEADER_HEIGHT);
  pageWrap = pageWrap || (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.PAGE_WRAP);
  pageWrap.style.marginTop = 0;
}

function addHeaderMargins(vm) {
  var mobileHeaderTop = vm.mobileHeaderTop;

  var marginTop = mobileHeaderTop;

  headerAdNode = headerAdNode || (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.HEADER_AD_UNIT);
  if (!headerAdNode) {
    return;
  }
  addTopComponentsMarginTop(marginTop);
  addPageWrapMarginTop(marginTop);
}

function addTopComponentsMarginTop(marginTop) {
  if ((0, _ua.getIsMobile)() || _ua.viewport.isPortrait) {
    headerAdNode.style.marginTop = 0;
    getHeaderNode().style.marginTop = px(marginTop);
    if (getNavigationNode()) {
      getNavigationNode().style.marginTop = px(marginTop);
    }
  } else {
    headerAdNode.classList.add('isTablet');
  }
}

function addPageWrapMarginTop(marginTop) {
  var MOBILE_HEADER_HEIGHT = 88;
  var pageWrapMarginTop = (0, _ua.getIsTabletInPortrait)() ? DESKTOP_HEADER_HEIGHT : MOBILE_HEADER_HEIGHT;
  pageWrap = pageWrap || (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.PAGE_WRAP);
  pageWrap.style.marginTop = px(pageWrapMarginTop + marginTop);
}

var topSlotHeight = void 0;

function onTopAdRendered(payload) {
  var _ref = payload || {},
      type = _ref.type,
      size = _ref.size,
      adId = _ref.adId;

  if (type == _adActions.TYPES.SLOT_RENDERED && adId == 'Top') {
    topSlotHeight = size.height;
    attachHeaderRepositionHandlers();
    _adStore.adStore.removeChangeListener(onTopAdRendered);
  }
}
function attachHeaderRepositionHandlers() {
  var mobileHeaderTop = _adStore.adStore.state.topSlotHeight || topSlotHeight;
  repositionMobileHeader({ mobileHeaderTop: mobileHeaderTop }); //should happen after init
  mobileHeaderOrientationHandler({ mobileHeaderTop: mobileHeaderTop });
}

function updateFanduelAffiliateCode() {
  var links = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('* > div > a')));
  links.forEach(function (x) {
    if (x.href === 'https://wlfanduel.adsrv.eacdn.com/C.ashx?btag=a_14794b_1943c_&affid=10543&siteid=14794&adid=1943&c=') {
      if (self.location.host === 'www.theduel.com') {
        x.href = 'http://wlfanduel.adsrv.eacdn.com/C.ashx?btag=a_14734b_1943c_&affid=10543&siteid=14734&adid=1943&c=';
      }
    }
  });
}

function mountHeaderComponents() {
  var _mountAll;

  initDialogProvider(!(0, _ua.getIsMobileOrTablet)());
  (0, _hamburger.registerHamburger)();
  (0, _editionDropdown2.default)();
  (0, _searchInjector.injectSearch)();
  //TODO refactor and update the affiliate in the VM
  if ((0, _pageDataObject.getSite)() === 'theduel') {
    updateFanduelAffiliateCode();
  }
  (0, _component.mountAll)((_mountAll = {}, (0, _defineProperty3.default)(_mountAll, _preRenderedSelectorsConfig.MOUNT_POINTS.SEARCH_COMPONENT, _googleSearchComponent2.default), (0, _defineProperty3.default)(_mountAll, _preRenderedSelectorsConfig.MOUNT_POINTS.USER_MENU_DROPDOWN, _userToolbarComponent2.default), _mountAll));
  _adStore.adStore.addChangeListener(onTopAdRendered);
}

/***/ }),

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = exports.LinkWithImage = exports.HBox = exports.MenuItem = exports.Text = exports.IconWithLink = exports.Icon = exports.SvgIcon = exports.FontIcon = exports.StickyToBottomContainer = undefined;

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filterOutFromObject = function filterOutFromObject(obj, keysToFilterOut) {
  return (0, _keys2.default)(obj).filter(function (key) {
    return !keysToFilterOut.includes(key);
  }).reduce(function (newObj, key) {
    return (0, _assign2.default)(newObj, (0, _defineProperty3.default)({}, key, obj[key]));
  }, {});
};

var filterOutSrc = function filterOutSrc(obj) {
  return filterOutFromObject(obj, 'src');
};

var addIconFontClass = function addIconFontClass(props) {
  return 'nm-icon-' + props.iconName + ' ' + (props.className ? props.className : '');
};

var StickyToBottomContainer = exports.StickyToBottomContainer = function StickyToBottomContainer(props) {
  return _react2.default.createElement(
    'div',
    { className: 'sticky-to-bottom ' + props.className },
    props.children
  );
};

var FontIcon = exports.FontIcon = function FontIcon(props) {
  return _react2.default.createElement('i', {
    style: props.size ? { fontSize: props.size + 'px', display: 'flex' } : {},
    className: '' + addIconFontClass(props)
  });
};

var SvgIcon = exports.SvgIcon = function SvgIcon(props) {
  return _react2.default.createElement('img', {
    style: props.size ? { height: props.size + 'px' } : {},
    src: __webpack_require__(1350)("./" + props.iconName.slice(0, -'.embedded'.length) + '.embedded.svg'),
    className: props.className
  });
};

var Icon = exports.Icon = function Icon(props) {
  return props.iconName.endsWith('.embedded') ? _react2.default.createElement(SvgIcon, props) : _react2.default.createElement(FontIcon, props);
};

var IconWithLink = exports.IconWithLink = function IconWithLink(props) {
  return _react2.default.createElement('a', {
    'data-analytics-event-category': props['data-analytics-event-category'],
    'data-analytics-event-action': props['data-analytics-event-action'],
    'data-analytics-event-label': props['data-analytics-event-label'],
    style: props.size ? { fontSize: props.size + 'px' } : {},
    href: props.href,
    className: addIconFontClass(props)
  });
};

Icon.propTypes = {
  children: _propTypes2.default.string
};

var Text = exports.Text = function Text(props) {
  return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'mm-ellipsis ' + (props.className ? props.className : '') }));
};

Text.propTypes = {
  children: _propTypes2.default.string
};

var MenuItem = exports.MenuItem = function MenuItem(props) {
  return _react2.default.createElement(
    'div',
    { className: 'menu-item' },
    props.children
  );
};

var HBox = exports.HBox = function HBox(props) {
  return _react2.default.createElement('div', (0, _extends3.default)({}, props, { className: 'hbox ' + (props.className ? props.className : '') }));
};

var LinkWithImage = exports.LinkWithImage = function LinkWithImage(props) {
  return _react2.default.createElement(
    'a',
    filterOutSrc(props),
    _react2.default.createElement('img', { src: props.src })
  );
};

var Link = exports.Link = function Link(props) {
  return _react2.default.createElement('a', (0, _extends3.default)({}, props, { className: 'mm-ellipsis ' + (props.className ? props.className : '') }));
};

/***/ }),

/***/ 203:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initCommonComponents = initCommonComponents;

var _hypernovaReact = __webpack_require__(191);

var _logoWithStore = __webpack_require__(642);

var _recommendedPostsWithStoreContainer = __webpack_require__(409);

var _menuWithStore = __webpack_require__(649);

var _menuButtonWithStore = __webpack_require__(648);

var _NavigationWithStore = __webpack_require__(652);

var _cookieConsentUtils = __webpack_require__(612);

function initCommonComponents() {
  (0, _hypernovaReact.renderReact)('LogoContainer', _logoWithStore.LogoContainerWithStore);
  (0, _hypernovaReact.renderReact)('RecommendedPostsContainer', _recommendedPostsWithStoreContainer.RecommendedPostsWithStore);
  (0, _hypernovaReact.renderReact)('MenuButtonContainer', _menuButtonWithStore.MenuButtonWithStoreComponent);
  (0, _hypernovaReact.renderReact)('MenuContainer', _menuWithStore.MenuWithStoreComponent);
  (0, _hypernovaReact.renderReact)('NavigationContainer', _NavigationWithStore.NavigationContainerWithStore);
  (0, _cookieConsentUtils.init)();
}

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

exports.isCampaignEnabled = isCampaignEnabled;

var _set = __webpack_require__(816);

var _console = __webpack_require__(11);

var _window = __webpack_require__(8);

var _geolocationProvider = __webpack_require__(44);

var _campaign = __webpack_require__(813);

var _pageContext = __webpack_require__(61);

var _pageDataObject = __webpack_require__(5);

var _ua = __webpack_require__(9);

var _pageDataObject2 = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmbedded = _ua.path.isEmbedded; /* eslint semi:0 */
/**
 * A way to query campaign configuration, which is delivered via PDO.
 */

var affiliateId = (0, _pageContext.getInfluencerId)();
var FEATURE_FLAGS = {
  currentTime: _window.queryString.currentTime
};

var currentTime = void 0;
function getCurrentTime() {
  return currentTime || (currentTime = FEATURE_FLAGS.currentTime || new Date());
}

function testLocale(_ref) {
  var locales = _ref.locales;

  if (!locales) {
    return true;
  }
  return locales.map(_campaign.normalizeLocale).includes((0, _campaign.normalizeLocale)((0, _pageDataObject2.getPageLocale)()));
}

function testPageType(_ref2) {
  var pageTypes = _ref2.pageTypes;

  if (!pageTypes) {
    return true;
  }
  return pageTypes.includes((0, _pageDataObject2.getPageType)());
}

function testAffiliateIdsWhiteList(_ref3) {
  var affiliateIdsWhiteList = _ref3.affiliateIdsWhiteList;

  if (!affiliateIdsWhiteList) {
    return true;
  }
  if (!affiliateId) {
    return false;
  }
  var normalizedList = affiliateIdsWhiteList.map(String);
  return normalizedList.includes(affiliateId);
}

function testSupportedForDomain(_ref4) {
  var featureId = _ref4.featureId;

  if (!featureId) {
    return true;
  }
  return (0, _pageDataObject2.isSupportedForDomain)(featureId);
}

function testBoolean(campaignField, booleanToCompare) {
  if (campaignField === undefined) {
    return true;
  }
  if (booleanToCompare === undefined) {
    (0, _console.warn)('booleanToCompare should not be undefind. something is wrong');
    return true;
  }
  return campaignField === booleanToCompare;
}

function testSlideShow(campaign) {
  return testBoolean(campaign.isSlideshow, (0, _pageDataObject2.getIsSlideshow)());
}

function testTopX(campaign) {
  return testBoolean(campaign.isTopX, (0, _pageDataObject2.getIsTopX)());
}

function testMobile(campaign) {
  return testBoolean(campaign.isMobile, (0, _ua.getIsMobile)());
}

function testTablet(campaign) {
  return testBoolean(campaign.isTablet, (0, _ua.getIsTablet)());
}

function testDesktop(campaign) {
  return testBoolean(campaign.isDesktop, (0, _ua.getIsDesktop)());
}

function testHybrid(campaign) {
  return testBoolean(campaign.isHybrid, (0, _pageDataObject2.getIsHybrid)());
}

function testNativeApp(campaign) {
  return testBoolean(campaign.isNativeApp, (0, _ua.getIsNativeApp)());
}

function testFacebookApp(campaign) {
  return testBoolean(campaign.isFacebookApp, (0, _ua.getIsFacebookApp)());
}

function testEmbedded(campaign) {
  return testBoolean(campaign.isEmbedded, isEmbedded);
}

function testCurrentDayEnabled(_ref5) {
  var daysWhiteList = _ref5.daysWhiteList;

  if (!daysWhiteList) {
    return true;
  }
  var currentDay = new Date().getDay();
  return daysWhiteList.includes(currentDay);
}

function testIsntInBlacklistedCategories(_ref6) {
  var blacklistedCategories = _ref6.blacklistedCategories;

  if (!Array.isArray(blacklistedCategories) || !blacklistedCategories.length) {
    return true;
  }
  return (0, _set.intersection)(blacklistedCategories, (0, _pageDataObject2.getPostCategories)()).size === 0;
}

function testIsntInWhitelistedPosts(_ref7) {
  var whitelistedPosts = _ref7.whitelistedPosts;

  if (!Array.isArray(whitelistedPosts) || !whitelistedPosts.length) {
    return true;
  }
  return whitelistedPosts.includes((0, _pageDataObject2.getPostId)());
}

function testIsntInBlacklistedPosts(_ref8) {
  var blacklistedPosts = _ref8.blacklistedPosts;

  if (!Array.isArray(blacklistedPosts) || !blacklistedPosts.length) {
    return true;
  }
  return !blacklistedPosts.includes((0, _pageDataObject2.getPostId)());
}

function isValidPartner(partnerIdentifier) {
  return window.location.search.includes(partnerIdentifier);
}

function testIsSpesificEmbedPartner(_ref9) {
  var embedPartners = _ref9.embedPartners;

  if (!Array.isArray(embedPartners) || embedPartners.length === 0) {
    return true;
  }
  return isValidPartner(embedPartners[0]);
}

function testIsSiteValid(_ref10) {
  var site = _ref10.site;

  return site === (0, _pageDataObject.getSite)();
}

function testExcludeByUrl(_ref11) {
  var excludeByUrl = _ref11.excludeByUrl;

  if (!Array.isArray(excludeByUrl) || excludeByUrl.length === 0) {
    return true;
  }
  return !isValidPartner(excludeByUrl[0]);
}

function testIsntInWhitelistedCategories(_ref12) {
  var whitelistedCategories = _ref12.whitelistedCategories;

  if (!Array.isArray(whitelistedCategories) || !whitelistedCategories.length) {
    return true;
  }
  return (0, _set.intersection)(whitelistedCategories, (0, _pageDataObject2.getPostCategories)()).size > 0;
}

function doesRequireGeo(_ref13) {
  var whiteListCountryCodes = _ref13.whiteListCountryCodes,
      blackListCountryCodes = _ref13.blackListCountryCodes,
      countryCodesToTimeSpan = _ref13.countryCodesToTimeSpan;

  return whiteListCountryCodes || blackListCountryCodes || countryCodesToTimeSpan;
}

function isInTimeframeByCountryCode(cc, time, _ref14) {
  var start = _ref14.start,
      end = _ref14.end,
      countryCodes = _ref14.countryCodes;

  if (!countryCodes.map(_campaign.normalizeCountryCode).includes(cc)) {
    return false;
  }
  return time >= new Date(start) && time <= new Date(end);
}

function isCountryCodesToTimeSpanEnabled(campaign, cc) {
  var countryCodesToTimeSpan = campaign.countryCodesToTimeSpan;

  if (!countryCodesToTimeSpan) {
    return true;
  }
  var isCurrentCountryCodeInTimeSpan = countryCodesToTimeSpan.some(isInTimeframeByCountryCode.part(cc, getCurrentTime()));
  return isCurrentCountryCodeInTimeSpan;
}

function isGeoWhiteListEnabled(campaign, cc) {
  if (!campaign.whiteListCountryCodes) {
    return true;
  }
  return campaign.whiteListCountryCodes.map(_campaign.normalizeCountryCode).includes(cc);
}

function isGeoBlackListEnabled(campaign, cc) {
  if (!campaign.blackListCountryCodes) {
    return true;
  }
  return !campaign.blackListCountryCodes.map(_campaign.normalizeCountryCode).includes(cc);
}

function isGeoEnabled(campaign, cc) {
  return isGeoWhiteListEnabled(campaign, cc) && isGeoBlackListEnabled(campaign, cc);
}

var SYNC_TESTS = [testFacebookApp, testNativeApp, testMobile, testTablet, testDesktop, testEmbedded, testCurrentDayEnabled, testTopX, testHybrid, testSlideShow, testPageType, testLocale, testSupportedForDomain, testAffiliateIdsWhiteList, testIsntInBlacklistedCategories, testIsntInWhitelistedCategories, testIsntInWhitelistedPosts, testIsntInBlacklistedPosts, testIsSpesificEmbedPartner, testIsSiteValid, testExcludeByUrl];

function isCampaignEnabled(campaign) {
  var partiallyApplyCampaign = function partiallyApplyCampaign(test) {
    return test.bind(0, campaign);
  };
  var syncTests = SYNC_TESTS.map(partiallyApplyCampaign);
  var allPass = syncTests.every(function (test) {
    return test();
  });

  var geoTests = [isGeoEnabled, isCountryCodesToTimeSpanEnabled].map(partiallyApplyCampaign);
  return new _promise2.default(function isCampaignEnabledPromise(resolve, reject) {
    var disableCampaign = function disableCampaign(reason) {
      return resolve({ isCampaignEnabled: false, campaign: campaign, reason: reason });
    };
    var enableCampaign = function enableCampaign(reason) {
      return resolve({ isCampaignEnabled: true, campaign: campaign, reason: reason });
    };
    if (!allPass) {
      return disableCampaign('sync test(s) failed');
    }
    if (!doesRequireGeo(campaign)) {
      return enableCampaign('does not require geoLocation');
    }
    return (0, _geolocationProvider.getCountryCode)().then(_campaign.normalizeCountryCode).then(function verifyGeoTests(cc) {
      return geoTests.every(function (t) {
        return t(cc);
      }) ? enableCampaign('geo location requirements met') : disableCampaign('geo test(s) failed');
    }).catch(function (err) {
      var errorMsg = 'cannot get country code: ' + err;
      (0, _console.warn)(errorMsg);
      return disableCampaign(errorMsg);
    });
  });
}

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scriptLoadingEnd = exports.scriptLoadingStart = exports.BROWSI_ACTIONS = undefined;

var _AppDispatcher = __webpack_require__(56);

var _object = __webpack_require__(13);

var dispatchViewAction = _AppDispatcher.appDispatcher.dispatchAction.view;
var BROWSI_ACTIONS = exports.BROWSI_ACTIONS = (0, _object.namespacedConsts)({
  ACTIONS: {
    SCRIPT_LOAD: {
      BEFORE: true,
      AFTER: true
    }
  }
});
var ACTIONS = BROWSI_ACTIONS.ACTIONS;
var _ACTIONS$SCRIPT_LOAD = ACTIONS.SCRIPT_LOAD,
    BEFORE = _ACTIONS$SCRIPT_LOAD.BEFORE,
    AFTER = _ACTIONS$SCRIPT_LOAD.AFTER;
var scriptLoadingStart = exports.scriptLoadingStart = dispatchViewAction.part({ type: BEFORE });
var scriptLoadingEnd = exports.scriptLoadingEnd = dispatchViewAction.part({ type: AFTER });

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routeChanged = exports.TYPES = undefined;

var _object = __webpack_require__(13);

var _AppDispatcher = __webpack_require__(56);

var CONSTS = (0, _object.namespacedConsts)({
  ROUTER: {
    ACTIONS: {
      ROUTE_CHANGED: true
    }
  }
});

var TYPES = exports.TYPES = CONSTS.ROUTER.ACTIONS;

var routeChanged = exports.routeChanged = function routeChanged(route) {
  _AppDispatcher.appDispatcher.dispatchAction.window({
    type: TYPES.ROUTE_CHANGED,
    route: route
  });
};

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrafficInfo = exports.initTrafficInfo = undefined;

var _trafficAnalyzer = __webpack_require__(726);

var _trafficAnalyzer2 = _interopRequireDefault(_trafficAnalyzer);

var _constants = __webpack_require__(53);

var _safeLocalStorageProvider = __webpack_require__(178);

var _safeLocalStorageProvider2 = _interopRequireDefault(_safeLocalStorageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initTrafficInfo = exports.initTrafficInfo = function initTrafficInfo() {
  var traffic = {
    url: window.location.href,
    referrer: document.referrer
  };

  var _checkAllRules = (0, _trafficAnalyzer2.default)(traffic),
      newSource = _checkAllRules.trafficSource,
      newId = _checkAllRules.trafficId;

  var sessionLength = 30;

  var trafficSource = newSource;
  var trafficId = newId;

  var trafficInfo = _safeLocalStorageProvider2.default.get(_constants.TRAFFIC_INFO_KEY);
  if (trafficInfo !== null) {
    var oldSource = trafficInfo.trafficSource,
        oldId = trafficInfo.trafficId,
        timestamp = trafficInfo.timestamp;

    var timestampValue = new Date(timestamp).getTime();
    var sessionPassed = new Date(timestampValue + sessionLength * 60000) < new Date();
    var isTrafficSourceNavigation = newSource === _constants.NAVIGATION_TRAFFIC_SOURCE;
    if (isTrafficSourceNavigation) {
      if (sessionPassed) {
        trafficSource = _constants.DIRECT_TRAFFIC_SOURCE;
        trafficId = _constants.DIRECT_TRAFFIC_ID;
      } else {
        trafficSource = oldSource;
        trafficId = oldId;
      }
    }
  }
  _safeLocalStorageProvider2.default.set(_constants.TRAFFIC_INFO_KEY, { trafficSource: trafficSource, trafficId: trafficId, timestamp: new Date() });
};

var getTrafficInfo = exports.getTrafficInfo = function getTrafficInfo() {
  var trafficInfo = _safeLocalStorageProvider2.default.get(_constants.TRAFFIC_INFO_KEY);

  var _ref = trafficInfo || {},
      trafficSource = _ref.trafficSource,
      trafficId = _ref.trafficId;

  var trafficSourceAndId = trafficId ? trafficSource + '-' + trafficId : trafficSource;
  return { trafficSource: trafficSource, trafficId: trafficId, trafficSourceAndId: trafficSourceAndId };
};

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeLogo = changeLogo;
var CHANGE_LOGO = exports.CHANGE_LOGO = '[logo] change logo';

function changeLogo(imageSrc) {
  return {
    type: CHANGE_LOGO,
    state: {
      imageSrc: imageSrc
    }
  };
}

/***/ }),

/***/ 23:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatch = exports.getState = exports.subscribe = undefined;

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _create = __webpack_require__(182);

var _create2 = _interopRequireDefault(_create);

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.addReducer = addReducer;
exports.setState = setState;

var _redux = __webpack_require__(174);

var _nm = __webpack_require__(26);

var _appStoreConfig = __webpack_require__(704);

var _mountedComponents = __webpack_require__(320);

var _reducers = __webpack_require__(807);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createComposedStore = _redux.compose.apply(undefined, (0, _toConsumableArray3.default)((0, _appStoreConfig.getStoreConfig)()))(_redux.createStore);

var appStore = createComposedStore((0, _redux.combineReducers)(_reducers.reducers));

var subscribe = appStore.subscribe,
    getState = appStore.getState,
    dispatch = appStore.dispatch;


var appStoreGetter = (0, _create2.default)(appStore, {
  state: {
    get: getState,
    enumerable: true
  }
});

(0, _nm.registerInNamespace)({ appStore: appStoreGetter });

exports.default = appStore;
exports.subscribe = subscribe;
exports.getState = getState;
exports.dispatch = dispatch;
function addReducer(stateKey, reducer) {
  dispatch((0, _mountedComponents.registerReducer)(stateKey, reducer));
  return appStore.replaceReducer((0, _redux.combineReducers)((0, _extends3.default)({}, _reducers.reducers, getState().mountedComponents.reducers)));
}

function setState(state, newState) {
  return (0, _extends3.default)({}, state, newState);
}

/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(521);

var _server2 = _interopRequireDefault(_server);

var _reactIntersectionObserver = __webpack_require__(1245);

var _reactIntersectionObserver2 = _interopRequireDefault(_reactIntersectionObserver);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Image = exports.Image = function Image(props) {
  return props.lazyLoad ? _react2.default.createElement(LazyLoadImage, props) : _react2.default.createElement(
    'div',
    { className: '' + props.className },
    _react2.default.createElement('img', getOriginalImageProps(props))
  );
};

var LazyLoadImage = function (_React$Component) {
  (0, _inherits3.default)(LazyLoadImage, _React$Component);

  function LazyLoadImage(props) {
    (0, _classCallCheck3.default)(this, LazyLoadImage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LazyLoadImage.__proto__ || (0, _getPrototypeOf2.default)(LazyLoadImage)).call(this, props));

    _this.imageProps = getOriginalImageProps(_this.props);

    _this.setImageLoaded = function () {
      return _this.setState({ imageLoaded: true });
    };

    _this.getChildren = function (inView) {
      return inView ? _react2.default.createElement('img', (0, _extends3.default)({
        onLoad: _this.setImageLoaded
      }, filterOutClassName(_this.imageProps), {
        className: 'lazy-loaded-image'
      })) : writeNoScriptWhenNotInServer(_this.imageProps);
    };

    _this.state = (0, _extends3.default)({}, _this.state, { imageLoaded: false });
    return _this;
  }

  (0, _createClass3.default)(LazyLoadImage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _reactIntersectionObserver2.default,
        {
          triggerOnce: true,
          rootMargin: '650px',
          className: this.imageProps.className + ' ' + (this.state.imageLoaded ? 'lazy-load-loaded' : 'lazy-load')
        },
        this.getChildren
      );
    }
  }]);
  return LazyLoadImage;
}(_react2.default.Component);

var filterOutClassName = function filterOutClassName(obj) {
  return filterOutFromObject(obj, 'className');
};

var getOriginalImageProps = function getOriginalImageProps(props) {
  return filterOutFromObject(props, ['lazyLoad', 'tag', 'threshold']);
};

var writeNoScriptWhenNotInServer = function writeNoScriptWhenNotInServer(props) {
  return _react2.default.createElement(
    Noscript,
    null,
    _react2.default.createElement('img', (0, _extends3.default)({}, filterOutClassName(props), { className: 'lazy-loaded-image' }))
  );
};

var filterOutFromObject = function filterOutFromObject(obj, keysToFilterOut) {
  return (0, _keys2.default)(obj).filter(function (key) {
    return !keysToFilterOut.includes(key);
  }).reduce(function (newObj, key) {
    return (0, _assign2.default)(newObj, (0, _defineProperty3.default)({}, key, obj[key]));
  }, {});
};

// https://github.com/facebook/react/issues/1252
var Noscript = function Noscript(props) {
  var staticMarkup = _server2.default.renderToStaticMarkup(props.children);
  return _react2.default.createElement('noscript', { dangerouslySetInnerHTML: { __html: staticMarkup } });
};

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slideshowInitializationFinished = exports.completeSlideChange = exports.startSlideChange = exports.TYPES = undefined;

var _object = __webpack_require__(13);

var _AppDispatcher = __webpack_require__(56);

/* eslint semi:0 */
var SLIDESHOW_CONSTANTS = (0, _object.namespacedConsts)({
  SLIDESHOW: {
    ACTIONS: {
      START_SLIDE_CHANGE: true,
      COMPLETE_SLIDE_CHANGE: true,
      SLIDESHOW_INITIALIZATION_FINISHED: true
    }
  }
});

var TYPES = exports.TYPES = SLIDESHOW_CONSTANTS.SLIDESHOW.ACTIONS;

var startSlideChange = exports.startSlideChange = function startSlideChange(slideEventObject) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.START_SLIDE_CHANGE,
    slideEventObject: slideEventObject
  });
};

var completeSlideChange = exports.completeSlideChange = function completeSlideChange(slideId) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.COMPLETE_SLIDE_CHANGE,
    slideId: slideId
  });
};
var slideshowInitializationFinished = exports.slideshowInitializationFinished = function slideshowInitializationFinished() {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.SLIDESHOW_INITIALIZATION_FINISHED
  });
};

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HB_MS_TIMEOUT = exports.HB_NAMESAPCE = undefined;
exports.debug = debug;

var _fn = __webpack_require__(15);

var _ua = __webpack_require__(9);

var _console = __webpack_require__(11);

var _window = __webpack_require__(8);

var _pageDataObject = __webpack_require__(5);

var _initAmazonHeaderBidder = __webpack_require__(141);

var FEATURE_ID = 'HeaderBidder';
var HB_NAMESAPCE = exports.HB_NAMESAPCE = 'headertag';
var HB_MS_TIMEOUT = exports.HB_MS_TIMEOUT = 2; // if 0 or false dfp wont start
var IS_HB_ALLOWED_IN_ALL_COUNTRY_CODES = true;
var HB_SCRIPT_BY_DOMAINS = {
  '12up': 'https://js-sec.indexww.com/ht/p/184533-181801739077362.js',
  '90min': 'https://js-sec.indexww.com/ht/p/184533-118030064613115.js',
  floor8: 'https://js-sec.indexww.com/ht/p/184533-236796720006866.js',
  dbltap: 'https://js-sec.indexww.com/ht/p/184533-153233836086166.js',
  german_site: 'https://js-sec.indexww.com/ht/p/184533-118030064613115.js',
  theduel: 'https://js-sec.indexww.com/ht/p/184533-36721899497143.js'
};
var FEATURE_FLAGS = {
  forceHb: _window.queryString.forceHb,
  debug: _window.queryString.debugHb
};

function debug() {
  if (FEATURE_FLAGS.debug) {
    _console.info.apply(undefined, ['[HEADER-BIDDING]'].concat(Array.prototype.slice.call(arguments)));
  }
}

function isHbAlreadyLoaded(hbNamespace) {
  return hbNamespace in window;
}

function getHbScriptUrlByDomain() {
  return HB_SCRIPT_BY_DOMAINS[(0, _ua.domainFromFqdn)()];
}

function shouldLoadHb(countryCode) {
  if (isHbAlreadyLoaded(HB_NAMESAPCE)) {
    debug('already loaded, not loading again');
    return false;
  }
  var predicates = [IS_HB_ALLOWED_IN_ALL_COUNTRY_CODES, (0, _pageDataObject.isSupportedForDomain)(FEATURE_ID), !(0, _ua.getIsNativeApp)(), !(0, _initAmazonHeaderBidder.isCountryCodeUnitedStates)(countryCode)];
  var shouldLoad = FEATURE_FLAGS.forceHb || _fn.allTrue.apply(undefined, predicates);
  debug('isHbEnabled?', shouldLoad, { predicates: predicates, countryCode: countryCode, isMobile: (0, _ua.getIsMobile)() });
  return shouldLoad;
}

function delayPromiseChain(resolve, value, delay) {
  if (delay) {
    debug('resolving with ' + delay + 'ms timeout from inside "' + HB_NAMESAPCE + '.jsLoaded", starting "' + delay + 'ms" timer until dfp script.');
    setTimeout(function resolveDelayedHeaderBidder() {
      debug(delay + 'ms delay complete, resolving promise.');
      resolve(value);
    }, delay);
  }
}

var headerBidderScriptConfig = {
  src: getHbScriptUrlByDomain,
  shouldLoad: shouldLoadHb,
  afterLoad: delayPromiseChain
};

exports.default = headerBidderScriptConfig;

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOCIAL_BUTTONS_CONF = exports.REDDIT = exports.COMMENTS = exports.EMBED = exports.WHATSAPP = exports.MESSAGE = exports.TWITTER = exports.FACEBOOK = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _SOCIAL_BUTTONS_CONF; /* eslint semi:0 */


var _mithril = __webpack_require__(54);

var _pageDataObject = __webpack_require__(5);

var _socialButtonsActions = __webpack_require__(140);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FACEBOOK = exports.FACEBOOK = 'facebook';
var TWITTER = exports.TWITTER = 'twitter';
var MESSAGE = exports.MESSAGE = 'message';
var WHATSAPP = exports.WHATSAPP = 'whatsapp';
var EMBED = exports.EMBED = 'embed';
var COMMENTS = exports.COMMENTS = 'comments';
var REDDIT = exports.REDDIT = 'reddit';

var EMBED_CODE_FEATURE_ID = 'EmbedCode';

var ANALYTICS_ACTION_SHARE = 'article share click';
var ANALYTICS_ACTION_EMBEDED = 'article embed click';

var TWITTER_VIA = {
  '90min.com': {
    default: '90min_Football'
  },
  'ftb90.com': {
    default: 'ftb_90'
  },
  '12up.com': {
    default: '12upSport',
    es: '12up_ES'
  },
  'minutemediaalpha.com': {
    default: 'Esp_Interativo'
  },
  'floor8.com': {
    default: 'Floor8Official',
    es: 'Floor8_ES'
  }
};

function twitterVia() {
  var forDomain = TWITTER_VIA[(0, _pageDataObject.getSiteDomainWithTld)()];
  return forDomain && (forDomain[_i18nProvider.locale] || forDomain.default);
}

var SOCIAL_BUTTONS_CONF = exports.SOCIAL_BUTTONS_CONF = (_SOCIAL_BUTTONS_CONF = {}, (0, _defineProperty3.default)(_SOCIAL_BUTTONS_CONF, FACEBOOK, {
  title: 'Facebook',
  name: FACEBOOK,
  get href() {
    var sharedUrlParams = {
      utm_source: this.sourceName, // eslint-disable-line camelcase
      utm_medium: 'share' // eslint-disable-line camelcase
    };
    var urlParams = {
      u: (0, _mithril.urlWithQs)((0, _pageDataObject.getPostUrl)(), sharedUrlParams)
    };
    return (0, _mithril.urlWithQs)('https://www.facebook.com/sharer.php', urlParams);
  },
  sourceName: 'facebook.com',
  analyticsActionText: ANALYTICS_ACTION_SHARE
}), (0, _defineProperty3.default)(_SOCIAL_BUTTONS_CONF, TWITTER, {
  title: (0, _i18nProvider.t)('common.tweet'),
  name: TWITTER,
  get href() {
    var sharedUrlParams = {
      utm_source: this.sourceName, // eslint-disable-line camelcase
      utm_medium: 'share' // eslint-disable-line camelcase
    };
    var urlParams = {
      text: (0, _pageDataObject.getPostTitle)().replace('|', '-'),
      via: twitterVia(),
      url: (0, _mithril.urlWithQs)((0, _pageDataObject.getPostUrl)(), sharedUrlParams)
    };
    return (0, _mithril.urlWithQs)('https://twitter.com/share', urlParams);
  },
  sourceName: 'twitter.com',
  analyticsActionText: ANALYTICS_ACTION_SHARE
}), (0, _defineProperty3.default)(_SOCIAL_BUTTONS_CONF, WHATSAPP, {
  title: (0, _i18nProvider.t)('common.share'),
  name: WHATSAPP,
  sourceName: 'whatsapp',
  get href() {
    var sharedUrlParams = {
      utm_source: this.sourceName, // eslint-disable-line camelcase
      utm_medium: 'share' // eslint-disable-line camelcase
    };
    var postUrl = (0, _mithril.urlWithQs)((0, _pageDataObject.getPostUrl)(), sharedUrlParams);
    return ['whatsapp://send?text=', (0, _pageDataObject.getPostTitle)(), encodeURIComponent(': ' + postUrl)].join('');
  },
  analyticsActionText: ANALYTICS_ACTION_SHARE
}), (0, _defineProperty3.default)(_SOCIAL_BUTTONS_CONF, REDDIT, {
  featureId: 'REDDIT',
  title: 'Reddit',
  name: REDDIT,
  get href() {
    var sharedUrlParams = {
      utm_source: this.sourceName, // eslint-disable-line camelcase
      utm_medium: 'share' // eslint-disable-line camelcase
    };
    var urlParams = {
      title: (0, _pageDataObject.getPostTitle)().replace('|', '-'),
      url: (0, _mithril.urlWithQs)((0, _pageDataObject.getPostUrl)(), sharedUrlParams),
      kind: 'link'
    };
    return (0, _mithril.urlWithQs)('https://reddit.com/submit', urlParams);
  },
  sourceName: 'reddit.com',
  analyticsActionText: ANALYTICS_ACTION_SHARE
}), (0, _defineProperty3.default)(_SOCIAL_BUTTONS_CONF, EMBED, {
  featureId: EMBED_CODE_FEATURE_ID,
  title: (0, _i18nProvider.t)('embed.button'),
  name: EMBED,
  onClick: _socialButtonsActions.openEmbed,
  analyticsActionText: ANALYTICS_ACTION_EMBEDED
}), _SOCIAL_BUTTONS_CONF);

exports.default = SOCIAL_BUTTONS_CONF;

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrentUser = exports.ROLES = exports.LOGGED_IN_COOKIE_NAME = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _safeLocalStorageProvider = __webpack_require__(178);

var _console = __webpack_require__(11);

var _cookies = __webpack_require__(180);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STORAGE_KEY = 'CurrentUser';
var LOGGED_IN_COOKIE_NAME = exports.LOGGED_IN_COOKIE_NAME = 'logged_in';
var ROLES = exports.ROLES = {
  EDITOR: 'editor',
  ADMIN: 'admin',
  AUTHOR: 'author'
};

var CurrentUser = exports.CurrentUser = function () {
  function CurrentUser() {
    (0, _classCallCheck3.default)(this, CurrentUser);
  }

  (0, _createClass3.default)(CurrentUser, [{
    key: 'get',
    value: function get() {
      var currentUser = {};

      try {
        currentUser = _safeLocalStorageProvider.safeLocalStorageProvider.get(STORAGE_KEY, {});
      } catch (e) {
        (0, _console.warn)('failed loading/parsing user data from localStorage', e);
      }

      return currentUser;
    }
  }, {
    key: 'getRole',
    value: function getRole(postAuthorId) {
      var currentUser = this.get();
      if (this.isLoggedIn) {
        if (currentUser.admin || currentUser.super_admin) {
          return ROLES.ADMIN;
        } else if (currentUser.editor || this.roleViaCookie(ROLES.EDITOR)) {
          return ROLES.EDITOR;
        } else if (currentUser.id === postAuthorId) {
          return ROLES.AUTHOR;
        }
      }
      return null;
    }
  }, {
    key: 'roleViaCookie',
    value: function roleViaCookie(role) {
      var loginCookie = (0, _cookies.get)(LOGGED_IN_COOKIE_NAME);
      if (loginCookie == null) {
        return false;
      }
      try {
        return JSON.parse(loginCookie).role == role;
      } catch (err) {
        this.warn('Cookie authentication failed', err);
        return false;
      }
    }
  }, {
    key: 'set',
    value: function set(data) {
      _safeLocalStorageProvider.safeLocalStorageProvider.set(STORAGE_KEY, data);
    }
  }, {
    key: 'isLoggedIn',
    get: function get() {
      var currentUser = this.get();
      var userDataInLocalStorage = currentUser && currentUser.authenticated;
      var loginCookie = (0, _cookies.get)(LOGGED_IN_COOKIE_NAME);
      if (!userDataInLocalStorage && loginCookie == null) {
        return false;
      }
      return true;
    }
  }]);
  return CurrentUser;
}();

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPostActions = exports.loadingPostActions = exports.confirmAndExecAdminAction = exports.FETCH_POST_ACTIONS_FAILED = exports.FETCH_POST_ACTIONS_SUCCESS = exports.LOADING_POST_ACTIONS = exports.FETCH_POST_ACTIONS = undefined;

var _window = __webpack_require__(8);

var _window2 = _interopRequireDefault(_window);

var _postActionsProvider = __webpack_require__(783);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_POST_ACTIONS = exports.FETCH_POST_ACTIONS = 'FETCH_POST_ACTIONS';
var LOADING_POST_ACTIONS = exports.LOADING_POST_ACTIONS = 'LOADING_POST_ACTIONS';
var FETCH_POST_ACTIONS_SUCCESS = exports.FETCH_POST_ACTIONS_SUCCESS = 'FETCH_POST_ACTIONS_SUCCESS';
var FETCH_POST_ACTIONS_FAILED = exports.FETCH_POST_ACTIONS_FAILED = 'FETCH_POST_ACTIONS_FAILED';

var confirmAndExecAdminAction = exports.confirmAndExecAdminAction = function confirmAndExecAdminAction(adminAction) {
  return function (dispatch) {
    var confirmationResult = (0, _postActionsProvider.confirmAdminAction)(adminAction);
    if (confirmationResult) {
      (0, _postActionsProvider.sendServerAdminAction)(adminAction).then(function (response) {
        response.success && alert('Successfully ' + adminAction.text);
        if (typeof response.redirect !== 'undefined') {
          _window2.default.navigateTo(response.redirect);
        }
      }).catch(function () {
        alert('something went wrong while trying to ' + adminAction.text + '. It might have work and might have not. please try again or verify');
      });
    }
  };
};

var loadingPostActions = exports.loadingPostActions = function loadingPostActions(isLoading) {
  return {
    type: LOADING_POST_ACTIONS,
    newState: { isLoading: isLoading }
  };
};

var fetchPostActionsFailed = function fetchPostActionsFailed() {
  return {
    type: FETCH_POST_ACTIONS_FAILED,
    newState: { hasErrors: true }
  };
};

var fetchPostActionsSuccess = function fetchPostActionsSuccess(optionsList) {
  return {
    type: FETCH_POST_ACTIONS_SUCCESS,
    newState: { optionsList: optionsList, hasErrors: false }
  };
};

var fetchPostActions = exports.fetchPostActions = function fetchPostActions(postId, fetchFromServer) {
  return function (dispatch) {
    var getPostActions = fetchFromServer ? getPostActions : _postActionsProvider.getPostActionsFromPdo;

    dispatch(loadingPostActions(true));
    return getPostActions(postId).then(function (_ref) {
      var data = _ref.data;

      return dispatch(fetchPostActionsSuccess(data.options));
    }).then(function () {
      return dispatch(loadingPostActions(false));
    }).catch(function (error) {
      return dispatch(fetchPostActionsFailed());
    });
  };
};

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAMESPACE = exports.registerProvider = exports.registerUtils = undefined;

var _create = __webpack_require__(182);

var _create2 = _interopRequireDefault(_create);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.registerInNamespace = registerInNamespace;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
/**
 * Allows adding keys/values to a single global namespace.
 * Should only be used for introspection: no code should ever
 * address the namespace.
 */
var assign = _assign2.default;


var NAMESPACE = 'NM';
var namespace = global[NAMESPACE] = assign(global[NAMESPACE] || (0, _create2.default)(null));

function registerInNamespace(obj) {
  assign(namespace, obj);
  return obj;
}

registerInNamespace({
  namespaceName: NAMESPACE
});

function registerSubNamespace(subNamespace, objectToRegister) {
  namespace[subNamespace] = namespace[subNamespace] || (0, _create2.default)(null);
  assign(namespace[subNamespace], objectToRegister);
  return objectToRegister;
}

var registerUtils = exports.registerUtils = registerSubNamespace.part('utils');
var registerProvider = exports.registerProvider = registerSubNamespace.part('providers');

exports.NAMESPACE = NAMESPACE;
exports.default = namespace;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(120)))

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLASS_NAMES = exports.AD_FORMATS = exports.ADS_QUERYSTRING_OVERRIDE_PREFIXES = exports.AD_TYPES = exports.adsConfig = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slot;

var _array = __webpack_require__(101);

var _adDimensionsConfig = __webpack_require__(710);

var _adDimensionsConfig2 = _interopRequireDefault(_adDimensionsConfig);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var d1x1 = _adDimensionsConfig2.default.d1x1,
    d300x50 = _adDimensionsConfig2.default.d300x50,
    d300x250 = _adDimensionsConfig2.default.d300x250,
    d300x300 = _adDimensionsConfig2.default.d300x300,
    d300x600 = _adDimensionsConfig2.default.d300x600,
    d320x50 = _adDimensionsConfig2.default.d320x50,
    d728x90 = _adDimensionsConfig2.default.d728x90,
    d900x250 = _adDimensionsConfig2.default.d900x250,
    d970x250 = _adDimensionsConfig2.default.d970x250,
    d250x250 = _adDimensionsConfig2.default.d250x250;


var AD_TYPES = {
  REGULAR: 'RegularAd',
  PASSBACK: 'Passback',
  VIDEO: 'Video',
  INJECTED: 'Injected'
};

var BLOCK_NAME = 'ad';

var CLASS_NAMES = {
  BLOCK: BLOCK_NAME,
  STICKY: BLOCK_NAME + '--fixed',
  EMPTY: BLOCK_NAME + '--empty',
  INJECTED: BLOCK_NAME + '--injected',
  DFP: BLOCK_NAME + '--dfp'
};

var ADS_QUERYSTRING_OVERRIDE_PREFIX = 'ads';
var ADS_QUERYSTRING_OVERRIDE_PREFIXES = {
  toString: function toString() {
    return ADS_QUERYSTRING_OVERRIDE_PREFIX;
  },
  CUSTOM_CRITERIA: ADS_QUERYSTRING_OVERRIDE_PREFIX + 'Cc'
};

var DISPLAY_FORMAT_NAMES = ['Top', 'Side', 'SideSecondary', 'Bottom', 'InArticle', '1x1', '1x1secondary', 'Outofpage', 'InArticleDynamic', 'InSlideshow', '1x1third'];
var VIDEO_FORMAT_NAMES = ['Video', 'Vinarticle', 'Vside'];
var AD_FORMAT_NAMES = [].concat(DISPLAY_FORMAT_NAMES, VIDEO_FORMAT_NAMES);
var AD_FORMATS = (0, _object.create)();
AD_FORMAT_NAMES.forEach(_array.toIdentityObject, AD_FORMATS);
(0, _object.deepFreeze)(AD_FORMATS);

var adsConfig = {
  global: {
    doubleClick: {}
  },

  slot: (_slot = {}, (0, _defineProperty3.default)(_slot, AD_FORMATS.Video, {
    type: AD_TYPES.VIDEO,
    doubleClick: {
      dimensions: {
        desktop: [[640, 360]]
      }
    }
  }), (0, _defineProperty3.default)(_slot, AD_FORMATS.Top, {
    type: AD_TYPES.REGULAR,
    doubleClick: {
      isSticky: {
        portraitTablet: {
          default: true,
          exceptOnSites: []
        },
        mobile: {
          default: true,
          exceptOnSites: []
        },
        desktop: {
          default: false,
          exceptOnSites: []
        }
      },
      slotDivId: 'div-gpt-ad-1430753718702-0-' + AD_FORMATS.Top,
      dimensions: {
        desktop: [d728x90, d900x250, d970x250],
        landscapeTablet: [d728x90],
        portraitTablet: [d728x90],
        mobile: [d300x50, d320x50]
      }
    }
  }), (0, _defineProperty3.default)(_slot, AD_FORMATS.Side, {
    type: AD_TYPES.REGULAR,
    doubleClick: {
      hideForHorizonalBreakpoint: true,
      slotDivId: 'div-gpt-ad-1430753718702-0-' + AD_FORMATS.Side,
      dimensions: {
        desktop: [d300x250, d300x600]
      }
    }
  }), (0, _defineProperty3.default)(_slot, AD_FORMATS.SideSecondary, {
    type: AD_TYPES.REGULAR,
    doubleClick: {
      // hideForLocale: 'en',
      hideForHorizonalBreakpoint: true,
      slotDivId: 'div-gpt-ad-1430753718702-0-' + AD_FORMATS.SideSecondary,
      dimensions: {
        desktop: [d300x250, d300x600]
      }
    }
  }), (0, _defineProperty3.default)(_slot, AD_FORMATS.InSlideshow, {
    type: AD_TYPES.REGULAR,
    doubleClick: {
      slotDivId: 'div-gpt-ad-1430753718702-0-' + AD_FORMATS.InSlideshow,
      dimensions: {
        desktop: [d300x250, d300x300, d728x90]
      }
    }
  }), (0, _defineProperty3.default)(_slot, AD_FORMATS.InArticle, {
    type: AD_TYPES.INJECTED,
    doubleClick: {
      hideForNonMobile: true,
      slotDivId: 'div-gpt-ad-1430753718702-0-' + AD_FORMATS.InArticle,
      dimensions: {
        mobile: [d300x250, d300x300, d250x250]
      }
    }
  }), (0, _defineProperty3.default)(_slot, AD_FORMATS.InArticleDynamic, {
    type: AD_TYPES.INJECTED,
    doubleClick: {
      isEnabledInNativeApp: true,
      hideForNonMobile: true,
      slotDivId: 'div-gpt-ad-1430753718702-0-' + AD_FORMATS.InArticleDynamic,
      dimensions: {
        mobile: [d300x250, d300x300, d250x250]
      }
    }
  }), (0, _defineProperty3.default)(_slot, AD_FORMATS['1x1secondary'], {
    type: AD_TYPES.REGULAR,
    hideSlotContainer: true,
    doubleClick: {
      slotDivId: 'div-gpt-ad-1430753718702-0-' + AD_FORMATS['1x1secondary'],
      isEnabledInNativeApp: false,
      hideForNonMobile: false,
      dimensions: {
        desktop: [d1x1],
        mobile: [d1x1]
      }
    }
  }), (0, _defineProperty3.default)(_slot, AD_FORMATS['1x1third'], {
    type: AD_TYPES.REGULAR,
    hideSlotContainer: true,
    doubleClick: {
      slotDivId: 'div-gpt-ad-1430753718702-0-' + AD_FORMATS['1x1third'],
      isEnabledInNativeApp: false,
      hideForNonMobile: false,
      dimensions: {
        desktop: [d1x1],
        mobile: [d1x1]
      }
    }
  }), _slot)
};

exports.adsConfig = adsConfig;
exports.AD_TYPES = AD_TYPES;
exports.ADS_QUERYSTRING_OVERRIDE_PREFIXES = ADS_QUERYSTRING_OVERRIDE_PREFIXES;
exports.AD_FORMATS = AD_FORMATS;
exports.CLASS_NAMES = CLASS_NAMES;

/***/ }),

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TYPES = exports.PAGEVIEW_ACTION = exports.CLASS_CONSTATNTS = undefined;

var _objectWithoutProperties2 = __webpack_require__(830);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _join = __webpack_require__(433);

var _join2 = _interopRequireDefault(_join);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

exports.riddleEmbedMessage = riddleEmbedMessage;
exports.pageViewed = pageViewed;
exports.heartBeat = heartBeat;
exports.scrollAnchorReached = scrollAnchorReached;
exports.timeOnPageInterval = timeOnPageInterval;
exports.pageClicked = pageClicked;
exports.shareButtonsAnalyticsAction = shareButtonsAnalyticsAction;
exports.viewbilityAnalyticsAction = viewbilityAnalyticsAction;
exports.recomendedPostsAnalyticsAction = recomendedPostsAnalyticsAction;
exports.recomendedPostsEmbedAnalyticsAction = recomendedPostsEmbedAnalyticsAction;
exports.mobileNavigationMenuClicked = mobileNavigationMenuClicked;
exports.taboolaFeedEmbedEvent = taboolaFeedEmbedEvent;
exports.taboolaFeedViewabilityEvent = taboolaFeedViewabilityEvent;
exports.taboolaFeedClickEvent = taboolaFeedClickEvent;
exports.cookieDisclaimerClickEvent = cookieDisclaimerClickEvent;
exports.cookieDisclaimerImpression = cookieDisclaimerImpression;
exports.zommdImpression = zommdImpression;
exports.widgetEmbedEvent = widgetEmbedEvent;
exports.dfpSlotOnloadEvent = dfpSlotOnloadEvent;

var _AppDispatcher = __webpack_require__(56);

var _object = __webpack_require__(13);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var debugAnalyticsClickHandler = _window.queryString.debugAnalyticsClickHandler;
var CLASS_CONSTATNTS = exports.CLASS_CONSTATNTS = (0, _object.namespacedConsts)({
  ANALYTICS: {
    ACTIONS: {
      CLICK_EVENT: true,
      PAGE_VIEWED: true,
      HEART_BEAT: true,
      SCROLL_ANCHOR_REACHED: true,
      TIME_ON_PAGE_INTERVAL: true,
      RIDDLE_EMBED_MESSAGE: true
    }
  }
});
var PAGEVIEW_ACTION = exports.PAGEVIEW_ACTION = { type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.PAGE_VIEWED };

var TYPES = exports.TYPES = CLASS_CONSTATNTS.ANALYTICS.ACTIONS;

function riddleEmbedMessage(payload) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.RIDDLE_EMBED_MESSAGE,
    payload: payload
  });
}

function pageViewed() {
  _AppDispatcher.appDispatcher.dispatchAction.view(PAGEVIEW_ACTION);
}

function heartBeat() {
  _AppDispatcher.appDispatcher.dispatchAction.window({
    type: TYPES.HEART_BEAT
  });
}

function scrollAnchorReached(payload) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.SCROLL_ANCHOR_REACHED,
    payload: (0, _extends3.default)({}, payload, {
      anchor: '.' + (0, _join2.default)(payload.anchor.classList, '.')
    }),
    dispatchToRedux: true
  });
}

function timeOnPageInterval(timeOnPage) {
  _AppDispatcher.appDispatcher.dispatchAction.window({
    type: TYPES.TIME_ON_PAGE_INTERVAL,
    timeOnPage: timeOnPage
  });
}

function pageClicked(payload) {
  if (debugAnalyticsClickHandler) {
    (0, _console.info)('CLICK DISPATCH PAYLOAD: ', payload);
  }
  return {
    type: TYPES.CLICK_EVENT,
    state: {
      payload: payload
    }
  };
}

function shareButtonsAnalyticsAction(shareType, position, action) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Article page',
        action: action,
        label: shareType,
        sub_label: position
      }
    }
  };
}

function viewbilityAnalyticsAction(category, action, label) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: category,
        action: action,
        label: label
      }
    }
  };
}

function recomendedPostsAnalyticsAction(label, position) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Article page',
        action: 'Article click ',
        label: 'in-article recommendations-' + label,
        sub_label: position
      }
    }
  };
}

function recomendedPostsEmbedAnalyticsAction() {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Article page',
        action: ' in-article recommendations embed',
        label: 'cards'
      }
    }
  };
}

function mobileNavigationMenuClicked(description, position) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Navigation',
        action: 'nav bar open',
        label: description,
        sub_label: position
      }
    }
  };
}

function taboolaFeedEmbedEvent() {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Article page',
        action: 'taboola feed embed',
        label: ' '
      }
    }
  };
}

function taboolaFeedViewabilityEvent(cardType, card, client) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Article page',
        action: 'taboola feed viewable impression',
        label: cardType + '-' + card,
        sub_label: client
      }
    }
  };
}

function taboolaFeedClickEvent(cardType, slot, card, client) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Article page',
        action: cardType,
        label: 'taboola feed card = ' + card,
        sub_label: 'position = ' + slot + ';' + client
      }
    }
  };
}

function cookieDisclaimerClickEvent() {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: 'consent banner click',
        label: 'bottom sticky banner',
        sub_label: ''
      }
    }
  };
}

function cookieDisclaimerImpression() {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: 'consent banner impression',
        label: 'bottom sticky banner',
        sub_label: ''
      }
    }
  };
}

function zommdImpression() {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Site search',
        action: 'search click',
        label: ' ',
        sub_label: ' '
      }
    }
  };
}

function widgetEmbedEvent(label) {
  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Article page',
        action: 'widget Embed',
        label: label
      }
    }
  };
}

function dfpSlotOnloadEvent(payload) {
  var adUnitPath = payload.adUnitPath,
      dfpPayload = (0, _objectWithoutProperties3.default)(payload, ['adUnitPath']);

  return {
    type: CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: (0, _extends3.default)({
        category: 'Ads tracking',
        action: 'ad impression',
        label: adUnitPath
      }, dfpPayload)
    }
  };
}

var analyticsActions = {
  TYPES: TYPES,
  riddleEmbedMessage: riddleEmbedMessage,
  heartBeat: heartBeat,
  scrollAnchorReached: scrollAnchorReached,
  pageClicked: pageClicked
};

exports.default = analyticsActions;

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchClicked = exports.ready = exports.TYPES = undefined;

var _AppDispatcher = __webpack_require__(56);

var _object = __webpack_require__(13);

/* eslint semi:0 */
var CLASS_CONSTATNTS = (0, _object.namespacedConsts)({
  GOOGLE_SEARCH: {
    ACTIONS: {
      READY: true,
      SEARCH_CLICKED: true
    }
  }
});

var TYPES = exports.TYPES = CLASS_CONSTATNTS.GOOGLE_SEARCH.ACTIONS;

var ready = exports.ready = function ready() {
  _AppDispatcher.appDispatcher.dispatchAction.external({
    type: TYPES.READY
  });
};

var searchClicked = exports.searchClicked = function searchClicked(searchTerm) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.SEARCH_CLICKED,
    searchTerm: searchTerm
  });
};

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeModal = exports.TYPES = undefined;

var _object = __webpack_require__(13);

var _AppDispatcher = __webpack_require__(56);

var CONSTS = (0, _object.namespacedConsts)({
  MODAL: {
    ACTIONS: {
      CLOSE: true
    }
  }
});

var TYPES = exports.TYPES = CONSTS.MODAL.ACTIONS;

var closeModal = exports.closeModal = function closeModal() {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.CLOSE
  });
};

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.browsiScriptConfig = undefined;
exports.isBrowsiEnabled = isBrowsiEnabled;

var _fn = __webpack_require__(15);

var _console = __webpack_require__(11);

var _window = __webpack_require__(8);

var _ua = __webpack_require__(9);

var _pageDataObject = __webpack_require__(5);

var _browsiActions = __webpack_require__(207);

var _dom = __webpack_require__(12);

var _pageContext = __webpack_require__(61);

var isEmbedded = _ua.path.isEmbedded;

var FEATURE_FLAGS = {
  forceBrowsi: _window.queryString.forceBrowsi,
  debug: _window.queryString.debugBrowsi
};
var SCORE_365 = 'partner=484476';
var BROWSI_ALLOWED_DOMAINS = ['90min', '12up', 'dbltap', 'floor8', 'german_site', 'theduel'];
var SHINEZ_POSTS = [6242836, 6296514, 6296515, 6296517, 6296519, 6296521, 6296525, 6296532, 6296536, 6296537, 6296544, 6296549, 6296551, 6296562, 6296565, 6296566, 6296568, 6296572, 6296574, 6296576, 6296578, 6296580, 6296583, 6296586, 6296587, 6296588, 6296590, 6296592, 6296593, 6296594];
var BROWSI_AFFID_BY_DOMAIN = {
  '12up': '12up',
  '90min': '90min',
  floor8: 'floor8',
  dbltap: 'dbltap',
  german_site: '90min',
  theduel: 'theduel'
};

var NINETY_MIN_MARKETPLACE_TRIVIA_GEO = ['"UK"'];
var FLOOR_EIGHT_MARKETPLACE_TRIVIA_GEO = ['"US"', '"IL"'];

var SCRIPT = 'https://middycdn-a.akamaihd.net/bootstrap/bootstrap.js';

var BROWSI_ALLOWED_UTM_SOURCES = ['facebook'];
var BROWSI_ALLOWED_REFERRALS = ['facebook.com'];

var affiliateId = (0, _pageContext.getInfluencerId)(); // eslint-disable-line camelcase

//yoni TODO - delete it by 1/5/18
// function hasAllowedReferral() {
//   const externalReferrer = referringDomain()
//   return BROWSI_ALLOWED_REFERRALS.some(externalReferrer.includes, externalReferrer)
// }

// function hasAffiliateId() {
//   return affiliateId !== true && !!affiliateId
// }

function getUtmSource() {
  return _window.queryString.utm_source || 'NO_UTM_SOURCE';
}

function hasAllowedUtmSource() {
  var utmSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getUtmSource();

  return BROWSI_ALLOWED_UTM_SOURCES.some(utmSource.includes, utmSource);
}

function hasWhitelistQuerystring() {
  return hasAllowedUtmSource();
}

function debug() {
  if (FEATURE_FLAGS.debug) {
    _console.info.apply(undefined, ['[browsi]'].concat(Array.prototype.slice.call(arguments)));
  }
}

function isBrowsiEnabled() {
  var predicates = [
  // getIsMobile(),
  BROWSI_ALLOWED_DOMAINS.includes((0, _pageDataObject.getSite)()), !SHINEZ_POSTS.includes((0, _pageDataObject.getPostId)())];
  var shouldLoadBrowsi = FEATURE_FLAGS.forceBrowsi || _fn.allTrue.apply(undefined, predicates);
  debug('isBrowsiEnabled?', shouldLoadBrowsi, { predicates: predicates });
  return shouldLoadBrowsi;
}

function beforeLoad() {
  debug('before script load');
  debug('browsi script src', SCRIPT);
  (0, _browsiActions.scriptLoadingStart)();
}

function onload() {
  // eslint-disable-line no-shadow
  debug('on script load');
  (0, _browsiActions.scriptLoadingEnd)();
}

function getOandOSiteKey() {
  return (0, _ua.getIsNativeApp)() ? '90minapp' : BROWSI_AFFID_BY_DOMAIN[(0, _pageDataObject.getSite)()];
}

function getSiteKey() {
  return window.location.search.includes(SCORE_365) ? 'score365' : getOandOSiteKey();
}

var browsiScriptConfig = exports.browsiScriptConfig = {
  name: 'browsi',
  src: SCRIPT,
  id: 'browsi-tag',
  'data-pubKey': 'minutemedia',
  'data-siteKey': getSiteKey(),
  beforeLoad: beforeLoad,
  onload: onload
};

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _console = __webpack_require__(11);

var _dom = __webpack_require__(12);

var _dialogPolyfill = __webpack_require__(1108);

var _dialogPolyfill2 = _interopRequireDefault(_dialogPolyfill);

var _component = __webpack_require__(70);

var _nm = __webpack_require__(26);

var _modalComponent = __webpack_require__(706);

var _modalComponent2 = _interopRequireDefault(_modalComponent);

var _modalActions = __webpack_require__(312);

var _preRenderedSelectorsConfig = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
/**
 * Adds dialog element polyfill and manages dialog state, as well as mounting
 * and unmounting and other dom operations for dialog. Currently only
 * supports Mithril component as payload.
 */
var dialog = {};
var rootDialog = (0, _dom.getElementById)(_preRenderedSelectorsConfig.SELECTORS.MODAL.slice(1));
var mountPoint = rootDialog && rootDialog.querySelector(_preRenderedSelectorsConfig.MOUNT_POINTS.MODAL__MOUNT_POINT);

var d = document;

var bodyClasses = d.body.classList;


var CLASS_NAMES = {
  HAS_MODAL: 'has-modal'
};
var IS_MODAL = true;

function onClose(e) {
  bodyClasses.remove(CLASS_NAMES.HAS_MODAL);
  (0, _component.unmount)(mountPoint);
}

if (rootDialog) {
  _dialogPolyfill2.default.registerDialog(rootDialog);
  rootDialog.addEventListener('click', function clickModal(ev) {
    if (ev.target === rootDialog) {
      (0, _modalActions.closeModal)(ev);
    }
  });

  var closeModalButton = rootDialog.querySelector(_preRenderedSelectorsConfig.SELECTORS.MODAL__CLOSE_BUTTON);
  closeModalButton.addEventListener('click', _modalActions.closeModal);

  rootDialog.addEventListener('close', onClose, false);

  var modal = {
    get isOpen() {
      return rootDialog.open;
    },
    get isClosed() {
      return !modal.isOpen;
    },
    show: function show(component) {
      if (modal.isClosed) {
        (0, _component.mount)({ rootNode: mountPoint, component: component });
        rootDialog.showModal(IS_MODAL);
        bodyClasses.add(CLASS_NAMES.HAS_MODAL);
        modal.currentComponent = component;
      }
      return modal;
    },
    close: function close(e) {
      rootDialog.close();
      return modal;
    }
  };

  (0, _component.mount)({
    modal: modal,
    rootNode: mountPoint,
    component: _modalComponent2.default
  });

  dialog = {
    modal: modal,
    rootDialog: rootDialog,
    polyfill: _dialogPolyfill2.default
  };
} else {
  (0, _console.warn)('Trying to initialize dialog provider without a mount point!', {
    rootDialog: rootDialog,
    dialog: dialog
  });
}

(0, _nm.registerInNamespace)({ dialog: dialog });

exports.default = dialog;

/***/ }),

/***/ 317:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.update = exports.USER_LOGOUT = exports.NEW_USER_AUTHENTICATED = exports.EXISTING_USER_AUTHENTICATED = undefined;

var _currentUser = __webpack_require__(249);

var EXISTING_USER_AUTHENTICATED = exports.EXISTING_USER_AUTHENTICATED = 'USER_TOOLBAR:ACTIONS:EXISTING_USER_AUTHENTICATED';
var NEW_USER_AUTHENTICATED = exports.NEW_USER_AUTHENTICATED = 'USER_TOOLBAR:ACTIONS:NEW_USER_AUTHENTICATED';
var USER_LOGOUT = exports.USER_LOGOUT = 'USER_TOOLBAR:ACTIONS:LOGOUT';

/*
 * This is just a temporary workaround.
 * currently we have 2 navbars the old one is depend on the window.currentUser and the new one the localStorage["currentUser"]
 * So we want to "update" the old navbars that we've changed the currentUser
 * When we will rewrite the old navbars in Redux we will be able to fully migrate the currentUser to this store and wont have to update the localstorage here
 */
var update = exports.update = function update(nextCurrentUser) {
  new _currentUser.CurrentUser().set(nextCurrentUser);
  window.location.reload();
};

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleMenu = exports.TOGGLE_MENU = undefined;
exports.toggleMenuAction = toggleMenuAction;

var _analyticsActions = __webpack_require__(31);

var _menu = __webpack_require__(319);

var TOGGLE_MENU = exports.TOGGLE_MENU = '[menu] toggle menu';
function toggleMenuAction() {
  return {
    type: TOGGLE_MENU
  };
}

function sendMenuButtonClickAnalyticsAction(action) {
  return {
    type: _analyticsActions.CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Navigation',
        action: 'hamburger menu ' + (action ? 'open' : 'close'),
        label: 'none'
      }
    }
  };
}

var toggleMenu = exports.toggleMenu = function toggleMenu() {
  return function (dispatch, getState) {
    dispatch(toggleMenuAction());
    dispatch(sendMenuButtonClickAnalyticsAction((0, _menu.isMenuOpen)(getState())));
  };
};

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isMenuOpen = exports.isMenuOpen = function isMenuOpen(state) {
  return state.menu.isOpen;
};

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appActionTypes = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.componentMount = componentMount;
exports.registerReducer = registerReducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dynamic Redux reconfiguration Actions
 */

var appActionTypes = exports.appActionTypes = {
  COMPONENT_MOUNT: 'COMPONENT_MOUNT',
  REGISTER_REDUCER: 'REGISTER_REDUCER'
};

function componentMount(ComponentInstance, componentName, sagas) {
  return {
    type: appActionTypes.COMPONENT_MOUNT,
    state: {
      component: ComponentInstance,
      name: componentName,
      sagas: sagas
    }
  };
}

function registerReducer(stateKey, reducer) {
  return function (dispatch) {
    dispatch({
      type: appActionTypes.REGISTER_REDUCER,
      state: (0, _defineProperty3.default)({}, stateKey, reducer)
    });
  };
}

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MAX_SESSION_DURATION = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get3 = __webpack_require__(71);

var _get4 = _interopRequireDefault(_get3);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _string = __webpack_require__(46);

var _cookies = __webpack_require__(180);

var _baseStore = __webpack_require__(77);

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

var _userToolbarActions = __webpack_require__(76);

var _analyticsActions = __webpack_require__(31);

var _safeLocalStorageProvider = __webpack_require__(178);

var _pageDataObject = __webpack_require__(5);

var _facebookAuthenticationProvider = __webpack_require__(780);

var _i18nProvider = __webpack_require__(18);

var _currentUser = __webpack_require__(249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_CONSTATNTS = (0, _object.namespacedConsts)({
  USER: {
    START_DATE: true,
    SESSION_START_TIME: true
  }
});

var GUEST_ID_KEY = 'GusetUserId'; // for backwards compatibility
var STORAGE_KEY = 'CurrentUser'; // for backwards compatibility
var USER_AUTHENTICATION_TTL = 24 * 60 * 60 * 1000; //1 day
var MAX_SESSION_DURATION = exports.MAX_SESSION_DURATION = 30 * 60 * 1000; //30 minutes
var LOGOUT_PATH = (0, _pageDataObject.get)('config.logout_path');

var UserStore = function (_BaseStore) {
  (0, _inherits3.default)(UserStore, _BaseStore);

  function UserStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, UserStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserStore.__proto__ || (0, _getPrototypeOf2.default)(UserStore)).call(this, options));

    _this.loadFromStorage();
    _this.recentReads = _this.recentReads || {};
    if (_this.isNewSession) {
      _this.resetSessionStartTime();
    }
    if (_this.isLoggedIn && _this.isLoginExpired()) {
      _this.isAuthenticated = false;
      _this.authenticationProvider.reAuthenticate();
    }
    return _this;
  }

  (0, _createClass3.default)(UserStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      var type = action.type;

      var ACTIONS = _userToolbarActions.TYPES;
      switch (type) {
        case ACTIONS.FB_SDK_READY:
          return this.state.fbSdkReady = true;
        case ACTIONS.FB_LOGIN:
          return this.fbLoggingIn();
        case ACTIONS.EXISTING_USER_AUTHENTICATED:
          return this.existingUserAuthenticated(action.userData);
        case ACTIONS.NEW_USER_AUTHENTICATED:
          return this.newUserAuthenticated(action.userData);
        case ACTIONS.LOGOUT:
          return this.logoutUser();
        case ACTIONS.AUTHENTICATION_FAILED:
          return this.authenticationFailed(action.response);
        case ACTIONS.UNIMPERSONATE:
          return this.assignData(action.response.data);
        case _analyticsActions.TYPES.PAGE_VIEWED:
          return this.updateRecentReads();
        default:
          return this;
      }
    }
  }, {
    key: 'isEditorViaCookie',
    value: function isEditorViaCookie() {
      var loginCookie = (0, _cookies.get)(_currentUser.LOGGED_IN_COOKIE_NAME);
      if (loginCookie == null) {
        return false;
      }
      try {
        return JSON.parse(loginCookie).role == _currentUser.ROLES.EDITOR;
      } catch (err) {
        this.warn('Cookie authentication failed', err);
        return false;
      }
    }
  }, {
    key: 'updateRecentReads',
    value: function updateRecentReads() {
      this.deleteOldReads();
      this.setCurrentPostRead();
      this.emitChange();
    }
  }, {
    key: 'deleteOldReads',
    value: function deleteOldReads() {
      for (var postId in this.recentReads) {
        if (this.recentReads[postId].time < Date.now() - MAX_SESSION_DURATION) {
          delete this.recentReads[postId];
        }
      }
    }
  }, {
    key: 'setCurrentPostRead',
    value: function setCurrentPostRead() {
      var postId = (0, _pageDataObject.get)('post.id');
      if (postId !== undefined) {
        this.recentReads[postId] = this.recentReads[postId] || {
          time: Date.now(),
          readsCount: 0
        };
        this.recentReads[postId].readsCount++;
      }
    }
  }, {
    key: 'isLoginExpired',
    value: function isLoginExpired() {
      return !(0, _cookies.get)(_currentUser.LOGGED_IN_COOKIE_NAME) || this.authenticatedAt < Date.now() - USER_AUTHENTICATION_TTL;
    }
  }, {
    key: 'fbLoggingIn',
    value: function fbLoggingIn() {
      this.isAuthenticating = true;
      _facebookAuthenticationProvider.facebookAuthenticationProvider.login();
      this.emitChange();
    }
  }, {
    key: 'existingUserAuthenticated',
    value: function existingUserAuthenticated(userData) {
      this.isAuthenticating = false;
      this.isAuthenticated = true;
      this.authenticatedAt = Date.now();
      this.assignData(userData);
    }
  }, {
    key: 'newUserAuthenticated',
    value: function newUserAuthenticated(userData) {
      this.draftUser = userData;
      // this.assignData(useraData);
    }
  }, {
    key: 'authenticationFailed',
    value: function authenticationFailed(response) {
      this.warn('User Authentication Failed', response);
      this.isAuthenticating = false;
      this.logoutUser();
      this.emitChange();
    }
  }, {
    key: 'assignData',
    value: function assignData(data) {
      (0, _assign2.default)(this.state, data);
      this.emitChange();
    }
  }, {
    key: 'emitChange',
    value: function emitChange() {
      this.saveToStorage();
      return (0, _get4.default)(UserStore.prototype.__proto__ || (0, _getPrototypeOf2.default)(UserStore.prototype), 'emitChange', this).call(this);
    }
  }, {
    key: 'saveToStorage',
    value: function saveToStorage() {
      // Note: for backwards compatibility, the key for this store in local storage should be 'CurrentUser'
      try {
        _safeLocalStorageProvider.safeLocalStorageProvider.set(STORAGE_KEY, this.state);
      } catch (ex) {
        this.warn('failed saving user data from localStorage', ex);
      }
      return this;
    }
  }, {
    key: 'logoutUser',
    value: function logoutUser() {
      this.state.isLoggedIn = false;
      this.isAuthenticated = false;
      this.isAuthenticating = false;
      this.removeFromStorage();
    }
  }, {
    key: 'removeFromStorage',
    value: function removeFromStorage() {
      _safeLocalStorageProvider.safeLocalStorageProvider.remove(STORAGE_KEY);
      window.location = LOGOUT_PATH;
    }
  }, {
    key: 'loadFromStorage',
    value: function loadFromStorage() {
      var userData = {};
      try {
        userData = _safeLocalStorageProvider.safeLocalStorageProvider.get(STORAGE_KEY, {});
      } catch (e) {
        this.warn('failed loading/parsing user data from localStorage', e);
      }
      this.assignData(userData);
      this.locale = (0, _cookies.get)('locale') || userData.locale || _i18nProvider.DEFAULT_LOCALE;
      return this;
    }
  }, {
    key: 'getStartDate',
    value: function getStartDate() {
      var date = _safeLocalStorageProvider.safeLocalStorageProvider.get(CLASS_CONSTATNTS.USER.START_DATE);
      if (!date) {
        date = new Date().toString();
        _safeLocalStorageProvider.safeLocalStorageProvider.set(CLASS_CONSTATNTS.USER.START_DATE, date);
      }
      return Date.parse(date);
    }
  }, {
    key: 'generateGuestUserId',
    value: function generateGuestUserId() {
      return '' + (0, _string.randId)() + (0, _string.randId)() + '-' + (0, _string.randId)() + '-' + (0, _string.randId)() + '-' + (0, _string.randId)() + '-' + (0, _string.randId)() + (0, _string.randId)() + (0, _string.randId)();
    }
  }, {
    key: 'resetSessionStartTime',
    value: function resetSessionStartTime() {
      _safeLocalStorageProvider.safeLocalStorageProvider.set(CLASS_CONSTATNTS.USER.SESSION_START_TIME, Date.now());
    }
  }, {
    key: 'authenticationProvider',
    get: function get() {
      // At the moment we use only facebook, so...
      return _facebookAuthenticationProvider.facebookAuthenticationProvider;
    }
  }, {
    key: 'isAdmin',
    get: function get() {
      return !!this.state.admin;
    }
  }, {
    key: 'isAuthor',
    get: function get() {
      return this.isAuthenticated && this.state.id === (0, _pageDataObject.get)('post.author.id');
    }
  }, {
    key: 'isAdminOrEditor',
    get: function get() {
      return this.isAdmin || this.isEditor;
    }
  }, {
    key: 'isEditor',
    get: function get() {
      return this.isEditorViaCookie();
    }
  }, {
    key: 'isLoggedIn',
    get: function get() {
      return !!this.state.loggedIn;
    }
  }, {
    key: 'isImpersonating',
    get: function get() {
      return !!this.state.impersonatingId;
    }
  }, {
    key: 'isAuthenticated',
    get: function get() {
      return this.state.authenticated;
    },
    set: function set(bool) {
      this.state.authenticated = bool;
    }
  }, {
    key: 'isAuthenticating',
    get: function get() {
      return this.authenticating;
    },
    set: function set(bool) {
      this.authenticating = bool;
    }
  }, {
    key: 'authenticatedAt',
    get: function get() {
      return this.state.authenticatedAt;
    },
    set: function set(time) {
      this.state.authenticatedAt = time;
    }
  }, {
    key: 'recentReads',
    get: function get() {
      return this.state.recentReads;
    },
    set: function set(readsObj) {
      this.state.recentReads = readsObj;
    }
  }, {
    key: 'team',
    get: function get() {
      return this.state.team || '';
    }
  }, {
    key: 'guestId',
    get: function get() {
      var id = _safeLocalStorageProvider.safeLocalStorageProvider.get(GUEST_ID_KEY, (0, _cookies.get)(GUEST_ID_KEY));
      if (!id) {
        id = this.generateGuestUserId();
        (0, _cookies.set)(GUEST_ID_KEY, id);
        _safeLocalStorageProvider.safeLocalStorageProvider.set(GUEST_ID_KEY, id);
        this.guestId = id;
      }
      return id;
    },
    set: function set(guestId) {
      this.assignData({ guestId: guestId });
    }
  }, {
    key: 'partnerId',
    get: function get() {
      return this.state.partnerId;
    }
  }, {
    key: 'isNewSession',
    get: function get() {
      if (this.newSessionFlag === undefined) {
        var sessionStartTime = _safeLocalStorageProvider.safeLocalStorageProvider.get(CLASS_CONSTATNTS.USER.SESSION_START_TIME) || 0;
        this.newSessionFlag = sessionStartTime < Date.now() - MAX_SESSION_DURATION;
      }
      return this.newSessionFlag;
    }
  }]);
  return UserStore;
}(_baseStore.BaseStore);

var userStore = UserStore.create();
(0, _nm.registerInNamespace)({ userStore: userStore });

exports.default = userStore;

/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = initializeEditionSelection;

var _fn = __webpack_require__(15);

var _console = __webpack_require__(11);

var _ua = __webpack_require__(9);

var _dom = __webpack_require__(12);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

/* eslint semi:0 */
var EDITION_SELECTION_FEATURE_ID = 'EditionSelection';
var EDITION_DROPDOWN = _preRenderedSelectorsConfig.SELECTORS.EDITION_DROPDOWN,
    EDITION_COMPONENT = _preRenderedSelectorsConfig.SELECTORS.EDITION_COMPONENT,
    SITE_HEADER = _preRenderedSelectorsConfig.SELECTORS.SITE_HEADER;

var PAGE_TYPES_TO_ADD_CLICK_LISTENERS = ['homepage'];

function registerEditionSelection() {
  if (!PAGE_TYPES_TO_ADD_CLICK_LISTENERS.includes((0, _pageDataObject.getPageType)())) {
    return null;
  }
  var editionCheckbox = (0, _dom.node)(EDITION_DROPDOWN);
  if (!editionCheckbox) {
    return (0, _console.warn)('Cannot find edition checkbox', { editionCheckbox: editionCheckbox, pageType: (0, _pageDataObject.getPageType)() });
  }
  if (!(0, _ua.getIsMobileOrTablet)()) {
    // do not allow desktop users to toggle the checkbox,
    // see https://90min-confluence.atlassian.net/browse/FEATURES-3399
    editionCheckbox.disabled = true;
    return editionCheckbox;
  }
  var editionComponent = (0, _dom.node)(EDITION_COMPONENT);
  var siteHeader = (0, _dom.node)(SITE_HEADER);
  if (!editionComponent || !siteHeader) {
    return (0, _console.warn)('cannot find edition component or site header component');
  }
  // the following line is a weird fix for a bug:
  // try removing this line, and using an iphone try expanding the lang dropdown
  // then, try clicking on the black area inside the site header.
  // without this line, it will not close the dropdown on ALL ios devices
  siteHeader.addEventListener('click', _fn.noop);

  (0, _dom.addDocumentEvent)('click', function documentClickEditionHandler(e) {
    if (editionCheckbox.checked) {
      e.preventDefault();
    }
    editionCheckbox.checked = false;
  });
  editionComponent.addEventListener('click', function editionComponentClickHandler(e) {
    e.stopPropagation();
  });
  return editionCheckbox;
}

function initializeEditionSelection() {
  var shouldInitializeEditionSelection = (0, _pageDataObject.isSupportedForDomain)(EDITION_SELECTION_FEATURE_ID);
  if (shouldInitializeEditionSelection) {
    registerEditionSelection();
  }
  return shouldInitializeEditionSelection;
}

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.registerHamburger = registerHamburger;

var _fn = __webpack_require__(15);

var _dom = __webpack_require__(12);

var _console = __webpack_require__(11);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _pageDataObject = __webpack_require__(5);

var HAMBURGER_FEATURE_ID = 'HamburgerMenu'; /* eslint semi:0 */

var HAMBURGER_CLASS_NAMES = {
  NO_SCROLL: 'no-scroll'
};
var CHECKED_MENU_RADIO_BUTTON_SELECTOR = "input[name=leagues-list-radio]:checked";

function uncheckCheckedSidenav(sideNav, e) {
  if (sideNav.checkbox && sideNav.checkbox.checked) {
    sideNav.hamburger.click();
    var checkedMenuButton = (0, _dom.node)(CHECKED_MENU_RADIO_BUTTON_SELECTOR);
    if (checkedMenuButton) {
      checkedMenuButton.checked = false;
    }
  }
}

function menuClickHandler(sideNav, e) {
  document.body.classList.toggle(HAMBURGER_CLASS_NAMES.NO_SCROLL, sideNav.checkbox.checked);
  e.stopPropagation();
}

function registerClickEvents(sideNav, element) {
  if (!element) {
    (0, _console.warn)('[hamburger] registerClickEvents got a falsy element', { sideNav: sideNav, element: element });
    return _fn.noop;
  }
  var partiallyAppliedClickHandler = menuClickHandler.bind(0, sideNav);
  element.addEventListener('click', partiallyAppliedClickHandler);
  return partiallyAppliedClickHandler;
}

function addHamburgerEventListeners() {
  var sideNav = {
    headerNode: (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.SITE_HEADER),
    checkbox: (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.MAIN_SIDENAV_CHECKBOX),
    hamburger: (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.MAIN_SIDENAV_TOGGLE),
    menu: (0, _dom.node)(_preRenderedSelectorsConfig.SELECTORS.MAIN_SIDENAV)
  };
  document.body.addEventListener('click', uncheckCheckedSidenav.bind(0, sideNav));
  var clickEventTargets = [sideNav.menu, sideNav.hamburger, sideNav.checkbox];
  return clickEventTargets.map(registerClickEvents.bind(0, sideNav));
}

function registerHamburger() {
  var shouldInitHamburgerMenu = (0, _pageDataObject.isSupportedForDomain)(HAMBURGER_FEATURE_ID);
  if (shouldInitHamburgerMenu) {
    addHamburgerEventListeners();
  }
  return shouldInitHamburgerMenu;
}

/***/ }),

/***/ 406:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _primitives = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandableContainer = exports.ExpandableContainer = function (_Component) {
  (0, _inherits3.default)(ExpandableContainer, _Component);

  function ExpandableContainer() {
    (0, _classCallCheck3.default)(this, ExpandableContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ExpandableContainer.__proto__ || (0, _getPrototypeOf2.default)(ExpandableContainer)).call(this));

    _this.state = { isOpen: false };
    return _this;
  }

  (0, _createClass3.default)(ExpandableContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.isOpen !== 'undefined' && nextProps.isOpen !== this.state.isOpen) {
        this.toggleExpandable();
      }
    }
  }, {
    key: 'toggleExpandable',
    value: function toggleExpandable() {
      this.setState({ isOpen: !this.state.isOpen });
    }
  }, {
    key: 'childFactory',
    value: function childFactory(child) {
      var _this2 = this;

      var component = null;
      if (child.type === ExpandableContainer.Header) {
        component = _react2.default.cloneElement(child, {
          isOpen: this.state.isOpen,
          onClick: this.props.onClick ? function (e) {
            return _this2.props.onClick(e);
          } : function () {
            return _this2.toggleExpandable();
          },
          key: 'header'
        });
      } else if (child.type === ExpandableContainer.Content) {
        component = _react2.default.cloneElement(child, { isOpen: this.state.isOpen, key: 'content' });
      }
      return component;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        'div',
        null,
        this.props.children.map(function (child) {
          return _this3.childFactory(child);
        })
      );
    }
  }], [{
    key: 'Header',
    value: function Header(props) {
      return _react2.default.createElement(
        'div',
        {
          onClick: props.onClick,
          className: 'expandable__header ' + (props.className ? props.className : '')
        },
        _react2.default.createElement(
          'div',
          { className: 'expandable__header-text' },
          props.children
        ),
        _react2.default.createElement(_primitives.Icon, {
          iconName: 'arrow',
          className: 'expandable__header-icon ' + (props.isOpen ? 'open' : ''),
          size: '8'
        })
      );
    }
  }, {
    key: 'Content',
    value: function Content(props) {
      return _react2.default.createElement(
        'div',
        { className: 'expandable__content ' + (props.isOpen ? 'expanded' : 'collapsed') },
        props.children
      );
    }
  }]);
  return ExpandableContainer;
}(_react.Component);

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageProps = imageProps;
exports.getIcon = getIcon;
exports.getNavItemStyle = getNavItemStyle;
exports.getItemsContainerClass = getItemsContainerClass;
exports.getItemContainerClass = getItemContainerClass;
exports.redirectToItemFeed = redirectToItemFeed;
exports.getPath = getPath;
exports.shouldHeaderCollapsedWithNavigation = shouldHeaderCollapsedWithNavigation;
var ROOT = '/';
var SHOULD_COLLAPSED_HEADER_WITH_NAVIGATION = ['floor8', '12up', 'german_site', 'dbltap', '90min', 'pluralist'];

function imageProps(imageSrc, className, alt) {
  return {
    lazyLoad: true,
    src: imageSrc,
    className: className,
    alt: alt
  };
}

function getIcon(icon) {
  return __webpack_require__(1351)("./" + icon + '_icon.svg');
}

function getNavItemStyle(navItemsSize) {
  return navItemsSize > 4 ? 'nav__item__smaller' : 'nav__item';
}

function getItemsContainerClass(itemsSize) {
  if (itemsSize < 7) return 'items-container__small';else if (itemsSize > 6 && itemsSize < 14) {
    return 'items-container__medium';
  }
  return 'items-container__large';
}

function getItemContainerClass(itemsSize) {
  return itemsSize < 4 ? 'item__container__small' : 'item__container__large';
}

function redirectToItemFeed(url) {
  location.replace(location.origin + url);
}

function getPath() {
  return typeof window !== 'undefined' ? window.location.pathname : ROOT;
}

function shouldHeaderCollapsedWithNavigation(site) {
  return SHOULD_COLLAPSED_HEADER_WITH_NAVIGATION.includes(site);
}

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.initRecommendedPosts = initRecommendedPosts;

var _connectWithStore = __webpack_require__(179);

var _recommendedPosts = __webpack_require__(805);

var _recommendedPostsCardsContainer = __webpack_require__(673);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _reduxMounter = __webpack_require__(45);

var _reduxMounter2 = _interopRequireDefault(_reduxMounter);

var _ua = __webpack_require__(9);

var _campaignConfig = __webpack_require__(206);

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

var _viewbilityTracker = __webpack_require__(99);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMPONENT_NAME = 'recommendedPostsComponent';

var mapStateTpProps = function mapStateTpProps(state, props) {
  return { posts: (0, _recommendedPosts.getRecommendedPosts)(state) };
};

var RECOMMENDED_POSTS_CONFIG = {
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'RecommendedPosts',
  blacklistedCategories: ['sponsored']
};

function connectToStore(component) {
  return (0, _connectWithStore.connectWithStore)(component, mapStateTpProps);
}

function getRecommendedPostsMountDetails(component) {
  return {
    name: COMPONENT_NAME,
    component: connectToStore(component)
  };
}

function mountRecommendedPosts(component) {
  return (0, _reduxMounter2.default)((0, _defineProperty3.default)({}, _preRenderedSelectorsConfig.MOUNT_POINTS.RECOMMENDED_POSTS, getRecommendedPostsMountDetails(component)));
}

function addPlaceHolder(position) {
  var paragreph = document.querySelectorAll('.post-content > p')[position];
  if (paragreph !== undefined && paragreph !== null) {
    paragreph.insertAdjacentHTML('afterEnd', '<div class="recommendedPostsPlaceHolder"></div>');
  }
}

function mountCards() {
  mountRecommendedPosts(_recommendedPostsCardsContainer.recommendedPostsCardsContainer);
  (0, _appStore.dispatch)((0, _analyticsActions.recomendedPostsEmbedAnalyticsAction)());
  (0, _viewbilityTracker.register)('.recommeneded_posts_cards__container');
}

function isSyndication() {
  return _ua.path.isSyndication;
}

function injectCards(paragraph) {
  if (paragraph !== undefined) {
    addPlaceHolder(paragraph);
    mountCards();
  }
}

function getMiddleParagraph() {
  if (undefined !== document.querySelectorAll('.post-content > p')) {
    return parseInt(document.querySelectorAll('.post-content > p').length / 2);
  }
  return -1;
}

function initRecommendedPosts() {
  (0, _campaignConfig.isCampaignEnabled)(RECOMMENDED_POSTS_CONFIG).then(function (response) {
    if (response.isCampaignEnabled) {
      if (!isSyndication()) {
        injectCards(getMiddleParagraph());
      }
    }
  });
}

/***/ }),

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectSearch = injectSearch;

var _script = __webpack_require__(19);

var _externalScripts = __webpack_require__(51);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getScriptName() {
  return _externalScripts.externalScriptsConfig.zoomd.name;
}

function addStyle(searchDiv) {
  searchDiv.setAttribute('zoomdSearch', '{"trigger":"OnClick"}');
}

function setupReportAnalytics() {
  var searchWraaperDiv = document.querySelector('.search-comp-zoomd');
  if (searchWraaperDiv !== undefined) {
    searchWraaperDiv.addEventListener('click', function () {
      (0, _appStore.dispatch)((0, _analyticsActions.zommdImpression)());
    });
  }
}
function initZoomd() {
  var searchDiv = document.querySelector('.search-comp-zoomd');
  if (searchDiv !== undefined && searchDiv !== null) {
    setupReportAnalytics();
    addStyle(searchDiv);
    _script.external.load({
      name: getScriptName(),
      loadNow: true
    });
  }
}

function injectSearch() {
  initZoomd();
}

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.youtubeAnalyticsPauseAction = exports.youtubeAnalyticsCompleteAction = exports.youtubeAnalyticsPlayAction = exports.sdkLoaded = exports.loadSdk = exports.YOUTUBE_ACTION_TYPES = undefined;
exports.youtubeAnalyticsPercentageChangeAction = youtubeAnalyticsPercentageChangeAction;

var _object = __webpack_require__(13);

var YOUTUBE_ACTION_TYPES = exports.YOUTUBE_ACTION_TYPES = (0, _object.namespacedConsts)({
  SDK_LOADED: true,
  LOAD_SDK: true,
  ANALYTICS: {
    VIDEO_PLAY: true,
    VIDEO_COMPLETE: true,
    VIDEO_PAUSE: true,
    VIDEO_PERCENTAGE_CHANGE: true
  }
});

var loadSdk = exports.loadSdk = function loadSdk(_) {
  return {
    type: YOUTUBE_ACTION_TYPES.LOAD_SDK
  };
};

var sdkLoaded = exports.sdkLoaded = function sdkLoaded(_) {
  return {
    type: YOUTUBE_ACTION_TYPES.SDK_LOADED
  };
};

var youtubeAnalyticsPlayAction = exports.youtubeAnalyticsPlayAction = function youtubeAnalyticsPlayAction(videoId, pageType, videoMainWrapperName, time) {
  return {
    type: YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PLAY,
    state: {
      payload: {
        category: pageType,
        action: 'youtube ' + videoMainWrapperName + ' video play',
        label: videoId,
        sub_label: 'current position=' + time.position + 'sec; video duration=' + time.duration + 'sec;'
      }
    }
  };
};

var youtubeAnalyticsCompleteAction = exports.youtubeAnalyticsCompleteAction = function youtubeAnalyticsCompleteAction(videoId, pageType, videoMainWrapperName, time) {
  return {
    type: YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_COMPLETE,
    state: {
      payload: {
        category: pageType,
        action: 'youtube ' + videoMainWrapperName + ' video complete',
        label: videoId,
        sub_label: 'current position=' + time.position + 'sec; video duration=' + time.duration + 'sec;'
      }
    }
  };
};

var youtubeAnalyticsPauseAction = exports.youtubeAnalyticsPauseAction = function youtubeAnalyticsPauseAction(videoId, pageType, videoMainWrapperName, time) {
  return {
    type: YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PAUSE,
    state: {
      payload: {
        category: pageType,
        action: 'youtube ' + videoMainWrapperName + ' video paused',
        label: videoId,
        sub_label: 'current position=' + time.position + 'sec; video duration=' + time.duration + 'sec;'
      }
    }
  };
};

function youtubeAnalyticsPercentageChangeAction(videoId, pageType, videoMainWrapperName, time, percentage) {
  return {
    type: YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PERCENTAGE_CHANGE,
    state: {
      payload: {
        category: pageType,
        label: videoId,
        sub_label: 'current position=' + time.position + 'sec; video duration=' + time.duration + 'sec;',
        action: 'youtube ' + videoMainWrapperName + ' video ' + percentage + '% complete'
      }
    }
  };
};

/***/ }),

/***/ 419:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.embedConfigurationChanged = exports.embedDataFailed = exports.embedDataReceived = exports.TYPES = undefined;

var _object = __webpack_require__(13);

var _AppDispatcher = __webpack_require__(56);

var CONSTS = (0, _object.namespacedConsts)({
  EMBED_MODAL: {
    ACTIONS: {
      EMBED_DATA_RECEIVED: true,
      EMBED_DATA_FAILED: true,
      EMBED_CONFIGURATION_CHANGED: true
    }
  }
});

var TYPES = exports.TYPES = CONSTS.EMBED_MODAL.ACTIONS;

var embedDataReceived = exports.embedDataReceived = function embedDataReceived(data) {
  _AppDispatcher.appDispatcher.dispatchAction.server({
    type: TYPES.EMBED_DATA_RECEIVED,
    data: data
  });
};

var embedDataFailed = exports.embedDataFailed = function embedDataFailed() {
  _AppDispatcher.appDispatcher.dispatchAction.server({
    type: TYPES.EMBED_DATA_FAILED
  });
};

var embedConfigurationChanged = exports.embedConfigurationChanged = function embedConfigurationChanged(configOption) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.EMBED_CONFIGURATION_CHANGED,
    configOption: configOption
  });
};

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _googleSearchVm = __webpack_require__(774);

var _googleSearchVm2 = _interopRequireDefault(_googleSearchVm);

var _GoogleSearchView = __webpack_require__(765);

var _GoogleSearchView2 = _interopRequireDefault(_GoogleSearchView);

var _pageDataObject = __webpack_require__(5);

var _component = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEARCH_BAR_FEATURE_ID = 'SearchBar'; /* eslint semi:0 */

var GoogleSearchController = function (_BaseClass) {
  (0, _inherits3.default)(GoogleSearchController, _BaseClass);

  function GoogleSearchController() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, GoogleSearchController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleSearchController.__proto__ || (0, _getPrototypeOf2.default)(GoogleSearchController)).apply(this, arguments));

    _this.vm = _googleSearchVm2.default.create(options);
    return _this;
  }

  return GoogleSearchController;
}(_BaseClass3.default);

exports.default = (0, _pageDataObject.isSupportedForDomain)(SEARCH_BAR_FEATURE_ID) ? (0, _component.make)(GoogleSearchController, _GoogleSearchView2.default) : _component.empty;

/***/ }),

/***/ 422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _SignupModalVm = __webpack_require__(772);

var _SignupModalVm2 = _interopRequireDefault(_SignupModalVm);

var _SignupModalView = __webpack_require__(767);

var _SignupModalView2 = _interopRequireDefault(_SignupModalView);

var _SignupModalStore = __webpack_require__(757);

var _SignupModalStore2 = _interopRequireDefault(_SignupModalStore);

var _component = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignupModalController = function (_BaseClass) {
  (0, _inherits3.default)(SignupModalController, _BaseClass);

  function SignupModalController() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, SignupModalController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SignupModalController.__proto__ || (0, _getPrototypeOf2.default)(SignupModalController)).call(this, options));

    var store = options.store || _SignupModalStore2.default.create(options);
    var vm = _SignupModalVm2.default.create((0, _assign2.default)({ store: store }, options));
    _this.merge({
      vm: vm,
      store: store
    });
    store.vm = vm;
    return _this;
  }

  return SignupModalController;
}(_BaseClass3.default); /* eslint semi:0 */


exports.default = (0, _component.make)(SignupModalController, _SignupModalView2.default);

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _component = __webpack_require__(70);

var _ua = __webpack_require__(9);

var _UserToolbarView = __webpack_require__(769);

var _UserToolbarView2 = _interopRequireDefault(_UserToolbarView);

var _userToolbarVm = __webpack_require__(776);

var _userToolbarVm2 = _interopRequireDefault(_userToolbarVm);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _script = __webpack_require__(19);

var _userToolbarActions = __webpack_require__(76);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var UserToolbarController = function (_BaseClass) {
  (0, _inherits3.default)(UserToolbarController, _BaseClass);

  function UserToolbarController() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, UserToolbarController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UserToolbarController.__proto__ || (0, _getPrototypeOf2.default)(UserToolbarController)).call(this));

    var store = options.store || _userStore2.default;
    _this.vm = _userToolbarVm2.default.create({ store: store });
    if (!_this.vm.store.isAuthenticated) {
      var facebookSdk = _script.external.load({ name: 'facebook' });
      facebookSdk(_userToolbarActions.fbSdkReady);
    }
    return _this;
  }

  return UserToolbarController;
}(_BaseClass3.default);

var component = (0, _ua.getIsDesktop)() ? (0, _component.make)(UserToolbarController, _UserToolbarView2.default) : _component.empty;
exports.default = component;

/***/ }),

/***/ 424:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.taboolaScriptConfig = exports.widgetMessages = undefined;

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = __webpack_require__(55);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _PAGE_TYPE_SETUP; /* eslint semi:0 */


exports.reloadTaboolaWidgets = reloadTaboolaWidgets;

var _fn = __webpack_require__(15);

var _dom = __webpack_require__(12);

var _string = __webpack_require__(46);

var _console = __webpack_require__(11);

var _ua = __webpack_require__(9);

var _preRenderedSelectorsConfig = __webpack_require__(17);

var _appStore = __webpack_require__(23);

var _pageDataObject = __webpack_require__(5);

var _window = __webpack_require__(8);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SHINEZ_POSTS = [6242836, 6296514, 6296515, 6296517, 6296519, 6296521, 6296525, 6296532, 6296536, 6296537, 6296544, 6296549, 6296551, 6296562, 6296565, 6296566, 6296568, 6296572, 6296574, 6296576, 6296578, 6296580, 6296583, 6296586, 6296587, 6296588, 6296590, 6296592, 6296593, 6296594];

var PAGE_DATA_OBJECT_FALLBACK = {
  post: {
    featured_to_site: false,
    id: null
  }
};
var post = (0, _pageDataObject.get)('post', PAGE_DATA_OBJECT_FALLBACK.post);
var isEmbedded = _ua.path.isEmbedded,
    isNativeApp = _ua.path.isNativeApp;

var IS_TABOOLA_ENABLED = true;
var IS_TABOOLA_ENABLED_IN_WEBVIEW = true;
var TABOOLA_WIDGET_CONTAINER = _preRenderedSelectorsConfig.SELECTORS.TABOOLA_WIDGET_CONTAINER;


var TABOOLA_MASTER_DOMAIN = '90min';
var TABOOLA_ROOT_PUBLISHER_ID = '90min';
var CURRENT_DOMAIN = (0, _ua.domainFromFqdn)();
var EN = _i18nProvider.AVAILABLE_LOCALES.EN,
    TH = _i18nProvider.AVAILABLE_LOCALES.TH,
    ES = _i18nProvider.AVAILABLE_LOCALES.ES,
    VN = _i18nProvider.AVAILABLE_LOCALES.VN,
    IT = _i18nProvider.AVAILABLE_LOCALES.IT,
    ID = _i18nProvider.AVAILABLE_LOCALES.ID,
    FR = _i18nProvider.AVAILABLE_LOCALES.FR,
    DE = _i18nProvider.AVAILABLE_LOCALES.DE,
    BR = _i18nProvider.AVAILABLE_LOCALES.BR,
    TR = _i18nProvider.AVAILABLE_LOCALES.TR;

var TABOOLA_ENABLED_LOCALES = {
  '90min': [EN, TH, ES, VN, IT, ID, FR, DE, TR, BR],
  floor8: [EN, ES],
  '12up': [EN, ES],
  dbltap: [EN],
  pluralist: [EN],
  german_site: [DE]
};

var noTaboola = _window.queryString.noTaboola,
    debugTaboola = _window.queryString.debugTaboola,
    delayTaboolaBySeconds = _window.queryString.delayTaboolaBySeconds;


function partnerNcrave() {
  return window.location.search.includes('trs_id=ncrave');
}

function isRevShareDeal() {
  return SHINEZ_POSTS.includes((0, _pageDataObject.getPostId)()) || _pageDataObject.postTemplate === 'slideshow' || partnerNcrave();
}

function isEnabledInWebView() {
  if (isNativeApp && CURRENT_DOMAIN !== 'esporteinterativo') {
    return IS_TABOOLA_ENABLED_IN_WEBVIEW;
  }
  return true;
}

function isLocaleInCurrentDomain() {
  return TABOOLA_ENABLED_LOCALES.hasOwnProperty(CURRENT_DOMAIN) ? TABOOLA_ENABLED_LOCALES[CURRENT_DOMAIN].includes(_i18nProvider.locale) : false;
}
function shouldLoadTaboola() {
  return IS_TABOOLA_ENABLED && !noTaboola && !isEmbedded && (0, _pageDataObject.isSupportedForDomain)('Taboola') && isEnabledInWebView() && isLocaleInCurrentDomain() && post.featured_to_site || IS_TABOOLA_ENABLED && !noTaboola && !isEmbedded && (0, _pageDataObject.isSupportedForDomain)('Taboola') && isEnabledInWebView() && isLocaleInCurrentDomain() && SHINEZ_POSTS.includes((0, _pageDataObject.getPostId)());
}

function getTaboolaPublisherIdByLocale() {
  var localeCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _i18nProvider.getShortLocale)();

  var isDefaultPublisherId = CURRENT_DOMAIN === TABOOLA_MASTER_DOMAIN && localeCode === EN;
  return isDefaultPublisherId ? TABOOLA_ROOT_PUBLISHER_ID : TABOOLA_ROOT_PUBLISHER_ID + '-' + CURRENT_DOMAIN + '-' + localeCode;
}

// function getMinuteMediaScript() {
//   // return isRevShareDeal()
//     // ? `https://cdn.taboola.com/libtrc/${getTaboolaPublisherIdByLocale()}/loader.js`
//     // : 'https://cdn.taboola.com/libtrc/90min-network/loader.js'
//   return 'https://cdn.taboola.com/libtrc/90min-network/loader.js'
// }

function getTaboolaScriptUrlByLocale() {
  var script = 'https://cdn.taboola.com/libtrc/90min-network/loader.js';
  console.log('taboola script=', script);
  return script;
}

function taboolaGlobalInit() {
  return window._taboola = window._taboola || []; // eslint-disable-line no-extra-parens
}

function pushMessagesToTaboola() {
  var _makeSafeFn$invoke;

  for (var _len = arguments.length, messages = Array(_len), _key = 0; _key < _len; _key++) {
    messages[_key] = arguments[_key];
  }

  debugTaboola && (0, _console.info)('pushMessagesToTaboola:', messages);
  (_makeSafeFn$invoke = (0, _fn.makeSafeFn)(taboolaGlobalInit).invoke()).push.apply(_makeSafeFn$invoke, messages);
  return messages;
}

function getTaboolaWidgetConfFromElementMetadata(element) {
  var id = element.id,
      _element$dataset = element.dataset,
      placement = _element$dataset.placement,
      mode = _element$dataset.modeId;

  return {
    mode: mode,
    container: id,
    placement: placement + ' ' + _pageDataObject.postTemplate
  };
}

var TABOOLA_PAGE_TYPES = {
  PHOTO: 'photo',
  VIDEO: 'video',
  SEARCH: 'search',
  ARTICLE: 'article',
  CATEGORY: 'category'
};

function getTaboolaPageType() {
  var VIDEO = TABOOLA_PAGE_TYPES.VIDEO,
      ARTICLE = TABOOLA_PAGE_TYPES.ARTICLE,
      PHOTO = TABOOLA_PAGE_TYPES.PHOTO,
      CATEGORY = TABOOLA_PAGE_TYPES.CATEGORY;

  if ((0, _pageDataObject.getHasBottomWidgetIndicator)()) {
    console.log('push video');
    return VIDEO;
  }
  if ((0, _pageDataObject.getIsTv)()) {
    console.log('push video');
    return VIDEO;
  }
  if (isRevShareDeal()) {
    console.log('photo');
    return PHOTO;
  }
  if ((0, _pageDataObject.getIsHybrid)()) {
    console.log('category');
    return CATEGORY;
  }
  console.log('article');
  return ARTICLE;
}

var TABOOLA_MESSAGES = {
  PAGE_TYPE_SETUP: (_PAGE_TYPE_SETUP = {
    // 3.3 in API documentation
    target_type: 'mix' }, (0, _defineProperty3.default)(_PAGE_TYPE_SETUP, getTaboolaPageType(), 'auto'), (0, _defineProperty3.default)(_PAGE_TYPE_SETUP, 'video_source', 'brightcove'), _PAGE_TYPE_SETUP),
  REFRESH_RECOMMENDATIONS: {
    notify: 'newPageLoad'
  },
  FLUSH_WIDGETS: {
    flush: true
  }
};

function checkTaboolaElementInViewport(opts) {
  var taboolaElement = opts.taboolaElement;

  var isTaboolaElementVisibleOnOrientationChanged = (0, _dom.isVisible)(taboolaElement);
  if (isTaboolaElementVisibleOnOrientationChanged) {
    pushMessagesToTaboola(getTaboolaWidgetConfFromElementMetadata(taboolaElement), TABOOLA_MESSAGES.FLUSH_WIDGETS);
    (0, _window.removeMatchMediaEvent)(opts);
  }
}

var TABOOLA_INITIAL_STATE = {
  widgets: []
};

var TABOOLA_ACTION_TYPES = {
  REFRESH_RECOMMENDATIONS: 'TABOOLA_REFRESH_RECOMMENDATIONS'
};

var TABOOLA_STATE_KEY = 'taboola';

function taboolaReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : TABOOLA_INITIAL_STATE;
  var action = arguments[1];

  // info('taboolaReducer', action.type, action)
  switch (action.type) {
    case TABOOLA_ACTION_TYPES.REFRESH_RECOMMENDATIONS:
      return (0, _appStore.setState)(state, action.state);
    default:
  }
  return state;
}

var FIRST_MESSAGE = TABOOLA_MESSAGES.PAGE_TYPE_SETUP,
    LAST_MESSAGE = TABOOLA_MESSAGES.FLUSH_WIDGETS,
    REFRESH_RECOMMENDATIONS = TABOOLA_MESSAGES.REFRESH_RECOMMENDATIONS;


var SLIDESHOW_COUNT_TO_REFRESH_TABOOLA_RECOMMENDATIONS = 3;

function shouldRefreshRecommendations() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var slideshow = state.slideshow;

  return slideshow && slideshow.changedSlidesCount % SLIDESHOW_COUNT_TO_REFRESH_TABOOLA_RECOMMENDATIONS === 0;
}

function collectWidgetMessagesFromDom() {
  var widgetMessages = [];
  var taboolaContainers = (0, _dom.nodes)(TABOOLA_WIDGET_CONTAINER);
  if (!taboolaContainers || !taboolaContainers.length) {
    debugTaboola && (0, _console.info)('no taboola containers found: ', { taboolaContainers: taboolaContainers });
    return widgetMessages;
  }
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(taboolaContainers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var taboolaElement = _step.value;

      var isTaboolaElementVisible = (0, _dom.isVisible)(taboolaElement);
      if (isTaboolaElementVisible) {
        debugTaboola && (0, _console.info)('visible:', taboolaElement);
        widgetMessages.push(getTaboolaWidgetConfFromElementMetadata(taboolaElement));
      } else {
        var opts = { taboolaElement: taboolaElement };
        var mqlAndHandlerObj = (0, _window.addOnLandscapeChangeEvent)(checkTaboolaElementInViewport.part(opts));
        (0, _assign2.default)(opts, mqlAndHandlerObj);
        debugTaboola && (0, _console.info)('hidden:', taboolaElement, { opts: opts });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return widgetMessages;
}

function initTaboolaWidgets(widgetMessages) {
  if (widgetMessages.length) {
    return pushMessagesToTaboola.apply(undefined, [FIRST_MESSAGE].concat((0, _toConsumableArray3.default)(widgetMessages), [LAST_MESSAGE]));
  }
  return widgetMessages;
}

function reloadTaboolaWidgets(widgetMessages) {
  debugTaboola && (0, _console.warn)('reloadTaboolaWidgets', widgetMessages);
  if (widgetMessages.length) {
    pushMessagesToTaboola(REFRESH_RECOMMENDATIONS);
    initTaboolaWidgets(widgetMessages);
    return true;
  }
  return false;
}

var widgetMessages = exports.widgetMessages = [];

var refresh = (0, _fn.once)(reloadTaboolaWidgets.part(widgetMessages));

var isRefreshing = false;

function stateListener() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _appStore.getState)();

  if (!isRefreshing) {
    isRefreshing = true;
    if (shouldRefreshRecommendations(state)) {
      refresh();
    } else {
      refresh.reset();
    }
    isRefreshing = false;
  }
}

function setupTaboola() {
  if (delayTaboolaBySeconds) {
    (0, _console.info)('Loading taboola after ' + delayTaboolaBySeconds + ' seconds.');
  }
  (0, _appStore.addReducer)(TABOOLA_STATE_KEY, taboolaReducer);
  (0, _appStore.subscribe)(stateListener);
  widgetMessages.push.apply(widgetMessages, (0, _toConsumableArray3.default)(collectWidgetMessagesFromDom()));
  debugTaboola && (0, _console.info)(widgetMessages);
  initTaboolaWidgets(widgetMessages);
}

function loadTaboolaWithDelay() {
  var secondsToDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : delayTaboolaBySeconds;

  (0, _console.warn)('Delaying taboola loading by ' + secondsToDelay + ' seconds.');
  return setTimeout(setupTaboola, secondsToDelay * 1e3);
}

var taboolaScriptConfig = exports.taboolaScriptConfig = {
  src: getTaboolaScriptUrlByLocale,
  beforeLoad: shouldLoadTaboola,
  onload: delayTaboolaBySeconds ? loadTaboolaWithDelay : setupTaboola
};

/***/ }),

/***/ 425:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.wrapButtonInLabel = wrapButtonInLabel;

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAG_NAMES = {
  BUTTON: 'button',
  ANCHOR: 'a'
}; /* eslint semi:0 */


var ATTRS = {
  IN_NEW_TAB: {
    rel: 'noopener',
    target: '_blank'
  }
};

var DEFAULTS = (0, _object.deepFreeze)({
  tagName: TAG_NAMES.BUTTON,
  type: 'button',
  shouldWrapInLabel: false,
  onclick: null,
  config: null,
  classList: ['button'],
  title: '',
  children: 'buttonText',
  isDisabled: null,
  target: null,
  isNewTab: false,
  style: null
});

function isAnchorTag(tagName, href) {
  return tagName === TAG_NAMES.ANCHOR || href || false;
}

function wrapButtonInLabel(buttonConf) {
  var tagName = buttonConf.tagName,
      href = buttonConf.href;

  if (isAnchorTag(tagName, href)) {
    return buttonConf;
  }
  return (0, _assign2.default)({}, buttonConf, { shouldWrapInLabel: true });
}

function bindCallerView(fn) {
  return fn instanceof Function && fn.bind(this) || undefined;
}

var ButtonView = function (_BaseView) {
  (0, _inherits3.default)(ButtonView, _BaseView);

  function ButtonView() {
    (0, _classCallCheck3.default)(this, ButtonView);
    return (0, _possibleConstructorReturn3.default)(this, (ButtonView.__proto__ || (0, _getPrototypeOf2.default)(ButtonView)).apply(this, arguments));
  }

  (0, _createClass3.default)(ButtonView, [{
    key: 'view',
    value: function view(ctrl) {
      var shouldWrapInLabel = this.shouldWrapInLabel,
          tagName = this.tagName,
          type = this.type,
          classList = this.classList,
          title = this.title,
          children = this.children,
          href = this.href,
          isDisabled = this.isDisabled,
          target = this.target,
          isNewTab = this.isNewTab,
          immutableAttrs = this.immutableAttrs,
          style = this.style,
          onclick = this.onclick,
          config = this.config;

      var isAnchor = isAnchorTag(tagName, href);
      var tagSpecificImmutableAttrs = void 0;
      if (isAnchor) {
        tagName = TAG_NAMES.ANCHOR;
        tagSpecificImmutableAttrs = { href: href, target: target };
        if (isNewTab) {
          (0, _assign2.default)(tagSpecificImmutableAttrs, ATTRS.IN_NEW_TAB);
        }
      } else {
        tagSpecificImmutableAttrs = { type: type };
      }
      (0, _assign2.default)(immutableAttrs, tagSpecificImmutableAttrs);
      onclick = bindCallerView(onclick);
      config = bindCallerView(config);
      var disabled = isDisabled instanceof Function ? bindCallerView.call(this, isDisabled) : isDisabled;
      var attrs = { onclick: onclick, title: title, style: style, config: config, disabled: disabled };
      var classes = classList.join('.');
      var buttonEl = (0, _mithril2.default)('' + tagName + immutableAttrs + '.' + classes, (0, _object.removeFalsyValues)(attrs), children);
      return shouldWrapInLabel ? (0, _mithril2.default)('label.' + classes, buttonEl) : buttonEl;
    }
  }, {
    key: 'DEFAULTS',
    get: function get() {
      return DEFAULTS;
    }
  }]);
  return ButtonView;
}(_BaseView3.default);

exports.default = ButtonView;

/***/ }),

/***/ 426:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkbox = exports.optionTag = exports.select = exports.textarea = exports.requiredInput = exports.hiddenInput = exports.DEFAULTS = exports.INPUT_TYPES = exports.TAG_NAMES = exports.CLASS_NAMES = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAMES = {
  VISITED: 'visited'
};

var TAG_NAMES = {
  INPUT: 'input',
  TEXTAREA: 'textarea',
  SELECT: 'select'
};

var TEXTAREA = TAG_NAMES.TEXTAREA,
    SELECT = TAG_NAMES.SELECT,
    INPUT = TAG_NAMES.INPUT;


var INPUT_TYPES = {
  TEXT: 'text',
  HIDDEN: 'hidden',
  CHECKBOX: 'checkbox',
  EMAIL: 'email',
  RADIO: 'radio'
};

var TEXT = INPUT_TYPES.TEXT,
    HIDDEN = INPUT_TYPES.HIDDEN,
    CHECKBOX = INPUT_TYPES.CHECKBOX;


var DEFAULTS = (0, _object.deepFreeze)({
  tagName: INPUT,
  type: TEXT,
  onclick: null,
  onchange: null,
  config: null,
  classList: [],
  autofocus: false,
  title: null,
  children: null,
  siblings: null,
  isDisabled: false,
  isReadonly: false,
  isRequired: false,
  placeholder: null,
  maxlength: null,
  minlength: null,
  style: null,
  name: null,
  value: null,
  pattern: null,
  id: null,
  spellcheck: null,
  misvalidationMessage: null
});

exports.CLASS_NAMES = CLASS_NAMES;
exports.TAG_NAMES = TAG_NAMES;
exports.INPUT_TYPES = INPUT_TYPES;
exports.DEFAULTS = DEFAULTS;


function bindCallerView(fn) {
  return fn instanceof Function && fn.bind(this) || undefined;
}

var InputView = function (_BaseView) {
  (0, _inherits3.default)(InputView, _BaseView);

  function InputView() {
    (0, _classCallCheck3.default)(this, InputView);
    return (0, _possibleConstructorReturn3.default)(this, (InputView.__proto__ || (0, _getPrototypeOf2.default)(InputView)).apply(this, arguments));
  }

  (0, _createClass3.default)(InputView, [{
    key: 'view',
    value: function view(ctrl) {
      var tagName = this.tagName,
          id = this.id,
          type = this.type,
          classList = this.classList,
          title = this.title,
          autofocus = this.autofocus,
          isDisabled = this.isDisabled,
          isReadonly = this.isReadonly,
          isRequired = this.isRequired,
          value = this.value,
          pattern = this.pattern,
          placeholder = this.placeholder,
          minlength = this.minlength,
          maxlength = this.maxlength,
          name = this.name,
          immutableAttrs = this.immutableAttrs,
          style = this.style,
          onclick = this.onclick,
          onchange = this.onchange,
          config = this.config,
          children = this.children,
          siblings = this.siblings,
          misvalidationMessage = this.misvalidationMessage;

      onclick = bindCallerView(onclick);
      config = bindCallerView(config);
      // Values of these attributes may be dynamic and may contain strings, which may be interpreted as selectors.
      var attrs = {
        onclick: onclick,
        onchange: onchange,
        config: config,
        name: name,
        pattern: pattern,
        value: value,
        disabled: isDisabled,
        readonly: isReadonly
        // Values of these attributes aren't expected to change.
      };(0, _assign2.default)(immutableAttrs, {
        required: isRequired,
        placeholder: placeholder,
        // FIXME: this doesn't work because BaseView doesn't compare value with the DEFAULTS.
        // spellcheck: [undefined, null, ].includes(spellcheck) ? false : spellcheck.toString(),
        minlength: minlength,
        maxlength: maxlength,
        autofocus: autofocus,
        title: title,
        style: style,
        type: tagName === INPUT ? type : null,
        id: id
      });
      var classes = classList.join('.');
      var inputView = (0, _mithril2.default)('' + tagName + immutableAttrs + '.' + classes, (0, _object.removeFalsyValues)(attrs), children);
      var currentView = [inputView];
      if (siblings) {
        currentView = currentView.concat(siblings);
      }
      if (misvalidationMessage) {
        currentView.push((0, _mithril2.default)('.misvalidation-message', misvalidationMessage));
      }
      return currentView;
    }
  }, {
    key: 'DEFAULTS',
    get: function get() {
      return DEFAULTS;
    }
  }]);
  return InputView;
}(_BaseView3.default);

exports.default = InputView;


function optionTag(text) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { value: '', isSelected: false };
  var value = props.value,
      selected = props.isSelected;

  return (0, _mithril2.default)('option', { value: value, selected: selected }, text);
}

function inheritedInput() {
  for (var _len = arguments.length, opts = Array(_len), _key = 0; _key < _len; _key++) {
    opts[_key] = arguments[_key];
  }

  return InputView.create(_assign2.default.apply(Object, [{}].concat(opts))).view();
}

var select = inheritedInput.part({ tagName: SELECT });
var checkbox = inheritedInput.part({ type: CHECKBOX });
var hiddenInput = inheritedInput.part({ type: HIDDEN });
var textarea = inheritedInput.part({ tagName: TEXTAREA });
var requiredInput = inheritedInput.part({ isRequired: true });

exports.hiddenInput = hiddenInput;
exports.requiredInput = requiredInput;
exports.textarea = textarea;
exports.select = select;
exports.optionTag = optionTag;
exports.checkbox = checkbox;

/***/ }),

/***/ 428:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendMessage = exports.closeMessageBox = exports.openMessageBox = exports.SEND_FAILED = exports.SEND_SUCCESS = exports.CLOSE_MESSAGE_BOX = exports.OPEN_MESSAGE_BOX = undefined;

var _PrivateMessages = __webpack_require__(777);

var OPEN_MESSAGE_BOX = exports.OPEN_MESSAGE_BOX = '[messageUser] message box opened';
var CLOSE_MESSAGE_BOX = exports.CLOSE_MESSAGE_BOX = '[messageUser] message box closed';
var SEND_SUCCESS = exports.SEND_SUCCESS = '[messageUser] successfully sent a private message';
var SEND_FAILED = exports.SEND_FAILED = '[messageUser] failed to send a private message';

var openMessageBox = exports.openMessageBox = function openMessageBox() {
  return { type: OPEN_MESSAGE_BOX };
};

var closeMessageBox = exports.closeMessageBox = function closeMessageBox() {
  return { type: CLOSE_MESSAGE_BOX };
};

var sendMessage = exports.sendMessage = function sendMessage(msg, to) {
  return function (dispatch) {
    var provider = new _PrivateMessages.PrivateMessagesProvider();

    provider.send(msg, to).then(function () {
      return dispatch({ type: SEND_SUCCESS });
    }).catch(function (e) {
      return dispatch({ type: SEND_FAILED, e: e });
    });
  };
};

/***/ }),

/***/ 429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getTopAdHeight = exports.getTopAdHeight = function getTopAdHeight(state) {
  return state.topAd.topAdHeight;
};

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _weakSet = __webpack_require__(323);

var _weakSet2 = _interopRequireDefault(_weakSet);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _nm = __webpack_require__(26);

var _nm2 = _interopRequireDefault(_nm);

var _console = __webpack_require__(11);

var _string = __webpack_require__(46);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * BaseClass, which is used for legacy Mithril Views,
 * Flux Stores and VMs. Don't use in new features.
 */
var MUST_OVERRIDE_METHOD_ERROR_MESSAGE = 'Must implement this method in subclass';

function addCurriedConsoleMethod(curriedMethods, method) {
  curriedMethods[method.methodName] = method.curry('[' + this.constructor.name + ']');
  return curriedMethods;
}

function curryConsoleMethods() {
  for (var _len = arguments.length, consoleMethods = Array(_len), _key = 0; _key < _len; _key++) {
    consoleMethods[_key] = arguments[_key];
  }

  // I have no idea why, but calling Array.from(...consoleMethods)
  // didn't work and Array.from(arguments) does.
  return (0, _from2.default)(arguments).reduce(addCurriedConsoleMethod.bind(this), (0, _object.create)());
}

var BaseClass = function () {
  (0, _createClass3.default)(BaseClass, [{
    key: 'DEFAULTS',
    get: function get() {
      return (0, _object.create)();
    }
  }], [{
    key: 'MUST_OVERRIDE_METHOD_ERROR_MESSAGE',
    get: function get() {
      return MUST_OVERRIDE_METHOD_ERROR_MESSAGE;
    }
  }]);

  function BaseClass() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, BaseClass);

    this.merge(curryConsoleMethods.call(this, _console.info, _console.log, _console.warn, _console.error), { options: options });

    var constructor = this.constructor;

    var className = constructor.name;
    var baseClassNamePlural = (0, _string.getLastWordFromCamelCase)(className) + 's';
    var baseClassNamePluralLower = baseClassNamePlural.toLowerCase();
    // Register classes in namespace
    var classes = _nm2.default.classes = _nm2.default.classes || (0, _object.create)();
    classes[baseClassNamePlural] = classes[baseClassNamePlural] || (0, _object.create)();
    classes[baseClassNamePlural][className] = constructor;
    // Register instances in namespace
    var instances = _nm2.default.instances = _nm2.default.instances || (0, _object.create)();
    instances[baseClassNamePluralLower] = instances[baseClassNamePluralLower] || new _weakSet2.default();
    instances[baseClassNamePluralLower].add(this);
  }

  (0, _createClass3.default)(BaseClass, [{
    key: 'merge',
    value: function merge() {
      for (var _len2 = arguments.length, sources = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        sources[_key2] = arguments[_key2];
      }

      _assign2.default.apply(Object, [this].concat(sources));
      return this;
    }
  }], [{
    key: 'create',
    value: function create() {
      var _classFactory;

      return (_classFactory = (0, _object.classFactory)(this)).create.apply(_classFactory, arguments);
    }
  }]);
  return BaseClass;
}();

exports.default = BaseClass;

/***/ }),

/***/ 430:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getIsMobile = exports.getIsMobile = function getIsMobile(state) {
  return state.userDevice.isMobile;
};

var getIsMobileOrTablet = exports.getIsMobileOrTablet = function getIsMobileOrTablet(state) {
  return state.userDevice.isMobile || state.userDevice.isTablet;
};

var getIsTabletInPortrait = exports.getIsTabletInPortrait = function getIsTabletInPortrait(state) {
  return state.userDevice.isTabletInPortrait;
};

/***/ }),

/***/ 431:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserStats = exports.FETCH_USER_STATS_SUCCESS = exports.FETCH_USER_STATS_FAILED = undefined;

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

var _userActionCounterProvider = __webpack_require__(778);

var api = _interopRequireWildcard(_userActionCounterProvider);

var _console = __webpack_require__(11);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_USER_STATS_FAILED = exports.FETCH_USER_STATS_FAILED = '[userStats] failed to fetch user stats';
var FETCH_USER_STATS_SUCCESS = exports.FETCH_USER_STATS_SUCCESS = '[userStats] fetched user stats successfully';

// TODO: delete this mockApi when done.
var mockApi = {
  fetchUserActionCounter: function fetchUserActionCounter(_ref) {
    var userId = _ref.userId;

    (0, _console.info)('fetching ' + userId + ' stats');

    return new _promise2.default(function (resolve) {
      resolve({
        postCreate: 104570,
        readsGot: 300,
        commentsGot: 400
      });
    });
  }
};

function apiFactory() {
  // replace "true" with url params
  return true ? api : mockApi;
}

var fetchUserStats = exports.fetchUserStats = function fetchUserStats(id) {
  return function (dispatch) {
    var api = apiFactory();

    api.fetchUserActionCounter({ userId: id }).then(function (response) {
      if (typeof response.error !== 'undefined') {
        dispatch({ type: FETCH_USER_STATS_FAILED });
        return;
      }

      dispatch({
        type: FETCH_USER_STATS_SUCCESS,
        response: response
      });
    }).catch(function () {
      return dispatch({ type: FETCH_USER_STATS_FAILED });
    });
  };
};

/***/ }),

/***/ 432:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coverShareButtonsNotInView = coverShareButtonsNotInView;
exports.coverShareButtonsInView = coverShareButtonsInView;
exports.titleAboveOrBellowViewport = titleAboveOrBellowViewport;
exports.scrollDirectionChanged = scrollDirectionChanged;
exports.userScrollUpTrend = userScrollUpTrend;
var COVER_SHARE_BUTTONS_NOT_IN_VIEW = exports.COVER_SHARE_BUTTONS_NOT_IN_VIEW = '[visibility] cover share buttons not in view';
function coverShareButtonsNotInView() {
  return {
    type: COVER_SHARE_BUTTONS_NOT_IN_VIEW
  };
}

var COVER_SHARE_BUTTONS_IN_VIEW = exports.COVER_SHARE_BUTTONS_IN_VIEW = '[visibility] cover share buttons in view';
function coverShareButtonsInView() {
  return {
    type: COVER_SHARE_BUTTONS_IN_VIEW
  };
}

var TITLE_ABOVE_OR_BELOW_VIEWPORT = exports.TITLE_ABOVE_OR_BELOW_VIEWPORT = '[visibility] title above viewport';
function titleAboveOrBellowViewport(isAbove) {
  return {
    type: TITLE_ABOVE_OR_BELOW_VIEWPORT,
    payload: { isAbove: isAbove }
  };
}

var SCROLL_DIRECTION_CHANGED = exports.SCROLL_DIRECTION_CHANGED = '[visibility] user changed scroll direction';
function scrollDirectionChanged(isScrollUp) {
  return {
    type: SCROLL_DIRECTION_CHANGED,
    payload: { isScrollUp: isScrollUp }
  };
}

var SCROLL_UP_TREND = exports.SCROLL_UP_TREND = '[visibility] user  scroll up trend';
function userScrollUpTrend(isScrollUpTrend) {
  return {
    type: SCROLL_UP_TREND,
    payload: { isScrollUpTrend: isScrollUpTrend }
  };
}

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_LOCATION = exports.COUNTRIES_IN_EUROPE = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

exports.getLastKnownCountryCode = getLastKnownCountryCode;
exports.getCountryCode = getCountryCode;

var _ua = __webpack_require__(9);

var _string = __webpack_require__(46);

var _window = __webpack_require__(8);

var _mithril = __webpack_require__(54);

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

var _safeLocalStorageProvider = __webpack_require__(178);

var _safeLocalStorageProvider2 = _interopRequireDefault(_safeLocalStorageProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var _require = __webpack_require__(11),
    info = _require.info;

var GEOLOCATION_API_ENDPOINT = '//geoip.90min.com';
var GEOLOCATION_STORAGE_KEY = 'NM_GEOLOCATION';

var COUNTRIES_IN_EUROPE = exports.COUNTRIES_IN_EUROPE = ['AU', 'IT', 'BE', 'LV', 'BG', 'LT', 'HR', 'LU', 'CY', 'MT', 'CZ', 'NL', 'DK', 'PL', 'EE', 'PT', 'FI', 'RO', 'FR', 'SK', 'DE', 'SI', 'GR', 'ES', 'HU', 'SE', 'IE', 'GB'];

var countryCodeQsOverride = _window.queryString.countryCode;
// I used an empty string (instead of null) to avoid checking for !== null
// each time you'll want to use String class methods on it.
var NO_LOCATION = exports.NO_LOCATION = 'no-location';
var QS_DELETE_COUNTRY_CODE = 'delete';

var countryCodePromise = null;

var isDeleteCountryCodeQs = countryCodeQsOverride === QS_DELETE_COUNTRY_CODE;

function getCountryCodeFromQsOverride() {
  var override = void 0;
  if (countryCodeQsOverride && (0, _string.isString)(countryCodeQsOverride) && !isDeleteCountryCodeQs) {
    override = countryCodeQsOverride.toUpperCase();
    info('[QS] overriding countryCode with \'' + countryCodeQsOverride + '\'');
  }
  return override;
}

function getCountryCodeFromLocalStorage() {
  return _safeLocalStorageProvider2.default.get(GEOLOCATION_STORAGE_KEY);
}

var currentCountryCode = getCountryCodeFromQsOverride() || getCountryCodeFromLocalStorage();

function getLastKnownCountryCode() {
  return currentCountryCode || NO_LOCATION;
}

function cacheCurrentCountryCode(countryCode) {
  currentCountryCode = countryCode;
  _safeLocalStorageProvider2.default.set(GEOLOCATION_STORAGE_KEY, countryCode);
}

function getCountryCodeFromApi() {
  return (0, _mithril.safeRequest)({
    method: 'GET',
    url: GEOLOCATION_API_ENDPOINT
  });
}

function deleteCountryCode() {
  currentCountryCode = NO_LOCATION;
  _safeLocalStorageProvider2.default.remove(GEOLOCATION_STORAGE_KEY);
  countryCodePromise = null;
}

if (isDeleteCountryCodeQs) {
  info('[QS] deleting current countryCode');
  deleteCountryCode();
}

function getCountryCode() {
  return countryCodePromise || (countryCodePromise = new _promise2.default(function getCountryCodePromise(resolve, reject) {
    if (currentCountryCode) {
      return resolve(currentCountryCode);
    }
    getCountryCodeFromApi().then(function cacheCountryCodeAndResolve(_ref) {
      var countryCode = _ref.countryCode;

      cacheCurrentCountryCode(countryCode);
      resolve(countryCode);
    }, reject);
  }));
}

function refreshCountryCode() {
  deleteCountryCode();
  return getCountryCode();
}

var countryCodeProvider = (0, _assign2.default)((0, _object.create)(), {
  getCountryCode: getCountryCode,
  get currentCountryCode() {
    return getLastKnownCountryCode();
  },
  delete: deleteCountryCode,
  refresh: refreshCountryCode,
  NO_LOCATION: NO_LOCATION
});

(0, _nm.registerInNamespace)({ countryCodeProvider: countryCodeProvider });

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _get = __webpack_require__(436);

var _get2 = _interopRequireDefault(_get);

var _ownKeys = __webpack_require__(827);

var _ownKeys2 = _interopRequireDefault(_ownKeys);

exports.default = reduxMount;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _dom = __webpack_require__(12);

var _reactDom = __webpack_require__(116);

var _console = __webpack_require__(11);

var _mountedComponent = __webpack_require__(702);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Safari has a bug in iOS9 and 10 sometimes it can't retrieve data attributes
// https://bugs.webkit.org/show_bug.cgi?id=161454
// workaround: https://gist.github.com/anonymous/db9f7359c81e1887fc72dd918dfe5975
function fixSafariDatasetBug(dataset) {
  return (0, _ownKeys2.default)(dataset).filter(function (key) {
    return key !== 'constructor';
  }).reduce(function (map, key) {
    map[key] = (0, _get2.default)(dataset, key);
    return map;
  }, {});
} /* eslint semi:0 */
/**
 * Handles mounting React components and registering with our Redux runtime.
 */


function renderMountedComponent(container, rootNode) {
  var dataset = fixSafariDatasetBug(rootNode.dataset);
  var mountedComponentProps = {
    container: container,
    options: { rootNode: rootNode, dataset: dataset }
  };
  return (0, _reactDom.render)(_react2.default.createElement(_mountedComponent.MountedComponent, mountedComponentProps), rootNode);
}

function dispatchMountAndRender(container, domNodes) {
  return (0, _from2.default)(domNodes, renderMountedComponent.bind(null, container));
}

function mountComponent() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var container = opts.container,
      rootSelector = opts.rootSelector;

  var domNodes = (0, _dom.nodes)(rootSelector);
  if (domNodes && domNodes.length > 0) {
    dispatchMountAndRender(container, domNodes);
    return true;
  }
  (0, _console.warn)('Container \'' + container.name + '\' can\'t be mounted: \'' + rootSelector + '\' selector result is empty!', { opts: opts, container: container, rootSelector: rootSelector, domNodes: domNodes });
  return false;
}

function reduxMount() {
  var selectorComponentMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  for (var rootSelector in selectorComponentMap) {
    var container = selectorComponentMap[rootSelector];
    if (rootSelector === 'undefined') {
      (0, _console.warn)('mountComponent selector not defined in preRenderedSelectorsConfig: ', selectorComponentMap);
      continue;
    }
    mountComponent({ container: container, rootSelector: rootSelector });
  }
}

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacesToDots = exports.getLastWordFromCamelCase = exports.unCapitalizeFirstLetter = exports.capitalizeFirstLetter = exports.toCamelCase = exports.toLowerCase = exports.toUpperCase = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.camelCaseToDashDelimited = camelCaseToDashDelimited;
exports.randId = randId;
exports.isString = isString;

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classof = Object.classof;

var CLASS_OF_STRING = classof('');

function borrowMethod(Type, methodName) {
  return Function.prototype.call.bind(Type.prototype[methodName]);
}

var toUpperCase = exports.toUpperCase = borrowMethod(String, 'toUpperCase');
var toLowerCase = exports.toLowerCase = borrowMethod(String, 'toLowerCase');

function transformFirstLetterCase(firstLetterTransformFn, str) {
  return firstLetterTransformFn(str.charAt(0)) + str.slice(1);
}

function camelCaseToDashDelimited(myStr) {
  return toLowerCase(myStr.replace(/([a-z])([A-Z])/g, '$1-$2'));
}
var toCamelCase = exports.toCamelCase = function toCamelCase(str) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '_';
  return toLowerCase(str).replace(new RegExp(delimiter + '([a-z])', 'g'), function (word) {
    return toUpperCase(word[1]);
  });
};

function randId() {
  return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
}

var capitalizeFirstLetter = exports.capitalizeFirstLetter = transformFirstLetterCase.part(toUpperCase);

var unCapitalizeFirstLetter = exports.unCapitalizeFirstLetter = transformFirstLetterCase.part(toLowerCase);

var getLastWordFromCamelCase = exports.getLastWordFromCamelCase = function getLastWordFromCamelCase(str) {
  return str.split(/(?=[A-Z][^A-Z]+$)/).pop();
};

var spacesToDots = exports.spacesToDots = function spacesToDots(str) {
  return str.toString().replace(' ', '.');
};

function isString(obj) {
  return classof(obj) === CLASS_OF_STRING;
}

var string = (0, _assign2.default)((0, _object.create)(), {
  toLowerCase: toLowerCase,
  toUpperCase: toUpperCase,
  toCamelCase: toCamelCase,
  camelCaseToDashDelimited: camelCaseToDashDelimited,
  randId: randId,
  capitalizeFirstLetter: capitalizeFirstLetter,
  unCapitalizeFirstLetter: unCapitalizeFirstLetter,
  getLastWordFromCamelCase: getLastWordFromCamelCase,
  spacesToDots: spacesToDots,
  isString: isString
});

(0, _nm.registerUtils)({ string: string });

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ads = exports.excludedComponents = exports.postTemplate = exports.get = exports.objectPathPdo = undefined;

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _set = __webpack_require__(254);

var _set2 = _interopRequireDefault(_set);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.getIsEmbededPost = getIsEmbededPost;
exports.getEnvironment = getEnvironment;
exports.getIsQaEnv = getIsQaEnv;
exports.getIsTopX = getIsTopX;
exports.getIsTv = getIsTv;
exports.getIsSlideshow = getIsSlideshow;
exports.getIsPostReader = getIsPostReader;
exports.getIsArticle = getIsArticle;
exports.getIsDraft = getIsDraft;
exports.getIsNative = getIsNative;
exports.getIsHybrid = getIsHybrid;
exports.getIsFull = getIsFull;
exports.getHasBottomWidgetIndicator = getHasBottomWidgetIndicator;
exports.getPostUrl = getPostUrl;
exports.getLeaguesForFixtures = getLeaguesForFixtures;
exports.getCampaigns = getCampaigns;
exports.getIsPostPage = getIsPostPage;
exports.getPageType = getPageType;
exports.getRequestUrl = getRequestUrl;
exports.getPageLocale = getPageLocale;
exports.getPageDomain = getPageDomain;
exports.getPostAuthorId = getPostAuthorId;
exports.getSiteDomainWithTld = getSiteDomainWithTld;
exports.getReactionsList = getReactionsList;
exports.getNextPosts = getNextPosts;
exports.getPostEmbedCodePath = getPostEmbedCodePath;
exports.getSite = getSite;
exports.getPostCategoriesSet = getPostCategoriesSet;
exports.getPostCategories = getPostCategories;
exports.getPostId = getPostId;
exports.getPostTitle = getPostTitle;
exports.getDistributionChannels = getDistributionChannels;
exports.isSupportedForDomain = isSupportedForDomain;
exports.getPostMediaTypes = getPostMediaTypes;
exports.getPostMainMediaType = getPostMainMediaType;
exports.getPostBodyMediaTypes = getPostBodyMediaTypes;
exports.getIsPostMainMediaImage = getIsPostMainMediaImage;
exports.getPostActionsPath = getPostActionsPath;
exports.getPostActionsFromPdo = getPostActionsFromPdo;
exports.getApiServicesEndpoints = getApiServicesEndpoints;
exports.getGTMIds = getGTMIds;
exports.getGTMData = getGTMData;
exports.getRecommendedPosts = getRecommendedPosts;

var _console = __webpack_require__(11);

var _objectPath = __webpack_require__(488);

var _objectPath2 = _interopRequireDefault(_objectPath);

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

var _adsConfig = __webpack_require__(27);

var _window = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
/**
 * PDO is our mechanism to pass site, page, and configuration data to
 * the client. It is passed in the page head as a script with mimetype
 * "application/json". Here we read, parse it and add methods based on
 * it's payload.
 */
var PAGE_DATA_OBJECT_ID = '_page_data_object';
var pageDataObject = null;
var pageDataObjectEl = document.getElementById(PAGE_DATA_OBJECT_ID); // Don't import utils/dom to avoid circular dependencies
var pageDataObjectTextcontent = pageDataObjectEl && pageDataObjectEl.textContent;

try {
  pageDataObject = (0, _assign2.default)((0, _object.create)(), JSON.parse(pageDataObjectTextcontent));
} catch (ex) {
  (0, _console.error)("Can't read or parse pageDataObject:", ex, {
    ex: ex,
    pageDataObjectEl: pageDataObjectEl,
    id: PAGE_DATA_OBJECT_ID,
    pageDataObjectTextcontent: pageDataObjectTextcontent
  });
}

var objectPathPdo = exports.objectPathPdo = (0, _objectPath2.default)(pageDataObject);
var getFromPdo = objectPathPdo.get;
var get = exports.get = getFromPdo;

var adsConfPath = getFromPdo('page.ads_conf', {
  dfp_client_id: '175840252' // eslint-disable-line camelcase
});
var shouldShowAds = 'should_show_ads?' in adsConfPath ? adsConfPath['should_show_ads?'] : true; // show ads by default!
var _adsConfPath$original = adsConfPath.original,
    adsConfOriginal = _adsConfPath$original === undefined ? {} : _adsConfPath$original;

var adsConfOriginalPath = {
  clientId: adsConfOriginal.dfp_client_id,
  property: adsConfOriginal.property,
  channel: adsConfOriginal.channel,
  pageType: adsConfOriginal.page_type
};
var postLayout = getFromPdo('post.layout');
var POST_LAYOUTS = {
  EMBED: 'embed',
  NATIVE: 'native',
  HYBRID: 'hybrid',
  FULL: 'full',
  DRAFT: 'preview'
};

var HAS_BOTTOM_WIDGET_INDICATOR_LABEL_NAME = 'bottom-embed';

var postTemplate = exports.postTemplate = getFromPdo('post.template');
var POST_TEMPLATES = {
  SLIDESHOW: 'slideshow',
  READER: 'reader',
  TV: 'tv',
  TOPX: 'topx',
  ARTICLE: 'article'
};

var excludedComponents = exports.excludedComponents = getFromPdo('config.excluded_components', []);

var ENVIRONMENT_NAMES = {
  PROD: 'production',
  DEV: 'development'
};

var postCategoriesSet = void 0;

function getIsEmbededPost() {
  return postLayout === POST_LAYOUTS.EMBED;
}

function getEnvironment() {
  return getFromPdo('config.env', ENVIRONMENT_NAMES.PROD);
}

function getIsQaEnv() {
  var DEV = ENVIRONMENT_NAMES.DEV,
      PROD = ENVIRONMENT_NAMES.PROD;

  return ![DEV, PROD].includes(getEnvironment());
}

function getIsTopX() {
  return postTemplate === POST_TEMPLATES.TOPX;
}

function getIsTv() {
  return postTemplate === POST_TEMPLATES.TV;
}

function getIsSlideshow() {
  return postTemplate === POST_TEMPLATES.SLIDESHOW;
}

function getIsPostReader() {
  return postTemplate === POST_TEMPLATES.READER;
}

function getIsArticle() {
  return postTemplate === POST_TEMPLATES.ARTICLE;
}

function getIsDraft() {
  return postLayout === POST_LAYOUTS.DRAFT;
}

function getIsNative() {
  return postLayout === POST_LAYOUTS.NATIVE;
}

function getIsHybrid() {
  return postLayout === POST_LAYOUTS.HYBRID;
}

function getIsFull() {
  return postLayout === POST_LAYOUTS.FULL;
}

function getHasBottomWidgetIndicator() {
  return getPostCategories().includes(HAS_BOTTOM_WIDGET_INDICATOR_LABEL_NAME);
}

function getPostUrl() {
  return getFromPdo('post.url');
}

function getLeaguesForFixtures() {
  return getFromPdo('config.leagues_for_edition.edition_legaues', {});
}

function getCampaigns() {
  return getFromPdo('config.campaigns', {});
}

function getIsPostPage() {
  return getFromPdo('page.type') === 'post';
}

function getPageType() {
  return getFromPdo('page.type');
}

function getRequestUrl() {
  return getFromPdo('page.requestUrl');
}

function getPageLocale() {
  return getFromPdo('page.locale');
}

function getPageDomain() {
  return getFromPdo('post.author.site');
}

function getPostAuthorId() {
  return getFromPdo('post.author.id');
}

function getSiteDomainWithTld() {
  return getFromPdo('context.domain');
}

function getReactionsList() {
  return getFromPdo('post.reactions');
}

function getNextPosts() {
  return getFromPdo('post.next_posts');
}

function getPostEmbedCodePath() {
  return getFromPdo('post.embed_code_path') || '/posts/' + getPostId() + '/embed_code';
}

function getSite() {
  return getFromPdo('context.site');
}

function getPostCategoriesSet() {
  return postCategoriesSet || (postCategoriesSet = function lazyGetPostCategoriesSet() {
    var overridePostCategories = _window.queryString.overridePostCategories;

    var fakeCategories = overridePostCategories && overridePostCategories.split(',');
    return new _set2.default(fakeCategories || getFromPdo('post.categories', []));
  }());
}

function getPostCategories() {
  return [].concat((0, _toConsumableArray3.default)(getPostCategoriesSet()));
}

function getPostId() {
  return getFromPdo('post.id', 0);
}

function getPostTitle() {
  return getFromPdo('post.title', '') || '';
}

function getDistributionChannels() {
  return getFromPdo('post.distribution_channels', []);
}

function isSupportedForDomain(componentName) {
  return !excludedComponents.includes(componentName);
}

var ads = exports.ads = {
  adsConfPath: adsConfPath,
  clientId: adsConfPath.dfp_client_id,
  property: adsConfPath.property,
  channel: adsConfPath.channel,
  pageType: adsConfPath.page_type,
  original: adsConfOriginalPath,
  shouldShowAds: shouldShowAds,
  isProSeven: shouldShowAds && adsConfPath['is_pro7?'] || false,
  getPropWithQsOverride: _window.getPossiblyOverriddenPropByQsWithPrefix.bind(adsConfOriginalPath, _adsConfig.ADS_QUERYSTRING_OVERRIDE_PREFIXES),

  get hierarchyLevels() {
    var getPropWithQsOverride = this.getPropWithQsOverride,
        clientId = this.clientId,
        property = this.property,
        channel = this.channel,
        pageType = this.pageType;

    var staticProps = {
      delimiter: '/',
      l0: getPropWithQsOverride('clientId', clientId),
      l1: getIsSlideshow() ? 'Slideshow' : getPropWithQsOverride('property', property),
      l2: getIsSlideshow() ? getPropWithQsOverride('property', property) : getPropWithQsOverride('channel', channel),
      l3: getPropWithQsOverride('pageType', pageType),
      format: 'DefaultFormat',
      toString: function adLevelsToString() {
        var l0 = this.l0,
            l1 = this.l1,
            l2 = this.l2,
            l3 = this.l3,
            l4 = this.l4,
            delimiter = this.delimiter;

        return [l0, l1, l2, l3, l4].join(delimiter);
      },
      get mainLevels() {
        return Object.make({
          toString: function mainLevelsToString() {
            var property = this.property,
                channel = this.channel,
                pageType = this.pageType; // eslint-disable-line no-shadow

            return [property, channel, pageType].join(staticProps.delimiter);
          }
        }, {
          property: this.l1,
          channel: this.l2,
          pageType: this.l3
        });
      }
    };
    return Object.define(staticProps, {
      set l4(format) {
        this.format = format;
      },
      get l4() {
        return this.formatWithQsOverride;
      },
      get formatWithQsOverride() {
        var format = this.format;

        return getPropWithQsOverride('format-' + format, format);
      }
    });
  }
};

function getPostMediaTypes() {
  return getFromPdo('post.template_data.media_type', []);
}

function getPostMainMediaType() {
  return getPostMediaTypes()[0] || null;
}

function getPostBodyMediaTypes() {
  return getPostMediaTypes().slice(1);
}

function getIsPostMainMediaImage() {
  return (getPostMainMediaType() || '').match(/image/i);
}

function getPostActionsPath() {
  return getFromPdo('post.admin_options_path');
}

function getPostActionsFromPdo() {
  return getFromPdo('post.post_actions');
}

function getApiServicesEndpoints() {
  return getFromPdo('config.api');
}

function getGTMIds() {
  return getFromPdo('config.gtm.ids');
}

function getGTMData() {
  function getFormatedDateFromEpoc(unixDate) {
    var d = new Date(unixDate * 1000);
    var rawMonth = d.getMonth() + 1;
    var rawDay = d.getDate();
    var month = rawMonth < 10 ? '0' + rawMonth : rawMonth;
    var day = rawDay < 10 ? '0' + rawDay : rawDay;
    return [d.getFullYear(), month, day, d.getHours(), d.getMinutes()].join('');
  }

  var pageData = {
    pageType: getPageType(),
    pageIdentifier: getFromPdo('page.identifier'),
    language: getPageLocale(),
    property: getSiteDomainWithTld(),
    markupFormat: 'web'
  };

  if (getPageType() === 'post') {
    pageData.articleAuthor = getFromPdo('post.author.name');
    pageData.articleId = getFromPdo('post.id');
    pageData.articleTitle = getPostTitle();
    pageData.articleTemplate = postTemplate;
    pageData.articlePublicationTime = getFormatedDateFromEpoc(getFromPdo('post.created_at'));
    pageData.contentTags = [].concat((0, _toConsumableArray3.default)(getFromPdo('post.content_tags')), ['']).join(';');
    pageData.behaviorLabels = [].concat((0, _toConsumableArray3.default)(getFromPdo('post.behavior_labels')), ['']).join(';') || 'none';
    pageData.distributionChannels = [].concat((0, _toConsumableArray3.default)(getFromPdo('post.distribution_channels')), ['']).join(';');
  }

  return pageData;
}

var publicPdo = (0, _object.create)({
  getIsEmbededPost: getIsEmbededPost,
  postTemplate: postTemplate,
  getEnvironment: getEnvironment,
  getIsQaEnv: getIsQaEnv,
  getIsTopX: getIsTopX,
  getIsTv: getIsTv,
  getIsSlideshow: getIsSlideshow,
  getIsPostReader: getIsPostReader,
  getIsDraft: getIsDraft,
  getIsNative: getIsNative,
  getIsHybrid: getIsHybrid,
  getIsFull: getIsFull,
  getLeaguesForFixtures: getLeaguesForFixtures,
  getCampaigns: getCampaigns,
  getIsPostPage: getIsPostPage,
  getPageType: getPageType,
  getRequestUrl: getRequestUrl,
  getPageLocale: getPageLocale,
  getPageDomain: getPageDomain,
  getReactionsList: getReactionsList,
  getPostCategoriesSet: getPostCategoriesSet,
  getPostCategories: getPostCategories,
  getPostId: getPostId,
  isSupportedForDomain: isSupportedForDomain,
  ads: ads,
  getPostMediaTypes: getPostMediaTypes,
  getPostMainMediaType: getPostMainMediaType,
  getPostBodyMediaTypes: getPostBodyMediaTypes,
  getIsPostMainMediaImage: getIsPostMainMediaImage,
  getSiteDomainWithTld: getSiteDomainWithTld
});

publicPdo = (0, _assign2.default)(publicPdo, objectPathPdo);
if (!publicPdo.has('config.ads')) {
  publicPdo.set('config.ads', _adsConfig.adsConfig);
}

// TODO: Render adsConfig on server

(0, _nm.registerInNamespace)({ pdo: publicPdo });

function getRecommendedPosts() {
  return getNextPosts();
  // const posts = [
  //   {
  //     image_url:
  //       'https://images0.minutemediacdn.com/development/912x516/593fbf8bbc46c820ff000006.jpg',
  //     title: 'Sat oh the cuddled and that pithily since chameleon regretful',
  //     author_name: 'Rocky Balboa',
  //     url:
  //       'http://www.90min.com/posts/5740008-inter-working-on-deal-to-sign-jiangsu-suning-midfielder-ramires-ahead-of-transfer-january',
  //   },
  //   {
  //     image_url:
  //       'https://images1.minutemediacdn.com/production/912x516/59f6fc432ee40f73a8000001.jpg',
  //     title: 'No Choice: Morata Reveals He Did Not Want to Leave Juventus for Real Madrid Return',
  //     author_name: 'Rocky Balboa',
  //     url:
  //       'http://www.90min.com/posts/5739898-no-choice-morata-reveals-he-did-not-want-to-leave-juventus-for-real-madrid-return',
  //   },
  //   {
  //     image_url:
  //       'https://images0.minutemediacdn.com/production/912x516/59f6f7c6d915b204e1000003.jpg',
  //     title:
  //       'PHOTO: Increasingly Desperate ISIS at it Again After Photoshopping Neymar & Messi into New Poster',
  //     author_name: 'Rocky Balboa',
  //     url:
  //       'http://www.90min.com/posts/5739792-photo-increasingly-desperate-isis-at-it-again-after-photoshopping-neymar-messi-into-new-poster',
  //   },
  // ]
  // return posts
}

exports.default = publicPdo;

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLASS_CONSTATNTS = exports.videoAdStarted = exports.adBlockDetectionFinished = exports.allSlotsRendered = exports.slotRendered = exports.slotHide = exports.requestingAds = exports.TYPES = undefined;

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _appStore = __webpack_require__(23);

var _AppDispatcher = __webpack_require__(56);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_CONSTATNTS = (0, _object.namespacedConsts)({
  ADS: {
    ACTIONS: {
      SLOT_HIDE: true,
      SLOT_RENDERED: true,
      ALL_SLOTS_RENDERED: true,
      AD_BLOCK_DETECTION_FINISHED: true,
      VIDEO_AD_STARTED: true,
      REQUESTING_ADS: true
    }
  }
});

var TYPES = exports.TYPES = CLASS_CONSTATNTS.ADS.ACTIONS;

var requestingAds = exports.requestingAds = function requestingAds(adType) {
  _AppDispatcher.appDispatcher.dispatchAction.window({
    type: TYPES.REQUESTING_ADS,
    adType: adType
  });
};

var slotHide = exports.slotHide = function slotHide(adId) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.SLOT_HIDE,
    adId: adId
  });
};

var slotRendered = exports.slotRendered = function slotRendered(slotRenderedEvent) {
  var adId = slotRenderedEvent.adId,
      isEmpty = slotRenderedEvent.isAdEmpty,
      adRenderedEvent = slotRenderedEvent.adRenderedEvent,
      size = slotRenderedEvent.size;

  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.SLOT_RENDERED,
    adId: adId,
    size: size,
    isEmpty: isEmpty,
    event: adRenderedEvent,
    dispatchToRedux: true,
    payload: (0, _extends3.default)({}, slotRenderedEvent)
  });
};

var allSlotsRendered = exports.allSlotsRendered = function allSlotsRendered(events) {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.ALL_SLOTS_RENDERED,
    events: events
  });
};

var adBlockDetectionFinished = exports.adBlockDetectionFinished = function adBlockDetectionFinished(state) {
  (0, _appStore.dispatch)({
    type: TYPES.AD_BLOCK_DETECTION_FINISHED,
    state: state
  });
};

var videoAdStarted = exports.videoAdStarted = function videoAdStarted(payload) {
  _AppDispatcher.appDispatcher.dispatchAction.external({
    type: TYPES.VIDEO_AD_STARTED,
    payload: payload
  });
};
exports.CLASS_CONSTATNTS = CLASS_CONSTATNTS;

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.externalScriptsConfig = exports.SCRIPT_LOADER_CONF_DEFAULTS = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _ua = __webpack_require__(9);

var _taboolaScriptConfig = __webpack_require__(424);

var _gtmScriptConfig = __webpack_require__(713);

var _amplitudeScriptConfig = __webpack_require__(711);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _fn = __webpack_require__(15);

var _nm = __webpack_require__(26);

var _facebookPixelScript = __webpack_require__(712);

var _facebookPixelScript2 = _interopRequireDefault(_facebookPixelScript);

var _headerBidderScriptConfig = __webpack_require__(247);

var _headerBidderScriptConfig2 = _interopRequireDefault(_headerBidderScriptConfig);

var _object = __webpack_require__(13);

var _browsiScriptConfig = __webpack_require__(314);

var _pageContext = __webpack_require__(61);

var _pageDataObject = __webpack_require__(5);

var _googleSearchActions = __webpack_require__(311);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trafficSrcId = _window.queryString.trs_id; /* eslint semi:0 */

var affiliateId = (0, _pageContext.getInfluencerId)();

var externalScriptsConfig = {
  facebookPixel: _facebookPixelScript2.default,
  browsi: _browsiScriptConfig.browsiScriptConfig,

  googleAnalytics: {
    src: 'https://www.google-analytics.com/analytics.js',
    beforeLoad: function beforeLoad() {
      window.GoogleAnalyticsObject = 'ga';
      var ga = window.ga = window.ga || function setGoogleAnalyticsQ() {
        ;(ga.q = ga.q || []).push(arguments);
      };
      ga.l = 1 * new Date();
      ga('create', (0, _pageDataObject.get)('config.google_analytics.account_id'), 'auto');
      // for double-click: https://support.google.com/analytics/answer/3450482
      ga('require', 'displayfeatures');
    }
  },

  gtmAnalytics: (0, _gtmScriptConfig.getGtmScriptConfig)((0, _pageDataObject.getGTMIds)(), (0, _pageDataObject.getGTMData)()),

  amplitude: (0, _amplitudeScriptConfig.getAmplitudeScriptConfig)(),

  comscore: {
    src: 'https://sb.scorecardresearch.com/beacon.js',
    beforeLoad: function beforeLoad() {
      window._comscore = window._comscore || [];
      window._comscore.push((0, _extends3.default)({}, (0, _pageDataObject.get)('config.comscore.account')));
    }
  },
  agof: { src: 'https://script.ioam.de/iam.js' },

  facebook: {
    src: 'https://connect.facebook.net/' + (0, _pageDataObject.get)('config.facebook.sdk_locale', 'en_US') + '/sdk.js',
    onload: (0, _fn.makeSafeFn)(function onFacebookSdkLoaded() {
      window.FB.init({
        appId: (0, _pageDataObject.get)('config.facebook.app_id'),
        version: (0, _pageDataObject.get)('config.facebook.api_version'),
        cookie: true,
        xfbml: true
      });
    })
  },

  twitter: { src: 'https://platform.twitter.com/widgets.js' },
  riddle: { src: 'https://www.riddle.com/files/js/embed.min.js' },

  googleSearch: {
    src: 'https://www.google.com/cse/cse.js?cx=' + (0, _pageDataObject.get)('config.google_search.cx'),
    beforeLoad: function beforeLoad() {
      window.__gcse = { callback: _googleSearchActions.ready };
    }
  },

  zoomd: {
    src: 'https://zdwidget3-bs.sphereup.com/zoomd/SearchUi/Script?clientId=' + getZoomdConfig(),
    name: 'zoomd'
  },

  taboolaScriptConfig: _taboolaScriptConfig.taboolaScriptConfig,
  headerBidder: _headerBidderScriptConfig2.default,

  dfp: {
    src: 'https://www.googletagservices.com/tag/js/gpt.js',
    beforeLoad: function beforeLoad() {
      var inAppConditions = (0, _pageDataObject.getIsHybrid)() && !(0, _pageDataObject.getIsEmbededPost)() && !affiliateId && !(0, _pageDataObject.getIsTopX)() && !(0, _pageDataObject.getIsSlideshow)();
      return (0, _ua.getIsNativeApp)() ? inAppConditions : true;
    }
  },

  youtube: {
    src: 'https://www.youtube.com/iframe_api',
    name: 'youtubeAPI'
  },

  freshEightMX: {
    src: 'https://fresh8.co/391499/embed.js?view=Article',
    name: 'freshEightMX'
  },
  freshEightGB: {
    src: 'https://fresh8.co/874248/embed.js?view=article',
    name: 'freshEightGB'
  },

  arcadium: {
    src: 'https://inhabit-service.cdn.arkadiumhosted.com/Widget/v1/',
    name: 'arcadium'
  },
  playgorithm: {
    src: 'https://create.playgorithm.com/js/init.js?containerId=playgorithm-unit-531&token=eyJzaXRlSWQiOjE5MCwiZW1iZWRJZCI6NTMxLCJ0b2tlbiI6IiQyeSQxMCR5d1wvM2pVWFgzeFhGdHJ6a3VyODlXT005ZEJiYlN2YVF3azB0d1wvVHI4WHpXRFl5NFBjUW5HIiwidGltZXN0YW1wIjoxNTQ2NTUxOTU1fQ==&origin=https://frontend.playgorithm.net&customComp=MinuteMedia&className=mm-playgorithm-unit&gtagId=UA-23669758-17&height=360px',
    name: 'playgorithm'
  },
  jwplayer: {
    src: function src(playerId) {
      return 'https://content.jwplatform.com/libraries/' + playerId + '.js';
    }
  },

  playbuzz: { src: 'https://cdn.playbuzz.com/widget/feed.js' },

  monti: {
    src: function src() {
      return 'https://www.oo-syringe.com/prod/players/mplayer_wrapper_v3_latest.js';
    }
  },

  montiSEOtest: {
    src: function src() {
      return 'https://www.oo-syringe.com/qa/players/mplayer_wrapper.3.2.9.js';
    }
  },

  newscorp: {
    src: '//www.ballball.com/static/js/enhanced_player/1.1/enhanced_player_host.js'
  },

  // perimeterX: {
  //   src: 'https://client.a.pxi.pub/PXszbKVa5M/main.min.js',
  //   beforeLoad() {
  //     Object.assign(window, {
  //       _pxAppId: 'PXszbKVa5M',
  //       _pxParam1: affiliateId,
  //       _pxParam3: trafficSrcId,
  //       _pxPubHost: 'collector.a',
  //     })
  //   },
  // },

  jQuery: { src: 'https://code.jquery.com/jquery-2.1.4.min.js' }
};

var SCRIPT_LOADER_CONF_DEFAULTS = exports.SCRIPT_LOADER_CONF_DEFAULTS = {
  defer: true,
  onload: _fn.noop,
  beforeLoad: function beforeLoad() {
    return true;
  }
};

function getZoomdConfig() {
  return typeof (0, _pageDataObject.get)('config.zoomd_search') !== 'undefined' ? (0, _pageDataObject.get)('config.zoomd_search') : (0, _pageDataObject.get)('zoomd_search');
}

function addNamePropertyToScriptConf(scriptConf, scriptName) {
  var scriptConfName = scriptConf.name || scriptName;
  var src = scriptConf.src;

  if (!src) {
    var falsySrcErrorMessage = 'Falsy src (\'' + src + '\') in scriptConf name \'' + scriptConfName + '\'!';
    (0, _console.warn)(falsySrcErrorMessage, { scriptConf: scriptConf, scriptConfName: scriptConfName });
  }
  scriptConf.name = scriptConfName;
}

(0, _assign2.default)((0, _object.iterate)(externalScriptsConfig, addNamePropertyToScriptConf), {
  defaults: SCRIPT_LOADER_CONF_DEFAULTS
});

(0, _nm.registerUtils)({ externalScriptsConfig: externalScriptsConfig });

exports.externalScriptsConfig = externalScriptsConfig;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAFFIC_INFO_KEY = exports.DIRECT_TRAFFIC_ID = exports.APP_TRAFFIC_ID = exports.DIRECT_TRAFFIC_SOURCE = exports.REFERRAL_TRAFFIC_SOURCE = exports.EMAIL_TRAFFIC_SOURCE = exports.SHARE_TRAFFIC_SOURCE = exports.RSS_TRAFFIC_SOURCE = exports.NAVIGATION_TRAFFIC_SOURCE = exports.ORGANIC_TRAFFIC_SOURCE = exports.PARTNER_TRAFFIC_SOURCE = exports.SOCIAL_TRAFFIC_SOURCE = exports.PAID_TRAFFIC_SOURCE = exports.SYNDICATION_TRAFFIC_SOURCE = exports.EMBED_PARTNER_TRAFFIC_SOURCE = exports.APP_TRAFFIC_SOURCE = exports.INFLUENCER_TRAFFIC_SOURCE = exports.UNKNOWN_TRAFFIC_ID = exports.UNKNOWN_TRAFFIC_SOURCE = exports.PLATFORM_REGEXES = exports.SEARCH_PLATFORMS = exports.SOCIAL_PLATFORMS = undefined;

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _PLATFORM_REGEXES;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FACEBOOK = 'facebook';
var TWITTER = 'twitter';
var INSTAGRAM = 'instagram';
var REDDIT = 'reddit';
var GOOGLE = 'google';
var BING = 'bing';
var YAHOO = 'yahoo';

var SOCIAL_PLATFORMS = exports.SOCIAL_PLATFORMS = {
  FACEBOOK: FACEBOOK,
  TWITTER: TWITTER,
  INSTAGRAM: INSTAGRAM,
  REDDIT: REDDIT
};

var SEARCH_PLATFORMS = exports.SEARCH_PLATFORMS = {
  GOOGLE: GOOGLE,
  BING: BING,
  YAHOO: YAHOO
};

var PLATFORM_REGEXES = exports.PLATFORM_REGEXES = (_PLATFORM_REGEXES = {}, (0, _defineProperty3.default)(_PLATFORM_REGEXES, FACEBOOK, [/^facebook\./, /\.facebook\./]), (0, _defineProperty3.default)(_PLATFORM_REGEXES, TWITTER, [/^twitter\./, /\.twitter\./, /^t\.co/]), (0, _defineProperty3.default)(_PLATFORM_REGEXES, INSTAGRAM, [/^instagram\./, /\.instagram\./]), (0, _defineProperty3.default)(_PLATFORM_REGEXES, REDDIT, [/^reddit\./, /\.reddit\./]), (0, _defineProperty3.default)(_PLATFORM_REGEXES, GOOGLE, [/^google\./, /\.google\./, /googleapi/, /googlequicksearchbox/, /amp-12up-com/, /amp\.12up\.com/]), (0, _defineProperty3.default)(_PLATFORM_REGEXES, BING, [/^bing\./, /\.bing\./]), (0, _defineProperty3.default)(_PLATFORM_REGEXES, YAHOO, [/^yahoo\./, /\.yahoo\./]), _PLATFORM_REGEXES);

var UNKNOWN_TRAFFIC_SOURCE = exports.UNKNOWN_TRAFFIC_SOURCE = 'unknown';
var UNKNOWN_TRAFFIC_ID = exports.UNKNOWN_TRAFFIC_ID = null;

var INFLUENCER_TRAFFIC_SOURCE = exports.INFLUENCER_TRAFFIC_SOURCE = 'influencer';
var APP_TRAFFIC_SOURCE = exports.APP_TRAFFIC_SOURCE = 'app';
var EMBED_PARTNER_TRAFFIC_SOURCE = exports.EMBED_PARTNER_TRAFFIC_SOURCE = 'embed_partner';
var SYNDICATION_TRAFFIC_SOURCE = exports.SYNDICATION_TRAFFIC_SOURCE = 'syndication';
var PAID_TRAFFIC_SOURCE = exports.PAID_TRAFFIC_SOURCE = 'paid';
var SOCIAL_TRAFFIC_SOURCE = exports.SOCIAL_TRAFFIC_SOURCE = 'social';
var PARTNER_TRAFFIC_SOURCE = exports.PARTNER_TRAFFIC_SOURCE = 'tr_partner';
var ORGANIC_TRAFFIC_SOURCE = exports.ORGANIC_TRAFFIC_SOURCE = 'organic';
var NAVIGATION_TRAFFIC_SOURCE = exports.NAVIGATION_TRAFFIC_SOURCE = 'navigation';
var RSS_TRAFFIC_SOURCE = exports.RSS_TRAFFIC_SOURCE = 'rss';
var SHARE_TRAFFIC_SOURCE = exports.SHARE_TRAFFIC_SOURCE = 'share';
var EMAIL_TRAFFIC_SOURCE = exports.EMAIL_TRAFFIC_SOURCE = 'email';
var REFERRAL_TRAFFIC_SOURCE = exports.REFERRAL_TRAFFIC_SOURCE = 'referral';
var DIRECT_TRAFFIC_SOURCE = exports.DIRECT_TRAFFIC_SOURCE = 'direct';

var APP_TRAFFIC_ID = exports.APP_TRAFFIC_ID = null;
var DIRECT_TRAFFIC_ID = exports.DIRECT_TRAFFIC_ID = null;

var TRAFFIC_INFO_KEY = exports.TRAFFIC_INFO_KEY = 'trafficInfo';

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.m = exports.trustHtmlString = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _stringify = __webpack_require__(126);

var _stringify2 = _interopRequireDefault(_stringify);

exports.createElementWithCallback = createElementWithCallback;
exports.urlWithQs = urlWithQs;
exports.safeRequest = safeRequest;
exports.routeAndDispatch = routeAndDispatch;

var _routerActions = __webpack_require__(208);

var _pageDataObject = __webpack_require__(5);

var _object = __webpack_require__(13);

var _fn = __webpack_require__(15);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _nm = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Legacy Mithril helpers. DO NOT USE.
 */
var _require = __webpack_require__(11),
    warn = _require.warn;

function coerceToJson(xhr) {
  try {
    JSON.parse(xhr.responseText);
    return xhr.responseText;
  } catch (ex) {
    var errorResponse = {
      xhr: xhr,
      exception: ex,
      code: xhr.status,
      body: xhr.responseText
    };
    warn('mithril ajax request error:', ex.stack, errorResponse);
    return (0, _stringify2.default)(errorResponse);
  }
}

function addTimeoutForRequest(originalOptions) {
  var originalConfigFunction = originalOptions.config;
  return function configureOptions(xhr, options) {
    xhr.timeout = options.timeout;
    if ((0, _fn.isFunction)(originalConfigFunction)) {
      return originalConfigFunction.apply(this, arguments);
    }
    return xhr;
  };
}

function createElementWithCallback() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var selector = arguments.length === 1 ? 'div' : args.shift();

  var _args$pop = args.pop(),
      children = _args$pop.children,
      callback = _args$pop.callback,
      attributes = _args$pop.attributes;

  var attrs = {
    config: callback
  };
  (0, _assign2.default)(attrs, attributes);
  _mithril2.default.redraw.strategy('diff');
  return (0, _mithril2.default)(selector, attrs, children);
}

function urlWithQs(url, qs) {
  var delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '?';

  return '' + url + delimiter + _mithril2.default.route.buildQueryString(qs);
}

function safeRequest(options) {
  if (options.timeout) {
    options.config = addTimeoutForRequest(options);
  }
  if (!options.deserialize) {
    // if deserialize is not given, then by default mithril expect a JSON response
    options.extract = options.extract || coerceToJson;
  }
  if (options.url.includes('undefined')) {
    warn("safeRequest options.url includes the string 'undefined'. Most likely a mistake, isn't it?", options);
  }
  return _mithril2.default.request(options);
}

function routeAndDispatch(url) {
  //Replace current history entry instead of adding new one only for embed posts
  var shouldReplaceCurrentHistory = (0, _pageDataObject.getIsEmbededPost)();
  _mithril2.default.route(url, {}, shouldReplaceCurrentHistory);
  (0, _routerActions.routeChanged)(url);
}

exports.trustHtmlString = _mithril.trust;


var mithrilHelpers = (0, _assign2.default)((0, _object.create)(), {
  createElementWithCallback: createElementWithCallback,
  urlWithQs: urlWithQs,
  safeRequest: safeRequest,
  routeAndDispatch: routeAndDispatch,
  trustHtmlString: _mithril.trust
});

(0, _nm.registerInNamespace)({ m: _mithril2.default });
(0, _nm.registerUtils)({ mithrilHelpers: mithrilHelpers });

exports.m = _mithril2.default;

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 200 70' style='enable-background:new 0 0 200 70;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D .st1%7Bfill:%23FF9900;%7D %3C/style%3E %3Cg%3E %3Cpath class='st0' d='M179.9,11.5c3.5,0,6.6,0.4,9.3,1.2c2.7,0.8,4.9,2,6.6,3.6s2.9,3.6,3.6,6c0.7,2.4,0.8,5.2,0.3,8.4 c-0.5,3.2-1.4,6-2.9,8.5c-1.4,2.4-3.2,4.4-5.5,6c-2.2,1.6-4.8,2.8-7.7,3.6c-2.9,0.8-6.1,1.2-9.6,1.2h-10.5l-2.7,17.6 c-0.1,0.6-0.4,1.1-0.9,1.6c-0.5,0.4-1.1,0.7-1.7,0.7h-10.8c-0.6,0-1.1-0.2-1.5-0.7c-0.4-0.4-0.5-1-0.4-1.6l8.2-53.9 c0.1-0.6,0.4-1.1,0.9-1.6c0.5-0.4,1.1-0.7,1.7-0.7H179.9z M165.5,37.1h10.1c2.3,0,4.3-0.5,5.9-1.5c1.7-1,2.7-2.7,3-5 c0.3-2.3-0.2-4-1.5-5c-1.4-1-3.2-1.5-5.5-1.5h-10.1L165.5,37.1z'/%3E %3Cpath class='st0' d='M148.8,12.4c-0.4-0.4-0.9-0.4-1.5-0.4h-10.8c-0.6,0-1.2-0.1-1.7,0.4c-0.5,0.4-0.8,0.8-0.9,1.4l-4.9,32.4 c-0.5,3.3-1.7,5.8-3.6,7.7c-1.9,1.9-4.5,2.8-7.8,2.8s-5.6-0.9-6.9-2.8c-1.3-1.9-1.8-4.4-1.3-7.7l4.9-32.4c0.1-0.6,0-0.9-0.4-1.3 c-0.4-0.4-0.9-0.4-1.5-0.4h-8.7c1.2,4,1.6,8.7,0.8,13.5C103.2,35.8,95.7,44,85.8,50h13.4c1.8,0,3,1.1,2.7,2.9l-2.6,16.7 c0,0.1-0.1,0.4-0.1,0.4H115v-0.3c0,0,0.4,0,0.5,0c3.7,0,7.3-0.5,10.5-1.5c3.2-1,6.2-2.5,8.7-4.5c2.5-2,4.6-4.4,6.3-7.3 c1.6-2.9,2.8-6.2,3.3-10l4.9-32.6C149.3,13.2,149.1,12.8,148.8,12.4z'/%3E %3Cpath class='st1' d='M0.3,24.2C0,23.6-0.1,23,0.1,22.3c0.2-0.7,0.7-1.3,1.3-1.7l23-15.8c0.6-0.4,1.3-0.8,2.1-1.3 c0.8-0.5,1.7-0.8,2.7-0.8h11.7c0.7,0,1.3,0.3,1.7,0.8C43,3.9,43.2,4.5,43,5.2l-9.3,61.9c-0.1,0.7-0.5,1.3-1,1.8 c-0.6,0.5-1.2,0.8-1.9,0.8H18.2c-0.7,0-1.3-0.3-1.7-0.8c-0.4-0.5-0.6-1.1-0.5-1.8l6.3-41.9L9.6,33.9c-0.6,0.4-1.3,0.6-2,0.5 c-0.7-0.1-1.2-0.4-1.6-1L0.3,24.2z'/%3E %3Cpath class='st1' d='M100.5,23.1c-0.3,1.9-0.8,3.7-1.4,5.5s-1.6,3.5-2.8,5.2c-1.2,1.7-2.7,3.3-4.5,5c-1.8,1.6-3.9,3.3-6.4,4.9 L70.1,54.1h24.7c0.7,0,1.3,0.3,1.7,0.8c0.4,0.5,0.6,1.1,0.5,1.9l-1.6,10.4c-0.1,0.7-0.5,1.3-1.1,1.9c-0.6,0.5-1.3,0.8-2,0.8H40.5 c-0.7,0-1.3-0.3-1.7-0.8c-0.4-0.5-0.6-1.1-0.5-1.9l1.3-8.5c0.2-1,0.5-2.1,1.1-3.1c0.6-1,1.5-1.9,2.6-2.7l32.6-21 c2.5-1.7,4.2-3.3,5-4.7c0.8-1.4,1.3-2.8,1.5-4.1c0.1-0.5,0.1-1.1,0-1.9c0-0.8-0.3-1.6-0.8-2.5c-0.5-0.8-1.2-1.5-2.2-2.1 c-1-0.6-2.4-0.9-4.2-0.9c-1.8,0-3.4,0.3-4.6,0.9c-1.2,0.6-2.2,1.3-3,2.1c-0.7,0.8-1.3,1.6-1.7,2.4c-0.4,0.8-0.7,1.4-0.9,1.8 c-0.5,0.9-1.1,1.5-1.8,1.8c-0.7,0.3-1.6,0.4-2.5,0.4H48.6c-0.6,0-1.1-0.2-1.4-0.6c-0.4-0.4-0.5-0.9-0.4-1.5c0.5-2.7,1.5-5.5,3-8.2 c1.5-2.7,3.6-5.2,6.2-7.4s5.7-4,9.3-5.4C68.7,0.7,72.8,0,77.4,0c4.3,0,8,0.6,11.2,1.9c3.1,1.3,5.6,3,7.5,5.1c1.9,2.1,3.2,4.6,4,7.4 C100.8,17.2,100.9,20.1,100.5,23.1z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 543:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='283.442px' height='69.73px' viewBox='0.018 106.866 283.442 69.73' enable-background='new 0.018 106.866 283.442 69.73' xml:space='preserve'%3E %3Cg%3E %3Cg%3E %3Cpolygon fill='%23FFFFFF' points='210.742,132.999 212.535,123.311 212.954,121.278 210.861,121.278 198.482,121.278 197.046,121.278 196.807,122.713 194.833,132.999 '/%3E %3C/g%3E %3Cg%3E %3Cpolygon fill='%23FFFFFF' points='281.367,121.278 269.048,121.278 267.613,121.278 267.314,122.653 260.794,157.218 236.576,121.996 236.037,121.278 235.14,121.278 218.754,121.278 217.32,121.278 217.021,122.653 207.333,174.382 206.914,176.416 209.007,176.416 221.386,176.416 222.822,176.416 223.121,175.04 229.818,139.278 254.516,175.697 255.054,176.416 255.951,176.416 271.679,176.416 273.115,176.416 273.353,175.04 283.101,123.311 283.46,121.278 '/%3E %3C/g%3E %3Cg%3E %3Cpolygon fill='%23FFFFFF' points='194.056,137.245 187.06,174.441 186.701,176.474 188.794,176.474 201.113,176.474 202.548,176.474 202.847,175.04 209.964,137.245 '/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23FFFFFF' d='M190.587,121.278h-18.658h-0.896l-0.538,0.718l-23.622,33.429l-10.645-32.951l-0.358-1.196h-1.256h-22.426 c1.555,2.452,2.811,5.083,3.768,7.834c1.435,4.186,2.153,8.611,2.153,13.097c-0.06,4.484-0.837,8.851-2.333,13.037 c-1.495,4.006-3.588,7.773-6.279,11.123c-2.691,3.349-5.861,6.159-9.449,8.432c-0.957,0.598-1.914,1.137-2.871,1.674h20.631h1.436 l0.239-1.435l6.817-36.419l11.123,36.598l0.359,1.197h1.256h8.611h0.897l0.538-0.777l24.758-36.479l-6.578,35.224l-0.359,2.033 H169h11.781h1.436l0.238-1.436l9.748-51.729l0.359-2.033h-1.975V121.278z'/%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath fill='%23FF9900' d='M111.889,130.547c-1.256-3.588-3.11-6.997-5.442-9.987c-2.332-2.99-5.143-5.562-8.312-7.654 c-3.229-2.093-6.758-3.708-10.465-4.605c-2.811-0.718-5.681-1.076-8.552-1.076c-10.705,0-20.333,4.903-26.671,12.558 c2.332,4.485,3.468,9.628,3.05,14.711c-0.239,2.571-0.777,5.023-1.675,7.415c-0.478,1.196-0.957,2.392-1.555,3.528 c-0.359,0.719-0.718,1.376-1.136,2.034c-1.315,2.511-2.631,5.022-3.947,7.534c0,0.061-0.06,0.12-0.06,0.18 c1.555,3.768,3.768,7.236,6.519,10.166c2.751,2.99,5.98,5.502,9.568,7.355c3.648,1.914,7.655,3.17,11.781,3.648 c4.066,0.479,8.193,0.239,12.14-0.658c3.768-0.896,7.296-2.392,10.585-4.484c3.169-2.033,6.04-4.605,8.432-7.535 c2.392-2.99,4.306-6.339,5.622-9.928c1.375-3.707,2.033-7.654,2.093-11.601C113.803,138.261,113.205,134.255,111.889,130.547z M97.955,149.803c-1.495,3.528-3.947,6.578-7.057,8.731c-3.169,2.271-6.937,3.527-10.824,3.768c-0.299,0-0.658,0-0.957,0 c-3.887,0-7.774-1.137-11.063-3.23c-3.169-2.033-5.801-5.022-7.416-8.432c-1.674-3.588-2.332-7.595-1.794-11.542 c0.539-3.827,2.153-7.475,4.605-10.405c2.452-2.93,5.741-5.143,9.329-6.279c3.768-1.196,7.894-1.315,11.721-0.239 c3.708,1.017,7.056,3.05,9.628,5.861c2.571,2.811,4.365,6.339,5.083,10.106C99.929,142.089,99.45,146.156,97.955,149.803z M49.815,124.626c-1.196-3.647-3.169-6.997-5.801-9.748s-5.861-4.904-9.389-6.279c-2.87-1.137-5.98-1.734-9.09-1.734 c-3.947,0-7.834,0.897-11.362,2.691c-3.409,1.674-6.398,4.126-8.731,7.116c-2.392,2.99-4.066,6.579-4.844,10.346 c-0.837,3.828-0.777,7.954,0.239,11.781c0.957,3.708,2.811,7.176,5.262,10.106c2.452,2.871,5.562,5.203,9.09,6.758 c2.99,1.316,6.279,2.094,9.568,2.152l-8.492,16.146l-1.316,2.512h2.871h12.2h1.076l0.479-0.896 c0.538-1.017,1.017-2.033,1.555-3.05c1.255-2.452,2.511-4.903,3.767-7.355c1.555-2.99,3.11-6.04,4.725-9.03 c1.435-2.631,2.871-5.322,4.306-8.014c0.598-1.136,1.256-2.271,1.854-3.408c1.196-2.272,2.093-4.665,2.631-7.176 C51.37,133.238,51.13,128.753,49.815,124.626z M35.881,136.707l-0.538,1.077l-0.359,0.658c-2.332,3.648-6.638,5.682-10.943,5.143 c-3.828-0.479-7.236-2.99-8.791-6.518c-1.615-3.588-1.196-7.894,1.076-11.123c2.093-2.93,5.562-4.724,9.15-4.724 c3.887,0,7.595,2.093,9.628,5.382C36.958,129.59,37.256,133.417,35.881,136.707z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 23.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 824.87 178.13' style='enable-background:new 0 0 824.87 178.13;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cg%3E %3Cpath class='st0' d='M121.3,158.72c-7.91,6.47-17.26,11.5-27.81,14.86c-9.11,3.12-18.94,4.56-29.49,4.56H0V7.69h64.01 c9.83,0,20.14,1.68,29.49,4.56c10.55,3.36,19.9,8.39,27.81,14.86c8.87,7.19,15.58,16.3,20.38,26.85 c5.27,11.26,7.91,24.45,7.91,39.31c0,14.14-2.64,27.33-7.91,38.83C137.12,142.41,130.17,151.29,121.3,158.72z M117.94,93.27 c0-19.42-6.23-33.56-18.22-42.19c-9.59-7.19-22.53-10.78-37.63-10.78H31.64v105.23h30.45c19.42,0,31.16-5.51,37.63-10.31 C111.71,126.83,117.94,112.45,117.94,93.27z'/%3E %3Cpath class='st0' d='M274.33,165.67c-9.59,7.91-23.01,12.46-36.44,12.46h-77.91V7.69h65.45c15.1,0,27.09,2.88,36.44,8.63 c12.7,7.91,19.42,21.34,19.42,40.03c0,20.85-11.75,31.4-11.75,31.4s22.77,8.39,22.77,36.68c0,9.82-1.92,18.7-5.76,26.37 C283.44,156.55,279.36,161.59,274.33,165.67z M191.62,78.17h38.35c5.51,0,10.31-1.68,13.66-4.55c3.84-3.6,5.99-8.87,5.99-15.83 c0-4.79-1.44-8.63-4.32-11.5c-3.84-4.08-10.79-6.24-20.14-6.24h-33.56V78.17z M260.9,125.15c0-5.75-2.88-10.54-8.39-13.91 c-4.07-2.63-9.35-4.31-14.38-4.31h-46.51v38.83h45.79c1.92,0,7.43-0.48,12.7-3.11C257.06,139.06,260.9,133.06,260.9,125.15z'/%3E %3Cpath class='st0' d='M336.48,7.69v138.55h77.67v31.89H304.6V7.69H336.48z'/%3E %3Cpath class='st0' d='M772.13,117.72h-42.91v60.41h-31.88V7.69h74.79c12.94,0,26.37,5.03,35.48,13.42 c11.75,10.79,17.26,23.97,17.26,41.48c0,21.34-9.35,34.27-17.26,41.47C798.26,112.69,785.32,117.72,772.13,117.72z M769.74,84.16 c8.39,0,14.39-2.15,18.46-6.23c3.36-3.6,5.03-8.87,5.03-15.34c0-6.48-1.68-11.75-5.03-15.11c-4.07-4.07-10.07-6.23-18.46-6.23 h-40.51v42.9H769.74z'/%3E %3Cpolygon class='st0' points='476.17,7.69 379.4,7.69 379.4,39.58 379.4,41.05 444.29,41.05 444.29,178.13 476.17,178.13 476.17,41.05 541.71,41.05 541.71,7.69 '/%3E %3Cpath class='st0' d='M601.41,0l-7.17,14.52L587.03,0l-87.97,178.11h14.38l0,0h21.98h13.5h36.89l3.49,0v-25.76l-28.4,0l33.36-71.76 l33.67,71.76l-28.68,0v25.76h13.92v0h41.23h12.57h22.91L601.41,0z M601.42,11.27l80.38,161.84h-8.8L597.04,20.15L601.42,11.27z M584.29,173.11h-9.01v-15.76l9.01,0V173.11z M556.36,150.24l-0.98,2.11h-8.87l40.52-87.15l4.45,9.49L556.36,150.24z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='EI' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 200 60.3' style='enable-background:new 0 0 200 60.3;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D .st1%7Bfill:%23E20613;%7D %3C/style%3E %3Cg id='Colorido_-_Branco_4_'%3E %3Cg%3E %3Cpath class='st0' d='M57.8,24.2L36.1,2.5c-3.3-3.3-8.7-3.3-12,0L2.5,24.2c-3.3,3.3-3.3,8.7,0,12l21.6,21.7c3.3,3.3,8.7,3.3,12,0 l21.7-21.7C61.1,32.9,61.1,27.5,57.8,24.2z'/%3E %3Cpath class='st1' d='M29.9,25.2l0.2,0.5l0.4,1.3c1.8,5.8-2.4,8.7-4.6,9.5l-5.9,2l2.4,7l17.7-6l1.2,3.6c1,3-0.6,6.2-3.5,7.2 l-14.6,5l1.2,1.2c3.1,3.1,8.2,3.1,11.4,0l6.5-6.5c1.7-1.7,2.3-4.2,1.5-6.4l-5.4-15.9c-1.7-5.1,1-10.6,6.1-12.4l0.5-0.1l6.6,19.2 c0.7,2.1,0.7,4.3,0.1,6.3l4.6-4.6c3.1-3.1,3.1-8.2,0-11.4L44.2,12.6L34.3,16l-3.1-9l2.9-1c1-0.4,2.1-0.5,3.1-0.4l-1.4-1.4 c-3.1-3.1-8.2-3.1-11.4,0l-8,8l12.9-4.4l2.9,8.9l-17.6,6l2.3,6.8l8.7-2.9h-0.2'/%3E %3Cpath class='st1' d='M5.7,27.9C5.2,26.5,5,25,5.1,23.6L4,24.7c-3.1,3.1-3.1,8.2,0,11.4l6.8,6.8L5.7,27.9z'/%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath class='st0' d='M115.4,7.5h-8.3H106H77.8c-2.8,0-5.1,2.3-5.1,5.1v18.5h13.4c0,0,6.5,0,9.5,0c2.4,0,4.8,0,6.7-1.6 c1.9-1.6,2.4-4,2.4-6.4c0-3.8-2.5-5.5-5.8-6.4l-1.6-0.5c-1.1-0.3-2.7-0.9-2.7-2.3c0-1.3,1.5-1.4,2.6-1.4c0.9,0,3.7,0,5.9,0 c1.6,0,2.9,1.3,2.9,3v12.1c0,1.9,1.6,3.5,3.5,3.5h2.5h0.1l0,0c0,0,0-0.8,0-1.7v-6.2h3.5c5.4,0,8.4-2.4,8.4-8 C124,9.9,120.5,7.5,115.4,7.5z M83.7,16.7h-4.9v-3.9h9.6c-0.2,0.6-0.3,1.3-0.3,2.1c0,4.6,2.5,5.6,6.4,6.7c1.3,0.4,3.7,1,3.7,2.7 s-2.2,1.8-3.7,1.8H86h-7.3V22h3.6c1.8,0,3.3-1.5,3.3-3.3v-1.9l0,0 M113.2,18.4h-1v-5.9h1c2.4,0,4.4,0,4.4,3 C117.6,18.4,115.4,18.4,113.2,18.4z M137,6.7c-6.8,0-13,5-13,12.1c0,7.6,5.5,13,13,13s13-5.4,13-13C150.1,11.8,143.8,6.7,137,6.7 z M137,26c-3.7,0-6.7-3-6.7-7c0-3.3,3-6.2,6.7-6.2s6.7,3,6.7,6.2C143.7,23,140.7,26,137,26z M196.6,16.7h-4.8v-3.9h8.2v-2.7 c0-1.4-1.1-2.5-2.5-2.5h-9.4h-2.4H160h-2.7h-6.5v23.6h6.1v-9.1h0.1l5.8,9.1h7.6l-7.4-9.7c3.3-0.6,5.2-3.4,5.2-6.7 c0-0.8-0.1-1.4-0.2-2.1h5.8v16.1c0,0.5,0,2.3,0,2.3l0,0l0,0h2.7c1.9,0,3.5-1.6,3.5-3.5V12.7h5.7v18.4H200v-5.2h-8.2v-4.1h3.8 c1.7,0,3.1-1.4,3.1-3.1v-2.1 M157.5,18.1H157v-5.9h0.6c2,0,4.3,0.4,4.3,2.9C161.8,17.7,159.6,18.1,157.5,18.1z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M96.7,25.8c-0.2,0-0.4,0.1-0.6,0.1C96.3,25.8,96.5,25.8,96.7,25.8z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M98.3,24.2c0,0.2,0,0.4-0.1,0.6C98.3,24.6,98.3,24.4,98.3,24.2L98.3,24.2z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M97.9,25.1c-0.1,0.1-0.3,0.2-0.4,0.3C97.7,25.4,97.8,25.3,97.9,25.1z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M101.5,30c-0.5,0.3-1,0.5-1.6,0.7C100.5,30.6,101,30.3,101.5,30z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M104.4,25.8c-0.1,0.6-0.3,1.1-0.6,1.6C104.1,26.9,104.3,26.4,104.4,25.8z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M102.2,29.5c0.5-0.4,0.9-0.8,1.2-1.3C103.1,28.7,102.7,29.1,102.2,29.5z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M173.8,28.9L173.8,28.9c0,0.1,0,0.1,0,0.2C173.8,29,173.8,28.9,173.8,28.9z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M137,31.9c-7.6,0-13-5.4-13-13l0,0C124,26.5,129.4,31.9,137,31.9s13-5.4,13-13l0,0 C150.1,26.5,144.6,31.9,137,31.9z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M108.8,31.1c-0.5-0.1-0.9-0.3-1.2-0.5C107.9,30.8,108.4,31,108.8,31.1z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M112.2,23.3v6.2c0,0.6,0,1.7,0,1.7s0-1,0-1.7V23.3L112.2,23.3z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M104.7,23.2c0,0.6,0,1.2-0.1,1.8C104.7,24.4,104.7,23.8,104.7,23.2c0-0.3,0-0.6-0.1-0.9 C104.7,22.6,104.7,22.9,104.7,23.2z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M120.6,22.2c-0.7,0.4-1.4,0.6-2.2,0.8C119.2,22.9,120,22.6,120.6,22.2z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M106.6,29.6c0.3,0.4,0.6,0.7,0.9,0.9C107.2,30.3,106.9,30,106.6,29.6z'/%3E %3C/g%3E %3Cpath class='st0' d='M75,53h-2.3V34.6H75V53z M78.2,33.7L92,48.2V34.6h2.3v19.1L80.5,39.3V53h-2.3V33.7z M102.5,53h-2.3V36.7h-4.4 v-2.1h11v2.1h-4.4V53H102.5z M108.6,34.6h9.9v2.1h-7.6v5.1h7.4v2.1h-7.4v6.9h7.6v2.1h-9.9V34.6z M132.7,53H130l-5.4-7.8h-0.9V53 h-2.3V34.6h2.8c1.6,0,3.4,0,4.8,0.9c1.5,0.9,2.4,2.6,2.4,4.4c0,2.6-1.8,4.8-4.4,5.1L132.7,53z M123.6,43.3h0.7 c2.3,0,4.9-0.4,4.9-3.4c0-2.9-2.7-3.3-5-3.3h-0.6V43.3z M137.1,48.4L135,53h-2.5l8.8-19.1l8.8,19.1h-2.5l-2.1-4.6H137.1z M141.4,38.8l-3.3,7.4h6.5L141.4,38.8z M154.7,53h-2.3V36.7H148v-2.1h11v2.1h-4.4L154.7,53L154.7,53z M163,53h-2.3V34.6h2.3V53z M172.5,48.2l5.5-13.6h2.5l-8,19.3l-8-19.3h2.5L172.5,48.2z M200,43.8c0,5.5-4.3,9.6-9.6,9.6s-9.6-4.1-9.6-9.6 c0-5.3,4.4-9.6,9.6-9.6S200,38.5,200,43.8z M197.7,43.8c0-4-3-7.4-7.3-7.4s-7.3,3.4-7.3,7.4c0,4.2,3.4,7.4,7.3,7.4 C194.4,51.2,197.7,48,197.7,43.8z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E%3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 902.33 195.87' style='enable-background:new 0 0 902.33 195.87;' xml:space='preserve'%3E%3Cstyle type='text/css'%3E.st0%7Bfill:none%7D.st1%7Bfill:%23FFF%7D%3C/style%3E%3Cg%3E %3Cg%3E %3Ccircle class='st0' cx='804.39' cy='97.94' r='80.57'/%3E %3Cpath class='st1' d='M804.39,195.87c-54,0-97.94-43.93-97.94-97.94S750.39,0,804.39,0s97.94,43.93,97.94,97.94 S858.39,195.87,804.39,195.87z M804.39,11.83c-47.48,0-86.1,38.63-86.1,86.1s38.63,86.1,86.1,86.1s86.1-38.63,86.1-86.1 S851.87,11.83,804.39,11.83z'/%3E %3C/g%3E %3Cpath class='st1' d='M829.48,86.18c-1.88-2.22-4.28-4.09-7.16-5.6c2.13-1.3,3.94-2.87,5.43-4.69c2.79-3.41,4.21-7.39,4.21-11.82 c0-5.62-2.59-10.6-7.71-14.79c-4.96-4.06-11.58-6.12-19.67-6.12c-8.18,0-14.84,2.1-19.8,6.24c-5.11,4.26-7.69,9.38-7.69,15.2 c0,4.41,1.37,8.4,4.06,11.87c1.46,1.88,3.27,3.52,5.42,4.89c-2.78,1.38-5.09,3.12-6.92,5.21c-3.11,3.56-4.69,7.74-4.69,12.41 c0,6.99,2.83,12.73,8.4,17.06c5.37,4.17,12.51,6.29,21.21,6.29c8.7,0,15.84-2.12,21.21-6.29l0,0c5.58-4.33,8.4-10.07,8.4-17.06 C834.19,94.19,832.61,89.88,829.48,86.18z M790.78,65.23c0-2.83,1.04-5.11,3.17-6.97c2.21-1.93,5.79-2.9,10.62-2.9 c4.71,0,8.24,0.97,10.49,2.87c2.15,1.82,3.2,3.97,3.2,6.57c0,2.84-1.15,5.25-3.52,7.36c-2.46,2.19-5.37,3.25-8.9,3.25 c-4.51,0-8.27-1.03-11.15-3.07C792.03,70.47,790.78,68.2,790.78,65.23z M820.28,98.24c0,3.59-1.25,6.38-3.82,8.52 c-2.68,2.23-6.68,3.36-11.89,3.36c-5.03,0-9-1.1-11.8-3.26c-2.63-2.03-3.91-4.54-3.91-7.66c0-3.4,1.25-6.15,3.82-8.4 c2.67-2.34,5.97-3.48,10.08-3.48c5.24,0,9.59,1.15,12.95,3.42C818.79,92.81,820.28,95.26,820.28,98.24z'/%3E %3Crect x='774.59' y='140.38' class='st1' width='59.23' height='12.34'/%3E %3Cg%3E %3Cpath class='st1' d='M100.76,32.79v0.19c0,3.47-2.81,6.29-6.29,6.29h-73.5c-3.8,0-6.88,3.08-6.88,6.88v39.38 c0,3.8,3.08,6.88,6.88,6.88h61.31c3.47,0,6.29,2.81,6.29,6.29v0c0,3.47-2.81,6.29-6.29,6.29H20.98c-3.8,0-6.88,3.08-6.88,6.88 v51.21c0,3.47-2.81,6.29-6.29,6.29H6.29c-3.47,0-6.29-2.81-6.29-6.29V32.79c0-3.47,2.81-6.29,6.29-6.29h88.19 C97.95,26.51,100.76,29.32,100.76,32.79z'/%3E %3Cpath class='st1' d='M137.4,32.79v116.93c0,3.8,3.08,6.88,6.88,6.88h75.6c3.47,0,6.29,2.81,6.29,6.29v0.19 c0,3.47-2.81,6.29-6.29,6.29h-90.29c-3.47,0-6.29-2.81-6.29-6.29V32.79c0-3.47,2.81-6.29,6.29-6.29h1.52 C134.59,26.51,137.4,29.32,137.4,32.79z'/%3E %3Cpath class='st1' d='M380.22,97.94c0,43.62-29.33,73.91-73.14,73.91c-43.62,0-73.14-29.53-73.14-73.91 c0-43.62,29.33-73.91,73.14-73.91C350.69,24.03,380.22,53.74,380.22,97.94z M248.02,97.94c0,35.62,22.86,61.14,59.05,61.14 c36.38,0,59.05-25.71,59.05-61.14s-23.05-61.14-59.05-61.14C270.5,36.79,248.02,62.32,248.02,97.94z'/%3E %3Cpath class='st1' d='M538.95,97.94c0,43.62-29.33,73.91-73.14,73.91c-43.62,0-73.14-29.53-73.14-73.91 c0-43.62,29.33-73.91,73.14-73.91C509.42,24.03,538.95,53.74,538.95,97.94z M406.76,97.94c0,35.62,22.86,61.14,59.05,61.14 c36.38,0,59.05-25.71,59.05-61.14s-23.05-61.14-59.05-61.14C429.23,36.79,406.76,62.32,406.76,97.94z'/%3E %3Cpath class='st1' d='M619.91,26.51c33.9,0,52.95,19.43,52.95,46.29c0,21.52-12.57,37.91-33.91,43.81l30.61,42.82 c2.97,4.16,0,9.94-5.11,9.94h-1.85c-2.05,0-3.97-1-5.14-2.67l-31.5-44.88c-1.25-1.78-3.27-2.92-5.45-2.93c-0.01,0-0.02,0-0.03,0 h-38.07c-3.8,0-6.88,3.08-6.88,6.88v37.31c0,3.47-2.81,6.29-6.29,6.29h-1.52c-3.47,0-6.29-2.81-6.29-6.29V32.79 c0-3.47,2.81-6.29,6.29-6.29H619.91z M575.53,99.24c0,3.8,3.08,6.88,6.88,6.88h36.93c24.76,0,39.43-12.95,39.43-33.33 c0-20.19-14.1-33.52-39.43-33.52h-36.93c-3.8,0-6.88,3.08-6.88,6.88V99.24z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 18.1.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 147.2 40.3' enable-background='new 0 0 147.2 40.3' xml:space='preserve'%3E %3Cg%3E %3Cpath fill='%23FFFFFF' d='M6,8.5h25.3l-2,7.4h-16l-1,5.3h15.7l-2,6.6H11.2l-2,11.9H0L6,8.5z'/%3E %3Cpath fill='%23FFFFFF' d='M32.9,8.5h26.8l-1.3,7.4h-10l-4,23.8h-8.2l4-23.8h-9.3L32.9,8.5z'/%3E %3Cpath fill='%23FFFFFF' d='M78.7,14.6c0-1.9,0.3-4.2,0.8-5.9c-0.2,0-0.5-0.4-0.7-0.4H61.4l-6,32H78c7.7,0,8.1-5.8,8.1-9.5 c0-0.4,0-0.9-0.1-1.2C81.6,26.2,78.7,20.7,78.7,14.6z M66.6,15.3h7.2c2.2,0,3.1,1.6,3.1,3c0,1.4-0.9,3-3.1,3h-8.2L66.6,15.3z M74.7,33.3h-10l1-6h9c2.2,0,3.6,0.9,3.6,2.9C78.3,32.3,76.8,33.3,74.7,33.3z'/%3E %3Cg%3E %3Cpath fill='%23FF9900' d='M146.2,13.2c-0.7-2-1.7-3.9-3-5.6c-1.3-1.7-2.9-3.1-4.6-4.3c-1.8-1.2-3.8-2.1-5.8-2.6 c-1.6-0.4-3.2-0.6-4.8-0.6c-6,0-11.3,2.7-14.9,7c1.3,2.5,1.9,5.4,1.7,8.2c-0.1,1.4-0.4,2.8-0.9,4.1c-0.3,0.7-0.5,1.3-0.9,2 c-0.2,0.4-0.4,0.8-0.6,1.1c-0.7,1.4-1.5,2.8-2.2,4.2c0,0,0,0.1,0,0.1c0.9,2.1,2.1,4,3.6,5.7c1.5,1.7,3.3,3.1,5.3,4.1 c2,1.1,4.3,1.8,6.6,2c2.3,0.3,4.6,0.1,6.8-0.4c2.1-0.5,4.1-1.3,5.9-2.5c1.8-1.1,3.4-2.6,4.7-4.2c1.3-1.7,2.4-3.5,3.1-5.5 c0.8-2.1,1.1-4.3,1.2-6.5C147.2,17.5,146.9,15.3,146.2,13.2z M138.4,23.9c-0.8,2-2.2,3.7-3.9,4.9c-1.8,1.3-3.9,2-6,2.1 c-0.2,0-0.4,0-0.5,0c-2.2,0-4.3-0.6-6.2-1.8c-1.8-1.1-3.2-2.8-4.1-4.7c-0.9-2-1.3-4.2-1-6.4c0.3-2.1,1.2-4.2,2.6-5.8 c1.4-1.6,3.2-2.9,5.2-3.5c2.1-0.7,4.4-0.7,6.5-0.1c2.1,0.6,3.9,1.7,5.4,3.3c1.4,1.6,2.4,3.5,2.8,5.6 C139.5,19.6,139.2,21.9,138.4,23.9z'/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23FF9900' d='M110.4,9.9c-0.6-2-1.8-3.9-3.2-5.4c-1.5-1.5-3.3-2.7-5.2-3.5C100.4,0.3,98.6,0,96.9,0 c-2.2,0-4.4,0.5-6.3,1.5c-1.9,0.9-3.6,2.3-4.9,4c-1.3,1.7-2.3,3.7-2.7,5.8c-0.5,2.2-0.4,4.5,0.1,6.6c0.5,2.1,1.6,4,2.9,5.6 c1.4,1.6,3.1,2.9,5.1,3.8c1.7,0.7,3.5,1.2,5.3,1.2l-4.7,9L91,38.9h1.6h6.8h0.6l0.3-0.5c0.3-0.6,0.6-1.1,0.9-1.7 c0.7-1.4,1.4-2.7,2.1-4.1c0.9-1.7,1.7-3.4,2.6-5c0.8-1.5,1.6-3,2.4-4.5c0.3-0.6,0.7-1.3,1-1.9c0.7-1.3,1.2-2.6,1.5-4 C111.3,14.7,111.2,12.2,110.4,9.9z M102.7,16.6l-0.3,0.6l-0.2,0.4c-1.3,2-3.7,3.2-6.1,2.9c-2.1-0.3-4-1.7-4.9-3.6 c-0.9-2-0.7-4.4,0.6-6.2C93,9,94.9,8,96.9,8c2.2,0,4.2,1.2,5.4,3C103.3,12.7,103.4,14.8,102.7,16.6z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='283.442px' height='69.73px' viewBox='0.018 106.866 283.442 69.73' enable-background='new 0.018 106.866 283.442 69.73' xml:space='preserve'%3E %3Cg%3E %3Cg%3E %3Cpolygon fill='%23FFFFFF' points='210.742,132.999 212.535,123.311 212.954,121.278 210.861,121.278 198.482,121.278 197.046,121.278 196.807,122.713 194.833,132.999 '/%3E %3C/g%3E %3Cg%3E %3Cpolygon fill='%23FFFFFF' points='281.367,121.278 269.048,121.278 267.613,121.278 267.314,122.653 260.794,157.218 236.576,121.996 236.037,121.278 235.14,121.278 218.754,121.278 217.32,121.278 217.021,122.653 207.333,174.382 206.914,176.416 209.007,176.416 221.386,176.416 222.822,176.416 223.121,175.04 229.818,139.278 254.516,175.697 255.054,176.416 255.951,176.416 271.679,176.416 273.115,176.416 273.353,175.04 283.101,123.311 283.46,121.278 '/%3E %3C/g%3E %3Cg%3E %3Cpolygon fill='%23FFFFFF' points='194.056,137.245 187.06,174.441 186.701,176.474 188.794,176.474 201.113,176.474 202.548,176.474 202.847,175.04 209.964,137.245 '/%3E %3C/g%3E %3Cg%3E %3Cpath fill='%23FFFFFF' d='M190.587,121.278h-18.658h-0.896l-0.538,0.718l-23.622,33.429l-10.645-32.951l-0.358-1.196h-1.256h-22.426 c1.555,2.452,2.811,5.083,3.768,7.834c1.435,4.186,2.153,8.611,2.153,13.097c-0.06,4.484-0.837,8.851-2.333,13.037 c-1.495,4.006-3.588,7.773-6.279,11.123c-2.691,3.349-5.861,6.159-9.449,8.432c-0.957,0.598-1.914,1.137-2.871,1.674h20.631h1.436 l0.239-1.435l6.817-36.419l11.123,36.598l0.359,1.197h1.256h8.611h0.897l0.538-0.777l24.758-36.479l-6.578,35.224l-0.359,2.033 H169h11.781h1.436l0.238-1.436l9.748-51.729l0.359-2.033h-1.975V121.278z'/%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath fill='%23FF9900' d='M111.889,130.547c-1.256-3.588-3.11-6.997-5.442-9.987c-2.332-2.99-5.143-5.562-8.312-7.654 c-3.229-2.093-6.758-3.708-10.465-4.605c-2.811-0.718-5.681-1.076-8.552-1.076c-10.705,0-20.333,4.903-26.671,12.558 c2.332,4.485,3.468,9.628,3.05,14.711c-0.239,2.571-0.777,5.023-1.675,7.415c-0.478,1.196-0.957,2.392-1.555,3.528 c-0.359,0.719-0.718,1.376-1.136,2.034c-1.315,2.511-2.631,5.022-3.947,7.534c0,0.061-0.06,0.12-0.06,0.18 c1.555,3.768,3.768,7.236,6.519,10.166c2.751,2.99,5.98,5.502,9.568,7.355c3.648,1.914,7.655,3.17,11.781,3.648 c4.066,0.479,8.193,0.239,12.14-0.658c3.768-0.896,7.296-2.392,10.585-4.484c3.169-2.033,6.04-4.605,8.432-7.535 c2.392-2.99,4.306-6.339,5.622-9.928c1.375-3.707,2.033-7.654,2.093-11.601C113.803,138.261,113.205,134.255,111.889,130.547z M97.955,149.803c-1.495,3.528-3.947,6.578-7.057,8.731c-3.169,2.271-6.937,3.527-10.824,3.768c-0.299,0-0.658,0-0.957,0 c-3.887,0-7.774-1.137-11.063-3.23c-3.169-2.033-5.801-5.022-7.416-8.432c-1.674-3.588-2.332-7.595-1.794-11.542 c0.539-3.827,2.153-7.475,4.605-10.405c2.452-2.93,5.741-5.143,9.329-6.279c3.768-1.196,7.894-1.315,11.721-0.239 c3.708,1.017,7.056,3.05,9.628,5.861c2.571,2.811,4.365,6.339,5.083,10.106C99.929,142.089,99.45,146.156,97.955,149.803z M49.815,124.626c-1.196-3.647-3.169-6.997-5.801-9.748s-5.861-4.904-9.389-6.279c-2.87-1.137-5.98-1.734-9.09-1.734 c-3.947,0-7.834,0.897-11.362,2.691c-3.409,1.674-6.398,4.126-8.731,7.116c-2.392,2.99-4.066,6.579-4.844,10.346 c-0.837,3.828-0.777,7.954,0.239,11.781c0.957,3.708,2.811,7.176,5.262,10.106c2.452,2.871,5.562,5.203,9.09,6.758 c2.99,1.316,6.279,2.094,9.568,2.152l-8.492,16.146l-1.316,2.512h2.871h12.2h1.076l0.479-0.896 c0.538-1.017,1.017-2.033,1.555-3.05c1.255-2.452,2.511-4.903,3.767-7.355c1.555-2.99,3.11-6.04,4.725-9.03 c1.435-2.631,2.871-5.322,4.306-8.014c0.598-1.136,1.256-2.271,1.854-3.408c1.196-2.272,2.093-4.665,2.631-7.176 C51.37,133.238,51.13,128.753,49.815,124.626z M35.881,136.707l-0.538,1.077l-0.359,0.658c-2.332,3.648-6.638,5.682-10.943,5.143 c-3.828-0.479-7.236-2.99-8.791-6.518c-1.615-3.588-1.196-7.894,1.076-11.123c2.093-2.93,5.562-4.724,9.15-4.724 c3.887,0,7.595,2.093,9.628,5.382C36.958,129.59,37.256,133.417,35.881,136.707z'/%3E %3C/g%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='logo_htmedia' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 462.9 93.8' style='enable-background:new 0 0 462.9 93.8;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:none;%7D .st1%7Bfill:%23BDBDBD;%7D .st2%7Bfill:%23FFFFFF;%7D .st3%7Bfill:%23FF9900;%7D %3C/style%3E %3Cpath class='st0' d='M0.7,0.5'/%3E %3Cpath class='st1' d='M0.7,0.5'/%3E %3Cg%3E %3Cpolygon class='st2' points='280.9,35.4 283.1,22.3 283.5,19.7 280.9,19.7 264.2,19.7 262.6,19.7 262.2,21.5 259.5,35.4 '/%3E %3C/g%3E %3Cg%3E %3Cpolygon class='st2' points='374.6,19.7 358.5,19.7 356.3,19.7 355.9,21.5 347.1,67.6 315.4,20.5 314.4,19.7 313.1,19.7 291.4,19.7 289.6,19.7 289.1,21.5 276.1,90.2 275.7,93 278.7,93 294.9,93 297,93 297,91.2 306.1,43.6 338.8,92 339.8,93 341.1,93 362,93 363.7,93 364.1,91.2 376.8,22.3 377.6,19.7 '/%3E %3C/g%3E %3Cg%3E %3Cpolygon class='st2' points='258.7,41 249.6,90.2 248.6,93 251.7,93 267.8,93 270,93 270.4,91.2 279.6,41 '/%3E %3C/g%3E %3Cg%3E %3Cpath class='st2' d='M253.8,19.7H229h-1.3l-0.5,0.8l-31.4,44.4l-14-43.6l-0.5-1.8h-1.8H150c2.2,3.6,3.9,7,4.9,10.4 c1.8,5.7,3.1,11.4,3.1,17.5s-1.3,11.7-3.1,17.5c-1.8,5.3-4.9,10.4-8.3,14.8c-3.6,4.4-7.8,8.3-12.7,11.4c-1.3,0.8-2.6,1.3-3.9,2.2 h27.5h1.8l0.5-1.8l9.1-48.4L183.6,92l0.5,1.8h1.8h11.4h1.3l0.8-0.8l33.1-48.4l-8.6,46.6l-0.5,2.6h2.6h15.7h1.8L244,92l13-68.9 l0.6-3.6h-3.8V19.7z'/%3E %3C/g%3E %3Cg%3E %3Cg%3E %3Cpath class='st3' d='M149.2,31.9c-1.8-4.9-3.9-9.1-7.3-13.1c-3.1-3.9-7-7.3-10.9-10.1c-4.4-2.6-9.1-4.9-14-6 c-3.9-0.8-7.3-1.3-11.4-1.3c-14.4,0-27.1,6.5-35.3,16.6c3.1,6,4.4,12.7,3.9,19.5C73.8,41,73.5,44,72,47.5 c-0.5,1.8-1.3,3.1-2.2,4.9c-0.5,0.8-0.8,1.8-1.3,2.6c-1.8,3.6-3.6,6.5-5.3,10.1l0,0c2.2,4.9,5.3,9.6,8.6,13.5 c3.6,3.9,7.8,7.3,12.7,9.6c4.9,2.6,10.1,4.4,15.7,4.9c5.3,0.5,10.9,0.5,16.2-0.8c4.9-1.3,9.6-3.1,14-6c4.4-2.6,7.8-6,11.4-10.1 c3.1-3.9,5.7-8.3,7.3-13.1c1.8-4.9,2.6-10.1,2.6-15.3C151.9,42.3,151,37.1,149.2,31.9z M131,57.6c-2.2,4.9-5.3,8.6-9.1,11.7 c-4.4,3.1-9.1,4.9-14.4,4.9c-0.5,0-0.8,0-1.3,0c-5.3,0-10.4-1.3-14.8-4.4c-4.4-2.6-7.8-6.5-10.1-11.4C79,53.5,78.2,48.3,79,43.1 c0.8-5.3,3.1-10.1,6-14c3.1-3.9,7.3-7,12.2-8.3c4.9-1.8,10.4-1.8,15.7-0.5c4.9,1.3,9.1,3.9,12.7,7.8s5.7,8.3,6.5,13.5 C133.6,47.2,132.8,52.7,131,57.6z M66.8,24.1C65,19.2,62.4,15,59,10.9c-3.6-3.6-7.8-6.6-12.7-8.3c-3.6-1.3-7.8-2.2-11.7-2.2 c-5.2,0-10.4,1.3-15.3,3.4C15,6.1,10.7,9.6,7.6,13.5s-5.3,8.6-6,13.5c-1.3,5.3-0.8,10.4,0.5,15.7c1.3,4.9,3.9,9.6,7,13.5 c3.6,3.9,7.3,7,12.2,9.1c3.9,1.8,8.3,2.6,12.7,3.1L22.6,89.8l-1.8,3.6h3.9h16.2h1.2l0.4-1.3c0.8-1.3,1.3-2.6,2.2-3.9 c1.8-3.1,3.6-6.5,5.3-9.6c2.2-3.9,4.4-7.8,6-12.2c1.8-3.6,3.9-7.3,5.7-10.9c0.8-1.3,1.8-3.1,2.6-4.4c1.8-3.1,2.6-6,3.6-9.6 C69.1,35.4,68.6,29.6,66.8,24.1z M48.1,40.2l-0.8,1.3l-0.5,0.8c-3.1,4.9-8.6,7.3-14.4,7c-5.3-0.8-9.6-3.9-11.7-8.6 c-1.8-4.9-1.3-10.4,1.8-14.8c2.6-3.9,7.3-6,12.2-6c5.3,0,10.1,2.6,12.7,7C49.9,30.6,50.4,35.8,48.1,40.2z'/%3E %3C/g%3E %3C/g%3E %3Cg%3E %3Cpath class='st2' d='M372.9,93l2.2-12.8h14.2L387.1,93H372.9z'/%3E %3Cpath class='st2' d='M400.2,51.3l1.8-9.8h13.8l-1.8,9.8H400.2z M406.4,93h-13.1l6.4-36.1h13.3L406.4,93L406.4,93z'/%3E %3Cpath class='st2' d='M445.6,93l3.3-18.6c1.1-5.7-1.2-8-6.6-8c-3.6,0-8.8,0.9-12.7,1.9L425.2,93H412l6.4-36.1h10.8l-0.1,2.4 c7-1.8,13.8-3.3,19.6-3.3c4.3,0,8.9,0.6,11.8,3.8c2.2,2.4,3,6,2,11.5l-3.9,21.9h-13V93z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 408 101.89'%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill:%23c1272d;%7D.cls-2%7Bfill:%232c1b68;%7D.cls-3%7Bfill:none;%7D.cls-4%7Bfill:%2329abe2;%7D.cls-5%7Bfill:%23fff;%7D.cls-6%7Bfill:url(%23linear-gradient);%7D.cls-7%7Bfill:url(%23linear-gradient-2);%7D.cls-8%7Bfill:url(%23linear-gradient-3);%7D.cls-9%7Bfill:url(%23linear-gradient-4);%7D.cls-10%7Bfill:url(%23linear-gradient-5);%7D.cls-11%7Bfill:url(%23linear-gradient-6);%7D.cls-12%7Bfill:url(%23linear-gradient-7);%7D.cls-13%7Bfill:url(%23linear-gradient-8);%7D.cls-14%7Bfill:url(%23linear-gradient-9);%7D.cls-15%7Bfill:url(%23linear-gradient-10);%7D%3C/style%3E%3ClinearGradient id='linear-gradient' x1='390.93' y1='128.98' x2='142.93' y2='51.98' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%233fa9f5'/%3E%3Cstop offset='0.5' stop-color='%231b1464'/%3E%3Cstop offset='0.71' stop-color='%23661d4b'/%3E%3Cstop offset='0.91' stop-color='%23a82435'/%3E%3Cstop offset='1' stop-color='%23c1272d'/%3E%3C/linearGradient%3E%3ClinearGradient id='linear-gradient-2' x1='398.43' y1='104.83' x2='150.43' y2='27.83' xlink:href='%23linear-gradient'/%3E%3ClinearGradient id='linear-gradient-3' x1='399.16' y1='102.47' x2='151.16' y2='25.47' xlink:href='%23linear-gradient'/%3E%3ClinearGradient id='linear-gradient-4' x1='401.85' y1='93.82' x2='153.85' y2='16.82' xlink:href='%23linear-gradient'/%3E%3ClinearGradient id='linear-gradient-5' x1='404.66' y1='84.75' x2='156.66' y2='7.75' xlink:href='%23linear-gradient'/%3E%3ClinearGradient id='linear-gradient-6' x1='409.49' y1='69.22' x2='161.49' y2='-7.78' xlink:href='%23linear-gradient'/%3E%3ClinearGradient id='linear-gradient-7' x1='408.79' y1='71.45' x2='160.79' y2='-5.55' xlink:href='%23linear-gradient'/%3E%3ClinearGradient id='linear-gradient-8' x1='416.73' y1='45.88' x2='168.73' y2='-31.12' xlink:href='%23linear-gradient'/%3E%3ClinearGradient id='linear-gradient-9' x1='410.92' y1='64.61' x2='162.92' y2='-12.39' xlink:href='%23linear-gradient'/%3E%3ClinearGradient id='linear-gradient-10' x1='415.29' y1='50.54' x2='167.29' y2='-26.46' xlink:href='%23linear-gradient'/%3E%3C/defs%3E%3Ctitle%3Epluralist logo &amp;amp; type%3C/title%3E%3Cg id='Layer_2' data-name='Layer 2'%3E%3Cg id='Layer_1-2' data-name='Layer 1'%3E%3Cpath class='cls-1' d='M77.05,0A50.65,50.65,0,0,0,64,1.7a51,51,0,0,1,0,98.5A50.95,50.95,0,1,0,77.05,0Z'/%3E%3Cellipse class='cls-2' cx='64' cy='50.95' rx='37.89' ry='49.25'/%3E%3Cellipse class='cls-3' cx='64.32' cy='51.52' rx='23.42' ry='23.47' transform='translate(-17.6 60.55) rotate(-44.98)'/%3E%3Cpath class='cls-4' d='M51,101.89a51.08,51.08,0,0,0,13-1.69A51,51,0,0,1,40.87,86.8v14.09A51.51,51.51,0,0,0,51,101.89Z'/%3E%3Cpath class='cls-4' d='M25.92,52c0-.17,0-.33,0-.5a38.43,38.43,0,0,1,.56-6.47A51,51,0,0,1,64,1.7,50.95,50.95,0,0,0,25.9,95.31V52Z'/%3E%3Cpath class='cls-5' d='M102.69,49.71A38.42,38.42,0,0,0,25.9,51.52c0,.17,0,.33,0,.5h0V95.31a50.59,50.59,0,0,0,15,5.58v-19a38.4,38.4,0,0,0,61.82-32.23Zm-15,3.34A23.45,23.45,0,1,1,62.8,28.12,23.54,23.54,0,0,1,87.72,53.05Z'/%3E%3Cpath class='cls-6' d='M179.19,35.17A18.12,18.12,0,0,0,170,32.79a17.61,17.61,0,0,0-15.61,8.93A18.28,18.28,0,0,0,152,51V80.82a3.22,3.22,0,0,0,.95,2.42,3.33,3.33,0,0,0,5.73-2.42V63.15a16,16,0,0,0,5.56,4.39,16.19,16.19,0,0,0,7.07,1.57,16,16,0,0,0,8.54-2.36,16.6,16.6,0,0,0,6-6.51A19.56,19.56,0,0,0,188.06,51a18.46,18.46,0,0,0-2.36-9.26A17.28,17.28,0,0,0,179.19,35.17Zm.92,22.06a11.6,11.6,0,0,1-4.19,4.38,11.71,11.71,0,0,1-11.85,0,11.36,11.36,0,0,1-4.15-4.38A12.87,12.87,0,0,1,158.41,51a13,13,0,0,1,1.51-6.28,11.52,11.52,0,0,1,16-4.42,11.5,11.5,0,0,1,4.19,4.42A12.92,12.92,0,0,1,181.65,51,12.78,12.78,0,0,1,180.11,57.23Z'/%3E%3Cpath class='cls-7' d='M205.55,62.3h-1.64a2.68,2.68,0,0,1-2.35-1.57,7.85,7.85,0,0,1-.92-4V21a3.27,3.27,0,1,0-6.54,0V56.74A15.16,15.16,0,0,0,195.34,63a10.12,10.12,0,0,0,3.5,4.32,8.85,8.85,0,0,0,5.07,1.53h.14a5.27,5.27,0,0,0,3.2-.91,2.82,2.82,0,0,0,1.25-2.36,3.41,3.41,0,0,0-.82-2.35A2.71,2.71,0,0,0,205.55,62.3Z'/%3E%3Cpath class='cls-8' d='M242,33a3.28,3.28,0,0,0-2.38.92,3.19,3.19,0,0,0-.95,2.42V54.77A7.49,7.49,0,0,1,237.34,59a8.92,8.92,0,0,1-3.53,3,11.23,11.23,0,0,1-5,1.11,10.47,10.47,0,0,1-7.56-2.72c-1.9-1.81-2.84-4.48-2.84-8V36.32a3.34,3.34,0,1,0-6.68,0v16.1a18.89,18.89,0,0,0,2,9.06,13.82,13.82,0,0,0,5.63,5.73,17.5,17.5,0,0,0,14.26.82,14.8,14.8,0,0,0,5-3.24v.72a3.4,3.4,0,0,0,5.76,2.38,3.27,3.27,0,0,0,.91-2.38V36.32A3.15,3.15,0,0,0,242,33Z'/%3E%3Cpath class='cls-9' d='M274.84,33.7a11.64,11.64,0,0,0-5.43-1.05A14.73,14.73,0,0,0,263.26,34a14,14,0,0,0-4.84,3.6V36.32q0-3.27-3.27-3.27a3,3,0,0,0-3.28,3.27V65.57a3.31,3.31,0,0,0,.85,2.46,3.4,3.4,0,0,0,2.43.81A3.24,3.24,0,0,0,257.6,68a3.36,3.36,0,0,0,.82-2.42V46.46a6.9,6.9,0,0,1,2.88-5.82,12.34,12.34,0,0,1,7.59-2.16,25.25,25.25,0,0,1,4.25.46,6.43,6.43,0,0,0,1,.13,2.53,2.53,0,0,0,2.62-2.1,2.38,2.38,0,0,0,.07-.65C276.81,35.27,276.15,34.4,274.84,33.7Z'/%3E%3Cpath class='cls-10' d='M305.4,35.17a17.79,17.79,0,0,0-9.13-2.38,18.16,18.16,0,0,0-9.2,2.38,17.28,17.28,0,0,0-6.51,6.55A18.45,18.45,0,0,0,278.21,51a19.56,19.56,0,0,0,2.19,9.26,16.53,16.53,0,0,0,6,6.51A16,16,0,0,0,295,69.11a16.06,16.06,0,0,0,12.63-6v2.42a3.34,3.34,0,1,0,6.67,0V51a18.27,18.27,0,0,0-2.38-9.26A17.78,17.78,0,0,0,305.4,35.17Zm1,22.06a11.38,11.38,0,0,1-4.16,4.38,11.71,11.71,0,0,1-11.85,0,11.58,11.58,0,0,1-4.18-4.38A12.67,12.67,0,0,1,284.62,51a12.81,12.81,0,0,1,1.54-6.28,11.48,11.48,0,0,1,4.18-4.42,11.4,11.4,0,0,1,16,4.42,13.12,13.12,0,0,1,1.5,6.28A13,13,0,0,1,306.35,57.23Z'/%3E%3Cpath class='cls-11' d='M331.29,62.3h-1.64a2.7,2.7,0,0,1-2.36-1.57,7.85,7.85,0,0,1-.91-4V21a3.28,3.28,0,1,0-6.55,0V56.74A15.16,15.16,0,0,0,321.08,63a10.05,10.05,0,0,0,3.5,4.32,8.83,8.83,0,0,0,5.07,1.53h.13a5.28,5.28,0,0,0,3.21-.91,2.81,2.81,0,0,0,1.24-2.36,3.37,3.37,0,0,0-.82-2.35A2.67,2.67,0,0,0,331.29,62.3Z'/%3E%3Cpath class='cls-12' d='M342.72,33.05a3.31,3.31,0,0,0-2.39.91,3.22,3.22,0,0,0-.95,2.42V65.51a3.25,3.25,0,0,0,3.34,3.33,3.17,3.17,0,0,0,2.42-1,3.28,3.28,0,0,0,.92-2.38V36.38a3.14,3.14,0,0,0-3.34-3.33Z'/%3E%3Cpath class='cls-13' d='M342.72,18.58a4.31,4.31,0,0,0-3,7.37,4.31,4.31,0,1,0,6.09-6.09A4.19,4.19,0,0,0,342.72,18.58Z'/%3E%3Cpath class='cls-14' d='M378.52,51.76q-3-2.55-10.11-4a31.58,31.58,0,0,1-5.3-1.47,5.78,5.78,0,0,1-2.49-1.64,3.56,3.56,0,0,1-.66-2.19,3.14,3.14,0,0,1,1.94-2.85,10.63,10.63,0,0,1,4.94-1,14.13,14.13,0,0,1,4.45.62,9.86,9.86,0,0,1,3.47,2.13,4.45,4.45,0,0,0,3.07,1.24,3,3,0,0,0,1.83-.52,2.64,2.64,0,0,0,1.12-2,3.38,3.38,0,0,0-.85-2.1,13.1,13.1,0,0,0-5.34-3.79A20,20,0,0,0,367,32.79a19.13,19.13,0,0,0-6.55,1.11,11.5,11.5,0,0,0-5,3.33,8.09,8.09,0,0,0-1.9,5.44q0,7.92,12.57,10.34A19.75,19.75,0,0,1,373,55.27a3.94,3.94,0,0,1,2,3.36A3.77,3.77,0,0,1,373,62a11.28,11.28,0,0,1-5.8,1.25,13.86,13.86,0,0,1-5.3-1,10,10,0,0,1-3.73-2.39,3.51,3.51,0,0,0-2.48-1.18,4,4,0,0,0-2.29.92,3,3,0,0,0-1.31,2.55,2.74,2.74,0,0,0,.85,2,16,16,0,0,0,6.15,3.6,25.1,25.1,0,0,0,8.38,1.38,18.71,18.71,0,0,0,7.62-1.41,10.92,10.92,0,0,0,4.81-3.86,9.66,9.66,0,0,0,1.64-5.47A8.32,8.32,0,0,0,378.52,51.76Z'/%3E%3Cpath class='cls-15' d='M407.18,63.22a2.54,2.54,0,0,0-2-.92H403a4.38,4.38,0,0,1-3.53-1.77A6.7,6.7,0,0,1,398,56.15V40h5.56a3.17,3.17,0,0,0,2.23-.78,2.6,2.6,0,0,0,.85-2,2.73,2.73,0,0,0-.85-2.09,3.17,3.17,0,0,0-2.23-.78H398V24.93a3.28,3.28,0,1,0-6.55,0v9.43h-3a3.15,3.15,0,0,0-2.22.78,2.69,2.69,0,0,0-.85,2.09,2.57,2.57,0,0,0,.85,2,3.15,3.15,0,0,0,2.22.78h3V56.15A13.7,13.7,0,0,0,393,62.63a11.59,11.59,0,0,0,4.15,4.54A10.72,10.72,0,0,0,403,68.84h1.18a4.16,4.16,0,0,0,2.78-.91A3,3,0,0,0,408,65.57,3.37,3.37,0,0,0,407.18,63.22Z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Logo' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 176.2 176.1' style='enable-background:new 0 0 176.2 176.1;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cpath class='st0' d='M72.8,29.1c3.4-7.3,7.3-14.2,11.8-20.6c1.8-2.6,3.7-5,5.6-7.3c0.3-0.5,0-1.2-0.6-1.2c-0.5,0-1,0-1.5,0 C68,0,48.6,3.4,30.6,9.6c-9.3,3.2-18.3,7.2-26.9,11.9C1.3,22.8-0.1,25.3,0,28c0.2,10,1.3,19.7,3.2,29.2c1.7,8.9,4.1,17.6,7.1,26 c3.6,10.1,8.1,19.8,13.5,28.9c9.8,16.9,22.3,32,37,44.7c2.5,2.2,5.1,4.3,7.7,6.3c0.6,0.4,1.4-0.2,1.1-0.8c-1.1-2.7-2.1-5.5-3-8.3 c-4.5-13.5-7.3-28-8.2-43c0-0.7-0.3-1.3-0.6-1.8c-3.7-5.1-7-10.3-10-15.9c2.7-1.5,5.6-2.8,8.5-3.9c1.3-0.5,2.1-1.7,2.2-3.1 c0.7-10,2.2-19.9,4.6-29.3c0.1-0.5-0.3-1-0.8-0.9c-9.1,2.1-17.9,5.2-26,9.3c-2.3-7.8-4-15.8-5-24c12.2-5.2,25.3-8.7,38.9-10.4 C71.2,31,72.2,30.2,72.8,29.1z'/%3E %3Cpath class='st0' d='M172.5,21.5c-8.6-4.7-17.5-8.6-26.9-11.9C133.1,5.3,120,2.4,106.5,1c-1.1-0.1-2.1,0.3-2.9,1 c-7.3,7.5-13.8,16.6-19.1,27c-0.2,0.5,0.1,1,0.6,1c1,0,1.9,0,2.9,0c20.2,0,39.5,4.1,57.1,11.5c-1,8.2-2.7,16.3-5,24 c-2.9,9.7-6.8,19-11.6,27.8c-10,18.4-23.9,34.5-40.5,47c-5.8-4.4-11.2-9.1-16.2-14.3c-0.5-0.5-1.3-0.1-1.2,0.6c1.3,7.6,3,15,5.2,22 c3.1,9.8,7.1,18.8,11.9,27c0.2,0.3,0.6,0.5,1,0.3c9.5-5.6,18.5-12,26.8-19.2c14.6-12.7,27.2-27.8,37-44.7 c5.3-9.1,9.8-18.8,13.5-28.9c3-8.4,5.4-17.1,7.1-26c1.8-9.5,2.9-19.3,3.2-29.2C176.3,25.2,174.9,22.7,172.5,21.5z'/%3E %3C/svg%3E"

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 22.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Logo' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 147 40' style='enable-background:new 0 0 147 40;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cg%3E %3Cg%3E %3Cpath class='st0' d='M34.4,28.4h2.8c0.1,0,0.2-0.1,0.2-0.2v-6.6h5.1c0.1,0,0.2-0.1,0.2-0.1l0.9-2.5c0-0.1,0-0.2-0.1-0.3 c0,0,0,0-0.1,0h-6v-4.1h7.6c0.1,0,0.2-0.1,0.2-0.1l0.9-2.5c0-0.1,0-0.2-0.1-0.3c0,0,0,0-0.1,0H34.4c-0.1,0-0.2,0.1-0.2,0.2v16.3 C34.2,28.3,34.3,28.4,34.4,28.4z'/%3E %3Cpath class='st0' d='M52.5,11.8l-5.9,16.3c0,0.1,0,0.2,0.1,0.3c0,0,0,0,0.1,0h2.9c0.1,0,0.2-0.1,0.2-0.1l1-2.8h6l0.9,2.8 c0,0.1,0.1,0.1,0.2,0.1h2.9c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0-0.1l-5.9-16.3c0-0.1-0.1-0.1-0.2-0.1h-2.2 C52.6,11.6,52.5,11.7,52.5,11.8z M51.8,22.7l2.1-6.1l2,6.1H51.8L51.8,22.7z'/%3E %3Cpath class='st0' d='M74.5,21.9l-6.6-10.1c0-0.1-0.1-0.1-0.2-0.1h-2.6c-0.1,0-0.2,0.1-0.2,0.2l0,0v16.3c0,0.1,0.1,0.2,0.2,0.2l0,0 H68c0.1,0,0.2-0.1,0.2-0.2l0,0V18.1l6.6,10.2c0,0.1,0.1,0.1,0.2,0.1h2.6c0.1,0,0.2-0.1,0.2-0.2l0,0V11.9c0-0.1-0.1-0.2-0.2-0.2 l0,0h-2.8c-0.1,0-0.2,0.1-0.2,0.2l0,0V21.9z'/%3E %3Cpath class='st0' d='M109.2,22.5c0,1.9-1.1,3.1-2.9,3.1s-2.9-1.1-2.9-3.1V11.9c0-0.1-0.1-0.2-0.2-0.2l0,0h-2.8 c-0.1,0-0.2,0.1-0.2,0.2l0,0v10.8c0,3.6,2.7,5.9,6.2,5.9s6.2-2.3,6.2-5.9V11.9c0-0.1-0.1-0.2-0.2-0.2l0,0h-2.8 c-0.1,0-0.2,0.1-0.2,0.2l0,0L109.2,22.5L109.2,22.5L109.2,22.5L109.2,22.5z'/%3E %3Cpath class='st0' d='M128.8,14.4l0.9-2.5c0-0.1,0-0.2-0.1-0.3c0,0,0,0-0.1,0H118c-0.1,0-0.2,0.1-0.2,0.2l0,0v16.3 c0,0.1,0.1,0.2,0.2,0.2l0,0h11.5c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0-0.1l-0.9-2.5c0-0.1-0.1-0.1-0.2-0.1H121v-4.1h6.1 c0.1,0,0.2-0.1,0.2-0.2l0,0v-2.5c0-0.1-0.1-0.2-0.2-0.2l0,0H121v-3.9h7.6C128.7,14.5,128.8,14.5,128.8,14.4z'/%3E %3Cpath class='st0' d='M143.8,25.5h-6.9V11.9c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0h-2.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v16.3 c0,0.1,0.1,0.2,0.2,0.2l0,0h10.8c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0-0.1l-0.9-2.5C144,25.5,143.9,25.5,143.8,25.5z'/%3E %3Cpath class='st0' d='M93.7,13.2c-1.1-1.1-2.7-1.6-4.4-1.6h-6.6c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0l0.5,2.5c0,0.1,0.1,0.2,0.2,0.2 H89c1.1,0,1.9,0.4,2.4,1c0.6,0.7,0.7,1.8,0.7,4.4s-0.1,3.7-0.7,4.5c-0.6,0.7-1.3,1-2.4,1h-2.4v-8.7c0-0.1-0.1-0.2-0.2-0.2l0,0 h-2.8c-0.1,0-0.2,0.1-0.2,0.2l0,0v11.4c0,0.1,0.1,0.2,0.2,0.2l0,0h5.8c1.7,0,3.3-0.5,4.4-1.6c1.9-1.9,1.7-4.3,1.7-6.8 C95.4,17.4,95.6,15.1,93.7,13.2z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st0' d='M10.7,11.3c0.5-1.1,1.1-2.1,1.7-3c0.3-0.4,0.5-0.7,0.8-1.1c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.1,0-0.2,0 c-3,0-5.8,0.5-8.5,1.4c-1.4,0.5-2.7,1.1-4,1.7c-0.4,0.2-0.6,0.6-0.5,1c0,1.5,0.2,2.9,0.5,4.3c0.2,1.3,0.6,2.6,1,3.8 c0.5,1.5,1.2,2.9,2,4.2c1.4,2.5,3.3,4.7,5.4,6.6c0.4,0.3,0.7,0.6,1.1,0.9c0.1,0.1,0.2,0,0.2-0.1c-0.2-0.4-0.3-0.8-0.4-1.2 c-0.7-2-1.1-4.1-1.2-6.3c0-0.1,0-0.2-0.1-0.3c-0.5-0.7-1-1.5-1.5-2.3c0.4-0.2,0.8-0.4,1.2-0.6c0.2-0.1,0.3-0.2,0.3-0.5 c0.1-1.5,0.3-2.9,0.7-4.3c0-0.1,0-0.1-0.1-0.1c-1.3,0.3-2.6,0.8-3.8,1.4c-0.3-1.1-0.6-2.3-0.7-3.5c1.8-0.8,3.7-1.3,5.7-1.5 C10.5,11.6,10.6,11.5,10.7,11.3z'/%3E %3Cpath class='st0' d='M25.4,10.2c-1.3-0.7-2.6-1.3-4-1.7c-1.8-0.6-3.7-1.1-5.7-1.3c-0.2,0-0.3,0-0.4,0.1c-1.1,1.1-2,2.4-2.8,4 c0,0.1,0,0.1,0.1,0.1c0.1,0,0.3,0,0.4,0c3,0,5.8,0.6,8.4,1.7c-0.1,1.2-0.4,2.4-0.7,3.5c-0.4,1.4-1,2.8-1.7,4.1 c-1.5,2.7-3.5,5.1-6,6.9c-0.9-0.6-1.6-1.3-2.4-2.1c-0.1-0.1-0.2,0-0.2,0.1c0.2,1.1,0.4,2.2,0.8,3.2c0.5,1.4,1,2.8,1.7,4 c0,0,0.1,0.1,0.1,0c1.4-0.8,2.7-1.8,3.9-2.8c2.1-1.9,4-4.1,5.4-6.6c0.8-1.4,1.4-2.8,2-4.2c0.4-1.2,0.8-2.5,1-3.8 c0.3-1.4,0.4-2.8,0.5-4.3C25.9,10.8,25.7,10.4,25.4,10.2z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 19.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 770.9 99.7' style='enable-background:new 0 0 770.9 99.7;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%23FF9900;%7D .st1%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cg%3E %3Cg%3E %3Cpath class='st0' d='M81.5,41.3L56.9,91H44.8L20.3,41.3v57.3H0v-91h27.5l23.4,50l23.6-50h27.3v91H81.5V41.3z'/%3E %3Cpath class='st0' d='M111.1,19.6c-2.2-2.2-3.3-4.9-3.3-8.1c0-3.2,1.1-5.9,3.3-8.1c2.2-2.2,4.9-3.3,8.1-3.3c3.2,0,5.9,1.1,8.1,3.3 c2.2,2.2,3.3,4.9,3.3,8.1c0,3.2-1.1,5.9-3.3,8.1c-2.2,2.2-4.9,3.3-8.1,3.3C116,22.9,113.3,21.8,111.1,19.6z M129,98.5h-19.5v-70 H129V98.5z'/%3E %3Cpath class='st0' d='M156.6,59.5v39h-19.5v-70h19.5v7.8c5.9-6,12.5-9,19.9-9c7.4,0,13.6,2.6,18.5,7.8c5,5.2,7.5,12.1,7.5,20.8 v42.6H183V59c0-10.8-4-16.1-11.8-16.1c-3.9,0-7.3,1.4-10.2,4.2C158,49.9,156.6,54,156.6,59.5z'/%3E %3Cpath class='st0' d='M254.8,66.2V28.5h19.7v70h-19.7v-9.2c-4.9,6.9-11.1,10.3-18.8,10.3c-7.7,0-14.1-2.4-19.3-7.2 c-5.2-4.8-7.8-12-7.8-21.4V28.5h19.7v38.1c0,10.8,3.9,16.1,11.8,16.1c3.9,0,7.3-1.4,10.2-4.2C253.4,75.7,254.8,71.6,254.8,66.2z' /%3E %3Cpath class='st0' d='M308.6,42.6v31.4c0,2.7,0.7,4.8,2.1,6.3c1.4,1.5,3,2.3,4.9,2.3c3.6,0,6.7-1.6,9.2-4.9l7.3,13.7 c-6.1,5.6-12.5,8.3-19.2,8.3c-6.7,0-12.4-2.2-17.1-6.6c-4.6-4.4-7-10.5-7-18.1V42.6h-8.2V28.5h8.2v-21h19.7v21h16.9v14.1H308.6z' /%3E %3Cpath class='st0' d='M398.5,88.4c-7.9,7.5-17.2,11.2-27.8,11.2c-10.6,0-19.4-3.3-26.4-9.8c-6.9-6.6-10.4-15.3-10.4-26.4 s3.5-19.8,10.6-26.3c7.1-6.5,15.4-9.8,25.1-9.8c9.6,0,17.8,2.9,24.5,8.7c6.7,5.8,10.1,13.8,10.1,23.9v10.4h-51 c0.6,3.8,2.6,6.9,6,9.4c3.4,2.4,7.2,3.6,11.5,3.6c6.9,0,12.5-2.3,16.9-6.9L398.5,88.4z M379.8,46.9c-2.7-2.3-6-3.4-9.8-3.4 c-3.9,0-7.4,1.2-10.6,3.5c-3.2,2.3-5.1,5.5-5.6,9.5h30.7C384,52.3,382.5,49.1,379.8,46.9z'/%3E %3C/g%3E %3Cg%3E %3Cpath class='st1' d='M499.4,41.3L474.8,91h-12.1l-24.5-49.7v57.3h-20.3v-91h27.5l23.4,50l23.6-50h27.3v91h-20.3V41.3z'/%3E %3Cpath class='st1' d='M590.3,88.5c-7.9,7.5-17.2,11.2-27.8,11.2c-10.6,0-19.4-3.3-26.4-9.8c-6.9-6.6-10.4-15.3-10.4-26.4 s3.5-19.8,10.6-26.3c7.1-6.5,15.4-9.8,25.1-9.8c9.6,0,17.8,2.9,24.5,8.7c6.7,5.8,10.1,13.8,10.1,23.9v10.4h-51 c0.6,3.8,2.6,6.9,6,9.4c3.4,2.4,7.2,3.6,11.5,3.6c6.9,0,12.5-2.3,16.9-6.9L590.3,88.5z M571.6,47c-2.7-2.3-6-3.4-9.8-3.4 c-3.9,0-7.4,1.2-10.6,3.5c-3.2,2.3-5.1,5.5-5.6,9.5h30.7C575.8,52.5,574.3,49.3,571.6,47z'/%3E %3Cpath class='st1' d='M634.4,99.7c-8.3,0-15.7-3.5-22.2-10.5c-6.5-7-9.8-15.7-9.8-26.2c0-10.4,3.2-18.9,9.5-25.6s13.8-10,22.3-10 s15.4,3,20.8,9V2.1h19.5v96.6h-19.5v-9.2C649.6,96.3,642.7,99.7,634.4,99.7z M622.1,63.8c0,5.6,1.7,10.3,5.1,13.9 c3.4,3.6,7.3,5.4,11.8,5.4c4.5,0,8.3-1.8,11.5-5.4c3.2-3.6,4.7-8.2,4.7-13.9c0-5.7-1.6-10.4-4.7-14.2c-3.2-3.8-7.1-5.7-11.6-5.7 c-4.6,0-8.5,1.9-11.8,5.7C623.8,53.4,622.1,58.2,622.1,63.8z'/%3E %3Cpath class='st1' d='M683.7,19.8c-2.2-2.2-3.3-4.9-3.3-8.1c0-3.2,1.1-5.9,3.3-8.1c2.2-2.2,4.9-3.3,8.1-3.3c3.2,0,5.9,1.1,8.1,3.3 c2.2,2.2,3.3,4.9,3.3,8.1c0,3.2-1.1,5.9-3.3,8.1c-2.2,2.2-4.9,3.3-8.1,3.3C688.7,23.1,686,22,683.7,19.8z M701.6,98.7h-19.5v-70 h19.5V98.7z'/%3E %3Cpath class='st1' d='M770.9,98.7h-18.4v-8.5c-5,6.3-11.3,9.5-18.7,9.5s-13.6-2.1-18.7-6.4c-5-4.3-7.5-10-7.5-17.2 c0-7.2,2.6-12.5,7.8-16.1c5.2-3.6,12.3-5.3,21.3-5.3h14.6v-0.4c0-7.5-4-11.2-11.8-11.2c-3.4,0-7,0.7-10.7,2c-3.8,1.3-7,3-9.6,5 l-8.7-12.6c9.2-6.7,19.7-10,31.5-10c8.5,0,15.4,2.1,20.8,6.4c5.4,4.3,8.1,11,8.1,20.2V98.7z M751.2,72v-3.4H739 c-7.8,0-11.7,2.4-11.7,7.3c0,2.5,0.9,4.4,2.8,5.8c1.9,1.3,4.5,2,8,2c3.5,0,6.5-1.1,9.2-3.2C749.9,78.4,751.2,75.6,751.2,72z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 594 217'%3E %3Cstyle%3E .st0%7Bfill:%231757DF;%7D .st1%7Bfill:%23FFFFFF;%7D %3C/style%3E %3Cg%3E %3Cpath class='st0' d='M0,217h492l44.3-144.3c0,0,13.3-56,57.7-72.7c-10.7,0-465.3,0-465.3,0S74.3,4.7,50.3,58.3C45,70.7,0,217,0,217 z'/%3E %3Cpath class='st1' d='M71.7,174.7h39l26.7-87c0,0,5.7-16,26-16s32,0,32,0l-8.7-29H153c0,0-26.3,0-40.3,17c-9,11.3-11.7,15.3-15.3,28 C93.7,100.3,71.7,174.7,71.7,174.7z'/%3E %3Cpath class='st1' d='M284.7,42.7c-51,0-76.7,0-76.7,0l8.7,29H275c0,0,5.3,1,6.7,5s-3,15-3,15H216c0,0-27-2.3-39.3,27.3 c-4.3,11.7-6.3,20.3-6.3,20.3s-10,35.4,26.7,35.4s68.7,0,68.7,0s29,3.4,36-27.1c2-6,16.3-56,16.3-56S335.7,42.7,284.7,42.7z M266.1,136.3c-3.3,11.7-17.1,10.6-17.1,10.6s-22.3-0.2-34-0.2s-8.3-9-6.3-16c3.7-13,14.7-11.7,14.7-11.7h48 C271.3,119,269.8,123.2,266.1,136.3z'/%3E %3Cpath class='st1' d='M315.4,174.6l31.2-104.1c0,0,6-27.8,33.2-27.8s59,0,59,0S460.3,42.8,467,56c3.2,7.2,9.5,10.5,6.2,25 s-26.8,93.6-26.8,93.6h-39.8l27.2-91.4c0,0,3.8-11.5-10.5-11.5s-28.8,0-28.8,0s-8.2-2-11,7.2S355,174.7,355,174.7L315.4,174.6z'/%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml,%3C?xml version='1.0' encoding='utf-8'?%3E %3C!-- Generator: Adobe Illustrator 21.1.0, SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3E %3Csvg version='1.1' id='logo_htmedia' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' viewBox='0 0 470.7 113.5' style='enable-background:new 0 0 470.7 113.5;' xml:space='preserve'%3E %3Cstyle type='text/css'%3E .st0%7Bfill:%230079C1;%7D .st1%7Bfill:%23EE4223;%7D %3C/style%3E %3Cg%3E %3Cpath class='st0' d='M367.7,113.5h-33.6V65.3h-40.6v48.2h-33.6V0h33.6v40.4h40.6V0h33.6V113.5z'/%3E %3Cpath class='st0' d='M470.7,24.1h-35v89.4h-33.6V24.1h-34.7V0h103.2L470.7,24.1L470.7,24.1z'/%3E %3Cg%3E %3Cpath class='st1' d='M0,112.2h111.1V62.6H0V112.2z M0,50.9h111.1V1.4H0V50.9z'/%3E %3Cpath class='st0' d='M122.2,112.2h49.6V1.1h-49.6V112.2z M183.5,112.2H233V1.1h-49.6V112.2z'/%3E %3C/g%3E %3C/g%3E %3C/svg%3E"

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appDispatcher = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _flux = __webpack_require__(1130);

var _nm = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This is the (legacy) flux app dispatcher. Do not use it for new features.
 */
var STATIC_ACTION_SOURCES = ['view', 'server', 'external', 'window'];

var AppDispatcher = function (_Dispatcher) {
  (0, _inherits3.default)(AppDispatcher, _Dispatcher);

  function AppDispatcher() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AppDispatcher);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AppDispatcher.__proto__ || (0, _getPrototypeOf2.default)(AppDispatcher)).call(this, opts));

    _this.constructor.ACTION_SOURCES = opts.actionSources || [];
    _this.actionHandlers = opts.actionHandlers || {};
    STATIC_ACTION_SOURCES.forEach(_this.addActionSource, _this);
    return _this;
  }

  (0, _createClass3.default)(AppDispatcher, [{
    key: 'addActionSource',
    value: function addActionSource(source) {
      this.constructor.ACTION_SOURCES.push(source);
      this.actionHandlers[source] = this.handleAction.bind(this, source);
      return this;
    }
  }, {
    key: 'handleAction',
    value: function handleAction(source, action) {
      this.dispatch((0, _assign2.default)({ source: source }, action));
      return this;
    }
  }, {
    key: 'dispatchAction',
    get: function get() {
      return this.actionHandlers;
    }
  }], [{
    key: 'STATIC_ACTION_SOURCES',
    get: function get() {
      return STATIC_ACTION_SOURCES;
    }
  }]);
  return AppDispatcher;
}(_flux.Dispatcher);

var appDispatcher = exports.appDispatcher = new AppDispatcher();

(0, _nm.registerInNamespace)({ appDispatcher: appDispatcher });

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNameSpacedFetchActions = exports.FETCH_REQUEST_ACTION_TYPE = undefined;

var _regenerator = __webpack_require__(128);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.getNamespacedFetchActionTypes = getNamespacedFetchActionTypes;
exports.fetchDataSaga = fetchDataSaga;
exports.getNoEndpointsErrorMessage = getNoEndpointsErrorMessage;
exports.watchFetchDataSaga = watchFetchDataSaga;

var _reduxSaga = __webpack_require__(536);

var _fetch = __webpack_require__(58);

var _console = __webpack_require__(11);

var _fn = __webpack_require__(15);

var _effects = __webpack_require__(1286);

var _object = __webpack_require__(13);

var _api = __webpack_require__(123);

var _pageDataObject = __webpack_require__(5);

var _pageDataObject2 = _interopRequireDefault(_pageDataObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchDataSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(watchFetchDataSaga); /* eslint semi:0 */
/**
 * Manages fetch lifecycle via Redux actions.
 */


var FETCH_REQUEST_ACTION_TYPE = exports.FETCH_REQUEST_ACTION_TYPE = 'FETCH_REQUESTED';
var FETCH_SUFFIXES = (0, _object.namespacedConsts)({
  FETCH: {
    SUCCESS: true,
    FAIL: true
  }
});

var getNameSpacedFetchActions = exports.getNameSpacedFetchActions = function getNameSpacedFetchActions(endpointName) {
  var namespacedActions = (0, _object.namespacedConsts)((0, _defineProperty3.default)({}, endpointName, FETCH_SUFFIXES));
  return namespacedActions[endpointName];
};

function getNamespacedFetchActionTypes(apiEndpointName) {
  var _memoizeFirstCall = (0, _fn.memoizeFirstCall)('API_ENDPOINT', _api.getApiEndpoints, apiEndpointName),
      API_ENDPOINT = _memoizeFirstCall.API_ENDPOINT;
  // FIXME: in case of failure, return value shouldn't be false


  return API_ENDPOINT ? getNameSpacedFetchActions(apiEndpointName) : false;
}

function defaultResponseTransformer() {
  var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return 'data' in response ? response.data : response;
}

function fetchDataSaga(_ref) {
  var _ref$payload = _ref.payload,
      url = _ref$payload.url,
      dataTransformer = _ref$payload.dataTransformer,
      additionalState = _ref$payload.additionalState,
      endpointName = _ref$payload.endpointName,
      ignoreJsonResponse = _ref$payload.ignoreJsonResponse;
  var NAMESPACED_FETCH_ACTIONS, fetchFn, response, responseJson, data, state;
  return _regenerator2.default.wrap(function fetchDataSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          NAMESPACED_FETCH_ACTIONS = getNameSpacedFetchActions(endpointName);
          _context.prev = 1;
          fetchFn = ignoreJsonResponse ? _fetch.getResponseText : _fetch.getJsonOrError;
          _context.next = 5;
          return (0, _effects.call)(fetchFn, url);

        case 5:
          response = _context.sent;

          if (!(response instanceof Error)) {
            _context.next = 8;
            break;
          }

          throw new Error(response);

        case 8:
          responseJson = defaultResponseTransformer(response);
          data = dataTransformer ? dataTransformer(responseJson) : responseJson;
          state = additionalState ? (0, _extends3.default)({}, additionalState, data) : data;
          _context.next = 13;
          return (0, _effects.put)({ type: '' + NAMESPACED_FETCH_ACTIONS.FETCH.SUCCESS, state: state });

        case 13:
          _context.next = 20;
          break;

        case 15:
          _context.prev = 15;
          _context.t0 = _context['catch'](1);

          (0, _console.error)('fetchSaga ' + _context.t0);
          _context.next = 20;
          return (0, _effects.put)({ type: '' + NAMESPACED_FETCH_ACTIONS.FETCH.FAIL, error: _context.t0 });

        case 20:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[1, 15]]);
}

function getNoEndpointsErrorMessage(context) {
  var message = 'FETCH action types are undefined. Check pdo.config.api for available endpoints';
  (0, _console.error)(message, {
    message: message,
    component: context,
    props: context.props,
    api: _pageDataObject2.default.get('config.api')
  });
}

function watchFetchDataSaga() {
  return _regenerator2.default.wrap(function watchFetchDataSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.delegateYield((0, _reduxSaga.takeEvery)(FETCH_REQUEST_ACTION_TYPE, fetchDataSaga), 't0', 1);

        case 1:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(64);

var _promise2 = _interopRequireDefault(_promise);

exports.getResponseText = getResponseText;
exports.getJsonOrError = getJsonOrError;

__webpack_require__(1159);

var _console = __webpack_require__(11);

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
function json(response) {
  if (!response) {
    return _promise2.default.reject(response);
  }
  return response.json();
}

function handleResponseCode(response) {
  return response.ok ? response : _promise2.default.reject(response);
}

function handleFetchError(url, conf, response) {
  var status = response.status,
      statusText = response.statusText; // eslint-disable-line no-shadow

  var errorMessage = 'Failed fetching url \'' + url + '\'!\n  Status ' + status + ', statusText \'' + statusText + '\'.';
  (0, _console.warn)(errorMessage, { url: url, conf: conf, status: status, statusText: statusText, response: response });
  return Error(errorMessage);
}

function getResponseText(url) {
  var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return fetch(url, conf).then(handleResponseCode).catch(handleFetchError.bind(null, url, conf));
}
function getJsonOrError(url) {
  var conf = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return getResponseText(url, conf).then(json);
}

var fetchUtils = (0, _assign2.default)((0, _object.create)(), {
  getResponseText: getResponseText,
  getJsonOrError: getJsonOrError
});

(0, _nm.registerUtils)({ fetchUtils: fetchUtils });

/***/ }),

/***/ 61:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.getInfluencerId = getInfluencerId;
exports.getUserPlatform = getUserPlatform;
exports.IsMobileApp = IsMobileApp;
exports.getSyndicationPartnerId = getSyndicationPartnerId;

var _window = __webpack_require__(8);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var affiliateId = _window.queryString.a_aid,
    isApp = _window.queryString.app;


function getInfluencerFromPath(relativePath) {
  var matches = /\/partners\/([a-zA-Z0-9]*)/.exec(relativePath);
  if (matches && matches.length > 0) {
    var _matches = (0, _slicedToArray3.default)(matches, 2),
        partnerId = _matches[1];

    return partnerId;
  }
  return null;
}

function getPartnerId(partner) {
  var partnerId = partner.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + partnerId + '=([^&#]*)');
  var results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  // if (
  //   undefined !== document.getElementsByClassName('nm-embed') &&
  //   undefined !== document.getElementsByClassName('nm-embed')[0] &&
  //   undefined !== document.getElementsByClassName('nm-embed')[0].getAttribute('data-partner')
  // ) {
  //   return document.getElementsByClassName('nm-embed')[0].getAttribute('data-partner')
  // }
  // return 'partner id is missing'
}

function getInfluencerId() {
  return getInfluencerFromPath(window.location.pathname) || affiliateId;
}

function getUserPlatform() {
  return IsMobileApp() ? 'native' : /mobile|android|ipad|iphone/i.exec(navigator.userAgent) === null ? 'desktop' : 'mobile';
}

function IsMobileApp() {
  return isApp === '1';
}

function getSyndicationPartnerId() {
  return getPartnerId('partner');
}

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _appStore = __webpack_require__(23);

var _analyticsActions = __webpack_require__(31);

function pushConsentToDataLayer(consent) {
  return {
    type: _analyticsActions.CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT,
    state: {
      payload: {
        category: 'Cookie consent',
        action: 'user consent status',
        label: ' ',
        cookieConsent: consent
      }
    }
  };
}

function init() {
  window.__cmp('getConsentData', null, function (result) {
    console.log('result-getConsentData', result);
    localStorage.setItem('gdprApplies', result.gdprApplies);
    localStorage.setItem('consentData', result.consentData);
    if (null !== result.consentData) {
      (0, _appStore.dispatch)(pushConsentToDataLayer(result.consentData));
    }
  });
}

/***/ }),

/***/ 63:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseVm = function (_BaseClass) {
  (0, _inherits3.default)(BaseVm, _BaseClass);

  function BaseVm() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, BaseVm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseVm.__proto__ || (0, _getPrototypeOf2.default)(BaseVm)).call(this, options));

    var _this$options = _this.options,
        store = _this$options.store,
        stores = _this$options.stores,
        blockName = _this$options.blockName;

    (0, _assign2.default)(_this, { blockName: blockName });
    if (stores || store) {
      if (store) {
        var singleStoreName = store.constructor.name.replace(/^./, function (match) {
          return match.toLowerCase();
        });
        _this.stores = (0, _defineProperty3.default)({}, singleStoreName, store);
      } else {
        _this.stores = stores;
      }
      _this.addStoresChangeListeners();
    }
    return _this;
  }

  (0, _createClass3.default)(BaseVm, [{
    key: 'addStoresChangeListeners',
    value: function addStoresChangeListeners() {
      (0, _keys2.default)(this.stores).forEach(this.addStoreChangeListenerByStoreName, this);
      return this;
    }
  }, {
    key: 'addStoreChangeListenerByStoreName',
    value: function addStoreChangeListenerByStoreName(storeName) {
      return this.addStoreChangeListener(this.stores[storeName]);
    }
  }, {
    key: 'addStoreChangeListener',
    value: function addStoreChangeListener(store) {
      // required for mocks
      store && store.addChangeListener instanceof Function && store.addChangeListener(this.onChange.bind(this));
      return this;
    }
  }, {
    key: 'onChange',
    value: function onChange() {
      (0, _mithril.redraw)();
      return this;
    }
  }, {
    key: 'store',
    get: function get() {
      return this.stores[(0, _keys2.default)(this.stores)[0]];
    }
  }, {
    key: 'state',
    get: function get() {
      var _options = this.options,
          store = _options.store,
          state = _options.state;

      return store && store.state || state || {};
    }
  }]);
  return BaseVm;
}(_BaseClass3.default);

exports.default = BaseVm;

/***/ }),

/***/ 641:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _poweredBy = __webpack_require__(643);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoContainer = exports.LogoContainer = function (_React$Component) {
  (0, _inherits3.default)(LogoContainer, _React$Component);

  function LogoContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LogoContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LogoContainer.__proto__ || (0, _getPrototypeOf2.default)(LogoContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.getImageSrcBySite = function (site, isMobileVersion) {
      return __webpack_require__(1354)("./logo-" + site + (isMobileVersion ? '-mobile' : '') + '.embedded.svg');
    }, _this.getImage = function (site, imageSrc) {
      var isMobileVersion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return imageSrc ? imageSrc : _this.getImageSrcBySite(site, isMobileVersion);
    }, _this.handleLogoMorphLoaded = function () {
      return _this.setState({ logoMorphLoaded: !!_this.props.imageSrc });
    }, _this.shouldShowPoweredBy = function () {
      return _this.props.powered_by && !_this.state.logoMorphLoaded;
    }, _this.render = function () {
      return _react2.default.createElement(
        'a',
        {
          href: _this.props.href,
          className: 'logo ' + _this.props.alignment,
          'data-analytics-event-category': 'Navigation',
          'data-analytics-event-action': 'top logo click',
          'data-analytics-event-label': '' + (_this.state.logoMorphLoaded ? 'campaign' : 'regular'),
          'data-logo-variant-text': _this.props.powered_by
        },
        _react2.default.createElement('img', {
          alt: _this.props.site,
          src: _this.getImage(_this.props.site, _this.props.imageSrc),
          className: 'logo-img logo-img--desktop ' + (_this.state.logoMorphLoaded ? 'logo-img--morph' : ''),
          height: '50px',
          onLoad: function onLoad() {
            return _this.handleLogoMorphLoaded();
          }
        }),
        _react2.default.createElement('img', {
          alt: _this.props.site,
          src: _this.getImage(_this.props.site, _this.props.imageSrc, _this.props.hasMobileVersion),
          className: 'logo-img logo-img--mobile  ' + (_this.state.logoMorphLoaded ? 'logo-img--morph' : ''),
          height: '40px',
          onLoad: function onLoad() {
            return _this.handleLogoMorphLoaded();
          }
        }),
        _this.shouldShowPoweredBy() && _react2.default.createElement(_poweredBy.PoweredBy, { text: _this.props.powered_by, site: _this.props.site })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return LogoContainer;
}(_react2.default.Component);

/***/ }),

/***/ 642:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoContainerWithStore = undefined;

var _connectWithStore = __webpack_require__(179);

var _logo = __webpack_require__(796);

var _logo2 = __webpack_require__(641);

var mapStateTpProps = function mapStateTpProps(state, props) {
  return {
    imageSrc: (0, _logo.getLogoImageSrc)(state) ? (0, _logo.getLogoImageSrc)(state) : props.imageSrc
  };
};

var LogoContainerWithStore = exports.LogoContainerWithStore = (0, _connectWithStore.connectWithStore)(_logo2.LogoContainer, mapStateTpProps);

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PoweredBy = undefined;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPoweredByImage = function getPoweredByImage(site) {
  return __webpack_require__(1355)("./powered-by-" + site + ".embedded.svg");
};

var PoweredBy = exports.PoweredBy = function PoweredBy(props) {
  return _react2.default.createElement(
    "div",
    { className: "powered-by-container" },
    _react2.default.createElement(
      "span",
      { className: "powered-by-text" },
      props.text,
      " "
    ),
    _react2.default.createElement("img", { className: "powered-by-logo", src: getPoweredByImage(props.site) })
  );
};

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setArrayImmutable = function setArrayImmutable(arr, i, value) {
  return (0, _assign2.default)([].concat((0, _toConsumableArray3.default)(arr)), (0, _defineProperty3.default)({}, i, value));
};

var AccordionContainer = exports.AccordionContainer = function (_Component) {
  (0, _inherits3.default)(AccordionContainer, _Component);

  function AccordionContainer() {
    (0, _classCallCheck3.default)(this, AccordionContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AccordionContainer.__proto__ || (0, _getPrototypeOf2.default)(AccordionContainer)).call(this));

    _this.state = { isOpen: [] };
    _this.lastOpen = 0;
    return _this;
  }

  (0, _createClass3.default)(AccordionContainer, [{
    key: 'toggleChild',
    value: function toggleChild(childIndex) {
      var isOpen = [].concat((0, _toConsumableArray3.default)(this.state.isOpen));
      if (this.lastOpen !== childIndex) {
        isOpen = setArrayImmutable(isOpen, this.lastOpen, false);
        this.lastOpen = childIndex;
      }
      this.setState({ isOpen: setArrayImmutable(isOpen, childIndex, !this.state.isOpen[childIndex]) });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ isOpen: nextProps.children.map(function () {
          return false;
        }) });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        this.props.children.map(function (expandable, index) {
          return _react2.default.cloneElement(expandable, {
            isOpen: _this2.state.isOpen[index],
            onClick: function onClick(e) {
              return _this2.toggleChild(index);
            },
            key: index
          });
        })
      );
    }
  }]);
  return AccordionContainer;
}(_react.Component);

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticLinksContainer = exports.MenuSocialContainer = exports.MenuDownloadAppContainer = exports.MenuFrame = undefined;

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = __webpack_require__(1172);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _primitives = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getAppStoreImage = function getAppStoreImage(locale) {
  return __webpack_require__(1352)("./download_appstore_" + locale + '.svg');
};

var getandroidStoreImage = function getandroidStoreImage(locale) {
  return __webpack_require__(1353)("./download_googleplay_" + locale + '.svg');
};

var MenuFrame = exports.MenuFrame = function MenuFrame(props) {
  return _react2.default.createElement(
    _reactAddonsCssTransitionGroup2.default,
    {
      transitionName: 'menu__container',
      transitionEnterTimeout: 400,
      transitionLeaveTimeout: 400
    },
    props.isMenuOpen ? _react2.default.createElement(
      'div',
      {
        className: 'menu__container',
        onClick: function onClick() {
          return props.toggleMenu();
        },
        style: { marginTop: props.topAdMargin + 'px' }
      },
      _react2.default.createElement(
        'div',
        { className: 'menu__container-list', onClick: function onClick(e) {
            return e.stopPropagation();
          } },
        props.children
      )
    ) : null
  );
};

var MenuDownloadAppContainer = exports.MenuDownloadAppContainer = function MenuDownloadAppContainer(props) {
  return _react2.default.createElement(
    'div',
    { className: 'download-apps' },
    _react2.default.createElement(
      _primitives.Text,
      { className: 'header' },
      props.downloadOurAppText
    ),
    _react2.default.createElement(
      _primitives.HBox,
      { className: 'download-apps__items' },
      _react2.default.createElement(_primitives.LinkWithImage, {
        href: props.mobile.ios_url,
        src: getAppStoreImage(props.mobile.ios_icon_locale),
        className: 'store',
        'data-analytics-event-category': 'Navigation',
        'data-analytics-event-action': 'hamburger menu download app click',
        'data-analytics-event-label': 'app store'
      }),
      _react2.default.createElement(_primitives.LinkWithImage, {
        href: props.mobile.android_url,
        src: getandroidStoreImage(props.mobile.android_icon_locale),
        className: 'store',
        'data-analytics-event-category': 'Navigation',
        'data-analytics-event-action': 'hamburger menu download app click',
        'data-analytics-event-label': 'google play'
      })
    )
  );
};

var MenuSocialContainer = exports.MenuSocialContainer = function MenuSocialContainer(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _primitives.Text,
      { className: 'header' },
      props.stayUpToDateText
    ),
    _react2.default.createElement(
      _primitives.HBox,
      { className: 'social__items' },
      props.items.map(function (item) {
        return _react2.default.createElement(_primitives.IconWithLink, {
          href: item.url,
          size: '32',
          iconName: item.icon_name,
          key: item.description,
          'data-analytics-event-category': 'Navigation',
          'data-analytics-event-action': 'hamburger menu follow us click',
          'data-analytics-event-label': item.description,
          className: 'social__item'
        });
      })
    )
  );
};

var StaticLinksContainer = exports.StaticLinksContainer = function StaticLinksContainer(props) {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      _primitives.HBox,
      { className: 'menu__static__links__container' },
      props.items.map(function (item) {
        return _react2.default.createElement(
          'a',
          {
            className: 'menu__static__link__container',
            href: item.url,
            key: item.description,
            'data-analytics-event-category': 'Navigation',
            'data-analytics-event-action': 'hamburger menu static link click',
            'data-analytics-event-label': item.description
          },
          item.description
        );
      })
    )
  );
};

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _expandable = __webpack_require__(406);

var _primitives = __webpack_require__(197);

var _menu = __webpack_require__(645);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var min = function min(a, b) {
  return a < b ? a : b;
};
var addUtmSource = function addUtmSource(link, analyticsName) {
  return link + '?view_source=menu&view_medium=menu_' + analyticsName.replace(/-|_/g, '');
};

var MenuContainer = exports.MenuContainer = function (_Component) {
  (0, _inherits3.default)(MenuContainer, _Component);

  function MenuContainer() {
    (0, _classCallCheck3.default)(this, MenuContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (MenuContainer.__proto__ || (0, _getPrototypeOf2.default)(MenuContainer)).call(this));

    _this.state = { showMenu: false };
    return _this;
  }

  (0, _createClass3.default)(MenuContainer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      document.body.classList.toggle('no-scroll', !!nextProps.isMenuOpen);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body.classList.remove('no-scroll');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _menu.MenuFrame,
        this.props,
        MenuContainer.getMenuItemsInRange(this.props.links, 0, min(MenuContainer.NUM_OF_OPEN_ITEMS, this.props.links.length - 1)),
        this.props.links.length > MenuContainer.NUM_OF_OPEN_ITEMS + 1 ? _react2.default.createElement(
          _expandable.ExpandableContainer,
          null,
          _react2.default.createElement(
            _expandable.ExpandableContainer.Content,
            null,
            MenuContainer.getMenuItemsInRange(this.props.links, min(MenuContainer.NUM_OF_OPEN_ITEMS, this.props.links.length), -1)
          ),
          _react2.default.createElement(
            _expandable.ExpandableContainer.Header,
            { className: 'menu__container-list--expandable-header menu-item' },
            this.props.constants.more
          )
        ) : null,
        _react2.default.createElement(
          _primitives.StickyToBottomContainer,
          { className: 'menu__container-sticky-to-bottom' },
          MenuContainer.getMenuItemsInRange(this.props.links, -1),
          this.props.mobile ? _react2.default.createElement(_menu.MenuDownloadAppContainer, {
            downloadOurAppText: this.props.constants.download_app
            // ios={this.props.mobile.ios}
            // android={this.props.mobile.android}
            , mobile: this.props.mobile
          }) : null,
          this.props.social ? _react2.default.createElement(_menu.MenuSocialContainer, {
            stayUpToDateText: this.props.constants.stay_up_to_date,
            items: this.props.social
          }) : null,
          this.props.staticLinks ? _react2.default.createElement(_menu.StaticLinksContainer, { items: this.props.staticLinks }) : null
        )
      );
    }
  }]);
  return MenuContainer;
}(_react.Component);

MenuContainer.NUM_OF_OPEN_ITEMS = 5;

MenuContainer.getMenuItemsInRange = function (items, start, end) {
  return items.slice(start, end).map(function (item, index) {
    return _react2.default.createElement(
      _primitives.MenuItem,
      { key: item.description },
      _react2.default.createElement(
        _primitives.Link,
        {
          className: 'menu-item__link',
          href: addUtmSource(item.url, item.analytics_description),
          'data-analytics-event-category': 'Navigation',
          'data-analytics-event-action': 'hamburger menu click',
          'data-analytics-event-label': item.analytics_description,
          'data-analytics-event-value': 'position ' + (start + index)
        },
        item.icon_name ? _react2.default.createElement(_primitives.Icon, { size: '20', className: 'menu-item__icon', iconName: item.icon_name }) : null,
        _react2.default.createElement(
          'div',
          { className: 'menu-item__text' },
          item.description
        )
      )
    );
  });
};

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButtonContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _primitives = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MenuButtonContainer = exports.MenuButtonContainer = function (_Component) {
  (0, _inherits3.default)(MenuButtonContainer, _Component);

  function MenuButtonContainer() {
    (0, _classCallCheck3.default)(this, MenuButtonContainer);
    return (0, _possibleConstructorReturn3.default)(this, (MenuButtonContainer.__proto__ || (0, _getPrototypeOf2.default)(MenuButtonContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(MenuButtonContainer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'button',
        {
          className: 'menu__button hamburger hamburger--spin\n          ' + (this.props.isMenuOpen ? 'is-active' : '') + '\n          ',
          type: 'button',
          onClick: function onClick() {
            return _this2.props.toggleMenu();
          }
        },
        this.props.menuIcon ? _react2.default.createElement(_primitives.Icon, { size: '20', className: 'menu__button icon', iconName: this.props.menuIcon }) : _react2.default.createElement(
          'span',
          { className: 'hamburger-box' },
          _react2.default.createElement('span', { className: 'hamburger-inner' })
        )
      );
    }
  }]);
  return MenuButtonContainer;
}(_react.Component);

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuButtonWithStoreComponent = undefined;

var _connectWithStore = __webpack_require__(179);

var _menu = __webpack_require__(319);

var _menuButton = __webpack_require__(647);

var _menu2 = __webpack_require__(318);

var mapStateTpProps = function mapStateTpProps(state) {
  return {
    isMenuOpen: (0, _menu.isMenuOpen)(state)
  };
};

var mapDispatchToProps = {
  toggleMenu: _menu2.toggleMenu
};

var MenuButtonWithStoreComponent = exports.MenuButtonWithStoreComponent = (0, _connectWithStore.connectWithStore)(_menuButton.MenuButtonContainer, mapStateTpProps, mapDispatchToProps);

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuWithStoreComponent = undefined;

var _menu = __webpack_require__(319);

var _connectWithStore = __webpack_require__(179);

var _menu2 = __webpack_require__(646);

var _menu3 = __webpack_require__(318);

var _topAd = __webpack_require__(429);

var mapStateTpProps = function mapStateTpProps(state) {
  return {
    isMenuOpen: (0, _menu.isMenuOpen)(state),
    topAdMargin: (0, _topAd.getTopAdHeight)(state)
  };
};
var mapDispatchToProps = {
  toggleMenu: _menu3.toggleMenu
};

var MenuWithStoreComponent = exports.MenuWithStoreComponent = (0, _connectWithStore.connectWithStore)(_menu2.MenuContainer, mapStateTpProps, mapDispatchToProps);

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CategoriesContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(407);

var _image = __webpack_require__(245);

var _expandable = __webpack_require__(406);

var _accordion = __webpack_require__(644);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addUtmSourceItem = function addUtmSourceItem(link, analyticsCategory, analyticsItem) {
  return link + '?view_source=nav_bar&view_medium=nav_bar_' + analyticsCategory.replace(/[^\w\s!?]/g, '') + '_' + analyticsItem.replace(/[^\w\s!?]/g, '');
};

var addUtmSourceCategory = function addUtmSourceCategory(link, analyticsCategory) {
  return link + '?view_source=nav_bar&view_medium=nav_bar_' + analyticsCategory.replace(/[^\w\s!?]/g, '');
};

var CategoriesContainer = exports.CategoriesContainer = function (_Component) {
  (0, _inherits3.default)(CategoriesContainer, _Component);

  function CategoriesContainer() {
    (0, _classCallCheck3.default)(this, CategoriesContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (CategoriesContainer.__proto__ || (0, _getPrototypeOf2.default)(CategoriesContainer)).call(this));

    _this.renderNonExpandableCategories = function () {
      if (_this.getNoneExpendableCategories().length === 0) return;
      return _this.getNoneExpendableCategories().map(function (category, index) {
        return _react2.default.createElement(
          'a',
          {
            key: index,
            href: addUtmSourceCategory(category.url, category.analytics),
            target: '_self',
            className: 'category__link-container',
            'data-analytics-event-category': 'Navigation',
            'data-analytics-event-action': 'nav bar click',
            'data-analytics-event-label': category.analytics,
            'data-analytics-event-value': '1=>' + index
          },
          _react2.default.createElement(_image.Image, (0, _util.imageProps)(category.icon, 'category__image')),
          _react2.default.createElement(
            'div',
            { className: 'category__description' },
            category.description
          )
        );
      });
    };

    _this.renderExpandableCategories = function () {
      if (_this.getExpendableCategories().length === 0) return;
      return _this.getExpendableCategories().map(function (category, index) {
        var itemsContainerClass = (0, _util.getItemsContainerClass)(category.items.length);
        return _react2.default.createElement(
          _expandable.ExpandableContainer,
          { key: index },
          _react2.default.createElement(
            _expandable.ExpandableContainer.Header,
            { className: 'category__arrow-icon' },
            _react2.default.createElement(_image.Image, (0, _util.imageProps)(category.icon, 'category__image')),
            _react2.default.createElement(
              'div',
              { className: 'category__description' },
              category.description
            )
          ),
          _react2.default.createElement(
            _expandable.ExpandableContainer.Content,
            null,
            _react2.default.createElement(
              'div',
              { className: 'items-container__wraaper' },
              _react2.default.createElement(
                'div',
                { className: ['items-container', itemsContainerClass].join(' ') },
                _this.renderItems(category, index)
              )
            )
          )
        );
      });
    };

    return _this;
  }

  (0, _createClass3.default)(CategoriesContainer, [{
    key: 'renderItems',
    value: function renderItems(category, categoryIndex) {
      var itemContainerClass = (0, _util.getItemContainerClass)(category.items.length);
      return category.items.map(function (item, index) {
        return _react2.default.createElement(
          'a',
          {
            className: ['item__container', itemContainerClass].join(' '),
            key: index,
            href: addUtmSourceItem(item.url, category.analytics, item.analytics),
            'data-analytics-event-category': 'Navigation',
            'data-analytics-event-action': 'nav bar click',
            'data-analytics-event-label': category.analytics + '=>' + item.analytics,
            'data-analytics-event-value': '1=>' + categoryIndex + '=>' + index
          },
          _react2.default.createElement(_image.Image, (0, _util.imageProps)(item.icon, 'item__image', item.description)),
          _react2.default.createElement(
            'div',
            { className: 'item__description' },
            item.description
          )
        );
      });
    }
  }, {
    key: 'getExpendableCategories',
    value: function getExpendableCategories() {
      return this.props.categories.filter(function (category) {
        return category.items.items !== null;
      });
    }
  }, {
    key: 'getNoneExpendableCategories',
    value: function getNoneExpendableCategories() {
      return this.props.categories.filter(function (category) {
        return category.items.items === null;
      });
    }
  }, {
    key: 'shouldRenderExpandable',
    value: function shouldRenderExpandable() {
      return this.getExpendableCategories().length > 0 ? true : false;
    }
  }, {
    key: 'shouldRenderNoneExpandable',
    value: function shouldRenderNoneExpandable() {
      return this.getNoneExpendableCategories().length > 0 ? true : false;
    }
  }, {
    key: 'renderExpandableWrraper',
    value: function renderExpandableWrraper() {
      return _react2.default.createElement(
        _accordion.AccordionContainer,
        null,
        this.renderExpandableCategories()
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          className: 'categories__wrapper ' + (this.props.isOpen ? 'categories__wrapper__container-opened' : 'categories__wrapper__container-closed')
        },
        _react2.default.createElement(
          'div',
          { className: 'categories__container' },
          this.shouldRenderExpandable() ? this.renderExpandableWrraper() : '',
          this.shouldRenderNoneExpandable() ? this.renderNonExpandableCategories() : ''
        ),
        _react2.default.createElement(
          'div',
          { className: 'categories__chevron-container', onClick: function onClick() {
              return _this2.props.closeMenu();
            } },
          _react2.default.createElement(_image.Image, (0, _util.imageProps)((0, _util.getIcon)('mainNavigationChevron'), 'mainNavigationChevron-icon'))
        )
      );
    }
  }]);
  return CategoriesContainer;
}(_react.Component);

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(407);

var _navItem = __webpack_require__(653);

var _Categories = __webpack_require__(650);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationContainer = exports.NavigationContainer = function (_Component) {
  (0, _inherits3.default)(NavigationContainer, _Component);

  function NavigationContainer() {
    (0, _classCallCheck3.default)(this, NavigationContainer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NavigationContainer.__proto__ || (0, _getPrototypeOf2.default)(NavigationContainer)).call(this));

    _this.state = {
      isOpen: false,
      openTabIndex: null,
      items: []
    };
    return _this;
  }

  (0, _createClass3.default)(NavigationContainer, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (document.body) {
        document.body.classList.toggle('no-scroll', nextState.isOpen);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (document.body) {
        document.body.classList.remove('no-scroll');
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if ((0, _util.shouldHeaderCollapsedWithNavigation)(this.props.site) && this.props.shouldShowNavigation !== nextProps.shouldShowNavigation) {
        document.getElementsByClassName('site-header')[0].classList.toggle('collapse');
        document.getElementsByClassName('video-top-anchor')[0].classList.toggle('collapsed');
      }
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu() {
      this.setState({ isOpen: false, openTabIndex: null });
    }
  }, {
    key: 'manageMenu',
    value: function manageMenu(navItem, index) {
      if (this.state.isOpen) {
        this.closeMenu();
      } else {
        this.props.mobileNavigationAnalyticsMenuClicked(navItem.analytics, index);
        this.setState({ isOpen: true, items: navItem.items, openTabIndex: index });
      }
    }
  }, {
    key: 'renderCategories',
    value: function renderCategories() {
      var _this2 = this;

      return _react2.default.createElement(_Categories.CategoriesContainer, {
        categories: this.state.items,
        isOpen: this.state.isOpen,
        closeMenu: function closeMenu() {
          return _this2.closeMenu();
        }
      });
    }
  }, {
    key: 'isLinkNavItemMatch',
    value: function isLinkNavItemMatch(url) {
      var path = (0, _util.getPath)();
      return path !== '/' && url === path;
    }
  }, {
    key: 'isMenuNavItemOpen',
    value: function isMenuNavItemOpen(index, categories) {
      return this.state.isOpen && this.state.openTabIndex == index && categories !== null;
    }
  }, {
    key: 'isLinkNavItemSelected',
    value: function isLinkNavItemSelected(url, categories) {
      return this.isLinkNavItemMatch(url) && categories === null && !this.state.isOpen;
    }
  }, {
    key: 'getNavItemBottomBorderStyle',
    value: function getNavItemBottomBorderStyle(index, url, categories) {
      return this.isMenuNavItemOpen(index, categories) || this.isLinkNavItemSelected(url, categories);
    }
  }, {
    key: 'renderNavigation',
    value: function renderNavigation(navItems) {
      var _this3 = this;

      return navItems.map(function (navItem, index) {
        return _react2.default.createElement(
          'div',
          {
            className: [(0, _util.getNavItemStyle)(navItems.length), _this3.getNavItemBottomBorderStyle(index, navItem.url, navItem.items) ? 'nav__item__selected_border' : 'nav__item__border', navItem.items !== null ? 'nav__item__with_children' : ''].join(' '),
            key: index
          },
          _react2.default.createElement(_navItem.NavItemContainer, {
            description: navItem.description,
            icon: navItem.icon,
            analytics: navItem.analytics,
            url: navItem.url,
            isHaveCategories: navItem.items !== null ? true : false,
            isOpen: _this3.state.isOpen && index === _this3.state.openTabIndex,
            selectedNavItem: (0, _util.getPath)(),
            index: index,
            onCategorySelected: function onCategorySelected() {
              _this3.manageMenu(navItem, index);
            }
          })
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: 'mobile-nav-main-wrapper ' + (this.props.shouldShowNavigation ? 'mobile-nav-main-wrapper__opened' : 'mobile-nav-main-wrapper__closed')
        },
        _react2.default.createElement(
          'div',
          { className: 'nav__wrapper' },
          this.renderNavigation(this.props.config)
        ),
        this.renderCategories()
      );
    }
  }]);
  return NavigationContainer;
}(_react.Component);

NavigationContainer.defaultProps = {
  shouldShowNavigation: true,
  topAdMargin: 0
};

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationContainerWithStore = undefined;

var _connectWithStore = __webpack_require__(179);

var _Navigation = __webpack_require__(651);

var _topAd = __webpack_require__(429);

var _visibility = __webpack_require__(812);

var _analyticsActions = __webpack_require__(31);

var _userDevice = __webpack_require__(430);

var mapDispatchToProps = {
  mobileNavigationAnalyticsMenuClicked: _analyticsActions.mobileNavigationMenuClicked
};

var mapStateTpProps = function mapStateTpProps(state, props) {
  return {
    topAdMargin: (0, _userDevice.getIsMobile)(state) || (0, _userDevice.getIsTabletInPortrait)(state) ? (0, _topAd.getTopAdHeight)(state) : 0,
    shouldShowNavigation: (0, _visibility.shouldShowNavigationInMobile)(state)
  };
};

var NavigationContainerWithStore = exports.NavigationContainerWithStore = (0, _connectWithStore.connectWithStore)(_Navigation.NavigationContainer, mapStateTpProps, mapDispatchToProps);

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavItemContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _primitives = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addUtmSource = function addUtmSource(link, analyticsName) {
  return link + '?view_source=nav_bar&viewmedium=nav_bar_' + analyticsName;
};
var ROOT = '/';

var NavItemContainer = exports.NavItemContainer = function (_Component) {
  (0, _inherits3.default)(NavItemContainer, _Component);

  function NavItemContainer() {
    (0, _classCallCheck3.default)(this, NavItemContainer);
    return (0, _possibleConstructorReturn3.default)(this, (NavItemContainer.__proto__ || (0, _getPrototypeOf2.default)(NavItemContainer)).call(this));
  }

  (0, _createClass3.default)(NavItemContainer, [{
    key: 'navItemClicked',
    value: function navItemClicked(ev) {
      this.props.onCategorySelected();
    }
  }, {
    key: 'renderMenuNavItem',
    value: function renderMenuNavItem() {
      var _this2 = this;

      var wrapperSelectedClass = 'nav__icon';
      var itemContainerSelectedClass = 'nav__item__text';
      var itemTriangleClass = 'nav__item__triangle';

      if (this.props.isOpen) {
        wrapperSelectedClass = wrapperSelectedClass + ' nav__icon__selected';
        itemContainerSelectedClass = itemContainerSelectedClass + ' nav__item__text__selected';
        itemTriangleClass = itemTriangleClass + ' nav__item__triangle__open';
      }

      return _react2.default.createElement(
        'div',
        { onClick: function onClick(ev) {
            return _this2.navItemClicked(ev);
          }, className: 'nav__item__link' },
        _react2.default.createElement(_primitives.Icon, { size: '20', className: wrapperSelectedClass, iconName: this.props.icon }),
        _react2.default.createElement(
          'div',
          { className: 'nav__item__container' },
          _react2.default.createElement(
            'div',
            { className: itemContainerSelectedClass },
            this.props.description
          ),
          _react2.default.createElement('div', { className: itemTriangleClass })
        )
      );
    }
  }, {
    key: 'isLinkNavItemSelected',
    value: function isLinkNavItemSelected() {
      return this.props.selectedNavItem !== ROOT && this.props.url === this.props.selectedNavItem;
    }
  }, {
    key: 'isIconColorful',
    value: function isIconColorful() {
      return this.props.icon.includes('.embedded');
    }
  }, {
    key: 'getLinkIconStyle',
    value: function getLinkIconStyle() {
      return this.props.isOpen || !this.isLinkNavItemSelected();
    }
  }, {
    key: 'renderLinkNavItem',
    value: function renderLinkNavItem() {
      return _react2.default.createElement(
        'a',
        {
          className: 'nav__item__link',
          href: addUtmSource(this.props.url, this.props.analytics),
          'data-analytics-event-category': 'Navigation',
          'data-analytics-event-action': 'nav bar click',
          'data-analytics-event-label': this.props.analytics,
          'data-analytics-event-sub-label': this.props.index
        },
        _react2.default.createElement(_primitives.Icon, {
          size: '20',
          className: this.getLinkIconStyle() ? 'nav__icon' : 'nav__icon__selected',
          iconName: this.props.icon
        }),
        _react2.default.createElement(
          'div',
          { className: 'nav__item__container' },
          _react2.default.createElement(
            'div',
            {
              className: 'nav__item__text ' + (this.isLinkNavItemSelected() && !this.props.isOpen ? 'nav__item__text__selected' : '')
            },
            this.props.description
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.isHaveCategories ? this.renderMenuNavItem() : this.renderLinkNavItem()
      );
    }
  }]);
  return NavItemContainer;
}(_react.Component);

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.linksCounter = linksCounter;
exports.linksDescription = linksDescription;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValid(link) {
  var site = window.location.host;
  return link.includes(site);
}

function queryByPath(path) {
  return [].concat((0, _toConsumableArray3.default)(document.querySelectorAll(path)));
}
function getArticleLinks() {
  return queryByPath('.post-content > p > a').concat(queryByPath('.post-content > p > strong > a'));
}

function getTopxLinks() {
  return queryByPath('.post-body > .fragment > p > a');
}

function getLinks() {
  var links = [].concat((0, _toConsumableArray3.default)(getArticleLinks())).length > 0 ? [].concat((0, _toConsumableArray3.default)(getArticleLinks())) : [].concat((0, _toConsumableArray3.default)(getTopxLinks()));
  return links.filter(function (link) {
    return isValid(link.href);
  });
}

function getLinkDescription(link) {
  if (undefined !== link.href) {
    var parts = link.href.split('/');
    return parts[parts.length - 1];
  }
  return '';
}

function linksCounter() {
  return getLinks().length;
}

function linksDescription() {
  var description = '';
  getLinks().forEach(function (link) {
    description += getLinkDescription(link) + ';';
  });

  return description;
}

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendedPostsCardsContainer = undefined;

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _i18nProvider = __webpack_require__(18);

var _image = __webpack_require__(245);

var _utils = __webpack_require__(674);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var recommendedPostsCardsContainer = exports.recommendedPostsCardsContainer = function (_React$Component) {
  (0, _inherits3.default)(recommendedPostsCardsContainer, _React$Component);

  function recommendedPostsCardsContainer() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, recommendedPostsCardsContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = recommendedPostsCardsContainer.__proto__ || (0, _getPrototypeOf2.default)(recommendedPostsCardsContainer)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      if (!(0, _utils.hasPosts)(_this.props.posts)) {
        return null;
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'recommeneded_posts_cards__container',
          'data-viewability': 'in-article recommendations-cards'
        },
        _react2.default.createElement(
          'div',
          { className: 'recommeneded_posts_cards__title' },
          (0, _i18nProvider.t)('post_page.similar_articles').toUpperCase()
        ),
        _react2.default.createElement('div', { className: 'recommeneded_posts_cards__divider' }),
        _this.props.posts.map(function (post, index) {
          return relatedArticleView(post, index);
        })
      );
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  return recommendedPostsCardsContainer;
}(_react2.default.Component);

function relatedArticleView(post, index) {
  return _react2.default.createElement(
    'a',
    {
      className: 'recommended_post_img_and_title_wrraper',
      href: (0, _utils.buildLinkUrl)(post.url, index, 'cards'),
      target: '_self',
      onClick: function onClick() {
        return (0, _utils.reportAnalytics)('cards', index);
      },
      key: index
    },
    _react2.default.createElement(_image.Image, (0, _utils.imageProps)(post.image_url, 'recommended_post__container__img')),
    _react2.default.createElement(
      'div',
      { className: 'recommended_post__container__title' },
      post.title,
      _react2.default.createElement(
        'div',
        { className: 'recommended_post__container__auther' },
        'By ',
        post.author_name
      )
    )
  );
}

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildLinkUrl = buildLinkUrl;
exports.reportAnalytics = reportAnalytics;
exports.imageProps = imageProps;
exports.hasPosts = hasPosts;

var _analyticsActions = __webpack_require__(31);

var _appStore = __webpack_require__(23);

function buildLinkUrl(url, index, version) {
  return url + '?view_source=recommendations&view_medium=inarticle_recommendations&unit_version=' + version + '&item_position=' + index;
}

function reportAnalytics(version, index) {
  (0, _appStore.dispatch)((0, _analyticsActions.recomendedPostsAnalyticsAction)(version, index));
}

function imageProps(imageSrc, className) {
  return {
    lazyLoad: true,
    src: imageSrc,
    className: className,
    alt: 'image'
  };
}

function hasPosts(posts) {
  return posts !== undefined && posts !== null && posts.length > 0;
}

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _and = __webpack_require__(742);

var _and2 = _interopRequireDefault(_and);

var _not = __webpack_require__(743);

var _not2 = _interopRequireDefault(_not);

var _or = __webpack_require__(744);

var _or2 = _interopRequireDefault(_or);

var _pathnameIncludesAfterKey = __webpack_require__(745);

var _pathnameIncludesAfterKey2 = _interopRequireDefault(_pathnameIncludesAfterKey);

var _pathnameIncludesOne = __webpack_require__(746);

var _pathnameIncludesOne2 = _interopRequireDefault(_pathnameIncludesOne);

var _referrerExists = __webpack_require__(747);

var _referrerExists2 = _interopRequireDefault(_referrerExists);

var _referrerIncludesPlatform = __webpack_require__(748);

var _referrerIncludesPlatform2 = _interopRequireDefault(_referrerIncludesPlatform);

var _referrerIsSameAsSite = __webpack_require__(749);

var _referrerIsSameAsSite2 = _interopRequireDefault(_referrerIsSameAsSite);

var _searchParamEqualsOne = __webpack_require__(750);

var _searchParamEqualsOne2 = _interopRequireDefault(_searchParamEqualsOne);

var _searchParamsIncludeOne = __webpack_require__(752);

var _searchParamsIncludeOne2 = _interopRequireDefault(_searchParamsIncludeOne);

var _searchParamIncludesOne = __webpack_require__(751);

var _searchParamIncludesOne2 = _interopRequireDefault(_searchParamIncludesOne);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  and: _and2.default,
  not: _not2.default,
  or: _or2.default,
  pathnameIncludesAfterKey: _pathnameIncludesAfterKey2.default,
  pathnameIncludesOne: _pathnameIncludesOne2.default,
  referrerExists: _referrerExists2.default,
  referrerIncludesPlatform: _referrerIncludesPlatform2.default,
  referrerIsSameAsSite: _referrerIsSameAsSite2.default,
  searchParamEqualsOne: _searchParamEqualsOne2.default,
  searchParamsIncludeOne: _searchParamsIncludeOne2.default,
  searchParamIncludesOne: _searchParamIncludesOne2.default
};

/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMPTY_SLOT_SIZES_OBJECT = exports.EMPTY_SLOT_DIMENSIONS = exports.adStore = undefined;

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseStore = __webpack_require__(77);

var _baseStore2 = _interopRequireDefault(_baseStore);

var _adActions = __webpack_require__(50);

var _window = __webpack_require__(8);

var _slideshowActions = __webpack_require__(246);

var _geolocationProvider = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// when set to true, COUNTRY_CODES_TO_REFRESH_ADS_IN_SLIDESHOW is ignored
var SHOULD_REFRESH_ADS_IN_ALL_COUNTRY_CODES = true;
// CountryCode list source: http://dev.maxmind.com/geoip/legacy/codes/iso3166/
var COUNTRY_CODES_TO_REFRESH_ADS_IN_SLIDESHOW = ['in', 'ar', 'th', 'mx'];
// disables ad refreshed, ignoring all other settings
var SHOULD_NOT_REFRESH = false;
var SLIDE_COUNT_BEFORE_ADS_REFRESH = 1;
var adsDebugRefresh = _window.queryString.adsDebugRefresh;

var EMPTY_SLOT_DIMENSIONS = [0, 0];
var EMPTY_SLOT_SIZES_OBJECT = { width: 0, height: 0 };

var AdStore = function (_BaseStore) {
  (0, _inherits3.default)(AdStore, _BaseStore);

  function AdStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, AdStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdStore.__proto__ || (0, _getPrototypeOf2.default)(AdStore)).call(this, options));

    _this.merge({
      state: {
        shown: {},
        topSlotHeight: null,
        slidesChanged: 0
      },
      adBlockDetected: null,
      shouldRefreshSlot: SHOULD_NOT_REFRESH
    });
    if (SHOULD_REFRESH_ADS_IN_ALL_COUNTRY_CODES) {
      _this.setAdRefreshPolicy(SHOULD_REFRESH_ADS_IN_ALL_COUNTRY_CODES);
    } else {
      (0, _geolocationProvider.getCountryCode)().then(_this.setAdRefreshPolicyByCountryCode.bind(_this)).catch(_this.setAdRefreshPolicy.part(SHOULD_NOT_REFRESH));
    }
    return _this;
  }

  (0, _createClass3.default)(AdStore, [{
    key: 'setAdRefreshPolicy',
    value: function setAdRefreshPolicy(shouldRefreshAdsOnSlideChange) {
      adsDebugRefresh && this.info('Setting slideshow ad refresh policy. Refresh every', SLIDE_COUNT_BEFORE_ADS_REFRESH, 'slides?', shouldRefreshAdsOnSlideChange);
      return this.merge({ shouldRefreshSlot: shouldRefreshAdsOnSlideChange }).emitChange();
    }
  }, {
    key: 'setAdRefreshPolicyByCountryCode',
    value: function setAdRefreshPolicyByCountryCode(countryCode) {
      adsDebugRefresh && this.info('current countryCode', countryCode);
      var shouldRefresh = COUNTRY_CODES_TO_REFRESH_ADS_IN_SLIDESHOW.includes(countryCode.toLowerCase());
      return this.setAdRefreshPolicy(shouldRefresh);
    }
  }, {
    key: 'routeAction',
    value: function routeAction(action) {
      var type = action.type,
          adId = action.adId,
          size = action.size,
          isEmpty = action.isEmpty;

      var ACTIONS = _adActions.TYPES;
      var SLIDESHOW_ACTIONS = _slideshowActions.TYPES;
      switch (type) {
        case ACTIONS.AD_BLOCK_DETECTION_FINISHED:
          return this.onAdBlockDetectionFinished(action.state.detected);
        case ACTIONS.SLOT_HIDE:
          this.state.shown[adId] = false;
          return this.emitChange();
        case ACTIONS.SLOT_RENDERED:
          var topSlot = window.googletag.renderedAdsEvents.Top;
          if (topSlot && !this.state.topSlotHeight) {
            var topSlotHeight = topSlot.isEmpty || !topSlot.size ? 0 : topSlot.size[1];
            this.state.topSlotHeight = !this.state.topSlotHeight ? topSlotHeight : 'auto';
          }
          this.state.shown[adId] = !isEmpty;
          this.state[adId] = this.state[adId] || {};
          this.state[adId].adSize = size;
          return this.emitChange(action);
        case SLIDESHOW_ACTIONS.START_SLIDE_CHANGE:
          this.state.slidesChanged += 1;
          if (this.state.slidesChanged % SLIDE_COUNT_BEFORE_ADS_REFRESH === 0) {
            adsDebugRefresh && this.info('Calling emitChange({ event: { slideshowRefreshAction: true, }, })', this, this.state.slidesChanged);
            return this.emitChange({
              event: {
                slideshowRefreshAction: true
              }
            });
          }
          return this;
        case SLIDESHOW_ACTIONS.COMPLETE_SLIDE_CHANGE:
          return this.emitChange({
            event: {
              resetPageTargetingLimit: true
            }
          });
        default:
          return this;
      }
    }
  }, {
    key: 'onAdBlockDetectionFinished',
    value: function onAdBlockDetectionFinished(detected) {
      this.state.adBlockDetected = detected;
      return this.emitChange();
    }
  }, {
    key: 'shouldRefreshSlot',
    get: function get() {
      return !this.isAdblockPresent && this.state.shouldRefreshSlot;
    },
    set: function set(bool) {
      this.state.shouldRefreshSlot = bool;
    }
  }, {
    key: 'isAdsEnabled',
    get: function get() {
      return this.state.isAdsEnabled;
    },
    set: function set(isEnabled) {
      this.state.isAdsEnabled = isEnabled;
    }
  }, {
    key: 'isAdblockPresent',
    get: function get() {
      return this.state.adBlockDetected;
    }
  }, {
    key: 'requestedAdsCount',
    get: function get() {
      return (0, _keys2.default)(this.state.shown).length;
    }
  }]);
  return AdStore;
}(_baseStore2.default);

var adStore = AdStore.create();

exports.adStore = adStore;
exports.EMPTY_SLOT_DIMENSIONS = EMPTY_SLOT_DIMENSIONS;
exports.EMPTY_SLOT_SIZES_OBJECT = EMPTY_SLOT_SIZES_OBJECT;

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.comp = exports.empty = undefined;

var _getIterator2 = __webpack_require__(55);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _weakSet = __webpack_require__(323);

var _weakSet2 = _interopRequireDefault(_weakSet);

exports.unmount = unmount;
exports.mount = mount;
exports.make = make;
exports.mountAll = mountAll;
exports.areComponentsIdentical = areComponentsIdentical;

var _mithril = __webpack_require__(34);

var _dom = __webpack_require__(12);

var _fn = __webpack_require__(15);

var _window = __webpack_require__(8);

var _console = __webpack_require__(11);

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentlyMountedElementSet = new _weakSet2.default(); /**
                                                           * Mithril abstractions and componentization.
                                                           */
function unmount(rootNode) {
  return (0, _mithril.mount)(rootNode, null);
}

function mountWithOptions(rootNode, opts) {
  var component = opts.component;

  if (component === null) {
    return unmount(rootNode);
  }
  var componentOptions = component((0, _assign2.default)(opts, { rootNode: rootNode }));
  if (currentlyMountedElementSet.has(rootNode)) {
    (0, _console.warn)('component with rootNode: "' + rootNode.className + '" already mounted', { rootNode: rootNode, opts: opts });
  }
  currentlyMountedElementSet.add(rootNode);
  return (0, _mithril.mount)(rootNode, componentOptions);
}

function mount() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var rootNode = opts.rootNode,
      rootSelector = opts.rootSelector;

  if (rootNode) {
    mountWithOptions(rootNode, opts);
  }
  if (rootSelector) {
    var rootNodes = (0, _dom.nodes)(rootSelector);
    if (rootNodes.length > 0) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(rootNodes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var mountNode = _step.value;

          mountWithOptions(mountNode, opts);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    } else if (_window.queryString.debugMounts) {
      (0, _console.warn)('mountComponent called with rootNodeSelector: \'' + opts.rootSelector + '\' but didn\'t find it in DOM', { opts: opts });
    }
  }
}

function make(ctrl) {
  var viewClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return function componentMaker(options) {
    var componentName = ctrl.name.replace('Controller', '');
    if (!viewClass) {
      throw new Error('Error in ' + ctrl.name + ' - pass view explicitly to component.make function. using component.make without explicitly passing view behavior has been disabled because of https://github.com/FTBpro/FTBpro/issues/1641');
      // disabled until dynamic requires are made non recursive.
      // viewClass = require(`views/${ componentName }View`);
    }
    var viewInstance = viewClass.create();
    return {
      view: viewInstance.view.bind(viewInstance),
      controller: ctrl.bind(null, options),
      name: componentName
    };
  };
}

function mountAll() {
  var selectorComponentMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  for (var rootSelector in selectorComponentMap) {
    var component = selectorComponentMap[rootSelector];
    mount({ component: component, rootSelector: rootSelector });
  }
}

var empty = exports.empty = (0, _fn.makeSafeFn)(make(_fn.noop, _fn.noop), { isMute: true });

function areComponentsIdentical(comp1, comp2) {
  try {
    return comp1().name === comp2().name;
  } catch (ex) {
    return false;
  }
}

var comp = exports.comp = (0, _assign2.default)((0, _object.create)(), {
  mount: mount,
  unmount: unmount,
  mountAll: mountAll,
  empty: empty,
  make: make,
  areComponentsIdentical: function areComponentsIdentical(comp1, comp2) {
    try {
      return comp1().name === comp2().name;
    } catch (ex) {
      return false;
    }
  }
});

(0, _nm.registerUtils)({ component: comp });

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MountedComponent = undefined;

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _reactRedux = __webpack_require__(37);

var _mountedComponents = __webpack_require__(320);

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(60);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _appStore = __webpack_require__(23);

var _appStore2 = _interopRequireDefault(_appStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MountedComponent = exports.MountedComponent = function (_Component) {
  (0, _inherits3.default)(MountedComponent, _Component);

  function MountedComponent() {
    (0, _classCallCheck3.default)(this, MountedComponent);
    return (0, _possibleConstructorReturn3.default)(this, (MountedComponent.__proto__ || (0, _getPrototypeOf2.default)(MountedComponent)).apply(this, arguments));
  }

  (0, _createClass3.default)(MountedComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          container = _props.container,
          options = _props.options;
      var MountingComponent = container.component,
          componentName = container.name,
          stateKey = container.stateKey,
          reducer = container.reducer,
          props = container.props,
          sagas = container.sagas;

      var componentProps = (0, _extends3.default)({ options: options }, props || {});
      var ComponentInstance = _react2.default.createElement(MountingComponent, componentProps);

      if (stateKey !== undefined && reducer !== undefined) {
        (0, _appStore.addReducer)(stateKey, reducer);
      }
      (0, _appStore.dispatch)((0, _mountedComponents.componentMount)(ComponentInstance, componentName, sagas));
      var componentWithStoreProps = {
        store: _appStore2.default,
        children: ComponentInstance
      };
      this.renderedView = _react2.default.createElement(_reactRedux.Provider, componentWithStoreProps);
      this.forceUpdate();
    }
  }, {
    key: 'render',
    value: function render() {
      return this.renderedView || false;
    }
  }]);
  return MountedComponent;
}(_react.Component); /* eslint semi:0 */
/**
 * HOC to connect Redux and dynamically reconfigure store, reducers,
 * sagas for mounting component configs and pass mountpoint data as props
 * to mounted component.
 */


MountedComponent.propTypes = {
  dispatch: _propTypes2.default.func,

  container: _propTypes2.default.object
};

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commonConfiguration = exports.gtmHandler = exports.logger = undefined;

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _symbol = __webpack_require__(437);

var _symbol2 = _interopRequireDefault(_symbol);

exports.dynamicSagasMiddleware = dynamicSagasMiddleware;

var _reduxLogger = __webpack_require__(1285);

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

var _window = __webpack_require__(8);

var _AppDispatcher = __webpack_require__(56);

var _reduxThunk = __webpack_require__(1292);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = __webpack_require__(174);

var _reduxSaga = __webpack_require__(536);

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _GtmService = __webpack_require__(724);

var _GtmService2 = _interopRequireDefault(_GtmService);

var _reduxDevtoolsExtension = __webpack_require__(1281);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FLUX_ACTION_SOURCE = (0, _symbol2.default)('Flux action'); /**
                                                                * Redux middlewares and interop with Flux.
                                                                */

var reduxLoggerConf = {
  collapsed: true,
  duration: true,
  timestamp: true,
  colors: {
    title: function title(action) {
      return action.source === FLUX_ACTION_SOURCE ? 'red' : 'green';
    }
  }
};

var FEATURE_FLAGS = {
  routeAllFluxActionsToRedux: _window.queryString.routeAllFluxActionsToRedux
};

var gtmService = null;

function getGtmService() {
  return (gtmService || (gtmService = (0, _GtmService2.default)())).apply(undefined, arguments);
}

function dispatchReduxAction(reduxStore, fluxAction) {
  if (FEATURE_FLAGS.routeAllFluxActionsToRedux || fluxAction.dispatchToRedux) {
    reduxStore.dispatch({
      type: fluxAction.type,
      source: FLUX_ACTION_SOURCE,
      state: fluxAction.payload
    });
  }
}

function fluxConnectorMiddleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      if (action.source !== FLUX_ACTION_SOURCE && result) {
        _AppDispatcher.appDispatcher.dispatchAction.view(result);
      }
      return result;
    };
  };
}

function fluxConnectorStoreEnhancer() {
  return function (next) {
    return function () {
      var store = next.apply(undefined, arguments);
      _AppDispatcher.appDispatcher.register(dispatchReduxAction.part(store));
      return store;
    };
  };
}

var logger = exports.logger = _window.queryString.debugRedux ? (0, _reduxLogger2.default)(reduxLoggerConf) : function (store) {
  return function (next) {
    return function (action) {
      return next(action);
    };
  };
};

var gtmHandler = exports.gtmHandler = function gtmHandler(store) {
  return function (next) {
    return function (action) {
      getGtmService(action);

      next(action);
    };
  };
};

function dynamicSagasMiddleware(reducerStateKeys, sagaKey, applicationSagas) {
  return function (store) {
    return function (next) {
      return function (action) {
        var state = store.getState();
        var stateChunksWithSagas = (0, _keys2.default)(state).filter(function (key) {
          return reducerStateKeys.includes(key);
        });
        if (!stateChunksWithSagas) {
          return next(action);
        }
        var sagasChunks = stateChunksWithSagas.reduce(function (accumulator, reducerName) {
          if (store.getState()[reducerName][sagaKey]) {
            return [].concat((0, _toConsumableArray3.default)(accumulator), [store.getState()[reducerName][sagaKey]]);
          }
        }, []);

        if (!sagasChunks.length) {
          return next(action);
        }

        var sagasList = sagasChunks.reduce(function (accumulator, sagas) {
          return [].concat((0, _toConsumableArray3.default)(accumulator), (0, _toConsumableArray3.default)(sagas));
        }, []);
        if (!sagasList) {
          return next(action);
        }
        return _reduxSaga2.default.apply(undefined, (0, _toConsumableArray3.default)(sagasList))(store)(next)(action);
      };
    };
  };
}

var storeMiddleware = (0, _redux.applyMiddleware)(dynamicSagasMiddleware(['mountedComponents'], 'sagas'), _reduxThunk2.default, logger, gtmHandler, fluxConnectorMiddleware);

var commonConfiguration = exports.commonConfiguration = [fluxConnectorStoreEnhancer(), (0, _reduxDevtoolsExtension.composeWithDevTools)(storeMiddleware)];

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.getStoreConfig = getStoreConfig;

var _reduxAppCore = __webpack_require__(703);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  dev: [],
  prod: [],
  common: _reduxAppCore.commonConfiguration
}; /**
    * Meant to manage configurations between environment types (e.g. Prod, Dev).
    */


function buildConfiguration(env) {
  return env !== 'production' ? [].concat((0, _toConsumableArray3.default)(config.common), (0, _toConsumableArray3.default)(config.dev)) : [].concat((0, _toConsumableArray3.default)(config.common), (0, _toConsumableArray3.default)(config.prod));
}

function getStoreConfig() {
  return buildConfiguration("production");
}

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _embedCodeModalVm = __webpack_require__(773);

var _embedCodeModalVm2 = _interopRequireDefault(_embedCodeModalVm);

var _component = __webpack_require__(70);

var _EmbedCodeModalView = __webpack_require__(763);

var _EmbedCodeModalView2 = _interopRequireDefault(_EmbedCodeModalView);

var _embedCodeModalStore = __webpack_require__(758);

var _embedCodeModalStore2 = _interopRequireDefault(_embedCodeModalStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbedCodeModalController = function (_BaseClass) {
  (0, _inherits3.default)(EmbedCodeModalController, _BaseClass);

  function EmbedCodeModalController() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, EmbedCodeModalController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EmbedCodeModalController.__proto__ || (0, _getPrototypeOf2.default)(EmbedCodeModalController)).call(this, options));

    options.store = options.store || _embedCodeModalStore2.default.getInstance();
    _this.merge({
      vm: _embedCodeModalVm2.default.create(options),
      store: options.store
    });
    return _this;
  }

  return EmbedCodeModalController;
}(_BaseClass3.default); /* eslint semi:0 */


exports.default = (0, _component.make)(EmbedCodeModalController, _EmbedCodeModalView2.default);

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _ModalVm = __webpack_require__(770);

var _ModalVm2 = _interopRequireDefault(_ModalVm);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

var _EmptyView = __webpack_require__(764);

var _EmptyView2 = _interopRequireDefault(_EmptyView);

var _ModalStore = __webpack_require__(756);

var _ModalStore2 = _interopRequireDefault(_ModalStore);

var _component = __webpack_require__(70);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalController = function (_BaseClass) {
  (0, _inherits3.default)(ModalController, _BaseClass);

  function ModalController() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ModalController);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ModalController.__proto__ || (0, _getPrototypeOf2.default)(ModalController)).call(this, options));

    var store = options.store || _ModalStore2.default.create(options);
    _this.merge({
      vm: _ModalVm2.default.create((0, _assign2.default)({}, options, { store: store })),
      store: store
    });
    return _this;
  }

  return ModalController;
}(_BaseClass3.default); /* eslint semi:0 */


exports.default = (0, _component.make)(ModalController, _EmptyView2.default);

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AD_DIMENSIONS = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdDimension = function (_BaseClass) {
  (0, _inherits3.default)(AdDimension, _BaseClass);

  function AdDimension() {
    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var sizesTuple = arguments[1];
    (0, _classCallCheck3.default)(this, AdDimension);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AdDimension.__proto__ || (0, _getPrototypeOf2.default)(AdDimension)).apply(this, arguments));

    var _sizesTuple = (0, _slicedToArray3.default)(sizesTuple, 2),
        width = _sizesTuple[0],
        height = _sizesTuple[1];

    _this.merge({ width: width, height: height, prefix: prefix });
    return _this;
  }

  (0, _createClass3.default)(AdDimension, [{
    key: 'toString',
    value: function toString() {
      return '' + this.prefix + this.sizesTuple.join('x');
    }
  }, {
    key: 'valueOf',
    value: function valueOf() {
      return this.sizesTuple;
    }
  }, {
    key: 'sizesTuple',
    get: function get() {
      return [this.width, this.height];
    }
  }, {
    key: 'self',
    get: function get() {
      var instance = this;
      return (0, _defineProperty3.default)({}, this.toString(), instance);
    }
  }]);
  return AdDimension;
}(_BaseClass3.default);

// Function.part didn't work here :(


var DisplayAdDimension = AdDimension.bind(null, 'd');
var VideoAdDimension = AdDimension.bind(null, 'v');

function addSizeToSizes(sizesObj, sizeInstance) {
  return (0, _assign2.default)(sizesObj, sizeInstance.self);
}

function sizesArrayToObj(DimensionClass, sizes) {
  return sizes
  // Safari is steaming pile of code manure. Dig into it for answers
  // .create from BaseClass is not recognized by Safari
  .map(function (dimensionTuple) {
    return new DimensionClass(dimensionTuple);
  }).reduce(addSizeToSizes, {});
}

var AD_DIMENSIONS = {
  DISPLAY: sizesArrayToObj(DisplayAdDimension, [[970, 250], [970, 90], [970, 90], [900, 250], [728, 90], [320, 50], [160, 600], [300, 600], [300, 300], [300, 250], [250, 250], [300, 50], [1, 1]]),
  VIDEO: sizesArrayToObj(VideoAdDimension, [[640, 360]])
};

exports.AD_DIMENSIONS = AD_DIMENSIONS;
exports.default = (0, _assign2.default)({}, AD_DIMENSIONS.DISPLAY, AD_DIMENSIONS.VIDEO);

/***/ }),

/***/ 711:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAmplitudeScriptConfig = getAmplitudeScriptConfig;

var _fn = __webpack_require__(15);

var _ua = __webpack_require__(9);

function amplitudeScript() {
  ;(function (e, t) {
    var n = e.amplitude || { _q: [], _iq: {} };
    var r = t.createElement('script');
    r.type = 'text/javascript';
    r.async = true;
    r.src = 'https://cdn.amplitude.com/libs/amplitude-4.2.1-min.gz.js';
    r.onload = function () {
      if (e.amplitude.runQueuedFunctions) {
        e.amplitude.runQueuedFunctions();
      } else {
        console.log('[Amplitude] Error: could not load SDK');
      }
    };
    var i = t.getElementsByTagName('script')[0];
    i.parentNode.insertBefore(r, i);
    function s(e, t) {
      e.prototype[t] = function () {
        this._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));
        return this;
      };
    }
    var o = function o() {
      this._q = [];
      return this;
    };
    var a = ['add', 'append', 'clearAll', 'prepend', 'set', 'setOnce', 'unset'];
    for (var u = 0; u < a.length; u++) {
      s(o, a[u]);
    }
    n.Identify = o;
    var c = function c() {
      this._q = [];
      return this;
    };
    var l = ['setProductId', 'setQuantity', 'setPrice', 'setRevenueType', 'setEventProperties'];
    for (var p = 0; p < l.length; p++) {
      s(c, l[p]);
    }
    n.Revenue = c;
    var d = ['init', 'logEvent', 'logRevenue', 'setUserId', 'setUserProperties', 'setOptOut', 'setVersionName', 'setDomain', 'setDeviceId', 'setGlobalUserProperties', 'identify', 'clearUserProperties', 'setGroup', 'logRevenueV2', 'regenerateDeviceId', 'logEventWithTimestamp', 'logEventWithGroups', 'setSessionId', 'resetSessionId'];
    function v(e) {
      function t(t) {
        e[t] = function () {
          e._q.push([t].concat(Array.prototype.slice.call(arguments, 0)));
        };
      }
      for (var n = 0; n < d.length; n++) {
        t(d[n]);
      }
    }
    v(n);
    n.getInstance = function (e) {
      e = (!e || e.length === 0 ? '$default_instance' : e).toLowerCase();
      if (!n._iq.hasOwnProperty(e)) {
        n._iq[e] = { _q: [] };
        v(n._iq[e]);
      }
      return n._iq[e];
    };
    e.amplitude = n;
  })(window, document);

  window.amplitude.getInstance().init('6a61a3a6882f5980f8b85ce3e351b557');
}
var browserName = (0, _ua.getBrowserName)();
var browserVersion = (0, _ua.getBrowserVersion)();
var postRegex = /posts/;
var hostRegex = /theduel\.com/;

function getAmplitudeScriptConfig(ids, gtmData) {
  return {
    src: function src() {},
    beforeLoad: function beforeLoad() {
      var parsedUrl = new URL(window.location.href);

      if (hostRegex.test(parsedUrl.hostname)) {
        return false;
      }

      amplitudeScript();

      var amplitudeClient = window.amplitude.getInstance();

      var viewName = function viewName(path) {
        if (path === '/') {
          return 'theduel';
        }

        if (postRegex.test(path)) {
          return 'posts';
        }

        var terms = path.split('/');
        if (terms.length > 2) {
          return terms[terms.length - 1];
        }

        return path;
      };

      var pageViewEvent = {
        'Page Path': parsedUrl.pathname,
        'View Name': viewName(parsedUrl.pathname),
        '[Super] Browser Name': browserName,
        '[Super] Browser Version': browserVersion,
        '[Super] Browser Viewport Width': window.innerWidth,
        '[Super] Browser Viewport Height': window.innerHeight
      };

      amplitudeClient.logEvent('Pageview', pageViewEvent);

      return false;
    }
  };
}

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fn = __webpack_require__(15);

var facebookPixelScriptConfig = {
  name: 'facebookPixel',
  src: 'https://connect.facebook.net/en_US/fbevents.js',
  beforeLoad: (0, _fn.makeSafeFn)(function beforeFbPixelLoad() {
    // All this shit is taken from FB documentation on how to implement the pixel, but I changed it to minimum. Without it, it doesn't work
    window._fbq = window.fbq = function () {
      window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
    };
    window.fbq.push = window.fbq;
    window.fbq.loaded = !0;
    window.fbq.version = '2.0';
    window.fbq.queue = [];
  })
}; /* eslint semi:0 */
exports.default = facebookPixelScriptConfig;

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

exports.getGtmScriptConfig = getGtmScriptConfig;

var _fn = __webpack_require__(15);

var _pageContext = __webpack_require__(61);

var _geolocationProvider = __webpack_require__(44);

var _postBodyLinksCounter = __webpack_require__(658);

var _useridentifierTracker = __webpack_require__(136);

var _trafficAnalyzerService = __webpack_require__(214);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function gtmScriptTemplate(ids) {
  return ids.forEach(function (id) {
    ;(function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', id);
  });
}

function pushPageViewDataToGtm(gtmData) {
  function getQueryAttrFromURI(attrName) {
    var qryString = window.location.search;
    var rgx = new RegExp(attrName + '=[a-z0-9]*', 'i');
    var rgxResult = rgx.exec(qryString);

    return rgxResult !== null ? rgxResult[0].split('=')[1] : null;
  }

  function safeGetIsUserAuthenticated() {
    try {
      return JSON.parse(localStorage.CurrentUser).authenticated;
    } catch (e) {
      return false;
    }
  }

  var gtmEventsData = (0, _keys2.default)(gtmData).reduce(function (accumulator, keyVal) {
    accumulator[keyVal] = gtmData[keyVal];

    return accumulator;
  }, { event: 'GTM data ready to GA' });

  gtmEventsData.platform = (0, _pageContext.getUserPlatform)();
  gtmEventsData.userIsConnected = safeGetIsUserAuthenticated();
  gtmEventsData.geoDetected = (0, _geolocationProvider.getLastKnownCountryCode)();
  gtmEventsData.inArticleLinksNum = (0, _postBodyLinksCounter.linksCounter)();
  gtmEventsData.inArticleLinks = (0, _postBodyLinksCounter.linksDescription)();
  gtmEventsData.mmUserIdentifier = (0, _useridentifierTracker.trackUserIdentifier)();

  // todo: added for debug, remove block later
  var prevTrafficInfo = (0, _trafficAnalyzerService.getTrafficInfo)();
  gtmEventsData.prevTrafficSource = prevTrafficInfo.trafficSource;
  gtmEventsData.prevTrafficId = prevTrafficInfo.trafficId;
  gtmEventsData.trafficUrl = window.location.href;
  gtmEventsData.trafficReferrer = document.referrer;

  (0, _trafficAnalyzerService.initTrafficInfo)(); // should run before pushing to datalayer (gtm) and sending to dfp
  var trafficInfo = (0, _trafficAnalyzerService.getTrafficInfo)();
  gtmEventsData.trafficSource = trafficInfo.trafficSource;
  gtmEventsData.trafficId = trafficInfo.trafficId;

  var aID = (0, _pageContext.getInfluencerId)();

  if (aID !== null) {
    gtmEventsData.affiliateId = aID;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(gtmEventsData);
}

function getGtmScriptConfig(ids, gtmData) {
  return {
    src: function src() {},
    beforeLoad: (0, _fn.makeSafeFn)(function () {
      pushPageViewDataToGtm(gtmData);
      gtmScriptTemplate(ids);
      return false;
    })
  };
}

/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initGtm = initGtm;

var _script = __webpack_require__(19);

var _externalScripts = __webpack_require__(51);

function initGtm() {
  _script.external.load({
    name: _externalScripts.externalScriptsConfig.gtmAnalytics.name,
    loadNow: true
  });
}

/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(128);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(183);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _extends3 = __webpack_require__(10);

var _extends4 = _interopRequireDefault(_extends3);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = __webpack_require__(87);

var _entries2 = _interopRequireDefault(_entries);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = gtmService;

var _string = __webpack_require__(46);

var _analyticsActions = __webpack_require__(31);

var _adActions = __webpack_require__(50);

var _youtubeActions = __webpack_require__(414);

var _geolocationProvider = __webpack_require__(44);

var _gtmScriptInitializer = __webpack_require__(717);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _gtmScriptInitializer.initGtm)();

function gtmService() {
  var _GTM_ACTIONS;

  window.dataLayer = window.dataLayer || [];
  var GTM_ACTIONS = (_GTM_ACTIONS = {}, (0, _defineProperty3.default)(_GTM_ACTIONS, _adActions.CLASS_CONSTATNTS.ADS.ACTIONS.AD_BLOCK_DETECTION_FINISHED, {
    normalizeDataFunction: 'normalizeAdblockData'
  }), (0, _defineProperty3.default)(_GTM_ACTIONS, _analyticsActions.CLASS_CONSTATNTS.ANALYTICS.ACTIONS.CLICK_EVENT, {
    normalizeDataFunction: 'normalizeClickData'
  }), (0, _defineProperty3.default)(_GTM_ACTIONS, 'REACTIONS:SEND_VOTE', {}), (0, _defineProperty3.default)(_GTM_ACTIONS, _youtubeActions.YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PLAY, {}), (0, _defineProperty3.default)(_GTM_ACTIONS, _youtubeActions.YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PAUSE, {}), (0, _defineProperty3.default)(_GTM_ACTIONS, _youtubeActions.YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_PERCENTAGE_CHANGE, {}), (0, _defineProperty3.default)(_GTM_ACTIONS, _youtubeActions.YOUTUBE_ACTION_TYPES.ANALYTICS.VIDEO_COMPLETE, {}), _GTM_ACTIONS);

  function unlessStringToString(value) {
    return typeof value !== 'string' && value !== null ? value.toString() : value;
  }

  function ifNotCategoryKeyRunFn(fn, key, value) {
    return key === 'category' ? (0, _string.capitalizeFirstLetter)(value) : fn(value).toLowerCase();
  }

  function normalizeEventData(eventPayload) {
    return (0, _entries2.default)(eventPayload).reduce(function (acc, _ref) {
      var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      return value === undefined ? acc : (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, 'GA_event_' + key, ifNotCategoryKeyRunFn(unlessStringToString, key, value)));
    }, { event: 'GTM event To GA' });
  }

  var dataConverters = {
    normalizeAdblockData: function normalizeAdblockData(state) {
      var isAdBlocked = state.detected ? 'yes' : 'no';
      return { event: 'GTM late data to GA', isAdBlock: isAdBlocked };
    },
    normalizeClickData: function normalizeClickData(state) {
      var _state$payload = state.payload,
          category = _state$payload.eventCategory,
          action = _state$payload.eventAction,
          label = _state$payload.eventLabel,
          sub_label = _state$payload.eventValue;


      var normalizedEventData = normalizeEventData({ category: category, action: action, label: label, sub_label: sub_label });

      var gtmAnchorCallback = state.payload.gtmAnchorCallback;

      if (gtmAnchorCallback) {
        (0, _assign2.default)(normalizedEventData, gtmAnchorCallback);
      }
      return normalizedEventData;
    }
  };

  return function () {
    var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(gtmReduxAction) {
      var currentGtmAction, finalNormalizedGtmData, _ref4, category, action, label, sub_label, value, valueOrSubLabel, normalizeDataMethodPerAction;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              currentGtmAction = GTM_ACTIONS[gtmReduxAction.type];

              if (!(currentGtmAction === undefined)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt('return');

            case 3:
              finalNormalizedGtmData = void 0;
              _ref4 = gtmReduxAction.state.payload || gtmReduxAction.state || {}, category = _ref4.category, action = _ref4.action, label = _ref4.label, sub_label = _ref4.sub_label, value = _ref4.value;
              valueOrSubLabel = sub_label || value;
              normalizeDataMethodPerAction = dataConverters[currentGtmAction.normalizeDataFunction];

              if (!(category && action && label)) {
                _context.next = 11;
                break;
              }

              finalNormalizedGtmData = normalizeEventData((0, _extends4.default)({}, gtmReduxAction.state.payload));
              _context.next = 27;
              break;

            case 11:
              if (!(currentGtmAction.normalizeDataFunction === 'normalizeAdblockData')) {
                _context.next = 22;
                break;
              }

              _context.t0 = _extends4.default;
              _context.t1 = {};
              _context.t2 = normalizeDataMethodPerAction(gtmReduxAction.state);
              _context.next = 17;
              return (0, _geolocationProvider.getCountryCode)();

            case 17:
              _context.t3 = _context.sent;
              _context.t4 = {
                geoDetected: _context.t3
              };
              finalNormalizedGtmData = (0, _context.t0)(_context.t1, _context.t2, _context.t4);
              _context.next = 27;
              break;

            case 22:
              if (!normalizeDataMethodPerAction) {
                _context.next = 26;
                break;
              }

              finalNormalizedGtmData = normalizeDataMethodPerAction(gtmReduxAction.state);
              _context.next = 27;
              break;

            case 26:
              return _context.abrupt('return');

            case 27:
              window.dataLayer.push(finalNormalizedGtmData);

            case 28:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function gtmPushToDataLayer(_x) {
      return _ref3.apply(this, arguments);
    }

    return gtmPushToDataLayer;
  }();
}

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__(55);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _constants = __webpack_require__(53);

var _pipelines = __webpack_require__(731);

var _pipelines2 = _interopRequireDefault(_pipelines);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var check = function check(rule) {
  return function (traffic) {
    return rule(traffic);
  };
};

var checkAllRules = function checkAllRules(traffic) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(_pipelines2.default), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var pipeline = _step.value;

      var isMatch = check(pipeline.rule)(traffic);
      if (isMatch) {
        return pipeline.extractor(traffic);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return {
    trafficSource: _constants.UNKNOWN_TRAFFIC_SOURCE,
    trafficId: _constants.UNKNOWN_TRAFFIC_ID
  };
};

exports.default = checkAllRules;

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var app = {
  rule: _predicates2.default.searchParamEqualsOne('app', '1'),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.APP_TRAFFIC_SOURCE;
    var trafficId = _constants.APP_TRAFFIC_ID;

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = app;

/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var direct = {
  rule: _predicates2.default.not(_predicates2.default.referrerExists(), _predicates2.default.searchParamsIncludeOne('utm_medium', 'utm_source')),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.DIRECT_TRAFFIC_SOURCE;
    var trafficId = _constants.DIRECT_TRAFFIC_ID;

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = direct;

/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var email = {
  rule: _predicates2.default.and(_predicates2.default.searchParamIncludesOne('utm_medium', 'email'), _predicates2.default.searchParamsIncludeOne('utm_source')),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.EMAIL_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.searchParamValue(traffic, 'utm_source');

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = email;

/***/ }),

/***/ 730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var embedPartner = {
  rule: _predicates2.default.and(_predicates2.default.pathnameIncludesOne('embed'), _predicates2.default.searchParamsIncludeOne('partner')),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.EMBED_PARTNER_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.searchParamValue(traffic, 'partner');

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = embedPartner;

/***/ }),

/***/ 731:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _influencer = __webpack_require__(732);

var _influencer2 = _interopRequireDefault(_influencer);

var _app = __webpack_require__(727);

var _app2 = _interopRequireDefault(_app);

var _embedPartner = __webpack_require__(730);

var _embedPartner2 = _interopRequireDefault(_embedPartner);

var _syndication = __webpack_require__(740);

var _syndication2 = _interopRequireDefault(_syndication);

var _paid = __webpack_require__(735);

var _paid2 = _interopRequireDefault(_paid);

var _social = __webpack_require__(739);

var _social2 = _interopRequireDefault(_social);

var _trPartner = __webpack_require__(741);

var _trPartner2 = _interopRequireDefault(_trPartner);

var _organic = __webpack_require__(734);

var _organic2 = _interopRequireDefault(_organic);

var _navigation = __webpack_require__(733);

var _navigation2 = _interopRequireDefault(_navigation);

var _rss = __webpack_require__(737);

var _rss2 = _interopRequireDefault(_rss);

var _share = __webpack_require__(738);

var _share2 = _interopRequireDefault(_share);

var _email = __webpack_require__(729);

var _email2 = _interopRequireDefault(_email);

var _referral = __webpack_require__(736);

var _referral2 = _interopRequireDefault(_referral);

var _direct = __webpack_require__(728);

var _direct2 = _interopRequireDefault(_direct);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// order of pipelines is important
exports.default = [_influencer2.default, _app2.default, _embedPartner2.default, _syndication2.default, _paid2.default, _social2.default, _trPartner2.default, _organic2.default, _navigation2.default, _rss2.default, _share2.default, _email2.default, _referral2.default, _direct2.default];

/***/ }),

/***/ 732:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var influencer = {
  rule: _predicates2.default.or(_predicates2.default.searchParamsIncludeOne('a_aid'), _predicates2.default.and(_predicates2.default.pathnameIncludesOne('partners'), _predicates2.default.pathnameIncludesAfterKey('partners'))),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.INFLUENCER_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.searchParamValue(traffic, 'a_aid') || _selectors2.default.afterPathnameKey(traffic, 'partners');

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = influencer;

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var navigation = {
  rule: _predicates2.default.referrerIsSameAsSite(),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.NAVIGATION_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.referrerHostname(traffic);

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = navigation;

/***/ }),

/***/ 734:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var organic = {
  rule: _predicates2.default.referrerIncludesPlatform(_constants.SEARCH_PLATFORMS.GOOGLE, _constants.SEARCH_PLATFORMS.BING, _constants.SEARCH_PLATFORMS.YAHOO),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.ORGANIC_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.referrerHostname(traffic);

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = organic;

/***/ }),

/***/ 735:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paid = {
  rule: _predicates2.default.and(_predicates2.default.searchParamsIncludeOne('utm_source'), _predicates2.default.or(_predicates2.default.searchParamEqualsOne('utm_medium', 'fbads', 'cpc', 'fbads_dyn'), _predicates2.default.searchParamEqualsOne('utm_source', 'googlecpc', 'cpc'))),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.PAID_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.searchParamValue(traffic, 'utm_source');

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = paid;

/***/ }),

/***/ 736:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var referral = {
  rule: _predicates2.default.referrerExists(),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.REFERRAL_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.referrerHostname(traffic);

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = referral;

/***/ }),

/***/ 737:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rss = {
  rule: _predicates2.default.searchParamEqualsOne('utm_source', 'rss'),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.RSS_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.referrerHostname(traffic);

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = rss;

/***/ }),

/***/ 738:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var share = {
  rule: _predicates2.default.and(_predicates2.default.searchParamIncludesOne('utm_medium', 'share'), _predicates2.default.searchParamsIncludeOne('utm_source')),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.SHARE_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.searchParamValue(traffic, 'utm_source');

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = share;

/***/ }),

/***/ 739:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var social = {
  rule: _predicates2.default.or(_predicates2.default.referrerIncludesPlatform(_constants.SOCIAL_PLATFORMS.FACEBOOK, _constants.SOCIAL_PLATFORMS.TWITTER, _constants.SOCIAL_PLATFORMS.INSTAGRAM, _constants.SOCIAL_PLATFORMS.REDDIT), _predicates2.default.searchParamEqualsOne('utm_medium', 'fan_page')),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.SOCIAL_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.referrerHostname(traffic);

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = social;

/***/ }),

/***/ 740:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var syndication = {
  rule: _predicates2.default.and(_predicates2.default.pathnameIncludesOne('synd'), _predicates2.default.searchParamsIncludeOne('partner')),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.SYNDICATION_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.searchParamValue(traffic, 'partner');

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = syndication;

/***/ }),

/***/ 741:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _predicates = __webpack_require__(68);

var _predicates2 = _interopRequireDefault(_predicates);

var _selectors = __webpack_require__(83);

var _selectors2 = _interopRequireDefault(_selectors);

var _constants = __webpack_require__(53);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var trPartner = {
  rule: _predicates2.default.and(_predicates2.default.searchParamEqualsOne('utm_medium', 'tr_partner'), _predicates2.default.searchParamsIncludeOne('utm_source')),
  extractor: function extractor(traffic) {
    var trafficSource = _constants.PARTNER_TRAFFIC_SOURCE;
    var trafficId = _selectors2.default.searchParamValue(traffic, 'utm_source');

    return {
      trafficSource: trafficSource,
      trafficId: trafficId
    };
  }
};

exports.default = trPartner;

/***/ }),

/***/ 742:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var and = function and() {
  for (var _len = arguments.length, predicates = Array(_len), _key = 0; _key < _len; _key++) {
    predicates[_key] = arguments[_key];
  }

  return function (traffic) {
    return predicates.every(function (predicate) {
      return predicate(traffic);
    });
  };
};

exports.default = and;

/***/ }),

/***/ 743:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var not = function not() {
  for (var _len = arguments.length, predicates = Array(_len), _key = 0; _key < _len; _key++) {
    predicates[_key] = arguments[_key];
  }

  return function (traffic) {
    return predicates.every(function (predicate) {
      return !predicate(traffic);
    });
  };
};

exports.default = not;

/***/ }),

/***/ 744:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var or = function or() {
  for (var _len = arguments.length, predicates = Array(_len), _key = 0; _key < _len; _key++) {
    predicates[_key] = arguments[_key];
  }

  return function (traffic) {
    return predicates.some(function (predicate) {
      return predicate(traffic);
    });
  };
};

exports.default = or;

/***/ }),

/***/ 745:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathnameIncludesAfterKey = function pathnameIncludesAfterKey(key) {
  return function (traffic) {
    var urlObject = new _URLParser2.default(traffic.url);
    var pathnameParts = urlObject.pathname.split('/');
    var value = pathnameParts[pathnameParts.indexOf(key) + 1];
    return value !== null;
  };
};

exports.default = pathnameIncludesAfterKey;

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pathnameIncludesOne = function pathnameIncludesOne() {
  for (var _len = arguments.length, pathParams = Array(_len), _key = 0; _key < _len; _key++) {
    pathParams[_key] = arguments[_key];
  }

  return function (traffic) {
    var urlObject = new _URLParser2.default(traffic.url);
    var pathParts = urlObject.pathname.split('/');
    return pathParams.some(function (pathParam) {
      return pathParts.includes(pathParam);
    });
  };
};

exports.default = pathnameIncludesOne;

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var referrerExists = function referrerExists() {
  return function (traffic) {
    return traffic.referrer !== '';
  };
};

exports.default = referrerExists;

/***/ }),

/***/ 748:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(53);

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var referrerIncludesPlatform = function referrerIncludesPlatform() {
  for (var _len = arguments.length, platforms = Array(_len), _key = 0; _key < _len; _key++) {
    platforms[_key] = arguments[_key];
  }

  return function (traffic) {
    if (traffic.referrer === '') {
      return false;
    }
    var referrerObject = new _URLParser2.default(traffic.referrer);
    var hostname = referrerObject.hostname;
    return platforms.some(function (platform) {
      return _constants.PLATFORM_REGEXES[platform].some(function (regex) {
        return regex.test(hostname);
      });
    });
  };
};

exports.default = referrerIncludesPlatform;

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var referrerIsSameAsSite = function referrerIsSameAsSite() {
  return function (traffic) {
    if (traffic.referrer === '') {
      return false;
    }
    var urlObject = new _URLParser2.default(traffic.url);
    var referrerObject = new _URLParser2.default(traffic.referrer);
    return urlObject.hostname === referrerObject.hostname;
  };
};

exports.default = referrerIsSameAsSite;

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchParamEqualsOne = function searchParamEqualsOne(searchParam) {
  for (var _len = arguments.length, expectedValues = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    expectedValues[_key - 1] = arguments[_key];
  }

  return function (traffic) {
    var urlObject = new _URLParser2.default(traffic.url);
    return expectedValues.some(function (expValue) {
      var value = urlObject.searchParams.get(searchParam);
      return value !== null && value === expValue;
    });
  };
};

exports.default = searchParamEqualsOne;

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchParamIncludesOne = function searchParamIncludesOne(searchParam) {
  for (var _len = arguments.length, expectedValues = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    expectedValues[_key - 1] = arguments[_key];
  }

  return function (traffic) {
    var urlObject = new _URLParser2.default(traffic.url);
    return expectedValues.some(function (expValue) {
      var value = urlObject.searchParams.get(searchParam);
      return value !== null && value.includes(expValue);
    });
  };
};

exports.default = searchParamIncludesOne;

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchParamsIncludeOne = function searchParamsIncludeOne() {
  for (var _len = arguments.length, searchParams = Array(_len), _key = 0; _key < _len; _key++) {
    searchParams[_key] = arguments[_key];
  }

  return function (traffic) {
    var urlObject = new _URLParser2.default(traffic.url);
    return searchParams.some(function (searchParam) {
      var value = urlObject.searchParams.get(searchParam);
      return value !== null;
    });
  };
};

exports.default = searchParamsIncludeOne;

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var afterPathnameKey = function afterPathnameKey(traffic, key) {
  var urlObject = new _URLParser2.default(traffic.url);
  var pathnameParts = urlObject.pathname.split('/');
  return pathnameParts[pathnameParts.indexOf(key) + 1];
};

exports.default = afterPathnameKey;

/***/ }),

/***/ 754:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants = __webpack_require__(53);

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var referrerHostname = function referrerHostname(traffic) {
  if (traffic.referrer === '') {
    return '';
  }
  var referrerObject = new _URLParser2.default(traffic.referrer);
  var hostname = referrerObject.hostname;
  for (var platform in _constants.PLATFORM_REGEXES) {
    if (_constants.PLATFORM_REGEXES[platform].some(function (regex) {
      return regex.test(hostname);
    })) {
      return platform;
    }
  }
  return hostname;
};

exports.default = referrerHostname;

/***/ }),

/***/ 755:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLParser = __webpack_require__(100);

var _URLParser2 = _interopRequireDefault(_URLParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var searchParamValue = function searchParamValue(traffic, key) {
  var urlObject = new _URLParser2.default(traffic.url);
  return urlObject.searchParams.get(key);
};

exports.default = searchParamValue;

/***/ }),

/***/ 756:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseStore = __webpack_require__(77);

var _modalActions = __webpack_require__(312);

var _component = __webpack_require__(70);

var _userToolbarActions = __webpack_require__(76);

var _socialButtonsActions = __webpack_require__(140);

var _signupModalComponent = __webpack_require__(422);

var _signupModalComponent2 = _interopRequireDefault(_signupModalComponent);

var _embedCodeModalComponent = __webpack_require__(705);

var _embedCodeModalComponent2 = _interopRequireDefault(_embedCodeModalComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalStore = function (_BaseStore) {
  (0, _inherits3.default)(ModalStore, _BaseStore);

  function ModalStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, ModalStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ModalStore.__proto__ || (0, _getPrototypeOf2.default)(ModalStore)).call(this, options));

    _this.merge(options);
    return _this;
  }

  (0, _createClass3.default)(ModalStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      var EMBED_OPEN = _socialButtonsActions.TYPES.EMBED_OPEN;
      var NEW_USER_AUTHENTICATED = _userToolbarActions.TYPES.NEW_USER_AUTHENTICATED;

      switch (action.type) {
        case EMBED_OPEN:
          return this.openEmbedModal();
        case _modalActions.TYPES.CLOSE:
          return this.closeModal();
        case NEW_USER_AUTHENTICATED:
          return this.openSignupModal({
            authId: action.authId,
            modalData: action.signupModalData
          });
        default:
          return {};
      }
    }
  }, {
    key: 'openEmbedModal',
    value: function openEmbedModal() {
      return this.merge({
        isModalOpen: true,
        currentComponent: _embedCodeModalComponent2.default
      }).emitChange();
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      return this.merge({
        isModalOpen: false,
        currentComponent: null
      }).emitChange();
    }
  }, {
    key: 'openSignupModal',
    value: function openSignupModal(options) {
      return this.merge({
        isModalOpen: true,
        currentComponent: _signupModalComponent2.default.part(options)
      }).emitChange();
    }
  }, {
    key: 'currentComponent',
    get: function get() {
      return this.state.currentComponent || _component.empty;
    },
    set: function set(componentFn) {
      this.state.currentComponent = componentFn || _component.empty;
    }
  }, {
    key: 'isModalOpen',
    get: function get() {
      return this.state.isModalOpen;
    },
    set: function set(isOpen) {
      this.state.isModalOpen = isOpen;
    }
  }]);
  return ModalStore;
}(_baseStore.BaseStore); /* eslint semi:0 */


exports.default = ModalStore;

/***/ }),

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _setImmediate2 = __webpack_require__(253);

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _baseStore = __webpack_require__(77);

var _dialogProvider = __webpack_require__(316);

var _dialogProvider2 = _interopRequireDefault(_dialogProvider);

var _mithril = __webpack_require__(54);

var _modalActions = __webpack_require__(312);

var _pageDataObject = __webpack_require__(5);

var _userToolbarActions = __webpack_require__(76);

var _i18nProvider = __webpack_require__(18);

var _component = __webpack_require__(70);

var _signupModalComponent = __webpack_require__(422);

var _signupModalComponent2 = _interopRequireDefault(_signupModalComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SIGNUP_PATH = (0, _pageDataObject.get)('config.signup_path'); /* eslint semi:0 */

var SignupModalStore = function (_BaseStore) {
  (0, _inherits3.default)(SignupModalStore, _BaseStore);

  function SignupModalStore() {
    (0, _classCallCheck3.default)(this, SignupModalStore);
    return (0, _possibleConstructorReturn3.default)(this, (SignupModalStore.__proto__ || (0, _getPrototypeOf2.default)(SignupModalStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(SignupModalStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      switch (action.type) {
        case _modalActions.TYPES.CLOSE:
          return this.onModalDirtyClose();
      }
    }
  }, {
    key: 'onModalDirtyClose',
    value: function onModalDirtyClose() {
      if ((0, _component.areComponentsIdentical)(_dialogProvider2.default.modal.currentComponent, _signupModalComponent2.default)) {
        return (0, _setImmediate3.default)(_userToolbarActions.autnenticationFailed);
      }
    }
  }, {
    key: 'submit',
    value: function submit(data) {
      var url = (0, _i18nProvider.localizedPath)(SIGNUP_PATH);

      (0, _mithril.safeRequest)({
        method: 'POST',
        data: data,
        url: url,
        serialize: function serialize(serializeData) {
          return serializeData;
        }
      }).then(this.onSubmitResponse.bind(this), this.onSubmitFailed.bind(this));
      this.isLoading = true;
    }
  }, {
    key: 'onSubmitResponse',
    value: function onSubmitResponse(response) {
      this.isLoading = false;
      response.errors ? this.onSubmitFailed(response) : this.onSubmitSucceed(response);
    }
  }, {
    key: 'onSubmitSucceed',
    value: function onSubmitSucceed(response) {
      response.existing = true;
      (0, _userToolbarActions.authenticated)(response);
      _dialogProvider2.default.modal.close();
    }
  }, {
    key: 'onSubmitFailed',
    value: function onSubmitFailed(response) {
      this.isLoading = false;
      this.serverValidationErrors = response.errors;
    }
  }, {
    key: 'languages',
    get: function get() {
      return this.options.modalData.languages;
    }
  }, {
    key: 'leagues',
    get: function get() {
      return this.options.modalData.leagues;
    }
  }, {
    key: 'localeLeague',
    get: function get() {
      return this.options.modalData.locale_league;
    }
  }, {
    key: 'localeLeagueName',
    get: function get() {
      return this.options.modalData.locale_league_name;
    }
  }, {
    key: 'teams',
    get: function get() {
      return this.options.modalData.teams;
    }
  }, {
    key: 'termsUrl',
    get: function get() {
      return this.options.modalData.terms_url;
    }
  }, {
    key: 'privacyUrl',
    get: function get() {
      return this.options.modalData.privacy_url;
    }
  }, {
    key: 'authId',
    get: function get() {
      return this.options.authId;
    }
  }, {
    key: 'isLoading',
    set: function set(flag) {
      this.vm.isLoading(flag);
      this.vm.onChange();
    }
  }, {
    key: 'serverValidationErrors',
    set: function set(errors) {
      this.vm.serverValidationErrors(errors);
    }
  }]);
  return SignupModalStore;
}(_baseStore.BaseStore);

exports.default = SignupModalStore;

/***/ }),

/***/ 758:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _dom = __webpack_require__(12);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _baseStore = __webpack_require__(77);

var _mithril = __webpack_require__(54);

var _pageDataObject = __webpack_require__(5);

var _userToolbarActions = __webpack_require__(76);

var _embedCodeModalActions = __webpack_require__(419);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EMBED_CODE_API = (0, _pageDataObject.getPostEmbedCodePath)(); /* eslint semi:0 */


var lazySingletonInstance = null;

var EmbedCodeModalStore = function (_BaseStore) {
  (0, _inherits3.default)(EmbedCodeModalStore, _BaseStore);
  (0, _createClass3.default)(EmbedCodeModalStore, null, [{
    key: 'getInstance',
    value: function getInstance() {
      if (!lazySingletonInstance) {
        lazySingletonInstance = EmbedCodeModalStore.create();
      }
      return lazySingletonInstance;
    }
  }]);

  function EmbedCodeModalStore() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, EmbedCodeModalStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EmbedCodeModalStore.__proto__ || (0, _getPrototypeOf2.default)(EmbedCodeModalStore)).call(this, options));

    _this.fetchModalData();
    return _this;
  }

  (0, _createClass3.default)(EmbedCodeModalStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      var type = action.type;

      var ACTIONS = _embedCodeModalActions.TYPES;
      switch (type) {
        case ACTIONS.EMBED_DATA_RECEIVED:
          return this.onDataReceived(action.data);
        case ACTIONS.EMBED_DATA_FAILED:
          return this.onDataError();
        case ACTIONS.EMBED_CONFIGURATION_CHANGED:
          return this.onConfigurationChanged(action.configOption);
        case _userToolbarActions.TYPES.FB_LOGIN:
          return this.state.dataReady = false;
        case _userToolbarActions.TYPES.EXISTING_USER_AUTHENTICATED:
          return this.fetchModalData();
        default:
          return this;
      }
    }
  }, {
    key: 'fetchModalData',
    value: function fetchModalData() {
      var timeStamp = _userStore2.default.partnerId ? Date.now() : 'notPartner';
      (0, _mithril.safeRequest)({
        method: 'GET',
        url: EMBED_CODE_API,
        data: {
          ts: timeStamp
        }
      }).then(_embedCodeModalActions.embedDataReceived, _embedCodeModalActions.embedDataFailed);
    }
  }, {
    key: 'onDataReceived',
    value: function onDataReceived(data) {
      (0, _assign2.default)(this.state, data);
      this.embedCodeElement = (0, _dom.createElement)('div');
      this.embedCodeElement.innerHTML = data.embed_code;
      this.state.dataReady = true;
      this.emitChange();
    }
  }, {
    key: 'onDataError',
    value: function onDataError() {
      this.state.dataError = true;
      this.emitChange();
    }
  }, {
    key: 'onConfigurationChanged',
    value: function onConfigurationChanged(configOption) {
      var newValue = !this.state.configuration[configOption];
      this.state.configuration[configOption] = newValue;
      var elementAction = newValue ? 'setAttribute' : 'removeAttribute';
      this.embedCodeElement.children[0][elementAction]('data-' + configOption, '');
      this.emitChange();
    }
  }, {
    key: 'embedCodePretty',
    get: function get() {
      var str = this.embedCodeElement.innerHTML;
      return str.replace(/=\"\"/g, '');
    }
  }]);
  return EmbedCodeModalStore;
}(_baseStore.BaseStore);

exports.default = EmbedCodeModalStore;

/***/ }),

/***/ 759:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _googleSearchActions = __webpack_require__(311);

var _baseStore = __webpack_require__(77);

var _script = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var googleSearch = _script.external.load({ name: 'googleSearch' }); /* eslint semi:0 */

var GoogleSearchStore = function (_BaseStore) {
  (0, _inherits3.default)(GoogleSearchStore, _BaseStore);

  function GoogleSearchStore() {
    (0, _classCallCheck3.default)(this, GoogleSearchStore);
    return (0, _possibleConstructorReturn3.default)(this, (GoogleSearchStore.__proto__ || (0, _getPrototypeOf2.default)(GoogleSearchStore)).apply(this, arguments));
  }

  (0, _createClass3.default)(GoogleSearchStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      var ACTIONS = _googleSearchActions.TYPES;
      switch (action.type) {
        case ACTIONS.READY:
          return this.onGoogleSearchReady();
        case ACTIONS.SEARCH_CLICKED:
          return this.searchClicked(action.searchTerm);
      }
    }
  }, {
    key: 'onGoogleSearchReady',
    value: function onGoogleSearchReady() {
      this.isGoogleSearchReady = true;
      if (this.searchTerm) {
        this.performSearch(this.searchTerm);
      }
    }
  }, {
    key: 'searchClicked',
    value: function searchClicked(searchTerm) {
      this.searchTerm = searchTerm;
      if (this.isExpandedView) {
        if (this.searchTerm) {
          if (this.isGoogleSearchReady) {
            this.performSearch();
          }
        } else {
          this.isExpandedView = false;
          this.emitChange();
        }
      } else {
        googleSearch(); //causes SDK to load if it haven't already
        this.isExpandedView = true;
        this.emitChange();
      }
    }
  }, {
    key: 'performSearch',
    value: function performSearch() {
      var _this2 = this;

      googleSearch(function () {
        var element = window.google.search.cse.element.getElement('searchresults-only0'); //documentation: https://developers.google.com/custom-search/docs/element#cse-element
        element.execute(_this2.searchTerm);
      });
    }
  }, {
    key: 'searchTerm',
    get: function get() {
      return this.state.searchTerm;
    },
    set: function set(newTerm) {
      this.state.searchTerm = newTerm;
    }
  }, {
    key: 'isGoogleSearchReady',
    get: function get() {
      return this.state.googleSearchReady;
    },
    set: function set(bool) {
      this.state.googleSearchReady = bool;
    }
  }, {
    key: 'isExpandedView',
    get: function get() {
      return this.state.expandedView;
    },
    set: function set(bool) {
      this.state.expandedView = bool;
    }
  }]);
  return GoogleSearchStore;
}(_baseStore.BaseStore);

exports.default = GoogleSearchStore;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unimpersonate = exports.autnenticationFailed = exports.logout = exports.reauthenticated = exports.authenticated = exports.fbLogin = exports.fbSdkReady = exports.TYPES = undefined;

var _window = __webpack_require__(8);

var _object = __webpack_require__(13);

var _AppDispatcher = __webpack_require__(56);

var _appStore = __webpack_require__(23);

var _postActions = __webpack_require__(250);

var _pageDataObject = __webpack_require__(5);

/* eslint semi:0 */
var CLASS_CONSTATNTS = (0, _object.namespacedConsts)({
  USER_TOOLBAR: {
    ACTIONS: {
      FB_SDK_READY: true,
      FB_LOGIN: true,
      EXISTING_USER_AUTHENTICATED: true,
      NEW_USER_AUTHENTICATED: true,
      LOGOUT: true,
      AUTHENTICATION_FAILED: true,
      UNIMPERSONATE: true
    }
  }
});

var TYPES = exports.TYPES = CLASS_CONSTATNTS.USER_TOOLBAR.ACTIONS;

var fbSdkReady = exports.fbSdkReady = function fbSdkReady() {
  _AppDispatcher.appDispatcher.dispatchAction.external({
    type: TYPES.FB_SDK_READY
  });
};

var fbLogin = exports.fbLogin = function fbLogin() {
  var origin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UserToolbar';

  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.FB_LOGIN,
    origin: origin
  });
};

var authenticated = exports.authenticated = function authenticated(response) {
  var EXISTING_USER_AUTHENTICATED = TYPES.EXISTING_USER_AUTHENTICATED,
      NEW_USER_AUTHENTICATED = TYPES.NEW_USER_AUTHENTICATED;

  var actionType = response.existing ? EXISTING_USER_AUTHENTICATED : NEW_USER_AUTHENTICATED;
  var userData = response.data;
  var signupModalData = response.signup_modal_data;
  if (_window.queryString.forceNewUser) {
    actionType = NEW_USER_AUTHENTICATED;
    signupModalData = {};
  }

  _AppDispatcher.appDispatcher.dispatchAction.server({
    type: actionType,
    userData: userData,
    authId: response.auth_id,
    signupModalData: signupModalData,
    dispatchToRedux: true,
    payload: userData
  });

  (0, _appStore.dispatch)((0, _postActions.fetchPostActions)((0, _pageDataObject.getPostId)(), false));
};

var reauthenticated = exports.reauthenticated = function reauthenticated(response) {
  response.isReauthenticated = true;
  authenticated(response);
};

var logout = exports.logout = function logout() {
  _AppDispatcher.appDispatcher.dispatchAction.view({
    type: TYPES.LOGOUT,
    dispatchToRedux: true
  });
};

var autnenticationFailed = exports.autnenticationFailed = function autnenticationFailed(response) {
  _AppDispatcher.appDispatcher.dispatchAction.server({
    type: TYPES.AUTHENTICATION_FAILED,
    response: response
  });
};

var unimpersonate = exports.unimpersonate = function unimpersonate(response) {
  _AppDispatcher.appDispatcher.dispatchAction.server({
    type: TYPES.UNIMPERSONATE,
    response: response
  });
};

/***/ }),

/***/ 763:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _userStore = __webpack_require__(38);

var _userStore2 = _interopRequireDefault(_userStore);

var _userToolbarActions = __webpack_require__(76);

var _embedCodeModalActions = __webpack_require__(419);

var _i18nProvider = __webpack_require__(18);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbedCodeModalView = function (_BaseView) {
  (0, _inherits3.default)(EmbedCodeModalView, _BaseView);

  function EmbedCodeModalView() {
    (0, _classCallCheck3.default)(this, EmbedCodeModalView);
    return (0, _possibleConstructorReturn3.default)(this, (EmbedCodeModalView.__proto__ || (0, _getPrototypeOf2.default)(EmbedCodeModalView)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmbedCodeModalView, [{
    key: 'view',
    value: function view(ctrl) {
      var _ctrl$vm$state = ctrl.vm.state,
          dataReady = _ctrl$vm$state.dataReady,
          dataError = _ctrl$vm$state.dataError,
          configuration = _ctrl$vm$state.configuration;

      var currentView = (0, _mithril2.default)('span.embed-modal--loading');
      if (dataReady) {
        currentView = [(0, _mithril2.default)('header.modal__header', (0, _mithril2.default)('h1.modal__title', (0, _i18nProvider.t)('embed.dialogue.header'))), (0, _mithril2.default)('section.modal__body', [(0, _mithril2.default)('h4', (0, _i18nProvider.t)('embed.dialogue.customise_collapse/expand')), this.customizationOptionsView(configuration), this.copyPasteView(ctrl.vm)]
        // this.becomePartnerView(),
        )];
      } else if (dataError) {
        currentView = 'Something went wrong :-(';
      }
      return (0, _mithril2.default)('.embed-modal', currentView);
    }
  }, {
    key: 'customizationOptionsView',
    value: function customizationOptionsView(configuration) {
      var optionsView = [];
      for (var option in configuration) {
        if (option.match(/^(show|hide)-/)) {
          var isChecked = configuration[option];
          optionsView.push((0, _mithril2.default)('label.checkbox.checkbox-${ option }', [(0, _mithril2.default)('input.embed-modal__config-options__input[type=checkbox]', {
            checked: isChecked,
            onchange: _embedCodeModalActions.embedConfigurationChanged.part(option)
          }), (0, _mithril2.default)('span', (0, _i18nProvider.t)('embed.dialogue.' + option))]));
        }
      }
      return (0, _mithril2.default)('div.embed-modal__config-options', optionsView);
    }
  }, {
    key: 'copyPasteView',
    value: function copyPasteView(vm) {
      var embedCode = vm.store.embedCodePretty;
      var termsLink = '<a class=\'embed-modal__copy-paste-link\' href="' + (0, _i18nProvider.localizedPath)('/terms') + '" target=\'_blank\'>' + (0, _i18nProvider.t)('footer.terms_conditions') + '</a>';
      var disclaimerMarkup = (0, _i18nProvider.translateTrusted)('embed.dialogue.disclaimer', {
        terms_conditions: termsLink
      }); // eslint-disable-line camelcase
      return (0, _mithril2.default)('div.embed-modal__copy-paste-area', [(0, _mithril2.default)('h4.embed-modal__copy-paste-title', (0, _i18nProvider.t)('embed.dialogue.embed_code')), (0, _mithril2.default)('span', (0, _i18nProvider.t)('embed.dialogue.embed_instructions')), (0, _mithril2.default)('code.textarea.embed-modal__embed-code', {
        onclick: function onclick(e) {
          vm.selectEmbedCode(e.currentTarget);
        },
        config: vm.selectEmbedCode
      }, embedCode), (0, _mithril2.default)('.embed-modal__embed-disclaimer', disclaimerMarkup)]);
    }
  }, {
    key: 'becomePartnerView',
    value: function becomePartnerView() {
      var view = [];
      var loginLink = '<a href=\'\'>' + (0, _i18nProvider.t)('affiliates.log_in') + '</a>';
      var siteDomainWithTld = (0, _pageDataObject.getSiteDomainWithTld)();
      var isLoggedIn = _userStore2.default.isLoggedIn,
          partnerId = _userStore2.default.partnerId;

      if (!(isLoggedIn && partnerId)) {
        var emailLink = '<a href=\'mailto:partners@' + siteDomainWithTld + '\' target=\'_blank\'>partners@' + siteDomainWithTld + '</a>';
        view = view.concat([(0, _mithril2.default)('h5.embed-modal__partner__title', (0, _i18nProvider.t)('embed.dialogue.become_a_partner')), (0, _mithril2.default)('p', (0, _i18nProvider.translateTrusted)('embed.dialogue.logged_in', { email: emailLink }))]);
      }
      if (!isLoggedIn) {
        view.push((0, _mithril2.default)('span', {
          onclick: function onclick(e) {
            e.preventDefault();
            (0, _userToolbarActions.fbLogin)();
          }
        }, (0, _i18nProvider.translateTrusted)('embed.dialogue.partner_message', { login: loginLink })));
      }

      return (0, _mithril2.default)('footer.modal__footer.embed-modal__partner', view);
    }
  }]);
  return EmbedCodeModalView;
}(_BaseView3.default); /* eslint semi:0 */


exports.default = EmbedCodeModalView;

/***/ }),

/***/ 764:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalView = function (_BaseView) {
  (0, _inherits3.default)(ModalView, _BaseView);

  function ModalView() {
    (0, _classCallCheck3.default)(this, ModalView);
    return (0, _possibleConstructorReturn3.default)(this, (ModalView.__proto__ || (0, _getPrototypeOf2.default)(ModalView)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModalView, [{
    key: 'view',
    value: function view(ctrl) {}
  }]);
  return ModalView;
}(_BaseView3.default); /* eslint semi:0 */


exports.default = ModalView;

/***/ }),

/***/ 765:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _dom = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var headerContainerNode = null; /* eslint semi:0 */


var searchInputSelector = '.search-comp__input';
var searchInputNode = null;

var GoogleSearchView = function (_BaseView) {
  (0, _inherits3.default)(GoogleSearchView, _BaseView);

  function GoogleSearchView() {
    (0, _classCallCheck3.default)(this, GoogleSearchView);
    return (0, _possibleConstructorReturn3.default)(this, (GoogleSearchView.__proto__ || (0, _getPrototypeOf2.default)(GoogleSearchView)).apply(this, arguments));
  }

  (0, _createClass3.default)(GoogleSearchView, [{
    key: 'view',
    value: function view(ctrl) {
      var vm = ctrl.vm;
      var isExpandedView = vm.options.store.isExpandedView;

      var componentClass = isExpandedView ? 'expanded' : '';
      headerContainerNode = headerContainerNode || (0, _dom.node)('.header-container');
      headerContainerNode.className = '' + (0, _dom.bem)('header-container')({ searching: isExpandedView });
      return [(0, _mithril2.default)("form.search-comp__form[method='get']", {
        onclick: function onSearchClick(e) {
          if (!isExpandedView) {
            searchInputNode = searchInputNode || this.querySelector(searchInputSelector);
            searchInputNode.focus();
          }
        },
        onsubmit: vm.search.bind(vm),
        class: componentClass
      }, [(0, _mithril2.default)('input' + searchInputSelector + '[type=\'text\']', {
        onchange: _mithril2.default.withAttr('value', vm.searchboxValue)
      }), (0, _mithril2.default)("button.search-comp__button[type='submit']")]), (0, _mithril2.default)("gcse:searchresults-only[linktarget='_self']")];
    }
  }]);
  return GoogleSearchView;
}(_BaseView3.default);

exports.default = GoogleSearchView;

/***/ }),

/***/ 767:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(22);

var _keys2 = _interopRequireDefault(_keys);

var _getIterator2 = __webpack_require__(55);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _ButtonView = __webpack_require__(425);

var _ButtonView2 = _interopRequireDefault(_ButtonView);

var _object = __webpack_require__(13);

var _i18nProvider = __webpack_require__(18);

var _InputView = __webpack_require__(426);

var _ua = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requiredCheckbox = _InputView.checkbox.part({ isRequired: true }); /* eslint semi:0 */

var SITES_WITH_GAMES = ['dbltap'];
var SITES_WITHOUT_TEAMS = SITES_WITH_GAMES;

function fieldset(children) {
  return (0, _mithril2.default)('fieldset', children);
}

function formItem(children) {
  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return (0, _mithril2.default)('.form-item', attrs, children);
}

var SignupModalView = function (_BaseView) {
  (0, _inherits3.default)(SignupModalView, _BaseView);

  function SignupModalView() {
    (0, _classCallCheck3.default)(this, SignupModalView);
    return (0, _possibleConstructorReturn3.default)(this, (SignupModalView.__proto__ || (0, _getPrototypeOf2.default)(SignupModalView)).apply(this, arguments));
  }

  (0, _createClass3.default)(SignupModalView, [{
    key: 'view',
    value: function view(ctrl) {
      var vm = ctrl.vm;

      return (0, _mithril2.default)('.signup-modal', {
        class: vm.isLoading() ? '.signup-modal--loading' : ''
      }, [(0, _mithril2.default)('header.modal__header', (0, _mithril2.default)('h1.modal__title', (0, _i18nProvider.t)('sign_up.lets_start'))), (0, _mithril2.default)('section.modal__body', [
      // m('p.centered', t('sign_up.change')),
      this.serverErrorsList(vm), this.formView(vm)])]);
    }
  }, {
    key: 'getFormViewAttrs',
    value: function getFormViewAttrs(vm) {
      var submit = vm.submit,
          onFieldChange = vm.onFieldChange;

      var _objectMap = (0, _object.objectMap)({ submit: submit, onFieldChange: onFieldChange }, function bindHandler(handlerName, handlerFn) {
        return (0, _defineProperty3.default)({}, handlerName, handlerFn.bind(vm));
      });

      submit = _objectMap.submit;
      onFieldChange = _objectMap.onFieldChange;

      return {
        config: function bindFormValidityToVm(el, isInitialized) {
          if (!isInitialized) {
            vm.formValidityGetter = el.checkValidity.bind(el);
          }
        },
        onchange: onFieldChange,
        oninput: onFieldChange,
        // FIXME: figure out how to make focus/onfocusin/out/blur work, then remove 'click'
        onfocusin: onFieldChange,
        onfocusout: onFieldChange,
        onclick: onFieldChange,
        onsubmit: submit
      };
    }
  }, {
    key: 'formView',
    value: function formView(vm) {
      var store = vm.store;

      var joinKey = 'sign_up.join_' + (0, _ua.domainFromFqdn)();
      return (0, _mithril2.default)('form[name=signup-new-user][novalidate]', this.getFormViewAttrs(vm), [fieldset([(0, _InputView.hiddenInput)({
        value: _i18nProvider.locale,
        name: 'user[locale]'
      }), (0, _InputView.hiddenInput)({
        name: 'auth_id',
        value: '' + store.authId
      }), formItem((0, _mithril2.default)('label', [(0, _mithril2.default)('span.form-item__title', (0, _i18nProvider.t)('sign_up.disp_name')), (0, _InputView.requiredInput)({
        // TODO: don't spellcheck - fix this in InputView
        spellcheck: false,
        // TODO: fix autofocus
        autofocus: true,
        name: 'user[nick]',
        classList: ['username'],
        minlength: 5,
        maxlength: 50,
        pattern: '[^~!@#$%^&*\\?\\(\\)\\+=\\{\\}\\[\\],<>~`"\\|:;\\\\]{5,50}',
        misvalidationMessage: (0, _mithril2.default)('.form-item__error', (0, _i18nProvider.t)('errors.nick.validation'))
      })])), formItem((0, _mithril2.default)('label', [(0, _mithril2.default)('span.form-item__title', (0, _i18nProvider.t)('sign_up.about_you')), (0, _InputView.textarea)({
        classList: ['signup-modal__motto'],
        name: 'user[motto]',
        maxlength: 250
      })])), this.leagueSelectView(vm), this.teamSelectView(vm), this.languageSelectView(vm)]), fieldset((0, _mithril2.default)('.form-item', (0, _mithril2.default)('label.checkbox.signup-modal__terms', requiredCheckbox({
        siblings: [(0, _mithril2.default)('span', this.agreeToTermsAndConditionsView(vm))],
        misvalidationMessage: (0, _mithril2.default)('.form-item__error', (0, _i18nProvider.t)('sign_up.required_field'))
      })))), _ButtonView2.default.make({
        type: 'submit',
        children: (0, _i18nProvider.t)(joinKey),
        isDisabled: !vm.isFormValid() || vm.isLoading()
      })]);
    }
  }, {
    key: 'agreeToTermsAndConditionsView',
    value: function agreeToTermsAndConditionsView(vm) {
      var signUpKey = 'sign_up.of_' + (0, _ua.domainFromFqdn)();
      return [(0, _i18nProvider.t)('sign_up.terms'), _ButtonView2.default.make({
        isNewTab: true,
        href: '' + vm.termsUrl,
        children: (0, _i18nProvider.t)('sign_up.terms_and_conditions')
      }), ' ', (0, _i18nProvider.t)('sign_up.and'), ' ', _ButtonView2.default.make({
        isNewTab: true,
        href: '' + vm.privacyUrl,
        children: (0, _i18nProvider.t)('sign_up.privacy_policy')
      }), ' ', (0, _i18nProvider.t)(signUpKey)];
    }
  }, {
    key: 'leagueSelectView',
    value: function leagueSelectView(vm) {
      var label = SITES_WITH_GAMES.includes((0, _ua.domainFromFqdn)()) ? (0, _i18nProvider.t)('sign_up.my_game') : (0, _i18nProvider.t)('sign_up.my_league');
      var leagues = vm.leagues,
          localeLeagueName = vm.localeLeagueName;

      var selectOptions = leagues.map(function getLeagueOptionTag(league) {
        var leagueName = league.name,
            leagueId = league.key;

        return (0, _InputView.optionTag)(leagueName, {
          value: leagueId,
          isSelected: leagueName === localeLeagueName
        });
      });
      return formItem((0, _mithril2.default)('label', (0, _mithril2.default)('span.form-item__title', label), (0, _mithril2.default)('.form-select', (0, _InputView.select)({
        onchange: _mithril2.default.withAttr('value', vm.selectedLeague),
        classList: ['dropdown', 'league'],
        name: 'user[league_slug]',
        children: selectOptions
      }))));
    }
  }, {
    key: 'teamSelectView',
    value: function teamSelectView(vm) {
      if (SITES_WITHOUT_TEAMS.includes((0, _ua.domainFromFqdn)())) {
        return null;
      }
      var teams = vm.teams[vm.selectedLeague()] || [];
      var selectOptions = teams.map(function getTeamOptionTag(team) {
        return (0, _InputView.optionTag)(team.name, { value: team.id });
      });
      return formItem((0, _mithril2.default)('label', (0, _mithril2.default)('span.form-item__title', (0, _i18nProvider.t)('sign_up.team')), (0, _mithril2.default)('.form-select', (0, _InputView.select)({
        classList: ['dropdown', 'team'],
        name: 'user[subject_id]',
        children: selectOptions
      }))));
    }
  }, {
    key: 'languageSelectView',
    value: function languageSelectView(vm) {
      var selectOptions = vm.languages.map(function addLanguageOptionTag(language) {
        return (0, _InputView.optionTag)((0, _i18nProvider.t)('common.languages.' + language), {
          value: language,
          isSelected: language === _i18nProvider.locale
        });
      });
      return formItem((0, _mithril2.default)('label', (0, _mithril2.default)('span.form-item__title', (0, _i18nProvider.t)('common.language')), (0, _mithril2.default)('.form-select', (0, _InputView.select)({
        name: 'user[writing_locale]',
        children: selectOptions
      }))));
    }
  }, {
    key: 'serverErrorsList',
    value: function serverErrorsList(vm) {
      var errors = vm.serverValidationErrors();
      var errorsListItems = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)((0, _keys2.default)(errors)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var itemErrors = errors[key];
          var listItem = this.serverErrorListItem(key, itemErrors);
          errorsListItems.push(listItem);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return (0, _mithril2.default)('ul.server-side-errors-wrap', errorsListItems);
    }
  }, {
    key: 'serverErrorListItem',
    value: function serverErrorListItem(key, errors) {
      var subItems = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(errors), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var error = _step2.value;

          var subItem = this.serverErrorSublistItem(error);
          subItems.push(subItem);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return (0, _mithril2.default)('li.server-side-errors-field', [(0, _mithril2.default)('ul.server-side-error-field-values', subItems)]);
    }
  }, {
    key: 'serverErrorSublistItem',
    value: function serverErrorSublistItem(error) {
      return (0, _mithril2.default)('li.server-side-error-field-value', error);
    }
  }]);
  return SignupModalView;
}(_BaseView3.default);

exports.default = SignupModalView;

/***/ }),

/***/ 769:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _BaseView2 = __webpack_require__(84);

var _BaseView3 = _interopRequireDefault(_BaseView2);

var _i18nProvider = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DROPDOWN_ITEM_CLASS = 'dropdown-comp__item'; /* eslint semi:0 */

var UserToolbarView = function (_BaseView) {
  (0, _inherits3.default)(UserToolbarView, _BaseView);

  function UserToolbarView() {
    (0, _classCallCheck3.default)(this, UserToolbarView);
    return (0, _possibleConstructorReturn3.default)(this, (UserToolbarView.__proto__ || (0, _getPrototypeOf2.default)(UserToolbarView)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserToolbarView, [{
    key: 'view',
    value: function view(ctrl) {
      return this.getCurrentView(ctrl.vm.store, ctrl.vm);
    }
  }, {
    key: 'getCurrentView',
    value: function getCurrentView(user, vm) {
      var loggedOutView = this.loggedOutView,
          loggingInView = this.loggingInView,
          loggedInView = this.loggedInView;

      var currentViewMethod = loggedOutView;
      if (user.isAuthenticated) {
        currentViewMethod = loggedInView;
      } else if (user.isAuthenticating) {
        currentViewMethod = loggingInView;
      }
      return currentViewMethod.apply(this, arguments);
    }
  }, {
    key: 'loggedInView',
    value: function loggedInView(user, vm) {
      var _user$state = user.state,
          userPath = _user$state.userPath,
          image = _user$state.image,
          fullName = _user$state.fullName,
          messages = _user$state.messages;

      var children = [(0, _mithril2.default)('a.user-menu__link', { href: (0, _i18nProvider.localizedPath)(userPath) }, (0, _mithril2.default)('img.user-menu__avatar', {
        src: image,
        alt: fullName
      }))];
      if (messages > 0) {
        children.push((0, _mithril2.default)('span.user-menu__notifications', messages));
      }
      return [(0, _mithril2.default)('.user-menu__avatar-wrap.label', children), this.userDropdownView(user, vm)];
    }
  }, {
    key: 'userDropdownView',
    value: function userDropdownView(_ref, vm) {
      var _ref$state = _ref.state,
          userPath = _ref$state.userPath,
          messagesPath = _ref$state.messagesPath,
          isAdmin = _ref.isAdmin,
          isImpersonating = _ref.isImpersonating;

      var dropdownItem = function dropdownItem(_ref2) {
        var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
            attrs = _ref3[0],
            children = _ref3[1];

        return (0, _mithril2.default)('a.' + DROPDOWN_ITEM_CLASS, attrs, children);
      };
      var children = [[{ href: (0, _i18nProvider.localizedPath)(userPath) }, (0, _i18nProvider.t)('header.profile')], [{ href: (0, _i18nProvider.localizedPath)(messagesPath) }, (0, _i18nProvider.t)('private_messages.messages')], [{ href: (0, _i18nProvider.localizedPath)('/edit_settings') }, (0, _i18nProvider.t)('header.settings')], [{ href: '/logout', onclick: vm.logoutClick.bind(vm) }, (0, _i18nProvider.t)('header.signout')]].map(dropdownItem);
      if (isAdmin) {
        children.unshift(dropdownItem([{ href: '/admin' }, 'Admin']));
      }
      if (isImpersonating) {
        children.unshift(dropdownItem([{
          href: '/admin/unimpersonate',
          onclick: vm.unimpersonateClick.bind(vm)
        }, 'Un-impersonate']));
      }
      return (0, _mithril2.default)('nav.dropdown-comp.dropdown-comp--right', children);
    }
  }, {
    key: 'loggingInView',
    value: function loggingInView(user, vm) {
      return (0, _mithril2.default)('span.sign-in-up__logging'); // TODO: maybe show a spinner/loader or something
    }
  }, {
    key: 'loggedOutView',
    value: function loggedOutView(user, vm) {
      return (0, _mithril2.default)('a.sign-in-up__facebook-btn', {
        onclick: vm.fbLoginClick.bind(vm)
      }, (0, _i18nProvider.t)('common.connect'));
    }
  }]);
  return UserToolbarView;
}(_BaseView3.default);

exports.default = UserToolbarView;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appDispatcher = exports.BaseStore = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _weakSet = __webpack_require__(323);

var _weakSet2 = _interopRequireDefault(_weakSet);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _nm = __webpack_require__(26);

var _nm2 = _interopRequireDefault(_nm);

var _events = __webpack_require__(1115);

var _events2 = _interopRequireDefault(_events);

var _AppDispatcher = __webpack_require__(56);

var _string = __webpack_require__(46);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(11),
    info = _require.info,
    log = _require.log,
    warn = _require.warn,
    error = _require.error;

function addCurriedConsoleMethod(curriedMethods, method) {
  curriedMethods[method.methodName] = method.curry('[' + this.constructor.name + ']');
  return curriedMethods;
}

function curryConsoleMethods() {
  for (var _len = arguments.length, consoleMethods = Array(_len), _key = 0; _key < _len; _key++) {
    consoleMethods[_key] = arguments[_key];
  }

  // I have no idea why, but calling Array.from(...consoleMethods)
  // didn't work and Array.from(arguments) does.
  return (0, _from2.default)(arguments).reduce(addCurriedConsoleMethod.bind(this), (0, _object.create)());
}

var CLASS_CONSTATNTS = (0, _object.deepFreeze)({
  EVENTS: {
    CHANGE: 'change'
  }
});

var BaseStore = function (_EventEmitter) {
  (0, _inherits3.default)(BaseStore, _EventEmitter);

  function BaseStore(options) {
    (0, _classCallCheck3.default)(this, BaseStore);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseStore.__proto__ || (0, _getPrototypeOf2.default)(BaseStore)).call(this));

    _this.state = (0, _object.create)();
    _AppDispatcher.appDispatcher.register(_this.routeAction.bind(_this));

    _this.merge(curryConsoleMethods.call(_this, info, log, warn, error), { options: options });

    var constructor = _this.constructor; // eslint-disable-line no-shadow

    var className = constructor.name;
    var baseClassNamePlural = (0, _string.getLastWordFromCamelCase)(className) + 's';
    var baseClassNamePluralLower = baseClassNamePlural.toLowerCase();
    // Register classes in namespace
    var classes = _nm2.default.classes = _nm2.default.classes || (0, _object.create)();
    classes[baseClassNamePlural] = classes[baseClassNamePlural] || (0, _object.create)();
    classes[baseClassNamePlural][className] = constructor;
    // Register instances in namespace
    var instances = _nm2.default.instances = _nm2.default.instances || (0, _object.create)();
    instances[baseClassNamePluralLower] = instances[baseClassNamePluralLower] || new _weakSet2.default();
    instances[baseClassNamePluralLower].add(_this);
    return _this;
  }

  (0, _createClass3.default)(BaseStore, [{
    key: 'routeAction',
    value: function routeAction(action) {
      throw new Error('This method must be overridden by subclasses!', { action: action, context: this });
    }
  }, {
    key: 'emitChange',
    value: function emitChange(payload) {
      // called in sub-classes by actions via this.routeAction.
      this.emit(this.constructor.EVENTS.CHANGE, payload);
      return this;
    }
  }, {
    key: 'addChangeListener',
    value: function addChangeListener(onChangeHandler) {
      // called by store consumers.
      this.on(this.constructor.EVENTS.CHANGE, onChangeHandler);
      return this;
    }
  }, {
    key: 'removeChangeListener',
    value: function removeChangeListener(callback) {
      this.removeListener(this.constructor.EVENTS.CHANGE, callback);
      return this;
    }
  }, {
    key: 'merge',
    value: function merge() {
      for (var _len2 = arguments.length, sources = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        sources[_key2] = arguments[_key2];
      }

      _assign2.default.apply(Object, [this].concat(sources));
      return this;
    }
  }], [{
    key: 'create',
    value: function create() {
      var _classFactory;

      return (_classFactory = (0, _object.classFactory)(this)).create.apply(_classFactory, arguments);
    }
  }, {
    key: 'EVENTS',
    get: function get() {
      return CLASS_CONSTATNTS.EVENTS;
    }
  }]);
  return BaseStore;
}(_events2.default);

exports.default = BaseStore;
exports.BaseStore = BaseStore;
exports.appDispatcher = _AppDispatcher.appDispatcher;

/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = __webpack_require__(71);

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalVm = function (_BaseVm) {
  (0, _inherits3.default)(ModalVm, _BaseVm);

  function ModalVm() {
    (0, _classCallCheck3.default)(this, ModalVm);
    return (0, _possibleConstructorReturn3.default)(this, (ModalVm.__proto__ || (0, _getPrototypeOf2.default)(ModalVm)).apply(this, arguments));
  }

  (0, _createClass3.default)(ModalVm, [{
    key: 'onChange',
    value: function onChange() {
      var modal = this.modal,
          isModalOpen = this.isModalOpen,
          currentComponent = this.currentComponent;

      if (isModalOpen) {
        modal.show(currentComponent);
      } else {
        modal.close();
      }
      (0, _get3.default)(ModalVm.prototype.__proto__ || (0, _getPrototypeOf2.default)(ModalVm.prototype), 'onChange', this).call(this);
      return this;
    }
  }, {
    key: 'modal',
    get: function get() {
      return this.store.modal;
    }
  }, {
    key: 'currentComponent',
    get: function get() {
      return this.store.currentComponent;
    }
  }, {
    key: 'isModalOpen',
    get: function get() {
      return this.store.isModalOpen;
    }
  }]);
  return ModalVm;
}(_BaseVm3.default); /* eslint semi:0 */


exports.default = ModalVm;

/***/ }),

/***/ 772:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _mithril = __webpack_require__(54);

var _InputView = __webpack_require__(426);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignupModalVm = function (_BaseVm) {
  (0, _inherits3.default)(SignupModalVm, _BaseVm);

  function SignupModalVm() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, SignupModalVm);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SignupModalVm.__proto__ || (0, _getPrototypeOf2.default)(SignupModalVm)).call(this, options));

    _this.merge({
      formData: {},
      isLoading: _mithril.m.prop(false),
      isFormValid: _mithril.m.prop(false),
      serverValidationErrors: _mithril.m.prop({}),
      selectedLeague: _mithril.m.prop(_this.localeLeague)
    });
    return _this;
  }

  (0, _createClass3.default)(SignupModalVm, [{
    key: 'onFieldChange',
    value: function onFieldChange(event) {
      // console.info('onFormChange', event, this.formData, this)
      var target = event.target;

      target.classList.add(_InputView.CLASS_NAMES.VISITED);
      var name = target.name,
          value = target.value;

      if (name) {
        this.formData[name] = value;
      }
      this.isFormValid(this.formValidityGetter());
    }
  }, {
    key: 'submit',
    value: function submit(event) {
      event.preventDefault();
      var data = new FormData(event.currentTarget);
      data.append('ieCompatible', 'true'); // This line is needed for FormData to work in ie
      this.store.submit(data);
    }
  }, {
    key: 'isFacebookDataLoaded',
    get: function get() {
      return this.store.isFacebookDataLoaded;
    }
  }, {
    key: 'languages',
    get: function get() {
      return this.store.languages || [];
    }
  }, {
    key: 'leagues',
    get: function get() {
      return this.store.leagues || [];
    }
  }, {
    key: 'localeLeague',
    get: function get() {
      return this.store.localeLeague;
    }
  }, {
    key: 'localeLeagueName',
    get: function get() {
      return this.store.localeLeagueName;
    }
  }, {
    key: 'teams',
    get: function get() {
      return this.store.teams || [];
    }
  }, {
    key: 'termsUrl',
    get: function get() {
      return this.store.termsUrl;
    }
  }, {
    key: 'privacyUrl',
    get: function get() {
      return this.store.privacyUrl;
    }
  }, {
    key: 'authId',
    get: function get() {
      return this.store.authId;
    }
  }, {
    key: 'randomInt',
    get: function get() {
      return parseInt(Math.random() * 10000, 10);
    }
  }]);
  return SignupModalVm;
}(_BaseVm3.default); /* eslint semi:0 */


exports.default = SignupModalVm;

/***/ }),

/***/ 773:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _fn = __webpack_require__(15);

var _dom = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmbedCodeModalVm = function (_BaseVm) {
  (0, _inherits3.default)(EmbedCodeModalVm, _BaseVm);

  function EmbedCodeModalVm() {
    (0, _classCallCheck3.default)(this, EmbedCodeModalVm);
    return (0, _possibleConstructorReturn3.default)(this, (EmbedCodeModalVm.__proto__ || (0, _getPrototypeOf2.default)(EmbedCodeModalVm)).apply(this, arguments));
  }

  (0, _createClass3.default)(EmbedCodeModalVm, [{
    key: 'selectEmbedCode',
    value: function selectEmbedCode(embedCodeElement) {
      embedCodeElement.focus();
      (0, _fn.makeSafeFn)(function () {
        return (0, _dom.selectText)(embedCodeElement);
      }).call();
    }
  }]);
  return EmbedCodeModalVm;
}(_BaseVm3.default);

exports.default = EmbedCodeModalVm;

/***/ }),

/***/ 774:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _mithril = __webpack_require__(34);

var _mithril2 = _interopRequireDefault(_mithril);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _googleSearchStore = __webpack_require__(759);

var _googleSearchStore2 = _interopRequireDefault(_googleSearchStore);

var _googleSearchActions = __webpack_require__(311);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
var GoogleSearchVm = function (_BaseVm) {
  (0, _inherits3.default)(GoogleSearchVm, _BaseVm);

  function GoogleSearchVm() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, GoogleSearchVm);

    options.store = options.store || _googleSearchStore2.default.create();

    var _this = (0, _possibleConstructorReturn3.default)(this, (GoogleSearchVm.__proto__ || (0, _getPrototypeOf2.default)(GoogleSearchVm)).call(this, options));

    _this.searchboxValue = _mithril2.default.prop('');
    return _this;
  }

  (0, _createClass3.default)(GoogleSearchVm, [{
    key: 'search',
    value: function search(e) {
      e.preventDefault();
      (0, _googleSearchActions.searchClicked)(this.searchboxValue());
    }
  }]);
  return GoogleSearchVm;
}(_BaseVm3.default);

exports.default = GoogleSearchVm;

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _userToolbarActions = __webpack_require__(76);

var _BaseVm2 = __webpack_require__(63);

var _BaseVm3 = _interopRequireDefault(_BaseVm2);

var _mithril = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UserToolbarVm = function (_BaseVm) {
  (0, _inherits3.default)(UserToolbarVm, _BaseVm);

  function UserToolbarVm() {
    (0, _classCallCheck3.default)(this, UserToolbarVm);
    return (0, _possibleConstructorReturn3.default)(this, (UserToolbarVm.__proto__ || (0, _getPrototypeOf2.default)(UserToolbarVm)).apply(this, arguments));
  }

  (0, _createClass3.default)(UserToolbarVm, [{
    key: 'fbLoginClick',
    value: function fbLoginClick(e) {
      if (this.state.fbSdkReady) {
        (0, _userToolbarActions.fbLogin)();
      }
    }
  }, {
    key: 'logoutClick',
    value: function logoutClick(e) {
      e.preventDefault();
      (0, _userToolbarActions.logout)();
    }
  }, {
    key: 'unimpersonateClick',
    value: function unimpersonateClick(e) {
      e.preventDefault();
      (0, _mithril.safeRequest)({
        method: 'PUT',
        url: e.target.href
      }).then(_userToolbarActions.unimpersonate);
    }
  }]);
  return UserToolbarVm;
}(_BaseVm3.default); /* eslint semi:0 */


exports.default = UserToolbarVm;

/***/ }),

/***/ 777:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivateMessagesProvider = undefined;

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _fetch = __webpack_require__(58);

var _pageDataObject = __webpack_require__(5);

var _urlSearchParams = __webpack_require__(1342);

var _urlSearchParams2 = _interopRequireDefault(_urlSearchParams);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrivateMessagesProvider = exports.PrivateMessagesProvider = function PrivateMessagesProvider() {
  var _this = this;

  (0, _classCallCheck3.default)(this, PrivateMessagesProvider);

  this.send = function (msg, to) {
    return (0, _fetch.getJsonOrError)(_this.getMessagesApi, {
      credentials: 'include',
      method: 'post',
      headers: {
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      body: _this.convertToForm(msg, to)
    });
  };

  this.convertToForm = function (msg, to) {
    var params = {
      'message[text]': msg,
      'message[to_user_id]': to
    };

    var searchParams = new _urlSearchParams2.default();
    for (var prop in params) {
      searchParams.set(prop, params[prop]);
    }

    return searchParams;
  };

  this.getMessagesApi = (0, _pageDataObject.get)('config.api.messages');
};

/***/ }),

/***/ 778:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchUserActionCounter = undefined;

var _actionCounterBaseProvider = __webpack_require__(153);

var _object = __webpack_require__(13);

var USER_PREFIX = 'User';
var getUserKey = function getUserKey(id) {
  return USER_PREFIX + '_' + id;
};

var fetchUserActionCounter = exports.fetchUserActionCounter = function fetchUserActionCounter(_ref) {
  var userId = _ref.userId;
  return (0, _actionCounterBaseProvider.fetchCounters)([getUserKey(userId)]).then(_object.snakeKeysToCamel);
};

/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.facebookAuthenticationProvider = undefined;

var _userToolbarActions = __webpack_require__(76);

var _console = __webpack_require__(11);

var _script = __webpack_require__(19);

var _mithril = __webpack_require__(54);

/* eslint semi:0 */
var FB_CONNECT_URL = '/auth/facebook/callback';
var facebook = _script.external.load({ name: 'facebook' });

var facebookAuthenticationProvider = {
  //eslint-disable-line no-unused-vars

  login: function login() {
    var _this = this;

    facebook(function () {
      return window.FB.login(_this.handleLoginResponse.part(_userToolbarActions.authenticated), {
        scope: 'public_profile,email'
      });
    });
  },
  handleLoginResponse: function handleLoginResponse(successCallback, response) {
    if (response.status === 'connected' && response.authResponse) {
      (0, _mithril.safeRequest)({
        method: 'GET',
        url: FB_CONNECT_URL,
        data: { signed_request: response.authResponse.signedRequest } //eslint-disable-line camelcase
      }).then(successCallback, _userToolbarActions.autnenticationFailed);
    } else {
      (0, _userToolbarActions.autnenticationFailed)(response); //TODO: probably should be an independent action
    }
  },
  reAuthenticate: function reAuthenticate() {
    var _this2 = this;

    facebook(function () {
      return window.FB.getLoginStatus(_this2.handleLoginResponse.part(_userToolbarActions.reauthenticated));
    });
  }
};

exports.facebookAuthenticationProvider = facebookAuthenticationProvider;

/***/ }),

/***/ 783:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendServerAdminAction = exports.confirmAdminAction = exports.getPostActionsFromPdo = exports.getPostActions = undefined;

var _regenerator = __webpack_require__(128);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(183);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var getPostActions = exports.getPostActions = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(postId) {
    var adminOptionsPathByPost;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            adminOptionsPathByPost = postActionsUrl + '/' + postId;
            _context.next = 3;
            return (0, _fetch.getJsonOrError)(adminOptionsPathByPost, {
              credentials: 'include',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'charset=utf-8'
              }
            });

          case 3:
            return _context.abrupt('return', _context.sent);

          case 4:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function getPostActions(_x) {
    return _ref.apply(this, arguments);
  };
}();

var getPostActionsFromPdo = exports.getPostActionsFromPdo = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
    var currentUser, userRole;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            currentUser = new _currentUser.CurrentUser();
            userRole = currentUser.getRole((0, _pageDataObject.getPostAuthorId)());

            if (!userRole) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt('return', formatPostActionsResult(userRole));

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function getPostActionsFromPdo() {
    return _ref2.apply(this, arguments);
  };
}();

var sendServerAdminAction = exports.sendServerAdminAction = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(action) {
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _fetch.getJsonOrError)(action.url, {
              credentials: 'include',
              method: 'POST'
            });

          case 2:
            return _context3.abrupt('return', _context3.sent);

          case 3:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function sendServerAdminAction(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var _fetch = __webpack_require__(58);

var _pageDataObject = __webpack_require__(5);

var _currentUser = __webpack_require__(249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var postActionsUrl = '' + location.protocol + (0, _pageDataObject.getPostActionsPath)();

function formatPostActionsResult(userRole) {
  var postActionsHash = (0, _pageDataObject.getPostActionsFromPdo)();
  return userRole ? { data: { options: postActionsHash[userRole] } } : { data: { options: [] } };
}

var confirmAdminAction = exports.confirmAdminAction = function confirmAdminAction(action) {
  var confirmationText = 'Really ' + action.text + ' this post ?';
  return confirm(confirmationText);
};

/***/ }),

/***/ 789:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configReducer = configReducer;

var _socialButtonsConfig = __webpack_require__(248);

var INITIAL_STATE = {
  socialButtonsConfig: _socialButtonsConfig.SOCIAL_BUTTONS_CONF
};

function configReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    default:
      return state;
  }
}

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.currentUserReducer = undefined;

var _currentUser = __webpack_require__(317);

var _currentUser2 = __webpack_require__(249);

var INITIAL_STATE = new _currentUser2.CurrentUser().get();

var currentUserReducer = exports.currentUserReducer = function currentUserReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _currentUser.EXISTING_USER_AUTHENTICATED:
      return action.state;
    case _currentUser.NEW_USER_AUTHENTICATED:
      return action.state;
    case _currentUser.USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

/***/ }),

/***/ 793:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureFlagReducer = featureFlagReducer;

var _pageDataObject = __webpack_require__(5);

var INITIAL_STATE = {
  excludedComponentsForSite: _pageDataObject.excludedComponents
};

function featureFlagReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    default:
      return state;
  }
}

/***/ }),

/***/ 795:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

exports.logoReducer = logoReducer;

var _logo = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  imageSrc: null
};

function logoReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _logo.CHANGE_LOGO:
      return (0, _extends3.default)({}, state, action.state);
    default:
      return state;
  }
}

/***/ }),

/***/ 796:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getLogoImageSrc = exports.getLogoImageSrc = function getLogoImageSrc(state) {
  return state.logo.imageSrc;
};

/***/ }),

/***/ 797:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.menuReducer = menuReducer;

var _menu = __webpack_require__(318);

var INITIAL_STATE = {
  isOpen: false
};

function menuReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _menu.TOGGLE_MENU:
      return { isOpen: !state.isOpen };
    default:
      return state;
  }
}

/***/ }),

/***/ 798:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messageUserReducer = undefined;

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _MessageUser = __webpack_require__(428);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  isMessageBoxOpen: false
};

var messageUserReducer = exports.messageUserReducer = function messageUserReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _MessageUser.OPEN_MESSAGE_BOX:
      return (0, _extends3.default)({}, state, { isMessageBoxOpen: true });
    case _MessageUser.CLOSE_MESSAGE_BOX:
      return (0, _extends3.default)({}, state, { isMessageBoxOpen: false });
    default:
      return state;
  }
};

/***/ }),

/***/ 799:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.mountedComponentReducer = mountedComponentReducer;

var _mountedComponents = __webpack_require__(320);

var _redux = __webpack_require__(174);

var _fetchSaga = __webpack_require__(57);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var appSagas = [_fetchSaga.watchFetchDataSaga];

var MOUNTED_COMPONENTS_REDUCER_INITIAL_STATE = {
  mountedComponents: [],
  reducers: {},
  sagas: appSagas
};

function addMountedComponent(state, newComponentProps) {
  var component = newComponentProps.component,
      componentName = newComponentProps.name,
      _newComponentProps$sa = newComponentProps.sagas,
      sagas = _newComponentProps$sa === undefined ? [] : _newComponentProps$sa;

  var newState = {
    mountedComponents: [].concat((0, _toConsumableArray3.default)(state.mountedComponents), [(0, _defineProperty3.default)({}, componentName, component)]),
    sagas: [].concat((0, _toConsumableArray3.default)(state.sagas), (0, _toConsumableArray3.default)(sagas))
  };
  return (0, _extends3.default)({}, state, newState);
}

function registerDynamicReducer(state, addedReducers) {
  var newConstructedState = (0, _extends3.default)({}, state.reducers, addedReducers);
  return (0, _extends3.default)({}, state, {
    reducers: newConstructedState
  });
}

function mountedComponentReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : MOUNTED_COMPONENTS_REDUCER_INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _mountedComponents.appActionTypes.COMPONENT_MOUNT:
      return addMountedComponent(state, action.state);
    case _mountedComponents.appActionTypes.REGISTER_REDUCER:
      return registerDynamicReducer(state, action.state);
    default:
  }
  return state;
}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addWindowEvent = exports.path = exports.queryString = exports.hash = undefined;

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _get = __webpack_require__(436);

var _get2 = _interopRequireDefault(_get);

var _defineProperty2 = __webpack_require__(14);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _from = __webpack_require__(49);

var _from2 = _interopRequireDefault(_from);

var _defineProperties = __webpack_require__(434);

var _defineProperties2 = _interopRequireDefault(_defineProperties);

var _map = __webpack_require__(225);

var _map2 = _interopRequireDefault(_map);

var _slicedToArray2 = __webpack_require__(39);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.unprefixQsProperty = unprefixQsProperty;
exports.getPossiblyOverriddenPropByQsWithPrefix = getPossiblyOverriddenPropByQsWithPrefix;
exports.removeMatchMediaEvent = removeMatchMediaEvent;
exports.addOnOrientationChangeEvent = addOnOrientationChangeEvent;
exports.addOnLandscapeChangeEvent = addOnLandscapeChangeEvent;
exports.openPopup = openPopup;
exports.navigateTo = navigateTo;

var _objectPath = __webpack_require__(488);

var _objectPath2 = _interopRequireDefault(_objectPath);

var _console = __webpack_require__(11);

var _fn = __webpack_require__(15);

var _object = __webpack_require__(13);

var _nm = __webpack_require__(26);

var _string = __webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
/**
 * Wraps window apis for cross-browser and mocking.
 */
function dashDelimitedToCamelCase(string) {
  return string.replace(/-([a-z])/g, function (_ref) {
    var firstLetterAfterDash = _ref[1];
    return firstLetterAfterDash.toUpperCase();
  });
}

function decode(string) {
  return decodeURIComponent(string.replace(/\+/g, ' '));
}

function deserializeQueryString(inputQuery) {
  var queryStringObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _object.create)();

  var search = /([^&=]+)=?([^&]*)/g;
  var query = inputQuery.substring(1);
  var matches = search.exec(query);
  while (matches) {
    var _matches = matches,
        _matches2 = (0, _slicedToArray3.default)(_matches, 3),
        fullKey = _matches2[0],
        onlyKey = _matches2[1],
        rawValue = _matches2[2];

    var isOnlyKey = fullKey === onlyKey;
    var value = isOnlyKey ? true : decode(rawValue);
    var key = dashDelimitedToCamelCase(onlyKey);
    queryStringObj[key] = value;
    matches = search.exec(query);
  }
  return queryStringObj;
}

var POPUP_DEFAULTS = (0, _object.deepFreeze)({
  url: null,
  title: '',
  width: 350,
  height: 350,
  event: null
});

var hash = exports.hash = deserializeQueryString(window.location.hash);
var qs = deserializeQueryString(window.location.search, hash);

function getStackTrace() {
  try {
    throw Error();
  } catch (ex) {
    return ex.stack.split('\n').slice(3).map(function (l) {
      return l.replace('at ', '').trim();
    });
  }
}

function proxyQueryStringMaybe(queryString) {
  if (!('Proxy' in window) || !queryString.captureQueryStrings) {
    return queryString;
  }
  var checkedQueries = new _map2.default();
  (0, _defineProperties2.default)(queryString, {
    checkedQueries: {
      value: checkedQueries
    },
    checkedQueriesMap: {
      get: function get() {
        return (0, _from2.default)(checkedQueries.entries()).reduce(function (queries, _ref2) {
          var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
              query = _ref3[0],
              stack = _ref3[1];

          return (0, _assign2.default)(queries, (0, _defineProperty3.default)({}, query, stack));
        }, (0, _object.create)());
      }
    }
  });
  return new Proxy(queryString, {
    get: function get(target, key, reciever) {
      if (!(key in target && !checkedQueries.has(key))) {
        checkedQueries.set(key, getStackTrace());
      }
      return _get2.default.apply(Reflect, arguments);
    }
  });
}

var queryString = exports.queryString = proxyQueryStringMaybe(qs);
var queryStringPath = (0, _objectPath2.default)(queryString);

(0, _nm.registerInNamespace)({ queryString: queryString });

function prefixQsProperty(propName) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return '' + prefix + (prefix ? (0, _string.capitalizeFirstLetter)(propName) : propName);
}

function unprefixQsProperty(prefix, prefixedPropName) {
  return (0, _string.unCapitalizeFirstLetter)(prefixedPropName.replace(prefix, ''));
}

var debugMessages = (0, _object.create)();

function getPossiblyOverriddenPropByQsWithPrefix(prefix, propNameToOverride, realValue) {
  var propName = prefixQsProperty(propNameToOverride, prefix);
  var possiblyOverridenValue = queryStringPath.get(propName, realValue);
  var originalValue = ([undefined, window].includes(this) ? realValue : this[propNameToOverride]) || realValue;
  // info({ propNameToOverride, originalValue, realValue, })
  if (possiblyOverridenValue !== originalValue && !(propNameToOverride in debugMessages)) {
    debugMessages[propNameToOverride] = true;
    var isAdditionalValue = originalValue === undefined;
    var verb = isAdditionalValue ? 'add' : 'override';
    var realValueString = isAdditionalValue ? 'with value' : 'of \'' + originalValue + '\' with';
  }
  return possiblyOverridenValue;
}

function addMatchMediaEvent(mediaQuery, matchChangeHandler) {
  var mismatchChangeHandler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _fn.noop;

  if (!(0, _fn.areAllFunctions)(window.matchMedia, matchChangeHandler, mismatchChangeHandler)) {
    return false;
  }
  var handler = function onMatchMediaChangeHandler(mql) {
    var handlerToCall = mql.matches ? matchChangeHandler : mismatchChangeHandler;
    return handlerToCall(mql);
  };
  var mql = window.matchMedia(mediaQuery);
  mql.addListener(handler);
  return {
    mql: mql,
    handler: handler
  };
}

function removeMatchMediaEvent(mqlAndHandlerObj) {
  var mql = mqlAndHandlerObj.mql,
      handler = mqlAndHandlerObj.handler;

  if (mql && (0, _fn.areAllFunctions)(mql.removeListener, handler)) {
    mql.removeListener(handler);
  }
}

function addOnOrientationChangeEvent(onPortrait, onLandscape) {
  if (!(0, _fn.areAllFunctions)(onPortrait, onLandscape)) {
    return false;
  }
  return addMatchMediaEvent('(orientation: portrait)', onPortrait, onLandscape);
}

function addOnLandscapeChangeEvent(onLandscape) {
  return addOnOrientationChangeEvent(_fn.noop, onLandscape);
}

function openPopup(options) {
  var _makeEmptyObj$POPUP_D = (0, _extends3.default)({}, (0, _object.create)(), POPUP_DEFAULTS, options),
      url = _makeEmptyObj$POPUP_D.url,
      title = _makeEmptyObj$POPUP_D.title,
      width = _makeEmptyObj$POPUP_D.width,
      height = _makeEmptyObj$POPUP_D.height,
      ev = _makeEmptyObj$POPUP_D.event;

  ev && ev.preventDefault();
  window.open(url, title, 'width=' + width + ' ,height=' + height);
}

function navigateTo(url) {
  window.location = url;
  return url;
}

var path = exports.path = window.location.pathname;

var addWindowEvent = exports.addWindowEvent = window.addEventListener.bind(window);
var removeWindowEvent = window.removeEventListener.bind(window);

var windw = (0, _assign2.default)((0, _object.create)(), {
  openPopup: openPopup,
  queryString: queryString,
  queryStringPath: queryStringPath,
  hash: hash,
  path: path,
  navigateTo: navigateTo,
  prefixQsProperty: prefixQsProperty,
  unprefixQsProperty: unprefixQsProperty,
  getPossiblyOverriddenPropByQsWithPrefix: getPossiblyOverriddenPropByQsWithPrefix,
  addWindowEvent: addWindowEvent,
  removeWindowEvent: removeWindowEvent,
  addMatchMediaEvent: addMatchMediaEvent,
  removeMatchMediaEvent: removeMatchMediaEvent,
  addOnOrientationChangeEvent: addOnOrientationChangeEvent,
  addOnLandscapeChangeEvent: addOnLandscapeChangeEvent
});

(0, _nm.registerUtils)({ window: windw });

exports.default = windw;

/***/ }),

/***/ 800:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HYDRATE_STORE = exports.HYDRATE_STORE = '[navigation] hydrating store with nav data';

var hydrateStore = exports.hydrateStore = function hydrateStore(config) {
  return {
    type: HYDRATE_STORE,
    payload: config
  };
};

/***/ }),

/***/ 801:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

exports.navigationReducer = navigationReducer;

var _navigation = __webpack_require__(800);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  bla: 'moshe'
};

function navigationReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _navigation.HYDRATE_STORE:
      return (0, _extends3.default)({}, state, { data: action.payload });
    default:
      return state;
  }
}

/***/ }),

/***/ 802:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postActionsReducer = undefined;

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _postActions = __webpack_require__(250);

var _currentUser = __webpack_require__(317);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  isLoading: false,
  hasErrors: false,
  optionsList: []
};

var postActionsReducer = exports.postActionsReducer = function postActionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var _ref = arguments[1];
  var type = _ref.type,
      newState = _ref.newState;

  switch (type) {
    case _postActions.LOADING_POST_ACTIONS:
      return (0, _extends3.default)({}, state, newState);
    case _postActions.FETCH_POST_ACTIONS_FAILED:
      return (0, _extends3.default)({}, state, newState);
    case _postActions.FETCH_POST_ACTIONS_SUCCESS:
      return (0, _extends3.default)({}, state, newState);
    case _currentUser.USER_LOGOUT:
      return (0, _extends3.default)({}, state, { optionsList: [] });
    default:
      return state;
  }
};

/***/ }),

/***/ 803:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.injectRecommendedPostsToPostPage = injectRecommendedPostsToPostPage;
var INJECT_RECOMMENDED_POSTS = exports.INJECT_RECOMMENDED_POSTS = '[recommendedPosts] inject recommended posts';

function injectRecommendedPostsToPostPage(posts) {
  return {
    type: INJECT_RECOMMENDED_POSTS,
    state: {
      posts: posts
    }
  };
}

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

exports.recommendedPostsReducer = recommendedPostsReducer;

var _recommendedPosts = __webpack_require__(803);

var _pageDataObject = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  posts: (0, _pageDataObject.getRecommendedPosts)()
};

function recommendedPostsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _recommendedPosts.INJECT_RECOMMENDED_POSTS:
      return (0, _extends3.default)({}, state, action.state);
    default:
      return state;
  }
}

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getRecommendedPosts = exports.getRecommendedPosts = function getRecommendedPosts(state) {
  return state.recommendedPosts.posts;
};

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducers = undefined;

var _mountedComponents = __webpack_require__(799);

var _config = __webpack_require__(789);

var _userDevice = __webpack_require__(809);

var _featureFlags = __webpack_require__(793);

var _visibility = __webpack_require__(811);

var _currentUser = __webpack_require__(791);

var _MessageUser = __webpack_require__(798);

var _Stats = __webpack_require__(810);

var _logo = __webpack_require__(795);

var _postActions = __webpack_require__(802);

var _navigation = __webpack_require__(801);

var _recommendedPosts = __webpack_require__(804);

var _menu = __webpack_require__(797);

var _topAd = __webpack_require__(808);

var reducers = exports.reducers = {
  mountedComponents: _mountedComponents.mountedComponentReducer,
  config: _config.configReducer,
  userDevice: _userDevice.userDeviceReducer,
  featureFlag: _featureFlags.featureFlagReducer,
  visibility: _visibility.visibilityReducers,
  currentUser: _currentUser.currentUserReducer,
  messageUser: _MessageUser.messageUserReducer,
  userStats: _Stats.userStatsReducer,
  logo: _logo.logoReducer,
  recommendedPosts: _recommendedPosts.recommendedPostsReducer,
  postActions: _postActions.postActionsReducer,
  navigation: _navigation.navigationReducer,
  menu: _menu.menuReducer,
  topAd: _topAd.topAdReducer
};

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

exports.topAdReducer = topAdReducer;

var _adActions = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  topAdHeight: 0
};
function topAdReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _adActions.TYPES.SLOT_RENDERED:
      return action.state.adId === 'Top' ? (0, _extends3.default)({}, state, { topAdHeight: action.state.size.height }) : state;
    default:
      return state;
  }
}

/***/ }),

/***/ 809:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userDeviceReducer = userDeviceReducer;

var _ua = __webpack_require__(9);

var INITIAL_STATE = {
  isMobile: (0, _ua.getIsMobile)(),
  isTablet: (0, _ua.getIsTablet)(),
  isTabletInPortrait: (0, _ua.getIsTabletInPortrait)()
};

function userDeviceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    default:
      return state;
  }
}

/***/ }),

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userStatsReducer = undefined;

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

var _object = __webpack_require__(13);

var _Stats = __webpack_require__(431);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  postCreate: 0,
  readsGot: 0,
  commentsGot: 0
};

var userStatsReducer = exports.userStatsReducer = function userStatsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _Stats.FETCH_USER_STATS_SUCCESS:
      /*
       This is guarding us against responses that are lower than 0
       (for some users this is the cases ¯\_(ツ)_/¯ )
       */
      var newState = (0, _object.objectMap)(action.response, function (stat, amount) {
        var statAsInt = {};
        statAsInt[stat] = isNaN(amount) || parseInt(amount, 10) < 0 ? 0 : parseInt(amount, 10);
        return statAsInt;
      });

      return (0, _extends3.default)({}, state, newState);
    default:
      return state;
  }
};

/***/ }),

/***/ 811:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(10);

var _extends3 = _interopRequireDefault(_extends2);

exports.visibilityReducers = visibilityReducers;

var _visibility = __webpack_require__(432);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
  coverShareButtonsInView: true,
  titleIsAboveViewport: false,
  isScrollUp: false,
  isScrollUpTrend: false
};

function visibilityReducers() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _visibility.COVER_SHARE_BUTTONS_NOT_IN_VIEW:
      return (0, _extends3.default)({}, state, { coverShareButtonsInView: false });
    case _visibility.COVER_SHARE_BUTTONS_IN_VIEW:
      return (0, _extends3.default)({}, state, { coverShareButtonsInView: true });
    case _visibility.TITLE_ABOVE_OR_BELOW_VIEWPORT:
      return (0, _extends3.default)({}, state, { titleIsAboveViewport: action.payload.isAbove });
    case _visibility.SCROLL_DIRECTION_CHANGED:
      return (0, _extends3.default)({}, state, { isScrollUp: action.payload.isScrollUp });
    case _visibility.SCROLL_UP_TREND:
      return (0, _extends3.default)({}, state, { isScrollUpTrend: action.payload.isScrollUpTrend });
    default:
      return state;
  }
}

/***/ }),

/***/ 812:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coverShareButtonsInView = undefined;
exports.shouldShowNavigationInMobile = shouldShowNavigationInMobile;

var _ua = __webpack_require__(9);

var visibility = function visibility(state) {
  return state.visibility;
};

var coverShareButtonsInView = exports.coverShareButtonsInView = function coverShareButtonsInView(state) {
  return !visibility(state).coverShareButtonsInView;
};

function shouldShowNavigationInMobile(state) {
  return (visibility(state).isScrollUpTrend || !visibility(state).titleIsAboveViewport) && (0, _ua.getIsMobile)() || (0, _ua.getIsDesktop)();
}

/***/ }),

/***/ 813:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeCountryCode = normalizeCountryCode;
exports.normalizeLocale = normalizeLocale;
/**
 * Should be moved into respective utils/providers.
 */

function normalizeCountryCode(countryCode) {
  return countryCode.toLowerCase();
}
function normalizeLocale(locale) {
  return locale.toLowerCase();
}

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _set = __webpack_require__(254);

var _set2 = _interopRequireDefault(_set);

var _toConsumableArray2 = __webpack_require__(32);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.filter = filter;
exports.intersection = intersection;
exports.union = union;

var _nm = __webpack_require__(26);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
function filter(iterable, predicateFn) {
  return [].concat((0, _toConsumableArray3.default)(iterable)).filter(predicateFn);
}

function makeSet(iterable) {
  return new _set2.default(iterable);
}

function intersection() {
  for (var _len = arguments.length, iterables = Array(_len), _key = 0; _key < _len; _key++) {
    iterables[_key] = arguments[_key];
  }

  return iterables.reduce(function (acc, iterable) {
    return makeSet(filter(iterable, function (m) {
      return acc.has(m);
    }));
  }, makeSet(iterables[0]));
}

function union() {
  for (var _len2 = arguments.length, iterables = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    iterables[_key2] = arguments[_key2];
  }

  return makeSet(iterables.reduce(function (acc, iterable) {
    return [].concat((0, _toConsumableArray3.default)(acc), (0, _toConsumableArray3.default)(iterable));
  }, []));
}

// based on http://www.2ality.com/2015/01/es6-set-operations.html
var set = (0, _assign2.default)((0, _object.create)(), {
  union: union,
  filter: filter,
  intersection: intersection
});

(0, _nm.registerUtils)({ set: set });

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _afterPathnameKey = __webpack_require__(753);

var _afterPathnameKey2 = _interopRequireDefault(_afterPathnameKey);

var _referrerHostname = __webpack_require__(754);

var _referrerHostname2 = _interopRequireDefault(_referrerHostname);

var _searchParamValue = __webpack_require__(755);

var _searchParamValue2 = _interopRequireDefault(_searchParamValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  searchParamValue: _searchParamValue2.default,
  afterPathnameKey: _afterPathnameKey2.default,
  referrerHostname: _referrerHostname2.default
};

/***/ }),

/***/ 84:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty = __webpack_require__(252);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _create = __webpack_require__(182);

var _create2 = _interopRequireDefault(_create);

var _set = __webpack_require__(254);

var _set2 = _interopRequireDefault(_set);

var _getPrototypeOf = __webpack_require__(1);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(0);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(6);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(2);

var _inherits3 = _interopRequireDefault(_inherits2);

var _object = __webpack_require__(13);

var _BaseClass2 = __webpack_require__(43);

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint semi:0 */
function getProp(propName) {
  var propSources = [this.options, this.vm, this.DEFAULTS];
  var prop = propSources.find(function (source) {
    if (source && propName in source) {
      var property = source[propName];
      if (property !== null) {
        return property;
      }
    }
    return null;
  });
  return prop && prop[propName] || null;
}

var VIEW_METHOD_NAME = 'view';

var BaseView = function (_BaseClass) {
  (0, _inherits3.default)(BaseView, _BaseClass);

  function BaseView() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, BaseView);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BaseView.__proto__ || (0, _getPrototypeOf2.default)(BaseView)).call(this, options));

    var propNames = new _set2.default((0, _object.keys)(_this.DEFAULTS, options));
    propNames.forEach(_this.addPropGetter, _this);
    _this.merge({
      immutableAttrs: (0, _create2.default)({
        toString: function serializeAttrs() {
          return '[' + (0, _object.serialize)(this, '][') + ']';
        }
      })
    });
    return _this;
  }

  (0, _createClass3.default)(BaseView, [{
    key: 'addPropGetter',
    value: function addPropGetter(propName) {
      (0, _defineProperty2.default)(this, propName, {
        enumerable: true,
        configurable: true,
        get: getProp.bind(this, propName)
      });
    }
  }, {
    key: VIEW_METHOD_NAME,
    value: function value(ctrl) {
      if (this[VIEW_METHOD_NAME] === BaseView.prototype[VIEW_METHOD_NAME]) {
        var message = 'The \'' + VIEW_METHOD_NAME + '\' method must be overridden in subclasses!';
        this.error(message, { ctrl: ctrl, context: this });
        throw new Error(message);
      }
      this.merge({ ctrl: ctrl });
    }
  }], [{
    key: 'make',
    value: function make() {
      for (var _len = arguments.length, opts = Array(_len), _key = 0; _key < _len; _key++) {
        opts[_key] = arguments[_key];
      }

      return this.create(_assign2.default.apply(Object, [{}].concat(opts)))[VIEW_METHOD_NAME]();
    }
  }]);
  return BaseView;
}(_BaseClass3.default);

exports.default = BaseView;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.path = exports.isInIframe = exports.viewport = exports.BREAKPOINTS = exports.BROWSER_NAMES = exports.DEVICE_MODELS = exports.PLATFORMS = exports.parserResult = undefined;

var _assign = __webpack_require__(16);

var _assign2 = _interopRequireDefault(_assign);

exports.domainFromFqdn = domainFromFqdn;
exports.getDomainFromFqdn = getDomainFromFqdn;
exports.getIsTabletSize = getIsTabletSize;
exports.getIsDesktop = getIsDesktop;
exports.getIsMobile = getIsMobile;
exports.getIsTablet = getIsTablet;
exports.getIsTabletInPortrait = getIsTabletInPortrait;
exports.getIsMobileOrTablet = getIsMobileOrTablet;
exports.getIsAndroid = getIsAndroid;
exports.getIsIos = getIsIos;
exports.getIsBot = getIsBot;
exports.getIsMobileOs = getIsMobileOs;
exports.getBrowserClassName = getBrowserClassName;
exports.getIsSafari = getIsSafari;
exports.getIsIe = getIsIe;
exports.getIsFacebookApp = getIsFacebookApp;
exports.getDoesSupportPns = getDoesSupportPns;
exports.getPlatform = getPlatform;
exports.getFormFactor = getFormFactor;
exports.getBrowserName = getBrowserName;
exports.getBrowserVersion = getBrowserVersion;
exports.getIsNativeApp = getIsNativeApp;
exports.isPlatform = isPlatform;

var _uaParserJs = __webpack_require__(1341);

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

var _fn = __webpack_require__(15);

var _nm = __webpack_require__(26);

var _window = __webpack_require__(8);

var _object = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var parser = new _uaParserJs2.default(); /**
                                          * User agent sniffer :(
                                          * They made me do it! I swear :(...
                                          */

parser.setUA(navigator.userAgent);
var parserResult = exports.parserResult = parser.getResult();

// based on domain elevation
function domainFromFqdn() {
  return document.domain.split('.')[0] || '90min';
}

var PAGE_LAYOUTS = {
  EMBED: {
    PATH: 'embed',
    INDEXES: [0, 1]
  },
  SYND: {
    PATH: 'synd',
    INDEXES: [0, 1]
  },
  HYBRID: {
    PATH: 'hybrid',
    INDEXES: [0, 1]
  },
  NATIVE: {
    PATH: 'native',
    INDEXES: [0, 1]
  },
  DRAFT: {
    PATH: 'drafts',
    INDEXES: [0, 1]
  },
  TEST: {
    PATH: 'test',
    INDEXES: [0]
  }
};

var USER_AGENTS = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  IOS: 'iOS',
  ANDROID: 'Android'
};

var PLATFORMS = exports.PLATFORMS = {
  DESKTOP: 'desktop',
  MOBILE_WEB: 'mobile web',
  NATIVE_APP: 'native app'
};

var DEVICE_MODELS = exports.DEVICE_MODELS = {
  NEXUS_6: 'Nexus 6'
};

var BROWSER_NAMES = exports.BROWSER_NAMES = {
  CHROME: 'Chrome',
  SAFARI: 'Safari'
};

var BROWSER_PN_SUPORTIVE_VERSIONS = {
  CHROME: 42
};

function isPageLayoutByName(pathnameParts, layout) {
  var indexOfLayoutName = pathnameParts.indexOf(layout.PATH);
  return (0, _fn.makeSafeFn)(function getLayoutName() {
    return layout && layout.INDEXES.includes(indexOfLayoutName) || false;
  }).invoke();
}

function addScreenCoverElementAndReturnHeight() {
  var coverElementId = 'cover-element';
  var element = document.getElementById(coverElementId);
  if (!element) {
    var coverElement = document.createElement('div');
    coverElement.id = coverElementId;
    (0, _assign2.default)(coverElement.style, {
      position: 'absolute',
      'z-index': '-9999',
      height: '100vh',
      width: '100vw',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0'
    });document.body.append && document.body.append(coverElement) || document.body.appendChild(coverElement);
    return document.getElementById(coverElementId).clientHeight;
  }
  return element.clientHeight;
}

var BREAKPOINTS = exports.BREAKPOINTS = {
  TABLET: {
    LANDSCAPE: 1e3,
    PORTRAIT: 768
  },
  DESKTOP: 1024
};

var viewport = exports.viewport = {
  // add comment about shy we userd the following:
  get width() {
    return 'orientation' in screen ? window.innerWidth : document.body.scrollWidth;
  },
  get height() {
    return 'orientation' in screen ? window.innerHeight : addScreenCoverElementAndReturnHeight();
  },
  get isPortrait() {
    return this.height > this.width;
  },
  get orientation() {
    return this.isPortrait ? 'portrait' : 'landscape';
  },
  get widerThanTabletBreakpoint() {
    return this.width >= BREAKPOINTS.TABLET.LANDSCAPE;
  },
  get narrowrThanTabletBreakpoint() {
    return this.width <= BREAKPOINTS.TABLET.LANDSCAPE;
  }
};

function getDomainFromFqdn() {
  return domainFromFqdn();
}

function getIsTabletSize() {
  var orientationScale = viewport.isPortrait ? viewport.width : viewport.height;
  return orientationScale >= BREAKPOINTS.TABLET.PORTRAIT && orientationScale < BREAKPOINTS.DESKTOP;
}

function getIsDesktop() {
  return parserResult.device.type === undefined && !getIsMobileOs();
}

function getIsMobile() {
  return parserResult.device.type === USER_AGENTS.MOBILE || !getIsTabletSize() && getIsMobileOs();
}

function getIsTablet() {
  return parserResult.device.type === USER_AGENTS.TABLET || getIsTabletSize() && getIsMobileOs();
}

function getIsTabletInPortrait() {
  return getIsTablet() && viewport.isPortrait;
}

function getIsMobileOrTablet() {
  return getIsMobile() || getIsTablet();
}

function getIsAndroid() {
  return parserResult.os.name === USER_AGENTS.ANDROID;
}

function getIsIos() {
  return parserResult.os.name === USER_AGENTS.IOS;
}

function getIsBot() {
  return !!parserResult.ua.match(/bot/i);
}
function getIsMobileOs() {
  return getIsIos() || getIsAndroid();
}
function getBrowserClassName() {
  return parserResult.browser.name.toLowerCase().split(' ').join('-');
}

function getIsSafari() {
  return parserResult.browser.name === BROWSER_NAMES.SAFARI;
}

function getIsIe() {
  return parserResult.browser.name === 'IE';
}

function getIsFacebookApp() {
  return (/FBAV\/([\w\.]+);/i.test(navigator.userAgent)
  );
}

function getDoesSupportPns() {
  return parserResult.browser.name === BROWSER_NAMES.CHROME && parseInt(parserResult.browser.major, 10) >= BROWSER_PN_SUPORTIVE_VERSIONS.CHROME;
}

function getPlatform() {
  return getIsDesktop() ? PLATFORMS.DESKTOP : getIsNativeApp() ? PLATFORMS.NATIVE_APP : PLATFORMS.MOBILE_WEB;
}

function getFormFactor() {
  return getIsDesktop() ? PLATFORMS.DESKTOP : getIsTablet() ? USER_AGENTS.TABLET : USER_AGENTS.MOBILE;
}

function getBrowserName() {
  return parserResult.browser.name;
}

function getBrowserVersion() {
  return parserResult.browser.version;
}

// This can be determined by the post layout, but then we have a problem of backwards compatibility.
function getIsNativeApp() {
  return !!_window.queryString.app || path.isNative || path.isHybrid;
}
var isInIframe = exports.isInIframe = function detectIframe() {
  try {
    return window.self !== window.top;
  } catch (ex) {
    return true;
  }
}();

var path = exports.path = (0, _object.create)({
  get parts() {
    return window.location.pathname.substr(1).split('/');
  },
  isLayoutByName: function isLayoutByName(layout) {
    return isPageLayoutByName(this.parts, layout);
  },

  get isEmbedded() {
    return this.isLayoutByName(PAGE_LAYOUTS.EMBED);
  },
  get isSyndication() {
    return this.isLayoutByName(PAGE_LAYOUTS.SYND);
  },
  get isHybrid() {
    return this.isLayoutByName(PAGE_LAYOUTS.HYBRID);
  },
  get isNative() {
    return this.isLayoutByName(PAGE_LAYOUTS.NATIVE);
  },
  get isDraft() {
    return this.isLayoutByName(PAGE_LAYOUTS.DRAFT);
  },
  get isKitchenSink() {
    return this.isLayoutByName(PAGE_LAYOUTS.KITCHEN_SINK);
  },
  get isFullLayout() {
    return !this.isEmbedded && !userAgent.isNativeApp;
  }
});

function isPlatform(platform) {
  if (platform === 'desktop') {
    return getIsDesktop();
  }
  if (platform === 'mobile') {
    return getIsMobile();
  }
  return parserResult.device.type === platform;
}

var userAgent = {
  BREAKPOINTS: BREAKPOINTS,
  PLATFORMS: PLATFORMS,
  DEVICE_MODELS: DEVICE_MODELS,
  BROWSER_NAMES: BROWSER_NAMES,
  viewport: viewport,
  getDomainFromFqdn: getDomainFromFqdn,
  getIsTabletSize: getIsTabletSize,
  getIsDesktop: getIsDesktop,
  getIsMobile: getIsMobile,
  getIsTablet: getIsTablet,
  getIsTabletInPortrait: getIsTabletInPortrait,
  getIsMobileOrTablet: getIsMobileOrTablet,
  getIsAndroid: getIsAndroid,
  getIsIos: getIsIos,
  getIsBot: getIsBot,
  getIsMobileOs: getIsMobileOs,
  getBrowserClassName: getBrowserClassName,
  getIsSafari: getIsSafari,
  getIsIe: getIsIe,
  getIsFacebookApp: getIsFacebookApp,
  getDoesSupportPns: getDoesSupportPns,
  getPlatform: getPlatform,
  getFormFactor: getFormFactor,
  getIsNativeApp: getIsNativeApp,
  path: path
};

(0, _assign2.default)(userAgent, parserResult, {
  isPlatform: isPlatform
});

(0, _nm.registerUtils)({ userAgent: userAgent });

//export default userAgent;

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;

var _analyticsActions = __webpack_require__(31);

var _appStore = __webpack_require__(23);

__webpack_require__(1157);

var _visibility = __webpack_require__(432);

var viewabilityTracker = null;

var config = {
  root: null,
  rootMargin: '0px',
  threshold: 0.5
};

var isAboveViewport = function isAboveViewport(bounded) {
  return bounded.top + bounded.height <= 0;
};

function isAboveTest(entries, observer) {
  entries.forEach(function (entry) {
    return (0, _appStore.dispatch)((0, _visibility.titleAboveOrBellowViewport)(isAboveViewport(entry.boundingClientRect)));
  });
}

function trackScrollDirection() {
  var previousPosition = window.scrollY;
  var isPreviousScrollDirectionUp = void 0;
  window.addEventListener('scroll', function () {
    var isCurrentScrollDirectionUp = window.scrollY < previousPosition;
    if (isPreviousScrollDirectionUp !== isCurrentScrollDirectionUp) {
      // dispatch(scrollDirectionChanged(isCurrentScrollDirectionUp))
      isPreviousScrollDirectionUp = isCurrentScrollDirectionUp;
    }
    previousPosition = window.scrollY;
  });
}

function trackScrollUpTrend() {
  var anchorScrollUpTrend = window.scrollY;
  var previousPosition = window.scrollY;
  window.addEventListener('scroll', function () {
    var isCurrentScrollDirectionUp = previousPosition > window.scrollY;
    if (isCurrentScrollDirectionUp && anchorScrollUpTrend - previousPosition > 400) {
      (0, _appStore.dispatch)((0, _visibility.userScrollUpTrend)(true));
      previousPosition = anchorScrollUpTrend = window.scrollY;
    } else if (isCurrentScrollDirectionUp) {
      previousPosition = window.scrollY;
    } else if (!isCurrentScrollDirectionUp) {
      (0, _appStore.dispatch)((0, _visibility.userScrollUpTrend)(false));
      anchorScrollUpTrend = previousPosition = window.scrollY;
    }
  });
}

function trackIsAboveTitle() {
  var intersection = new IntersectionObserver(isAboveTest);
  if (document.querySelector('.post-article__post-title') !== null) {
    intersection.observe(document.querySelector('.post-article__post-title'));
  }
}

function viabilityTrackerNotInitialized() {
  return viewabilityTracker === null;
}

var handleIntersect = function handleIntersect(entries, observer) {
  return entries.filter(function (entry) {
    return entry.intersectionRatio > 0.5;
  }).forEach(function (entry) {
    (0, _appStore.dispatch)((0, _analyticsActions.viewbilityAnalyticsAction)(entry.target.dataset.viewability_category, entry.target.dataset.viewability_action, entry.target.dataset.viewability_label));
    observer.unobserve(entry.target);
  });
};

function init() {
  if (viabilityTrackerNotInitialized()) {
    viewabilityTracker = new IntersectionObserver(handleIntersect, config);
    trackIsAboveTitle();
    trackScrollDirection();
    trackScrollUpTrend();
  }
}

function registerSelector(querySelector) {
  if (document.querySelector(querySelector) !== null) {
    viewabilityTracker.observe(document.querySelector(querySelector));
  }
}

function register(querySelector) {
  if (viabilityTrackerNotInitialized()) {
    init();
  }
  registerSelector(querySelector);
}

/***/ })

});


// WEBPACK FOOTER //
// webpack-commons.js